function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6480"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6480"] = parcelRequire;
}
parcelRequire.register("jFRSQ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $e52ba4ca8b4df2bf$export$ffb0004e005737fa; }, function (v) { return $e52ba4ca8b4df2bf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $e52ba4ca8b4df2bf$export$34b9dba7ce09269b; }, function (v) { return $e52ba4ca8b4df2bf$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $e52ba4ca8b4df2bf$export$25062201e9e25d76; }, function (v) { return $e52ba4ca8b4df2bf$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e52ba4ca8b4df2bf$export$ffb0004e005737fa;
var $e52ba4ca8b4df2bf$export$34b9dba7ce09269b;
var $e52ba4ca8b4df2bf$export$25062201e9e25d76;
"use strict";

var $9KJkx = parcelRequire("9KJkx");
var $e52ba4ca8b4df2bf$var$k = Symbol.for("react.element"), $e52ba4ca8b4df2bf$var$l = Symbol.for("react.fragment"), $e52ba4ca8b4df2bf$var$m = Object.prototype.hasOwnProperty, $e52ba4ca8b4df2bf$var$n = $9KJkx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $e52ba4ca8b4df2bf$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e52ba4ca8b4df2bf$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$e52ba4ca8b4df2bf$var$m.call(a, b) && !$e52ba4ca8b4df2bf$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $e52ba4ca8b4df2bf$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $e52ba4ca8b4df2bf$var$n.current
    };
}
$e52ba4ca8b4df2bf$export$ffb0004e005737fa = $e52ba4ca8b4df2bf$var$l;
$e52ba4ca8b4df2bf$export$34b9dba7ce09269b = $e52ba4ca8b4df2bf$var$q;
$e52ba4ca8b4df2bf$export$25062201e9e25d76 = $e52ba4ca8b4df2bf$var$q;

});
parcelRequire.register("9KJkx", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1UXgx"));

});
parcelRequire.register("1UXgx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $1658fe5a533eee99$export$dca3b0875bd9a954; }, function (v) { return $1658fe5a533eee99$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1658fe5a533eee99$export$16fa2f45be04daa8; }, function (v) { return $1658fe5a533eee99$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1658fe5a533eee99$export$ffb0004e005737fa; }, function (v) { return $1658fe5a533eee99$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1658fe5a533eee99$export$e2c29f18771995cb; }, function (v) { return $1658fe5a533eee99$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1658fe5a533eee99$export$221d75b3f55bb0bd; }, function (v) { return $1658fe5a533eee99$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1658fe5a533eee99$export$5f8d39834fd61797; }, function (v) { return $1658fe5a533eee99$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1658fe5a533eee99$export$74bf444e3cd11ea5; }, function (v) { return $1658fe5a533eee99$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1658fe5a533eee99$export$ae55be85d98224ed; }, function (v) { return $1658fe5a533eee99$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1658fe5a533eee99$export$e530037191fcd5d7; }, function (v) { return $1658fe5a533eee99$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1658fe5a533eee99$export$fd42f52fd3ae1109; }, function (v) { return $1658fe5a533eee99$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1658fe5a533eee99$export$c8a8987d4410bf2d; }, function (v) { return $1658fe5a533eee99$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $1658fe5a533eee99$export$d38cd72104c1f0e9; }, function (v) { return $1658fe5a533eee99$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $1658fe5a533eee99$export$7d1e3a5e95ceca43; }, function (v) { return $1658fe5a533eee99$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1658fe5a533eee99$export$257a8862b851cb5b; }, function (v) { return $1658fe5a533eee99$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1658fe5a533eee99$export$a8257692ac88316c; }, function (v) { return $1658fe5a533eee99$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1658fe5a533eee99$export$488013bae63b21da; }, function (v) { return $1658fe5a533eee99$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1658fe5a533eee99$export$7c73462e0d25e514; }, function (v) { return $1658fe5a533eee99$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1658fe5a533eee99$export$7568632d0d33d16d; }, function (v) { return $1658fe5a533eee99$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $1658fe5a533eee99$export$88948ce120ea2619; }, function (v) { return $1658fe5a533eee99$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1658fe5a533eee99$export$35808ee640e87ca7; }, function (v) { return $1658fe5a533eee99$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1658fe5a533eee99$export$fae74005e78b1a27; }, function (v) { return $1658fe5a533eee99$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1658fe5a533eee99$export$dc8fbce3eb94dc1e; }, function (v) { return $1658fe5a533eee99$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1658fe5a533eee99$export$6a7bc4e911dc01cf; }, function (v) { return $1658fe5a533eee99$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1658fe5a533eee99$export$6d9c69b0de29b591; }, function (v) { return $1658fe5a533eee99$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $1658fe5a533eee99$export$f680877a34711e37; }, function (v) { return $1658fe5a533eee99$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1658fe5a533eee99$export$d5a552a76deda3c2; }, function (v) { return $1658fe5a533eee99$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1658fe5a533eee99$export$aaabe4eda9ed9969; }, function (v) { return $1658fe5a533eee99$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1658fe5a533eee99$export$e5c5a5f917a5871c; }, function (v) { return $1658fe5a533eee99$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1658fe5a533eee99$export$1538c33de8887b59; }, function (v) { return $1658fe5a533eee99$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $1658fe5a533eee99$export$13e3392192263954; }, function (v) { return $1658fe5a533eee99$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1658fe5a533eee99$export$b8f5890fc79d6aca; }, function (v) { return $1658fe5a533eee99$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1658fe5a533eee99$export$60241385465d0a34; }, function (v) { return $1658fe5a533eee99$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1658fe5a533eee99$export$306c0aa65ff9ec16; }, function (v) { return $1658fe5a533eee99$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1658fe5a533eee99$export$7b286972b8d8ccbf; }, function (v) { return $1658fe5a533eee99$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1658fe5a533eee99$export$83d89fbfd8236492; }, function (v) { return $1658fe5a533eee99$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1658fe5a533eee99$export$dca3b0875bd9a954;
var $1658fe5a533eee99$export$16fa2f45be04daa8;
var $1658fe5a533eee99$export$ffb0004e005737fa;
var $1658fe5a533eee99$export$e2c29f18771995cb;
var $1658fe5a533eee99$export$221d75b3f55bb0bd;
var $1658fe5a533eee99$export$5f8d39834fd61797;
var $1658fe5a533eee99$export$74bf444e3cd11ea5;
var $1658fe5a533eee99$export$ae55be85d98224ed;
var $1658fe5a533eee99$export$e530037191fcd5d7;
var $1658fe5a533eee99$export$fd42f52fd3ae1109;
var $1658fe5a533eee99$export$c8a8987d4410bf2d;
var $1658fe5a533eee99$export$d38cd72104c1f0e9;
var $1658fe5a533eee99$export$7d1e3a5e95ceca43;
var $1658fe5a533eee99$export$257a8862b851cb5b;
var $1658fe5a533eee99$export$a8257692ac88316c;
var $1658fe5a533eee99$export$488013bae63b21da;
var $1658fe5a533eee99$export$7c73462e0d25e514;
var $1658fe5a533eee99$export$7568632d0d33d16d;
var $1658fe5a533eee99$export$88948ce120ea2619;
var $1658fe5a533eee99$export$35808ee640e87ca7;
var $1658fe5a533eee99$export$fae74005e78b1a27;
var $1658fe5a533eee99$export$dc8fbce3eb94dc1e;
var $1658fe5a533eee99$export$6a7bc4e911dc01cf;
var $1658fe5a533eee99$export$6d9c69b0de29b591;
var $1658fe5a533eee99$export$f680877a34711e37;
var $1658fe5a533eee99$export$d5a552a76deda3c2;
var $1658fe5a533eee99$export$aaabe4eda9ed9969;
var $1658fe5a533eee99$export$e5c5a5f917a5871c;
var $1658fe5a533eee99$export$1538c33de8887b59;
var $1658fe5a533eee99$export$13e3392192263954;
var $1658fe5a533eee99$export$b8f5890fc79d6aca;
var $1658fe5a533eee99$export$60241385465d0a34;
var $1658fe5a533eee99$export$306c0aa65ff9ec16;
var $1658fe5a533eee99$export$7b286972b8d8ccbf;
var $1658fe5a533eee99$export$83d89fbfd8236492;
"use strict";
var $1658fe5a533eee99$var$l = Symbol.for("react.element"), $1658fe5a533eee99$var$n = Symbol.for("react.portal"), $1658fe5a533eee99$var$p = Symbol.for("react.fragment"), $1658fe5a533eee99$var$q = Symbol.for("react.strict_mode"), $1658fe5a533eee99$var$r = Symbol.for("react.profiler"), $1658fe5a533eee99$var$t = Symbol.for("react.provider"), $1658fe5a533eee99$var$u = Symbol.for("react.context"), $1658fe5a533eee99$var$v = Symbol.for("react.forward_ref"), $1658fe5a533eee99$var$w = Symbol.for("react.suspense"), $1658fe5a533eee99$var$x = Symbol.for("react.memo"), $1658fe5a533eee99$var$y = Symbol.for("react.lazy"), $1658fe5a533eee99$var$z = Symbol.iterator;
function $1658fe5a533eee99$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1658fe5a533eee99$var$z && a[$1658fe5a533eee99$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1658fe5a533eee99$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1658fe5a533eee99$var$C = Object.assign, $1658fe5a533eee99$var$D = {};
function $1658fe5a533eee99$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1658fe5a533eee99$var$D;
    this.updater = e || $1658fe5a533eee99$var$B;
}
$1658fe5a533eee99$var$E.prototype.isReactComponent = {};
$1658fe5a533eee99$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1658fe5a533eee99$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1658fe5a533eee99$var$F() {}
$1658fe5a533eee99$var$F.prototype = $1658fe5a533eee99$var$E.prototype;
function $1658fe5a533eee99$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1658fe5a533eee99$var$D;
    this.updater = e || $1658fe5a533eee99$var$B;
}
var $1658fe5a533eee99$var$H = $1658fe5a533eee99$var$G.prototype = new $1658fe5a533eee99$var$F;
$1658fe5a533eee99$var$H.constructor = $1658fe5a533eee99$var$G;
$1658fe5a533eee99$var$C($1658fe5a533eee99$var$H, $1658fe5a533eee99$var$E.prototype);
$1658fe5a533eee99$var$H.isPureReactComponent = !0;
var $1658fe5a533eee99$var$I = Array.isArray, $1658fe5a533eee99$var$J = Object.prototype.hasOwnProperty, $1658fe5a533eee99$var$K = {
    current: null
}, $1658fe5a533eee99$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1658fe5a533eee99$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1658fe5a533eee99$var$J.call(b, d) && !$1658fe5a533eee99$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1658fe5a533eee99$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1658fe5a533eee99$var$K.current
    };
}
function $1658fe5a533eee99$var$N(a, b) {
    return {
        $$typeof: $1658fe5a533eee99$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1658fe5a533eee99$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1658fe5a533eee99$var$l;
}
function $1658fe5a533eee99$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1658fe5a533eee99$var$P = /\/+/g;
function $1658fe5a533eee99$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1658fe5a533eee99$var$escape("" + a.key) : b.toString(36);
}
function $1658fe5a533eee99$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1658fe5a533eee99$var$l:
                case $1658fe5a533eee99$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1658fe5a533eee99$var$Q(h, 0) : d, $1658fe5a533eee99$var$I(c) ? (e = "", null != a && (e = a.replace($1658fe5a533eee99$var$P, "$&/") + "/"), $1658fe5a533eee99$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1658fe5a533eee99$var$O(c) && (c = $1658fe5a533eee99$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1658fe5a533eee99$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1658fe5a533eee99$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1658fe5a533eee99$var$Q(k, g);
        h += $1658fe5a533eee99$var$R(k, b, e, f, c);
    }
    else if (f = $1658fe5a533eee99$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1658fe5a533eee99$var$Q(k, g++), h += $1658fe5a533eee99$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1658fe5a533eee99$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1658fe5a533eee99$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1658fe5a533eee99$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1658fe5a533eee99$var$U = {
    current: null
}, $1658fe5a533eee99$var$V = {
    transition: null
}, $1658fe5a533eee99$var$W = {
    ReactCurrentDispatcher: $1658fe5a533eee99$var$U,
    ReactCurrentBatchConfig: $1658fe5a533eee99$var$V,
    ReactCurrentOwner: $1658fe5a533eee99$var$K
};
$1658fe5a533eee99$export$dca3b0875bd9a954 = {
    map: $1658fe5a533eee99$var$S,
    forEach: function(a, b, e) {
        $1658fe5a533eee99$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1658fe5a533eee99$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1658fe5a533eee99$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1658fe5a533eee99$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1658fe5a533eee99$export$16fa2f45be04daa8 = $1658fe5a533eee99$var$E;
$1658fe5a533eee99$export$ffb0004e005737fa = $1658fe5a533eee99$var$p;
$1658fe5a533eee99$export$e2c29f18771995cb = $1658fe5a533eee99$var$r;
$1658fe5a533eee99$export$221d75b3f55bb0bd = $1658fe5a533eee99$var$G;
$1658fe5a533eee99$export$5f8d39834fd61797 = $1658fe5a533eee99$var$q;
$1658fe5a533eee99$export$74bf444e3cd11ea5 = $1658fe5a533eee99$var$w;
$1658fe5a533eee99$export$ae55be85d98224ed = $1658fe5a533eee99$var$W;
$1658fe5a533eee99$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1658fe5a533eee99$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1658fe5a533eee99$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1658fe5a533eee99$var$J.call(b, f) && !$1658fe5a533eee99$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1658fe5a533eee99$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1658fe5a533eee99$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1658fe5a533eee99$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1658fe5a533eee99$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1658fe5a533eee99$export$c8a8987d4410bf2d = $1658fe5a533eee99$var$M;
$1658fe5a533eee99$export$d38cd72104c1f0e9 = function(a) {
    var b = $1658fe5a533eee99$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1658fe5a533eee99$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1658fe5a533eee99$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1658fe5a533eee99$var$v,
        render: a
    };
};
$1658fe5a533eee99$export$a8257692ac88316c = $1658fe5a533eee99$var$O;
$1658fe5a533eee99$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1658fe5a533eee99$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1658fe5a533eee99$var$T
    };
};
$1658fe5a533eee99$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1658fe5a533eee99$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1658fe5a533eee99$export$7568632d0d33d16d = function(a) {
    var b = $1658fe5a533eee99$var$V.transition;
    $1658fe5a533eee99$var$V.transition = {};
    try {
        a();
    } finally{
        $1658fe5a533eee99$var$V.transition = b;
    }
};
$1658fe5a533eee99$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1658fe5a533eee99$export$35808ee640e87ca7 = function(a, b) {
    return $1658fe5a533eee99$var$U.current.useCallback(a, b);
};
$1658fe5a533eee99$export$fae74005e78b1a27 = function(a) {
    return $1658fe5a533eee99$var$U.current.useContext(a);
};
$1658fe5a533eee99$export$dc8fbce3eb94dc1e = function() {};
$1658fe5a533eee99$export$6a7bc4e911dc01cf = function(a) {
    return $1658fe5a533eee99$var$U.current.useDeferredValue(a);
};
$1658fe5a533eee99$export$6d9c69b0de29b591 = function(a, b) {
    return $1658fe5a533eee99$var$U.current.useEffect(a, b);
};
$1658fe5a533eee99$export$f680877a34711e37 = function() {
    return $1658fe5a533eee99$var$U.current.useId();
};
$1658fe5a533eee99$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1658fe5a533eee99$var$U.current.useImperativeHandle(a, b, e);
};
$1658fe5a533eee99$export$aaabe4eda9ed9969 = function(a, b) {
    return $1658fe5a533eee99$var$U.current.useInsertionEffect(a, b);
};
$1658fe5a533eee99$export$e5c5a5f917a5871c = function(a, b) {
    return $1658fe5a533eee99$var$U.current.useLayoutEffect(a, b);
};
$1658fe5a533eee99$export$1538c33de8887b59 = function(a, b) {
    return $1658fe5a533eee99$var$U.current.useMemo(a, b);
};
$1658fe5a533eee99$export$13e3392192263954 = function(a, b, e) {
    return $1658fe5a533eee99$var$U.current.useReducer(a, b, e);
};
$1658fe5a533eee99$export$b8f5890fc79d6aca = function(a) {
    return $1658fe5a533eee99$var$U.current.useRef(a);
};
$1658fe5a533eee99$export$60241385465d0a34 = function(a) {
    return $1658fe5a533eee99$var$U.current.useState(a);
};
$1658fe5a533eee99$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1658fe5a533eee99$var$U.current.useSyncExternalStore(a, b, e);
};
$1658fe5a533eee99$export$7b286972b8d8ccbf = function() {
    return $1658fe5a533eee99$var$U.current.useTransition();
};
$1658fe5a533eee99$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("lk0Tq", function(module, exports) {
"use strict";
function $f85c288b1a88dd28$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($f85c288b1a88dd28$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$f85c288b1a88dd28$var$checkDCE();

module.exports = (parcelRequire("kzmoG"));

});
parcelRequire.register("kzmoG", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ef987327cc5edb69$export$ae55be85d98224ed; }, function (v) { return $ef987327cc5edb69$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $ef987327cc5edb69$export$d39a5bbd09211389; }, function (v) { return $ef987327cc5edb69$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $ef987327cc5edb69$export$882461b6382ed46c; }, function (v) { return $ef987327cc5edb69$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $ef987327cc5edb69$export$466bfc07425424d5; }, function (v) { return $ef987327cc5edb69$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $ef987327cc5edb69$export$cd75ccfd720a3cd4; }, function (v) { return $ef987327cc5edb69$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $ef987327cc5edb69$export$fa8d919ba61d84db; }, function (v) { return $ef987327cc5edb69$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $ef987327cc5edb69$export$757ceba2d55c277e; }, function (v) { return $ef987327cc5edb69$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $ef987327cc5edb69$export$b3890eb0ae9dca99; }, function (v) { return $ef987327cc5edb69$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $ef987327cc5edb69$export$502457920280e6be; }, function (v) { return $ef987327cc5edb69$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ef987327cc5edb69$export$c78a37762a8d58e1; }, function (v) { return $ef987327cc5edb69$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $ef987327cc5edb69$export$dc54d992c10e8a18; }, function (v) { return $ef987327cc5edb69$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $ef987327cc5edb69$export$83d89fbfd8236492; }, function (v) { return $ef987327cc5edb69$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $ef987327cc5edb69$export$ae55be85d98224ed;
var $ef987327cc5edb69$export$d39a5bbd09211389;
var $ef987327cc5edb69$export$882461b6382ed46c;
var $ef987327cc5edb69$export$466bfc07425424d5;
var $ef987327cc5edb69$export$cd75ccfd720a3cd4;
var $ef987327cc5edb69$export$fa8d919ba61d84db;
var $ef987327cc5edb69$export$757ceba2d55c277e;
var $ef987327cc5edb69$export$b3890eb0ae9dca99;
var $ef987327cc5edb69$export$502457920280e6be;
var $ef987327cc5edb69$export$c78a37762a8d58e1;
var $ef987327cc5edb69$export$dc54d992c10e8a18;
var $ef987327cc5edb69$export$83d89fbfd8236492;
"use strict";

var $9KJkx = parcelRequire("9KJkx");

var $frsaN = parcelRequire("frsaN");
function $ef987327cc5edb69$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $ef987327cc5edb69$var$da = new Set, $ef987327cc5edb69$var$ea = {};
function $ef987327cc5edb69$var$fa(a, b) {
    $ef987327cc5edb69$var$ha(a, b);
    $ef987327cc5edb69$var$ha(a + "Capture", b);
}
function $ef987327cc5edb69$var$ha(a, b) {
    $ef987327cc5edb69$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$ef987327cc5edb69$var$da.add(b[a]);
}
var $ef987327cc5edb69$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $ef987327cc5edb69$var$ja = Object.prototype.hasOwnProperty, $ef987327cc5edb69$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $ef987327cc5edb69$var$la = {}, $ef987327cc5edb69$var$ma = {};
function $ef987327cc5edb69$var$oa(a) {
    if ($ef987327cc5edb69$var$ja.call($ef987327cc5edb69$var$ma, a)) return !0;
    if ($ef987327cc5edb69$var$ja.call($ef987327cc5edb69$var$la, a)) return !1;
    if ($ef987327cc5edb69$var$ka.test(a)) return $ef987327cc5edb69$var$ma[a] = !0;
    $ef987327cc5edb69$var$la[a] = !0;
    return !1;
}
function $ef987327cc5edb69$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $ef987327cc5edb69$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $ef987327cc5edb69$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $ef987327cc5edb69$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $ef987327cc5edb69$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $ef987327cc5edb69$var$z[b] = new $ef987327cc5edb69$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $ef987327cc5edb69$var$ra = /[\-:]([a-z])/g;
function $ef987327cc5edb69$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($ef987327cc5edb69$var$ra, $ef987327cc5edb69$var$sa);
    $ef987327cc5edb69$var$z[b] = new $ef987327cc5edb69$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($ef987327cc5edb69$var$ra, $ef987327cc5edb69$var$sa);
    $ef987327cc5edb69$var$z[b] = new $ef987327cc5edb69$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($ef987327cc5edb69$var$ra, $ef987327cc5edb69$var$sa);
    $ef987327cc5edb69$var$z[b] = new $ef987327cc5edb69$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$ef987327cc5edb69$var$z.xlinkHref = new $ef987327cc5edb69$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $ef987327cc5edb69$var$z[a] = new $ef987327cc5edb69$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $ef987327cc5edb69$var$ta(a, b, c, d) {
    var e = $ef987327cc5edb69$var$z.hasOwnProperty(b) ? $ef987327cc5edb69$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $ef987327cc5edb69$var$qa(b, c, e, d) && (c = null), d || null === e ? $ef987327cc5edb69$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $ef987327cc5edb69$var$ua = $9KJkx.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $ef987327cc5edb69$var$va = Symbol.for("react.element"), $ef987327cc5edb69$var$wa = Symbol.for("react.portal"), $ef987327cc5edb69$var$ya = Symbol.for("react.fragment"), $ef987327cc5edb69$var$za = Symbol.for("react.strict_mode"), $ef987327cc5edb69$var$Aa = Symbol.for("react.profiler"), $ef987327cc5edb69$var$Ba = Symbol.for("react.provider"), $ef987327cc5edb69$var$Ca = Symbol.for("react.context"), $ef987327cc5edb69$var$Da = Symbol.for("react.forward_ref"), $ef987327cc5edb69$var$Ea = Symbol.for("react.suspense"), $ef987327cc5edb69$var$Fa = Symbol.for("react.suspense_list"), $ef987327cc5edb69$var$Ga = Symbol.for("react.memo"), $ef987327cc5edb69$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $ef987327cc5edb69$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $ef987327cc5edb69$var$Ja = Symbol.iterator;
function $ef987327cc5edb69$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ef987327cc5edb69$var$Ja && a[$ef987327cc5edb69$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ef987327cc5edb69$var$A = Object.assign, $ef987327cc5edb69$var$La;
function $ef987327cc5edb69$var$Ma(a) {
    if (void 0 === $ef987327cc5edb69$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $ef987327cc5edb69$var$La = b && b[1] || "";
    }
    return "\n" + $ef987327cc5edb69$var$La + a;
}
var $ef987327cc5edb69$var$Na = !1;
function $ef987327cc5edb69$var$Oa(a, b) {
    if (!a || $ef987327cc5edb69$var$Na) return "";
    $ef987327cc5edb69$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $ef987327cc5edb69$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $ef987327cc5edb69$var$Ma(a) : "";
}
function $ef987327cc5edb69$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $ef987327cc5edb69$var$Ma(a.type);
        case 16:
            return $ef987327cc5edb69$var$Ma("Lazy");
        case 13:
            return $ef987327cc5edb69$var$Ma("Suspense");
        case 19:
            return $ef987327cc5edb69$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $ef987327cc5edb69$var$Oa(a.type, !1), a;
        case 11:
            return a = $ef987327cc5edb69$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $ef987327cc5edb69$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $ef987327cc5edb69$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $ef987327cc5edb69$var$ya:
            return "Fragment";
        case $ef987327cc5edb69$var$wa:
            return "Portal";
        case $ef987327cc5edb69$var$Aa:
            return "Profiler";
        case $ef987327cc5edb69$var$za:
            return "StrictMode";
        case $ef987327cc5edb69$var$Ea:
            return "Suspense";
        case $ef987327cc5edb69$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $ef987327cc5edb69$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $ef987327cc5edb69$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $ef987327cc5edb69$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $ef987327cc5edb69$var$Ga:
            return b = a.displayName || null, null !== b ? b : $ef987327cc5edb69$var$Qa(a.type) || "Memo";
        case $ef987327cc5edb69$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $ef987327cc5edb69$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $ef987327cc5edb69$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $ef987327cc5edb69$var$Qa(b);
        case 8:
            return b === $ef987327cc5edb69$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $ef987327cc5edb69$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $ef987327cc5edb69$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $ef987327cc5edb69$var$Ua(a) {
    var b = $ef987327cc5edb69$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $ef987327cc5edb69$var$Va(a) {
    a._valueTracker || (a._valueTracker = $ef987327cc5edb69$var$Ua(a));
}
function $ef987327cc5edb69$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $ef987327cc5edb69$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $ef987327cc5edb69$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $ef987327cc5edb69$var$Ya(a, b) {
    var c = b.checked;
    return $ef987327cc5edb69$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $ef987327cc5edb69$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $ef987327cc5edb69$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $ef987327cc5edb69$var$ab(a, b) {
    b = b.checked;
    null != b && $ef987327cc5edb69$var$ta(a, "checked", b, !1);
}
function $ef987327cc5edb69$var$bb(a, b) {
    $ef987327cc5edb69$var$ab(a, b);
    var c = $ef987327cc5edb69$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $ef987327cc5edb69$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $ef987327cc5edb69$var$cb(a, b.type, $ef987327cc5edb69$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $ef987327cc5edb69$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $ef987327cc5edb69$var$cb(a, b, c) {
    if ("number" !== b || $ef987327cc5edb69$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $ef987327cc5edb69$var$eb = Array.isArray;
function $ef987327cc5edb69$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $ef987327cc5edb69$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $ef987327cc5edb69$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($ef987327cc5edb69$var$p(91));
    return $ef987327cc5edb69$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $ef987327cc5edb69$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($ef987327cc5edb69$var$p(92));
            if ($ef987327cc5edb69$var$eb(c)) {
                if (1 < c.length) throw Error($ef987327cc5edb69$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $ef987327cc5edb69$var$Sa(c)
    };
}
function $ef987327cc5edb69$var$ib(a, b) {
    var c = $ef987327cc5edb69$var$Sa(b.value), d = $ef987327cc5edb69$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $ef987327cc5edb69$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $ef987327cc5edb69$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $ef987327cc5edb69$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $ef987327cc5edb69$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $ef987327cc5edb69$var$mb, $ef987327cc5edb69$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $ef987327cc5edb69$var$mb = $ef987327cc5edb69$var$mb || document.createElement("div");
        $ef987327cc5edb69$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $ef987327cc5edb69$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $ef987327cc5edb69$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $ef987327cc5edb69$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $ef987327cc5edb69$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($ef987327cc5edb69$var$pb).forEach(function(a) {
    $ef987327cc5edb69$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $ef987327cc5edb69$var$pb[b] = $ef987327cc5edb69$var$pb[a];
    });
});
function $ef987327cc5edb69$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $ef987327cc5edb69$var$pb.hasOwnProperty(a) && $ef987327cc5edb69$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $ef987327cc5edb69$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $ef987327cc5edb69$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $ef987327cc5edb69$var$tb = $ef987327cc5edb69$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $ef987327cc5edb69$var$ub(a, b) {
    if (b) {
        if ($ef987327cc5edb69$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($ef987327cc5edb69$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($ef987327cc5edb69$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($ef987327cc5edb69$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($ef987327cc5edb69$var$p(62));
    }
}
function $ef987327cc5edb69$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $ef987327cc5edb69$var$wb = null;
function $ef987327cc5edb69$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $ef987327cc5edb69$var$yb = null, $ef987327cc5edb69$var$zb = null, $ef987327cc5edb69$var$Ab = null;
function $ef987327cc5edb69$var$Bb(a) {
    if (a = $ef987327cc5edb69$var$Cb(a)) {
        if ("function" !== typeof $ef987327cc5edb69$var$yb) throw Error($ef987327cc5edb69$var$p(280));
        var b = a.stateNode;
        b && (b = $ef987327cc5edb69$var$Db(b), $ef987327cc5edb69$var$yb(a.stateNode, a.type, b));
    }
}
function $ef987327cc5edb69$var$Eb(a) {
    $ef987327cc5edb69$var$zb ? $ef987327cc5edb69$var$Ab ? $ef987327cc5edb69$var$Ab.push(a) : $ef987327cc5edb69$var$Ab = [
        a
    ] : $ef987327cc5edb69$var$zb = a;
}
function $ef987327cc5edb69$var$Fb() {
    if ($ef987327cc5edb69$var$zb) {
        var a = $ef987327cc5edb69$var$zb, b = $ef987327cc5edb69$var$Ab;
        $ef987327cc5edb69$var$Ab = $ef987327cc5edb69$var$zb = null;
        $ef987327cc5edb69$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$ef987327cc5edb69$var$Bb(b[a]);
    }
}
function $ef987327cc5edb69$var$Gb(a, b) {
    return a(b);
}
function $ef987327cc5edb69$var$Hb() {}
var $ef987327cc5edb69$var$Ib = !1;
function $ef987327cc5edb69$var$Jb(a, b, c) {
    if ($ef987327cc5edb69$var$Ib) return a(b, c);
    $ef987327cc5edb69$var$Ib = !0;
    try {
        return $ef987327cc5edb69$var$Gb(a, b, c);
    } finally{
        if ($ef987327cc5edb69$var$Ib = !1, null !== $ef987327cc5edb69$var$zb || null !== $ef987327cc5edb69$var$Ab) $ef987327cc5edb69$var$Hb(), $ef987327cc5edb69$var$Fb();
    }
}
function $ef987327cc5edb69$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $ef987327cc5edb69$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($ef987327cc5edb69$var$p(231, b, typeof c));
    return c;
}
var $ef987327cc5edb69$var$Lb = !1;
if ($ef987327cc5edb69$var$ia) try {
    var $ef987327cc5edb69$var$Mb = {};
    Object.defineProperty($ef987327cc5edb69$var$Mb, "passive", {
        get: function() {
            $ef987327cc5edb69$var$Lb = !0;
        }
    });
    window.addEventListener("test", $ef987327cc5edb69$var$Mb, $ef987327cc5edb69$var$Mb);
    window.removeEventListener("test", $ef987327cc5edb69$var$Mb, $ef987327cc5edb69$var$Mb);
} catch (a) {
    $ef987327cc5edb69$var$Lb = !1;
}
function $ef987327cc5edb69$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $ef987327cc5edb69$var$Ob = !1, $ef987327cc5edb69$var$Pb = null, $ef987327cc5edb69$var$Qb = !1, $ef987327cc5edb69$var$Rb = null, $ef987327cc5edb69$var$Sb = {
    onError: function(a) {
        $ef987327cc5edb69$var$Ob = !0;
        $ef987327cc5edb69$var$Pb = a;
    }
};
function $ef987327cc5edb69$var$Tb(a, b, c, d, e, f, g, h, k) {
    $ef987327cc5edb69$var$Ob = !1;
    $ef987327cc5edb69$var$Pb = null;
    $ef987327cc5edb69$var$Nb.apply($ef987327cc5edb69$var$Sb, arguments);
}
function $ef987327cc5edb69$var$Ub(a, b, c, d, e, f, g, h, k) {
    $ef987327cc5edb69$var$Tb.apply(this, arguments);
    if ($ef987327cc5edb69$var$Ob) {
        if ($ef987327cc5edb69$var$Ob) {
            var l = $ef987327cc5edb69$var$Pb;
            $ef987327cc5edb69$var$Ob = !1;
            $ef987327cc5edb69$var$Pb = null;
        } else throw Error($ef987327cc5edb69$var$p(198));
        $ef987327cc5edb69$var$Qb || ($ef987327cc5edb69$var$Qb = !0, $ef987327cc5edb69$var$Rb = l);
    }
}
function $ef987327cc5edb69$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $ef987327cc5edb69$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $ef987327cc5edb69$var$Xb(a) {
    if ($ef987327cc5edb69$var$Vb(a) !== a) throw Error($ef987327cc5edb69$var$p(188));
}
function $ef987327cc5edb69$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $ef987327cc5edb69$var$Vb(a);
        if (null === b) throw Error($ef987327cc5edb69$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $ef987327cc5edb69$var$Xb(e), a;
                if (f === d) return $ef987327cc5edb69$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($ef987327cc5edb69$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($ef987327cc5edb69$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($ef987327cc5edb69$var$p(190));
    }
    if (3 !== c.tag) throw Error($ef987327cc5edb69$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $ef987327cc5edb69$var$Zb(a) {
    a = $ef987327cc5edb69$var$Yb(a);
    return null !== a ? $ef987327cc5edb69$var$$b(a) : null;
}
function $ef987327cc5edb69$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $ef987327cc5edb69$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $ef987327cc5edb69$var$ac = $frsaN.unstable_scheduleCallback, $ef987327cc5edb69$var$bc = $frsaN.unstable_cancelCallback, $ef987327cc5edb69$var$cc = $frsaN.unstable_shouldYield, $ef987327cc5edb69$var$dc = $frsaN.unstable_requestPaint, $ef987327cc5edb69$var$B = $frsaN.unstable_now, $ef987327cc5edb69$var$ec = $frsaN.unstable_getCurrentPriorityLevel, $ef987327cc5edb69$var$fc = $frsaN.unstable_ImmediatePriority, $ef987327cc5edb69$var$gc = $frsaN.unstable_UserBlockingPriority, $ef987327cc5edb69$var$hc = $frsaN.unstable_NormalPriority, $ef987327cc5edb69$var$ic = $frsaN.unstable_LowPriority, $ef987327cc5edb69$var$jc = $frsaN.unstable_IdlePriority, $ef987327cc5edb69$var$kc = null, $ef987327cc5edb69$var$lc = null;
function $ef987327cc5edb69$var$mc(a) {
    if ($ef987327cc5edb69$var$lc && "function" === typeof $ef987327cc5edb69$var$lc.onCommitFiberRoot) try {
        $ef987327cc5edb69$var$lc.onCommitFiberRoot($ef987327cc5edb69$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $ef987327cc5edb69$var$oc = Math.clz32 ? Math.clz32 : $ef987327cc5edb69$var$nc, $ef987327cc5edb69$var$pc = Math.log, $ef987327cc5edb69$var$qc = Math.LN2;
function $ef987327cc5edb69$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($ef987327cc5edb69$var$pc(a) / $ef987327cc5edb69$var$qc | 0) | 0;
}
var $ef987327cc5edb69$var$rc = 64, $ef987327cc5edb69$var$sc = 4194304;
function $ef987327cc5edb69$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $ef987327cc5edb69$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $ef987327cc5edb69$var$tc(h) : (f &= g, 0 !== f && (d = $ef987327cc5edb69$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $ef987327cc5edb69$var$tc(g) : 0 !== f && (d = $ef987327cc5edb69$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $ef987327cc5edb69$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $ef987327cc5edb69$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $ef987327cc5edb69$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $ef987327cc5edb69$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $ef987327cc5edb69$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $ef987327cc5edb69$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $ef987327cc5edb69$var$yc() {
    var a = $ef987327cc5edb69$var$rc;
    $ef987327cc5edb69$var$rc <<= 1;
    0 === ($ef987327cc5edb69$var$rc & 4194240) && ($ef987327cc5edb69$var$rc = 64);
    return a;
}
function $ef987327cc5edb69$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $ef987327cc5edb69$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $ef987327cc5edb69$var$oc(b);
    a[b] = c;
}
function $ef987327cc5edb69$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $ef987327cc5edb69$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $ef987327cc5edb69$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $ef987327cc5edb69$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $ef987327cc5edb69$var$C = 0;
function $ef987327cc5edb69$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $ef987327cc5edb69$var$Ec, $ef987327cc5edb69$var$Fc, $ef987327cc5edb69$var$Gc, $ef987327cc5edb69$var$Hc, $ef987327cc5edb69$var$Ic, $ef987327cc5edb69$var$Jc = !1, $ef987327cc5edb69$var$Kc = [], $ef987327cc5edb69$var$Lc = null, $ef987327cc5edb69$var$Mc = null, $ef987327cc5edb69$var$Nc = null, $ef987327cc5edb69$var$Oc = new Map, $ef987327cc5edb69$var$Pc = new Map, $ef987327cc5edb69$var$Qc = [], $ef987327cc5edb69$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $ef987327cc5edb69$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $ef987327cc5edb69$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $ef987327cc5edb69$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $ef987327cc5edb69$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $ef987327cc5edb69$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $ef987327cc5edb69$var$Pc.delete(b.pointerId);
    }
}
function $ef987327cc5edb69$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $ef987327cc5edb69$var$Cb(b), null !== b && $ef987327cc5edb69$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $ef987327cc5edb69$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $ef987327cc5edb69$var$Lc = $ef987327cc5edb69$var$Tc($ef987327cc5edb69$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $ef987327cc5edb69$var$Mc = $ef987327cc5edb69$var$Tc($ef987327cc5edb69$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $ef987327cc5edb69$var$Nc = $ef987327cc5edb69$var$Tc($ef987327cc5edb69$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $ef987327cc5edb69$var$Oc.set(f, $ef987327cc5edb69$var$Tc($ef987327cc5edb69$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $ef987327cc5edb69$var$Pc.set(f, $ef987327cc5edb69$var$Tc($ef987327cc5edb69$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $ef987327cc5edb69$var$Vc(a) {
    var b = $ef987327cc5edb69$var$Wc(a.target);
    if (null !== b) {
        var c = $ef987327cc5edb69$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $ef987327cc5edb69$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $ef987327cc5edb69$var$Ic(a.priority, function() {
                        $ef987327cc5edb69$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $ef987327cc5edb69$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $ef987327cc5edb69$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $ef987327cc5edb69$var$wb = d;
            c.target.dispatchEvent(d);
            $ef987327cc5edb69$var$wb = null;
        } else return b = $ef987327cc5edb69$var$Cb(c), null !== b && $ef987327cc5edb69$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $ef987327cc5edb69$var$Zc(a, b, c) {
    $ef987327cc5edb69$var$Xc(a) && c.delete(b);
}
function $ef987327cc5edb69$var$$c() {
    $ef987327cc5edb69$var$Jc = !1;
    null !== $ef987327cc5edb69$var$Lc && $ef987327cc5edb69$var$Xc($ef987327cc5edb69$var$Lc) && ($ef987327cc5edb69$var$Lc = null);
    null !== $ef987327cc5edb69$var$Mc && $ef987327cc5edb69$var$Xc($ef987327cc5edb69$var$Mc) && ($ef987327cc5edb69$var$Mc = null);
    null !== $ef987327cc5edb69$var$Nc && $ef987327cc5edb69$var$Xc($ef987327cc5edb69$var$Nc) && ($ef987327cc5edb69$var$Nc = null);
    $ef987327cc5edb69$var$Oc.forEach($ef987327cc5edb69$var$Zc);
    $ef987327cc5edb69$var$Pc.forEach($ef987327cc5edb69$var$Zc);
}
function $ef987327cc5edb69$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $ef987327cc5edb69$var$Jc || ($ef987327cc5edb69$var$Jc = !0, $frsaN.unstable_scheduleCallback($frsaN.unstable_NormalPriority, $ef987327cc5edb69$var$$c)));
}
function $ef987327cc5edb69$var$bd(a) {
    function b(b) {
        return $ef987327cc5edb69$var$ad(b, a);
    }
    if (0 < $ef987327cc5edb69$var$Kc.length) {
        $ef987327cc5edb69$var$ad($ef987327cc5edb69$var$Kc[0], a);
        for(var c = 1; c < $ef987327cc5edb69$var$Kc.length; c++){
            var d = $ef987327cc5edb69$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $ef987327cc5edb69$var$Lc && $ef987327cc5edb69$var$ad($ef987327cc5edb69$var$Lc, a);
    null !== $ef987327cc5edb69$var$Mc && $ef987327cc5edb69$var$ad($ef987327cc5edb69$var$Mc, a);
    null !== $ef987327cc5edb69$var$Nc && $ef987327cc5edb69$var$ad($ef987327cc5edb69$var$Nc, a);
    $ef987327cc5edb69$var$Oc.forEach(b);
    $ef987327cc5edb69$var$Pc.forEach(b);
    for(c = 0; c < $ef987327cc5edb69$var$Qc.length; c++)d = $ef987327cc5edb69$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $ef987327cc5edb69$var$Qc.length && (c = $ef987327cc5edb69$var$Qc[0], null === c.blockedOn);)$ef987327cc5edb69$var$Vc(c), null === c.blockedOn && $ef987327cc5edb69$var$Qc.shift();
}
var $ef987327cc5edb69$var$cd = $ef987327cc5edb69$var$ua.ReactCurrentBatchConfig, $ef987327cc5edb69$var$dd = !0;
function $ef987327cc5edb69$var$ed(a, b, c, d) {
    var e = $ef987327cc5edb69$var$C, f = $ef987327cc5edb69$var$cd.transition;
    $ef987327cc5edb69$var$cd.transition = null;
    try {
        $ef987327cc5edb69$var$C = 1, $ef987327cc5edb69$var$fd(a, b, c, d);
    } finally{
        $ef987327cc5edb69$var$C = e, $ef987327cc5edb69$var$cd.transition = f;
    }
}
function $ef987327cc5edb69$var$gd(a, b, c, d) {
    var e = $ef987327cc5edb69$var$C, f = $ef987327cc5edb69$var$cd.transition;
    $ef987327cc5edb69$var$cd.transition = null;
    try {
        $ef987327cc5edb69$var$C = 4, $ef987327cc5edb69$var$fd(a, b, c, d);
    } finally{
        $ef987327cc5edb69$var$C = e, $ef987327cc5edb69$var$cd.transition = f;
    }
}
function $ef987327cc5edb69$var$fd(a, b, c, d) {
    if ($ef987327cc5edb69$var$dd) {
        var e = $ef987327cc5edb69$var$Yc(a, b, c, d);
        if (null === e) $ef987327cc5edb69$var$hd(a, b, d, $ef987327cc5edb69$var$id, c), $ef987327cc5edb69$var$Sc(a, d);
        else if ($ef987327cc5edb69$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($ef987327cc5edb69$var$Sc(a, d), b & 4 && -1 < $ef987327cc5edb69$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $ef987327cc5edb69$var$Cb(e);
                null !== f && $ef987327cc5edb69$var$Ec(f);
                f = $ef987327cc5edb69$var$Yc(a, b, c, d);
                null === f && $ef987327cc5edb69$var$hd(a, b, d, $ef987327cc5edb69$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $ef987327cc5edb69$var$hd(a, b, d, null, c);
    }
}
var $ef987327cc5edb69$var$id = null;
function $ef987327cc5edb69$var$Yc(a, b, c, d) {
    $ef987327cc5edb69$var$id = null;
    a = $ef987327cc5edb69$var$xb(d);
    a = $ef987327cc5edb69$var$Wc(a);
    if (null !== a) {
        if (b = $ef987327cc5edb69$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $ef987327cc5edb69$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $ef987327cc5edb69$var$id = a;
    return null;
}
function $ef987327cc5edb69$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($ef987327cc5edb69$var$ec()){
                case $ef987327cc5edb69$var$fc:
                    return 1;
                case $ef987327cc5edb69$var$gc:
                    return 4;
                case $ef987327cc5edb69$var$hc:
                case $ef987327cc5edb69$var$ic:
                    return 16;
                case $ef987327cc5edb69$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $ef987327cc5edb69$var$kd = null, $ef987327cc5edb69$var$ld = null, $ef987327cc5edb69$var$md = null;
function $ef987327cc5edb69$var$nd() {
    if ($ef987327cc5edb69$var$md) return $ef987327cc5edb69$var$md;
    var a, b = $ef987327cc5edb69$var$ld, c = b.length, d, e = "value" in $ef987327cc5edb69$var$kd ? $ef987327cc5edb69$var$kd.value : $ef987327cc5edb69$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $ef987327cc5edb69$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $ef987327cc5edb69$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $ef987327cc5edb69$var$pd() {
    return !0;
}
function $ef987327cc5edb69$var$qd() {
    return !1;
}
function $ef987327cc5edb69$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $ef987327cc5edb69$var$pd : $ef987327cc5edb69$var$qd;
        this.isPropagationStopped = $ef987327cc5edb69$var$qd;
        return this;
    }
    $ef987327cc5edb69$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $ef987327cc5edb69$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $ef987327cc5edb69$var$pd);
        },
        persist: function() {},
        isPersistent: $ef987327cc5edb69$var$pd
    });
    return b;
}
var $ef987327cc5edb69$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $ef987327cc5edb69$var$td = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$sd), $ef987327cc5edb69$var$ud = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$sd, {
    view: 0,
    detail: 0
}), $ef987327cc5edb69$var$vd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$ud), $ef987327cc5edb69$var$wd, $ef987327cc5edb69$var$xd, $ef987327cc5edb69$var$yd, $ef987327cc5edb69$var$Ad = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $ef987327cc5edb69$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $ef987327cc5edb69$var$yd && ($ef987327cc5edb69$var$yd && "mousemove" === a.type ? ($ef987327cc5edb69$var$wd = a.screenX - $ef987327cc5edb69$var$yd.screenX, $ef987327cc5edb69$var$xd = a.screenY - $ef987327cc5edb69$var$yd.screenY) : $ef987327cc5edb69$var$xd = $ef987327cc5edb69$var$wd = 0, $ef987327cc5edb69$var$yd = a);
        return $ef987327cc5edb69$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $ef987327cc5edb69$var$xd;
    }
}), $ef987327cc5edb69$var$Bd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Ad), $ef987327cc5edb69$var$Cd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$Ad, {
    dataTransfer: 0
}), $ef987327cc5edb69$var$Dd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Cd), $ef987327cc5edb69$var$Ed = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$ud, {
    relatedTarget: 0
}), $ef987327cc5edb69$var$Fd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Ed), $ef987327cc5edb69$var$Gd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ef987327cc5edb69$var$Hd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Gd), $ef987327cc5edb69$var$Id = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $ef987327cc5edb69$var$Jd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Id), $ef987327cc5edb69$var$Kd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$sd, {
    data: 0
}), $ef987327cc5edb69$var$Ld = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Kd), $ef987327cc5edb69$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $ef987327cc5edb69$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $ef987327cc5edb69$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $ef987327cc5edb69$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $ef987327cc5edb69$var$Od[a]) ? !!b[a] : !1;
}
function $ef987327cc5edb69$var$zd() {
    return $ef987327cc5edb69$var$Pd;
}
var $ef987327cc5edb69$var$Qd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $ef987327cc5edb69$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $ef987327cc5edb69$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $ef987327cc5edb69$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $ef987327cc5edb69$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $ef987327cc5edb69$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $ef987327cc5edb69$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $ef987327cc5edb69$var$Rd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Qd), $ef987327cc5edb69$var$Sd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $ef987327cc5edb69$var$Td = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Sd), $ef987327cc5edb69$var$Ud = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $ef987327cc5edb69$var$zd
}), $ef987327cc5edb69$var$Vd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Ud), $ef987327cc5edb69$var$Wd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $ef987327cc5edb69$var$Xd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Wd), $ef987327cc5edb69$var$Yd = $ef987327cc5edb69$var$A({}, $ef987327cc5edb69$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $ef987327cc5edb69$var$Zd = $ef987327cc5edb69$var$rd($ef987327cc5edb69$var$Yd), $ef987327cc5edb69$var$$d = [
    9,
    13,
    27,
    32
], $ef987327cc5edb69$var$ae = $ef987327cc5edb69$var$ia && "CompositionEvent" in window, $ef987327cc5edb69$var$be = null;
$ef987327cc5edb69$var$ia && "documentMode" in document && ($ef987327cc5edb69$var$be = document.documentMode);
var $ef987327cc5edb69$var$ce = $ef987327cc5edb69$var$ia && "TextEvent" in window && !$ef987327cc5edb69$var$be, $ef987327cc5edb69$var$de = $ef987327cc5edb69$var$ia && (!$ef987327cc5edb69$var$ae || $ef987327cc5edb69$var$be && 8 < $ef987327cc5edb69$var$be && 11 >= $ef987327cc5edb69$var$be), $ef987327cc5edb69$var$ee = String.fromCharCode(32), $ef987327cc5edb69$var$fe = !1;
function $ef987327cc5edb69$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $ef987327cc5edb69$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $ef987327cc5edb69$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $ef987327cc5edb69$var$ie = !1;
function $ef987327cc5edb69$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $ef987327cc5edb69$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $ef987327cc5edb69$var$fe = !0;
            return $ef987327cc5edb69$var$ee;
        case "textInput":
            return a = b.data, a === $ef987327cc5edb69$var$ee && $ef987327cc5edb69$var$fe ? null : a;
        default:
            return null;
    }
}
function $ef987327cc5edb69$var$ke(a, b) {
    if ($ef987327cc5edb69$var$ie) return "compositionend" === a || !$ef987327cc5edb69$var$ae && $ef987327cc5edb69$var$ge(a, b) ? (a = $ef987327cc5edb69$var$nd(), $ef987327cc5edb69$var$md = $ef987327cc5edb69$var$ld = $ef987327cc5edb69$var$kd = null, $ef987327cc5edb69$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $ef987327cc5edb69$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $ef987327cc5edb69$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $ef987327cc5edb69$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$ef987327cc5edb69$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $ef987327cc5edb69$var$ne(a, b, c, d) {
    $ef987327cc5edb69$var$Eb(d);
    b = $ef987327cc5edb69$var$oe(b, "onChange");
    0 < b.length && (c = new $ef987327cc5edb69$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $ef987327cc5edb69$var$pe = null, $ef987327cc5edb69$var$qe = null;
function $ef987327cc5edb69$var$re(a) {
    $ef987327cc5edb69$var$se(a, 0);
}
function $ef987327cc5edb69$var$te(a) {
    var b = $ef987327cc5edb69$var$ue(a);
    if ($ef987327cc5edb69$var$Wa(b)) return a;
}
function $ef987327cc5edb69$var$ve(a, b) {
    if ("change" === a) return b;
}
var $ef987327cc5edb69$var$we = !1;
if ($ef987327cc5edb69$var$ia) {
    var $ef987327cc5edb69$var$xe;
    if ($ef987327cc5edb69$var$ia) {
        var $ef987327cc5edb69$var$ye = "oninput" in document;
        if (!$ef987327cc5edb69$var$ye) {
            var $ef987327cc5edb69$var$ze = document.createElement("div");
            $ef987327cc5edb69$var$ze.setAttribute("oninput", "return;");
            $ef987327cc5edb69$var$ye = "function" === typeof $ef987327cc5edb69$var$ze.oninput;
        }
        $ef987327cc5edb69$var$xe = $ef987327cc5edb69$var$ye;
    } else $ef987327cc5edb69$var$xe = !1;
    $ef987327cc5edb69$var$we = $ef987327cc5edb69$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $ef987327cc5edb69$var$Ae() {
    $ef987327cc5edb69$var$pe && ($ef987327cc5edb69$var$pe.detachEvent("onpropertychange", $ef987327cc5edb69$var$Be), $ef987327cc5edb69$var$qe = $ef987327cc5edb69$var$pe = null);
}
function $ef987327cc5edb69$var$Be(a) {
    if ("value" === a.propertyName && $ef987327cc5edb69$var$te($ef987327cc5edb69$var$qe)) {
        var b = [];
        $ef987327cc5edb69$var$ne(b, $ef987327cc5edb69$var$qe, a, $ef987327cc5edb69$var$xb(a));
        $ef987327cc5edb69$var$Jb($ef987327cc5edb69$var$re, b);
    }
}
function $ef987327cc5edb69$var$Ce(a, b, c) {
    "focusin" === a ? ($ef987327cc5edb69$var$Ae(), $ef987327cc5edb69$var$pe = b, $ef987327cc5edb69$var$qe = c, $ef987327cc5edb69$var$pe.attachEvent("onpropertychange", $ef987327cc5edb69$var$Be)) : "focusout" === a && $ef987327cc5edb69$var$Ae();
}
function $ef987327cc5edb69$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $ef987327cc5edb69$var$te($ef987327cc5edb69$var$qe);
}
function $ef987327cc5edb69$var$Ee(a, b) {
    if ("click" === a) return $ef987327cc5edb69$var$te(b);
}
function $ef987327cc5edb69$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $ef987327cc5edb69$var$te(b);
}
function $ef987327cc5edb69$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $ef987327cc5edb69$var$He = "function" === typeof Object.is ? Object.is : $ef987327cc5edb69$var$Ge;
function $ef987327cc5edb69$var$Ie(a, b) {
    if ($ef987327cc5edb69$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$ef987327cc5edb69$var$ja.call(b, e) || !$ef987327cc5edb69$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $ef987327cc5edb69$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $ef987327cc5edb69$var$Ke(a, b) {
    var c = $ef987327cc5edb69$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $ef987327cc5edb69$var$Je(c);
    }
}
function $ef987327cc5edb69$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $ef987327cc5edb69$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $ef987327cc5edb69$var$Me() {
    for(var a = window, b = $ef987327cc5edb69$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $ef987327cc5edb69$var$Xa(a.document);
    }
    return b;
}
function $ef987327cc5edb69$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $ef987327cc5edb69$var$Oe(a) {
    var b = $ef987327cc5edb69$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $ef987327cc5edb69$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $ef987327cc5edb69$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $ef987327cc5edb69$var$Ke(c, f);
                var g = $ef987327cc5edb69$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $ef987327cc5edb69$var$Pe = $ef987327cc5edb69$var$ia && "documentMode" in document && 11 >= document.documentMode, $ef987327cc5edb69$var$Qe = null, $ef987327cc5edb69$var$Re = null, $ef987327cc5edb69$var$Se = null, $ef987327cc5edb69$var$Te = !1;
function $ef987327cc5edb69$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $ef987327cc5edb69$var$Te || null == $ef987327cc5edb69$var$Qe || $ef987327cc5edb69$var$Qe !== $ef987327cc5edb69$var$Xa(d) || (d = $ef987327cc5edb69$var$Qe, "selectionStart" in d && $ef987327cc5edb69$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $ef987327cc5edb69$var$Se && $ef987327cc5edb69$var$Ie($ef987327cc5edb69$var$Se, d) || ($ef987327cc5edb69$var$Se = d, d = $ef987327cc5edb69$var$oe($ef987327cc5edb69$var$Re, "onSelect"), 0 < d.length && (b = new $ef987327cc5edb69$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $ef987327cc5edb69$var$Qe)));
}
function $ef987327cc5edb69$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $ef987327cc5edb69$var$We = {
    animationend: $ef987327cc5edb69$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $ef987327cc5edb69$var$Ve("Animation", "AnimationIteration"),
    animationstart: $ef987327cc5edb69$var$Ve("Animation", "AnimationStart"),
    transitionend: $ef987327cc5edb69$var$Ve("Transition", "TransitionEnd")
}, $ef987327cc5edb69$var$Xe = {}, $ef987327cc5edb69$var$Ye = {};
$ef987327cc5edb69$var$ia && ($ef987327cc5edb69$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $ef987327cc5edb69$var$We.animationend.animation, delete $ef987327cc5edb69$var$We.animationiteration.animation, delete $ef987327cc5edb69$var$We.animationstart.animation), "TransitionEvent" in window || delete $ef987327cc5edb69$var$We.transitionend.transition);
function $ef987327cc5edb69$var$Ze(a) {
    if ($ef987327cc5edb69$var$Xe[a]) return $ef987327cc5edb69$var$Xe[a];
    if (!$ef987327cc5edb69$var$We[a]) return a;
    var b = $ef987327cc5edb69$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $ef987327cc5edb69$var$Ye) return $ef987327cc5edb69$var$Xe[a] = b[c];
    return a;
}
var $ef987327cc5edb69$var$$e = $ef987327cc5edb69$var$Ze("animationend"), $ef987327cc5edb69$var$af = $ef987327cc5edb69$var$Ze("animationiteration"), $ef987327cc5edb69$var$bf = $ef987327cc5edb69$var$Ze("animationstart"), $ef987327cc5edb69$var$cf = $ef987327cc5edb69$var$Ze("transitionend"), $ef987327cc5edb69$var$df = new Map, $ef987327cc5edb69$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $ef987327cc5edb69$var$ff(a, b) {
    $ef987327cc5edb69$var$df.set(a, b);
    $ef987327cc5edb69$var$fa(b, [
        a
    ]);
}
for(var $ef987327cc5edb69$var$gf = 0; $ef987327cc5edb69$var$gf < $ef987327cc5edb69$var$ef.length; $ef987327cc5edb69$var$gf++){
    var $ef987327cc5edb69$var$hf = $ef987327cc5edb69$var$ef[$ef987327cc5edb69$var$gf], $ef987327cc5edb69$var$jf = $ef987327cc5edb69$var$hf.toLowerCase(), $ef987327cc5edb69$var$kf = $ef987327cc5edb69$var$hf[0].toUpperCase() + $ef987327cc5edb69$var$hf.slice(1);
    $ef987327cc5edb69$var$ff($ef987327cc5edb69$var$jf, "on" + $ef987327cc5edb69$var$kf);
}
$ef987327cc5edb69$var$ff($ef987327cc5edb69$var$$e, "onAnimationEnd");
$ef987327cc5edb69$var$ff($ef987327cc5edb69$var$af, "onAnimationIteration");
$ef987327cc5edb69$var$ff($ef987327cc5edb69$var$bf, "onAnimationStart");
$ef987327cc5edb69$var$ff("dblclick", "onDoubleClick");
$ef987327cc5edb69$var$ff("focusin", "onFocus");
$ef987327cc5edb69$var$ff("focusout", "onBlur");
$ef987327cc5edb69$var$ff($ef987327cc5edb69$var$cf, "onTransitionEnd");
$ef987327cc5edb69$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$ef987327cc5edb69$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$ef987327cc5edb69$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$ef987327cc5edb69$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$ef987327cc5edb69$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$ef987327cc5edb69$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$ef987327cc5edb69$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$ef987327cc5edb69$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$ef987327cc5edb69$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$ef987327cc5edb69$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $ef987327cc5edb69$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $ef987327cc5edb69$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($ef987327cc5edb69$var$lf));
function $ef987327cc5edb69$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $ef987327cc5edb69$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $ef987327cc5edb69$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ef987327cc5edb69$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $ef987327cc5edb69$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($ef987327cc5edb69$var$Qb) throw a = $ef987327cc5edb69$var$Rb, $ef987327cc5edb69$var$Qb = !1, $ef987327cc5edb69$var$Rb = null, a;
}
function $ef987327cc5edb69$var$D(a, b) {
    var c = b[$ef987327cc5edb69$var$of];
    void 0 === c && (c = b[$ef987327cc5edb69$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($ef987327cc5edb69$var$pf(b, a, 2, !1), c.add(d));
}
function $ef987327cc5edb69$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $ef987327cc5edb69$var$pf(c, a, d, b);
}
var $ef987327cc5edb69$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $ef987327cc5edb69$var$sf(a) {
    if (!a[$ef987327cc5edb69$var$rf]) {
        a[$ef987327cc5edb69$var$rf] = !0;
        $ef987327cc5edb69$var$da.forEach(function(b) {
            "selectionchange" !== b && ($ef987327cc5edb69$var$mf.has(b) || $ef987327cc5edb69$var$qf(b, !1, a), $ef987327cc5edb69$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$ef987327cc5edb69$var$rf] || (b[$ef987327cc5edb69$var$rf] = !0, $ef987327cc5edb69$var$qf("selectionchange", !1, b));
    }
}
function $ef987327cc5edb69$var$pf(a, b, c, d) {
    switch($ef987327cc5edb69$var$jd(b)){
        case 1:
            var e = $ef987327cc5edb69$var$ed;
            break;
        case 4:
            e = $ef987327cc5edb69$var$gd;
            break;
        default:
            e = $ef987327cc5edb69$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$ef987327cc5edb69$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $ef987327cc5edb69$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $ef987327cc5edb69$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $ef987327cc5edb69$var$Jb(function() {
        var d = f, e = $ef987327cc5edb69$var$xb(c), g = [];
        a: {
            var h = $ef987327cc5edb69$var$df.get(a);
            if (void 0 !== h) {
                var k = $ef987327cc5edb69$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $ef987327cc5edb69$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $ef987327cc5edb69$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $ef987327cc5edb69$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $ef987327cc5edb69$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $ef987327cc5edb69$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $ef987327cc5edb69$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $ef987327cc5edb69$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $ef987327cc5edb69$var$Vd;
                        break;
                    case $ef987327cc5edb69$var$$e:
                    case $ef987327cc5edb69$var$af:
                    case $ef987327cc5edb69$var$bf:
                        k = $ef987327cc5edb69$var$Hd;
                        break;
                    case $ef987327cc5edb69$var$cf:
                        k = $ef987327cc5edb69$var$Xd;
                        break;
                    case "scroll":
                        k = $ef987327cc5edb69$var$vd;
                        break;
                    case "wheel":
                        k = $ef987327cc5edb69$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $ef987327cc5edb69$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $ef987327cc5edb69$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $ef987327cc5edb69$var$Kb(w, x), null != F && t.push($ef987327cc5edb69$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $ef987327cc5edb69$var$wb && (n = c.relatedTarget || c.fromElement) && ($ef987327cc5edb69$var$Wc(n) || n[$ef987327cc5edb69$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $ef987327cc5edb69$var$Wc(n) : null, null !== n && (J = $ef987327cc5edb69$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $ef987327cc5edb69$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $ef987327cc5edb69$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $ef987327cc5edb69$var$ue(k);
                        u = null == n ? h : $ef987327cc5edb69$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $ef987327cc5edb69$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $ef987327cc5edb69$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $ef987327cc5edb69$var$vf(F))u++;
                            for(; 0 < w - u;)t = $ef987327cc5edb69$var$vf(t), w--;
                            for(; 0 < u - w;)x = $ef987327cc5edb69$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $ef987327cc5edb69$var$vf(t);
                                x = $ef987327cc5edb69$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $ef987327cc5edb69$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $ef987327cc5edb69$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $ef987327cc5edb69$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $ef987327cc5edb69$var$ve;
                else if ($ef987327cc5edb69$var$me(h)) {
                    if ($ef987327cc5edb69$var$we) na = $ef987327cc5edb69$var$Fe;
                    else {
                        na = $ef987327cc5edb69$var$De;
                        var xa = $ef987327cc5edb69$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $ef987327cc5edb69$var$Ee);
                if (na && (na = na(a, d))) {
                    $ef987327cc5edb69$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $ef987327cc5edb69$var$cb(h, "number", h.value);
            }
            xa = d ? $ef987327cc5edb69$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($ef987327cc5edb69$var$me(xa) || "true" === xa.contentEditable) $ef987327cc5edb69$var$Qe = xa, $ef987327cc5edb69$var$Re = d, $ef987327cc5edb69$var$Se = null;
                    break;
                case "focusout":
                    $ef987327cc5edb69$var$Se = $ef987327cc5edb69$var$Re = $ef987327cc5edb69$var$Qe = null;
                    break;
                case "mousedown":
                    $ef987327cc5edb69$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $ef987327cc5edb69$var$Te = !1;
                    $ef987327cc5edb69$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($ef987327cc5edb69$var$Pe) break;
                case "keydown":
                case "keyup":
                    $ef987327cc5edb69$var$Ue(g, c, e);
            }
            var $a;
            if ($ef987327cc5edb69$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $ef987327cc5edb69$var$ie ? $ef987327cc5edb69$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($ef987327cc5edb69$var$de && "ko" !== c.locale && ($ef987327cc5edb69$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $ef987327cc5edb69$var$ie && ($a = $ef987327cc5edb69$var$nd()) : ($ef987327cc5edb69$var$kd = e, $ef987327cc5edb69$var$ld = "value" in $ef987327cc5edb69$var$kd ? $ef987327cc5edb69$var$kd.value : $ef987327cc5edb69$var$kd.textContent, $ef987327cc5edb69$var$ie = !0)), xa = $ef987327cc5edb69$var$oe(d, ba), 0 < xa.length && (ba = new $ef987327cc5edb69$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $ef987327cc5edb69$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $ef987327cc5edb69$var$ce ? $ef987327cc5edb69$var$je(a, c) : $ef987327cc5edb69$var$ke(a, c)) d = $ef987327cc5edb69$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $ef987327cc5edb69$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $ef987327cc5edb69$var$se(g, b);
    });
}
function $ef987327cc5edb69$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $ef987327cc5edb69$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $ef987327cc5edb69$var$Kb(a, c), null != f && d.unshift($ef987327cc5edb69$var$tf(a, f, e)), f = $ef987327cc5edb69$var$Kb(a, b), null != f && d.push($ef987327cc5edb69$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $ef987327cc5edb69$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $ef987327cc5edb69$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $ef987327cc5edb69$var$Kb(c, f), null != k && g.unshift($ef987327cc5edb69$var$tf(c, k, h))) : e || (k = $ef987327cc5edb69$var$Kb(c, f), null != k && g.push($ef987327cc5edb69$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $ef987327cc5edb69$var$xf = /\r\n?/g, $ef987327cc5edb69$var$yf = /\u0000|\uFFFD/g;
function $ef987327cc5edb69$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($ef987327cc5edb69$var$xf, "\n").replace($ef987327cc5edb69$var$yf, "");
}
function $ef987327cc5edb69$var$Af(a, b, c) {
    b = $ef987327cc5edb69$var$zf(b);
    if ($ef987327cc5edb69$var$zf(a) !== b && c) throw Error($ef987327cc5edb69$var$p(425));
}
function $ef987327cc5edb69$var$Bf() {}
var $ef987327cc5edb69$var$Cf = null, $ef987327cc5edb69$var$Df = null;
function $ef987327cc5edb69$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $ef987327cc5edb69$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $ef987327cc5edb69$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $ef987327cc5edb69$var$Hf = "function" === typeof Promise ? Promise : void 0, $ef987327cc5edb69$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $ef987327cc5edb69$var$Hf ? function(a) {
    return $ef987327cc5edb69$var$Hf.resolve(null).then(a).catch($ef987327cc5edb69$var$If);
} : $ef987327cc5edb69$var$Ff;
function $ef987327cc5edb69$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $ef987327cc5edb69$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $ef987327cc5edb69$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $ef987327cc5edb69$var$bd(b);
}
function $ef987327cc5edb69$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $ef987327cc5edb69$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $ef987327cc5edb69$var$Nf = Math.random().toString(36).slice(2), $ef987327cc5edb69$var$Of = "__reactFiber$" + $ef987327cc5edb69$var$Nf, $ef987327cc5edb69$var$Pf = "__reactProps$" + $ef987327cc5edb69$var$Nf, $ef987327cc5edb69$var$uf = "__reactContainer$" + $ef987327cc5edb69$var$Nf, $ef987327cc5edb69$var$of = "__reactEvents$" + $ef987327cc5edb69$var$Nf, $ef987327cc5edb69$var$Qf = "__reactListeners$" + $ef987327cc5edb69$var$Nf, $ef987327cc5edb69$var$Rf = "__reactHandles$" + $ef987327cc5edb69$var$Nf;
function $ef987327cc5edb69$var$Wc(a) {
    var b = a[$ef987327cc5edb69$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$ef987327cc5edb69$var$uf] || c[$ef987327cc5edb69$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $ef987327cc5edb69$var$Mf(a); null !== a;){
                if (c = a[$ef987327cc5edb69$var$Of]) return c;
                a = $ef987327cc5edb69$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $ef987327cc5edb69$var$Cb(a) {
    a = a[$ef987327cc5edb69$var$Of] || a[$ef987327cc5edb69$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $ef987327cc5edb69$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($ef987327cc5edb69$var$p(33));
}
function $ef987327cc5edb69$var$Db(a) {
    return a[$ef987327cc5edb69$var$Pf] || null;
}
var $ef987327cc5edb69$var$Sf = [], $ef987327cc5edb69$var$Tf = -1;
function $ef987327cc5edb69$var$Uf(a) {
    return {
        current: a
    };
}
function $ef987327cc5edb69$var$E(a) {
    0 > $ef987327cc5edb69$var$Tf || (a.current = $ef987327cc5edb69$var$Sf[$ef987327cc5edb69$var$Tf], $ef987327cc5edb69$var$Sf[$ef987327cc5edb69$var$Tf] = null, $ef987327cc5edb69$var$Tf--);
}
function $ef987327cc5edb69$var$G(a, b) {
    $ef987327cc5edb69$var$Tf++;
    $ef987327cc5edb69$var$Sf[$ef987327cc5edb69$var$Tf] = a.current;
    a.current = b;
}
var $ef987327cc5edb69$var$Vf = {}, $ef987327cc5edb69$var$H = $ef987327cc5edb69$var$Uf($ef987327cc5edb69$var$Vf), $ef987327cc5edb69$var$Wf = $ef987327cc5edb69$var$Uf(!1), $ef987327cc5edb69$var$Xf = $ef987327cc5edb69$var$Vf;
function $ef987327cc5edb69$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $ef987327cc5edb69$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $ef987327cc5edb69$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $ef987327cc5edb69$var$$f() {
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf);
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$H);
}
function $ef987327cc5edb69$var$ag(a, b, c) {
    if ($ef987327cc5edb69$var$H.current !== $ef987327cc5edb69$var$Vf) throw Error($ef987327cc5edb69$var$p(168));
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$H, b);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Wf, c);
}
function $ef987327cc5edb69$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($ef987327cc5edb69$var$p(108, $ef987327cc5edb69$var$Ra(a) || "Unknown", e));
    return $ef987327cc5edb69$var$A({}, c, d);
}
function $ef987327cc5edb69$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $ef987327cc5edb69$var$Vf;
    $ef987327cc5edb69$var$Xf = $ef987327cc5edb69$var$H.current;
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$H, a);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Wf, $ef987327cc5edb69$var$Wf.current);
    return !0;
}
function $ef987327cc5edb69$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($ef987327cc5edb69$var$p(169));
    c ? (a = $ef987327cc5edb69$var$bg(a, b, $ef987327cc5edb69$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf), $ef987327cc5edb69$var$E($ef987327cc5edb69$var$H), $ef987327cc5edb69$var$G($ef987327cc5edb69$var$H, a)) : $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Wf, c);
}
var $ef987327cc5edb69$var$eg = null, $ef987327cc5edb69$var$fg = !1, $ef987327cc5edb69$var$gg = !1;
function $ef987327cc5edb69$var$hg(a) {
    null === $ef987327cc5edb69$var$eg ? $ef987327cc5edb69$var$eg = [
        a
    ] : $ef987327cc5edb69$var$eg.push(a);
}
function $ef987327cc5edb69$var$ig(a) {
    $ef987327cc5edb69$var$fg = !0;
    $ef987327cc5edb69$var$hg(a);
}
function $ef987327cc5edb69$var$jg() {
    if (!$ef987327cc5edb69$var$gg && null !== $ef987327cc5edb69$var$eg) {
        $ef987327cc5edb69$var$gg = !0;
        var a = 0, b = $ef987327cc5edb69$var$C;
        try {
            var c = $ef987327cc5edb69$var$eg;
            for($ef987327cc5edb69$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $ef987327cc5edb69$var$eg = null;
            $ef987327cc5edb69$var$fg = !1;
        } catch (e) {
            throw null !== $ef987327cc5edb69$var$eg && ($ef987327cc5edb69$var$eg = $ef987327cc5edb69$var$eg.slice(a + 1)), $ef987327cc5edb69$var$ac($ef987327cc5edb69$var$fc, $ef987327cc5edb69$var$jg), e;
        } finally{
            $ef987327cc5edb69$var$C = b, $ef987327cc5edb69$var$gg = !1;
        }
    }
    return null;
}
var $ef987327cc5edb69$var$kg = [], $ef987327cc5edb69$var$lg = 0, $ef987327cc5edb69$var$mg = null, $ef987327cc5edb69$var$ng = 0, $ef987327cc5edb69$var$og = [], $ef987327cc5edb69$var$pg = 0, $ef987327cc5edb69$var$qg = null, $ef987327cc5edb69$var$rg = 1, $ef987327cc5edb69$var$sg = "";
function $ef987327cc5edb69$var$tg(a, b) {
    $ef987327cc5edb69$var$kg[$ef987327cc5edb69$var$lg++] = $ef987327cc5edb69$var$ng;
    $ef987327cc5edb69$var$kg[$ef987327cc5edb69$var$lg++] = $ef987327cc5edb69$var$mg;
    $ef987327cc5edb69$var$mg = a;
    $ef987327cc5edb69$var$ng = b;
}
function $ef987327cc5edb69$var$ug(a, b, c) {
    $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$rg;
    $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$sg;
    $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$qg;
    $ef987327cc5edb69$var$qg = a;
    var d = $ef987327cc5edb69$var$rg;
    a = $ef987327cc5edb69$var$sg;
    var e = 32 - $ef987327cc5edb69$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $ef987327cc5edb69$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $ef987327cc5edb69$var$rg = 1 << 32 - $ef987327cc5edb69$var$oc(b) + e | c << e | d;
        $ef987327cc5edb69$var$sg = f + a;
    } else $ef987327cc5edb69$var$rg = 1 << f | c << e | d, $ef987327cc5edb69$var$sg = a;
}
function $ef987327cc5edb69$var$vg(a) {
    null !== a.return && ($ef987327cc5edb69$var$tg(a, 1), $ef987327cc5edb69$var$ug(a, 1, 0));
}
function $ef987327cc5edb69$var$wg(a) {
    for(; a === $ef987327cc5edb69$var$mg;)$ef987327cc5edb69$var$mg = $ef987327cc5edb69$var$kg[--$ef987327cc5edb69$var$lg], $ef987327cc5edb69$var$kg[$ef987327cc5edb69$var$lg] = null, $ef987327cc5edb69$var$ng = $ef987327cc5edb69$var$kg[--$ef987327cc5edb69$var$lg], $ef987327cc5edb69$var$kg[$ef987327cc5edb69$var$lg] = null;
    for(; a === $ef987327cc5edb69$var$qg;)$ef987327cc5edb69$var$qg = $ef987327cc5edb69$var$og[--$ef987327cc5edb69$var$pg], $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg] = null, $ef987327cc5edb69$var$sg = $ef987327cc5edb69$var$og[--$ef987327cc5edb69$var$pg], $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg] = null, $ef987327cc5edb69$var$rg = $ef987327cc5edb69$var$og[--$ef987327cc5edb69$var$pg], $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg] = null;
}
var $ef987327cc5edb69$var$xg = null, $ef987327cc5edb69$var$yg = null, $ef987327cc5edb69$var$I = !1, $ef987327cc5edb69$var$zg = null;
function $ef987327cc5edb69$var$Ag(a, b) {
    var c = $ef987327cc5edb69$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $ef987327cc5edb69$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $ef987327cc5edb69$var$xg = a, $ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $ef987327cc5edb69$var$xg = a, $ef987327cc5edb69$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $ef987327cc5edb69$var$qg ? {
                id: $ef987327cc5edb69$var$rg,
                overflow: $ef987327cc5edb69$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $ef987327cc5edb69$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $ef987327cc5edb69$var$xg = a, $ef987327cc5edb69$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $ef987327cc5edb69$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $ef987327cc5edb69$var$Eg(a) {
    if ($ef987327cc5edb69$var$I) {
        var b = $ef987327cc5edb69$var$yg;
        if (b) {
            var c = b;
            if (!$ef987327cc5edb69$var$Cg(a, b)) {
                if ($ef987327cc5edb69$var$Dg(a)) throw Error($ef987327cc5edb69$var$p(418));
                b = $ef987327cc5edb69$var$Lf(c.nextSibling);
                var d = $ef987327cc5edb69$var$xg;
                b && $ef987327cc5edb69$var$Cg(a, b) ? $ef987327cc5edb69$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $ef987327cc5edb69$var$I = !1, $ef987327cc5edb69$var$xg = a);
            }
        } else {
            if ($ef987327cc5edb69$var$Dg(a)) throw Error($ef987327cc5edb69$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $ef987327cc5edb69$var$I = !1;
            $ef987327cc5edb69$var$xg = a;
        }
    }
}
function $ef987327cc5edb69$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $ef987327cc5edb69$var$xg = a;
}
function $ef987327cc5edb69$var$Gg(a) {
    if (a !== $ef987327cc5edb69$var$xg) return !1;
    if (!$ef987327cc5edb69$var$I) return $ef987327cc5edb69$var$Fg(a), $ef987327cc5edb69$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$ef987327cc5edb69$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $ef987327cc5edb69$var$yg)) {
        if ($ef987327cc5edb69$var$Dg(a)) throw $ef987327cc5edb69$var$Hg(), Error($ef987327cc5edb69$var$p(418));
        for(; b;)$ef987327cc5edb69$var$Ag(a, b), b = $ef987327cc5edb69$var$Lf(b.nextSibling);
    }
    $ef987327cc5edb69$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($ef987327cc5edb69$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $ef987327cc5edb69$var$yg = null;
        }
    } else $ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$xg ? $ef987327cc5edb69$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $ef987327cc5edb69$var$Hg() {
    for(var a = $ef987327cc5edb69$var$yg; a;)a = $ef987327cc5edb69$var$Lf(a.nextSibling);
}
function $ef987327cc5edb69$var$Ig() {
    $ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$xg = null;
    $ef987327cc5edb69$var$I = !1;
}
function $ef987327cc5edb69$var$Jg(a) {
    null === $ef987327cc5edb69$var$zg ? $ef987327cc5edb69$var$zg = [
        a
    ] : $ef987327cc5edb69$var$zg.push(a);
}
var $ef987327cc5edb69$var$Kg = $ef987327cc5edb69$var$ua.ReactCurrentBatchConfig;
function $ef987327cc5edb69$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $ef987327cc5edb69$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $ef987327cc5edb69$var$Mg = $ef987327cc5edb69$var$Uf(null), $ef987327cc5edb69$var$Ng = null, $ef987327cc5edb69$var$Og = null, $ef987327cc5edb69$var$Pg = null;
function $ef987327cc5edb69$var$Qg() {
    $ef987327cc5edb69$var$Pg = $ef987327cc5edb69$var$Og = $ef987327cc5edb69$var$Ng = null;
}
function $ef987327cc5edb69$var$Rg(a) {
    var b = $ef987327cc5edb69$var$Mg.current;
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Mg);
    a._currentValue = b;
}
function $ef987327cc5edb69$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $ef987327cc5edb69$var$Tg(a, b) {
    $ef987327cc5edb69$var$Ng = a;
    $ef987327cc5edb69$var$Pg = $ef987327cc5edb69$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($ef987327cc5edb69$var$Ug = !0), a.firstContext = null);
}
function $ef987327cc5edb69$var$Vg(a) {
    var b = a._currentValue;
    if ($ef987327cc5edb69$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $ef987327cc5edb69$var$Og) {
            if (null === $ef987327cc5edb69$var$Ng) throw Error($ef987327cc5edb69$var$p(308));
            $ef987327cc5edb69$var$Og = a;
            $ef987327cc5edb69$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $ef987327cc5edb69$var$Og = $ef987327cc5edb69$var$Og.next = a;
    }
    return b;
}
var $ef987327cc5edb69$var$Wg = null;
function $ef987327cc5edb69$var$Xg(a) {
    null === $ef987327cc5edb69$var$Wg ? $ef987327cc5edb69$var$Wg = [
        a
    ] : $ef987327cc5edb69$var$Wg.push(a);
}
function $ef987327cc5edb69$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $ef987327cc5edb69$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $ef987327cc5edb69$var$Zg(a, d);
}
function $ef987327cc5edb69$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $ef987327cc5edb69$var$$g = !1;
function $ef987327cc5edb69$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $ef987327cc5edb69$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $ef987327cc5edb69$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $ef987327cc5edb69$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($ef987327cc5edb69$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $ef987327cc5edb69$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $ef987327cc5edb69$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $ef987327cc5edb69$var$Zg(a, c);
}
function $ef987327cc5edb69$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ef987327cc5edb69$var$Cc(a, c);
    }
}
function $ef987327cc5edb69$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $ef987327cc5edb69$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $ef987327cc5edb69$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $ef987327cc5edb69$var$A({}, q, r);
                            break a;
                        case 2:
                            $ef987327cc5edb69$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $ef987327cc5edb69$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $ef987327cc5edb69$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($ef987327cc5edb69$var$p(191, e));
            e.call(d);
        }
    }
}
var $ef987327cc5edb69$var$jh = (new $9KJkx.Component).refs;
function $ef987327cc5edb69$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $ef987327cc5edb69$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $ef987327cc5edb69$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $ef987327cc5edb69$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ef987327cc5edb69$var$L(), e = $ef987327cc5edb69$var$lh(a), f = $ef987327cc5edb69$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ef987327cc5edb69$var$dh(a, f, e);
        null !== b && ($ef987327cc5edb69$var$mh(b, a, e, d), $ef987327cc5edb69$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $ef987327cc5edb69$var$L(), e = $ef987327cc5edb69$var$lh(a), f = $ef987327cc5edb69$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $ef987327cc5edb69$var$dh(a, f, e);
        null !== b && ($ef987327cc5edb69$var$mh(b, a, e, d), $ef987327cc5edb69$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $ef987327cc5edb69$var$L(), d = $ef987327cc5edb69$var$lh(a), e = $ef987327cc5edb69$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $ef987327cc5edb69$var$dh(a, e, d);
        null !== b && ($ef987327cc5edb69$var$mh(b, a, d, c), $ef987327cc5edb69$var$eh(b, a, d));
    }
};
function $ef987327cc5edb69$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$ef987327cc5edb69$var$Ie(c, d) || !$ef987327cc5edb69$var$Ie(e, f) : !0;
}
function $ef987327cc5edb69$var$ph(a, b, c) {
    var d = !1, e = $ef987327cc5edb69$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $ef987327cc5edb69$var$Vg(f) : (e = $ef987327cc5edb69$var$Zf(b) ? $ef987327cc5edb69$var$Xf : $ef987327cc5edb69$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $ef987327cc5edb69$var$Yf(a, e) : $ef987327cc5edb69$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $ef987327cc5edb69$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $ef987327cc5edb69$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $ef987327cc5edb69$var$nh.enqueueReplaceState(b, b.state, null);
}
function $ef987327cc5edb69$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $ef987327cc5edb69$var$jh;
    $ef987327cc5edb69$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $ef987327cc5edb69$var$Vg(f) : (f = $ef987327cc5edb69$var$Zf(b) ? $ef987327cc5edb69$var$Xf : $ef987327cc5edb69$var$H.current, e.context = $ef987327cc5edb69$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($ef987327cc5edb69$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $ef987327cc5edb69$var$nh.enqueueReplaceState(e, e.state, null), $ef987327cc5edb69$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $ef987327cc5edb69$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($ef987327cc5edb69$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($ef987327cc5edb69$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $ef987327cc5edb69$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($ef987327cc5edb69$var$p(284));
        if (!c._owner) throw Error($ef987327cc5edb69$var$p(290, a));
    }
    return a;
}
function $ef987327cc5edb69$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($ef987327cc5edb69$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $ef987327cc5edb69$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $ef987327cc5edb69$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $ef987327cc5edb69$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $ef987327cc5edb69$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $ef987327cc5edb69$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $ef987327cc5edb69$var$Ha && $ef987327cc5edb69$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $ef987327cc5edb69$var$sh(a, b, c), d.return = a, d;
        d = $ef987327cc5edb69$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $ef987327cc5edb69$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $ef987327cc5edb69$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $ef987327cc5edb69$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $ef987327cc5edb69$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $ef987327cc5edb69$var$va:
                    return c = $ef987327cc5edb69$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $ef987327cc5edb69$var$sh(a, null, b), c.return = a, c;
                case $ef987327cc5edb69$var$wa:
                    return b = $ef987327cc5edb69$var$zh(b, a.mode, c), b.return = a, b;
                case $ef987327cc5edb69$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($ef987327cc5edb69$var$eb(b) || $ef987327cc5edb69$var$Ka(b)) return b = $ef987327cc5edb69$var$Ah(b, a.mode, c, null), b.return = a, b;
            $ef987327cc5edb69$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $ef987327cc5edb69$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $ef987327cc5edb69$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $ef987327cc5edb69$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($ef987327cc5edb69$var$eb(c) || $ef987327cc5edb69$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $ef987327cc5edb69$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $ef987327cc5edb69$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $ef987327cc5edb69$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $ef987327cc5edb69$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($ef987327cc5edb69$var$eb(d) || $ef987327cc5edb69$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $ef987327cc5edb69$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $ef987327cc5edb69$var$Ka(h);
        if ("function" !== typeof l) throw Error($ef987327cc5edb69$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($ef987327cc5edb69$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $ef987327cc5edb69$var$I && $ef987327cc5edb69$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $ef987327cc5edb69$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $ef987327cc5edb69$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $ef987327cc5edb69$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $ef987327cc5edb69$var$Ha && $ef987327cc5edb69$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $ef987327cc5edb69$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $ef987327cc5edb69$var$ya ? (d = $ef987327cc5edb69$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $ef987327cc5edb69$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $ef987327cc5edb69$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $ef987327cc5edb69$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $ef987327cc5edb69$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $ef987327cc5edb69$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($ef987327cc5edb69$var$eb(f)) return n(a, d, f, h);
            if ($ef987327cc5edb69$var$Ka(f)) return t(a, d, f, h);
            $ef987327cc5edb69$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $ef987327cc5edb69$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $ef987327cc5edb69$var$Bh = $ef987327cc5edb69$var$vh(!0), $ef987327cc5edb69$var$Ch = $ef987327cc5edb69$var$vh(!1), $ef987327cc5edb69$var$Dh = {}, $ef987327cc5edb69$var$Eh = $ef987327cc5edb69$var$Uf($ef987327cc5edb69$var$Dh), $ef987327cc5edb69$var$Fh = $ef987327cc5edb69$var$Uf($ef987327cc5edb69$var$Dh), $ef987327cc5edb69$var$Gh = $ef987327cc5edb69$var$Uf($ef987327cc5edb69$var$Dh);
function $ef987327cc5edb69$var$Hh(a) {
    if (a === $ef987327cc5edb69$var$Dh) throw Error($ef987327cc5edb69$var$p(174));
    return a;
}
function $ef987327cc5edb69$var$Ih(a, b) {
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Gh, b);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Fh, a);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Eh, $ef987327cc5edb69$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $ef987327cc5edb69$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $ef987327cc5edb69$var$lb(b, a);
    }
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Eh);
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Eh, b);
}
function $ef987327cc5edb69$var$Jh() {
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Eh);
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Fh);
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Gh);
}
function $ef987327cc5edb69$var$Kh(a) {
    $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Gh.current);
    var b = $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Eh.current);
    var c = $ef987327cc5edb69$var$lb(b, a.type);
    b !== c && ($ef987327cc5edb69$var$G($ef987327cc5edb69$var$Fh, a), $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Eh, c));
}
function $ef987327cc5edb69$var$Lh(a) {
    $ef987327cc5edb69$var$Fh.current === a && ($ef987327cc5edb69$var$E($ef987327cc5edb69$var$Eh), $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Fh));
}
var $ef987327cc5edb69$var$M = $ef987327cc5edb69$var$Uf(0);
function $ef987327cc5edb69$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $ef987327cc5edb69$var$Nh = [];
function $ef987327cc5edb69$var$Oh() {
    for(var a = 0; a < $ef987327cc5edb69$var$Nh.length; a++)$ef987327cc5edb69$var$Nh[a]._workInProgressVersionPrimary = null;
    $ef987327cc5edb69$var$Nh.length = 0;
}
var $ef987327cc5edb69$var$Ph = $ef987327cc5edb69$var$ua.ReactCurrentDispatcher, $ef987327cc5edb69$var$Qh = $ef987327cc5edb69$var$ua.ReactCurrentBatchConfig, $ef987327cc5edb69$var$Rh = 0, $ef987327cc5edb69$var$N = null, $ef987327cc5edb69$var$O = null, $ef987327cc5edb69$var$P = null, $ef987327cc5edb69$var$Sh = !1, $ef987327cc5edb69$var$Th = !1, $ef987327cc5edb69$var$Uh = 0, $ef987327cc5edb69$var$Vh = 0;
function $ef987327cc5edb69$var$Q() {
    throw Error($ef987327cc5edb69$var$p(321));
}
function $ef987327cc5edb69$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$ef987327cc5edb69$var$He(a[c], b[c])) return !1;
    return !0;
}
function $ef987327cc5edb69$var$Xh(a, b, c, d, e, f) {
    $ef987327cc5edb69$var$Rh = f;
    $ef987327cc5edb69$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $ef987327cc5edb69$var$Ph.current = null === a || null === a.memoizedState ? $ef987327cc5edb69$var$Yh : $ef987327cc5edb69$var$Zh;
    a = c(d, e);
    if ($ef987327cc5edb69$var$Th) {
        f = 0;
        do {
            $ef987327cc5edb69$var$Th = !1;
            $ef987327cc5edb69$var$Uh = 0;
            if (25 <= f) throw Error($ef987327cc5edb69$var$p(301));
            f += 1;
            $ef987327cc5edb69$var$P = $ef987327cc5edb69$var$O = null;
            b.updateQueue = null;
            $ef987327cc5edb69$var$Ph.current = $ef987327cc5edb69$var$$h;
            a = c(d, e);
        }while ($ef987327cc5edb69$var$Th);
    }
    $ef987327cc5edb69$var$Ph.current = $ef987327cc5edb69$var$ai;
    b = null !== $ef987327cc5edb69$var$O && null !== $ef987327cc5edb69$var$O.next;
    $ef987327cc5edb69$var$Rh = 0;
    $ef987327cc5edb69$var$P = $ef987327cc5edb69$var$O = $ef987327cc5edb69$var$N = null;
    $ef987327cc5edb69$var$Sh = !1;
    if (b) throw Error($ef987327cc5edb69$var$p(300));
    return a;
}
function $ef987327cc5edb69$var$bi() {
    var a = 0 !== $ef987327cc5edb69$var$Uh;
    $ef987327cc5edb69$var$Uh = 0;
    return a;
}
function $ef987327cc5edb69$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $ef987327cc5edb69$var$P ? $ef987327cc5edb69$var$N.memoizedState = $ef987327cc5edb69$var$P = a : $ef987327cc5edb69$var$P = $ef987327cc5edb69$var$P.next = a;
    return $ef987327cc5edb69$var$P;
}
function $ef987327cc5edb69$var$di() {
    if (null === $ef987327cc5edb69$var$O) {
        var a = $ef987327cc5edb69$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $ef987327cc5edb69$var$O.next;
    var b = null === $ef987327cc5edb69$var$P ? $ef987327cc5edb69$var$N.memoizedState : $ef987327cc5edb69$var$P.next;
    if (null !== b) $ef987327cc5edb69$var$P = b, $ef987327cc5edb69$var$O = a;
    else {
        if (null === a) throw Error($ef987327cc5edb69$var$p(310));
        $ef987327cc5edb69$var$O = a;
        a = {
            memoizedState: $ef987327cc5edb69$var$O.memoizedState,
            baseState: $ef987327cc5edb69$var$O.baseState,
            baseQueue: $ef987327cc5edb69$var$O.baseQueue,
            queue: $ef987327cc5edb69$var$O.queue,
            next: null
        };
        null === $ef987327cc5edb69$var$P ? $ef987327cc5edb69$var$N.memoizedState = $ef987327cc5edb69$var$P = a : $ef987327cc5edb69$var$P = $ef987327cc5edb69$var$P.next = a;
    }
    return $ef987327cc5edb69$var$P;
}
function $ef987327cc5edb69$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $ef987327cc5edb69$var$fi(a) {
    var b = $ef987327cc5edb69$var$di(), c = b.queue;
    if (null === c) throw Error($ef987327cc5edb69$var$p(311));
    c.lastRenderedReducer = a;
    var d = $ef987327cc5edb69$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($ef987327cc5edb69$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $ef987327cc5edb69$var$N.lanes |= m;
                $ef987327cc5edb69$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $ef987327cc5edb69$var$He(d, b.memoizedState) || ($ef987327cc5edb69$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $ef987327cc5edb69$var$N.lanes |= f, $ef987327cc5edb69$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $ef987327cc5edb69$var$gi(a) {
    var b = $ef987327cc5edb69$var$di(), c = b.queue;
    if (null === c) throw Error($ef987327cc5edb69$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $ef987327cc5edb69$var$He(f, b.memoizedState) || ($ef987327cc5edb69$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $ef987327cc5edb69$var$hi() {}
function $ef987327cc5edb69$var$ii(a, b) {
    var c = $ef987327cc5edb69$var$N, d = $ef987327cc5edb69$var$di(), e = b(), f = !$ef987327cc5edb69$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $ef987327cc5edb69$var$Ug = !0);
    d = d.queue;
    $ef987327cc5edb69$var$ji($ef987327cc5edb69$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $ef987327cc5edb69$var$P && $ef987327cc5edb69$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $ef987327cc5edb69$var$li(9, $ef987327cc5edb69$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $ef987327cc5edb69$var$R) throw Error($ef987327cc5edb69$var$p(349));
        0 !== ($ef987327cc5edb69$var$Rh & 30) || $ef987327cc5edb69$var$ni(c, b, e);
    }
    return e;
}
function $ef987327cc5edb69$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $ef987327cc5edb69$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ef987327cc5edb69$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $ef987327cc5edb69$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $ef987327cc5edb69$var$oi(b) && $ef987327cc5edb69$var$pi(a);
}
function $ef987327cc5edb69$var$ki(a, b, c) {
    return c(function() {
        $ef987327cc5edb69$var$oi(b) && $ef987327cc5edb69$var$pi(a);
    });
}
function $ef987327cc5edb69$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$ef987327cc5edb69$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $ef987327cc5edb69$var$pi(a) {
    var b = $ef987327cc5edb69$var$Zg(a, 1);
    null !== b && $ef987327cc5edb69$var$mh(b, a, 1, -1);
}
function $ef987327cc5edb69$var$qi(a) {
    var b = $ef987327cc5edb69$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $ef987327cc5edb69$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $ef987327cc5edb69$var$ri.bind(null, $ef987327cc5edb69$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $ef987327cc5edb69$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $ef987327cc5edb69$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $ef987327cc5edb69$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $ef987327cc5edb69$var$si() {
    return $ef987327cc5edb69$var$di().memoizedState;
}
function $ef987327cc5edb69$var$ti(a, b, c, d) {
    var e = $ef987327cc5edb69$var$ci();
    $ef987327cc5edb69$var$N.flags |= a;
    e.memoizedState = $ef987327cc5edb69$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $ef987327cc5edb69$var$ui(a, b, c, d) {
    var e = $ef987327cc5edb69$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $ef987327cc5edb69$var$O) {
        var g = $ef987327cc5edb69$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $ef987327cc5edb69$var$Wh(d, g.deps)) {
            e.memoizedState = $ef987327cc5edb69$var$li(b, c, f, d);
            return;
        }
    }
    $ef987327cc5edb69$var$N.flags |= a;
    e.memoizedState = $ef987327cc5edb69$var$li(1 | b, c, f, d);
}
function $ef987327cc5edb69$var$vi(a, b) {
    return $ef987327cc5edb69$var$ti(8390656, 8, a, b);
}
function $ef987327cc5edb69$var$ji(a, b) {
    return $ef987327cc5edb69$var$ui(2048, 8, a, b);
}
function $ef987327cc5edb69$var$wi(a, b) {
    return $ef987327cc5edb69$var$ui(4, 2, a, b);
}
function $ef987327cc5edb69$var$xi(a, b) {
    return $ef987327cc5edb69$var$ui(4, 4, a, b);
}
function $ef987327cc5edb69$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $ef987327cc5edb69$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $ef987327cc5edb69$var$ui(4, 4, $ef987327cc5edb69$var$yi.bind(null, b, a), c);
}
function $ef987327cc5edb69$var$Ai() {}
function $ef987327cc5edb69$var$Bi(a, b) {
    var c = $ef987327cc5edb69$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ef987327cc5edb69$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ef987327cc5edb69$var$Ci(a, b) {
    var c = $ef987327cc5edb69$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $ef987327cc5edb69$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $ef987327cc5edb69$var$Di(a, b, c) {
    if (0 === ($ef987327cc5edb69$var$Rh & 21)) return a.baseState && (a.baseState = !1, $ef987327cc5edb69$var$Ug = !0), a.memoizedState = c;
    $ef987327cc5edb69$var$He(c, b) || (c = $ef987327cc5edb69$var$yc(), $ef987327cc5edb69$var$N.lanes |= c, $ef987327cc5edb69$var$hh |= c, a.baseState = !0);
    return b;
}
function $ef987327cc5edb69$var$Ei(a, b) {
    var c = $ef987327cc5edb69$var$C;
    $ef987327cc5edb69$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $ef987327cc5edb69$var$Qh.transition;
    $ef987327cc5edb69$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $ef987327cc5edb69$var$C = c, $ef987327cc5edb69$var$Qh.transition = d;
    }
}
function $ef987327cc5edb69$var$Fi() {
    return $ef987327cc5edb69$var$di().memoizedState;
}
function $ef987327cc5edb69$var$Gi(a, b, c) {
    var d = $ef987327cc5edb69$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ef987327cc5edb69$var$Hi(a)) $ef987327cc5edb69$var$Ii(b, c);
    else if (c = $ef987327cc5edb69$var$Yg(a, b, c, d), null !== c) {
        var e = $ef987327cc5edb69$var$L();
        $ef987327cc5edb69$var$mh(c, a, d, e);
        $ef987327cc5edb69$var$Ji(c, b, d);
    }
}
function $ef987327cc5edb69$var$ri(a, b, c) {
    var d = $ef987327cc5edb69$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($ef987327cc5edb69$var$Hi(a)) $ef987327cc5edb69$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($ef987327cc5edb69$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $ef987327cc5edb69$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $ef987327cc5edb69$var$Yg(a, b, e, d);
        null !== c && (e = $ef987327cc5edb69$var$L(), $ef987327cc5edb69$var$mh(c, a, d, e), $ef987327cc5edb69$var$Ji(c, b, d));
    }
}
function $ef987327cc5edb69$var$Hi(a) {
    var b = a.alternate;
    return a === $ef987327cc5edb69$var$N || null !== b && b === $ef987327cc5edb69$var$N;
}
function $ef987327cc5edb69$var$Ii(a, b) {
    $ef987327cc5edb69$var$Th = $ef987327cc5edb69$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $ef987327cc5edb69$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $ef987327cc5edb69$var$Cc(a, c);
    }
}
var $ef987327cc5edb69$var$ai = {
    readContext: $ef987327cc5edb69$var$Vg,
    useCallback: $ef987327cc5edb69$var$Q,
    useContext: $ef987327cc5edb69$var$Q,
    useEffect: $ef987327cc5edb69$var$Q,
    useImperativeHandle: $ef987327cc5edb69$var$Q,
    useInsertionEffect: $ef987327cc5edb69$var$Q,
    useLayoutEffect: $ef987327cc5edb69$var$Q,
    useMemo: $ef987327cc5edb69$var$Q,
    useReducer: $ef987327cc5edb69$var$Q,
    useRef: $ef987327cc5edb69$var$Q,
    useState: $ef987327cc5edb69$var$Q,
    useDebugValue: $ef987327cc5edb69$var$Q,
    useDeferredValue: $ef987327cc5edb69$var$Q,
    useTransition: $ef987327cc5edb69$var$Q,
    useMutableSource: $ef987327cc5edb69$var$Q,
    useSyncExternalStore: $ef987327cc5edb69$var$Q,
    useId: $ef987327cc5edb69$var$Q,
    unstable_isNewReconciler: !1
}, $ef987327cc5edb69$var$Yh = {
    readContext: $ef987327cc5edb69$var$Vg,
    useCallback: function(a, b) {
        $ef987327cc5edb69$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $ef987327cc5edb69$var$Vg,
    useEffect: $ef987327cc5edb69$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $ef987327cc5edb69$var$ti(4194308, 4, $ef987327cc5edb69$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $ef987327cc5edb69$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $ef987327cc5edb69$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $ef987327cc5edb69$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $ef987327cc5edb69$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $ef987327cc5edb69$var$Gi.bind(null, $ef987327cc5edb69$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $ef987327cc5edb69$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $ef987327cc5edb69$var$qi,
    useDebugValue: $ef987327cc5edb69$var$Ai,
    useDeferredValue: function(a) {
        return $ef987327cc5edb69$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $ef987327cc5edb69$var$qi(!1), b = a[0];
        a = $ef987327cc5edb69$var$Ei.bind(null, a[1]);
        $ef987327cc5edb69$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $ef987327cc5edb69$var$N, e = $ef987327cc5edb69$var$ci();
        if ($ef987327cc5edb69$var$I) {
            if (void 0 === c) throw Error($ef987327cc5edb69$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $ef987327cc5edb69$var$R) throw Error($ef987327cc5edb69$var$p(349));
            0 !== ($ef987327cc5edb69$var$Rh & 30) || $ef987327cc5edb69$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $ef987327cc5edb69$var$vi($ef987327cc5edb69$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $ef987327cc5edb69$var$li(9, $ef987327cc5edb69$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $ef987327cc5edb69$var$ci(), b = $ef987327cc5edb69$var$R.identifierPrefix;
        if ($ef987327cc5edb69$var$I) {
            var c = $ef987327cc5edb69$var$sg;
            var d = $ef987327cc5edb69$var$rg;
            c = (d & ~(1 << 32 - $ef987327cc5edb69$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $ef987327cc5edb69$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $ef987327cc5edb69$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $ef987327cc5edb69$var$Zh = {
    readContext: $ef987327cc5edb69$var$Vg,
    useCallback: $ef987327cc5edb69$var$Bi,
    useContext: $ef987327cc5edb69$var$Vg,
    useEffect: $ef987327cc5edb69$var$ji,
    useImperativeHandle: $ef987327cc5edb69$var$zi,
    useInsertionEffect: $ef987327cc5edb69$var$wi,
    useLayoutEffect: $ef987327cc5edb69$var$xi,
    useMemo: $ef987327cc5edb69$var$Ci,
    useReducer: $ef987327cc5edb69$var$fi,
    useRef: $ef987327cc5edb69$var$si,
    useState: function() {
        return $ef987327cc5edb69$var$fi($ef987327cc5edb69$var$ei);
    },
    useDebugValue: $ef987327cc5edb69$var$Ai,
    useDeferredValue: function(a) {
        var b = $ef987327cc5edb69$var$di();
        return $ef987327cc5edb69$var$Di(b, $ef987327cc5edb69$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $ef987327cc5edb69$var$fi($ef987327cc5edb69$var$ei)[0], b = $ef987327cc5edb69$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ef987327cc5edb69$var$hi,
    useSyncExternalStore: $ef987327cc5edb69$var$ii,
    useId: $ef987327cc5edb69$var$Fi,
    unstable_isNewReconciler: !1
}, $ef987327cc5edb69$var$$h = {
    readContext: $ef987327cc5edb69$var$Vg,
    useCallback: $ef987327cc5edb69$var$Bi,
    useContext: $ef987327cc5edb69$var$Vg,
    useEffect: $ef987327cc5edb69$var$ji,
    useImperativeHandle: $ef987327cc5edb69$var$zi,
    useInsertionEffect: $ef987327cc5edb69$var$wi,
    useLayoutEffect: $ef987327cc5edb69$var$xi,
    useMemo: $ef987327cc5edb69$var$Ci,
    useReducer: $ef987327cc5edb69$var$gi,
    useRef: $ef987327cc5edb69$var$si,
    useState: function() {
        return $ef987327cc5edb69$var$gi($ef987327cc5edb69$var$ei);
    },
    useDebugValue: $ef987327cc5edb69$var$Ai,
    useDeferredValue: function(a) {
        var b = $ef987327cc5edb69$var$di();
        return null === $ef987327cc5edb69$var$O ? b.memoizedState = a : $ef987327cc5edb69$var$Di(b, $ef987327cc5edb69$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $ef987327cc5edb69$var$gi($ef987327cc5edb69$var$ei)[0], b = $ef987327cc5edb69$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $ef987327cc5edb69$var$hi,
    useSyncExternalStore: $ef987327cc5edb69$var$ii,
    useId: $ef987327cc5edb69$var$Fi,
    unstable_isNewReconciler: !1
};
function $ef987327cc5edb69$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $ef987327cc5edb69$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $ef987327cc5edb69$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $ef987327cc5edb69$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $ef987327cc5edb69$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $ef987327cc5edb69$var$Oi(a, b, c) {
    c = $ef987327cc5edb69$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $ef987327cc5edb69$var$Pi || ($ef987327cc5edb69$var$Pi = !0, $ef987327cc5edb69$var$Qi = d);
        $ef987327cc5edb69$var$Mi(a, b);
    };
    return c;
}
function $ef987327cc5edb69$var$Ri(a, b, c) {
    c = $ef987327cc5edb69$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $ef987327cc5edb69$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $ef987327cc5edb69$var$Mi(a, b);
        "function" !== typeof d && (null === $ef987327cc5edb69$var$Si ? $ef987327cc5edb69$var$Si = new Set([
            this
        ]) : $ef987327cc5edb69$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $ef987327cc5edb69$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $ef987327cc5edb69$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $ef987327cc5edb69$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $ef987327cc5edb69$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $ef987327cc5edb69$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $ef987327cc5edb69$var$ch(-1, 1), b.tag = 2, $ef987327cc5edb69$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $ef987327cc5edb69$var$Xi = $ef987327cc5edb69$var$ua.ReactCurrentOwner, $ef987327cc5edb69$var$Ug = !1;
function $ef987327cc5edb69$var$Yi(a, b, c, d) {
    b.child = null === a ? $ef987327cc5edb69$var$Ch(b, null, c, d) : $ef987327cc5edb69$var$Bh(b, a.child, c, d);
}
function $ef987327cc5edb69$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $ef987327cc5edb69$var$Tg(b, e);
    d = $ef987327cc5edb69$var$Xh(a, b, c, d, f, e);
    c = $ef987327cc5edb69$var$bi();
    if (null !== a && !$ef987327cc5edb69$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ef987327cc5edb69$var$$i(a, b, e);
    $ef987327cc5edb69$var$I && c && $ef987327cc5edb69$var$vg(b);
    b.flags |= 1;
    $ef987327cc5edb69$var$Yi(a, b, d, e);
    return b.child;
}
function $ef987327cc5edb69$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$ef987327cc5edb69$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $ef987327cc5edb69$var$cj(a, b, f, d, e);
        a = $ef987327cc5edb69$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $ef987327cc5edb69$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $ef987327cc5edb69$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $ef987327cc5edb69$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $ef987327cc5edb69$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($ef987327cc5edb69$var$Ie(f, d) && a.ref === b.ref) {
            if ($ef987327cc5edb69$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($ef987327cc5edb69$var$Ug = !0);
            else return b.lanes = a.lanes, $ef987327cc5edb69$var$$i(a, b, e);
        }
    }
    return $ef987327cc5edb69$var$dj(a, b, c, d, e);
}
function $ef987327cc5edb69$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $ef987327cc5edb69$var$G($ef987327cc5edb69$var$fj, $ef987327cc5edb69$var$gj), $ef987327cc5edb69$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $ef987327cc5edb69$var$G($ef987327cc5edb69$var$fj, $ef987327cc5edb69$var$gj), $ef987327cc5edb69$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $ef987327cc5edb69$var$G($ef987327cc5edb69$var$fj, $ef987327cc5edb69$var$gj);
            $ef987327cc5edb69$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $ef987327cc5edb69$var$G($ef987327cc5edb69$var$fj, $ef987327cc5edb69$var$gj), $ef987327cc5edb69$var$gj |= d;
    $ef987327cc5edb69$var$Yi(a, b, e, c);
    return b.child;
}
function $ef987327cc5edb69$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $ef987327cc5edb69$var$dj(a, b, c, d, e) {
    var f = $ef987327cc5edb69$var$Zf(c) ? $ef987327cc5edb69$var$Xf : $ef987327cc5edb69$var$H.current;
    f = $ef987327cc5edb69$var$Yf(b, f);
    $ef987327cc5edb69$var$Tg(b, e);
    c = $ef987327cc5edb69$var$Xh(a, b, c, d, f, e);
    d = $ef987327cc5edb69$var$bi();
    if (null !== a && !$ef987327cc5edb69$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $ef987327cc5edb69$var$$i(a, b, e);
    $ef987327cc5edb69$var$I && d && $ef987327cc5edb69$var$vg(b);
    b.flags |= 1;
    $ef987327cc5edb69$var$Yi(a, b, c, e);
    return b.child;
}
function $ef987327cc5edb69$var$ij(a, b, c, d, e) {
    if ($ef987327cc5edb69$var$Zf(c)) {
        var f = !0;
        $ef987327cc5edb69$var$cg(b);
    } else f = !1;
    $ef987327cc5edb69$var$Tg(b, e);
    if (null === b.stateNode) $ef987327cc5edb69$var$jj(a, b), $ef987327cc5edb69$var$ph(b, c, d), $ef987327cc5edb69$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $ef987327cc5edb69$var$Vg(l) : (l = $ef987327cc5edb69$var$Zf(c) ? $ef987327cc5edb69$var$Xf : $ef987327cc5edb69$var$H.current, l = $ef987327cc5edb69$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $ef987327cc5edb69$var$qh(b, g, d, l);
        $ef987327cc5edb69$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $ef987327cc5edb69$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $ef987327cc5edb69$var$Wf.current || $ef987327cc5edb69$var$$g ? ("function" === typeof m && ($ef987327cc5edb69$var$kh(b, c, m, d), k = b.memoizedState), (h = $ef987327cc5edb69$var$$g || $ef987327cc5edb69$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $ef987327cc5edb69$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $ef987327cc5edb69$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $ef987327cc5edb69$var$Vg(k) : (k = $ef987327cc5edb69$var$Zf(c) ? $ef987327cc5edb69$var$Xf : $ef987327cc5edb69$var$H.current, k = $ef987327cc5edb69$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $ef987327cc5edb69$var$qh(b, g, d, k);
        $ef987327cc5edb69$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $ef987327cc5edb69$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $ef987327cc5edb69$var$Wf.current || $ef987327cc5edb69$var$$g ? ("function" === typeof y && ($ef987327cc5edb69$var$kh(b, c, y, d), n = b.memoizedState), (l = $ef987327cc5edb69$var$$g || $ef987327cc5edb69$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $ef987327cc5edb69$var$kj(a, b, c, d, f, e);
}
function $ef987327cc5edb69$var$kj(a, b, c, d, e, f) {
    $ef987327cc5edb69$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $ef987327cc5edb69$var$dg(b, c, !1), $ef987327cc5edb69$var$$i(a, b, f);
    d = b.stateNode;
    $ef987327cc5edb69$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $ef987327cc5edb69$var$Bh(b, a.child, null, f), b.child = $ef987327cc5edb69$var$Bh(b, null, h, f)) : $ef987327cc5edb69$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $ef987327cc5edb69$var$dg(b, c, !0);
    return b.child;
}
function $ef987327cc5edb69$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $ef987327cc5edb69$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $ef987327cc5edb69$var$ag(a, b.context, !1);
    $ef987327cc5edb69$var$Ih(a, b.containerInfo);
}
function $ef987327cc5edb69$var$mj(a, b, c, d, e) {
    $ef987327cc5edb69$var$Ig();
    $ef987327cc5edb69$var$Jg(e);
    b.flags |= 256;
    $ef987327cc5edb69$var$Yi(a, b, c, d);
    return b.child;
}
var $ef987327cc5edb69$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $ef987327cc5edb69$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $ef987327cc5edb69$var$pj(a, b, c) {
    var d = b.pendingProps, e = $ef987327cc5edb69$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, e & 1);
    if (null === a) {
        $ef987327cc5edb69$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $ef987327cc5edb69$var$qj(g, d, 0, null), a = $ef987327cc5edb69$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $ef987327cc5edb69$var$oj(c), b.memoizedState = $ef987327cc5edb69$var$nj, a) : $ef987327cc5edb69$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $ef987327cc5edb69$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $ef987327cc5edb69$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $ef987327cc5edb69$var$wh(h, f) : (f = $ef987327cc5edb69$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $ef987327cc5edb69$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $ef987327cc5edb69$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $ef987327cc5edb69$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $ef987327cc5edb69$var$rj(a, b) {
    b = $ef987327cc5edb69$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $ef987327cc5edb69$var$tj(a, b, c, d) {
    null !== d && $ef987327cc5edb69$var$Jg(d);
    $ef987327cc5edb69$var$Bh(b, a.child, null, c);
    a = $ef987327cc5edb69$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $ef987327cc5edb69$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $ef987327cc5edb69$var$Li(Error($ef987327cc5edb69$var$p(422))), $ef987327cc5edb69$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $ef987327cc5edb69$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $ef987327cc5edb69$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $ef987327cc5edb69$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $ef987327cc5edb69$var$oj(g);
        b.memoizedState = $ef987327cc5edb69$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $ef987327cc5edb69$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($ef987327cc5edb69$var$p(419));
        d = $ef987327cc5edb69$var$Li(f, d, void 0);
        return $ef987327cc5edb69$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($ef987327cc5edb69$var$Ug || h) {
        d = $ef987327cc5edb69$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $ef987327cc5edb69$var$Zg(a, e), $ef987327cc5edb69$var$mh(d, a, e, -1));
        }
        $ef987327cc5edb69$var$uj();
        d = $ef987327cc5edb69$var$Li(Error($ef987327cc5edb69$var$p(421)));
        return $ef987327cc5edb69$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $ef987327cc5edb69$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$Lf(e.nextSibling);
    $ef987327cc5edb69$var$xg = b;
    $ef987327cc5edb69$var$I = !0;
    $ef987327cc5edb69$var$zg = null;
    null !== a && ($ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$rg, $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$sg, $ef987327cc5edb69$var$og[$ef987327cc5edb69$var$pg++] = $ef987327cc5edb69$var$qg, $ef987327cc5edb69$var$rg = a.id, $ef987327cc5edb69$var$sg = a.overflow, $ef987327cc5edb69$var$qg = b);
    b = $ef987327cc5edb69$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $ef987327cc5edb69$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $ef987327cc5edb69$var$Sg(a.return, b, c);
}
function $ef987327cc5edb69$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $ef987327cc5edb69$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $ef987327cc5edb69$var$Yi(a, b, d.children, c);
    d = $ef987327cc5edb69$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $ef987327cc5edb69$var$wj(a, c, b);
            else if (19 === a.tag) $ef987327cc5edb69$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $ef987327cc5edb69$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $ef987327cc5edb69$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $ef987327cc5edb69$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $ef987327cc5edb69$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $ef987327cc5edb69$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $ef987327cc5edb69$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $ef987327cc5edb69$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $ef987327cc5edb69$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($ef987327cc5edb69$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $ef987327cc5edb69$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $ef987327cc5edb69$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $ef987327cc5edb69$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $ef987327cc5edb69$var$lj(b);
            $ef987327cc5edb69$var$Ig();
            break;
        case 5:
            $ef987327cc5edb69$var$Kh(b);
            break;
        case 1:
            $ef987327cc5edb69$var$Zf(b.type) && $ef987327cc5edb69$var$cg(b);
            break;
        case 4:
            $ef987327cc5edb69$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, $ef987327cc5edb69$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $ef987327cc5edb69$var$pj(a, b, c);
                $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, $ef987327cc5edb69$var$M.current & 1);
                a = $ef987327cc5edb69$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, $ef987327cc5edb69$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $ef987327cc5edb69$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, $ef987327cc5edb69$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $ef987327cc5edb69$var$ej(a, b, c);
    }
    return $ef987327cc5edb69$var$$i(a, b, c);
}
var $ef987327cc5edb69$var$Aj, $ef987327cc5edb69$var$Bj, $ef987327cc5edb69$var$Cj, $ef987327cc5edb69$var$Dj;
$ef987327cc5edb69$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$ef987327cc5edb69$var$Bj = function() {};
$ef987327cc5edb69$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $ef987327cc5edb69$var$Ya(a, e);
                d = $ef987327cc5edb69$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $ef987327cc5edb69$var$A({}, e, {
                    value: void 0
                });
                d = $ef987327cc5edb69$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $ef987327cc5edb69$var$gb(a, e);
                d = $ef987327cc5edb69$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $ef987327cc5edb69$var$Bf);
        }
        $ef987327cc5edb69$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($ef987327cc5edb69$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($ef987327cc5edb69$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $ef987327cc5edb69$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$ef987327cc5edb69$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $ef987327cc5edb69$var$Ej(a, b) {
    if (!$ef987327cc5edb69$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $ef987327cc5edb69$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $ef987327cc5edb69$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $ef987327cc5edb69$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $ef987327cc5edb69$var$S(b), null;
        case 1:
            return $ef987327cc5edb69$var$Zf(b.type) && $ef987327cc5edb69$var$$f(), $ef987327cc5edb69$var$S(b), null;
        case 3:
            d = b.stateNode;
            $ef987327cc5edb69$var$Jh();
            $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf);
            $ef987327cc5edb69$var$E($ef987327cc5edb69$var$H);
            $ef987327cc5edb69$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $ef987327cc5edb69$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $ef987327cc5edb69$var$zg && ($ef987327cc5edb69$var$Gj($ef987327cc5edb69$var$zg), $ef987327cc5edb69$var$zg = null));
            $ef987327cc5edb69$var$Bj(a, b);
            $ef987327cc5edb69$var$S(b);
            return null;
        case 5:
            $ef987327cc5edb69$var$Lh(b);
            var e = $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $ef987327cc5edb69$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($ef987327cc5edb69$var$p(166));
                    $ef987327cc5edb69$var$S(b);
                    return null;
                }
                a = $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Eh.current);
                if ($ef987327cc5edb69$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$ef987327cc5edb69$var$Of] = b;
                    d[$ef987327cc5edb69$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $ef987327cc5edb69$var$D("cancel", d);
                            $ef987327cc5edb69$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $ef987327cc5edb69$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $ef987327cc5edb69$var$lf.length; e++)$ef987327cc5edb69$var$D($ef987327cc5edb69$var$lf[e], d);
                            break;
                        case "source":
                            $ef987327cc5edb69$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $ef987327cc5edb69$var$D("error", d);
                            $ef987327cc5edb69$var$D("load", d);
                            break;
                        case "details":
                            $ef987327cc5edb69$var$D("toggle", d);
                            break;
                        case "input":
                            $ef987327cc5edb69$var$Za(d, f);
                            $ef987327cc5edb69$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $ef987327cc5edb69$var$D("invalid", d);
                            break;
                        case "textarea":
                            $ef987327cc5edb69$var$hb(d, f), $ef987327cc5edb69$var$D("invalid", d);
                    }
                    $ef987327cc5edb69$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $ef987327cc5edb69$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $ef987327cc5edb69$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $ef987327cc5edb69$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $ef987327cc5edb69$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $ef987327cc5edb69$var$Va(d);
                            $ef987327cc5edb69$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $ef987327cc5edb69$var$Va(d);
                            $ef987327cc5edb69$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $ef987327cc5edb69$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $ef987327cc5edb69$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$ef987327cc5edb69$var$Of] = b;
                    a[$ef987327cc5edb69$var$Pf] = d;
                    $ef987327cc5edb69$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $ef987327cc5edb69$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $ef987327cc5edb69$var$D("cancel", a);
                                $ef987327cc5edb69$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $ef987327cc5edb69$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $ef987327cc5edb69$var$lf.length; e++)$ef987327cc5edb69$var$D($ef987327cc5edb69$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $ef987327cc5edb69$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $ef987327cc5edb69$var$D("error", a);
                                $ef987327cc5edb69$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $ef987327cc5edb69$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $ef987327cc5edb69$var$Za(a, d);
                                e = $ef987327cc5edb69$var$Ya(a, d);
                                $ef987327cc5edb69$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $ef987327cc5edb69$var$A({}, d, {
                                    value: void 0
                                });
                                $ef987327cc5edb69$var$D("invalid", a);
                                break;
                            case "textarea":
                                $ef987327cc5edb69$var$hb(a, d);
                                e = $ef987327cc5edb69$var$gb(a, d);
                                $ef987327cc5edb69$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $ef987327cc5edb69$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $ef987327cc5edb69$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $ef987327cc5edb69$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $ef987327cc5edb69$var$ob(a, k) : "number" === typeof k && $ef987327cc5edb69$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($ef987327cc5edb69$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $ef987327cc5edb69$var$D("scroll", a) : null != k && $ef987327cc5edb69$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $ef987327cc5edb69$var$Va(a);
                                $ef987327cc5edb69$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $ef987327cc5edb69$var$Va(a);
                                $ef987327cc5edb69$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $ef987327cc5edb69$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $ef987327cc5edb69$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $ef987327cc5edb69$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $ef987327cc5edb69$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $ef987327cc5edb69$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $ef987327cc5edb69$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($ef987327cc5edb69$var$p(166));
                c = $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Gh.current);
                $ef987327cc5edb69$var$Hh($ef987327cc5edb69$var$Eh.current);
                if ($ef987327cc5edb69$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$ef987327cc5edb69$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $ef987327cc5edb69$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $ef987327cc5edb69$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $ef987327cc5edb69$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$ef987327cc5edb69$var$Of] = b, b.stateNode = d;
            }
            $ef987327cc5edb69$var$S(b);
            return null;
        case 13:
            $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($ef987327cc5edb69$var$I && null !== $ef987327cc5edb69$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $ef987327cc5edb69$var$Hg(), $ef987327cc5edb69$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $ef987327cc5edb69$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($ef987327cc5edb69$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($ef987327cc5edb69$var$p(317));
                        f[$ef987327cc5edb69$var$Of] = b;
                    } else $ef987327cc5edb69$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $ef987327cc5edb69$var$S(b);
                    f = !1;
                } else null !== $ef987327cc5edb69$var$zg && ($ef987327cc5edb69$var$Gj($ef987327cc5edb69$var$zg), $ef987327cc5edb69$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($ef987327cc5edb69$var$M.current & 1) ? 0 === $ef987327cc5edb69$var$T && ($ef987327cc5edb69$var$T = 3) : $ef987327cc5edb69$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $ef987327cc5edb69$var$S(b);
            return null;
        case 4:
            return $ef987327cc5edb69$var$Jh(), $ef987327cc5edb69$var$Bj(a, b), null === a && $ef987327cc5edb69$var$sf(b.stateNode.containerInfo), $ef987327cc5edb69$var$S(b), null;
        case 10:
            return $ef987327cc5edb69$var$Rg(b.type._context), $ef987327cc5edb69$var$S(b), null;
        case 17:
            return $ef987327cc5edb69$var$Zf(b.type) && $ef987327cc5edb69$var$$f(), $ef987327cc5edb69$var$S(b), null;
        case 19:
            $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M);
            f = b.memoizedState;
            if (null === f) return $ef987327cc5edb69$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $ef987327cc5edb69$var$Ej(f, !1);
                else {
                    if (0 !== $ef987327cc5edb69$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $ef987327cc5edb69$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $ef987327cc5edb69$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, $ef987327cc5edb69$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $ef987327cc5edb69$var$B() > $ef987327cc5edb69$var$Hj && (b.flags |= 128, d = !0, $ef987327cc5edb69$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $ef987327cc5edb69$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $ef987327cc5edb69$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$ef987327cc5edb69$var$I) return $ef987327cc5edb69$var$S(b), null;
                    } else 2 * $ef987327cc5edb69$var$B() - f.renderingStartTime > $ef987327cc5edb69$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $ef987327cc5edb69$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $ef987327cc5edb69$var$B(), b.sibling = null, c = $ef987327cc5edb69$var$M.current, $ef987327cc5edb69$var$G($ef987327cc5edb69$var$M, d ? c & 1 | 2 : c & 1), b;
            $ef987327cc5edb69$var$S(b);
            return null;
        case 22:
        case 23:
            return $ef987327cc5edb69$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($ef987327cc5edb69$var$gj & 1073741824) && ($ef987327cc5edb69$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $ef987327cc5edb69$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($ef987327cc5edb69$var$p(156, b.tag));
}
function $ef987327cc5edb69$var$Jj(a, b) {
    $ef987327cc5edb69$var$wg(b);
    switch(b.tag){
        case 1:
            return $ef987327cc5edb69$var$Zf(b.type) && $ef987327cc5edb69$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $ef987327cc5edb69$var$Jh(), $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf), $ef987327cc5edb69$var$E($ef987327cc5edb69$var$H), $ef987327cc5edb69$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $ef987327cc5edb69$var$Lh(b), null;
        case 13:
            $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($ef987327cc5edb69$var$p(340));
                $ef987327cc5edb69$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M), null;
        case 4:
            return $ef987327cc5edb69$var$Jh(), null;
        case 10:
            return $ef987327cc5edb69$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $ef987327cc5edb69$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $ef987327cc5edb69$var$Kj = !1, $ef987327cc5edb69$var$U = !1, $ef987327cc5edb69$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $ef987327cc5edb69$var$V = null;
function $ef987327cc5edb69$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $ef987327cc5edb69$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $ef987327cc5edb69$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $ef987327cc5edb69$var$W(a, b, d);
    }
}
var $ef987327cc5edb69$var$Oj = !1;
function $ef987327cc5edb69$var$Pj(a, b) {
    $ef987327cc5edb69$var$Cf = $ef987327cc5edb69$var$dd;
    a = $ef987327cc5edb69$var$Me();
    if ($ef987327cc5edb69$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $ef987327cc5edb69$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $ef987327cc5edb69$var$dd = !1;
    for($ef987327cc5edb69$var$V = b; null !== $ef987327cc5edb69$var$V;)if (b = $ef987327cc5edb69$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $ef987327cc5edb69$var$V = a;
    else for(; null !== $ef987327cc5edb69$var$V;){
        b = $ef987327cc5edb69$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $ef987327cc5edb69$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($ef987327cc5edb69$var$p(163));
            }
        } catch (F) {
            $ef987327cc5edb69$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $ef987327cc5edb69$var$V = a;
            break;
        }
        $ef987327cc5edb69$var$V = b.return;
    }
    n = $ef987327cc5edb69$var$Oj;
    $ef987327cc5edb69$var$Oj = !1;
    return n;
}
function $ef987327cc5edb69$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $ef987327cc5edb69$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $ef987327cc5edb69$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $ef987327cc5edb69$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $ef987327cc5edb69$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $ef987327cc5edb69$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$ef987327cc5edb69$var$Of], delete b[$ef987327cc5edb69$var$Pf], delete b[$ef987327cc5edb69$var$of], delete b[$ef987327cc5edb69$var$Qf], delete b[$ef987327cc5edb69$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $ef987327cc5edb69$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $ef987327cc5edb69$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $ef987327cc5edb69$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $ef987327cc5edb69$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $ef987327cc5edb69$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($ef987327cc5edb69$var$Wj(a, b, c), a = a.sibling; null !== a;)$ef987327cc5edb69$var$Wj(a, b, c), a = a.sibling;
}
function $ef987327cc5edb69$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($ef987327cc5edb69$var$Xj(a, b, c), a = a.sibling; null !== a;)$ef987327cc5edb69$var$Xj(a, b, c), a = a.sibling;
}
var $ef987327cc5edb69$var$X = null, $ef987327cc5edb69$var$Yj = !1;
function $ef987327cc5edb69$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$ef987327cc5edb69$var$ak(a, b, c), c = c.sibling;
}
function $ef987327cc5edb69$var$ak(a, b, c) {
    if ($ef987327cc5edb69$var$lc && "function" === typeof $ef987327cc5edb69$var$lc.onCommitFiberUnmount) try {
        $ef987327cc5edb69$var$lc.onCommitFiberUnmount($ef987327cc5edb69$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $ef987327cc5edb69$var$U || $ef987327cc5edb69$var$Mj(c, b);
        case 6:
            var d = $ef987327cc5edb69$var$X, e = $ef987327cc5edb69$var$Yj;
            $ef987327cc5edb69$var$X = null;
            $ef987327cc5edb69$var$Zj(a, b, c);
            $ef987327cc5edb69$var$X = d;
            $ef987327cc5edb69$var$Yj = e;
            null !== $ef987327cc5edb69$var$X && ($ef987327cc5edb69$var$Yj ? (a = $ef987327cc5edb69$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $ef987327cc5edb69$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $ef987327cc5edb69$var$X && ($ef987327cc5edb69$var$Yj ? (a = $ef987327cc5edb69$var$X, c = c.stateNode, 8 === a.nodeType ? $ef987327cc5edb69$var$Kf(a.parentNode, c) : 1 === a.nodeType && $ef987327cc5edb69$var$Kf(a, c), $ef987327cc5edb69$var$bd(a)) : $ef987327cc5edb69$var$Kf($ef987327cc5edb69$var$X, c.stateNode));
            break;
        case 4:
            d = $ef987327cc5edb69$var$X;
            e = $ef987327cc5edb69$var$Yj;
            $ef987327cc5edb69$var$X = c.stateNode.containerInfo;
            $ef987327cc5edb69$var$Yj = !0;
            $ef987327cc5edb69$var$Zj(a, b, c);
            $ef987327cc5edb69$var$X = d;
            $ef987327cc5edb69$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$ef987327cc5edb69$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $ef987327cc5edb69$var$Nj(c, b, g) : 0 !== (f & 4) && $ef987327cc5edb69$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $ef987327cc5edb69$var$Zj(a, b, c);
            break;
        case 1:
            if (!$ef987327cc5edb69$var$U && ($ef987327cc5edb69$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $ef987327cc5edb69$var$W(c, b, h);
            }
            $ef987327cc5edb69$var$Zj(a, b, c);
            break;
        case 21:
            $ef987327cc5edb69$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($ef987327cc5edb69$var$U = (d = $ef987327cc5edb69$var$U) || null !== c.memoizedState, $ef987327cc5edb69$var$Zj(a, b, c), $ef987327cc5edb69$var$U = d) : $ef987327cc5edb69$var$Zj(a, b, c);
            break;
        default:
            $ef987327cc5edb69$var$Zj(a, b, c);
    }
}
function $ef987327cc5edb69$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $ef987327cc5edb69$var$Lj);
        b.forEach(function(b) {
            var d = $ef987327cc5edb69$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $ef987327cc5edb69$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $ef987327cc5edb69$var$X = h.stateNode;
                        $ef987327cc5edb69$var$Yj = !1;
                        break a;
                    case 3:
                        $ef987327cc5edb69$var$X = h.stateNode.containerInfo;
                        $ef987327cc5edb69$var$Yj = !0;
                        break a;
                    case 4:
                        $ef987327cc5edb69$var$X = h.stateNode.containerInfo;
                        $ef987327cc5edb69$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $ef987327cc5edb69$var$X) throw Error($ef987327cc5edb69$var$p(160));
            $ef987327cc5edb69$var$ak(f, g, e);
            $ef987327cc5edb69$var$X = null;
            $ef987327cc5edb69$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $ef987327cc5edb69$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$ef987327cc5edb69$var$ek(b, a), b = b.sibling;
}
function $ef987327cc5edb69$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            if (d & 4) {
                try {
                    $ef987327cc5edb69$var$Qj(3, a, a.return), $ef987327cc5edb69$var$Rj(3, a);
                } catch (t) {
                    $ef987327cc5edb69$var$W(a, a.return, t);
                }
                try {
                    $ef987327cc5edb69$var$Qj(5, a, a.return);
                } catch (t) {
                    $ef987327cc5edb69$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            d & 512 && null !== c && $ef987327cc5edb69$var$Mj(c, c.return);
            break;
        case 5:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            d & 512 && null !== c && $ef987327cc5edb69$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $ef987327cc5edb69$var$ob(e, "");
                } catch (t) {
                    $ef987327cc5edb69$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $ef987327cc5edb69$var$ab(e, f);
                    $ef987327cc5edb69$var$vb(h, g);
                    var l = $ef987327cc5edb69$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $ef987327cc5edb69$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $ef987327cc5edb69$var$nb(e, q) : "children" === m ? $ef987327cc5edb69$var$ob(e, q) : $ef987327cc5edb69$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $ef987327cc5edb69$var$bb(e, f);
                            break;
                        case "textarea":
                            $ef987327cc5edb69$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $ef987327cc5edb69$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $ef987327cc5edb69$var$fb(e, !!f.multiple, f.defaultValue, !0) : $ef987327cc5edb69$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$ef987327cc5edb69$var$Pf] = f;
                } catch (t) {
                    $ef987327cc5edb69$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($ef987327cc5edb69$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $ef987327cc5edb69$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $ef987327cc5edb69$var$bd(b.containerInfo);
            } catch (t) {
                $ef987327cc5edb69$var$W(a, a.return, t);
            }
            break;
        case 4:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            break;
        case 13:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($ef987327cc5edb69$var$gk = $ef987327cc5edb69$var$B()));
            d & 4 && $ef987327cc5edb69$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($ef987327cc5edb69$var$U = (l = $ef987327cc5edb69$var$U) || m, $ef987327cc5edb69$var$dk(b, a), $ef987327cc5edb69$var$U = l) : $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($ef987327cc5edb69$var$V = a, m = a.child; null !== m;){
                    for(q = $ef987327cc5edb69$var$V = m; null !== $ef987327cc5edb69$var$V;){
                        r = $ef987327cc5edb69$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $ef987327cc5edb69$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $ef987327cc5edb69$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $ef987327cc5edb69$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $ef987327cc5edb69$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $ef987327cc5edb69$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $ef987327cc5edb69$var$V = y) : $ef987327cc5edb69$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $ef987327cc5edb69$var$rb("display", g));
                            } catch (t) {
                                $ef987327cc5edb69$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $ef987327cc5edb69$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $ef987327cc5edb69$var$dk(b, a);
            $ef987327cc5edb69$var$fk(a);
            d & 4 && $ef987327cc5edb69$var$bk(a);
            break;
        case 21:
            break;
        default:
            $ef987327cc5edb69$var$dk(b, a), $ef987327cc5edb69$var$fk(a);
    }
}
function $ef987327cc5edb69$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($ef987327cc5edb69$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($ef987327cc5edb69$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($ef987327cc5edb69$var$ob(e, ""), d.flags &= -33);
                    var f = $ef987327cc5edb69$var$Vj(a);
                    $ef987327cc5edb69$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $ef987327cc5edb69$var$Vj(a);
                    $ef987327cc5edb69$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($ef987327cc5edb69$var$p(161));
            }
        } catch (k) {
            $ef987327cc5edb69$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $ef987327cc5edb69$var$ik(a, b, c) {
    $ef987327cc5edb69$var$V = a;
    $ef987327cc5edb69$var$jk(a, b, c);
}
function $ef987327cc5edb69$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $ef987327cc5edb69$var$V;){
        var e = $ef987327cc5edb69$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $ef987327cc5edb69$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $ef987327cc5edb69$var$U;
                h = $ef987327cc5edb69$var$Kj;
                var l = $ef987327cc5edb69$var$U;
                $ef987327cc5edb69$var$Kj = g;
                if (($ef987327cc5edb69$var$U = k) && !l) for($ef987327cc5edb69$var$V = e; null !== $ef987327cc5edb69$var$V;)g = $ef987327cc5edb69$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $ef987327cc5edb69$var$kk(e) : null !== k ? (k.return = g, $ef987327cc5edb69$var$V = k) : $ef987327cc5edb69$var$kk(e);
                for(; null !== f;)$ef987327cc5edb69$var$V = f, $ef987327cc5edb69$var$jk(f, b, c), f = f.sibling;
                $ef987327cc5edb69$var$V = e;
                $ef987327cc5edb69$var$Kj = h;
                $ef987327cc5edb69$var$U = l;
            }
            $ef987327cc5edb69$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $ef987327cc5edb69$var$V = f) : $ef987327cc5edb69$var$lk(a, b, c);
    }
}
function $ef987327cc5edb69$var$lk(a) {
    for(; null !== $ef987327cc5edb69$var$V;){
        var b = $ef987327cc5edb69$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $ef987327cc5edb69$var$U || $ef987327cc5edb69$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$ef987327cc5edb69$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $ef987327cc5edb69$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $ef987327cc5edb69$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $ef987327cc5edb69$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $ef987327cc5edb69$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($ef987327cc5edb69$var$p(163));
                }
                $ef987327cc5edb69$var$U || b.flags & 512 && $ef987327cc5edb69$var$Sj(b);
            } catch (r) {
                $ef987327cc5edb69$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $ef987327cc5edb69$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ef987327cc5edb69$var$V = c;
            break;
        }
        $ef987327cc5edb69$var$V = b.return;
    }
}
function $ef987327cc5edb69$var$hk(a) {
    for(; null !== $ef987327cc5edb69$var$V;){
        var b = $ef987327cc5edb69$var$V;
        if (b === a) {
            $ef987327cc5edb69$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $ef987327cc5edb69$var$V = c;
            break;
        }
        $ef987327cc5edb69$var$V = b.return;
    }
}
function $ef987327cc5edb69$var$kk(a) {
    for(; null !== $ef987327cc5edb69$var$V;){
        var b = $ef987327cc5edb69$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $ef987327cc5edb69$var$Rj(4, b);
                    } catch (k) {
                        $ef987327cc5edb69$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $ef987327cc5edb69$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $ef987327cc5edb69$var$Sj(b);
                    } catch (k) {
                        $ef987327cc5edb69$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $ef987327cc5edb69$var$Sj(b);
                    } catch (k) {
                        $ef987327cc5edb69$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $ef987327cc5edb69$var$W(b, b.return, k);
        }
        if (b === a) {
            $ef987327cc5edb69$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $ef987327cc5edb69$var$V = h;
            break;
        }
        $ef987327cc5edb69$var$V = b.return;
    }
}
var $ef987327cc5edb69$var$mk = Math.ceil, $ef987327cc5edb69$var$nk = $ef987327cc5edb69$var$ua.ReactCurrentDispatcher, $ef987327cc5edb69$var$ok = $ef987327cc5edb69$var$ua.ReactCurrentOwner, $ef987327cc5edb69$var$pk = $ef987327cc5edb69$var$ua.ReactCurrentBatchConfig, $ef987327cc5edb69$var$K = 0, $ef987327cc5edb69$var$R = null, $ef987327cc5edb69$var$Y = null, $ef987327cc5edb69$var$Z = 0, $ef987327cc5edb69$var$gj = 0, $ef987327cc5edb69$var$fj = $ef987327cc5edb69$var$Uf(0), $ef987327cc5edb69$var$T = 0, $ef987327cc5edb69$var$qk = null, $ef987327cc5edb69$var$hh = 0, $ef987327cc5edb69$var$rk = 0, $ef987327cc5edb69$var$sk = 0, $ef987327cc5edb69$var$tk = null, $ef987327cc5edb69$var$uk = null, $ef987327cc5edb69$var$gk = 0, $ef987327cc5edb69$var$Hj = Infinity, $ef987327cc5edb69$var$vk = null, $ef987327cc5edb69$var$Pi = !1, $ef987327cc5edb69$var$Qi = null, $ef987327cc5edb69$var$Si = null, $ef987327cc5edb69$var$wk = !1, $ef987327cc5edb69$var$xk = null, $ef987327cc5edb69$var$yk = 0, $ef987327cc5edb69$var$zk = 0, $ef987327cc5edb69$var$Ak = null, $ef987327cc5edb69$var$Bk = -1, $ef987327cc5edb69$var$Ck = 0;
function $ef987327cc5edb69$var$L() {
    return 0 !== ($ef987327cc5edb69$var$K & 6) ? $ef987327cc5edb69$var$B() : -1 !== $ef987327cc5edb69$var$Bk ? $ef987327cc5edb69$var$Bk : $ef987327cc5edb69$var$Bk = $ef987327cc5edb69$var$B();
}
function $ef987327cc5edb69$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($ef987327cc5edb69$var$K & 2) && 0 !== $ef987327cc5edb69$var$Z) return $ef987327cc5edb69$var$Z & -$ef987327cc5edb69$var$Z;
    if (null !== $ef987327cc5edb69$var$Kg.transition) return 0 === $ef987327cc5edb69$var$Ck && ($ef987327cc5edb69$var$Ck = $ef987327cc5edb69$var$yc()), $ef987327cc5edb69$var$Ck;
    a = $ef987327cc5edb69$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $ef987327cc5edb69$var$jd(a.type);
    return a;
}
function $ef987327cc5edb69$var$mh(a, b, c, d) {
    if (50 < $ef987327cc5edb69$var$zk) throw $ef987327cc5edb69$var$zk = 0, $ef987327cc5edb69$var$Ak = null, Error($ef987327cc5edb69$var$p(185));
    $ef987327cc5edb69$var$Ac(a, c, d);
    if (0 === ($ef987327cc5edb69$var$K & 2) || a !== $ef987327cc5edb69$var$R) a === $ef987327cc5edb69$var$R && (0 === ($ef987327cc5edb69$var$K & 2) && ($ef987327cc5edb69$var$rk |= c), 4 === $ef987327cc5edb69$var$T && $ef987327cc5edb69$var$Dk(a, $ef987327cc5edb69$var$Z)), $ef987327cc5edb69$var$Ek(a, d), 1 === c && 0 === $ef987327cc5edb69$var$K && 0 === (b.mode & 1) && ($ef987327cc5edb69$var$Hj = $ef987327cc5edb69$var$B() + 500, $ef987327cc5edb69$var$fg && $ef987327cc5edb69$var$jg());
}
function $ef987327cc5edb69$var$Ek(a, b) {
    var c = a.callbackNode;
    $ef987327cc5edb69$var$wc(a, b);
    var d = $ef987327cc5edb69$var$uc(a, a === $ef987327cc5edb69$var$R ? $ef987327cc5edb69$var$Z : 0);
    if (0 === d) null !== c && $ef987327cc5edb69$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $ef987327cc5edb69$var$bc(c);
        if (1 === b) 0 === a.tag ? $ef987327cc5edb69$var$ig($ef987327cc5edb69$var$Fk.bind(null, a)) : $ef987327cc5edb69$var$hg($ef987327cc5edb69$var$Fk.bind(null, a)), $ef987327cc5edb69$var$Jf(function() {
            0 === ($ef987327cc5edb69$var$K & 6) && $ef987327cc5edb69$var$jg();
        }), c = null;
        else {
            switch($ef987327cc5edb69$var$Dc(d)){
                case 1:
                    c = $ef987327cc5edb69$var$fc;
                    break;
                case 4:
                    c = $ef987327cc5edb69$var$gc;
                    break;
                case 16:
                    c = $ef987327cc5edb69$var$hc;
                    break;
                case 536870912:
                    c = $ef987327cc5edb69$var$jc;
                    break;
                default:
                    c = $ef987327cc5edb69$var$hc;
            }
            c = $ef987327cc5edb69$var$Gk(c, $ef987327cc5edb69$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $ef987327cc5edb69$var$Hk(a, b) {
    $ef987327cc5edb69$var$Bk = -1;
    $ef987327cc5edb69$var$Ck = 0;
    if (0 !== ($ef987327cc5edb69$var$K & 6)) throw Error($ef987327cc5edb69$var$p(327));
    var c = a.callbackNode;
    if ($ef987327cc5edb69$var$Ik() && a.callbackNode !== c) return null;
    var d = $ef987327cc5edb69$var$uc(a, a === $ef987327cc5edb69$var$R ? $ef987327cc5edb69$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $ef987327cc5edb69$var$Jk(a, d);
    else {
        b = d;
        var e = $ef987327cc5edb69$var$K;
        $ef987327cc5edb69$var$K |= 2;
        var f = $ef987327cc5edb69$var$Kk();
        if ($ef987327cc5edb69$var$R !== a || $ef987327cc5edb69$var$Z !== b) $ef987327cc5edb69$var$vk = null, $ef987327cc5edb69$var$Hj = $ef987327cc5edb69$var$B() + 500, $ef987327cc5edb69$var$Lk(a, b);
        for(;;)try {
            $ef987327cc5edb69$var$Mk();
            break;
        } catch (h) {
            $ef987327cc5edb69$var$Nk(a, h);
        }
        $ef987327cc5edb69$var$Qg();
        $ef987327cc5edb69$var$nk.current = f;
        $ef987327cc5edb69$var$K = e;
        null !== $ef987327cc5edb69$var$Y ? b = 0 : ($ef987327cc5edb69$var$R = null, $ef987327cc5edb69$var$Z = 0, b = $ef987327cc5edb69$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $ef987327cc5edb69$var$xc(a), 0 !== e && (d = e, b = $ef987327cc5edb69$var$Ok(a, e)));
        if (1 === b) throw c = $ef987327cc5edb69$var$qk, $ef987327cc5edb69$var$Lk(a, 0), $ef987327cc5edb69$var$Dk(a, d), $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B()), c;
        if (6 === b) $ef987327cc5edb69$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$ef987327cc5edb69$var$Pk(e) && (b = $ef987327cc5edb69$var$Jk(a, d), 2 === b && (f = $ef987327cc5edb69$var$xc(a), 0 !== f && (d = f, b = $ef987327cc5edb69$var$Ok(a, f))), 1 === b)) throw c = $ef987327cc5edb69$var$qk, $ef987327cc5edb69$var$Lk(a, 0), $ef987327cc5edb69$var$Dk(a, d), $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($ef987327cc5edb69$var$p(345));
                case 2:
                    $ef987327cc5edb69$var$Qk(a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk);
                    break;
                case 3:
                    $ef987327cc5edb69$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $ef987327cc5edb69$var$gk + 500 - $ef987327cc5edb69$var$B(), 10 < b)) {
                        if (0 !== $ef987327cc5edb69$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $ef987327cc5edb69$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $ef987327cc5edb69$var$Ff($ef987327cc5edb69$var$Qk.bind(null, a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk), b);
                        break;
                    }
                    $ef987327cc5edb69$var$Qk(a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk);
                    break;
                case 4:
                    $ef987327cc5edb69$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $ef987327cc5edb69$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $ef987327cc5edb69$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $ef987327cc5edb69$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $ef987327cc5edb69$var$Ff($ef987327cc5edb69$var$Qk.bind(null, a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk), d);
                        break;
                    }
                    $ef987327cc5edb69$var$Qk(a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk);
                    break;
                case 5:
                    $ef987327cc5edb69$var$Qk(a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk);
                    break;
                default:
                    throw Error($ef987327cc5edb69$var$p(329));
            }
        }
    }
    $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B());
    return a.callbackNode === c ? $ef987327cc5edb69$var$Hk.bind(null, a) : null;
}
function $ef987327cc5edb69$var$Ok(a, b) {
    var c = $ef987327cc5edb69$var$tk;
    a.current.memoizedState.isDehydrated && ($ef987327cc5edb69$var$Lk(a, b).flags |= 256);
    a = $ef987327cc5edb69$var$Jk(a, b);
    2 !== a && (b = $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$uk = c, null !== b && $ef987327cc5edb69$var$Gj(b));
    return a;
}
function $ef987327cc5edb69$var$Gj(a) {
    null === $ef987327cc5edb69$var$uk ? $ef987327cc5edb69$var$uk = a : $ef987327cc5edb69$var$uk.push.apply($ef987327cc5edb69$var$uk, a);
}
function $ef987327cc5edb69$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$ef987327cc5edb69$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $ef987327cc5edb69$var$Dk(a, b) {
    b &= ~$ef987327cc5edb69$var$sk;
    b &= ~$ef987327cc5edb69$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $ef987327cc5edb69$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $ef987327cc5edb69$var$Fk(a) {
    if (0 !== ($ef987327cc5edb69$var$K & 6)) throw Error($ef987327cc5edb69$var$p(327));
    $ef987327cc5edb69$var$Ik();
    var b = $ef987327cc5edb69$var$uc(a, 0);
    if (0 === (b & 1)) return $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B()), null;
    var c = $ef987327cc5edb69$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $ef987327cc5edb69$var$xc(a);
        0 !== d && (b = d, c = $ef987327cc5edb69$var$Ok(a, d));
    }
    if (1 === c) throw c = $ef987327cc5edb69$var$qk, $ef987327cc5edb69$var$Lk(a, 0), $ef987327cc5edb69$var$Dk(a, b), $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B()), c;
    if (6 === c) throw Error($ef987327cc5edb69$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $ef987327cc5edb69$var$Qk(a, $ef987327cc5edb69$var$uk, $ef987327cc5edb69$var$vk);
    $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B());
    return null;
}
function $ef987327cc5edb69$var$Rk(a, b) {
    var c = $ef987327cc5edb69$var$K;
    $ef987327cc5edb69$var$K |= 1;
    try {
        return a(b);
    } finally{
        $ef987327cc5edb69$var$K = c, 0 === $ef987327cc5edb69$var$K && ($ef987327cc5edb69$var$Hj = $ef987327cc5edb69$var$B() + 500, $ef987327cc5edb69$var$fg && $ef987327cc5edb69$var$jg());
    }
}
function $ef987327cc5edb69$var$Sk(a) {
    null !== $ef987327cc5edb69$var$xk && 0 === $ef987327cc5edb69$var$xk.tag && 0 === ($ef987327cc5edb69$var$K & 6) && $ef987327cc5edb69$var$Ik();
    var b = $ef987327cc5edb69$var$K;
    $ef987327cc5edb69$var$K |= 1;
    var c = $ef987327cc5edb69$var$pk.transition, d = $ef987327cc5edb69$var$C;
    try {
        if ($ef987327cc5edb69$var$pk.transition = null, $ef987327cc5edb69$var$C = 1, a) return a();
    } finally{
        $ef987327cc5edb69$var$C = d, $ef987327cc5edb69$var$pk.transition = c, $ef987327cc5edb69$var$K = b, 0 === ($ef987327cc5edb69$var$K & 6) && $ef987327cc5edb69$var$jg();
    }
}
function $ef987327cc5edb69$var$Ij() {
    $ef987327cc5edb69$var$gj = $ef987327cc5edb69$var$fj.current;
    $ef987327cc5edb69$var$E($ef987327cc5edb69$var$fj);
}
function $ef987327cc5edb69$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $ef987327cc5edb69$var$Gf(c));
    if (null !== $ef987327cc5edb69$var$Y) for(c = $ef987327cc5edb69$var$Y.return; null !== c;){
        var d = c;
        $ef987327cc5edb69$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $ef987327cc5edb69$var$$f();
                break;
            case 3:
                $ef987327cc5edb69$var$Jh();
                $ef987327cc5edb69$var$E($ef987327cc5edb69$var$Wf);
                $ef987327cc5edb69$var$E($ef987327cc5edb69$var$H);
                $ef987327cc5edb69$var$Oh();
                break;
            case 5:
                $ef987327cc5edb69$var$Lh(d);
                break;
            case 4:
                $ef987327cc5edb69$var$Jh();
                break;
            case 13:
                $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M);
                break;
            case 19:
                $ef987327cc5edb69$var$E($ef987327cc5edb69$var$M);
                break;
            case 10:
                $ef987327cc5edb69$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $ef987327cc5edb69$var$Ij();
        }
        c = c.return;
    }
    $ef987327cc5edb69$var$R = a;
    $ef987327cc5edb69$var$Y = a = $ef987327cc5edb69$var$wh(a.current, null);
    $ef987327cc5edb69$var$Z = $ef987327cc5edb69$var$gj = b;
    $ef987327cc5edb69$var$T = 0;
    $ef987327cc5edb69$var$qk = null;
    $ef987327cc5edb69$var$sk = $ef987327cc5edb69$var$rk = $ef987327cc5edb69$var$hh = 0;
    $ef987327cc5edb69$var$uk = $ef987327cc5edb69$var$tk = null;
    if (null !== $ef987327cc5edb69$var$Wg) {
        for(b = 0; b < $ef987327cc5edb69$var$Wg.length; b++)if (c = $ef987327cc5edb69$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $ef987327cc5edb69$var$Wg = null;
    }
    return a;
}
function $ef987327cc5edb69$var$Nk(a, b) {
    do {
        var c = $ef987327cc5edb69$var$Y;
        try {
            $ef987327cc5edb69$var$Qg();
            $ef987327cc5edb69$var$Ph.current = $ef987327cc5edb69$var$ai;
            if ($ef987327cc5edb69$var$Sh) {
                for(var d = $ef987327cc5edb69$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $ef987327cc5edb69$var$Sh = !1;
            }
            $ef987327cc5edb69$var$Rh = 0;
            $ef987327cc5edb69$var$P = $ef987327cc5edb69$var$O = $ef987327cc5edb69$var$N = null;
            $ef987327cc5edb69$var$Th = !1;
            $ef987327cc5edb69$var$Uh = 0;
            $ef987327cc5edb69$var$ok.current = null;
            if (null === c || null === c.return) {
                $ef987327cc5edb69$var$T = 1;
                $ef987327cc5edb69$var$qk = b;
                $ef987327cc5edb69$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $ef987327cc5edb69$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $ef987327cc5edb69$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $ef987327cc5edb69$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $ef987327cc5edb69$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $ef987327cc5edb69$var$Ti(f, l, b);
                            $ef987327cc5edb69$var$uj();
                            break a;
                        }
                        k = Error($ef987327cc5edb69$var$p(426));
                    }
                } else if ($ef987327cc5edb69$var$I && h.mode & 1) {
                    var J = $ef987327cc5edb69$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $ef987327cc5edb69$var$Wi(J, g, h, f, b);
                        $ef987327cc5edb69$var$Jg($ef987327cc5edb69$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $ef987327cc5edb69$var$Ki(k, h);
                4 !== $ef987327cc5edb69$var$T && ($ef987327cc5edb69$var$T = 2);
                null === $ef987327cc5edb69$var$tk ? $ef987327cc5edb69$var$tk = [
                    f
                ] : $ef987327cc5edb69$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $ef987327cc5edb69$var$Oi(f, k, b);
                            $ef987327cc5edb69$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $ef987327cc5edb69$var$Si || !$ef987327cc5edb69$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $ef987327cc5edb69$var$Ri(f, h, b);
                                $ef987327cc5edb69$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $ef987327cc5edb69$var$Tk(c);
        } catch (na) {
            b = na;
            $ef987327cc5edb69$var$Y === c && null !== c && ($ef987327cc5edb69$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $ef987327cc5edb69$var$Kk() {
    var a = $ef987327cc5edb69$var$nk.current;
    $ef987327cc5edb69$var$nk.current = $ef987327cc5edb69$var$ai;
    return null === a ? $ef987327cc5edb69$var$ai : a;
}
function $ef987327cc5edb69$var$uj() {
    if (0 === $ef987327cc5edb69$var$T || 3 === $ef987327cc5edb69$var$T || 2 === $ef987327cc5edb69$var$T) $ef987327cc5edb69$var$T = 4;
    null === $ef987327cc5edb69$var$R || 0 === ($ef987327cc5edb69$var$hh & 268435455) && 0 === ($ef987327cc5edb69$var$rk & 268435455) || $ef987327cc5edb69$var$Dk($ef987327cc5edb69$var$R, $ef987327cc5edb69$var$Z);
}
function $ef987327cc5edb69$var$Jk(a, b) {
    var c = $ef987327cc5edb69$var$K;
    $ef987327cc5edb69$var$K |= 2;
    var d = $ef987327cc5edb69$var$Kk();
    if ($ef987327cc5edb69$var$R !== a || $ef987327cc5edb69$var$Z !== b) $ef987327cc5edb69$var$vk = null, $ef987327cc5edb69$var$Lk(a, b);
    for(;;)try {
        $ef987327cc5edb69$var$Uk();
        break;
    } catch (e) {
        $ef987327cc5edb69$var$Nk(a, e);
    }
    $ef987327cc5edb69$var$Qg();
    $ef987327cc5edb69$var$K = c;
    $ef987327cc5edb69$var$nk.current = d;
    if (null !== $ef987327cc5edb69$var$Y) throw Error($ef987327cc5edb69$var$p(261));
    $ef987327cc5edb69$var$R = null;
    $ef987327cc5edb69$var$Z = 0;
    return $ef987327cc5edb69$var$T;
}
function $ef987327cc5edb69$var$Uk() {
    for(; null !== $ef987327cc5edb69$var$Y;)$ef987327cc5edb69$var$Vk($ef987327cc5edb69$var$Y);
}
function $ef987327cc5edb69$var$Mk() {
    for(; null !== $ef987327cc5edb69$var$Y && !$ef987327cc5edb69$var$cc();)$ef987327cc5edb69$var$Vk($ef987327cc5edb69$var$Y);
}
function $ef987327cc5edb69$var$Vk(a) {
    var b = $ef987327cc5edb69$var$Wk(a.alternate, a, $ef987327cc5edb69$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $ef987327cc5edb69$var$Tk(a) : $ef987327cc5edb69$var$Y = b;
    $ef987327cc5edb69$var$ok.current = null;
}
function $ef987327cc5edb69$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $ef987327cc5edb69$var$Fj(c, b, $ef987327cc5edb69$var$gj), null !== c) {
                $ef987327cc5edb69$var$Y = c;
                return;
            }
        } else {
            c = $ef987327cc5edb69$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $ef987327cc5edb69$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $ef987327cc5edb69$var$T = 6;
                $ef987327cc5edb69$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $ef987327cc5edb69$var$Y = b;
            return;
        }
        $ef987327cc5edb69$var$Y = b = a;
    }while (null !== b);
    0 === $ef987327cc5edb69$var$T && ($ef987327cc5edb69$var$T = 5);
}
function $ef987327cc5edb69$var$Qk(a, b, c) {
    var d = $ef987327cc5edb69$var$C, e = $ef987327cc5edb69$var$pk.transition;
    try {
        $ef987327cc5edb69$var$pk.transition = null, $ef987327cc5edb69$var$C = 1, $ef987327cc5edb69$var$Xk(a, b, c, d);
    } finally{
        $ef987327cc5edb69$var$pk.transition = e, $ef987327cc5edb69$var$C = d;
    }
    return null;
}
function $ef987327cc5edb69$var$Xk(a, b, c, d) {
    do $ef987327cc5edb69$var$Ik();
    while (null !== $ef987327cc5edb69$var$xk);
    if (0 !== ($ef987327cc5edb69$var$K & 6)) throw Error($ef987327cc5edb69$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($ef987327cc5edb69$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $ef987327cc5edb69$var$Bc(a, f);
    a === $ef987327cc5edb69$var$R && ($ef987327cc5edb69$var$Y = $ef987327cc5edb69$var$R = null, $ef987327cc5edb69$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $ef987327cc5edb69$var$wk || ($ef987327cc5edb69$var$wk = !0, $ef987327cc5edb69$var$Gk($ef987327cc5edb69$var$hc, function() {
        $ef987327cc5edb69$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $ef987327cc5edb69$var$pk.transition;
        $ef987327cc5edb69$var$pk.transition = null;
        var g = $ef987327cc5edb69$var$C;
        $ef987327cc5edb69$var$C = 1;
        var h = $ef987327cc5edb69$var$K;
        $ef987327cc5edb69$var$K |= 4;
        $ef987327cc5edb69$var$ok.current = null;
        $ef987327cc5edb69$var$Pj(a, c);
        $ef987327cc5edb69$var$ek(c, a);
        $ef987327cc5edb69$var$Oe($ef987327cc5edb69$var$Df);
        $ef987327cc5edb69$var$dd = !!$ef987327cc5edb69$var$Cf;
        $ef987327cc5edb69$var$Df = $ef987327cc5edb69$var$Cf = null;
        a.current = c;
        $ef987327cc5edb69$var$ik(c, a, e);
        $ef987327cc5edb69$var$dc();
        $ef987327cc5edb69$var$K = h;
        $ef987327cc5edb69$var$C = g;
        $ef987327cc5edb69$var$pk.transition = f;
    } else a.current = c;
    $ef987327cc5edb69$var$wk && ($ef987327cc5edb69$var$wk = !1, $ef987327cc5edb69$var$xk = a, $ef987327cc5edb69$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($ef987327cc5edb69$var$Si = null);
    $ef987327cc5edb69$var$mc(c.stateNode, d);
    $ef987327cc5edb69$var$Ek(a, $ef987327cc5edb69$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($ef987327cc5edb69$var$Pi) throw $ef987327cc5edb69$var$Pi = !1, a = $ef987327cc5edb69$var$Qi, $ef987327cc5edb69$var$Qi = null, a;
    0 !== ($ef987327cc5edb69$var$yk & 1) && 0 !== a.tag && $ef987327cc5edb69$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $ef987327cc5edb69$var$Ak ? $ef987327cc5edb69$var$zk++ : ($ef987327cc5edb69$var$zk = 0, $ef987327cc5edb69$var$Ak = a) : $ef987327cc5edb69$var$zk = 0;
    $ef987327cc5edb69$var$jg();
    return null;
}
function $ef987327cc5edb69$var$Ik() {
    if (null !== $ef987327cc5edb69$var$xk) {
        var a = $ef987327cc5edb69$var$Dc($ef987327cc5edb69$var$yk), b = $ef987327cc5edb69$var$pk.transition, c = $ef987327cc5edb69$var$C;
        try {
            $ef987327cc5edb69$var$pk.transition = null;
            $ef987327cc5edb69$var$C = 16 > a ? 16 : a;
            if (null === $ef987327cc5edb69$var$xk) var d = !1;
            else {
                a = $ef987327cc5edb69$var$xk;
                $ef987327cc5edb69$var$xk = null;
                $ef987327cc5edb69$var$yk = 0;
                if (0 !== ($ef987327cc5edb69$var$K & 6)) throw Error($ef987327cc5edb69$var$p(331));
                var e = $ef987327cc5edb69$var$K;
                $ef987327cc5edb69$var$K |= 4;
                for($ef987327cc5edb69$var$V = a.current; null !== $ef987327cc5edb69$var$V;){
                    var f = $ef987327cc5edb69$var$V, g = f.child;
                    if (0 !== ($ef987327cc5edb69$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($ef987327cc5edb69$var$V = l; null !== $ef987327cc5edb69$var$V;){
                                    var m = $ef987327cc5edb69$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $ef987327cc5edb69$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $ef987327cc5edb69$var$V = q;
                                    else for(; null !== $ef987327cc5edb69$var$V;){
                                        m = $ef987327cc5edb69$var$V;
                                        var r = m.sibling, y = m.return;
                                        $ef987327cc5edb69$var$Tj(m);
                                        if (m === l) {
                                            $ef987327cc5edb69$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $ef987327cc5edb69$var$V = r;
                                            break;
                                        }
                                        $ef987327cc5edb69$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $ef987327cc5edb69$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $ef987327cc5edb69$var$V = g;
                    else b: for(; null !== $ef987327cc5edb69$var$V;){
                        f = $ef987327cc5edb69$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $ef987327cc5edb69$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $ef987327cc5edb69$var$V = x;
                            break b;
                        }
                        $ef987327cc5edb69$var$V = f.return;
                    }
                }
                var w = a.current;
                for($ef987327cc5edb69$var$V = w; null !== $ef987327cc5edb69$var$V;){
                    g = $ef987327cc5edb69$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $ef987327cc5edb69$var$V = u;
                    else b: for(g = w; null !== $ef987327cc5edb69$var$V;){
                        h = $ef987327cc5edb69$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $ef987327cc5edb69$var$Rj(9, h);
                            }
                        } catch (na) {
                            $ef987327cc5edb69$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $ef987327cc5edb69$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $ef987327cc5edb69$var$V = F;
                            break b;
                        }
                        $ef987327cc5edb69$var$V = h.return;
                    }
                }
                $ef987327cc5edb69$var$K = e;
                $ef987327cc5edb69$var$jg();
                if ($ef987327cc5edb69$var$lc && "function" === typeof $ef987327cc5edb69$var$lc.onPostCommitFiberRoot) try {
                    $ef987327cc5edb69$var$lc.onPostCommitFiberRoot($ef987327cc5edb69$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $ef987327cc5edb69$var$C = c, $ef987327cc5edb69$var$pk.transition = b;
        }
    }
    return !1;
}
function $ef987327cc5edb69$var$Yk(a, b, c) {
    b = $ef987327cc5edb69$var$Ki(c, b);
    b = $ef987327cc5edb69$var$Oi(a, b, 1);
    a = $ef987327cc5edb69$var$dh(a, b, 1);
    b = $ef987327cc5edb69$var$L();
    null !== a && ($ef987327cc5edb69$var$Ac(a, 1, b), $ef987327cc5edb69$var$Ek(a, b));
}
function $ef987327cc5edb69$var$W(a, b, c) {
    if (3 === a.tag) $ef987327cc5edb69$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $ef987327cc5edb69$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $ef987327cc5edb69$var$Si || !$ef987327cc5edb69$var$Si.has(d))) {
                a = $ef987327cc5edb69$var$Ki(c, a);
                a = $ef987327cc5edb69$var$Ri(b, a, 1);
                b = $ef987327cc5edb69$var$dh(b, a, 1);
                a = $ef987327cc5edb69$var$L();
                null !== b && ($ef987327cc5edb69$var$Ac(b, 1, a), $ef987327cc5edb69$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $ef987327cc5edb69$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $ef987327cc5edb69$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $ef987327cc5edb69$var$R === a && ($ef987327cc5edb69$var$Z & c) === c && (4 === $ef987327cc5edb69$var$T || 3 === $ef987327cc5edb69$var$T && ($ef987327cc5edb69$var$Z & 130023424) === $ef987327cc5edb69$var$Z && 500 > $ef987327cc5edb69$var$B() - $ef987327cc5edb69$var$gk ? $ef987327cc5edb69$var$Lk(a, 0) : $ef987327cc5edb69$var$sk |= c);
    $ef987327cc5edb69$var$Ek(a, b);
}
function $ef987327cc5edb69$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $ef987327cc5edb69$var$sc, $ef987327cc5edb69$var$sc <<= 1, 0 === ($ef987327cc5edb69$var$sc & 130023424) && ($ef987327cc5edb69$var$sc = 4194304)));
    var c = $ef987327cc5edb69$var$L();
    a = $ef987327cc5edb69$var$Zg(a, b);
    null !== a && ($ef987327cc5edb69$var$Ac(a, b, c), $ef987327cc5edb69$var$Ek(a, c));
}
function $ef987327cc5edb69$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $ef987327cc5edb69$var$Zk(a, c);
}
function $ef987327cc5edb69$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($ef987327cc5edb69$var$p(314));
    }
    null !== d && d.delete(b);
    $ef987327cc5edb69$var$Zk(a, c);
}
var $ef987327cc5edb69$var$Wk;
$ef987327cc5edb69$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $ef987327cc5edb69$var$Wf.current) $ef987327cc5edb69$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $ef987327cc5edb69$var$Ug = !1, $ef987327cc5edb69$var$zj(a, b, c);
            $ef987327cc5edb69$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $ef987327cc5edb69$var$Ug = !1, $ef987327cc5edb69$var$I && 0 !== (b.flags & 1048576) && $ef987327cc5edb69$var$ug(b, $ef987327cc5edb69$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $ef987327cc5edb69$var$jj(a, b);
            a = b.pendingProps;
            var e = $ef987327cc5edb69$var$Yf(b, $ef987327cc5edb69$var$H.current);
            $ef987327cc5edb69$var$Tg(b, c);
            e = $ef987327cc5edb69$var$Xh(null, b, d, a, e, c);
            var f = $ef987327cc5edb69$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $ef987327cc5edb69$var$Zf(d) ? (f = !0, $ef987327cc5edb69$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $ef987327cc5edb69$var$ah(b), e.updater = $ef987327cc5edb69$var$nh, b.stateNode = e, e._reactInternals = b, $ef987327cc5edb69$var$rh(b, d, a, c), b = $ef987327cc5edb69$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $ef987327cc5edb69$var$I && f && $ef987327cc5edb69$var$vg(b), $ef987327cc5edb69$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $ef987327cc5edb69$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $ef987327cc5edb69$var$$k(d);
                a = $ef987327cc5edb69$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $ef987327cc5edb69$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $ef987327cc5edb69$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $ef987327cc5edb69$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $ef987327cc5edb69$var$aj(null, b, d, $ef987327cc5edb69$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($ef987327cc5edb69$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ef987327cc5edb69$var$Lg(d, e), $ef987327cc5edb69$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ef987327cc5edb69$var$Lg(d, e), $ef987327cc5edb69$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $ef987327cc5edb69$var$lj(b);
                if (null === a) throw Error($ef987327cc5edb69$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $ef987327cc5edb69$var$bh(a, b);
                $ef987327cc5edb69$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $ef987327cc5edb69$var$Ki(Error($ef987327cc5edb69$var$p(423)), b);
                        b = $ef987327cc5edb69$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $ef987327cc5edb69$var$Ki(Error($ef987327cc5edb69$var$p(424)), b);
                        b = $ef987327cc5edb69$var$mj(a, b, d, c, e);
                        break a;
                    } else for($ef987327cc5edb69$var$yg = $ef987327cc5edb69$var$Lf(b.stateNode.containerInfo.firstChild), $ef987327cc5edb69$var$xg = b, $ef987327cc5edb69$var$I = !0, $ef987327cc5edb69$var$zg = null, c = $ef987327cc5edb69$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $ef987327cc5edb69$var$Ig();
                    if (d === e) {
                        b = $ef987327cc5edb69$var$$i(a, b, c);
                        break a;
                    }
                    $ef987327cc5edb69$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $ef987327cc5edb69$var$Kh(b), null === a && $ef987327cc5edb69$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $ef987327cc5edb69$var$Ef(d, e) ? g = null : null !== f && $ef987327cc5edb69$var$Ef(d, f) && (b.flags |= 32), $ef987327cc5edb69$var$hj(a, b), $ef987327cc5edb69$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $ef987327cc5edb69$var$Eg(b), null;
        case 13:
            return $ef987327cc5edb69$var$pj(a, b, c);
        case 4:
            return $ef987327cc5edb69$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $ef987327cc5edb69$var$Bh(b, null, d, c) : $ef987327cc5edb69$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ef987327cc5edb69$var$Lg(d, e), $ef987327cc5edb69$var$Zi(a, b, d, e, c);
        case 7:
            return $ef987327cc5edb69$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $ef987327cc5edb69$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $ef987327cc5edb69$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $ef987327cc5edb69$var$G($ef987327cc5edb69$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($ef987327cc5edb69$var$He(f.value, g)) {
                        if (f.children === e.children && !$ef987327cc5edb69$var$Wf.current) {
                            b = $ef987327cc5edb69$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $ef987327cc5edb69$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $ef987327cc5edb69$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($ef987327cc5edb69$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $ef987327cc5edb69$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $ef987327cc5edb69$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $ef987327cc5edb69$var$Tg(b, c), e = $ef987327cc5edb69$var$Vg(e), d = d(e), b.flags |= 1, $ef987327cc5edb69$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $ef987327cc5edb69$var$Lg(d, b.pendingProps), e = $ef987327cc5edb69$var$Lg(d.type, e), $ef987327cc5edb69$var$aj(a, b, d, e, c);
        case 15:
            return $ef987327cc5edb69$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $ef987327cc5edb69$var$Lg(d, e), $ef987327cc5edb69$var$jj(a, b), b.tag = 1, $ef987327cc5edb69$var$Zf(d) ? (a = !0, $ef987327cc5edb69$var$cg(b)) : a = !1, $ef987327cc5edb69$var$Tg(b, c), $ef987327cc5edb69$var$ph(b, d, e), $ef987327cc5edb69$var$rh(b, d, e, c), $ef987327cc5edb69$var$kj(null, b, d, !0, a, c);
        case 19:
            return $ef987327cc5edb69$var$yj(a, b, c);
        case 22:
            return $ef987327cc5edb69$var$ej(a, b, c);
    }
    throw Error($ef987327cc5edb69$var$p(156, b.tag));
};
function $ef987327cc5edb69$var$Gk(a, b) {
    return $ef987327cc5edb69$var$ac(a, b);
}
function $ef987327cc5edb69$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $ef987327cc5edb69$var$Bg(a, b, c, d) {
    return new $ef987327cc5edb69$var$al(a, b, c, d);
}
function $ef987327cc5edb69$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $ef987327cc5edb69$var$$k(a) {
    if ("function" === typeof a) return $ef987327cc5edb69$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $ef987327cc5edb69$var$Da) return 11;
        if (a === $ef987327cc5edb69$var$Ga) return 14;
    }
    return 2;
}
function $ef987327cc5edb69$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $ef987327cc5edb69$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $ef987327cc5edb69$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $ef987327cc5edb69$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $ef987327cc5edb69$var$ya:
            return $ef987327cc5edb69$var$Ah(c.children, e, f, b);
        case $ef987327cc5edb69$var$za:
            g = 8;
            e |= 8;
            break;
        case $ef987327cc5edb69$var$Aa:
            return a = $ef987327cc5edb69$var$Bg(12, c, b, e | 2), a.elementType = $ef987327cc5edb69$var$Aa, a.lanes = f, a;
        case $ef987327cc5edb69$var$Ea:
            return a = $ef987327cc5edb69$var$Bg(13, c, b, e), a.elementType = $ef987327cc5edb69$var$Ea, a.lanes = f, a;
        case $ef987327cc5edb69$var$Fa:
            return a = $ef987327cc5edb69$var$Bg(19, c, b, e), a.elementType = $ef987327cc5edb69$var$Fa, a.lanes = f, a;
        case $ef987327cc5edb69$var$Ia:
            return $ef987327cc5edb69$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $ef987327cc5edb69$var$Ba:
                    g = 10;
                    break a;
                case $ef987327cc5edb69$var$Ca:
                    g = 9;
                    break a;
                case $ef987327cc5edb69$var$Da:
                    g = 11;
                    break a;
                case $ef987327cc5edb69$var$Ga:
                    g = 14;
                    break a;
                case $ef987327cc5edb69$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($ef987327cc5edb69$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $ef987327cc5edb69$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $ef987327cc5edb69$var$Ah(a, b, c, d) {
    a = $ef987327cc5edb69$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $ef987327cc5edb69$var$qj(a, b, c, d) {
    a = $ef987327cc5edb69$var$Bg(22, a, d, b);
    a.elementType = $ef987327cc5edb69$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $ef987327cc5edb69$var$xh(a, b, c) {
    a = $ef987327cc5edb69$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $ef987327cc5edb69$var$zh(a, b, c) {
    b = $ef987327cc5edb69$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $ef987327cc5edb69$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $ef987327cc5edb69$var$zc(0);
    this.expirationTimes = $ef987327cc5edb69$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $ef987327cc5edb69$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $ef987327cc5edb69$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $ef987327cc5edb69$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $ef987327cc5edb69$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $ef987327cc5edb69$var$ah(f);
    return a;
}
function $ef987327cc5edb69$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $ef987327cc5edb69$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $ef987327cc5edb69$var$el(a) {
    if (!a) return $ef987327cc5edb69$var$Vf;
    a = a._reactInternals;
    a: {
        if ($ef987327cc5edb69$var$Vb(a) !== a || 1 !== a.tag) throw Error($ef987327cc5edb69$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($ef987327cc5edb69$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($ef987327cc5edb69$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($ef987327cc5edb69$var$Zf(c)) return $ef987327cc5edb69$var$bg(a, c, b);
    }
    return b;
}
function $ef987327cc5edb69$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $ef987327cc5edb69$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $ef987327cc5edb69$var$el(null);
    c = a.current;
    d = $ef987327cc5edb69$var$L();
    e = $ef987327cc5edb69$var$lh(c);
    f = $ef987327cc5edb69$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $ef987327cc5edb69$var$dh(c, f, e);
    a.current.lanes = e;
    $ef987327cc5edb69$var$Ac(a, e, d);
    $ef987327cc5edb69$var$Ek(a, d);
    return a;
}
function $ef987327cc5edb69$var$gl(a, b, c, d) {
    var e = b.current, f = $ef987327cc5edb69$var$L(), g = $ef987327cc5edb69$var$lh(e);
    c = $ef987327cc5edb69$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $ef987327cc5edb69$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $ef987327cc5edb69$var$dh(e, b, g);
    null !== a && ($ef987327cc5edb69$var$mh(a, e, g, f), $ef987327cc5edb69$var$eh(a, e, g));
    return g;
}
function $ef987327cc5edb69$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $ef987327cc5edb69$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $ef987327cc5edb69$var$jl(a, b) {
    $ef987327cc5edb69$var$il(a, b);
    (a = a.alternate) && $ef987327cc5edb69$var$il(a, b);
}
function $ef987327cc5edb69$var$kl() {
    return null;
}
var $ef987327cc5edb69$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $ef987327cc5edb69$var$ml(a) {
    this._internalRoot = a;
}
$ef987327cc5edb69$var$nl.prototype.render = $ef987327cc5edb69$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($ef987327cc5edb69$var$p(409));
    $ef987327cc5edb69$var$gl(a, b, null, null);
};
$ef987327cc5edb69$var$nl.prototype.unmount = $ef987327cc5edb69$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $ef987327cc5edb69$var$Sk(function() {
            $ef987327cc5edb69$var$gl(null, a, null, null);
        });
        b[$ef987327cc5edb69$var$uf] = null;
    }
};
function $ef987327cc5edb69$var$nl(a) {
    this._internalRoot = a;
}
$ef987327cc5edb69$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $ef987327cc5edb69$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $ef987327cc5edb69$var$Qc.length && 0 !== b && b < $ef987327cc5edb69$var$Qc[c].priority; c++);
        $ef987327cc5edb69$var$Qc.splice(c, 0, a);
        0 === c && $ef987327cc5edb69$var$Vc(a);
    }
};
function $ef987327cc5edb69$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $ef987327cc5edb69$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $ef987327cc5edb69$var$ql() {}
function $ef987327cc5edb69$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $ef987327cc5edb69$var$hl(g);
                f.call(a);
            };
        }
        var g = $ef987327cc5edb69$var$fl(b, d, a, 0, null, !1, !1, "", $ef987327cc5edb69$var$ql);
        a._reactRootContainer = g;
        a[$ef987327cc5edb69$var$uf] = g.current;
        $ef987327cc5edb69$var$sf(8 === a.nodeType ? a.parentNode : a);
        $ef987327cc5edb69$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $ef987327cc5edb69$var$hl(k);
            h.call(a);
        };
    }
    var k = $ef987327cc5edb69$var$cl(a, 0, !1, null, null, !1, !1, "", $ef987327cc5edb69$var$ql);
    a._reactRootContainer = k;
    a[$ef987327cc5edb69$var$uf] = k.current;
    $ef987327cc5edb69$var$sf(8 === a.nodeType ? a.parentNode : a);
    $ef987327cc5edb69$var$Sk(function() {
        $ef987327cc5edb69$var$gl(b, k, c, d);
    });
    return k;
}
function $ef987327cc5edb69$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $ef987327cc5edb69$var$hl(g);
                h.call(a);
            };
        }
        $ef987327cc5edb69$var$gl(b, g, a, e);
    } else g = $ef987327cc5edb69$var$rl(c, b, a, e, d);
    return $ef987327cc5edb69$var$hl(g);
}
$ef987327cc5edb69$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $ef987327cc5edb69$var$tc(b.pendingLanes);
                0 !== c && ($ef987327cc5edb69$var$Cc(b, c | 1), $ef987327cc5edb69$var$Ek(b, $ef987327cc5edb69$var$B()), 0 === ($ef987327cc5edb69$var$K & 6) && ($ef987327cc5edb69$var$Hj = $ef987327cc5edb69$var$B() + 500, $ef987327cc5edb69$var$jg()));
            }
            break;
        case 13:
            $ef987327cc5edb69$var$Sk(function() {
                var b = $ef987327cc5edb69$var$Zg(a, 1);
                if (null !== b) {
                    var c = $ef987327cc5edb69$var$L();
                    $ef987327cc5edb69$var$mh(b, a, 1, c);
                }
            }), $ef987327cc5edb69$var$jl(a, 1);
    }
};
$ef987327cc5edb69$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $ef987327cc5edb69$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $ef987327cc5edb69$var$L();
            $ef987327cc5edb69$var$mh(b, a, 134217728, c);
        }
        $ef987327cc5edb69$var$jl(a, 134217728);
    }
};
$ef987327cc5edb69$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $ef987327cc5edb69$var$lh(a), c = $ef987327cc5edb69$var$Zg(a, b);
        if (null !== c) {
            var d = $ef987327cc5edb69$var$L();
            $ef987327cc5edb69$var$mh(c, a, b, d);
        }
        $ef987327cc5edb69$var$jl(a, b);
    }
};
$ef987327cc5edb69$var$Hc = function() {
    return $ef987327cc5edb69$var$C;
};
$ef987327cc5edb69$var$Ic = function(a, b) {
    var c = $ef987327cc5edb69$var$C;
    try {
        return $ef987327cc5edb69$var$C = a, b();
    } finally{
        $ef987327cc5edb69$var$C = c;
    }
};
$ef987327cc5edb69$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $ef987327cc5edb69$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $ef987327cc5edb69$var$Db(d);
                        if (!e) throw Error($ef987327cc5edb69$var$p(90));
                        $ef987327cc5edb69$var$Wa(d);
                        $ef987327cc5edb69$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $ef987327cc5edb69$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $ef987327cc5edb69$var$fb(a, !!c.multiple, b, !1);
    }
};
$ef987327cc5edb69$var$Gb = $ef987327cc5edb69$var$Rk;
$ef987327cc5edb69$var$Hb = $ef987327cc5edb69$var$Sk;
var $ef987327cc5edb69$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $ef987327cc5edb69$var$Cb,
        $ef987327cc5edb69$var$ue,
        $ef987327cc5edb69$var$Db,
        $ef987327cc5edb69$var$Eb,
        $ef987327cc5edb69$var$Fb,
        $ef987327cc5edb69$var$Rk
    ]
}, $ef987327cc5edb69$var$ul = {
    findFiberByHostInstance: $ef987327cc5edb69$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $ef987327cc5edb69$var$vl = {
    bundleType: $ef987327cc5edb69$var$ul.bundleType,
    version: $ef987327cc5edb69$var$ul.version,
    rendererPackageName: $ef987327cc5edb69$var$ul.rendererPackageName,
    rendererConfig: $ef987327cc5edb69$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $ef987327cc5edb69$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $ef987327cc5edb69$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $ef987327cc5edb69$var$ul.findFiberByHostInstance || $ef987327cc5edb69$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $ef987327cc5edb69$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$ef987327cc5edb69$var$wl.isDisabled && $ef987327cc5edb69$var$wl.supportsFiber) try {
        $ef987327cc5edb69$var$kc = $ef987327cc5edb69$var$wl.inject($ef987327cc5edb69$var$vl), $ef987327cc5edb69$var$lc = $ef987327cc5edb69$var$wl;
    } catch (a) {}
}
$ef987327cc5edb69$export$ae55be85d98224ed = $ef987327cc5edb69$var$tl;
$ef987327cc5edb69$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$ef987327cc5edb69$var$ol(b)) throw Error($ef987327cc5edb69$var$p(200));
    return $ef987327cc5edb69$var$dl(a, b, null, c);
};
$ef987327cc5edb69$export$882461b6382ed46c = function(a, b) {
    if (!$ef987327cc5edb69$var$ol(a)) throw Error($ef987327cc5edb69$var$p(299));
    var c = !1, d = "", e = $ef987327cc5edb69$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $ef987327cc5edb69$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$ef987327cc5edb69$var$uf] = b.current;
    $ef987327cc5edb69$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $ef987327cc5edb69$var$ml(b);
};
$ef987327cc5edb69$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($ef987327cc5edb69$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($ef987327cc5edb69$var$p(268, a));
    }
    a = $ef987327cc5edb69$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$ef987327cc5edb69$export$cd75ccfd720a3cd4 = function(a) {
    return $ef987327cc5edb69$var$Sk(a);
};
$ef987327cc5edb69$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$ef987327cc5edb69$var$pl(b)) throw Error($ef987327cc5edb69$var$p(200));
    return $ef987327cc5edb69$var$sl(null, a, b, !0, c);
};
$ef987327cc5edb69$export$757ceba2d55c277e = function(a, b, c) {
    if (!$ef987327cc5edb69$var$ol(a)) throw Error($ef987327cc5edb69$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $ef987327cc5edb69$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $ef987327cc5edb69$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$ef987327cc5edb69$var$uf] = b.current;
    $ef987327cc5edb69$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $ef987327cc5edb69$var$nl(b);
};
$ef987327cc5edb69$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$ef987327cc5edb69$var$pl(b)) throw Error($ef987327cc5edb69$var$p(200));
    return $ef987327cc5edb69$var$sl(null, a, b, !1, c);
};
$ef987327cc5edb69$export$502457920280e6be = function(a) {
    if (!$ef987327cc5edb69$var$pl(a)) throw Error($ef987327cc5edb69$var$p(40));
    return a._reactRootContainer ? ($ef987327cc5edb69$var$Sk(function() {
        $ef987327cc5edb69$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$ef987327cc5edb69$var$uf] = null;
        });
    }), !0) : !1;
};
$ef987327cc5edb69$export$c78a37762a8d58e1 = $ef987327cc5edb69$var$Rk;
$ef987327cc5edb69$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$ef987327cc5edb69$var$pl(c)) throw Error($ef987327cc5edb69$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($ef987327cc5edb69$var$p(38));
    return $ef987327cc5edb69$var$sl(a, b, c, !1, d);
};
$ef987327cc5edb69$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("frsaN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jpUiI"));

});
parcelRequire.register("jpUiI", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e22c06507235be40$export$c4744153514ff05d; }, function (v) { return $e22c06507235be40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e22c06507235be40$export$3e506c1ccc9cc1a7; }, function (v) { return $e22c06507235be40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e22c06507235be40$export$e26fe2ed2fa76875; }, function (v) { return $e22c06507235be40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e22c06507235be40$export$502329bbf4b505b1; }, function (v) { return $e22c06507235be40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e22c06507235be40$export$6e3807111c4874c4; }, function (v) { return $e22c06507235be40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e22c06507235be40$export$c27134553091fb3a; }, function (v) { return $e22c06507235be40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e22c06507235be40$export$33ee1acdc04fd2a2; }, function (v) { return $e22c06507235be40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e22c06507235be40$export$b00a404bbd5edef2; }, function (v) { return $e22c06507235be40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e22c06507235be40$export$8352ce38b91d0c62; }, function (v) { return $e22c06507235be40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e22c06507235be40$export$d66a1c1c77bd778b; }, function (v) { return $e22c06507235be40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e22c06507235be40$export$d3dfb8e4810cb555; }, function (v) { return $e22c06507235be40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e22c06507235be40$export$839f9183b0465a69; }, function (v) { return $e22c06507235be40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e22c06507235be40$export$72fdf0e06517287b; }, function (v) { return $e22c06507235be40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e22c06507235be40$export$4b844e58a3e414b4; }, function (v) { return $e22c06507235be40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e22c06507235be40$export$816d2913ae6b83b1; }, function (v) { return $e22c06507235be40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e22c06507235be40$export$61bcfe829111a1d0; }, function (v) { return $e22c06507235be40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e22c06507235be40$export$7ee8c9beb337bc3f; }, function (v) { return $e22c06507235be40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e22c06507235be40$export$b5836b71941fa3ed; }, function (v) { return $e22c06507235be40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e22c06507235be40$export$cf845f2c119da08a; }, function (v) { return $e22c06507235be40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e22c06507235be40$export$c4744153514ff05d;
var $e22c06507235be40$export$3e506c1ccc9cc1a7;
var $e22c06507235be40$export$e26fe2ed2fa76875;
var $e22c06507235be40$export$502329bbf4b505b1;
var $e22c06507235be40$export$6e3807111c4874c4;
var $e22c06507235be40$export$c27134553091fb3a;
var $e22c06507235be40$export$33ee1acdc04fd2a2;
var $e22c06507235be40$export$b00a404bbd5edef2;
var $e22c06507235be40$export$8352ce38b91d0c62;
var $e22c06507235be40$export$d66a1c1c77bd778b;
var $e22c06507235be40$export$d3dfb8e4810cb555;
var $e22c06507235be40$export$839f9183b0465a69;
var $e22c06507235be40$export$72fdf0e06517287b;
var $e22c06507235be40$export$4b844e58a3e414b4;
var $e22c06507235be40$export$816d2913ae6b83b1;
var $e22c06507235be40$export$61bcfe829111a1d0;
var $e22c06507235be40$export$7ee8c9beb337bc3f;
var $e22c06507235be40$export$b5836b71941fa3ed;
var $e22c06507235be40$export$cf845f2c119da08a;
"use strict";
function $e22c06507235be40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e22c06507235be40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e22c06507235be40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e22c06507235be40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e22c06507235be40$var$g(C, c)) n < e && 0 > $e22c06507235be40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e22c06507235be40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e22c06507235be40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e22c06507235be40$var$l = performance;
    $e22c06507235be40$export$c4744153514ff05d = function() {
        return $e22c06507235be40$var$l.now();
    };
} else {
    var $e22c06507235be40$var$p = Date, $e22c06507235be40$var$q = $e22c06507235be40$var$p.now();
    $e22c06507235be40$export$c4744153514ff05d = function() {
        return $e22c06507235be40$var$p.now() - $e22c06507235be40$var$q;
    };
}
var $e22c06507235be40$var$r = [], $e22c06507235be40$var$t = [], $e22c06507235be40$var$u = 1, $e22c06507235be40$var$v = null, $e22c06507235be40$var$y = 3, $e22c06507235be40$var$z = !1, $e22c06507235be40$var$A = !1, $e22c06507235be40$var$B = !1, $e22c06507235be40$var$D = "function" === typeof setTimeout ? setTimeout : null, $e22c06507235be40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e22c06507235be40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e22c06507235be40$var$G(a) {
    for(var b = $e22c06507235be40$var$h($e22c06507235be40$var$t); null !== b;){
        if (null === b.callback) $e22c06507235be40$var$k($e22c06507235be40$var$t);
        else if (b.startTime <= a) $e22c06507235be40$var$k($e22c06507235be40$var$t), b.sortIndex = b.expirationTime, $e22c06507235be40$var$f($e22c06507235be40$var$r, b);
        else break;
        b = $e22c06507235be40$var$h($e22c06507235be40$var$t);
    }
}
function $e22c06507235be40$var$H(a) {
    $e22c06507235be40$var$B = !1;
    $e22c06507235be40$var$G(a);
    if (!$e22c06507235be40$var$A) {
        if (null !== $e22c06507235be40$var$h($e22c06507235be40$var$r)) $e22c06507235be40$var$A = !0, $e22c06507235be40$var$I($e22c06507235be40$var$J);
        else {
            var b = $e22c06507235be40$var$h($e22c06507235be40$var$t);
            null !== b && $e22c06507235be40$var$K($e22c06507235be40$var$H, b.startTime - a);
        }
    }
}
function $e22c06507235be40$var$J(a, b) {
    $e22c06507235be40$var$A = !1;
    $e22c06507235be40$var$B && ($e22c06507235be40$var$B = !1, $e22c06507235be40$var$E($e22c06507235be40$var$L), $e22c06507235be40$var$L = -1);
    $e22c06507235be40$var$z = !0;
    var c = $e22c06507235be40$var$y;
    try {
        $e22c06507235be40$var$G(b);
        for($e22c06507235be40$var$v = $e22c06507235be40$var$h($e22c06507235be40$var$r); null !== $e22c06507235be40$var$v && (!($e22c06507235be40$var$v.expirationTime > b) || a && !$e22c06507235be40$var$M());){
            var d = $e22c06507235be40$var$v.callback;
            if ("function" === typeof d) {
                $e22c06507235be40$var$v.callback = null;
                $e22c06507235be40$var$y = $e22c06507235be40$var$v.priorityLevel;
                var e = d($e22c06507235be40$var$v.expirationTime <= b);
                b = $e22c06507235be40$export$c4744153514ff05d();
                "function" === typeof e ? $e22c06507235be40$var$v.callback = e : $e22c06507235be40$var$v === $e22c06507235be40$var$h($e22c06507235be40$var$r) && $e22c06507235be40$var$k($e22c06507235be40$var$r);
                $e22c06507235be40$var$G(b);
            } else $e22c06507235be40$var$k($e22c06507235be40$var$r);
            $e22c06507235be40$var$v = $e22c06507235be40$var$h($e22c06507235be40$var$r);
        }
        if (null !== $e22c06507235be40$var$v) var w = !0;
        else {
            var m = $e22c06507235be40$var$h($e22c06507235be40$var$t);
            null !== m && $e22c06507235be40$var$K($e22c06507235be40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e22c06507235be40$var$v = null, $e22c06507235be40$var$y = c, $e22c06507235be40$var$z = !1;
    }
}
var $e22c06507235be40$var$N = !1, $e22c06507235be40$var$O = null, $e22c06507235be40$var$L = -1, $e22c06507235be40$var$P = 5, $e22c06507235be40$var$Q = -1;
function $e22c06507235be40$var$M() {
    return $e22c06507235be40$export$c4744153514ff05d() - $e22c06507235be40$var$Q < $e22c06507235be40$var$P ? !1 : !0;
}
function $e22c06507235be40$var$R() {
    if (null !== $e22c06507235be40$var$O) {
        var a = $e22c06507235be40$export$c4744153514ff05d();
        $e22c06507235be40$var$Q = a;
        var b = !0;
        try {
            b = $e22c06507235be40$var$O(!0, a);
        } finally{
            b ? $e22c06507235be40$var$S() : ($e22c06507235be40$var$N = !1, $e22c06507235be40$var$O = null);
        }
    } else $e22c06507235be40$var$N = !1;
}
var $e22c06507235be40$var$S;
if ("function" === typeof $e22c06507235be40$var$F) $e22c06507235be40$var$S = function() {
    $e22c06507235be40$var$F($e22c06507235be40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e22c06507235be40$var$T = new MessageChannel, $e22c06507235be40$var$U = $e22c06507235be40$var$T.port2;
    $e22c06507235be40$var$T.port1.onmessage = $e22c06507235be40$var$R;
    $e22c06507235be40$var$S = function() {
        $e22c06507235be40$var$U.postMessage(null);
    };
} else $e22c06507235be40$var$S = function() {
    $e22c06507235be40$var$D($e22c06507235be40$var$R, 0);
};
function $e22c06507235be40$var$I(a) {
    $e22c06507235be40$var$O = a;
    $e22c06507235be40$var$N || ($e22c06507235be40$var$N = !0, $e22c06507235be40$var$S());
}
function $e22c06507235be40$var$K(a, b) {
    $e22c06507235be40$var$L = $e22c06507235be40$var$D(function() {
        a($e22c06507235be40$export$c4744153514ff05d());
    }, b);
}
$e22c06507235be40$export$3e506c1ccc9cc1a7 = 5;
$e22c06507235be40$export$e26fe2ed2fa76875 = 1;
$e22c06507235be40$export$502329bbf4b505b1 = 4;
$e22c06507235be40$export$6e3807111c4874c4 = 3;
$e22c06507235be40$export$c27134553091fb3a = null;
$e22c06507235be40$export$33ee1acdc04fd2a2 = 2;
$e22c06507235be40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e22c06507235be40$export$8352ce38b91d0c62 = function() {
    $e22c06507235be40$var$A || $e22c06507235be40$var$z || ($e22c06507235be40$var$A = !0, $e22c06507235be40$var$I($e22c06507235be40$var$J));
};
$e22c06507235be40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e22c06507235be40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e22c06507235be40$export$d3dfb8e4810cb555 = function() {
    return $e22c06507235be40$var$y;
};
$e22c06507235be40$export$839f9183b0465a69 = function() {
    return $e22c06507235be40$var$h($e22c06507235be40$var$r);
};
$e22c06507235be40$export$72fdf0e06517287b = function(a) {
    switch($e22c06507235be40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e22c06507235be40$var$y;
    }
    var c = $e22c06507235be40$var$y;
    $e22c06507235be40$var$y = b;
    try {
        return a();
    } finally{
        $e22c06507235be40$var$y = c;
    }
};
$e22c06507235be40$export$4b844e58a3e414b4 = function() {};
$e22c06507235be40$export$816d2913ae6b83b1 = function() {};
$e22c06507235be40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e22c06507235be40$var$y;
    $e22c06507235be40$var$y = a;
    try {
        return b();
    } finally{
        $e22c06507235be40$var$y = c;
    }
};
$e22c06507235be40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e22c06507235be40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e22c06507235be40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e22c06507235be40$var$f($e22c06507235be40$var$t, a), null === $e22c06507235be40$var$h($e22c06507235be40$var$r) && a === $e22c06507235be40$var$h($e22c06507235be40$var$t) && ($e22c06507235be40$var$B ? ($e22c06507235be40$var$E($e22c06507235be40$var$L), $e22c06507235be40$var$L = -1) : $e22c06507235be40$var$B = !0, $e22c06507235be40$var$K($e22c06507235be40$var$H, c - d))) : (a.sortIndex = e, $e22c06507235be40$var$f($e22c06507235be40$var$r, a), $e22c06507235be40$var$A || $e22c06507235be40$var$z || ($e22c06507235be40$var$A = !0, $e22c06507235be40$var$I($e22c06507235be40$var$J)));
    return a;
};
$e22c06507235be40$export$b5836b71941fa3ed = $e22c06507235be40$var$M;
$e22c06507235be40$export$cf845f2c119da08a = function(a) {
    var b = $e22c06507235be40$var$y;
    return function() {
        var c = $e22c06507235be40$var$y;
        $e22c06507235be40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e22c06507235be40$var$y = c;
        }
    };
};

});




parcelRequire.register("fR9CR", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b8b345bd4985c32f$export$2b8d127b894957b9; }, function (v) { return $b8b345bd4985c32f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b8b345bd4985c32f$export$cea3a54a6425200c; }, function (v) { return $b8b345bd4985c32f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b8b345bd4985c32f$export$a7c73072b1a182ae; }, function (v) { return $b8b345bd4985c32f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b8b345bd4985c32f$export$9f27bc3417b4524d; }, function (v) { return $b8b345bd4985c32f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b8b345bd4985c32f$export$db77ccec0bb4ccac; }, function (v) { return $b8b345bd4985c32f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b8b345bd4985c32f$export$8392c0c9d3dcbd35; }, function (v) { return $b8b345bd4985c32f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b8b345bd4985c32f$export$ffb0004e005737fa; }, function (v) { return $b8b345bd4985c32f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b8b345bd4985c32f$export$b624eff549462981; }, function (v) { return $b8b345bd4985c32f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b8b345bd4985c32f$export$7897aa7841a5380c; }, function (v) { return $b8b345bd4985c32f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b8b345bd4985c32f$export$602eac185826482c; }, function (v) { return $b8b345bd4985c32f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b8b345bd4985c32f$export$e2c29f18771995cb; }, function (v) { return $b8b345bd4985c32f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b8b345bd4985c32f$export$5f8d39834fd61797; }, function (v) { return $b8b345bd4985c32f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b8b345bd4985c32f$export$74bf444e3cd11ea5; }, function (v) { return $b8b345bd4985c32f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b8b345bd4985c32f$export$92387174baf9b227; }, function (v) { return $b8b345bd4985c32f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b8b345bd4985c32f$export$ec112efeb987d9c6; }, function (v) { return $b8b345bd4985c32f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b8b345bd4985c32f$export$b706b080d889d2c9; }, function (v) { return $b8b345bd4985c32f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b8b345bd4985c32f$export$5be5a87408f70ddc; }, function (v) { return $b8b345bd4985c32f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b8b345bd4985c32f$export$45a5e7f76e0caa8d; }, function (v) { return $b8b345bd4985c32f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b8b345bd4985c32f$export$455c2e768291efa6; }, function (v) { return $b8b345bd4985c32f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b8b345bd4985c32f$export$9522e17588c12572; }, function (v) { return $b8b345bd4985c32f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b8b345bd4985c32f$export$2110ac352bb060b9; }, function (v) { return $b8b345bd4985c32f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b8b345bd4985c32f$export$56885ab8b9c456ab; }, function (v) { return $b8b345bd4985c32f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b8b345bd4985c32f$export$d927fcb6adf8f9de; }, function (v) { return $b8b345bd4985c32f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b8b345bd4985c32f$export$b82d16f27459e05a; }, function (v) { return $b8b345bd4985c32f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b8b345bd4985c32f$export$522c17b4f5e123e8; }, function (v) { return $b8b345bd4985c32f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b8b345bd4985c32f$export$1aabd8a0274ecfd6; }, function (v) { return $b8b345bd4985c32f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b8b345bd4985c32f$export$9b621391a187a31a; }, function (v) { return $b8b345bd4985c32f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b8b345bd4985c32f$export$f5bbd400c2f4426f; }, function (v) { return $b8b345bd4985c32f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b8b345bd4985c32f$export$2b8d127b894957b9;
var $b8b345bd4985c32f$export$cea3a54a6425200c;
var $b8b345bd4985c32f$export$a7c73072b1a182ae;
var $b8b345bd4985c32f$export$9f27bc3417b4524d;
var $b8b345bd4985c32f$export$db77ccec0bb4ccac;
var $b8b345bd4985c32f$export$8392c0c9d3dcbd35;
var $b8b345bd4985c32f$export$ffb0004e005737fa;
var $b8b345bd4985c32f$export$b624eff549462981;
var $b8b345bd4985c32f$export$7897aa7841a5380c;
var $b8b345bd4985c32f$export$602eac185826482c;
var $b8b345bd4985c32f$export$e2c29f18771995cb;
var $b8b345bd4985c32f$export$5f8d39834fd61797;
var $b8b345bd4985c32f$export$74bf444e3cd11ea5;
var $b8b345bd4985c32f$export$92387174baf9b227;
var $b8b345bd4985c32f$export$ec112efeb987d9c6;
var $b8b345bd4985c32f$export$b706b080d889d2c9;
var $b8b345bd4985c32f$export$5be5a87408f70ddc;
var $b8b345bd4985c32f$export$45a5e7f76e0caa8d;
var $b8b345bd4985c32f$export$455c2e768291efa6;
var $b8b345bd4985c32f$export$9522e17588c12572;
var $b8b345bd4985c32f$export$2110ac352bb060b9;
var $b8b345bd4985c32f$export$56885ab8b9c456ab;
var $b8b345bd4985c32f$export$d927fcb6adf8f9de;
var $b8b345bd4985c32f$export$b82d16f27459e05a;
var $b8b345bd4985c32f$export$522c17b4f5e123e8;
var $b8b345bd4985c32f$export$1aabd8a0274ecfd6;
var $b8b345bd4985c32f$export$9b621391a187a31a;
var $b8b345bd4985c32f$export$f5bbd400c2f4426f;
"use strict";
var $b8b345bd4985c32f$var$b = "function" === typeof Symbol && Symbol.for, $b8b345bd4985c32f$var$c = $b8b345bd4985c32f$var$b ? Symbol.for("react.element") : 60103, $b8b345bd4985c32f$var$d = $b8b345bd4985c32f$var$b ? Symbol.for("react.portal") : 60106, $b8b345bd4985c32f$var$e = $b8b345bd4985c32f$var$b ? Symbol.for("react.fragment") : 60107, $b8b345bd4985c32f$var$f = $b8b345bd4985c32f$var$b ? Symbol.for("react.strict_mode") : 60108, $b8b345bd4985c32f$var$g = $b8b345bd4985c32f$var$b ? Symbol.for("react.profiler") : 60114, $b8b345bd4985c32f$var$h = $b8b345bd4985c32f$var$b ? Symbol.for("react.provider") : 60109, $b8b345bd4985c32f$var$k = $b8b345bd4985c32f$var$b ? Symbol.for("react.context") : 60110, $b8b345bd4985c32f$var$l = $b8b345bd4985c32f$var$b ? Symbol.for("react.async_mode") : 60111, $b8b345bd4985c32f$var$m = $b8b345bd4985c32f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b8b345bd4985c32f$var$n = $b8b345bd4985c32f$var$b ? Symbol.for("react.forward_ref") : 60112, $b8b345bd4985c32f$var$p = $b8b345bd4985c32f$var$b ? Symbol.for("react.suspense") : 60113, $b8b345bd4985c32f$var$q = $b8b345bd4985c32f$var$b ? Symbol.for("react.suspense_list") : 60120, $b8b345bd4985c32f$var$r = $b8b345bd4985c32f$var$b ? Symbol.for("react.memo") : 60115, $b8b345bd4985c32f$var$t = $b8b345bd4985c32f$var$b ? Symbol.for("react.lazy") : 60116, $b8b345bd4985c32f$var$v = $b8b345bd4985c32f$var$b ? Symbol.for("react.block") : 60121, $b8b345bd4985c32f$var$w = $b8b345bd4985c32f$var$b ? Symbol.for("react.fundamental") : 60117, $b8b345bd4985c32f$var$x = $b8b345bd4985c32f$var$b ? Symbol.for("react.responder") : 60118, $b8b345bd4985c32f$var$y = $b8b345bd4985c32f$var$b ? Symbol.for("react.scope") : 60119;
function $b8b345bd4985c32f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b8b345bd4985c32f$var$c:
                switch(a = a.type, a){
                    case $b8b345bd4985c32f$var$l:
                    case $b8b345bd4985c32f$var$m:
                    case $b8b345bd4985c32f$var$e:
                    case $b8b345bd4985c32f$var$g:
                    case $b8b345bd4985c32f$var$f:
                    case $b8b345bd4985c32f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b8b345bd4985c32f$var$k:
                            case $b8b345bd4985c32f$var$n:
                            case $b8b345bd4985c32f$var$t:
                            case $b8b345bd4985c32f$var$r:
                            case $b8b345bd4985c32f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b8b345bd4985c32f$var$d:
                return u;
        }
    }
}
function $b8b345bd4985c32f$var$A(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$m;
}
$b8b345bd4985c32f$export$2b8d127b894957b9 = $b8b345bd4985c32f$var$l;
$b8b345bd4985c32f$export$cea3a54a6425200c = $b8b345bd4985c32f$var$m;
$b8b345bd4985c32f$export$a7c73072b1a182ae = $b8b345bd4985c32f$var$k;
$b8b345bd4985c32f$export$9f27bc3417b4524d = $b8b345bd4985c32f$var$h;
$b8b345bd4985c32f$export$db77ccec0bb4ccac = $b8b345bd4985c32f$var$c;
$b8b345bd4985c32f$export$8392c0c9d3dcbd35 = $b8b345bd4985c32f$var$n;
$b8b345bd4985c32f$export$ffb0004e005737fa = $b8b345bd4985c32f$var$e;
$b8b345bd4985c32f$export$b624eff549462981 = $b8b345bd4985c32f$var$t;
$b8b345bd4985c32f$export$7897aa7841a5380c = $b8b345bd4985c32f$var$r;
$b8b345bd4985c32f$export$602eac185826482c = $b8b345bd4985c32f$var$d;
$b8b345bd4985c32f$export$e2c29f18771995cb = $b8b345bd4985c32f$var$g;
$b8b345bd4985c32f$export$5f8d39834fd61797 = $b8b345bd4985c32f$var$f;
$b8b345bd4985c32f$export$74bf444e3cd11ea5 = $b8b345bd4985c32f$var$p;
$b8b345bd4985c32f$export$92387174baf9b227 = function(a) {
    return $b8b345bd4985c32f$var$A(a) || $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$l;
};
$b8b345bd4985c32f$export$ec112efeb987d9c6 = $b8b345bd4985c32f$var$A;
$b8b345bd4985c32f$export$b706b080d889d2c9 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$k;
};
$b8b345bd4985c32f$export$5be5a87408f70ddc = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$h;
};
$b8b345bd4985c32f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b8b345bd4985c32f$var$c;
};
$b8b345bd4985c32f$export$455c2e768291efa6 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$n;
};
$b8b345bd4985c32f$export$9522e17588c12572 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$e;
};
$b8b345bd4985c32f$export$2110ac352bb060b9 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$t;
};
$b8b345bd4985c32f$export$56885ab8b9c456ab = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$r;
};
$b8b345bd4985c32f$export$d927fcb6adf8f9de = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$d;
};
$b8b345bd4985c32f$export$b82d16f27459e05a = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$g;
};
$b8b345bd4985c32f$export$522c17b4f5e123e8 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$f;
};
$b8b345bd4985c32f$export$1aabd8a0274ecfd6 = function(a) {
    return $b8b345bd4985c32f$var$z(a) === $b8b345bd4985c32f$var$p;
};
$b8b345bd4985c32f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b8b345bd4985c32f$var$e || a === $b8b345bd4985c32f$var$m || a === $b8b345bd4985c32f$var$g || a === $b8b345bd4985c32f$var$f || a === $b8b345bd4985c32f$var$p || a === $b8b345bd4985c32f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b8b345bd4985c32f$var$t || a.$$typeof === $b8b345bd4985c32f$var$r || a.$$typeof === $b8b345bd4985c32f$var$h || a.$$typeof === $b8b345bd4985c32f$var$k || a.$$typeof === $b8b345bd4985c32f$var$n || a.$$typeof === $b8b345bd4985c32f$var$w || a.$$typeof === $b8b345bd4985c32f$var$x || a.$$typeof === $b8b345bd4985c32f$var$y || a.$$typeof === $b8b345bd4985c32f$var$v);
};
$b8b345bd4985c32f$export$f5bbd400c2f4426f = $b8b345bd4985c32f$var$z;

});

parcelRequire.register("3nAsT", function(module, exports) {

var $jgVft = parcelRequire("jgVft");

var $3EjEV = parcelRequire("3EjEV");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jgVft.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $3EjEV;
module.exports = isBuffer;

});
parcelRequire.register("jgVft", function(module, exports) {

var $hGERO = parcelRequire("hGERO");
/** Detect free variable `self`. */ var $e07beb523dcc036c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e07beb523dcc036c$var$root = $hGERO || $e07beb523dcc036c$var$freeSelf || Function("return this")();
module.exports = $e07beb523dcc036c$var$root;

});
parcelRequire.register("hGERO", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ce060f3c868f3f0b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ce060f3c868f3f0b$var$freeGlobal;

});


parcelRequire.register("3EjEV", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $2a845b65a5063b4c$var$stubFalse() {
    return false;
}
module.exports = $2a845b65a5063b4c$var$stubFalse;

});


parcelRequire.register("cydsp", function(module, exports) {

var $hGERO = parcelRequire("hGERO");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $hGERO.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("4FAiI", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("bDhtX"));

});
parcelRequire.register("bDhtX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $8780e5d99aeda446$var$_tickFormat.default;
    }
});

var $8780e5d99aeda446$var$_band = $8780e5d99aeda446$var$_interopRequireWildcard((parcelRequire("l6rSk")));

var $8780e5d99aeda446$var$_identity = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("4cvsM")));

var $8780e5d99aeda446$var$_linear = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("4s2nh")));

var $8780e5d99aeda446$var$_log = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("hIWMD")));

var $8780e5d99aeda446$var$_symlog = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("9EBZE")));

var $8780e5d99aeda446$var$_ordinal = $8780e5d99aeda446$var$_interopRequireWildcard((parcelRequire("4VZkF")));

var $8780e5d99aeda446$var$_pow = $8780e5d99aeda446$var$_interopRequireWildcard((parcelRequire("6Z3ZX")));

var $8780e5d99aeda446$var$_radial = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("70DHH")));

var $8780e5d99aeda446$var$_quantile = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("2Djfy")));

var $8780e5d99aeda446$var$_quantize = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("elVIm")));

var $8780e5d99aeda446$var$_threshold = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("4LWyM")));

var $8780e5d99aeda446$var$_time = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("jI0v0")));

var $8780e5d99aeda446$var$_utcTime = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("1GFVB")));

var $8780e5d99aeda446$var$_sequential = $8780e5d99aeda446$var$_interopRequireWildcard((parcelRequire("g0Oo4")));

var $8780e5d99aeda446$var$_sequentialQuantile = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("hZyAu")));

var $8780e5d99aeda446$var$_diverging = $8780e5d99aeda446$var$_interopRequireWildcard((parcelRequire("m4DII")));

var $8780e5d99aeda446$var$_tickFormat = $8780e5d99aeda446$var$_interopRequireDefault((parcelRequire("tbdzI")));
function $8780e5d99aeda446$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8780e5d99aeda446$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8780e5d99aeda446$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8780e5d99aeda446$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8780e5d99aeda446$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("l6rSk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5cfc7ef157fcfd8$var$band;
module.exports.point = $f5cfc7ef157fcfd8$var$point;

var $1A3M6 = parcelRequire("1A3M6");

var $2n3DU = parcelRequire("2n3DU");

var $f5cfc7ef157fcfd8$var$_ordinal = $f5cfc7ef157fcfd8$var$_interopRequireDefault((parcelRequire("4VZkF")));
function $f5cfc7ef157fcfd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5cfc7ef157fcfd8$var$band() {
    var scale = (0, $f5cfc7ef157fcfd8$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $1A3M6.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $f5cfc7ef157fcfd8$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $2n3DU.initRange.apply(rescale(), arguments);
}
function $f5cfc7ef157fcfd8$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $f5cfc7ef157fcfd8$var$pointish(copy());
    };
    return scale;
}
function $f5cfc7ef157fcfd8$var$point() {
    return $f5cfc7ef157fcfd8$var$pointish($f5cfc7ef157fcfd8$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRequire.register("1A3M6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $kJ4sR.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $aEKoL.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $aEKoL.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $kJ4sR.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $kJ4sR.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $126c14d201846112$var$_zip.default;
    }
});

var $126c14d201846112$var$_bisect = $126c14d201846112$var$_interopRequireWildcard((parcelRequire("kDfX1")));

var $126c14d201846112$var$_ascending = $126c14d201846112$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $126c14d201846112$var$_bisector = $126c14d201846112$var$_interopRequireDefault((parcelRequire("gKATP")));

var $126c14d201846112$var$_count = $126c14d201846112$var$_interopRequireDefault((parcelRequire("8O42X")));

var $126c14d201846112$var$_cross = $126c14d201846112$var$_interopRequireDefault((parcelRequire("8bQHR")));

var $126c14d201846112$var$_cumsum = $126c14d201846112$var$_interopRequireDefault((parcelRequire("kAs38")));

var $126c14d201846112$var$_descending = $126c14d201846112$var$_interopRequireDefault((parcelRequire("7LP4Y")));

var $126c14d201846112$var$_deviation = $126c14d201846112$var$_interopRequireDefault((parcelRequire("8l0J0")));

var $126c14d201846112$var$_extent = $126c14d201846112$var$_interopRequireDefault((parcelRequire("335sZ")));

var $kJ4sR = parcelRequire("kJ4sR");

var $126c14d201846112$var$_group = $126c14d201846112$var$_interopRequireWildcard((parcelRequire("6gZ0Y")));

var $126c14d201846112$var$_groupSort = $126c14d201846112$var$_interopRequireDefault((parcelRequire("bm7iX")));

var $126c14d201846112$var$_bin = $126c14d201846112$var$_interopRequireDefault((parcelRequire("jY5a8")));

var $126c14d201846112$var$_freedmanDiaconis = $126c14d201846112$var$_interopRequireDefault((parcelRequire("8cux3")));

var $126c14d201846112$var$_scott = $126c14d201846112$var$_interopRequireDefault((parcelRequire("6jPew")));

var $126c14d201846112$var$_sturges = $126c14d201846112$var$_interopRequireDefault((parcelRequire("i5uuu")));

var $126c14d201846112$var$_max = $126c14d201846112$var$_interopRequireDefault((parcelRequire("f7lTD")));

var $126c14d201846112$var$_maxIndex = $126c14d201846112$var$_interopRequireDefault((parcelRequire("caJRH")));

var $126c14d201846112$var$_mean = $126c14d201846112$var$_interopRequireDefault((parcelRequire("bwrlw")));

var $126c14d201846112$var$_median = $126c14d201846112$var$_interopRequireDefault((parcelRequire("a0ihT")));

var $126c14d201846112$var$_merge = $126c14d201846112$var$_interopRequireDefault((parcelRequire("gDXa3")));

var $126c14d201846112$var$_min = $126c14d201846112$var$_interopRequireDefault((parcelRequire("1TRnd")));

var $126c14d201846112$var$_minIndex = $126c14d201846112$var$_interopRequireDefault((parcelRequire("2J770")));

var $126c14d201846112$var$_mode = $126c14d201846112$var$_interopRequireDefault((parcelRequire("7Db0k")));

var $126c14d201846112$var$_nice = $126c14d201846112$var$_interopRequireDefault((parcelRequire("9BHb8")));

var $126c14d201846112$var$_pairs = $126c14d201846112$var$_interopRequireDefault((parcelRequire("focdw")));

var $126c14d201846112$var$_permute = $126c14d201846112$var$_interopRequireDefault((parcelRequire("4kgz1")));

var $126c14d201846112$var$_quantile = $126c14d201846112$var$_interopRequireWildcard((parcelRequire("k1VCG")));

var $126c14d201846112$var$_quickselect = $126c14d201846112$var$_interopRequireDefault((parcelRequire("fmPhj")));

var $126c14d201846112$var$_range = $126c14d201846112$var$_interopRequireDefault((parcelRequire("5RVP1")));

var $126c14d201846112$var$_rank = $126c14d201846112$var$_interopRequireDefault((parcelRequire("4wNyJ")));

var $126c14d201846112$var$_least = $126c14d201846112$var$_interopRequireDefault((parcelRequire("5LxKq")));

var $126c14d201846112$var$_leastIndex = $126c14d201846112$var$_interopRequireDefault((parcelRequire("cg4u1")));

var $126c14d201846112$var$_greatest = $126c14d201846112$var$_interopRequireDefault((parcelRequire("iXDKV")));

var $126c14d201846112$var$_greatestIndex = $126c14d201846112$var$_interopRequireDefault((parcelRequire("2USlz")));

var $126c14d201846112$var$_scan = $126c14d201846112$var$_interopRequireDefault((parcelRequire("5tHEs")));

var $126c14d201846112$var$_shuffle = $126c14d201846112$var$_interopRequireWildcard((parcelRequire("4Nvil")));

var $126c14d201846112$var$_sum = $126c14d201846112$var$_interopRequireDefault((parcelRequire("6XdsT")));

var $126c14d201846112$var$_ticks = $126c14d201846112$var$_interopRequireWildcard((parcelRequire("bSZLi")));

var $126c14d201846112$var$_transpose = $126c14d201846112$var$_interopRequireDefault((parcelRequire("f65mm")));

var $126c14d201846112$var$_variance = $126c14d201846112$var$_interopRequireDefault((parcelRequire("d1rWC")));

var $126c14d201846112$var$_zip = $126c14d201846112$var$_interopRequireDefault((parcelRequire("1fgsh")));

var $126c14d201846112$var$_every = $126c14d201846112$var$_interopRequireDefault((parcelRequire("goLA0")));

var $126c14d201846112$var$_some = $126c14d201846112$var$_interopRequireDefault((parcelRequire("3FdVj")));

var $126c14d201846112$var$_filter = $126c14d201846112$var$_interopRequireDefault((parcelRequire("d92Rr")));

var $126c14d201846112$var$_map = $126c14d201846112$var$_interopRequireDefault((parcelRequire("1XfMR")));

var $126c14d201846112$var$_reduce = $126c14d201846112$var$_interopRequireDefault((parcelRequire("k98cF")));

var $126c14d201846112$var$_reverse = $126c14d201846112$var$_interopRequireDefault((parcelRequire("iz8qP")));

var $126c14d201846112$var$_sort = $126c14d201846112$var$_interopRequireDefault((parcelRequire("8YFfh")));

var $126c14d201846112$var$_difference = $126c14d201846112$var$_interopRequireDefault((parcelRequire("29wQc")));

var $126c14d201846112$var$_disjoint = $126c14d201846112$var$_interopRequireDefault((parcelRequire("chco0")));

var $126c14d201846112$var$_intersection = $126c14d201846112$var$_interopRequireDefault((parcelRequire("ghMiN")));

var $126c14d201846112$var$_subset = $126c14d201846112$var$_interopRequireDefault((parcelRequire("eOPOs")));

var $126c14d201846112$var$_superset = $126c14d201846112$var$_interopRequireDefault((parcelRequire("9shzl")));

var $126c14d201846112$var$_union = $126c14d201846112$var$_interopRequireDefault((parcelRequire("640l4")));

var $aEKoL = parcelRequire("aEKoL");
function $126c14d201846112$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $126c14d201846112$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($126c14d201846112$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $126c14d201846112$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $126c14d201846112$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("kDfX1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $f053d2b0dfd1e546$var$_ascending = $f053d2b0dfd1e546$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $f053d2b0dfd1e546$var$_bisector = $f053d2b0dfd1e546$var$_interopRequireDefault((parcelRequire("gKATP")));

var $f053d2b0dfd1e546$var$_number = $f053d2b0dfd1e546$var$_interopRequireDefault((parcelRequire("eDuSe")));
function $f053d2b0dfd1e546$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f053d2b0dfd1e546$var$ascendingBisect = (0, $f053d2b0dfd1e546$var$_bisector.default)($f053d2b0dfd1e546$var$_ascending.default);
const $f053d2b0dfd1e546$var$bisectRight = $f053d2b0dfd1e546$var$ascendingBisect.right;
module.exports.bisectRight = $f053d2b0dfd1e546$var$bisectRight;
const $f053d2b0dfd1e546$var$bisectLeft = $f053d2b0dfd1e546$var$ascendingBisect.left;
module.exports.bisectLeft = $f053d2b0dfd1e546$var$bisectLeft;
const $f053d2b0dfd1e546$var$bisectCenter = (0, $f053d2b0dfd1e546$var$_bisector.default)($f053d2b0dfd1e546$var$_number.default).center;
module.exports.bisectCenter = $f053d2b0dfd1e546$var$bisectCenter;
var $f053d2b0dfd1e546$var$_default = $f053d2b0dfd1e546$var$bisectRight;
module.exports.default = $f053d2b0dfd1e546$var$_default;

});
parcelRequire.register("1gDYV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ec64c9db2e891e4$var$ascending;
function $0ec64c9db2e891e4$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRequire.register("gKATP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c31d90b085ea1cbc$var$bisector;

var $c31d90b085ea1cbc$var$_ascending = $c31d90b085ea1cbc$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $c31d90b085ea1cbc$var$_descending = $c31d90b085ea1cbc$var$_interopRequireDefault((parcelRequire("7LP4Y")));
function $c31d90b085ea1cbc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c31d90b085ea1cbc$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $c31d90b085ea1cbc$var$_ascending.default;
        compare2 = (d, x)=>(0, $c31d90b085ea1cbc$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $c31d90b085ea1cbc$var$_ascending.default || f === $c31d90b085ea1cbc$var$_descending.default ? f : $c31d90b085ea1cbc$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $c31d90b085ea1cbc$var$zero() {
    return 0;
}

});
parcelRequire.register("7LP4Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5a848b7b0af473b8$var$descending;
function $5a848b7b0af473b8$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRequire.register("eDuSe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa7ca819bc5adace$var$number;
module.exports.numbers = $aa7ca819bc5adace$var$numbers;
function $aa7ca819bc5adace$var$number(x) {
    return x === null ? NaN : +x;
}
function* $aa7ca819bc5adace$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRequire.register("8O42X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $669621d8371182a4$var$count;
function $669621d8371182a4$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRequire.register("8bQHR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f683c31d4c50090$var$cross;
function $5f683c31d4c50090$var$length(array) {
    return array.length | 0;
}
function $5f683c31d4c50090$var$empty(length) {
    return !(length > 0);
}
function $5f683c31d4c50090$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $5f683c31d4c50090$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $5f683c31d4c50090$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $5f683c31d4c50090$var$reducer(values.pop());
    values = values.map($5f683c31d4c50090$var$arrayify);
    const lengths = values.map($5f683c31d4c50090$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($5f683c31d4c50090$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRequire.register("kAs38", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $efcced7f51eea4ff$var$cumsum;
function $efcced7f51eea4ff$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRequire.register("8l0J0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6120d8d57cefbece$var$deviation;

var $6120d8d57cefbece$var$_variance = $6120d8d57cefbece$var$_interopRequireDefault((parcelRequire("d1rWC")));
function $6120d8d57cefbece$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6120d8d57cefbece$var$deviation(values, valueof) {
    const v = (0, $6120d8d57cefbece$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRequire.register("d1rWC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97b10b90f68fdda0$var$variance;
function $97b10b90f68fdda0$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRequire.register("335sZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2385e46fd0348c29$var$extent;
function $2385e46fd0348c29$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRequire.register("kJ4sR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $f16b792e0235c36a$var$fcumsum;
module.exports.fsum = $f16b792e0235c36a$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $f16b792e0235c36a$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $f16b792e0235c36a$var$Adder;
function $f16b792e0235c36a$var$fsum(values, valueof) {
    const adder = new $f16b792e0235c36a$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $f16b792e0235c36a$var$fcumsum(values, valueof) {
    const adder = new $f16b792e0235c36a$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRequire.register("6gZ0Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $491390eea217a318$var$group;
module.exports.flatGroup = $491390eea217a318$var$flatGroup;
module.exports.flatRollup = $491390eea217a318$var$flatRollup;
module.exports.groups = $491390eea217a318$var$groups;
module.exports.index = $491390eea217a318$var$index;
module.exports.indexes = $491390eea217a318$var$indexes;
module.exports.rollup = $491390eea217a318$var$rollup;
module.exports.rollups = $491390eea217a318$var$rollups;

var $aEKoL = parcelRequire("aEKoL");

var $491390eea217a318$var$_identity = $491390eea217a318$var$_interopRequireDefault((parcelRequire("c2QEI")));
function $491390eea217a318$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $491390eea217a318$var$group(values, ...keys) {
    return $491390eea217a318$var$nest(values, $491390eea217a318$var$_identity.default, $491390eea217a318$var$_identity.default, keys);
}
function $491390eea217a318$var$groups(values, ...keys) {
    return $491390eea217a318$var$nest(values, Array.from, $491390eea217a318$var$_identity.default, keys);
}
function $491390eea217a318$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $491390eea217a318$var$flatGroup(values, ...keys) {
    return $491390eea217a318$var$flatten($491390eea217a318$var$groups(values, ...keys), keys);
}
function $491390eea217a318$var$flatRollup(values, reduce, ...keys) {
    return $491390eea217a318$var$flatten($491390eea217a318$var$rollups(values, reduce, ...keys), keys);
}
function $491390eea217a318$var$rollup(values, reduce, ...keys) {
    return $491390eea217a318$var$nest(values, $491390eea217a318$var$_identity.default, reduce, keys);
}
function $491390eea217a318$var$rollups(values, reduce, ...keys) {
    return $491390eea217a318$var$nest(values, Array.from, reduce, keys);
}
function $491390eea217a318$var$index(values, ...keys) {
    return $491390eea217a318$var$nest(values, $491390eea217a318$var$_identity.default, $491390eea217a318$var$unique, keys);
}
function $491390eea217a318$var$indexes(values, ...keys) {
    return $491390eea217a318$var$nest(values, Array.from, $491390eea217a318$var$unique, keys);
}
function $491390eea217a318$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $491390eea217a318$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $aEKoL.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRequire.register("aEKoL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $7c21a197a9d48f07$var$InternMap extends Map {
    constructor(entries, key = $7c21a197a9d48f07$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($7c21a197a9d48f07$var$intern_get(this, key));
    }
    has(key) {
        return super.has($7c21a197a9d48f07$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($7c21a197a9d48f07$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($7c21a197a9d48f07$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $7c21a197a9d48f07$var$InternMap;
class $7c21a197a9d48f07$var$InternSet extends Set {
    constructor(values, key = $7c21a197a9d48f07$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($7c21a197a9d48f07$var$intern_get(this, value));
    }
    add(value) {
        return super.add($7c21a197a9d48f07$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($7c21a197a9d48f07$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $7c21a197a9d48f07$var$InternSet;
function $7c21a197a9d48f07$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $7c21a197a9d48f07$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $7c21a197a9d48f07$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $7c21a197a9d48f07$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRequire.register("c2QEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c4e84428e28ecf2$var$identity;
function $8c4e84428e28ecf2$var$identity(x) {
    return x;
}

});


parcelRequire.register("bm7iX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84476a60d74eee07$var$groupSort;

var $84476a60d74eee07$var$_ascending = $84476a60d74eee07$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $84476a60d74eee07$var$_group = $84476a60d74eee07$var$_interopRequireWildcard((parcelRequire("6gZ0Y")));

var $84476a60d74eee07$var$_sort = $84476a60d74eee07$var$_interopRequireDefault((parcelRequire("8YFfh")));
function $84476a60d74eee07$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($84476a60d74eee07$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $84476a60d74eee07$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $84476a60d74eee07$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $84476a60d74eee07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84476a60d74eee07$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $84476a60d74eee07$var$_sort.default)((0, $84476a60d74eee07$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $84476a60d74eee07$var$_ascending.default)(av, bv) || (0, $84476a60d74eee07$var$_ascending.default)(ak, bk)) : (0, $84476a60d74eee07$var$_sort.default)((0, $84476a60d74eee07$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $84476a60d74eee07$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRequire.register("8YFfh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $6893ebcabe3d326a$var$ascendingDefined;
module.exports.compareDefined = $6893ebcabe3d326a$var$compareDefined;
module.exports.default = $6893ebcabe3d326a$var$sort;

var $6893ebcabe3d326a$var$_ascending = $6893ebcabe3d326a$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $6893ebcabe3d326a$var$_permute = $6893ebcabe3d326a$var$_interopRequireDefault((parcelRequire("4kgz1")));
function $6893ebcabe3d326a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6893ebcabe3d326a$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $6893ebcabe3d326a$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$6893ebcabe3d326a$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $6893ebcabe3d326a$var$_permute.default)(values, index);
    }
    return values.sort($6893ebcabe3d326a$var$compareDefined(f));
}
function $6893ebcabe3d326a$var$compareDefined(compare = $6893ebcabe3d326a$var$_ascending.default) {
    if (compare === $6893ebcabe3d326a$var$_ascending.default) return $6893ebcabe3d326a$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $6893ebcabe3d326a$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRequire.register("4kgz1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3265e0e7f28b9a0e$var$permute;
function $3265e0e7f28b9a0e$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRequire.register("jY5a8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e897a00e0e9da608$var$bin;

var $bZJys = parcelRequire("bZJys");

var $e897a00e0e9da608$var$_bisect = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("kDfX1")));

var $e897a00e0e9da608$var$_constant = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("91Tze")));

var $e897a00e0e9da608$var$_extent = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("335sZ")));

var $e897a00e0e9da608$var$_identity = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("c2QEI")));

var $e897a00e0e9da608$var$_nice = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("9BHb8")));

var $e897a00e0e9da608$var$_ticks = $e897a00e0e9da608$var$_interopRequireWildcard((parcelRequire("bSZLi")));

var $e897a00e0e9da608$var$_sturges = $e897a00e0e9da608$var$_interopRequireDefault((parcelRequire("i5uuu")));
function $e897a00e0e9da608$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e897a00e0e9da608$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e897a00e0e9da608$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e897a00e0e9da608$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e897a00e0e9da608$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e897a00e0e9da608$var$bin() {
    var value = $e897a00e0e9da608$var$_identity.default, domain = $e897a00e0e9da608$var$_extent.default, threshold = $e897a00e0e9da608$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $e897a00e0e9da608$var$_extent.default) [x0, x1] = (0, $e897a00e0e9da608$var$_nice.default)(x0, x1, tn);
            tz = (0, $e897a00e0e9da608$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $e897a00e0e9da608$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $e897a00e0e9da608$var$_extent.default) {
                    const step = (0, $e897a00e0e9da608$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $e897a00e0e9da608$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $e897a00e0e9da608$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $e897a00e0e9da608$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $e897a00e0e9da608$var$_constant.default)($bZJys.slice.call(_)) : (0, $e897a00e0e9da608$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRequire.register("bZJys", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $8bb8ba6cab828e19$var$array = Array.prototype;
var $8bb8ba6cab828e19$var$slice = $8bb8ba6cab828e19$var$array.slice;
module.exports.slice = $8bb8ba6cab828e19$var$slice;
var $8bb8ba6cab828e19$var$map = $8bb8ba6cab828e19$var$array.map;
module.exports.map = $8bb8ba6cab828e19$var$map;

});

parcelRequire.register("91Tze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $692f4f887dccfe98$var$constant;
function $692f4f887dccfe98$var$constant(x) {
    return ()=>x;
}

});

parcelRequire.register("9BHb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6fe91020275f1cd8$var$nice;

var $bSZLi = parcelRequire("bSZLi");
function $6fe91020275f1cd8$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $bSZLi.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRequire.register("bSZLi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a74a57497827699$var$ticks;
module.exports.tickIncrement = $8a74a57497827699$var$tickIncrement;
module.exports.tickStep = $8a74a57497827699$var$tickStep;
var $8a74a57497827699$var$e10 = Math.sqrt(50), $8a74a57497827699$var$e5 = Math.sqrt(10), $8a74a57497827699$var$e2 = Math.sqrt(2);
function $8a74a57497827699$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $8a74a57497827699$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $8a74a57497827699$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $8a74a57497827699$var$e10 ? 10 : error >= $8a74a57497827699$var$e5 ? 5 : error >= $8a74a57497827699$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $8a74a57497827699$var$e10 ? 10 : error >= $8a74a57497827699$var$e5 ? 5 : error >= $8a74a57497827699$var$e2 ? 2 : 1);
}
function $8a74a57497827699$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $8a74a57497827699$var$e10) step1 *= 10;
    else if (error >= $8a74a57497827699$var$e5) step1 *= 5;
    else if (error >= $8a74a57497827699$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRequire.register("i5uuu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2b0587169fe2116$var$thresholdSturges;

var $d2b0587169fe2116$var$_count = $d2b0587169fe2116$var$_interopRequireDefault((parcelRequire("8O42X")));
function $d2b0587169fe2116$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d2b0587169fe2116$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $d2b0587169fe2116$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRequire.register("8cux3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f8720c0607d0ab9$var$thresholdFreedmanDiaconis;

var $5f8720c0607d0ab9$var$_count = $5f8720c0607d0ab9$var$_interopRequireDefault((parcelRequire("8O42X")));

var $5f8720c0607d0ab9$var$_quantile = $5f8720c0607d0ab9$var$_interopRequireDefault((parcelRequire("k1VCG")));
function $5f8720c0607d0ab9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f8720c0607d0ab9$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $5f8720c0607d0ab9$var$_quantile.default)(values, 0.75) - (0, $5f8720c0607d0ab9$var$_quantile.default)(values, 0.25)) * Math.pow((0, $5f8720c0607d0ab9$var$_count.default)(values), -1 / 3)));
}

});
parcelRequire.register("k1VCG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e95099549a5835a6$var$quantile;
module.exports.quantileSorted = $e95099549a5835a6$var$quantileSorted;

var $e95099549a5835a6$var$_max = $e95099549a5835a6$var$_interopRequireDefault((parcelRequire("f7lTD")));

var $e95099549a5835a6$var$_min = $e95099549a5835a6$var$_interopRequireDefault((parcelRequire("1TRnd")));

var $e95099549a5835a6$var$_quickselect = $e95099549a5835a6$var$_interopRequireDefault((parcelRequire("fmPhj")));

var $e95099549a5835a6$var$_number = $e95099549a5835a6$var$_interopRequireWildcard((parcelRequire("eDuSe")));
function $e95099549a5835a6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e95099549a5835a6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e95099549a5835a6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e95099549a5835a6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e95099549a5835a6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e95099549a5835a6$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $e95099549a5835a6$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $e95099549a5835a6$var$_min.default)(values);
    if (p >= 1) return (0, $e95099549a5835a6$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $e95099549a5835a6$var$_max.default)((0, $e95099549a5835a6$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $e95099549a5835a6$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $e95099549a5835a6$var$quantileSorted(values, p, valueof = $e95099549a5835a6$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRequire.register("f7lTD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0187e98d58b39cc$var$max;
function $b0187e98d58b39cc$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRequire.register("1TRnd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1624545c677e6f37$var$min;
function $1624545c677e6f37$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRequire.register("fmPhj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b300afe3b19f4275$var$quickselect;

var $8YFfh = parcelRequire("8YFfh");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $b300afe3b19f4275$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $8YFfh.ascendingDefined : (0, $8YFfh.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $b300afe3b19f4275$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $b300afe3b19f4275$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $b300afe3b19f4275$var$swap(array, left, right);
        while(i < j){
            $b300afe3b19f4275$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $b300afe3b19f4275$var$swap(array, left, j);
        else ++j, $b300afe3b19f4275$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $b300afe3b19f4275$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRequire.register("6jPew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $499c42464645c7f0$var$thresholdScott;

var $499c42464645c7f0$var$_count = $499c42464645c7f0$var$_interopRequireDefault((parcelRequire("8O42X")));

var $499c42464645c7f0$var$_deviation = $499c42464645c7f0$var$_interopRequireDefault((parcelRequire("8l0J0")));
function $499c42464645c7f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $499c42464645c7f0$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $499c42464645c7f0$var$_count.default)(values)) / (3.49 * (0, $499c42464645c7f0$var$_deviation.default)(values)));
}

});

parcelRequire.register("caJRH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8dc9ff16810f71a3$var$maxIndex;
function $8dc9ff16810f71a3$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRequire.register("bwrlw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8637e53ee1d85b8c$var$mean;
function $8637e53ee1d85b8c$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRequire.register("a0ihT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $748816ff8c6272b4$var$median;

var $748816ff8c6272b4$var$_quantile = $748816ff8c6272b4$var$_interopRequireDefault((parcelRequire("k1VCG")));
function $748816ff8c6272b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $748816ff8c6272b4$var$median(values, valueof) {
    return (0, $748816ff8c6272b4$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRequire.register("gDXa3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1de2e05f3e2f253$var$merge;
function* $c1de2e05f3e2f253$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $c1de2e05f3e2f253$var$merge(arrays) {
    return Array.from($c1de2e05f3e2f253$var$flatten(arrays));
}

});

parcelRequire.register("2J770", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fc54d02ca40f2eb$var$minIndex;
function $1fc54d02ca40f2eb$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRequire.register("7Db0k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58e4b629edef381e$var$mode;

var $aEKoL = parcelRequire("aEKoL");
function $58e4b629edef381e$var$mode(values, valueof) {
    const counts = new $aEKoL.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRequire.register("focdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b34292fc3589f148$var$pairs;
module.exports.pair = $b34292fc3589f148$var$pair;
function $b34292fc3589f148$var$pairs(values, pairof = $b34292fc3589f148$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $b34292fc3589f148$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRequire.register("5RVP1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $011a4d70496245d2$var$range;
function $011a4d70496245d2$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRequire.register("4wNyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34c0980639fa69b8$var$rank;

var $34c0980639fa69b8$var$_ascending = $34c0980639fa69b8$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $8YFfh = parcelRequire("8YFfh");
function $34c0980639fa69b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34c0980639fa69b8$var$rank(values, valueof = $34c0980639fa69b8$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $34c0980639fa69b8$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $34c0980639fa69b8$var$_ascending.default ? (i, j)=>(0, $8YFfh.ascendingDefined)(V[i], V[j]) : (0, $8YFfh.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRequire.register("5LxKq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $432b8520163e2a53$var$least;

var $432b8520163e2a53$var$_ascending = $432b8520163e2a53$var$_interopRequireDefault((parcelRequire("1gDYV")));
function $432b8520163e2a53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $432b8520163e2a53$var$least(values, compare = $432b8520163e2a53$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $432b8520163e2a53$var$_ascending.default)(value, minValue) < 0 : (0, $432b8520163e2a53$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRequire.register("cg4u1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8eca74edbd79a808$var$leastIndex;

var $8eca74edbd79a808$var$_ascending = $8eca74edbd79a808$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $8eca74edbd79a808$var$_minIndex = $8eca74edbd79a808$var$_interopRequireDefault((parcelRequire("2J770")));
function $8eca74edbd79a808$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8eca74edbd79a808$var$leastIndex(values, compare = $8eca74edbd79a808$var$_ascending.default) {
    if (compare.length === 1) return (0, $8eca74edbd79a808$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRequire.register("iXDKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dcdc9360c5a6cdb6$var$greatest;

var $dcdc9360c5a6cdb6$var$_ascending = $dcdc9360c5a6cdb6$var$_interopRequireDefault((parcelRequire("1gDYV")));
function $dcdc9360c5a6cdb6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dcdc9360c5a6cdb6$var$greatest(values, compare = $dcdc9360c5a6cdb6$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $dcdc9360c5a6cdb6$var$_ascending.default)(value, maxValue) > 0 : (0, $dcdc9360c5a6cdb6$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRequire.register("2USlz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $21faf7ea95b5dc3d$var$greatestIndex;

var $21faf7ea95b5dc3d$var$_ascending = $21faf7ea95b5dc3d$var$_interopRequireDefault((parcelRequire("1gDYV")));

var $21faf7ea95b5dc3d$var$_maxIndex = $21faf7ea95b5dc3d$var$_interopRequireDefault((parcelRequire("caJRH")));
function $21faf7ea95b5dc3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $21faf7ea95b5dc3d$var$greatestIndex(values, compare = $21faf7ea95b5dc3d$var$_ascending.default) {
    if (compare.length === 1) return (0, $21faf7ea95b5dc3d$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRequire.register("5tHEs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fd18579bc8a6acd$var$scan;

var $3fd18579bc8a6acd$var$_leastIndex = $3fd18579bc8a6acd$var$_interopRequireDefault((parcelRequire("cg4u1")));
function $3fd18579bc8a6acd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3fd18579bc8a6acd$var$scan(values, compare) {
    const index = (0, $3fd18579bc8a6acd$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRequire.register("4Nvil", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $37e4038a02ca1503$var$shuffler;
var $37e4038a02ca1503$var$_default = $37e4038a02ca1503$var$shuffler(Math.random);
module.exports.default = $37e4038a02ca1503$var$_default;
function $37e4038a02ca1503$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRequire.register("6XdsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5102b2a0d86bcf3e$var$sum;
function $5102b2a0d86bcf3e$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRequire.register("f65mm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afdb92e2f8b99754$var$transpose;

var $afdb92e2f8b99754$var$_min = $afdb92e2f8b99754$var$_interopRequireDefault((parcelRequire("1TRnd")));
function $afdb92e2f8b99754$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $afdb92e2f8b99754$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $afdb92e2f8b99754$var$_min.default)(matrix, $afdb92e2f8b99754$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $afdb92e2f8b99754$var$length(d) {
    return d.length;
}

});

parcelRequire.register("1fgsh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e83f4c7ef7039c6$var$zip;

var $0e83f4c7ef7039c6$var$_transpose = $0e83f4c7ef7039c6$var$_interopRequireDefault((parcelRequire("f65mm")));
function $0e83f4c7ef7039c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e83f4c7ef7039c6$var$zip() {
    return (0, $0e83f4c7ef7039c6$var$_transpose.default)(arguments);
}

});

parcelRequire.register("goLA0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf03cb8dd463f8f0$var$every;
function $bf03cb8dd463f8f0$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRequire.register("3FdVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ab0005a356c884f$var$some;
function $2ab0005a356c884f$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRequire.register("d92Rr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $991e55c4c2944c6a$var$filter;
function $991e55c4c2944c6a$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRequire.register("1XfMR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $16c78c1d0fbf21a6$var$map;
function $16c78c1d0fbf21a6$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRequire.register("k98cF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eaab02f1268b1af6$var$reduce;
function $eaab02f1268b1af6$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRequire.register("iz8qP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d842093a6a266e7b$var$reverse;
function $d842093a6a266e7b$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRequire.register("29wQc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1915e58f8ffad84b$var$difference;

var $aEKoL = parcelRequire("aEKoL");
function $1915e58f8ffad84b$var$difference(values, ...others) {
    values = new $aEKoL.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRequire.register("chco0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8f00ae394ae9b01d$var$disjoint;

var $aEKoL = parcelRequire("aEKoL");
function $8f00ae394ae9b01d$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $aEKoL.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRequire.register("ghMiN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bdb3b3a7be5eeae5$var$intersection;

var $aEKoL = parcelRequire("aEKoL");
function $bdb3b3a7be5eeae5$var$intersection(values, ...others) {
    values = new $aEKoL.InternSet(values);
    others = others.map($bdb3b3a7be5eeae5$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $bdb3b3a7be5eeae5$var$set(values) {
    return values instanceof $aEKoL.InternSet ? values : new $aEKoL.InternSet(values);
}

});

parcelRequire.register("eOPOs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac9ded29f749a8eb$var$subset;

var $ac9ded29f749a8eb$var$_superset = $ac9ded29f749a8eb$var$_interopRequireDefault((parcelRequire("9shzl")));
function $ac9ded29f749a8eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ac9ded29f749a8eb$var$subset(values, other) {
    return (0, $ac9ded29f749a8eb$var$_superset.default)(other, values);
}

});
parcelRequire.register("9shzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e245b7093f88fa2$var$superset;
function $6e245b7093f88fa2$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $6e245b7093f88fa2$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $6e245b7093f88fa2$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $6e245b7093f88fa2$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRequire.register("640l4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46a36117714e0b7d$var$union;

var $aEKoL = parcelRequire("aEKoL");
function $46a36117714e0b7d$var$union(...others) {
    const set = new $aEKoL.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRequire.register("2n3DU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $1ba08e1ec6742638$var$initInterpolator;
module.exports.initRange = $1ba08e1ec6742638$var$initRange;
function $1ba08e1ec6742638$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $1ba08e1ec6742638$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRequire.register("4VZkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $397c0f9ad782497b$var$ordinal;
module.exports.implicit = void 0;

var $1A3M6 = parcelRequire("1A3M6");

var $2n3DU = parcelRequire("2n3DU");
const $397c0f9ad782497b$var$implicit = Symbol("implicit");
module.exports.implicit = $397c0f9ad782497b$var$implicit;
function $397c0f9ad782497b$var$ordinal() {
    var index = new $1A3M6.InternMap(), domain = [], range = [], unknown = $397c0f9ad782497b$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $397c0f9ad782497b$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $1A3M6.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $397c0f9ad782497b$var$ordinal(domain, range).unknown(unknown);
    };
    $2n3DU.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRequire.register("4cvsM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30f0b052984cce74$var$identity;

var $4s2nh = parcelRequire("4s2nh");

var $30f0b052984cce74$var$_number = $30f0b052984cce74$var$_interopRequireDefault((parcelRequire("2ERzY")));
function $30f0b052984cce74$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30f0b052984cce74$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $30f0b052984cce74$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $30f0b052984cce74$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $30f0b052984cce74$var$_number.default) : [
        0,
        1
    ];
    return (0, $4s2nh.linearish)(scale);
}

});
parcelRequire.register("4s2nh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $33db9e7c2f94d332$var$linear;
module.exports.linearish = $33db9e7c2f94d332$var$linearish;

var $1A3M6 = parcelRequire("1A3M6");

var $33db9e7c2f94d332$var$_continuous = $33db9e7c2f94d332$var$_interopRequireWildcard((parcelRequire("hYhGt")));

var $2n3DU = parcelRequire("2n3DU");

var $33db9e7c2f94d332$var$_tickFormat = $33db9e7c2f94d332$var$_interopRequireDefault((parcelRequire("tbdzI")));
function $33db9e7c2f94d332$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $33db9e7c2f94d332$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($33db9e7c2f94d332$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $33db9e7c2f94d332$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $33db9e7c2f94d332$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $33db9e7c2f94d332$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $1A3M6.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $33db9e7c2f94d332$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $1A3M6.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $33db9e7c2f94d332$var$linear() {
    var scale = (0, $33db9e7c2f94d332$var$_continuous.default)();
    scale.copy = function() {
        return (0, $33db9e7c2f94d332$var$_continuous.copy)(scale, $33db9e7c2f94d332$var$linear());
    };
    $2n3DU.initRange.apply(scale, arguments);
    return $33db9e7c2f94d332$var$linearish(scale);
}

});
parcelRequire.register("hYhGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $d155c1f5e94803e3$var$copy;
module.exports.default = $d155c1f5e94803e3$var$continuous;
module.exports.identity = $d155c1f5e94803e3$var$identity;
module.exports.transformer = $d155c1f5e94803e3$var$transformer;

var $1A3M6 = parcelRequire("1A3M6");

var $efgB1 = parcelRequire("efgB1");

var $d155c1f5e94803e3$var$_constant = $d155c1f5e94803e3$var$_interopRequireDefault((parcelRequire("7870o")));

var $d155c1f5e94803e3$var$_number = $d155c1f5e94803e3$var$_interopRequireDefault((parcelRequire("2ERzY")));
function $d155c1f5e94803e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d155c1f5e94803e3$var$unit = [
    0,
    1
];
function $d155c1f5e94803e3$var$identity(x) {
    return x;
}
function $d155c1f5e94803e3$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $d155c1f5e94803e3$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $d155c1f5e94803e3$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $d155c1f5e94803e3$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $d155c1f5e94803e3$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $d155c1f5e94803e3$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $d155c1f5e94803e3$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $d155c1f5e94803e3$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $1A3M6.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $d155c1f5e94803e3$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $d155c1f5e94803e3$var$transformer() {
    var domain = $d155c1f5e94803e3$var$unit, range = $d155c1f5e94803e3$var$unit, interpolate = $efgB1.interpolate, transform, untransform, unknown, clamp = $d155c1f5e94803e3$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $d155c1f5e94803e3$var$identity) clamp = $d155c1f5e94803e3$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $d155c1f5e94803e3$var$polymap : $d155c1f5e94803e3$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $efgB1.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $d155c1f5e94803e3$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $efgB1.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $d155c1f5e94803e3$var$identity, rescale()) : clamp !== $d155c1f5e94803e3$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $d155c1f5e94803e3$var$continuous() {
    return $d155c1f5e94803e3$var$transformer()($d155c1f5e94803e3$var$identity, $d155c1f5e94803e3$var$identity);
}

});
parcelRequire.register("efgB1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $252hG.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $252hG.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $a5ef570ca7f1e6a8$var$_quantize.default;
    }
});

var $a5ef570ca7f1e6a8$var$_value = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("8bYLN")));

var $a5ef570ca7f1e6a8$var$_array = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("5n5jr")));

var $a5ef570ca7f1e6a8$var$_basis = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("seI8H")));

var $a5ef570ca7f1e6a8$var$_basisClosed = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("empek")));

var $a5ef570ca7f1e6a8$var$_date = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("i2Mw0")));

var $a5ef570ca7f1e6a8$var$_discrete = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("1RNOV")));

var $a5ef570ca7f1e6a8$var$_hue = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("3xLSp")));

var $a5ef570ca7f1e6a8$var$_number = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("j3ClO")));

var $a5ef570ca7f1e6a8$var$_numberArray = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("85Uqy")));

var $a5ef570ca7f1e6a8$var$_object = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("cMroD")));

var $a5ef570ca7f1e6a8$var$_round = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("b4nqS")));

var $a5ef570ca7f1e6a8$var$_string = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("ebJuK")));

var $252hG = parcelRequire("252hG");

var $a5ef570ca7f1e6a8$var$_zoom = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("gqGVI")));

var $a5ef570ca7f1e6a8$var$_rgb = $a5ef570ca7f1e6a8$var$_interopRequireWildcard((parcelRequire("5LkpE")));

var $a5ef570ca7f1e6a8$var$_hsl = $a5ef570ca7f1e6a8$var$_interopRequireWildcard((parcelRequire("7yK2c")));

var $a5ef570ca7f1e6a8$var$_lab = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("5XCpy")));

var $a5ef570ca7f1e6a8$var$_hcl = $a5ef570ca7f1e6a8$var$_interopRequireWildcard((parcelRequire("fKBGI")));

var $a5ef570ca7f1e6a8$var$_cubehelix = $a5ef570ca7f1e6a8$var$_interopRequireWildcard((parcelRequire("go30C")));

var $a5ef570ca7f1e6a8$var$_piecewise = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("i0NTN")));

var $a5ef570ca7f1e6a8$var$_quantize = $a5ef570ca7f1e6a8$var$_interopRequireDefault((parcelRequire("1IIEv")));
function $a5ef570ca7f1e6a8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a5ef570ca7f1e6a8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a5ef570ca7f1e6a8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a5ef570ca7f1e6a8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a5ef570ca7f1e6a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("8bYLN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f6e7d748fec5d6e$var$_default;

var $dg9yh = parcelRequire("dg9yh");

var $5f6e7d748fec5d6e$var$_rgb = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("5LkpE")));

var $5n5jr = parcelRequire("5n5jr");

var $5f6e7d748fec5d6e$var$_date = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("i2Mw0")));

var $5f6e7d748fec5d6e$var$_number = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("j3ClO")));

var $5f6e7d748fec5d6e$var$_object = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("cMroD")));

var $5f6e7d748fec5d6e$var$_string = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("ebJuK")));

var $5f6e7d748fec5d6e$var$_constant = $5f6e7d748fec5d6e$var$_interopRequireDefault((parcelRequire("dYHuV")));

var $5f6e7d748fec5d6e$var$_numberArray = $5f6e7d748fec5d6e$var$_interopRequireWildcard((parcelRequire("85Uqy")));
function $5f6e7d748fec5d6e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f6e7d748fec5d6e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f6e7d748fec5d6e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f6e7d748fec5d6e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f6e7d748fec5d6e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f6e7d748fec5d6e$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $5f6e7d748fec5d6e$var$_constant.default)(b) : (t === "number" ? $5f6e7d748fec5d6e$var$_number.default : t === "string" ? (c = (0, $dg9yh.color)(b)) ? (b = c, $5f6e7d748fec5d6e$var$_rgb.default) : $5f6e7d748fec5d6e$var$_string.default : b instanceof $dg9yh.color ? $5f6e7d748fec5d6e$var$_rgb.default : b instanceof Date ? $5f6e7d748fec5d6e$var$_date.default : (0, $5f6e7d748fec5d6e$var$_numberArray.isNumberArray)(b) ? $5f6e7d748fec5d6e$var$_numberArray.default : Array.isArray(b) ? $5n5jr.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $5f6e7d748fec5d6e$var$_object.default : $5f6e7d748fec5d6e$var$_number.default)(a, b);
}

});
parcelRequire.register("dg9yh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $9a742dc6950dfd9d$var$_color.rgb;
    }
});

var $9a742dc6950dfd9d$var$_color = $9a742dc6950dfd9d$var$_interopRequireWildcard((parcelRequire("kkl9V")));

var $9a742dc6950dfd9d$var$_lab = $9a742dc6950dfd9d$var$_interopRequireWildcard((parcelRequire("3W5hX")));

var $9a742dc6950dfd9d$var$_cubehelix = $9a742dc6950dfd9d$var$_interopRequireDefault((parcelRequire("9hBfV")));
function $9a742dc6950dfd9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a742dc6950dfd9d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9a742dc6950dfd9d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9a742dc6950dfd9d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9a742dc6950dfd9d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("kkl9V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = $ecc616a48e5bde22$var$Color;
module.exports.Rgb = $ecc616a48e5bde22$var$Rgb;
module.exports.darker = module.exports.brighter = void 0;
module.exports.default = $ecc616a48e5bde22$var$color;
module.exports.hsl = $ecc616a48e5bde22$var$hsl;
module.exports.hslConvert = $ecc616a48e5bde22$var$hslConvert;
module.exports.rgb = $ecc616a48e5bde22$var$rgb;
module.exports.rgbConvert = $ecc616a48e5bde22$var$rgbConvert;

var $ecc616a48e5bde22$var$_define = $ecc616a48e5bde22$var$_interopRequireWildcard((parcelRequire("64ovI")));
function $ecc616a48e5bde22$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ecc616a48e5bde22$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ecc616a48e5bde22$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ecc616a48e5bde22$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ecc616a48e5bde22$var$Color() {}
var $ecc616a48e5bde22$var$darker = 0.7;
module.exports.darker = $ecc616a48e5bde22$var$darker;
var $ecc616a48e5bde22$var$brighter = 1 / $ecc616a48e5bde22$var$darker;
module.exports.brighter = $ecc616a48e5bde22$var$brighter;
var $ecc616a48e5bde22$var$reI = "\\s*([+-]?\\d+)\\s*", $ecc616a48e5bde22$var$reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", $ecc616a48e5bde22$var$reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $ecc616a48e5bde22$var$reHex = /^#([0-9a-f]{3,8})$/, $ecc616a48e5bde22$var$reRgbInteger = new RegExp(`^rgb\\(${$ecc616a48e5bde22$var$reI},${$ecc616a48e5bde22$var$reI},${$ecc616a48e5bde22$var$reI}\\)$`), $ecc616a48e5bde22$var$reRgbPercent = new RegExp(`^rgb\\(${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP}\\)$`), $ecc616a48e5bde22$var$reRgbaInteger = new RegExp(`^rgba\\(${$ecc616a48e5bde22$var$reI},${$ecc616a48e5bde22$var$reI},${$ecc616a48e5bde22$var$reI},${$ecc616a48e5bde22$var$reN}\\)$`), $ecc616a48e5bde22$var$reRgbaPercent = new RegExp(`^rgba\\(${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reN}\\)$`), $ecc616a48e5bde22$var$reHslPercent = new RegExp(`^hsl\\(${$ecc616a48e5bde22$var$reN},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP}\\)$`), $ecc616a48e5bde22$var$reHslaPercent = new RegExp(`^hsla\\(${$ecc616a48e5bde22$var$reN},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reP},${$ecc616a48e5bde22$var$reN}\\)$`);
var $ecc616a48e5bde22$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $ecc616a48e5bde22$var$_define.default)($ecc616a48e5bde22$var$Color, $ecc616a48e5bde22$var$color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: $ecc616a48e5bde22$var$color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $ecc616a48e5bde22$var$color_formatHex,
    formatHex8: $ecc616a48e5bde22$var$color_formatHex8,
    formatHsl: $ecc616a48e5bde22$var$color_formatHsl,
    formatRgb: $ecc616a48e5bde22$var$color_formatRgb,
    toString: $ecc616a48e5bde22$var$color_formatRgb
});
function $ecc616a48e5bde22$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $ecc616a48e5bde22$var$color_formatHex8() {
    return this.rgb().formatHex8();
}
function $ecc616a48e5bde22$var$color_formatHsl() {
    return $ecc616a48e5bde22$var$hslConvert(this).formatHsl();
}
function $ecc616a48e5bde22$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $ecc616a48e5bde22$var$color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $ecc616a48e5bde22$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $ecc616a48e5bde22$var$rgbn(m) // #ff0000
     : l === 3 ? new $ecc616a48e5bde22$var$Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $ecc616a48e5bde22$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $ecc616a48e5bde22$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $ecc616a48e5bde22$var$reRgbInteger.exec(format)) ? new $ecc616a48e5bde22$var$Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $ecc616a48e5bde22$var$reRgbPercent.exec(format)) ? new $ecc616a48e5bde22$var$Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $ecc616a48e5bde22$var$reRgbaInteger.exec(format)) ? $ecc616a48e5bde22$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $ecc616a48e5bde22$var$reRgbaPercent.exec(format)) ? $ecc616a48e5bde22$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $ecc616a48e5bde22$var$reHslPercent.exec(format)) ? $ecc616a48e5bde22$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $ecc616a48e5bde22$var$reHslaPercent.exec(format)) ? $ecc616a48e5bde22$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $ecc616a48e5bde22$var$named.hasOwnProperty(format) ? $ecc616a48e5bde22$var$rgbn($ecc616a48e5bde22$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $ecc616a48e5bde22$var$Rgb(NaN, NaN, NaN, 0) : null;
}
function $ecc616a48e5bde22$var$rgbn(n) {
    return new $ecc616a48e5bde22$var$Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $ecc616a48e5bde22$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $ecc616a48e5bde22$var$Rgb(r, g, b, a);
}
function $ecc616a48e5bde22$var$rgbConvert(o) {
    if (!(o instanceof $ecc616a48e5bde22$var$Color)) o = $ecc616a48e5bde22$var$color(o);
    if (!o) return new $ecc616a48e5bde22$var$Rgb();
    o = o.rgb();
    return new $ecc616a48e5bde22$var$Rgb(o.r, o.g, o.b, o.opacity);
}
function $ecc616a48e5bde22$var$rgb(r, g, b, opacity) {
    return arguments.length === 1 ? $ecc616a48e5bde22$var$rgbConvert(r) : new $ecc616a48e5bde22$var$Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function $ecc616a48e5bde22$var$Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $ecc616a48e5bde22$var$_define.default)($ecc616a48e5bde22$var$Rgb, $ecc616a48e5bde22$var$rgb, (0, $ecc616a48e5bde22$var$_define.extend)($ecc616a48e5bde22$var$Color, {
    brighter (k) {
        k = k == null ? $ecc616a48e5bde22$var$brighter : Math.pow($ecc616a48e5bde22$var$brighter, k);
        return new $ecc616a48e5bde22$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $ecc616a48e5bde22$var$darker : Math.pow($ecc616a48e5bde22$var$darker, k);
        return new $ecc616a48e5bde22$var$Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new $ecc616a48e5bde22$var$Rgb($ecc616a48e5bde22$var$clampi(this.r), $ecc616a48e5bde22$var$clampi(this.g), $ecc616a48e5bde22$var$clampi(this.b), $ecc616a48e5bde22$var$clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $ecc616a48e5bde22$var$rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: $ecc616a48e5bde22$var$rgb_formatHex,
    formatHex8: $ecc616a48e5bde22$var$rgb_formatHex8,
    formatRgb: $ecc616a48e5bde22$var$rgb_formatRgb,
    toString: $ecc616a48e5bde22$var$rgb_formatRgb
}));
function $ecc616a48e5bde22$var$rgb_formatHex() {
    return `#${$ecc616a48e5bde22$var$hex(this.r)}${$ecc616a48e5bde22$var$hex(this.g)}${$ecc616a48e5bde22$var$hex(this.b)}`;
}
function $ecc616a48e5bde22$var$rgb_formatHex8() {
    return `#${$ecc616a48e5bde22$var$hex(this.r)}${$ecc616a48e5bde22$var$hex(this.g)}${$ecc616a48e5bde22$var$hex(this.b)}${$ecc616a48e5bde22$var$hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function $ecc616a48e5bde22$var$rgb_formatRgb() {
    const a = $ecc616a48e5bde22$var$clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${$ecc616a48e5bde22$var$clampi(this.r)}, ${$ecc616a48e5bde22$var$clampi(this.g)}, ${$ecc616a48e5bde22$var$clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function $ecc616a48e5bde22$var$clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function $ecc616a48e5bde22$var$clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function $ecc616a48e5bde22$var$hex(value) {
    value = $ecc616a48e5bde22$var$clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $ecc616a48e5bde22$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $ecc616a48e5bde22$var$Hsl(h, s, l, a);
}
function $ecc616a48e5bde22$var$hslConvert(o) {
    if (o instanceof $ecc616a48e5bde22$var$Hsl) return new $ecc616a48e5bde22$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $ecc616a48e5bde22$var$Color)) o = $ecc616a48e5bde22$var$color(o);
    if (!o) return new $ecc616a48e5bde22$var$Hsl();
    if (o instanceof $ecc616a48e5bde22$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $ecc616a48e5bde22$var$Hsl(h, s, l, o.opacity);
}
function $ecc616a48e5bde22$var$hsl(h, s, l, opacity) {
    return arguments.length === 1 ? $ecc616a48e5bde22$var$hslConvert(h) : new $ecc616a48e5bde22$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $ecc616a48e5bde22$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ecc616a48e5bde22$var$_define.default)($ecc616a48e5bde22$var$Hsl, $ecc616a48e5bde22$var$hsl, (0, $ecc616a48e5bde22$var$_define.extend)($ecc616a48e5bde22$var$Color, {
    brighter (k) {
        k = k == null ? $ecc616a48e5bde22$var$brighter : Math.pow($ecc616a48e5bde22$var$brighter, k);
        return new $ecc616a48e5bde22$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $ecc616a48e5bde22$var$darker : Math.pow($ecc616a48e5bde22$var$darker, k);
        return new $ecc616a48e5bde22$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $ecc616a48e5bde22$var$Rgb($ecc616a48e5bde22$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $ecc616a48e5bde22$var$hsl2rgb(h, m1, m2), $ecc616a48e5bde22$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new $ecc616a48e5bde22$var$Hsl($ecc616a48e5bde22$var$clamph(this.h), $ecc616a48e5bde22$var$clampt(this.s), $ecc616a48e5bde22$var$clampt(this.l), $ecc616a48e5bde22$var$clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = $ecc616a48e5bde22$var$clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${$ecc616a48e5bde22$var$clamph(this.h)}, ${$ecc616a48e5bde22$var$clampt(this.s) * 100}%, ${$ecc616a48e5bde22$var$clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function $ecc616a48e5bde22$var$clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function $ecc616a48e5bde22$var$clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function $ecc616a48e5bde22$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRequire.register("64ovI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46b6211b40be1220$var$_default;
module.exports.extend = $46b6211b40be1220$var$extend;
function $46b6211b40be1220$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $46b6211b40be1220$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRequire.register("3W5hX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $2ddae41836c6996e$var$Hcl;
module.exports.Lab = $2ddae41836c6996e$var$Lab;
module.exports.default = $2ddae41836c6996e$var$lab;
module.exports.gray = $2ddae41836c6996e$var$gray;
module.exports.hcl = $2ddae41836c6996e$var$hcl;
module.exports.lch = $2ddae41836c6996e$var$lch;

var $2ddae41836c6996e$var$_define = $2ddae41836c6996e$var$_interopRequireWildcard((parcelRequire("64ovI")));

var $kkl9V = parcelRequire("kkl9V");

var $8fe58 = parcelRequire("8fe58");
function $2ddae41836c6996e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2ddae41836c6996e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2ddae41836c6996e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2ddae41836c6996e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $2ddae41836c6996e$var$K = 18, $2ddae41836c6996e$var$Xn = 0.96422, $2ddae41836c6996e$var$Yn = 1, $2ddae41836c6996e$var$Zn = 0.82521, $2ddae41836c6996e$var$t0 = 4 / 29, $2ddae41836c6996e$var$t1 = 6 / 29, $2ddae41836c6996e$var$t2 = 3 * $2ddae41836c6996e$var$t1 * $2ddae41836c6996e$var$t1, $2ddae41836c6996e$var$t3 = $2ddae41836c6996e$var$t1 * $2ddae41836c6996e$var$t1 * $2ddae41836c6996e$var$t1;
function $2ddae41836c6996e$var$labConvert(o) {
    if (o instanceof $2ddae41836c6996e$var$Lab) return new $2ddae41836c6996e$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $2ddae41836c6996e$var$Hcl) return $2ddae41836c6996e$var$hcl2lab(o);
    if (!(o instanceof $kkl9V.Rgb)) o = (0, $kkl9V.rgbConvert)(o);
    var r = $2ddae41836c6996e$var$rgb2lrgb(o.r), g = $2ddae41836c6996e$var$rgb2lrgb(o.g), b = $2ddae41836c6996e$var$rgb2lrgb(o.b), y = $2ddae41836c6996e$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $2ddae41836c6996e$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $2ddae41836c6996e$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $2ddae41836c6996e$var$Xn);
        z = $2ddae41836c6996e$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $2ddae41836c6996e$var$Zn);
    }
    return new $2ddae41836c6996e$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $2ddae41836c6996e$var$gray(l, opacity) {
    return new $2ddae41836c6996e$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $2ddae41836c6996e$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $2ddae41836c6996e$var$labConvert(l) : new $2ddae41836c6996e$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $2ddae41836c6996e$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $2ddae41836c6996e$var$_define.default)($2ddae41836c6996e$var$Lab, $2ddae41836c6996e$var$lab, (0, $2ddae41836c6996e$var$_define.extend)($kkl9V.Color, {
    brighter (k) {
        return new $2ddae41836c6996e$var$Lab(this.l + $2ddae41836c6996e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $2ddae41836c6996e$var$Lab(this.l - $2ddae41836c6996e$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $2ddae41836c6996e$var$Xn * $2ddae41836c6996e$var$lab2xyz(x);
        y = $2ddae41836c6996e$var$Yn * $2ddae41836c6996e$var$lab2xyz(y);
        z = $2ddae41836c6996e$var$Zn * $2ddae41836c6996e$var$lab2xyz(z);
        return new $kkl9V.Rgb($2ddae41836c6996e$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $2ddae41836c6996e$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $2ddae41836c6996e$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $2ddae41836c6996e$var$xyz2lab(t) {
    return t > $2ddae41836c6996e$var$t3 ? Math.pow(t, 1 / 3) : t / $2ddae41836c6996e$var$t2 + $2ddae41836c6996e$var$t0;
}
function $2ddae41836c6996e$var$lab2xyz(t) {
    return t > $2ddae41836c6996e$var$t1 ? t * t * t : $2ddae41836c6996e$var$t2 * (t - $2ddae41836c6996e$var$t0);
}
function $2ddae41836c6996e$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $2ddae41836c6996e$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $2ddae41836c6996e$var$hclConvert(o) {
    if (o instanceof $2ddae41836c6996e$var$Hcl) return new $2ddae41836c6996e$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $2ddae41836c6996e$var$Lab)) o = $2ddae41836c6996e$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $2ddae41836c6996e$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $8fe58.degrees;
    return new $2ddae41836c6996e$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $2ddae41836c6996e$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $2ddae41836c6996e$var$hclConvert(l) : new $2ddae41836c6996e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $2ddae41836c6996e$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $2ddae41836c6996e$var$hclConvert(h) : new $2ddae41836c6996e$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $2ddae41836c6996e$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $2ddae41836c6996e$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $2ddae41836c6996e$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $8fe58.radians;
    return new $2ddae41836c6996e$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $2ddae41836c6996e$var$_define.default)($2ddae41836c6996e$var$Hcl, $2ddae41836c6996e$var$hcl, (0, $2ddae41836c6996e$var$_define.extend)($kkl9V.Color, {
    brighter (k) {
        return new $2ddae41836c6996e$var$Hcl(this.h, this.c, this.l + $2ddae41836c6996e$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $2ddae41836c6996e$var$Hcl(this.h, this.c, this.l - $2ddae41836c6996e$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $2ddae41836c6996e$var$hcl2lab(this).rgb();
    }
}));

});
parcelRequire.register("8fe58", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $600aa5c7e5f793fd$var$radians = Math.PI / 180;
module.exports.radians = $600aa5c7e5f793fd$var$radians;
const $600aa5c7e5f793fd$var$degrees = 180 / Math.PI;
module.exports.degrees = $600aa5c7e5f793fd$var$degrees;

});


parcelRequire.register("9hBfV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $6c2299cfd33a8921$var$Cubehelix;
module.exports.default = $6c2299cfd33a8921$var$cubehelix;

var $6c2299cfd33a8921$var$_define = $6c2299cfd33a8921$var$_interopRequireWildcard((parcelRequire("64ovI")));

var $kkl9V = parcelRequire("kkl9V");

var $8fe58 = parcelRequire("8fe58");
function $6c2299cfd33a8921$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6c2299cfd33a8921$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6c2299cfd33a8921$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6c2299cfd33a8921$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $6c2299cfd33a8921$var$A = -0.14861, $6c2299cfd33a8921$var$B = 1.78277, $6c2299cfd33a8921$var$C = -0.29227, $6c2299cfd33a8921$var$D = -0.90649, $6c2299cfd33a8921$var$E = 1.97294, $6c2299cfd33a8921$var$ED = $6c2299cfd33a8921$var$E * $6c2299cfd33a8921$var$D, $6c2299cfd33a8921$var$EB = $6c2299cfd33a8921$var$E * $6c2299cfd33a8921$var$B, $6c2299cfd33a8921$var$BC_DA = $6c2299cfd33a8921$var$B * $6c2299cfd33a8921$var$C - $6c2299cfd33a8921$var$D * $6c2299cfd33a8921$var$A;
function $6c2299cfd33a8921$var$cubehelixConvert(o) {
    if (o instanceof $6c2299cfd33a8921$var$Cubehelix) return new $6c2299cfd33a8921$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $kkl9V.Rgb)) o = (0, $kkl9V.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($6c2299cfd33a8921$var$BC_DA * b + $6c2299cfd33a8921$var$ED * r - $6c2299cfd33a8921$var$EB * g) / ($6c2299cfd33a8921$var$BC_DA + $6c2299cfd33a8921$var$ED - $6c2299cfd33a8921$var$EB), bl = b - l, k = ($6c2299cfd33a8921$var$E * (g - l) - $6c2299cfd33a8921$var$C * bl) / $6c2299cfd33a8921$var$D, s = Math.sqrt(k * k + bl * bl) / ($6c2299cfd33a8921$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $8fe58.degrees - 120 : NaN;
    return new $6c2299cfd33a8921$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $6c2299cfd33a8921$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $6c2299cfd33a8921$var$cubehelixConvert(h) : new $6c2299cfd33a8921$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $6c2299cfd33a8921$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $6c2299cfd33a8921$var$_define.default)($6c2299cfd33a8921$var$Cubehelix, $6c2299cfd33a8921$var$cubehelix, (0, $6c2299cfd33a8921$var$_define.extend)($kkl9V.Color, {
    brighter (k) {
        k = k == null ? $kkl9V.brighter : Math.pow($kkl9V.brighter, k);
        return new $6c2299cfd33a8921$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $kkl9V.darker : Math.pow($kkl9V.darker, k);
        return new $6c2299cfd33a8921$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $8fe58.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $kkl9V.Rgb(255 * (l + a * ($6c2299cfd33a8921$var$A * cosh + $6c2299cfd33a8921$var$B * sinh)), 255 * (l + a * ($6c2299cfd33a8921$var$C * cosh + $6c2299cfd33a8921$var$D * sinh)), 255 * (l + a * ($6c2299cfd33a8921$var$E * cosh)), this.opacity);
    }
}));

});


parcelRequire.register("5LkpE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $dg9yh = parcelRequire("dg9yh");

var $43212d1383a3efd6$var$_basis = $43212d1383a3efd6$var$_interopRequireDefault((parcelRequire("seI8H")));

var $43212d1383a3efd6$var$_basisClosed = $43212d1383a3efd6$var$_interopRequireDefault((parcelRequire("empek")));

var $43212d1383a3efd6$var$_color = $43212d1383a3efd6$var$_interopRequireWildcard((parcelRequire("iWwtk")));
function $43212d1383a3efd6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($43212d1383a3efd6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $43212d1383a3efd6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $43212d1383a3efd6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $43212d1383a3efd6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $43212d1383a3efd6$var$_default = function rgbGamma(y) {
    var color = (0, $43212d1383a3efd6$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $dg9yh.rgb)(start)).r, (end = (0, $dg9yh.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $43212d1383a3efd6$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $43212d1383a3efd6$var$_default;
function $43212d1383a3efd6$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $dg9yh.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $43212d1383a3efd6$var$rgbBasis = $43212d1383a3efd6$var$rgbSpline($43212d1383a3efd6$var$_basis.default);
module.exports.rgbBasis = $43212d1383a3efd6$var$rgbBasis;
var $43212d1383a3efd6$var$rgbBasisClosed = $43212d1383a3efd6$var$rgbSpline($43212d1383a3efd6$var$_basisClosed.default);
module.exports.rgbBasisClosed = $43212d1383a3efd6$var$rgbBasisClosed;

});
parcelRequire.register("seI8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $054e06ec283e0382$var$basis;
module.exports.default = $054e06ec283e0382$var$_default;
function $054e06ec283e0382$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $054e06ec283e0382$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $054e06ec283e0382$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("empek", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a746b0f57897f62f$var$_default;

var $seI8H = parcelRequire("seI8H");
function $a746b0f57897f62f$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $seI8H.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRequire.register("iWwtk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dca6d5108a5c519b$var$nogamma;
module.exports.gamma = $dca6d5108a5c519b$var$gamma;
module.exports.hue = $dca6d5108a5c519b$var$hue;

var $dca6d5108a5c519b$var$_constant = $dca6d5108a5c519b$var$_interopRequireDefault((parcelRequire("dYHuV")));
function $dca6d5108a5c519b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dca6d5108a5c519b$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $dca6d5108a5c519b$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $dca6d5108a5c519b$var$hue(a, b) {
    var d = b - a;
    return d ? $dca6d5108a5c519b$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $dca6d5108a5c519b$var$_constant.default)(isNaN(a) ? b : a);
}
function $dca6d5108a5c519b$var$gamma(y) {
    return (y = +y) === 1 ? $dca6d5108a5c519b$var$nogamma : function(a, b) {
        return b - a ? $dca6d5108a5c519b$var$exponential(a, b, y) : (0, $dca6d5108a5c519b$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $dca6d5108a5c519b$var$nogamma(a, b) {
    var d = b - a;
    return d ? $dca6d5108a5c519b$var$linear(a, d) : (0, $dca6d5108a5c519b$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRequire.register("dYHuV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a2d29eb10f50e150$var$_default = (x)=>()=>x;
module.exports.default = $a2d29eb10f50e150$var$_default;

});



parcelRequire.register("5n5jr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e9338b226a057fc$var$_default;
module.exports.genericArray = $3e9338b226a057fc$var$genericArray;

var $3e9338b226a057fc$var$_value = $3e9338b226a057fc$var$_interopRequireDefault((parcelRequire("8bYLN")));

var $3e9338b226a057fc$var$_numberArray = $3e9338b226a057fc$var$_interopRequireWildcard((parcelRequire("85Uqy")));
function $3e9338b226a057fc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3e9338b226a057fc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3e9338b226a057fc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3e9338b226a057fc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $3e9338b226a057fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3e9338b226a057fc$var$_default(a, b) {
    return ((0, $3e9338b226a057fc$var$_numberArray.isNumberArray)(b) ? $3e9338b226a057fc$var$_numberArray.default : $3e9338b226a057fc$var$genericArray)(a, b);
}
function $3e9338b226a057fc$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $3e9338b226a057fc$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRequire.register("85Uqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5e4a8fa86a48b51f$var$_default;
module.exports.isNumberArray = $5e4a8fa86a48b51f$var$isNumberArray;
function $5e4a8fa86a48b51f$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $5e4a8fa86a48b51f$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRequire.register("i2Mw0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d22e0bffcbb0e2d2$var$_default;
function $d22e0bffcbb0e2d2$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRequire.register("j3ClO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ddfc0bc8b2c6ade3$var$_default;
function $ddfc0bc8b2c6ade3$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRequire.register("cMroD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94df380c5ec3d073$var$_default;

var $94df380c5ec3d073$var$_value = $94df380c5ec3d073$var$_interopRequireDefault((parcelRequire("8bYLN")));
function $94df380c5ec3d073$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94df380c5ec3d073$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $94df380c5ec3d073$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRequire.register("ebJuK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a54562234e6ecc7e$var$_default;

var $a54562234e6ecc7e$var$_number = $a54562234e6ecc7e$var$_interopRequireDefault((parcelRequire("j3ClO")));
function $a54562234e6ecc7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a54562234e6ecc7e$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $a54562234e6ecc7e$var$reB = new RegExp($a54562234e6ecc7e$var$reA.source, "g");
function $a54562234e6ecc7e$var$zero(b) {
    return function() {
        return b;
    };
}
function $a54562234e6ecc7e$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $a54562234e6ecc7e$var$_default(a, b) {
    var bi = $a54562234e6ecc7e$var$reA.lastIndex = $a54562234e6ecc7e$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $a54562234e6ecc7e$var$reA.exec(a)) && (bm = $a54562234e6ecc7e$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $a54562234e6ecc7e$var$_number.default)(am, bm)
            });
        }
        bi = $a54562234e6ecc7e$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $a54562234e6ecc7e$var$one(q[0].x) : $a54562234e6ecc7e$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRequire.register("1RNOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15c162f62ef52caa$var$_default;
function $15c162f62ef52caa$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRequire.register("3xLSp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2949977008d5cf22$var$_default;

var $iWwtk = parcelRequire("iWwtk");
function $2949977008d5cf22$var$_default(a, b) {
    var i = (0, $iWwtk.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRequire.register("b4nqS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80f23ea5215344d0$var$_default;
function $80f23ea5215344d0$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRequire.register("252hG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $183dd2018dd8950e$var$_number = $183dd2018dd8950e$var$_interopRequireDefault((parcelRequire("j3ClO")));

var $lnHrF = parcelRequire("lnHrF");
function $183dd2018dd8950e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $183dd2018dd8950e$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $183dd2018dd8950e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $183dd2018dd8950e$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $183dd2018dd8950e$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $183dd2018dd8950e$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $183dd2018dd8950e$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $183dd2018dd8950e$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $183dd2018dd8950e$var$interpolateTransformCss = $183dd2018dd8950e$var$interpolateTransform($lnHrF.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $183dd2018dd8950e$var$interpolateTransformCss;
var $183dd2018dd8950e$var$interpolateTransformSvg = $183dd2018dd8950e$var$interpolateTransform($lnHrF.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $183dd2018dd8950e$var$interpolateTransformSvg;

});
parcelRequire.register("lnHrF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $f90d72426cc6af7c$var$parseCss;
module.exports.parseSvg = $f90d72426cc6af7c$var$parseSvg;

var $f90d72426cc6af7c$var$_decompose = $f90d72426cc6af7c$var$_interopRequireWildcard((parcelRequire("1KSbo")));
function $f90d72426cc6af7c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f90d72426cc6af7c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f90d72426cc6af7c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f90d72426cc6af7c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $f90d72426cc6af7c$var$svgNode;
/* eslint-disable no-undef */ function $f90d72426cc6af7c$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $f90d72426cc6af7c$var$_decompose.identity : (0, $f90d72426cc6af7c$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $f90d72426cc6af7c$var$parseSvg(value) {
    if (value == null) return $f90d72426cc6af7c$var$_decompose.identity;
    if (!$f90d72426cc6af7c$var$svgNode) $f90d72426cc6af7c$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $f90d72426cc6af7c$var$svgNode.setAttribute("transform", value);
    if (!(value = $f90d72426cc6af7c$var$svgNode.transform.baseVal.consolidate())) return $f90d72426cc6af7c$var$_decompose.identity;
    value = value.matrix;
    return (0, $f90d72426cc6af7c$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRequire.register("1KSbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14741de7ef389cfc$var$_default;
module.exports.identity = void 0;
var $14741de7ef389cfc$var$degrees = 180 / Math.PI;
var $14741de7ef389cfc$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $14741de7ef389cfc$var$identity;
function $14741de7ef389cfc$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $14741de7ef389cfc$var$degrees,
        skewX: Math.atan(skewX) * $14741de7ef389cfc$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRequire.register("gqGVI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $bf60600afb9be61f$var$epsilon2 = 1e-12;
function $bf60600afb9be61f$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $bf60600afb9be61f$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $bf60600afb9be61f$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $bf60600afb9be61f$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $bf60600afb9be61f$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $bf60600afb9be61f$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $bf60600afb9be61f$var$tanh(rho * s + r0) - $bf60600afb9be61f$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $bf60600afb9be61f$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $bf60600afb9be61f$var$_default;

});

parcelRequire.register("7yK2c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $dg9yh = parcelRequire("dg9yh");

var $580f6adef298dde4$var$_color = $580f6adef298dde4$var$_interopRequireWildcard((parcelRequire("iWwtk")));
function $580f6adef298dde4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($580f6adef298dde4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $580f6adef298dde4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $580f6adef298dde4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $580f6adef298dde4$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $dg9yh.hsl)(start)).h, (end = (0, $dg9yh.hsl)(end)).h), s = (0, $580f6adef298dde4$var$_color.default)(start.s, end.s), l = (0, $580f6adef298dde4$var$_color.default)(start.l, end.l), opacity = (0, $580f6adef298dde4$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $580f6adef298dde4$var$_default = $580f6adef298dde4$var$hsl($580f6adef298dde4$var$_color.hue);
module.exports.default = $580f6adef298dde4$var$_default;
var $580f6adef298dde4$var$hslLong = $580f6adef298dde4$var$hsl($580f6adef298dde4$var$_color.default);
module.exports.hslLong = $580f6adef298dde4$var$hslLong;

});

parcelRequire.register("5XCpy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $457042131fce11ae$var$lab;

var $dg9yh = parcelRequire("dg9yh");

var $457042131fce11ae$var$_color = $457042131fce11ae$var$_interopRequireDefault((parcelRequire("iWwtk")));
function $457042131fce11ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $457042131fce11ae$var$lab(start, end) {
    var l = (0, $457042131fce11ae$var$_color.default)((start = (0, $dg9yh.lab)(start)).l, (end = (0, $dg9yh.lab)(end)).l), a = (0, $457042131fce11ae$var$_color.default)(start.a, end.a), b = (0, $457042131fce11ae$var$_color.default)(start.b, end.b), opacity = (0, $457042131fce11ae$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRequire.register("fKBGI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $dg9yh = parcelRequire("dg9yh");

var $b77862f5c1311e6f$var$_color = $b77862f5c1311e6f$var$_interopRequireWildcard((parcelRequire("iWwtk")));
function $b77862f5c1311e6f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b77862f5c1311e6f$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b77862f5c1311e6f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b77862f5c1311e6f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b77862f5c1311e6f$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $dg9yh.hcl)(start)).h, (end = (0, $dg9yh.hcl)(end)).h), c = (0, $b77862f5c1311e6f$var$_color.default)(start.c, end.c), l = (0, $b77862f5c1311e6f$var$_color.default)(start.l, end.l), opacity = (0, $b77862f5c1311e6f$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $b77862f5c1311e6f$var$_default = $b77862f5c1311e6f$var$hcl($b77862f5c1311e6f$var$_color.hue);
module.exports.default = $b77862f5c1311e6f$var$_default;
var $b77862f5c1311e6f$var$hclLong = $b77862f5c1311e6f$var$hcl($b77862f5c1311e6f$var$_color.default);
module.exports.hclLong = $b77862f5c1311e6f$var$hclLong;

});

parcelRequire.register("go30C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $dg9yh = parcelRequire("dg9yh");

var $bee138bbe8a4608b$var$_color = $bee138bbe8a4608b$var$_interopRequireWildcard((parcelRequire("iWwtk")));
function $bee138bbe8a4608b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bee138bbe8a4608b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bee138bbe8a4608b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bee138bbe8a4608b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bee138bbe8a4608b$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $dg9yh.cubehelix)(start)).h, (end = (0, $dg9yh.cubehelix)(end)).h), s = (0, $bee138bbe8a4608b$var$_color.default)(start.s, end.s), l = (0, $bee138bbe8a4608b$var$_color.default)(start.l, end.l), opacity = (0, $bee138bbe8a4608b$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $bee138bbe8a4608b$var$_default = $bee138bbe8a4608b$var$cubehelix($bee138bbe8a4608b$var$_color.hue);
module.exports.default = $bee138bbe8a4608b$var$_default;
var $bee138bbe8a4608b$var$cubehelixLong = $bee138bbe8a4608b$var$cubehelix($bee138bbe8a4608b$var$_color.default);
module.exports.cubehelixLong = $bee138bbe8a4608b$var$cubehelixLong;

});

parcelRequire.register("i0NTN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d1ceeef7aca5bcd8$var$piecewise;

var $d1ceeef7aca5bcd8$var$_value = $d1ceeef7aca5bcd8$var$_interopRequireDefault((parcelRequire("8bYLN")));
function $d1ceeef7aca5bcd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d1ceeef7aca5bcd8$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $d1ceeef7aca5bcd8$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRequire.register("1IIEv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $140c8986ac188c46$var$_default;
function $140c8986ac188c46$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRequire.register("7870o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $530eb6df60ee1b60$var$constants;
function $530eb6df60ee1b60$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRequire.register("2ERzY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ef8e0e4c019d349$var$number;
function $1ef8e0e4c019d349$var$number(x) {
    return +x;
}

});


parcelRequire.register("tbdzI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $057b69331eb9cf11$var$tickFormat;

var $1A3M6 = parcelRequire("1A3M6");

var $5idjn = parcelRequire("5idjn");
function $057b69331eb9cf11$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $1A3M6.tickStep)(start, stop, count), precision;
    specifier = (0, $5idjn.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $5idjn.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $5idjn.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $5idjn.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $5idjn.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $5idjn.format)(specifier);
}

});
parcelRequire.register("5idjn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $3da8f5919c5ef0f4$var$_precisionRound.default;
    }
});

var $3da8f5919c5ef0f4$var$_defaultLocale = $3da8f5919c5ef0f4$var$_interopRequireWildcard((parcelRequire("gqGmD")));

var $3da8f5919c5ef0f4$var$_locale = $3da8f5919c5ef0f4$var$_interopRequireDefault((parcelRequire("bgA3B")));

var $3da8f5919c5ef0f4$var$_formatSpecifier = $3da8f5919c5ef0f4$var$_interopRequireWildcard((parcelRequire("7psBE")));

var $3da8f5919c5ef0f4$var$_precisionFixed = $3da8f5919c5ef0f4$var$_interopRequireDefault((parcelRequire("cbQcy")));

var $3da8f5919c5ef0f4$var$_precisionPrefix = $3da8f5919c5ef0f4$var$_interopRequireDefault((parcelRequire("6SGvv")));

var $3da8f5919c5ef0f4$var$_precisionRound = $3da8f5919c5ef0f4$var$_interopRequireDefault((parcelRequire("hGhFX")));
function $3da8f5919c5ef0f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3da8f5919c5ef0f4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3da8f5919c5ef0f4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3da8f5919c5ef0f4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3da8f5919c5ef0f4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("gqGmD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bf5fefae6dbe944c$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $bf5fefae6dbe944c$var$_locale = $bf5fefae6dbe944c$var$_interopRequireDefault((parcelRequire("bgA3B")));
function $bf5fefae6dbe944c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bf5fefae6dbe944c$var$locale;
var $bf5fefae6dbe944c$var$format;
module.exports.format = $bf5fefae6dbe944c$var$format;
var $bf5fefae6dbe944c$var$formatPrefix;
module.exports.formatPrefix = $bf5fefae6dbe944c$var$formatPrefix;
$bf5fefae6dbe944c$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $bf5fefae6dbe944c$var$defaultLocale(definition) {
    $bf5fefae6dbe944c$var$locale = (0, $bf5fefae6dbe944c$var$_locale.default)(definition);
    module.exports.format = $bf5fefae6dbe944c$var$format = $bf5fefae6dbe944c$var$locale.format;
    module.exports.formatPrefix = $bf5fefae6dbe944c$var$formatPrefix = $bf5fefae6dbe944c$var$locale.formatPrefix;
    return $bf5fefae6dbe944c$var$locale;
}

});
parcelRequire.register("bgA3B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $833d28898c322ebf$var$_default;

var $833d28898c322ebf$var$_exponent = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("4lCT3")));

var $833d28898c322ebf$var$_formatGroup = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("dZE7T")));

var $833d28898c322ebf$var$_formatNumerals = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("f3PG0")));

var $833d28898c322ebf$var$_formatSpecifier = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("7psBE")));

var $833d28898c322ebf$var$_formatTrim = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("0Vig4")));

var $833d28898c322ebf$var$_formatTypes = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("lqtZz")));

var $cyv4B = parcelRequire("cyv4B");

var $833d28898c322ebf$var$_identity = $833d28898c322ebf$var$_interopRequireDefault((parcelRequire("dKrYa")));
function $833d28898c322ebf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $833d28898c322ebf$var$map = Array.prototype.map, $833d28898c322ebf$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $833d28898c322ebf$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $833d28898c322ebf$var$_identity.default : (0, $833d28898c322ebf$var$_formatGroup.default)($833d28898c322ebf$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $833d28898c322ebf$var$_identity.default : (0, $833d28898c322ebf$var$_formatNumerals.default)($833d28898c322ebf$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $833d28898c322ebf$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$833d28898c322ebf$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $833d28898c322ebf$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $833d28898c322ebf$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $833d28898c322ebf$var$prefixes[8 + $cyv4B.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $833d28898c322ebf$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $833d28898c322ebf$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $833d28898c322ebf$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRequire.register("4lCT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $32a749c0386619b5$var$_default;

var $iFVTO = parcelRequire("iFVTO");
function $32a749c0386619b5$var$_default(x) {
    return x = (0, $iFVTO.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRequire.register("iFVTO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d988f7e1645d6a88$var$_default;
module.exports.formatDecimalParts = $d988f7e1645d6a88$var$formatDecimalParts;
function $d988f7e1645d6a88$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $d988f7e1645d6a88$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRequire.register("dZE7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a300191ea5382dde$var$_default;
function $a300191ea5382dde$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRequire.register("f3PG0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af6f38b4a3430700$var$_default;
function $af6f38b4a3430700$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRequire.register("7psBE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $56510ecc7e37956c$var$FormatSpecifier;
module.exports.default = $56510ecc7e37956c$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $56510ecc7e37956c$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $56510ecc7e37956c$var$formatSpecifier(specifier) {
    if (!(match = $56510ecc7e37956c$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $56510ecc7e37956c$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$56510ecc7e37956c$var$formatSpecifier.prototype = $56510ecc7e37956c$var$FormatSpecifier.prototype; // instanceof
function $56510ecc7e37956c$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$56510ecc7e37956c$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRequire.register("0Vig4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $002c717ec19a9ea0$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $002c717ec19a9ea0$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRequire.register("lqtZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9934a8104492584$var$_formatDecimal = $f9934a8104492584$var$_interopRequireDefault((parcelRequire("iFVTO")));

var $f9934a8104492584$var$_formatPrefixAuto = $f9934a8104492584$var$_interopRequireDefault((parcelRequire("cyv4B")));

var $f9934a8104492584$var$_formatRounded = $f9934a8104492584$var$_interopRequireDefault((parcelRequire("jc8xz")));
function $f9934a8104492584$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f9934a8104492584$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $f9934a8104492584$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $f9934a8104492584$var$_formatRounded.default)(x * 100, p),
    "r": $f9934a8104492584$var$_formatRounded.default,
    "s": $f9934a8104492584$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $f9934a8104492584$var$_default;

});
parcelRequire.register("cyv4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9240c3886659c027$var$_default;
module.exports.prefixExponent = void 0;

var $iFVTO = parcelRequire("iFVTO");
var $9240c3886659c027$var$prefixExponent;
module.exports.prefixExponent = $9240c3886659c027$var$prefixExponent;
function $9240c3886659c027$var$_default(x, p) {
    var d = (0, $iFVTO.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $9240c3886659c027$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $iFVTO.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRequire.register("jc8xz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df95c343d880c4dc$var$_default;

var $iFVTO = parcelRequire("iFVTO");
function $df95c343d880c4dc$var$_default(x, p) {
    var d = (0, $iFVTO.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRequire.register("dKrYa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a025445cba1685b4$var$_default;
function $a025445cba1685b4$var$_default(x) {
    return x;
}

});



parcelRequire.register("cbQcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8dff0144c4b00911$var$_default;

var $8dff0144c4b00911$var$_exponent = $8dff0144c4b00911$var$_interopRequireDefault((parcelRequire("4lCT3")));
function $8dff0144c4b00911$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8dff0144c4b00911$var$_default(step) {
    return Math.max(0, -(0, $8dff0144c4b00911$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("6SGvv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5028c24571063ebc$var$_default;

var $5028c24571063ebc$var$_exponent = $5028c24571063ebc$var$_interopRequireDefault((parcelRequire("4lCT3")));
function $5028c24571063ebc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5028c24571063ebc$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $5028c24571063ebc$var$_exponent.default)(value) / 3))) * 3 - (0, $5028c24571063ebc$var$_exponent.default)(Math.abs(step)));
}

});

parcelRequire.register("hGhFX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cdf411ec73617258$var$_default;

var $cdf411ec73617258$var$_exponent = $cdf411ec73617258$var$_interopRequireDefault((parcelRequire("4lCT3")));
function $cdf411ec73617258$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdf411ec73617258$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $cdf411ec73617258$var$_exponent.default)(max) - (0, $cdf411ec73617258$var$_exponent.default)(step)) + 1;
}

});





parcelRequire.register("hIWMD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce7424e05d7fa153$var$log;
module.exports.loggish = $ce7424e05d7fa153$var$loggish;

var $1A3M6 = parcelRequire("1A3M6");

var $5idjn = parcelRequire("5idjn");

var $ce7424e05d7fa153$var$_nice = $ce7424e05d7fa153$var$_interopRequireDefault((parcelRequire("cQjKg")));

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");
function $ce7424e05d7fa153$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ce7424e05d7fa153$var$transformLog(x) {
    return Math.log(x);
}
function $ce7424e05d7fa153$var$transformExp(x) {
    return Math.exp(x);
}
function $ce7424e05d7fa153$var$transformLogn(x) {
    return -Math.log(-x);
}
function $ce7424e05d7fa153$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $ce7424e05d7fa153$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $ce7424e05d7fa153$var$powp(base) {
    return base === 10 ? $ce7424e05d7fa153$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $ce7424e05d7fa153$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $ce7424e05d7fa153$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $ce7424e05d7fa153$var$loggish(transform) {
    const scale = transform($ce7424e05d7fa153$var$transformLog, $ce7424e05d7fa153$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $ce7424e05d7fa153$var$logp(base), pows = $ce7424e05d7fa153$var$powp(base);
        if (domain()[0] < 0) {
            logs = $ce7424e05d7fa153$var$reflect(logs), pows = $ce7424e05d7fa153$var$reflect(pows);
            transform($ce7424e05d7fa153$var$transformLogn, $ce7424e05d7fa153$var$transformExpn);
        } else transform($ce7424e05d7fa153$var$transformLog, $ce7424e05d7fa153$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $1A3M6.ticks)(u, v, n);
        } else z = (0, $1A3M6.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $5idjn.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $5idjn.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $ce7424e05d7fa153$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $ce7424e05d7fa153$var$log() {
    const scale = $ce7424e05d7fa153$var$loggish((0, $hYhGt.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $hYhGt.copy)(scale, $ce7424e05d7fa153$var$log()).base(scale.base());
    $2n3DU.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRequire.register("cQjKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9599a85e89892938$var$nice;
function $9599a85e89892938$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRequire.register("9EBZE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7075523200a68621$var$symlog;
module.exports.symlogish = $7075523200a68621$var$symlogish;

var $4s2nh = parcelRequire("4s2nh");

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");
function $7075523200a68621$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $7075523200a68621$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $7075523200a68621$var$symlogish(transform) {
    var c = 1, scale = transform($7075523200a68621$var$transformSymlog(c), $7075523200a68621$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($7075523200a68621$var$transformSymlog(c = +_), $7075523200a68621$var$transformSymexp(c)) : c;
    };
    return (0, $4s2nh.linearish)(scale);
}
function $7075523200a68621$var$symlog() {
    var scale = $7075523200a68621$var$symlogish((0, $hYhGt.transformer)());
    scale.copy = function() {
        return (0, $hYhGt.copy)(scale, $7075523200a68621$var$symlog()).constant(scale.constant());
    };
    return $2n3DU.initRange.apply(scale, arguments);
}

});

parcelRequire.register("6Z3ZX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $515b8a8b21a237ba$var$pow;
module.exports.powish = $515b8a8b21a237ba$var$powish;
module.exports.sqrt = $515b8a8b21a237ba$var$sqrt;

var $4s2nh = parcelRequire("4s2nh");

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");
function $515b8a8b21a237ba$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $515b8a8b21a237ba$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $515b8a8b21a237ba$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $515b8a8b21a237ba$var$powish(transform) {
    var scale = transform($hYhGt.identity, $hYhGt.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($hYhGt.identity, $hYhGt.identity) : exponent === 0.5 ? transform($515b8a8b21a237ba$var$transformSqrt, $515b8a8b21a237ba$var$transformSquare) : transform($515b8a8b21a237ba$var$transformPow(exponent), $515b8a8b21a237ba$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $4s2nh.linearish)(scale);
}
function $515b8a8b21a237ba$var$pow() {
    var scale = $515b8a8b21a237ba$var$powish((0, $hYhGt.transformer)());
    scale.copy = function() {
        return (0, $hYhGt.copy)(scale, $515b8a8b21a237ba$var$pow()).exponent(scale.exponent());
    };
    $2n3DU.initRange.apply(scale, arguments);
    return scale;
}
function $515b8a8b21a237ba$var$sqrt() {
    return $515b8a8b21a237ba$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("70DHH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51a754d826fc7569$var$radial;

var $51a754d826fc7569$var$_continuous = $51a754d826fc7569$var$_interopRequireDefault((parcelRequire("hYhGt")));

var $2n3DU = parcelRequire("2n3DU");

var $4s2nh = parcelRequire("4s2nh");

var $51a754d826fc7569$var$_number = $51a754d826fc7569$var$_interopRequireDefault((parcelRequire("2ERzY")));
function $51a754d826fc7569$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $51a754d826fc7569$var$square(x) {
    return Math.sign(x) * x * x;
}
function $51a754d826fc7569$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $51a754d826fc7569$var$radial() {
    var squared = (0, $51a754d826fc7569$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $51a754d826fc7569$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($51a754d826fc7569$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $51a754d826fc7569$var$_number.default)).map($51a754d826fc7569$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $51a754d826fc7569$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $2n3DU.initRange.apply(scale, arguments);
    return (0, $4s2nh.linearish)(scale);
}

});

parcelRequire.register("2Djfy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1eae27e899fb0e28$var$quantile;

var $1A3M6 = parcelRequire("1A3M6");

var $2n3DU = parcelRequire("2n3DU");
function $1eae27e899fb0e28$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $1A3M6.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $1A3M6.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($1A3M6.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $1eae27e899fb0e28$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $2n3DU.initRange.apply(scale, arguments);
}

});

parcelRequire.register("elVIm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a72fcbc3323a9b4f$var$quantize;

var $1A3M6 = parcelRequire("1A3M6");

var $4s2nh = parcelRequire("4s2nh");

var $2n3DU = parcelRequire("2n3DU");
function $a72fcbc3323a9b4f$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $1A3M6.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a72fcbc3323a9b4f$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $2n3DU.initRange.apply((0, $4s2nh.linearish)(scale), arguments);
}

});

parcelRequire.register("4LWyM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3798f9fcbb80b844$var$threshold;

var $1A3M6 = parcelRequire("1A3M6");

var $2n3DU = parcelRequire("2n3DU");
function $3798f9fcbb80b844$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $1A3M6.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $3798f9fcbb80b844$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $2n3DU.initRange.apply(scale, arguments);
}

});

parcelRequire.register("jI0v0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $e592837ab503e6a9$var$calendar;
module.exports.default = $e592837ab503e6a9$var$time;

var $8f2QI = parcelRequire("8f2QI");

var $do7RX = parcelRequire("do7RX");

var $e592837ab503e6a9$var$_continuous = $e592837ab503e6a9$var$_interopRequireWildcard((parcelRequire("hYhGt")));

var $2n3DU = parcelRequire("2n3DU");

var $e592837ab503e6a9$var$_nice = $e592837ab503e6a9$var$_interopRequireDefault((parcelRequire("cQjKg")));
function $e592837ab503e6a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e592837ab503e6a9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e592837ab503e6a9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e592837ab503e6a9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e592837ab503e6a9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e592837ab503e6a9$var$date(t) {
    return new Date(t);
}
function $e592837ab503e6a9$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $e592837ab503e6a9$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $e592837ab503e6a9$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $e592837ab503e6a9$var$number)) : domain().map($e592837ab503e6a9$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $e592837ab503e6a9$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $e592837ab503e6a9$var$_continuous.copy)(scale, $e592837ab503e6a9$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $e592837ab503e6a9$var$time() {
    return $2n3DU.initRange.apply($e592837ab503e6a9$var$calendar($8f2QI.timeTicks, $8f2QI.timeTickInterval, $8f2QI.timeYear, $8f2QI.timeMonth, $8f2QI.timeWeek, $8f2QI.timeDay, $8f2QI.timeHour, $8f2QI.timeMinute, $8f2QI.timeSecond, $do7RX.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRequire.register("8f2QI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $b02l2.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $b02l2.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $b02l2.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $b02l2.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $b02l2.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $b02l2.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $b02l2.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $b02l2.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $b02l2.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $b02l2.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $3980q.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $3980q.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $b02l2.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $b02l2.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $b02l2.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $b02l2.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $b02l2.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $b02l2.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $3980q.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $3980q.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $fHOof.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $fHOof.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $fHOof.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $6001ef3b2caec7cc$var$_utcYear.utcYears;
    }
});

var $6001ef3b2caec7cc$var$_interval = $6001ef3b2caec7cc$var$_interopRequireDefault((parcelRequire("97NCS")));

var $6001ef3b2caec7cc$var$_millisecond = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("4dEVg")));

var $6001ef3b2caec7cc$var$_second = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("2GEk6")));

var $6001ef3b2caec7cc$var$_minute = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("6hNXX")));

var $6001ef3b2caec7cc$var$_hour = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("7o0D8")));

var $6001ef3b2caec7cc$var$_day = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("l68RS")));

var $b02l2 = parcelRequire("b02l2");

var $6001ef3b2caec7cc$var$_month = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("04d8n")));

var $6001ef3b2caec7cc$var$_year = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("2KAaZ")));

var $6001ef3b2caec7cc$var$_utcMinute = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("c3qC3")));

var $6001ef3b2caec7cc$var$_utcHour = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("kvLUo")));

var $6001ef3b2caec7cc$var$_utcDay = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("2j9dm")));

var $fHOof = parcelRequire("fHOof");

var $6001ef3b2caec7cc$var$_utcMonth = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("boo3Y")));

var $6001ef3b2caec7cc$var$_utcYear = $6001ef3b2caec7cc$var$_interopRequireWildcard((parcelRequire("ggVJq")));

var $3980q = parcelRequire("3980q");
function $6001ef3b2caec7cc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6001ef3b2caec7cc$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6001ef3b2caec7cc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6001ef3b2caec7cc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6001ef3b2caec7cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("97NCS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a4b432da6c28903$var$newInterval;
var $6a4b432da6c28903$var$t0 = new Date(), $6a4b432da6c28903$var$t1 = new Date();
function $6a4b432da6c28903$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $6a4b432da6c28903$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $6a4b432da6c28903$var$t0.setTime(+start), $6a4b432da6c28903$var$t1.setTime(+end);
            floori($6a4b432da6c28903$var$t0), floori($6a4b432da6c28903$var$t1);
            return Math.floor(count($6a4b432da6c28903$var$t0, $6a4b432da6c28903$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRequire.register("4dEVg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $31281eaef8ead535$var$_interval = $31281eaef8ead535$var$_interopRequireDefault((parcelRequire("97NCS")));
function $31281eaef8ead535$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31281eaef8ead535$var$millisecond = (0, $31281eaef8ead535$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$31281eaef8ead535$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $31281eaef8ead535$var$millisecond;
    return (0, $31281eaef8ead535$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $31281eaef8ead535$var$_default = $31281eaef8ead535$var$millisecond;
module.exports.default = $31281eaef8ead535$var$_default;
var $31281eaef8ead535$var$milliseconds = $31281eaef8ead535$var$millisecond.range;
module.exports.milliseconds = $31281eaef8ead535$var$milliseconds;

});

parcelRequire.register("2GEk6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $1f4ec85fa89cce98$var$_interval = $1f4ec85fa89cce98$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $1f4ec85fa89cce98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1f4ec85fa89cce98$var$second = (0, $1f4ec85fa89cce98$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $l449Y.durationSecond);
}, function(start, end) {
    return (end - start) / $l449Y.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $1f4ec85fa89cce98$var$_default = $1f4ec85fa89cce98$var$second;
module.exports.default = $1f4ec85fa89cce98$var$_default;
var $1f4ec85fa89cce98$var$seconds = $1f4ec85fa89cce98$var$second.range;
module.exports.seconds = $1f4ec85fa89cce98$var$seconds;

});
parcelRequire.register("l449Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $f55d32bc0fb9c3f8$var$durationSecond = 1000;
module.exports.durationSecond = $f55d32bc0fb9c3f8$var$durationSecond;
const $f55d32bc0fb9c3f8$var$durationMinute = $f55d32bc0fb9c3f8$var$durationSecond * 60;
module.exports.durationMinute = $f55d32bc0fb9c3f8$var$durationMinute;
const $f55d32bc0fb9c3f8$var$durationHour = $f55d32bc0fb9c3f8$var$durationMinute * 60;
module.exports.durationHour = $f55d32bc0fb9c3f8$var$durationHour;
const $f55d32bc0fb9c3f8$var$durationDay = $f55d32bc0fb9c3f8$var$durationHour * 24;
module.exports.durationDay = $f55d32bc0fb9c3f8$var$durationDay;
const $f55d32bc0fb9c3f8$var$durationWeek = $f55d32bc0fb9c3f8$var$durationDay * 7;
module.exports.durationWeek = $f55d32bc0fb9c3f8$var$durationWeek;
const $f55d32bc0fb9c3f8$var$durationMonth = $f55d32bc0fb9c3f8$var$durationDay * 30;
module.exports.durationMonth = $f55d32bc0fb9c3f8$var$durationMonth;
const $f55d32bc0fb9c3f8$var$durationYear = $f55d32bc0fb9c3f8$var$durationDay * 365;
module.exports.durationYear = $f55d32bc0fb9c3f8$var$durationYear;

});


parcelRequire.register("6hNXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $493b16d08791c94f$var$_interval = $493b16d08791c94f$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $493b16d08791c94f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $493b16d08791c94f$var$minute = (0, $493b16d08791c94f$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $l449Y.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $l449Y.durationMinute);
}, function(start, end) {
    return (end - start) / $l449Y.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $493b16d08791c94f$var$_default = $493b16d08791c94f$var$minute;
module.exports.default = $493b16d08791c94f$var$_default;
var $493b16d08791c94f$var$minutes = $493b16d08791c94f$var$minute.range;
module.exports.minutes = $493b16d08791c94f$var$minutes;

});

parcelRequire.register("7o0D8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $560b436f06c0bf1d$var$_interval = $560b436f06c0bf1d$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $560b436f06c0bf1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $560b436f06c0bf1d$var$hour = (0, $560b436f06c0bf1d$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $l449Y.durationSecond - date.getMinutes() * $l449Y.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $l449Y.durationHour);
}, function(start, end) {
    return (end - start) / $l449Y.durationHour;
}, function(date) {
    return date.getHours();
});
var $560b436f06c0bf1d$var$_default = $560b436f06c0bf1d$var$hour;
module.exports.default = $560b436f06c0bf1d$var$_default;
var $560b436f06c0bf1d$var$hours = $560b436f06c0bf1d$var$hour.range;
module.exports.hours = $560b436f06c0bf1d$var$hours;

});

parcelRequire.register("l68RS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $f5c1098514e86bd2$var$_interval = $f5c1098514e86bd2$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $f5c1098514e86bd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f5c1098514e86bd2$var$day = (0, $f5c1098514e86bd2$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $l449Y.durationMinute) / $l449Y.durationDay, (date)=>date.getDate() - 1);
var $f5c1098514e86bd2$var$_default = $f5c1098514e86bd2$var$day;
module.exports.default = $f5c1098514e86bd2$var$_default;
var $f5c1098514e86bd2$var$days = $f5c1098514e86bd2$var$day.range;
module.exports.days = $f5c1098514e86bd2$var$days;

});

parcelRequire.register("b02l2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $802182258a00935b$var$_interval = $802182258a00935b$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $802182258a00935b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $802182258a00935b$var$weekday(i) {
    return (0, $802182258a00935b$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $l449Y.durationMinute) / $l449Y.durationWeek;
    });
}
var $802182258a00935b$var$sunday = $802182258a00935b$var$weekday(0);
module.exports.sunday = $802182258a00935b$var$sunday;
var $802182258a00935b$var$monday = $802182258a00935b$var$weekday(1);
module.exports.monday = $802182258a00935b$var$monday;
var $802182258a00935b$var$tuesday = $802182258a00935b$var$weekday(2);
module.exports.tuesday = $802182258a00935b$var$tuesday;
var $802182258a00935b$var$wednesday = $802182258a00935b$var$weekday(3);
module.exports.wednesday = $802182258a00935b$var$wednesday;
var $802182258a00935b$var$thursday = $802182258a00935b$var$weekday(4);
module.exports.thursday = $802182258a00935b$var$thursday;
var $802182258a00935b$var$friday = $802182258a00935b$var$weekday(5);
module.exports.friday = $802182258a00935b$var$friday;
var $802182258a00935b$var$saturday = $802182258a00935b$var$weekday(6);
module.exports.saturday = $802182258a00935b$var$saturday;
var $802182258a00935b$var$sundays = $802182258a00935b$var$sunday.range;
module.exports.sundays = $802182258a00935b$var$sundays;
var $802182258a00935b$var$mondays = $802182258a00935b$var$monday.range;
module.exports.mondays = $802182258a00935b$var$mondays;
var $802182258a00935b$var$tuesdays = $802182258a00935b$var$tuesday.range;
module.exports.tuesdays = $802182258a00935b$var$tuesdays;
var $802182258a00935b$var$wednesdays = $802182258a00935b$var$wednesday.range;
module.exports.wednesdays = $802182258a00935b$var$wednesdays;
var $802182258a00935b$var$thursdays = $802182258a00935b$var$thursday.range;
module.exports.thursdays = $802182258a00935b$var$thursdays;
var $802182258a00935b$var$fridays = $802182258a00935b$var$friday.range;
module.exports.fridays = $802182258a00935b$var$fridays;
var $802182258a00935b$var$saturdays = $802182258a00935b$var$saturday.range;
module.exports.saturdays = $802182258a00935b$var$saturdays;

});

parcelRequire.register("04d8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $00ca900352b52e69$var$_interval = $00ca900352b52e69$var$_interopRequireDefault((parcelRequire("97NCS")));
function $00ca900352b52e69$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $00ca900352b52e69$var$month = (0, $00ca900352b52e69$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $00ca900352b52e69$var$_default = $00ca900352b52e69$var$month;
module.exports.default = $00ca900352b52e69$var$_default;
var $00ca900352b52e69$var$months = $00ca900352b52e69$var$month.range;
module.exports.months = $00ca900352b52e69$var$months;

});

parcelRequire.register("2KAaZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $200bf0827ba4e6d4$var$_interval = $200bf0827ba4e6d4$var$_interopRequireDefault((parcelRequire("97NCS")));
function $200bf0827ba4e6d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $200bf0827ba4e6d4$var$year = (0, $200bf0827ba4e6d4$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$200bf0827ba4e6d4$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $200bf0827ba4e6d4$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $200bf0827ba4e6d4$var$_default = $200bf0827ba4e6d4$var$year;
module.exports.default = $200bf0827ba4e6d4$var$_default;
var $200bf0827ba4e6d4$var$years = $200bf0827ba4e6d4$var$year.range;
module.exports.years = $200bf0827ba4e6d4$var$years;

});

parcelRequire.register("c3qC3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $8c6a6891a343905e$var$_interval = $8c6a6891a343905e$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $8c6a6891a343905e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8c6a6891a343905e$var$utcMinute = (0, $8c6a6891a343905e$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $l449Y.durationMinute);
}, function(start, end) {
    return (end - start) / $l449Y.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $8c6a6891a343905e$var$_default = $8c6a6891a343905e$var$utcMinute;
module.exports.default = $8c6a6891a343905e$var$_default;
var $8c6a6891a343905e$var$utcMinutes = $8c6a6891a343905e$var$utcMinute.range;
module.exports.utcMinutes = $8c6a6891a343905e$var$utcMinutes;

});

parcelRequire.register("kvLUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $eeebdd8520bb23bc$var$_interval = $eeebdd8520bb23bc$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $eeebdd8520bb23bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eeebdd8520bb23bc$var$utcHour = (0, $eeebdd8520bb23bc$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $l449Y.durationHour);
}, function(start, end) {
    return (end - start) / $l449Y.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $eeebdd8520bb23bc$var$_default = $eeebdd8520bb23bc$var$utcHour;
module.exports.default = $eeebdd8520bb23bc$var$_default;
var $eeebdd8520bb23bc$var$utcHours = $eeebdd8520bb23bc$var$utcHour.range;
module.exports.utcHours = $eeebdd8520bb23bc$var$utcHours;

});

parcelRequire.register("2j9dm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $1ae480e7a5d573b5$var$_interval = $1ae480e7a5d573b5$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $1ae480e7a5d573b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1ae480e7a5d573b5$var$utcDay = (0, $1ae480e7a5d573b5$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $l449Y.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $1ae480e7a5d573b5$var$_default = $1ae480e7a5d573b5$var$utcDay;
module.exports.default = $1ae480e7a5d573b5$var$_default;
var $1ae480e7a5d573b5$var$utcDays = $1ae480e7a5d573b5$var$utcDay.range;
module.exports.utcDays = $1ae480e7a5d573b5$var$utcDays;

});

parcelRequire.register("fHOof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $b6f1f59dbbf2742d$var$_interval = $b6f1f59dbbf2742d$var$_interopRequireDefault((parcelRequire("97NCS")));

var $l449Y = parcelRequire("l449Y");
function $b6f1f59dbbf2742d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b6f1f59dbbf2742d$var$utcWeekday(i) {
    return (0, $b6f1f59dbbf2742d$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $l449Y.durationWeek;
    });
}
var $b6f1f59dbbf2742d$var$utcSunday = $b6f1f59dbbf2742d$var$utcWeekday(0);
module.exports.utcSunday = $b6f1f59dbbf2742d$var$utcSunday;
var $b6f1f59dbbf2742d$var$utcMonday = $b6f1f59dbbf2742d$var$utcWeekday(1);
module.exports.utcMonday = $b6f1f59dbbf2742d$var$utcMonday;
var $b6f1f59dbbf2742d$var$utcTuesday = $b6f1f59dbbf2742d$var$utcWeekday(2);
module.exports.utcTuesday = $b6f1f59dbbf2742d$var$utcTuesday;
var $b6f1f59dbbf2742d$var$utcWednesday = $b6f1f59dbbf2742d$var$utcWeekday(3);
module.exports.utcWednesday = $b6f1f59dbbf2742d$var$utcWednesday;
var $b6f1f59dbbf2742d$var$utcThursday = $b6f1f59dbbf2742d$var$utcWeekday(4);
module.exports.utcThursday = $b6f1f59dbbf2742d$var$utcThursday;
var $b6f1f59dbbf2742d$var$utcFriday = $b6f1f59dbbf2742d$var$utcWeekday(5);
module.exports.utcFriday = $b6f1f59dbbf2742d$var$utcFriday;
var $b6f1f59dbbf2742d$var$utcSaturday = $b6f1f59dbbf2742d$var$utcWeekday(6);
module.exports.utcSaturday = $b6f1f59dbbf2742d$var$utcSaturday;
var $b6f1f59dbbf2742d$var$utcSundays = $b6f1f59dbbf2742d$var$utcSunday.range;
module.exports.utcSundays = $b6f1f59dbbf2742d$var$utcSundays;
var $b6f1f59dbbf2742d$var$utcMondays = $b6f1f59dbbf2742d$var$utcMonday.range;
module.exports.utcMondays = $b6f1f59dbbf2742d$var$utcMondays;
var $b6f1f59dbbf2742d$var$utcTuesdays = $b6f1f59dbbf2742d$var$utcTuesday.range;
module.exports.utcTuesdays = $b6f1f59dbbf2742d$var$utcTuesdays;
var $b6f1f59dbbf2742d$var$utcWednesdays = $b6f1f59dbbf2742d$var$utcWednesday.range;
module.exports.utcWednesdays = $b6f1f59dbbf2742d$var$utcWednesdays;
var $b6f1f59dbbf2742d$var$utcThursdays = $b6f1f59dbbf2742d$var$utcThursday.range;
module.exports.utcThursdays = $b6f1f59dbbf2742d$var$utcThursdays;
var $b6f1f59dbbf2742d$var$utcFridays = $b6f1f59dbbf2742d$var$utcFriday.range;
module.exports.utcFridays = $b6f1f59dbbf2742d$var$utcFridays;
var $b6f1f59dbbf2742d$var$utcSaturdays = $b6f1f59dbbf2742d$var$utcSaturday.range;
module.exports.utcSaturdays = $b6f1f59dbbf2742d$var$utcSaturdays;

});

parcelRequire.register("boo3Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $84b49a089e72e8e3$var$_interval = $84b49a089e72e8e3$var$_interopRequireDefault((parcelRequire("97NCS")));
function $84b49a089e72e8e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $84b49a089e72e8e3$var$utcMonth = (0, $84b49a089e72e8e3$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $84b49a089e72e8e3$var$_default = $84b49a089e72e8e3$var$utcMonth;
module.exports.default = $84b49a089e72e8e3$var$_default;
var $84b49a089e72e8e3$var$utcMonths = $84b49a089e72e8e3$var$utcMonth.range;
module.exports.utcMonths = $84b49a089e72e8e3$var$utcMonths;

});

parcelRequire.register("ggVJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $bd8aec46574a9d22$var$_interval = $bd8aec46574a9d22$var$_interopRequireDefault((parcelRequire("97NCS")));
function $bd8aec46574a9d22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bd8aec46574a9d22$var$utcYear = (0, $bd8aec46574a9d22$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$bd8aec46574a9d22$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $bd8aec46574a9d22$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $bd8aec46574a9d22$var$_default = $bd8aec46574a9d22$var$utcYear;
module.exports.default = $bd8aec46574a9d22$var$_default;
var $bd8aec46574a9d22$var$utcYears = $bd8aec46574a9d22$var$utcYear.range;
module.exports.utcYears = $bd8aec46574a9d22$var$utcYears;

});

parcelRequire.register("3980q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $1A3M6 = parcelRequire("1A3M6");

var $l449Y = parcelRequire("l449Y");

var $24a86c2409cdf9ba$var$_millisecond = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("4dEVg")));

var $24a86c2409cdf9ba$var$_second = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("2GEk6")));

var $24a86c2409cdf9ba$var$_minute = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("6hNXX")));

var $24a86c2409cdf9ba$var$_hour = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("7o0D8")));

var $24a86c2409cdf9ba$var$_day = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("l68RS")));

var $b02l2 = parcelRequire("b02l2");

var $24a86c2409cdf9ba$var$_month = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("04d8n")));

var $24a86c2409cdf9ba$var$_year = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("2KAaZ")));

var $24a86c2409cdf9ba$var$_utcMinute = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("c3qC3")));

var $24a86c2409cdf9ba$var$_utcHour = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("kvLUo")));

var $24a86c2409cdf9ba$var$_utcDay = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("2j9dm")));

var $fHOof = parcelRequire("fHOof");

var $24a86c2409cdf9ba$var$_utcMonth = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("boo3Y")));

var $24a86c2409cdf9ba$var$_utcYear = $24a86c2409cdf9ba$var$_interopRequireDefault((parcelRequire("ggVJq")));
function $24a86c2409cdf9ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24a86c2409cdf9ba$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $24a86c2409cdf9ba$var$_second.default,
            1,
            $l449Y.durationSecond
        ],
        [
            $24a86c2409cdf9ba$var$_second.default,
            5,
            5 * $l449Y.durationSecond
        ],
        [
            $24a86c2409cdf9ba$var$_second.default,
            15,
            15 * $l449Y.durationSecond
        ],
        [
            $24a86c2409cdf9ba$var$_second.default,
            30,
            30 * $l449Y.durationSecond
        ],
        [
            minute,
            1,
            $l449Y.durationMinute
        ],
        [
            minute,
            5,
            5 * $l449Y.durationMinute
        ],
        [
            minute,
            15,
            15 * $l449Y.durationMinute
        ],
        [
            minute,
            30,
            30 * $l449Y.durationMinute
        ],
        [
            hour,
            1,
            $l449Y.durationHour
        ],
        [
            hour,
            3,
            3 * $l449Y.durationHour
        ],
        [
            hour,
            6,
            6 * $l449Y.durationHour
        ],
        [
            hour,
            12,
            12 * $l449Y.durationHour
        ],
        [
            day,
            1,
            $l449Y.durationDay
        ],
        [
            day,
            2,
            2 * $l449Y.durationDay
        ],
        [
            week,
            1,
            $l449Y.durationWeek
        ],
        [
            month,
            1,
            $l449Y.durationMonth
        ],
        [
            month,
            3,
            3 * $l449Y.durationMonth
        ],
        [
            year,
            1,
            $l449Y.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $1A3M6.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $1A3M6.tickStep)(start / $l449Y.durationYear, stop / $l449Y.durationYear, count));
        if (i === 0) return $24a86c2409cdf9ba$var$_millisecond.default.every(Math.max((0, $1A3M6.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$24a86c2409cdf9ba$var$utcTicks, $24a86c2409cdf9ba$var$utcTickInterval] = $24a86c2409cdf9ba$var$ticker($24a86c2409cdf9ba$var$_utcYear.default, $24a86c2409cdf9ba$var$_utcMonth.default, $fHOof.utcSunday, $24a86c2409cdf9ba$var$_utcDay.default, $24a86c2409cdf9ba$var$_utcHour.default, $24a86c2409cdf9ba$var$_utcMinute.default);
module.exports.utcTickInterval = $24a86c2409cdf9ba$var$utcTickInterval;
module.exports.utcTicks = $24a86c2409cdf9ba$var$utcTicks;
const [$24a86c2409cdf9ba$var$timeTicks, $24a86c2409cdf9ba$var$timeTickInterval] = $24a86c2409cdf9ba$var$ticker($24a86c2409cdf9ba$var$_year.default, $24a86c2409cdf9ba$var$_month.default, $b02l2.sunday, $24a86c2409cdf9ba$var$_day.default, $24a86c2409cdf9ba$var$_hour.default, $24a86c2409cdf9ba$var$_minute.default);
module.exports.timeTickInterval = $24a86c2409cdf9ba$var$timeTickInterval;
module.exports.timeTicks = $24a86c2409cdf9ba$var$timeTicks;

});


parcelRequire.register("do7RX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $9bf39eea1aa29c83$var$_defaultLocale.utcParse;
    }
});

var $9bf39eea1aa29c83$var$_defaultLocale = $9bf39eea1aa29c83$var$_interopRequireWildcard((parcelRequire("cbFQZ")));

var $9bf39eea1aa29c83$var$_locale = $9bf39eea1aa29c83$var$_interopRequireDefault((parcelRequire("9Z0z6")));

var $9bf39eea1aa29c83$var$_isoFormat = $9bf39eea1aa29c83$var$_interopRequireDefault((parcelRequire("hKmZK")));

var $9bf39eea1aa29c83$var$_isoParse = $9bf39eea1aa29c83$var$_interopRequireDefault((parcelRequire("42WJU")));
function $9bf39eea1aa29c83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9bf39eea1aa29c83$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9bf39eea1aa29c83$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9bf39eea1aa29c83$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9bf39eea1aa29c83$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRequire.register("cbFQZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8df6fa5fa5fc45fd$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $8df6fa5fa5fc45fd$var$_locale = $8df6fa5fa5fc45fd$var$_interopRequireDefault((parcelRequire("9Z0z6")));
function $8df6fa5fa5fc45fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8df6fa5fa5fc45fd$var$locale;
var $8df6fa5fa5fc45fd$var$timeFormat;
module.exports.timeFormat = $8df6fa5fa5fc45fd$var$timeFormat;
var $8df6fa5fa5fc45fd$var$timeParse;
module.exports.timeParse = $8df6fa5fa5fc45fd$var$timeParse;
var $8df6fa5fa5fc45fd$var$utcFormat;
module.exports.utcFormat = $8df6fa5fa5fc45fd$var$utcFormat;
var $8df6fa5fa5fc45fd$var$utcParse;
module.exports.utcParse = $8df6fa5fa5fc45fd$var$utcParse;
$8df6fa5fa5fc45fd$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $8df6fa5fa5fc45fd$var$defaultLocale(definition) {
    $8df6fa5fa5fc45fd$var$locale = (0, $8df6fa5fa5fc45fd$var$_locale.default)(definition);
    module.exports.timeFormat = $8df6fa5fa5fc45fd$var$timeFormat = $8df6fa5fa5fc45fd$var$locale.format;
    module.exports.timeParse = $8df6fa5fa5fc45fd$var$timeParse = $8df6fa5fa5fc45fd$var$locale.parse;
    module.exports.utcFormat = $8df6fa5fa5fc45fd$var$utcFormat = $8df6fa5fa5fc45fd$var$locale.utcFormat;
    module.exports.utcParse = $8df6fa5fa5fc45fd$var$utcParse = $8df6fa5fa5fc45fd$var$locale.utcParse;
    return $8df6fa5fa5fc45fd$var$locale;
}

});
parcelRequire.register("9Z0z6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744a3fcb3c8d0260$var$formatLocale;

var $8f2QI = parcelRequire("8f2QI");
function $744a3fcb3c8d0260$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $744a3fcb3c8d0260$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $744a3fcb3c8d0260$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $744a3fcb3c8d0260$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $744a3fcb3c8d0260$var$formatRe(locale_periods), periodLookup = $744a3fcb3c8d0260$var$formatLookup(locale_periods), weekdayRe = $744a3fcb3c8d0260$var$formatRe(locale_weekdays), weekdayLookup = $744a3fcb3c8d0260$var$formatLookup(locale_weekdays), shortWeekdayRe = $744a3fcb3c8d0260$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $744a3fcb3c8d0260$var$formatLookup(locale_shortWeekdays), monthRe = $744a3fcb3c8d0260$var$formatRe(locale_months), monthLookup = $744a3fcb3c8d0260$var$formatLookup(locale_months), shortMonthRe = $744a3fcb3c8d0260$var$formatRe(locale_shortMonths), shortMonthLookup = $744a3fcb3c8d0260$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $744a3fcb3c8d0260$var$formatDayOfMonth,
        "e": $744a3fcb3c8d0260$var$formatDayOfMonth,
        "f": $744a3fcb3c8d0260$var$formatMicroseconds,
        "g": $744a3fcb3c8d0260$var$formatYearISO,
        "G": $744a3fcb3c8d0260$var$formatFullYearISO,
        "H": $744a3fcb3c8d0260$var$formatHour24,
        "I": $744a3fcb3c8d0260$var$formatHour12,
        "j": $744a3fcb3c8d0260$var$formatDayOfYear,
        "L": $744a3fcb3c8d0260$var$formatMilliseconds,
        "m": $744a3fcb3c8d0260$var$formatMonthNumber,
        "M": $744a3fcb3c8d0260$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $744a3fcb3c8d0260$var$formatUnixTimestamp,
        "s": $744a3fcb3c8d0260$var$formatUnixTimestampSeconds,
        "S": $744a3fcb3c8d0260$var$formatSeconds,
        "u": $744a3fcb3c8d0260$var$formatWeekdayNumberMonday,
        "U": $744a3fcb3c8d0260$var$formatWeekNumberSunday,
        "V": $744a3fcb3c8d0260$var$formatWeekNumberISO,
        "w": $744a3fcb3c8d0260$var$formatWeekdayNumberSunday,
        "W": $744a3fcb3c8d0260$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $744a3fcb3c8d0260$var$formatYear,
        "Y": $744a3fcb3c8d0260$var$formatFullYear,
        "Z": $744a3fcb3c8d0260$var$formatZone,
        "%": $744a3fcb3c8d0260$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $744a3fcb3c8d0260$var$formatUTCDayOfMonth,
        "e": $744a3fcb3c8d0260$var$formatUTCDayOfMonth,
        "f": $744a3fcb3c8d0260$var$formatUTCMicroseconds,
        "g": $744a3fcb3c8d0260$var$formatUTCYearISO,
        "G": $744a3fcb3c8d0260$var$formatUTCFullYearISO,
        "H": $744a3fcb3c8d0260$var$formatUTCHour24,
        "I": $744a3fcb3c8d0260$var$formatUTCHour12,
        "j": $744a3fcb3c8d0260$var$formatUTCDayOfYear,
        "L": $744a3fcb3c8d0260$var$formatUTCMilliseconds,
        "m": $744a3fcb3c8d0260$var$formatUTCMonthNumber,
        "M": $744a3fcb3c8d0260$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $744a3fcb3c8d0260$var$formatUnixTimestamp,
        "s": $744a3fcb3c8d0260$var$formatUnixTimestampSeconds,
        "S": $744a3fcb3c8d0260$var$formatUTCSeconds,
        "u": $744a3fcb3c8d0260$var$formatUTCWeekdayNumberMonday,
        "U": $744a3fcb3c8d0260$var$formatUTCWeekNumberSunday,
        "V": $744a3fcb3c8d0260$var$formatUTCWeekNumberISO,
        "w": $744a3fcb3c8d0260$var$formatUTCWeekdayNumberSunday,
        "W": $744a3fcb3c8d0260$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $744a3fcb3c8d0260$var$formatUTCYear,
        "Y": $744a3fcb3c8d0260$var$formatUTCFullYear,
        "Z": $744a3fcb3c8d0260$var$formatUTCZone,
        "%": $744a3fcb3c8d0260$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $744a3fcb3c8d0260$var$parseDayOfMonth,
        "e": $744a3fcb3c8d0260$var$parseDayOfMonth,
        "f": $744a3fcb3c8d0260$var$parseMicroseconds,
        "g": $744a3fcb3c8d0260$var$parseYear,
        "G": $744a3fcb3c8d0260$var$parseFullYear,
        "H": $744a3fcb3c8d0260$var$parseHour24,
        "I": $744a3fcb3c8d0260$var$parseHour24,
        "j": $744a3fcb3c8d0260$var$parseDayOfYear,
        "L": $744a3fcb3c8d0260$var$parseMilliseconds,
        "m": $744a3fcb3c8d0260$var$parseMonthNumber,
        "M": $744a3fcb3c8d0260$var$parseMinutes,
        "p": parsePeriod,
        "q": $744a3fcb3c8d0260$var$parseQuarter,
        "Q": $744a3fcb3c8d0260$var$parseUnixTimestamp,
        "s": $744a3fcb3c8d0260$var$parseUnixTimestampSeconds,
        "S": $744a3fcb3c8d0260$var$parseSeconds,
        "u": $744a3fcb3c8d0260$var$parseWeekdayNumberMonday,
        "U": $744a3fcb3c8d0260$var$parseWeekNumberSunday,
        "V": $744a3fcb3c8d0260$var$parseWeekNumberISO,
        "w": $744a3fcb3c8d0260$var$parseWeekdayNumberSunday,
        "W": $744a3fcb3c8d0260$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $744a3fcb3c8d0260$var$parseYear,
        "Y": $744a3fcb3c8d0260$var$parseFullYear,
        "Z": $744a3fcb3c8d0260$var$parseZone,
        "%": $744a3fcb3c8d0260$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $744a3fcb3c8d0260$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $744a3fcb3c8d0260$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $744a3fcb3c8d0260$var$utcDate($744a3fcb3c8d0260$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $8f2QI.utcMonday.ceil(week) : (0, $8f2QI.utcMonday)(week);
                    week = $8f2QI.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $744a3fcb3c8d0260$var$localDate($744a3fcb3c8d0260$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $8f2QI.timeMonday.ceil(week) : (0, $8f2QI.timeMonday)(week);
                    week = $8f2QI.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $744a3fcb3c8d0260$var$utcDate($744a3fcb3c8d0260$var$newDate(d.y, 0, 1)).getUTCDay() : $744a3fcb3c8d0260$var$localDate($744a3fcb3c8d0260$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $744a3fcb3c8d0260$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $744a3fcb3c8d0260$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $744a3fcb3c8d0260$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $744a3fcb3c8d0260$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $744a3fcb3c8d0260$var$numberRe = /^\s*\d+/, // note: ignores next directive
$744a3fcb3c8d0260$var$percentRe = /^%/, $744a3fcb3c8d0260$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $744a3fcb3c8d0260$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $744a3fcb3c8d0260$var$requote(s) {
    return s.replace($744a3fcb3c8d0260$var$requoteRe, "\\$&");
}
function $744a3fcb3c8d0260$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($744a3fcb3c8d0260$var$requote).join("|") + ")", "i");
}
function $744a3fcb3c8d0260$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $744a3fcb3c8d0260$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseWeekNumberSunday(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseWeekNumberISO(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseWeekNumberMonday(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseFullYear(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseYear(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseQuarter(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseMonthNumber(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseDayOfMonth(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseDayOfYear(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseHour24(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseMinutes(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseSeconds(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseMilliseconds(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseMicroseconds(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseLiteralPercent(d, string, i) {
    var n = $744a3fcb3c8d0260$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $744a3fcb3c8d0260$var$parseUnixTimestamp(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $744a3fcb3c8d0260$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $744a3fcb3c8d0260$var$formatDayOfMonth(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getDate(), p, 2);
}
function $744a3fcb3c8d0260$var$formatHour24(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getHours(), p, 2);
}
function $744a3fcb3c8d0260$var$formatHour12(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $744a3fcb3c8d0260$var$formatDayOfYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(1 + $8f2QI.timeDay.count((0, $8f2QI.timeYear)(d), d), p, 3);
}
function $744a3fcb3c8d0260$var$formatMilliseconds(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getMilliseconds(), p, 3);
}
function $744a3fcb3c8d0260$var$formatMicroseconds(d, p) {
    return $744a3fcb3c8d0260$var$formatMilliseconds(d, p) + "000";
}
function $744a3fcb3c8d0260$var$formatMonthNumber(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getMonth() + 1, p, 2);
}
function $744a3fcb3c8d0260$var$formatMinutes(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getMinutes(), p, 2);
}
function $744a3fcb3c8d0260$var$formatSeconds(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getSeconds(), p, 2);
}
function $744a3fcb3c8d0260$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $744a3fcb3c8d0260$var$formatWeekNumberSunday(d, p) {
    return $744a3fcb3c8d0260$var$pad($8f2QI.timeSunday.count((0, $8f2QI.timeYear)(d) - 1, d), p, 2);
}
function $744a3fcb3c8d0260$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $8f2QI.timeThursday)(d) : $8f2QI.timeThursday.ceil(d);
}
function $744a3fcb3c8d0260$var$formatWeekNumberISO(d, p) {
    d = $744a3fcb3c8d0260$var$dISO(d);
    return $744a3fcb3c8d0260$var$pad($8f2QI.timeThursday.count((0, $8f2QI.timeYear)(d), d) + ((0, $8f2QI.timeYear)(d).getDay() === 4), p, 2);
}
function $744a3fcb3c8d0260$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $744a3fcb3c8d0260$var$formatWeekNumberMonday(d, p) {
    return $744a3fcb3c8d0260$var$pad($8f2QI.timeMonday.count((0, $8f2QI.timeYear)(d) - 1, d), p, 2);
}
function $744a3fcb3c8d0260$var$formatYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getFullYear() % 100, p, 2);
}
function $744a3fcb3c8d0260$var$formatYearISO(d, p) {
    d = $744a3fcb3c8d0260$var$dISO(d);
    return $744a3fcb3c8d0260$var$pad(d.getFullYear() % 100, p, 2);
}
function $744a3fcb3c8d0260$var$formatFullYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getFullYear() % 10000, p, 4);
}
function $744a3fcb3c8d0260$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $8f2QI.timeThursday)(d) : $8f2QI.timeThursday.ceil(d);
    return $744a3fcb3c8d0260$var$pad(d.getFullYear() % 10000, p, 4);
}
function $744a3fcb3c8d0260$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $744a3fcb3c8d0260$var$pad(z / 60 | 0, "0", 2) + $744a3fcb3c8d0260$var$pad(z % 60, "0", 2);
}
function $744a3fcb3c8d0260$var$formatUTCDayOfMonth(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCDate(), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCHour24(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCHours(), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCHour12(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCDayOfYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(1 + $8f2QI.utcDay.count((0, $8f2QI.utcYear)(d), d), p, 3);
}
function $744a3fcb3c8d0260$var$formatUTCMilliseconds(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $744a3fcb3c8d0260$var$formatUTCMicroseconds(d, p) {
    return $744a3fcb3c8d0260$var$formatUTCMilliseconds(d, p) + "000";
}
function $744a3fcb3c8d0260$var$formatUTCMonthNumber(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCMinutes(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCMinutes(), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCSeconds(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCSeconds(), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $744a3fcb3c8d0260$var$formatUTCWeekNumberSunday(d, p) {
    return $744a3fcb3c8d0260$var$pad($8f2QI.utcSunday.count((0, $8f2QI.utcYear)(d) - 1, d), p, 2);
}
function $744a3fcb3c8d0260$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $8f2QI.utcThursday)(d) : $8f2QI.utcThursday.ceil(d);
}
function $744a3fcb3c8d0260$var$formatUTCWeekNumberISO(d, p) {
    d = $744a3fcb3c8d0260$var$UTCdISO(d);
    return $744a3fcb3c8d0260$var$pad($8f2QI.utcThursday.count((0, $8f2QI.utcYear)(d), d) + ((0, $8f2QI.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $744a3fcb3c8d0260$var$formatUTCWeekNumberMonday(d, p) {
    return $744a3fcb3c8d0260$var$pad($8f2QI.utcMonday.count((0, $8f2QI.utcYear)(d) - 1, d), p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCYearISO(d, p) {
    d = $744a3fcb3c8d0260$var$UTCdISO(d);
    return $744a3fcb3c8d0260$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $744a3fcb3c8d0260$var$formatUTCFullYear(d, p) {
    return $744a3fcb3c8d0260$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $744a3fcb3c8d0260$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $8f2QI.utcThursday)(d) : $8f2QI.utcThursday.ceil(d);
    return $744a3fcb3c8d0260$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $744a3fcb3c8d0260$var$formatUTCZone() {
    return "+0000";
}
function $744a3fcb3c8d0260$var$formatLiteralPercent() {
    return "%";
}
function $744a3fcb3c8d0260$var$formatUnixTimestamp(d) {
    return +d;
}
function $744a3fcb3c8d0260$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRequire.register("hKmZK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $cbFQZ = parcelRequire("cbFQZ");
var $ceb891d6a4837713$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $ceb891d6a4837713$var$isoSpecifier;
function $ceb891d6a4837713$var$formatIsoNative(date) {
    return date.toISOString();
}
var $ceb891d6a4837713$var$formatIso = Date.prototype.toISOString ? $ceb891d6a4837713$var$formatIsoNative : (0, $cbFQZ.utcFormat)($ceb891d6a4837713$var$isoSpecifier);
var $ceb891d6a4837713$var$_default = $ceb891d6a4837713$var$formatIso;
module.exports.default = $ceb891d6a4837713$var$_default;

});

parcelRequire.register("42WJU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hKmZK = parcelRequire("hKmZK");

var $cbFQZ = parcelRequire("cbFQZ");
function $2f24e9c8dc43c060$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $2f24e9c8dc43c060$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $2f24e9c8dc43c060$var$parseIsoNative : (0, $cbFQZ.utcParse)($hKmZK.isoSpecifier);
var $2f24e9c8dc43c060$var$_default = $2f24e9c8dc43c060$var$parseIso;
module.exports.default = $2f24e9c8dc43c060$var$_default;

});



parcelRequire.register("1GFVB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $13aa3cbb7d0f3d25$var$utcTime;

var $8f2QI = parcelRequire("8f2QI");

var $do7RX = parcelRequire("do7RX");

var $jI0v0 = parcelRequire("jI0v0");

var $2n3DU = parcelRequire("2n3DU");
function $13aa3cbb7d0f3d25$var$utcTime() {
    return $2n3DU.initRange.apply((0, $jI0v0.calendar)($8f2QI.utcTicks, $8f2QI.utcTickInterval, $8f2QI.utcYear, $8f2QI.utcMonth, $8f2QI.utcWeek, $8f2QI.utcDay, $8f2QI.utcHour, $8f2QI.utcMinute, $8f2QI.utcSecond, $do7RX.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRequire.register("g0Oo4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $ba83bb49439746ba$var$copy;
module.exports.default = $ba83bb49439746ba$var$sequential;
module.exports.sequentialLog = $ba83bb49439746ba$var$sequentialLog;
module.exports.sequentialPow = $ba83bb49439746ba$var$sequentialPow;
module.exports.sequentialSqrt = $ba83bb49439746ba$var$sequentialSqrt;
module.exports.sequentialSymlog = $ba83bb49439746ba$var$sequentialSymlog;

var $efgB1 = parcelRequire("efgB1");

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");

var $4s2nh = parcelRequire("4s2nh");

var $hIWMD = parcelRequire("hIWMD");

var $9EBZE = parcelRequire("9EBZE");

var $6Z3ZX = parcelRequire("6Z3ZX");
function $ba83bb49439746ba$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $hYhGt.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($efgB1.interpolate);
    scale.rangeRound = range($efgB1.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $ba83bb49439746ba$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $ba83bb49439746ba$var$sequential() {
    var scale = (0, $4s2nh.linearish)($ba83bb49439746ba$var$transformer()($hYhGt.identity));
    scale.copy = function() {
        return $ba83bb49439746ba$var$copy(scale, $ba83bb49439746ba$var$sequential());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $ba83bb49439746ba$var$sequentialLog() {
    var scale = (0, $hIWMD.loggish)($ba83bb49439746ba$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $ba83bb49439746ba$var$copy(scale, $ba83bb49439746ba$var$sequentialLog()).base(scale.base());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $ba83bb49439746ba$var$sequentialSymlog() {
    var scale = (0, $9EBZE.symlogish)($ba83bb49439746ba$var$transformer());
    scale.copy = function() {
        return $ba83bb49439746ba$var$copy(scale, $ba83bb49439746ba$var$sequentialSymlog()).constant(scale.constant());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $ba83bb49439746ba$var$sequentialPow() {
    var scale = (0, $6Z3ZX.powish)($ba83bb49439746ba$var$transformer());
    scale.copy = function() {
        return $ba83bb49439746ba$var$copy(scale, $ba83bb49439746ba$var$sequentialPow()).exponent(scale.exponent());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $ba83bb49439746ba$var$sequentialSqrt() {
    return $ba83bb49439746ba$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRequire.register("hZyAu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d192f6857f16ac2e$var$sequentialQuantile;

var $1A3M6 = parcelRequire("1A3M6");

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");
function $d192f6857f16ac2e$var$sequentialQuantile() {
    var domain = [], interpolator = $hYhGt.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $1A3M6.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($1A3M6.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $1A3M6.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $d192f6857f16ac2e$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}

});

parcelRequire.register("m4DII", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0425a786a6e8e966$var$diverging;
module.exports.divergingLog = $0425a786a6e8e966$var$divergingLog;
module.exports.divergingPow = $0425a786a6e8e966$var$divergingPow;
module.exports.divergingSqrt = $0425a786a6e8e966$var$divergingSqrt;
module.exports.divergingSymlog = $0425a786a6e8e966$var$divergingSymlog;

var $efgB1 = parcelRequire("efgB1");

var $hYhGt = parcelRequire("hYhGt");

var $2n3DU = parcelRequire("2n3DU");

var $4s2nh = parcelRequire("4s2nh");

var $hIWMD = parcelRequire("hIWMD");

var $g0Oo4 = parcelRequire("g0Oo4");

var $9EBZE = parcelRequire("9EBZE");

var $6Z3ZX = parcelRequire("6Z3ZX");
function $0425a786a6e8e966$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $hYhGt.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $efgB1.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($efgB1.interpolate);
    scale.rangeRound = range($efgB1.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $0425a786a6e8e966$var$diverging() {
    var scale = (0, $4s2nh.linearish)($0425a786a6e8e966$var$transformer()($hYhGt.identity));
    scale.copy = function() {
        return (0, $g0Oo4.copy)(scale, $0425a786a6e8e966$var$diverging());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $0425a786a6e8e966$var$divergingLog() {
    var scale = (0, $hIWMD.loggish)($0425a786a6e8e966$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $g0Oo4.copy)(scale, $0425a786a6e8e966$var$divergingLog()).base(scale.base());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $0425a786a6e8e966$var$divergingSymlog() {
    var scale = (0, $9EBZE.symlogish)($0425a786a6e8e966$var$transformer());
    scale.copy = function() {
        return (0, $g0Oo4.copy)(scale, $0425a786a6e8e966$var$divergingSymlog()).constant(scale.constant());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $0425a786a6e8e966$var$divergingPow() {
    var scale = (0, $6Z3ZX.powish)($0425a786a6e8e966$var$transformer());
    scale.copy = function() {
        return (0, $g0Oo4.copy)(scale, $0425a786a6e8e966$var$divergingPow()).exponent(scale.exponent());
    };
    return $2n3DU.initInterpolator.apply(scale, arguments);
}
function $0425a786a6e8e966$var$divergingSqrt() {
    return $0425a786a6e8e966$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRequire.register("hyQ6c", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("6gFGb"));

});
parcelRequire.register("6gFGb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $930vn.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $930vn.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $5TXew.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $5TXew.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $bB7QD.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $bB7QD.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $bB7QD.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $bB7QD.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $4904915c16818f23$var$_symbol.symbolsStroke;
    }
});

var $4904915c16818f23$var$_arc = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("9hstF")));

var $4904915c16818f23$var$_area = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("91az8")));

var $4904915c16818f23$var$_line = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("gcxNy")));

var $4904915c16818f23$var$_pie = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("2ZZxn")));

var $4904915c16818f23$var$_areaRadial = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("fdEX4")));

var $4904915c16818f23$var$_lineRadial = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("lPsyJ")));

var $4904915c16818f23$var$_pointRadial = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("9LhmB")));

var $bB7QD = parcelRequire("bB7QD");

var $4904915c16818f23$var$_symbol = $4904915c16818f23$var$_interopRequireWildcard((parcelRequire("4fnAB")));

var $4904915c16818f23$var$_asterisk = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("5dvDL")));

var $4904915c16818f23$var$_circle = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("l969W")));

var $4904915c16818f23$var$_cross = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("8N9PA")));

var $4904915c16818f23$var$_diamond = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("kWarP")));

var $4904915c16818f23$var$_diamond2 = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("6nZ19")));

var $4904915c16818f23$var$_plus = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("guSS4")));

var $4904915c16818f23$var$_square = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("awFLa")));

var $4904915c16818f23$var$_square2 = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("kh1ee")));

var $4904915c16818f23$var$_star = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("3oewW")));

var $4904915c16818f23$var$_triangle = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("cY1lJ")));

var $4904915c16818f23$var$_triangle2 = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("dOwkg")));

var $4904915c16818f23$var$_wye = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("3GZX2")));

var $4904915c16818f23$var$_x = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("7VTFk")));

var $4904915c16818f23$var$_basisClosed = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("fdRyK")));

var $4904915c16818f23$var$_basisOpen = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("h9Un5")));

var $4904915c16818f23$var$_basis = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("eEz9v")));

var $930vn = parcelRequire("930vn");

var $4904915c16818f23$var$_bundle = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("jSnsu")));

var $4904915c16818f23$var$_cardinalClosed = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("eaNfU")));

var $4904915c16818f23$var$_cardinalOpen = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("300P3")));

var $4904915c16818f23$var$_cardinal = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("5kjd5")));

var $4904915c16818f23$var$_catmullRomClosed = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("6niaP")));

var $4904915c16818f23$var$_catmullRomOpen = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("7G4Ea")));

var $4904915c16818f23$var$_catmullRom = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("H7zH1")));

var $4904915c16818f23$var$_linearClosed = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("2tiLX")));

var $4904915c16818f23$var$_linear = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("jOaRV")));

var $5TXew = parcelRequire("5TXew");

var $4904915c16818f23$var$_natural = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("cPV27")));

var $4904915c16818f23$var$_step = $4904915c16818f23$var$_interopRequireWildcard((parcelRequire("2q7zt")));

var $4904915c16818f23$var$_stack = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("gtjIt")));

var $4904915c16818f23$var$_expand = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("8fH0h")));

var $4904915c16818f23$var$_diverging = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("ckPUG")));

var $4904915c16818f23$var$_none = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("ft5tg")));

var $4904915c16818f23$var$_silhouette = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("6uQse")));

var $4904915c16818f23$var$_wiggle = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("1ABW5")));

var $4904915c16818f23$var$_appearance = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("8cpDw")));

var $4904915c16818f23$var$_ascending = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("aAng2")));

var $4904915c16818f23$var$_descending = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("9dX5H")));

var $4904915c16818f23$var$_insideOut = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("tCVuS")));

var $4904915c16818f23$var$_none2 = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("isQ40")));

var $4904915c16818f23$var$_reverse = $4904915c16818f23$var$_interopRequireDefault((parcelRequire("jyaLZ")));
function $4904915c16818f23$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4904915c16818f23$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4904915c16818f23$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4904915c16818f23$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4904915c16818f23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("9hstF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c1bcaa5475264b2$var$_default;

var $3Oifc = parcelRequire("3Oifc");

var $6c1bcaa5475264b2$var$_constant = $6c1bcaa5475264b2$var$_interopRequireDefault((parcelRequire("kktHL")));

var $1Q1kL = parcelRequire("1Q1kL");
function $6c1bcaa5475264b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6c1bcaa5475264b2$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $6c1bcaa5475264b2$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $6c1bcaa5475264b2$var$arcStartAngle(d) {
    return d.startAngle;
}
function $6c1bcaa5475264b2$var$arcEndAngle(d) {
    return d.endAngle;
}
function $6c1bcaa5475264b2$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $6c1bcaa5475264b2$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $1Q1kL.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $6c1bcaa5475264b2$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $1Q1kL.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $1Q1kL.sqrt)((0, $1Q1kL.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $6c1bcaa5475264b2$var$_default() {
    var innerRadius = $6c1bcaa5475264b2$var$arcInnerRadius, outerRadius = $6c1bcaa5475264b2$var$arcOuterRadius, cornerRadius = (0, $6c1bcaa5475264b2$var$_constant.default)(0), padRadius = null, startAngle = $6c1bcaa5475264b2$var$arcStartAngle, endAngle = $6c1bcaa5475264b2$var$arcEndAngle, padAngle = $6c1bcaa5475264b2$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $1Q1kL.halfPi, a1 = endAngle.apply(this, arguments) - $1Q1kL.halfPi, da = (0, $1Q1kL.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $3Oifc.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $1Q1kL.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $1Q1kL.tau - $1Q1kL.epsilon) {
            context.moveTo(r1 * (0, $1Q1kL.cos)(a0), r1 * (0, $1Q1kL.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $1Q1kL.epsilon) {
                context.moveTo(r0 * (0, $1Q1kL.cos)(a1), r0 * (0, $1Q1kL.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $1Q1kL.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $1Q1kL.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $1Q1kL.min)((0, $1Q1kL.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $1Q1kL.epsilon) {
                var p0 = (0, $1Q1kL.asin)(rp / r0 * (0, $1Q1kL.sin)(ap)), p1 = (0, $1Q1kL.asin)(rp / r1 * (0, $1Q1kL.sin)(ap));
                if ((da0 -= p0 * 2) > $1Q1kL.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $1Q1kL.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $1Q1kL.cos)(a01), y01 = r1 * (0, $1Q1kL.sin)(a01), x10 = r0 * (0, $1Q1kL.cos)(a10), y10 = r0 * (0, $1Q1kL.sin)(a10); // Apply rounded corners?
            if (rc > $1Q1kL.epsilon) {
                var x11 = r1 * (0, $1Q1kL.cos)(a11), y11 = r1 * (0, $1Q1kL.sin)(a11), x00 = r0 * (0, $1Q1kL.cos)(a00), y00 = r0 * (0, $1Q1kL.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $1Q1kL.pi && (oc = $6c1bcaa5475264b2$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $1Q1kL.sin)((0, $1Q1kL.acos)((ax * bx + ay * by) / ((0, $1Q1kL.sqrt)(ax * ax + ay * ay) * (0, $1Q1kL.sqrt)(bx * bx + by * by))) / 2), lc = (0, $1Q1kL.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $1Q1kL.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $1Q1kL.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $1Q1kL.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $1Q1kL.epsilon) {
                t0 = $6c1bcaa5475264b2$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $6c1bcaa5475264b2$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $1Q1kL.atan2)(t0.y01, t0.x01), (0, $1Q1kL.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $1Q1kL.atan2)(t0.y01, t0.x01), (0, $1Q1kL.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $1Q1kL.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1Q1kL.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $1Q1kL.atan2)(t1.y11, t1.x11), (0, $1Q1kL.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $1Q1kL.epsilon) || !(da0 > $1Q1kL.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $1Q1kL.epsilon) {
                t0 = $6c1bcaa5475264b2$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $6c1bcaa5475264b2$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $1Q1kL.atan2)(t0.y01, t0.x01), (0, $1Q1kL.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $1Q1kL.atan2)(t0.y01, t0.x01), (0, $1Q1kL.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $1Q1kL.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $1Q1kL.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $1Q1kL.atan2)(t1.y11, t1.x11), (0, $1Q1kL.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $1Q1kL.pi / 2;
        return [
            (0, $1Q1kL.cos)(a) * r,
            (0, $1Q1kL.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $6c1bcaa5475264b2$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRequire.register("3Oifc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $2c6431866dd53be3$var$_path.default;
    }
});

var $2c6431866dd53be3$var$_path = $2c6431866dd53be3$var$_interopRequireDefault((parcelRequire("1r6W6")));
function $2c6431866dd53be3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRequire.register("1r6W6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $10bdb173dd2d7555$var$pi = Math.PI, $10bdb173dd2d7555$var$tau = 2 * $10bdb173dd2d7555$var$pi, $10bdb173dd2d7555$var$epsilon = 1e-6, $10bdb173dd2d7555$var$tauEpsilon = $10bdb173dd2d7555$var$tau - $10bdb173dd2d7555$var$epsilon;
function $10bdb173dd2d7555$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $10bdb173dd2d7555$var$path() {
    return new $10bdb173dd2d7555$var$Path();
}
$10bdb173dd2d7555$var$Path.prototype = $10bdb173dd2d7555$var$path.prototype = {
    constructor: $10bdb173dd2d7555$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $10bdb173dd2d7555$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $10bdb173dd2d7555$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($10bdb173dd2d7555$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $10bdb173dd2d7555$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $10bdb173dd2d7555$var$epsilon || Math.abs(this._y1 - y0) > $10bdb173dd2d7555$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $10bdb173dd2d7555$var$tau + $10bdb173dd2d7555$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $10bdb173dd2d7555$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $10bdb173dd2d7555$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $10bdb173dd2d7555$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $10bdb173dd2d7555$var$_default = $10bdb173dd2d7555$var$path;
module.exports.default = $10bdb173dd2d7555$var$_default;

});


parcelRequire.register("kktHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecccb7b134881197$var$_default;
function $ecccb7b134881197$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRequire.register("1Q1kL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $156baea872612038$var$acos;
module.exports.asin = $156baea872612038$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $156baea872612038$var$abs = Math.abs;
module.exports.abs = $156baea872612038$var$abs;
const $156baea872612038$var$atan2 = Math.atan2;
module.exports.atan2 = $156baea872612038$var$atan2;
const $156baea872612038$var$cos = Math.cos;
module.exports.cos = $156baea872612038$var$cos;
const $156baea872612038$var$max = Math.max;
module.exports.max = $156baea872612038$var$max;
const $156baea872612038$var$min = Math.min;
module.exports.min = $156baea872612038$var$min;
const $156baea872612038$var$sin = Math.sin;
module.exports.sin = $156baea872612038$var$sin;
const $156baea872612038$var$sqrt = Math.sqrt;
module.exports.sqrt = $156baea872612038$var$sqrt;
const $156baea872612038$var$epsilon = 1e-12;
module.exports.epsilon = $156baea872612038$var$epsilon;
const $156baea872612038$var$pi = Math.PI;
module.exports.pi = $156baea872612038$var$pi;
const $156baea872612038$var$halfPi = $156baea872612038$var$pi / 2;
module.exports.halfPi = $156baea872612038$var$halfPi;
const $156baea872612038$var$tau = 2 * $156baea872612038$var$pi;
module.exports.tau = $156baea872612038$var$tau;
function $156baea872612038$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $156baea872612038$var$pi : Math.acos(x);
}
function $156baea872612038$var$asin(x) {
    return x >= 1 ? $156baea872612038$var$halfPi : x <= -1 ? -$156baea872612038$var$halfPi : Math.asin(x);
}

});


parcelRequire.register("91az8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $690c6730cdefaad3$var$_default;

var $3Oifc = parcelRequire("3Oifc");

var $690c6730cdefaad3$var$_array = $690c6730cdefaad3$var$_interopRequireDefault((parcelRequire("ejJqH")));

var $690c6730cdefaad3$var$_constant = $690c6730cdefaad3$var$_interopRequireDefault((parcelRequire("kktHL")));

var $690c6730cdefaad3$var$_linear = $690c6730cdefaad3$var$_interopRequireDefault((parcelRequire("jOaRV")));

var $690c6730cdefaad3$var$_line = $690c6730cdefaad3$var$_interopRequireDefault((parcelRequire("gcxNy")));

var $3eut6 = parcelRequire("3eut6");
function $690c6730cdefaad3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $690c6730cdefaad3$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $690c6730cdefaad3$var$_constant.default)(true), context = null, curve = $690c6730cdefaad3$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $3eut6.x : (0, $690c6730cdefaad3$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $690c6730cdefaad3$var$_constant.default)(0) : (0, $690c6730cdefaad3$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $3eut6.y : (0, $690c6730cdefaad3$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $690c6730cdefaad3$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $3Oifc.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $690c6730cdefaad3$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $690c6730cdefaad3$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRequire.register("ejJqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6c6146c7892332d$var$_default;
module.exports.slice = void 0;
var $a6c6146c7892332d$var$slice = Array.prototype.slice;
module.exports.slice = $a6c6146c7892332d$var$slice;
function $a6c6146c7892332d$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRequire.register("jOaRV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6bb1e20addfbe45$var$_default;
function $e6bb1e20addfbe45$var$Linear(context) {
    this._context = context;
}
$e6bb1e20addfbe45$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $e6bb1e20addfbe45$var$_default(context) {
    return new $e6bb1e20addfbe45$var$Linear(context);
}

});

parcelRequire.register("gcxNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcb7fbf969f1ed09$var$_default;

var $3Oifc = parcelRequire("3Oifc");

var $bcb7fbf969f1ed09$var$_array = $bcb7fbf969f1ed09$var$_interopRequireDefault((parcelRequire("ejJqH")));

var $bcb7fbf969f1ed09$var$_constant = $bcb7fbf969f1ed09$var$_interopRequireDefault((parcelRequire("kktHL")));

var $bcb7fbf969f1ed09$var$_linear = $bcb7fbf969f1ed09$var$_interopRequireDefault((parcelRequire("jOaRV")));

var $3eut6 = parcelRequire("3eut6");
function $bcb7fbf969f1ed09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bcb7fbf969f1ed09$var$_default(x, y) {
    var defined = (0, $bcb7fbf969f1ed09$var$_constant.default)(true), context = null, curve = $bcb7fbf969f1ed09$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $3eut6.x : (0, $bcb7fbf969f1ed09$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $3eut6.y : (0, $bcb7fbf969f1ed09$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $bcb7fbf969f1ed09$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $3Oifc.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $bcb7fbf969f1ed09$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $bcb7fbf969f1ed09$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $bcb7fbf969f1ed09$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRequire.register("3eut6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $25aa504b579ce00b$var$x;
module.exports.y = $25aa504b579ce00b$var$y;
function $25aa504b579ce00b$var$x(p) {
    return p[0];
}
function $25aa504b579ce00b$var$y(p) {
    return p[1];
}

});



parcelRequire.register("2ZZxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22f10352c707d516$var$_default;

var $22f10352c707d516$var$_array = $22f10352c707d516$var$_interopRequireDefault((parcelRequire("ejJqH")));

var $22f10352c707d516$var$_constant = $22f10352c707d516$var$_interopRequireDefault((parcelRequire("kktHL")));

var $22f10352c707d516$var$_descending = $22f10352c707d516$var$_interopRequireDefault((parcelRequire("dcc4E")));

var $22f10352c707d516$var$_identity = $22f10352c707d516$var$_interopRequireDefault((parcelRequire("eu0nh")));

var $1Q1kL = parcelRequire("1Q1kL");
function $22f10352c707d516$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22f10352c707d516$var$_default() {
    var value = $22f10352c707d516$var$_identity.default, sortValues = $22f10352c707d516$var$_descending.default, sort = null, startAngle = (0, $22f10352c707d516$var$_constant.default)(0), endAngle = (0, $22f10352c707d516$var$_constant.default)($1Q1kL.tau), padAngle = (0, $22f10352c707d516$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $22f10352c707d516$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($1Q1kL.tau, Math.max(-$1Q1kL.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $22f10352c707d516$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $22f10352c707d516$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $22f10352c707d516$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $22f10352c707d516$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRequire.register("dcc4E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99b5c2ff2169bfc3$var$_default;
function $99b5c2ff2169bfc3$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRequire.register("eu0nh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8b42861e18637fe$var$_default;
function $a8b42861e18637fe$var$_default(d) {
    return d;
}

});


parcelRequire.register("fdEX4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b147d6128dfcdf39$var$_default;

var $b147d6128dfcdf39$var$_radial = $b147d6128dfcdf39$var$_interopRequireWildcard((parcelRequire("aqQDe")));

var $b147d6128dfcdf39$var$_area = $b147d6128dfcdf39$var$_interopRequireDefault((parcelRequire("91az8")));

var $lPsyJ = parcelRequire("lPsyJ");
function $b147d6128dfcdf39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b147d6128dfcdf39$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b147d6128dfcdf39$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b147d6128dfcdf39$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b147d6128dfcdf39$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b147d6128dfcdf39$var$_default() {
    var a = (0, $b147d6128dfcdf39$var$_area.default)().curve($b147d6128dfcdf39$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $lPsyJ.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $lPsyJ.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $lPsyJ.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $lPsyJ.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $b147d6128dfcdf39$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRequire.register("aqQDe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $798528a69859126a$var$curveRadial;

var $798528a69859126a$var$_linear = $798528a69859126a$var$_interopRequireDefault((parcelRequire("jOaRV")));
function $798528a69859126a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $798528a69859126a$var$curveRadialLinear = $798528a69859126a$var$curveRadial($798528a69859126a$var$_linear.default);
module.exports.curveRadialLinear = $798528a69859126a$var$curveRadialLinear;
function $798528a69859126a$var$Radial(curve) {
    this._curve = curve;
}
$798528a69859126a$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $798528a69859126a$var$curveRadial(curve) {
    function radial(context) {
        return new $798528a69859126a$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRequire.register("lPsyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fe4483ab28e932b7$var$_default;
module.exports.lineRadial = $fe4483ab28e932b7$var$lineRadial;

var $fe4483ab28e932b7$var$_radial = $fe4483ab28e932b7$var$_interopRequireWildcard((parcelRequire("aqQDe")));

var $fe4483ab28e932b7$var$_line = $fe4483ab28e932b7$var$_interopRequireDefault((parcelRequire("gcxNy")));
function $fe4483ab28e932b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe4483ab28e932b7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fe4483ab28e932b7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fe4483ab28e932b7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fe4483ab28e932b7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fe4483ab28e932b7$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $fe4483ab28e932b7$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $fe4483ab28e932b7$var$_default() {
    return $fe4483ab28e932b7$var$lineRadial((0, $fe4483ab28e932b7$var$_line.default)().curve($fe4483ab28e932b7$var$_radial.curveRadialLinear));
}

});


parcelRequire.register("9LhmB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71b5f8dc9e9053fe$var$_default;
function $71b5f8dc9e9053fe$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRequire.register("bB7QD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $87193cdcbe37d9dc$var$link;
module.exports.linkHorizontal = $87193cdcbe37d9dc$var$linkHorizontal;
module.exports.linkRadial = $87193cdcbe37d9dc$var$linkRadial;
module.exports.linkVertical = $87193cdcbe37d9dc$var$linkVertical;

var $3Oifc = parcelRequire("3Oifc");

var $ejJqH = parcelRequire("ejJqH");

var $87193cdcbe37d9dc$var$_constant = $87193cdcbe37d9dc$var$_interopRequireDefault((parcelRequire("kktHL")));

var $930vn = parcelRequire("930vn");

var $3eut6 = parcelRequire("3eut6");
function $87193cdcbe37d9dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $87193cdcbe37d9dc$var$linkSource(d) {
    return d.source;
}
function $87193cdcbe37d9dc$var$linkTarget(d) {
    return d.target;
}
function $87193cdcbe37d9dc$var$link(curve) {
    let source = $87193cdcbe37d9dc$var$linkSource;
    let target = $87193cdcbe37d9dc$var$linkTarget;
    let x = $3eut6.x;
    let y = $3eut6.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $ejJqH.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $3Oifc.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $87193cdcbe37d9dc$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $87193cdcbe37d9dc$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $87193cdcbe37d9dc$var$linkHorizontal() {
    return $87193cdcbe37d9dc$var$link($930vn.bumpX);
}
function $87193cdcbe37d9dc$var$linkVertical() {
    return $87193cdcbe37d9dc$var$link($930vn.bumpY);
}
function $87193cdcbe37d9dc$var$linkRadial() {
    const l = $87193cdcbe37d9dc$var$link($930vn.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRequire.register("930vn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $6964c92c3068c960$var$bumpRadial;
module.exports.bumpX = $6964c92c3068c960$var$bumpX;
module.exports.bumpY = $6964c92c3068c960$var$bumpY;

var $6964c92c3068c960$var$_pointRadial = $6964c92c3068c960$var$_interopRequireDefault((parcelRequire("9LhmB")));
function $6964c92c3068c960$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $6964c92c3068c960$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $6964c92c3068c960$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $6964c92c3068c960$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $6964c92c3068c960$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $6964c92c3068c960$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $6964c92c3068c960$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $6964c92c3068c960$var$bumpX(context) {
    return new $6964c92c3068c960$var$Bump(context, true);
}
function $6964c92c3068c960$var$bumpY(context) {
    return new $6964c92c3068c960$var$Bump(context, false);
}
function $6964c92c3068c960$var$bumpRadial(context) {
    return new $6964c92c3068c960$var$BumpRadial(context);
}

});


parcelRequire.register("4fnAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $317adc824ebbf5eb$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $3Oifc = parcelRequire("3Oifc");

var $317adc824ebbf5eb$var$_constant = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("kktHL")));

var $317adc824ebbf5eb$var$_asterisk = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("5dvDL")));

var $317adc824ebbf5eb$var$_circle = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("l969W")));

var $317adc824ebbf5eb$var$_cross = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("8N9PA")));

var $317adc824ebbf5eb$var$_diamond = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("kWarP")));

var $317adc824ebbf5eb$var$_diamond2 = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("6nZ19")));

var $317adc824ebbf5eb$var$_plus = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("guSS4")));

var $317adc824ebbf5eb$var$_square = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("awFLa")));

var $317adc824ebbf5eb$var$_square2 = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("kh1ee")));

var $317adc824ebbf5eb$var$_star = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("3oewW")));

var $317adc824ebbf5eb$var$_triangle = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("cY1lJ")));

var $317adc824ebbf5eb$var$_triangle2 = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("dOwkg")));

var $317adc824ebbf5eb$var$_wye = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("3GZX2")));

var $317adc824ebbf5eb$var$_x = $317adc824ebbf5eb$var$_interopRequireDefault((parcelRequire("7VTFk")));
function $317adc824ebbf5eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $317adc824ebbf5eb$var$symbolsFill = [
    $317adc824ebbf5eb$var$_circle.default,
    $317adc824ebbf5eb$var$_cross.default,
    $317adc824ebbf5eb$var$_diamond.default,
    $317adc824ebbf5eb$var$_square.default,
    $317adc824ebbf5eb$var$_star.default,
    $317adc824ebbf5eb$var$_triangle.default,
    $317adc824ebbf5eb$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $317adc824ebbf5eb$var$symbolsFill;
const $317adc824ebbf5eb$var$symbolsStroke = [
    $317adc824ebbf5eb$var$_circle.default,
    $317adc824ebbf5eb$var$_plus.default,
    $317adc824ebbf5eb$var$_x.default,
    $317adc824ebbf5eb$var$_triangle2.default,
    $317adc824ebbf5eb$var$_asterisk.default,
    $317adc824ebbf5eb$var$_square2.default,
    $317adc824ebbf5eb$var$_diamond2.default
];
module.exports.symbolsStroke = $317adc824ebbf5eb$var$symbolsStroke;
function $317adc824ebbf5eb$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $317adc824ebbf5eb$var$_constant.default)(type || $317adc824ebbf5eb$var$_circle.default);
    size = typeof size === "function" ? size : (0, $317adc824ebbf5eb$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $3Oifc.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $317adc824ebbf5eb$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $317adc824ebbf5eb$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRequire.register("5dvDL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $3cc6b5c0b4b78591$var$sqrt3 = (0, $1Q1kL.sqrt)(3);
var $3cc6b5c0b4b78591$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size + (0, $1Q1kL.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $3cc6b5c0b4b78591$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $3cc6b5c0b4b78591$var$_default;

});

parcelRequire.register("l969W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $f64f3754e99ec6d3$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size / $1Q1kL.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $1Q1kL.tau);
    }
};
module.exports.default = $f64f3754e99ec6d3$var$_default;

});

parcelRequire.register("8N9PA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $666a8697f9ef2a5e$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $666a8697f9ef2a5e$var$_default;

});

parcelRequire.register("kWarP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $f3e15421ecfc0c3c$var$tan30 = (0, $1Q1kL.sqrt)(1 / 3);
const $f3e15421ecfc0c3c$var$tan30_2 = $f3e15421ecfc0c3c$var$tan30 * 2;
var $f3e15421ecfc0c3c$var$_default = {
    draw (context, size) {
        const y = (0, $1Q1kL.sqrt)(size / $f3e15421ecfc0c3c$var$tan30_2);
        const x = y * $f3e15421ecfc0c3c$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $f3e15421ecfc0c3c$var$_default;

});

parcelRequire.register("6nZ19", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $4a6438dac61c1e37$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $4a6438dac61c1e37$var$_default;

});

parcelRequire.register("guSS4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $c02a02f1d1267304$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size - (0, $1Q1kL.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $c02a02f1d1267304$var$_default;

});

parcelRequire.register("awFLa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $7a9d492c92e2b94d$var$_default = {
    draw (context, size) {
        const w = (0, $1Q1kL.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $7a9d492c92e2b94d$var$_default;

});

parcelRequire.register("kh1ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $ec26591ff984130d$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $ec26591ff984130d$var$_default;

});

parcelRequire.register("3oewW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $277ee263e49d865e$var$ka = 0.89081309152928522810;
const $277ee263e49d865e$var$kr = (0, $1Q1kL.sin)($1Q1kL.pi / 10) / (0, $1Q1kL.sin)(7 * $1Q1kL.pi / 10);
const $277ee263e49d865e$var$kx = (0, $1Q1kL.sin)($1Q1kL.tau / 10) * $277ee263e49d865e$var$kr;
const $277ee263e49d865e$var$ky = -(0, $1Q1kL.cos)($1Q1kL.tau / 10) * $277ee263e49d865e$var$kr;
var $277ee263e49d865e$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size * $277ee263e49d865e$var$ka);
        const x = $277ee263e49d865e$var$kx * r;
        const y = $277ee263e49d865e$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $1Q1kL.tau * i / 5;
            const c = (0, $1Q1kL.cos)(a);
            const s = (0, $1Q1kL.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $277ee263e49d865e$var$_default;

});

parcelRequire.register("cY1lJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $970c22a27ff4688f$var$sqrt3 = (0, $1Q1kL.sqrt)(3);
var $970c22a27ff4688f$var$_default = {
    draw (context, size) {
        const y = -(0, $1Q1kL.sqrt)(size / ($970c22a27ff4688f$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$970c22a27ff4688f$var$sqrt3 * y, -y);
        context.lineTo($970c22a27ff4688f$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $970c22a27ff4688f$var$_default;

});

parcelRequire.register("dOwkg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $a0e9051dedbf6158$var$sqrt3 = (0, $1Q1kL.sqrt)(3);
var $a0e9051dedbf6158$var$_default = {
    draw (context, size) {
        const s = (0, $1Q1kL.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $a0e9051dedbf6158$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $a0e9051dedbf6158$var$_default;

});

parcelRequire.register("3GZX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
const $2b05598f46215565$var$c = -0.5;
const $2b05598f46215565$var$s = (0, $1Q1kL.sqrt)(3) / 2;
const $2b05598f46215565$var$k = 1 / (0, $1Q1kL.sqrt)(12);
const $2b05598f46215565$var$a = ($2b05598f46215565$var$k / 2 + 1) * 3;
var $2b05598f46215565$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size / $2b05598f46215565$var$a);
        const x0 = r / 2, y0 = r * $2b05598f46215565$var$k;
        const x1 = x0, y1 = r * $2b05598f46215565$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($2b05598f46215565$var$c * x0 - $2b05598f46215565$var$s * y0, $2b05598f46215565$var$s * x0 + $2b05598f46215565$var$c * y0);
        context.lineTo($2b05598f46215565$var$c * x1 - $2b05598f46215565$var$s * y1, $2b05598f46215565$var$s * x1 + $2b05598f46215565$var$c * y1);
        context.lineTo($2b05598f46215565$var$c * x2 - $2b05598f46215565$var$s * y2, $2b05598f46215565$var$s * x2 + $2b05598f46215565$var$c * y2);
        context.lineTo($2b05598f46215565$var$c * x0 + $2b05598f46215565$var$s * y0, $2b05598f46215565$var$c * y0 - $2b05598f46215565$var$s * x0);
        context.lineTo($2b05598f46215565$var$c * x1 + $2b05598f46215565$var$s * y1, $2b05598f46215565$var$c * y1 - $2b05598f46215565$var$s * x1);
        context.lineTo($2b05598f46215565$var$c * x2 + $2b05598f46215565$var$s * y2, $2b05598f46215565$var$c * y2 - $2b05598f46215565$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $2b05598f46215565$var$_default;

});

parcelRequire.register("7VTFk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1Q1kL = parcelRequire("1Q1kL");
var $5c6909478864a759$var$_default = {
    draw (context, size) {
        const r = (0, $1Q1kL.sqrt)(size - (0, $1Q1kL.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $5c6909478864a759$var$_default;

});


parcelRequire.register("fdRyK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1519db4e87b330c$var$_default;

var $b1519db4e87b330c$var$_noop = $b1519db4e87b330c$var$_interopRequireDefault((parcelRequire("kLi5G")));

var $eEz9v = parcelRequire("eEz9v");
function $b1519db4e87b330c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1519db4e87b330c$var$BasisClosed(context) {
    this._context = context;
}
$b1519db4e87b330c$var$BasisClosed.prototype = {
    areaStart: $b1519db4e87b330c$var$_noop.default,
    areaEnd: $b1519db4e87b330c$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $eEz9v.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $b1519db4e87b330c$var$_default(context) {
    return new $b1519db4e87b330c$var$BasisClosed(context);
}

});
parcelRequire.register("kLi5G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1d63ae287dbda1e$var$_default;
function $f1d63ae287dbda1e$var$_default() {}

});

parcelRequire.register("eEz9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $aab011a3972ff97c$var$Basis;
module.exports.default = $aab011a3972ff97c$var$_default;
module.exports.point = $aab011a3972ff97c$var$point;
function $aab011a3972ff97c$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $aab011a3972ff97c$var$Basis(context) {
    this._context = context;
}
$aab011a3972ff97c$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $aab011a3972ff97c$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $aab011a3972ff97c$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $aab011a3972ff97c$var$_default(context) {
    return new $aab011a3972ff97c$var$Basis(context);
}

});


parcelRequire.register("h9Un5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7df011bbd586814$var$_default;

var $eEz9v = parcelRequire("eEz9v");
function $c7df011bbd586814$var$BasisOpen(context) {
    this._context = context;
}
$c7df011bbd586814$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $eEz9v.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $c7df011bbd586814$var$_default(context) {
    return new $c7df011bbd586814$var$BasisOpen(context);
}

});

parcelRequire.register("jSnsu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eEz9v = parcelRequire("eEz9v");
function $e78541d753b4bdc5$var$Bundle(context, beta) {
    this._basis = new $eEz9v.Basis(context);
    this._beta = beta;
}
$e78541d753b4bdc5$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $e78541d753b4bdc5$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $eEz9v.Basis(context) : new $e78541d753b4bdc5$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $e78541d753b4bdc5$var$_default;

});

parcelRequire.register("eaNfU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $a51834fc29a8f24a$var$CardinalClosed;
module.exports.default = void 0;

var $a51834fc29a8f24a$var$_noop = $a51834fc29a8f24a$var$_interopRequireDefault((parcelRequire("kLi5G")));

var $5kjd5 = parcelRequire("5kjd5");
function $a51834fc29a8f24a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a51834fc29a8f24a$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$a51834fc29a8f24a$var$CardinalClosed.prototype = {
    areaStart: $a51834fc29a8f24a$var$_noop.default,
    areaEnd: $a51834fc29a8f24a$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $5kjd5.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a51834fc29a8f24a$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $a51834fc29a8f24a$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $a51834fc29a8f24a$var$_default;

});
parcelRequire.register("5kjd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $3e0db8bc35e66fc0$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $3e0db8bc35e66fc0$var$point;
function $3e0db8bc35e66fc0$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $3e0db8bc35e66fc0$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3e0db8bc35e66fc0$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $3e0db8bc35e66fc0$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $3e0db8bc35e66fc0$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3e0db8bc35e66fc0$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $3e0db8bc35e66fc0$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $3e0db8bc35e66fc0$var$_default;

});


parcelRequire.register("300P3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $22f2028532138db5$var$CardinalOpen;
module.exports.default = void 0;

var $5kjd5 = parcelRequire("5kjd5");
function $22f2028532138db5$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$22f2028532138db5$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $5kjd5.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $22f2028532138db5$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $22f2028532138db5$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $22f2028532138db5$var$_default;

});

parcelRequire.register("6niaP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eaNfU = parcelRequire("eaNfU");

var $4a42fcf4745c4307$var$_noop = $4a42fcf4745c4307$var$_interopRequireDefault((parcelRequire("kLi5G")));

var $H7zH1 = parcelRequire("H7zH1");
function $4a42fcf4745c4307$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a42fcf4745c4307$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$4a42fcf4745c4307$var$CatmullRomClosed.prototype = {
    areaStart: $4a42fcf4745c4307$var$_noop.default,
    areaEnd: $4a42fcf4745c4307$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $H7zH1.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4a42fcf4745c4307$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $4a42fcf4745c4307$var$CatmullRomClosed(context, alpha) : new $eaNfU.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $4a42fcf4745c4307$var$_default;

});
parcelRequire.register("H7zH1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.point = $0819e471636b0f12$var$point;

var $1Q1kL = parcelRequire("1Q1kL");

var $5kjd5 = parcelRequire("5kjd5");
function $0819e471636b0f12$var$point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $1Q1kL.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $1Q1kL.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function $0819e471636b0f12$var$CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$0819e471636b0f12$var$CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $0819e471636b0f12$var$point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0819e471636b0f12$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $0819e471636b0f12$var$CatmullRom(context, alpha) : new $5kjd5.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $0819e471636b0f12$var$_default;

});


parcelRequire.register("7G4Ea", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $300P3 = parcelRequire("300P3");

var $H7zH1 = parcelRequire("H7zH1");
function $59700f6dbe1b9b03$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$59700f6dbe1b9b03$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $H7zH1.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $59700f6dbe1b9b03$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $59700f6dbe1b9b03$var$CatmullRomOpen(context, alpha) : new $300P3.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $59700f6dbe1b9b03$var$_default;

});

parcelRequire.register("2tiLX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1cccda0879f37bed$var$_default;

var $1cccda0879f37bed$var$_noop = $1cccda0879f37bed$var$_interopRequireDefault((parcelRequire("kLi5G")));
function $1cccda0879f37bed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1cccda0879f37bed$var$LinearClosed(context) {
    this._context = context;
}
$1cccda0879f37bed$var$LinearClosed.prototype = {
    areaStart: $1cccda0879f37bed$var$_noop.default,
    areaEnd: $1cccda0879f37bed$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $1cccda0879f37bed$var$_default(context) {
    return new $1cccda0879f37bed$var$LinearClosed(context);
}

});

parcelRequire.register("5TXew", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $44c0094b627a19a1$var$monotoneX;
module.exports.monotoneY = $44c0094b627a19a1$var$monotoneY;
function $44c0094b627a19a1$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $44c0094b627a19a1$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($44c0094b627a19a1$var$sign(s0) + $44c0094b627a19a1$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $44c0094b627a19a1$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $44c0094b627a19a1$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $44c0094b627a19a1$var$MonotoneX(context) {
    this._context = context;
}
$44c0094b627a19a1$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $44c0094b627a19a1$var$point(this, this._t0, $44c0094b627a19a1$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $44c0094b627a19a1$var$point(this, $44c0094b627a19a1$var$slope2(this, t1 = $44c0094b627a19a1$var$slope3(this, x, y)), t1);
                break;
            default:
                $44c0094b627a19a1$var$point(this, this._t0, t1 = $44c0094b627a19a1$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $44c0094b627a19a1$var$MonotoneY(context) {
    this._context = new $44c0094b627a19a1$var$ReflectContext(context);
}
($44c0094b627a19a1$var$MonotoneY.prototype = Object.create($44c0094b627a19a1$var$MonotoneX.prototype)).point = function(x, y) {
    $44c0094b627a19a1$var$MonotoneX.prototype.point.call(this, y, x);
};
function $44c0094b627a19a1$var$ReflectContext(context) {
    this._context = context;
}
$44c0094b627a19a1$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $44c0094b627a19a1$var$monotoneX(context) {
    return new $44c0094b627a19a1$var$MonotoneX(context);
}
function $44c0094b627a19a1$var$monotoneY(context) {
    return new $44c0094b627a19a1$var$MonotoneY(context);
}

});

parcelRequire.register("cPV27", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $95867d136bf0cea4$var$_default;
function $95867d136bf0cea4$var$Natural(context) {
    this._context = context;
}
$95867d136bf0cea4$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $95867d136bf0cea4$var$controlPoints(x), py = $95867d136bf0cea4$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $95867d136bf0cea4$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $95867d136bf0cea4$var$_default(context) {
    return new $95867d136bf0cea4$var$Natural(context);
}

});

parcelRequire.register("2q7zt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c33e1ed5efa5952$var$_default;
module.exports.stepAfter = $1c33e1ed5efa5952$var$stepAfter;
module.exports.stepBefore = $1c33e1ed5efa5952$var$stepBefore;
function $1c33e1ed5efa5952$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1c33e1ed5efa5952$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1c33e1ed5efa5952$var$_default(context) {
    return new $1c33e1ed5efa5952$var$Step(context, 0.5);
}
function $1c33e1ed5efa5952$var$stepBefore(context) {
    return new $1c33e1ed5efa5952$var$Step(context, 0);
}
function $1c33e1ed5efa5952$var$stepAfter(context) {
    return new $1c33e1ed5efa5952$var$Step(context, 1);
}

});

parcelRequire.register("gtjIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfdea602b80c03ad$var$_default;

var $bfdea602b80c03ad$var$_array = $bfdea602b80c03ad$var$_interopRequireDefault((parcelRequire("ejJqH")));

var $bfdea602b80c03ad$var$_constant = $bfdea602b80c03ad$var$_interopRequireDefault((parcelRequire("kktHL")));

var $bfdea602b80c03ad$var$_none = $bfdea602b80c03ad$var$_interopRequireDefault((parcelRequire("ft5tg")));

var $bfdea602b80c03ad$var$_none2 = $bfdea602b80c03ad$var$_interopRequireDefault((parcelRequire("isQ40")));
function $bfdea602b80c03ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfdea602b80c03ad$var$stackValue(d, key) {
    return d[key];
}
function $bfdea602b80c03ad$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $bfdea602b80c03ad$var$_default() {
    var keys = (0, $bfdea602b80c03ad$var$_constant.default)([]), order = $bfdea602b80c03ad$var$_none2.default, offset = $bfdea602b80c03ad$var$_none.default, value = $bfdea602b80c03ad$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $bfdea602b80c03ad$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $bfdea602b80c03ad$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $bfdea602b80c03ad$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $bfdea602b80c03ad$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $bfdea602b80c03ad$var$_none2.default : typeof _ === "function" ? _ : (0, $bfdea602b80c03ad$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $bfdea602b80c03ad$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRequire.register("ft5tg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b42dcee151690d60$var$_default;
function $b42dcee151690d60$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRequire.register("isQ40", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7133a42bce16962$var$_default;
function $d7133a42bce16962$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRequire.register("8fH0h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60211506b54b9071$var$_default;

var $60211506b54b9071$var$_none = $60211506b54b9071$var$_interopRequireDefault((parcelRequire("ft5tg")));
function $60211506b54b9071$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $60211506b54b9071$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $60211506b54b9071$var$_none.default)(series, order);
}

});

parcelRequire.register("ckPUG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8faf9f286ccdce9e$var$_default;
function $8faf9f286ccdce9e$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRequire.register("6uQse", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4bae3bc24e47ddd0$var$_default;

var $4bae3bc24e47ddd0$var$_none = $4bae3bc24e47ddd0$var$_interopRequireDefault((parcelRequire("ft5tg")));
function $4bae3bc24e47ddd0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4bae3bc24e47ddd0$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $4bae3bc24e47ddd0$var$_none.default)(series, order);
}

});

parcelRequire.register("1ABW5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1286947dc67a920c$var$_default;

var $1286947dc67a920c$var$_none = $1286947dc67a920c$var$_interopRequireDefault((parcelRequire("ft5tg")));
function $1286947dc67a920c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1286947dc67a920c$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $1286947dc67a920c$var$_none.default)(series, order);
}

});

parcelRequire.register("8cpDw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f835491a3dc9213$var$_default;

var $5f835491a3dc9213$var$_none = $5f835491a3dc9213$var$_interopRequireDefault((parcelRequire("isQ40")));
function $5f835491a3dc9213$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f835491a3dc9213$var$_default(series) {
    var peaks = series.map($5f835491a3dc9213$var$peak);
    return (0, $5f835491a3dc9213$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $5f835491a3dc9213$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRequire.register("aAng2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b4f4ea684092e8b$var$_default;
module.exports.sum = $7b4f4ea684092e8b$var$sum;

var $7b4f4ea684092e8b$var$_none = $7b4f4ea684092e8b$var$_interopRequireDefault((parcelRequire("isQ40")));
function $7b4f4ea684092e8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7b4f4ea684092e8b$var$_default(series) {
    var sums = series.map($7b4f4ea684092e8b$var$sum);
    return (0, $7b4f4ea684092e8b$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $7b4f4ea684092e8b$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRequire.register("9dX5H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b732a313d7ee4bd$var$_default;

var $6b732a313d7ee4bd$var$_ascending = $6b732a313d7ee4bd$var$_interopRequireDefault((parcelRequire("aAng2")));
function $6b732a313d7ee4bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b732a313d7ee4bd$var$_default(series) {
    return (0, $6b732a313d7ee4bd$var$_ascending.default)(series).reverse();
}

});

parcelRequire.register("tCVuS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0590e783ba5a6781$var$_default;

var $0590e783ba5a6781$var$_appearance = $0590e783ba5a6781$var$_interopRequireDefault((parcelRequire("8cpDw")));

var $aAng2 = parcelRequire("aAng2");
function $0590e783ba5a6781$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0590e783ba5a6781$var$_default(series) {
    var n = series.length, i, j, sums = series.map($aAng2.sum), order = (0, $0590e783ba5a6781$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRequire.register("jyaLZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3b98c97552f9f7e$var$_default;

var $e3b98c97552f9f7e$var$_none = $e3b98c97552f9f7e$var$_interopRequireDefault((parcelRequire("isQ40")));
function $e3b98c97552f9f7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e3b98c97552f9f7e$var$_default(series) {
    return (0, $e3b98c97552f9f7e$var$_none.default)(series).reverse();
}

});



parcelRequire.register("3P0iH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2c865e3b3c4e8ae9$var$ReactIs, $2c865e3b3c4e8ae9$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dLIfQ"))();

});
parcelRequire.register("dLIfQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $mMlYN = parcelRequire("mMlYN");
function $a061fe2a463e2757$var$emptyFunction() {}
function $a061fe2a463e2757$var$emptyFunctionWithReset() {}
$a061fe2a463e2757$var$emptyFunctionWithReset.resetWarningCache = $a061fe2a463e2757$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $mMlYN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a061fe2a463e2757$var$emptyFunctionWithReset,
        resetWarningCache: $a061fe2a463e2757$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("mMlYN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $0447903027eb89ff$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $0447903027eb89ff$var$ReactPropTypesSecret;

});



parcelRequire.register("4e8ah", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $313ecd9cb02cdf68$var$PropTypes = $313ecd9cb02cdf68$var$_interopRequireWildcard((parcelRequire("3P0iH")));

var $313ecd9cb02cdf68$var$_addClass = $313ecd9cb02cdf68$var$_interopRequireDefault((parcelRequire("lXIAr")));

var $313ecd9cb02cdf68$var$_removeClass = $313ecd9cb02cdf68$var$_interopRequireDefault((parcelRequire("cXV7E")));

var $313ecd9cb02cdf68$var$_react = $313ecd9cb02cdf68$var$_interopRequireDefault((parcelRequire("9KJkx")));

var $313ecd9cb02cdf68$var$_Transition = $313ecd9cb02cdf68$var$_interopRequireDefault((parcelRequire("dj5i3")));

function $313ecd9cb02cdf68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $313ecd9cb02cdf68$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $313ecd9cb02cdf68$var$_extends() {
    $313ecd9cb02cdf68$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $313ecd9cb02cdf68$var$_extends.apply(this, arguments);
}
function $313ecd9cb02cdf68$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $313ecd9cb02cdf68$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $313ecd9cb02cdf68$var$_addClass.default)(node, c);
    });
};
var $313ecd9cb02cdf68$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $313ecd9cb02cdf68$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $313ecd9cb02cdf68$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $313ecd9cb02cdf68$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $313ecd9cb02cdf68$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $313ecd9cb02cdf68$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $313ecd9cb02cdf68$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $313ecd9cb02cdf68$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $313ecd9cb02cdf68$var$removeClass(node, className);
        activeClassName && $313ecd9cb02cdf68$var$removeClass(node, activeClassName);
        doneClassName && $313ecd9cb02cdf68$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $313ecd9cb02cdf68$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $313ecd9cb02cdf68$var$_extends({}, this.props);
        delete props.classNames;
        return $313ecd9cb02cdf68$var$_react.default.createElement($313ecd9cb02cdf68$var$_Transition.default, $313ecd9cb02cdf68$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($313ecd9cb02cdf68$var$_react.default.Component);
$313ecd9cb02cdf68$var$CSSTransition.defaultProps = {
    classNames: ""
};
$313ecd9cb02cdf68$var$CSSTransition.propTypes = {};
var $313ecd9cb02cdf68$var$_default = $313ecd9cb02cdf68$var$CSSTransition;
module.exports.default = $313ecd9cb02cdf68$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("lXIAr", function(module, exports) {
"use strict";

var $caUNx = parcelRequire("caUNx");
module.exports.__esModule = true;
module.exports.default = $ffd1b1aa88a14a73$var$addClass;

var $ffd1b1aa88a14a73$var$_hasClass = $caUNx((parcelRequire("iYuH6")));
function $ffd1b1aa88a14a73$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $ffd1b1aa88a14a73$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRequire.register("caUNx", function(module, exports) {
function $8dd27a1bdb44a3cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $8dd27a1bdb44a3cc$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("iYuH6", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $dd05a3d7d521151d$var$hasClass;
function $dd05a3d7d521151d$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRequire.register("cXV7E", function(module, exports) {
"use strict";
function $97074e0af36b9346$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $97074e0af36b9346$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $97074e0af36b9346$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRequire.register("dj5i3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $9b012735e086c958$export$1e511d4a378977f5; }, function (v) { return $9b012735e086c958$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $9b012735e086c958$export$2e2bcd8739ae039; }, function (v) { return $9b012735e086c958$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $9b012735e086c958$export$4aacc83d4d59139f; }, function (v) { return $9b012735e086c958$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $9b012735e086c958$export$78e9e6e3e014d60a; }, function (v) { return $9b012735e086c958$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $9b012735e086c958$export$df38205c966be359; }, function (v) { return $9b012735e086c958$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $9b012735e086c958$export$84cbff306f539230; }, function (v) { return $9b012735e086c958$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $9b012735e086c958$export$bb38bb9a1161268; }, function (v) { return $9b012735e086c958$export$bb38bb9a1161268 = v; });
var $9b012735e086c958$export$1e511d4a378977f5;
var $9b012735e086c958$export$2e2bcd8739ae039;
var $9b012735e086c958$export$4aacc83d4d59139f;
var $9b012735e086c958$export$78e9e6e3e014d60a;
var $9b012735e086c958$export$df38205c966be359;
var $9b012735e086c958$export$84cbff306f539230;
var $9b012735e086c958$export$bb38bb9a1161268;
"use strict";
$9b012735e086c958$export$1e511d4a378977f5 = true;
$9b012735e086c958$export$2e2bcd8739ae039 = $9b012735e086c958$export$4aacc83d4d59139f = $9b012735e086c958$export$78e9e6e3e014d60a = $9b012735e086c958$export$df38205c966be359 = $9b012735e086c958$export$84cbff306f539230 = $9b012735e086c958$export$bb38bb9a1161268 = void 0;

var $9b012735e086c958$var$PropTypes = $9b012735e086c958$var$_interopRequireWildcard((parcelRequire("3P0iH")));

var $9b012735e086c958$var$_react = $9b012735e086c958$var$_interopRequireDefault((parcelRequire("9KJkx")));

var $9b012735e086c958$var$_reactDom = $9b012735e086c958$var$_interopRequireDefault((parcelRequire("lk0Tq")));

var $5o511 = parcelRequire("5o511");

function $9b012735e086c958$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b012735e086c958$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $9b012735e086c958$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9b012735e086c958$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9b012735e086c958$var$UNMOUNTED = "unmounted";
$9b012735e086c958$export$bb38bb9a1161268 = $9b012735e086c958$var$UNMOUNTED;
var $9b012735e086c958$var$EXITED = "exited";
$9b012735e086c958$export$84cbff306f539230 = $9b012735e086c958$var$EXITED;
var $9b012735e086c958$var$ENTERING = "entering";
$9b012735e086c958$export$df38205c966be359 = $9b012735e086c958$var$ENTERING;
var $9b012735e086c958$var$ENTERED = "entered";
$9b012735e086c958$export$78e9e6e3e014d60a = $9b012735e086c958$var$ENTERED;
var $9b012735e086c958$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $9b012735e086c958$export$4aacc83d4d59139f = $9b012735e086c958$var$EXITING;
var $9b012735e086c958$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $9b012735e086c958$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $9b012735e086c958$var$EXITED;
                _this.appearStatus = $9b012735e086c958$var$ENTERING;
            } else initialStatus = $9b012735e086c958$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $9b012735e086c958$var$UNMOUNTED;
        else initialStatus = $9b012735e086c958$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $9b012735e086c958$var$UNMOUNTED) return {
            status: $9b012735e086c958$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $9b012735e086c958$var$ENTERING && status !== $9b012735e086c958$var$ENTERED) nextStatus = $9b012735e086c958$var$ENTERING;
            } else if (status === $9b012735e086c958$var$ENTERING || status === $9b012735e086c958$var$ENTERED) nextStatus = $9b012735e086c958$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $9b012735e086c958$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $9b012735e086c958$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $9b012735e086c958$var$EXITED) this.setState({
            status: $9b012735e086c958$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $9b012735e086c958$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $9b012735e086c958$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $9b012735e086c958$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $9b012735e086c958$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $9b012735e086c958$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $9b012735e086c958$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $9b012735e086c958$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $9b012735e086c958$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $9b012735e086c958$var$_react.default.Children.only(children);
        return $9b012735e086c958$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($9b012735e086c958$var$_react.default.Component);
$9b012735e086c958$var$Transition.contextTypes = {
    transitionGroup: $9b012735e086c958$var$PropTypes.object
};
$9b012735e086c958$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$9b012735e086c958$var$Transition.propTypes = {};
function $9b012735e086c958$var$noop() {}
$9b012735e086c958$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $9b012735e086c958$var$noop,
    onEntering: $9b012735e086c958$var$noop,
    onEntered: $9b012735e086c958$var$noop,
    onExit: $9b012735e086c958$var$noop,
    onExiting: $9b012735e086c958$var$noop,
    onExited: $9b012735e086c958$var$noop
};
$9b012735e086c958$var$Transition.UNMOUNTED = 0;
$9b012735e086c958$var$Transition.EXITED = 1;
$9b012735e086c958$var$Transition.ENTERING = 2;
$9b012735e086c958$var$Transition.ENTERED = 3;
$9b012735e086c958$var$Transition.EXITING = 4;
var $9b012735e086c958$var$_default = (0, $5o511.polyfill)($9b012735e086c958$var$Transition);
$9b012735e086c958$export$2e2bcd8739ae039 = $9b012735e086c958$var$_default;

});
parcelRequire.register("5o511", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $3ec315972edda65a$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $3ec315972edda65a$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $3ec315972edda65a$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $3ec315972edda65a$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$3ec315972edda65a$var$componentWillMount.__suppressDeprecationWarning = true;
$3ec315972edda65a$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$3ec315972edda65a$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $3ec315972edda65a$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $3ec315972edda65a$var$componentWillMount;
        prototype.componentWillReceiveProps = $3ec315972edda65a$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $3ec315972edda65a$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRequire.register("i0Zus", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $d1d7ecc776825560$var$_propTypes = $d1d7ecc776825560$var$_interopRequireDefault((parcelRequire("3P0iH")));

var $d1d7ecc776825560$var$_react = $d1d7ecc776825560$var$_interopRequireDefault((parcelRequire("9KJkx")));

var $lk0Tq = parcelRequire("lk0Tq");

var $d1d7ecc776825560$var$_TransitionGroup = $d1d7ecc776825560$var$_interopRequireDefault((parcelRequire("iAsDd")));
function $d1d7ecc776825560$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d1d7ecc776825560$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d1d7ecc776825560$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $d1d7ecc776825560$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $d1d7ecc776825560$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $d1d7ecc776825560$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $lk0Tq.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $d1d7ecc776825560$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $d1d7ecc776825560$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $d1d7ecc776825560$var$_react.default.createElement($d1d7ecc776825560$var$_TransitionGroup.default, props, inProp ? $d1d7ecc776825560$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $d1d7ecc776825560$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($d1d7ecc776825560$var$_react.default.Component);
$d1d7ecc776825560$var$ReplaceTransition.propTypes = {};
var $d1d7ecc776825560$var$_default = $d1d7ecc776825560$var$ReplaceTransition;
module.exports.default = $d1d7ecc776825560$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("iAsDd", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $d881cc6718940ef9$var$_propTypes = $d881cc6718940ef9$var$_interopRequireDefault((parcelRequire("3P0iH")));

var $d881cc6718940ef9$var$_react = $d881cc6718940ef9$var$_interopRequireDefault((parcelRequire("9KJkx")));

var $5o511 = parcelRequire("5o511");

var $clGWf = parcelRequire("clGWf");
function $d881cc6718940ef9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d881cc6718940ef9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d881cc6718940ef9$var$_extends() {
    $d881cc6718940ef9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d881cc6718940ef9$var$_extends.apply(this, arguments);
}
function $d881cc6718940ef9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $d881cc6718940ef9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $d881cc6718940ef9$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $d881cc6718940ef9$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $d881cc6718940ef9$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $d881cc6718940ef9$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($d881cc6718940ef9$var$_assertThisInitialized($d881cc6718940ef9$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $clGWf.getInitialChildMapping)(nextProps, handleExited) : (0, $clGWf.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $clGWf.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $d881cc6718940ef9$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $d881cc6718940ef9$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $d881cc6718940ef9$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $d881cc6718940ef9$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($d881cc6718940ef9$var$_react.default.Component);
$d881cc6718940ef9$var$TransitionGroup.childContextTypes = {
    transitionGroup: $d881cc6718940ef9$var$_propTypes.default.object.isRequired
};
$d881cc6718940ef9$var$TransitionGroup.propTypes = {};
$d881cc6718940ef9$var$TransitionGroup.defaultProps = $d881cc6718940ef9$var$defaultProps;
var $d881cc6718940ef9$var$_default = (0, $5o511.polyfill)($d881cc6718940ef9$var$TransitionGroup);
module.exports.default = $d881cc6718940ef9$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("clGWf", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $8fd8c0e735d99271$export$bbc8a025727ea824; }, function (v) { return $8fd8c0e735d99271$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $8fd8c0e735d99271$export$fa71e2345c31d7a2; }, function (v) { return $8fd8c0e735d99271$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $8fd8c0e735d99271$export$36fd1af28d383ec0; }, function (v) { return $8fd8c0e735d99271$export$36fd1af28d383ec0 = v; });
var $8fd8c0e735d99271$export$1e511d4a378977f5;
var $8fd8c0e735d99271$export$bbc8a025727ea824;
var $8fd8c0e735d99271$export$7a874f95ccf533dd;
var $8fd8c0e735d99271$export$fa71e2345c31d7a2;
var $8fd8c0e735d99271$export$36fd1af28d383ec0;
"use strict";
$8fd8c0e735d99271$export$1e511d4a378977f5 = true;
$8fd8c0e735d99271$export$bbc8a025727ea824 = $8fd8c0e735d99271$var$getChildMapping;
$8fd8c0e735d99271$export$7a874f95ccf533dd = $8fd8c0e735d99271$var$mergeChildMappings;
$8fd8c0e735d99271$export$fa71e2345c31d7a2 = $8fd8c0e735d99271$var$getInitialChildMapping;
$8fd8c0e735d99271$export$36fd1af28d383ec0 = $8fd8c0e735d99271$var$getNextChildMapping;

var $9KJkx = parcelRequire("9KJkx");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $8fd8c0e735d99271$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $9KJkx.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $9KJkx.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $8fd8c0e735d99271$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $8fd8c0e735d99271$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $8fd8c0e735d99271$var$getInitialChildMapping(props, onExited) {
    return $8fd8c0e735d99271$var$getChildMapping(props.children, function(child) {
        return (0, $9KJkx.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $8fd8c0e735d99271$var$getProp(child, "appear", props),
            enter: $8fd8c0e735d99271$var$getProp(child, "enter", props),
            exit: $8fd8c0e735d99271$var$getProp(child, "exit", props)
        });
    });
}
function $8fd8c0e735d99271$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $8fd8c0e735d99271$var$getChildMapping(nextProps.children);
    var children = $8fd8c0e735d99271$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $9KJkx.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $9KJkx.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $9KJkx.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $8fd8c0e735d99271$var$getProp(child, "exit", nextProps),
            enter: $8fd8c0e735d99271$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $9KJkx.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $9KJkx.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $9KJkx.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $8fd8c0e735d99271$var$getProp(child, "exit", nextProps),
            enter: $8fd8c0e735d99271$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



function $dc4dfe08a56070a6$export$1a288977efa87e02() {
    const details = document.querySelectorAll(".js-details");
    details.forEach((element)=>{
        element.addEventListener("toggle", function() {
            const summary = element.querySelector("summary span");
            const textClosed = summary?.dataset.textClosed;
            const textOpen = summary?.dataset.textOpen;
            if (!summary || !textClosed || !textOpen) return;
            if (element.open) summary.textContent = textOpen;
            else summary.textContent = textClosed;
        });
    });
}


function $d04805db938379b5$export$2e2bcd8739ae039() {
    const section = document.querySelectorAll(".js-factsheet-section");
    window.addEventListener("scroll", ()=>{
        section.forEach((element)=>{
            const link = document.querySelector(`a[href='#${element.id}']`);
            if (element.getBoundingClientRect().top <= 0.5 && element.getBoundingClientRect().bottom >= 0.5) link?.classList.add("active");
            else link?.classList.remove("active");
        });
    });
}


function $484b67efc9cd0e78$export$2e2bcd8739ae039() {
    const header = document.querySelector("#js-header");
    const menu = document.querySelector("#js-menu-sandwich");
    const menuText = menu?.querySelector("span");
    if (!header || !menu || !menuText) return;
    const openText = menuText.dataset.open ?? "Menu";
    const closeText = menuText.dataset.close ?? "Close";
    menu.addEventListener("click", ()=>{
        header.classList.toggle("menu-open");
        menuText.textContent = header.classList.contains("menu-open") ? closeText : openText;
    });
}


var $25a891b5df1b0dc7$exports = {};
"use strict";

$25a891b5df1b0dc7$exports = (parcelRequire("jFRSQ"));


var $d9c73ad69b0d6fe9$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $d9c73ad69b0d6fe9$exports) {
        classNames.default = classNames;
        $d9c73ad69b0d6fe9$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $9KJkx = parcelRequire("9KJkx");
var $bcfd25cead63bedb$export$882461b6382ed46c;
var $bcfd25cead63bedb$export$757ceba2d55c277e;
"use strict";

var $lk0Tq = parcelRequire("lk0Tq");
var $bcfd25cead63bedb$var$i;
$bcfd25cead63bedb$export$882461b6382ed46c = $lk0Tq.createRoot;
$bcfd25cead63bedb$export$757ceba2d55c277e = $lk0Tq.hydrateRoot;


var $2c9e117f21850d30$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($2c9e117f21850d30$export$7debb50ef11d5e0b || ($2c9e117f21850d30$export$7debb50ef11d5e0b = {}));
var $2c9e117f21850d30$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($2c9e117f21850d30$export$4aa2142c225fd5c7 || ($2c9e117f21850d30$export$4aa2142c225fd5c7 = {}));
const $2c9e117f21850d30$export$5716da67bfaa244d = $2c9e117f21850d30$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $2c9e117f21850d30$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $2c9e117f21850d30$export$5716da67bfaa244d.undefined;
        case "string":
            return $2c9e117f21850d30$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $2c9e117f21850d30$export$5716da67bfaa244d.nan : $2c9e117f21850d30$export$5716da67bfaa244d.number;
        case "boolean":
            return $2c9e117f21850d30$export$5716da67bfaa244d.boolean;
        case "function":
            return $2c9e117f21850d30$export$5716da67bfaa244d.function;
        case "bigint":
            return $2c9e117f21850d30$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $2c9e117f21850d30$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $2c9e117f21850d30$export$5716da67bfaa244d.array;
            if (data === null) return $2c9e117f21850d30$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $2c9e117f21850d30$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $2c9e117f21850d30$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $2c9e117f21850d30$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $2c9e117f21850d30$export$5716da67bfaa244d.date;
            return $2c9e117f21850d30$export$5716da67bfaa244d.object;
        default:
            return $2c9e117f21850d30$export$5716da67bfaa244d.unknown;
    }
};
const $2c9e117f21850d30$export$5ba560653e4a1035 = $2c9e117f21850d30$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $2c9e117f21850d30$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $2c9e117f21850d30$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $2c9e117f21850d30$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$2c9e117f21850d30$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $2c9e117f21850d30$export$f98dac4b251ab333(issues);
    return error;
};
const $2c9e117f21850d30$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $2c9e117f21850d30$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $2c9e117f21850d30$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$2c9e117f21850d30$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$2c9e117f21850d30$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$2c9e117f21850d30$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $2c9e117f21850d30$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $2c9e117f21850d30$var$overrideErrorMap = $2c9e117f21850d30$export$341b0b6e0a6f5099;
function $2c9e117f21850d30$export$1097a8289cfd22d7(map) {
    $2c9e117f21850d30$var$overrideErrorMap = map;
}
function $2c9e117f21850d30$export$32f27c719778d4c4() {
    return $2c9e117f21850d30$var$overrideErrorMap;
}
const $2c9e117f21850d30$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $2c9e117f21850d30$export$1526d2e05f74572 = [];
function $2c9e117f21850d30$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $2c9e117f21850d30$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $2c9e117f21850d30$export$32f27c719778d4c4(),
            $2c9e117f21850d30$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $2c9e117f21850d30$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $2c9e117f21850d30$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $2c9e117f21850d30$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $2c9e117f21850d30$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $2c9e117f21850d30$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $2c9e117f21850d30$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $2c9e117f21850d30$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $2c9e117f21850d30$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $2c9e117f21850d30$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($2c9e117f21850d30$var$errorUtil || ($2c9e117f21850d30$var$errorUtil = {}));
class $2c9e117f21850d30$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $2c9e117f21850d30$var$handleResult = (ctx, result)=>{
    if ($2c9e117f21850d30$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $2c9e117f21850d30$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $2c9e117f21850d30$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $2c9e117f21850d30$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $2c9e117f21850d30$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $2c9e117f21850d30$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $2c9e117f21850d30$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($2c9e117f21850d30$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2c9e117f21850d30$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $2c9e117f21850d30$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $2c9e117f21850d30$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($2c9e117f21850d30$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $2c9e117f21850d30$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $2c9e117f21850d30$export$a60af00cc0ce2582({
            schema: this,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $2c9e117f21850d30$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $2c9e117f21850d30$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $2c9e117f21850d30$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $2c9e117f21850d30$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $2c9e117f21850d30$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $2c9e117f21850d30$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $2c9e117f21850d30$export$a60af00cc0ce2582({
            ...$2c9e117f21850d30$var$processCreateParams(this._def),
            schema: this,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2c9e117f21850d30$export$bb19b37874861e7e({
            ...$2c9e117f21850d30$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $2c9e117f21850d30$export$66b0c798a395271f({
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$2c9e117f21850d30$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $2c9e117f21850d30$export$75a44ec6249ac76b({
            ...$2c9e117f21850d30$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $2c9e117f21850d30$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $2c9e117f21850d30$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $2c9e117f21850d30$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $2c9e117f21850d30$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $2c9e117f21850d30$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $2c9e117f21850d30$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $2c9e117f21850d30$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $2c9e117f21850d30$var$emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
const $2c9e117f21850d30$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $2c9e117f21850d30$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $2c9e117f21850d30$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $2c9e117f21850d30$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $2c9e117f21850d30$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $2c9e117f21850d30$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $2c9e117f21850d30$export$1230eb29b8d3b502 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._regex = (regex, validation, message)=>this.refinement((data)=>regex.test(data), {
                validation: validation,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
            });
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ this.nonempty = (message)=>this.min(1, $2c9e117f21850d30$var$errorUtil.errToObj(message));
        this.trim = ()=>new $2c9e117f21850d30$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "trim"
                    }
                ]
            });
        this.toLowerCase = ()=>new $2c9e117f21850d30$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toLowerCase"
                    }
                ]
            });
        this.toUpperCase = ()=>new $2c9e117f21850d30$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toUpperCase"
                    }
                ]
            });
    }
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const status = new $2c9e117f21850d30$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$2c9e117f21850d30$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$2c9e117f21850d30$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$2c9e117f21850d30$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$2c9e117f21850d30$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$2c9e117f21850d30$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$2c9e117f21850d30$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $2c9e117f21850d30$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$2c9e117f21850d30$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _addCheck(check) {
        return new $2c9e117f21850d30$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$2c9e117f21850d30$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$2c9e117f21850d30$var$errorUtil.errToObj(message)
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2c9e117f21850d30$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $2c9e117f21850d30$export$1230eb29b8d3b502({
        checks: [],
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $2c9e117f21850d30$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $2c9e117f21850d30$export$5b070a55c0c43e09 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2c9e117f21850d30$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$2c9e117f21850d30$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($2c9e117f21850d30$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2c9e117f21850d30$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2c9e117f21850d30$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2c9e117f21850d30$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $2c9e117f21850d30$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$2c9e117f21850d30$export$5b070a55c0c43e09.create = (params)=>{
    return new $2c9e117f21850d30$export$5b070a55c0c43e09({
        checks: [],
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$67d741fd70ff98f4 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $2c9e117f21850d30$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $2c9e117f21850d30$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $2c9e117f21850d30$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $2c9e117f21850d30$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $2c9e117f21850d30$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$2c9e117f21850d30$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $2c9e117f21850d30$export$67d741fd70ff98f4({
        checks: [],
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$723d146f80596191 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$723d146f80596191.create = (params)=>{
    return new $2c9e117f21850d30$export$723d146f80596191({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$e974be33bdc55521 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_date
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const status = new $2c9e117f21850d30$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $2c9e117f21850d30$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $2c9e117f21850d30$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$2c9e117f21850d30$export$e974be33bdc55521.create = (params)=>{
    return new $2c9e117f21850d30$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodDate,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$bcc3b40f6b638044 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$bcc3b40f6b638044.create = (params)=>{
    return new $2c9e117f21850d30$export$bcc3b40f6b638044({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodSymbol,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$4e780e961c30340d extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$4e780e961c30340d.create = (params)=>{
    return new $2c9e117f21850d30$export$4e780e961c30340d({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodUndefined,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$a96281f914484f2d extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$a96281f914484f2d.create = (params)=>{
    return new $2c9e117f21850d30$export$a96281f914484f2d({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNull,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$b9d1edb536b4e4eb extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $2c9e117f21850d30$export$b9d1edb536b4e4eb({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodAny,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$ef3b1bb1630977ae extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$ef3b1bb1630977ae.create = (params)=>{
    return new $2c9e117f21850d30$export$ef3b1bb1630977ae({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodUnknown,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$1e576a20c3ce9fb5 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
            code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
            expected: $2c9e117f21850d30$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $2c9e117f21850d30$export$9a105a556e65c2c0;
    }
}
$2c9e117f21850d30$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $2c9e117f21850d30$export$1e576a20c3ce9fb5({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNever,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$7d39f5df85f21031 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
}
$2c9e117f21850d30$export$7d39f5df85f21031.create = (params)=>{
    return new $2c9e117f21850d30$export$7d39f5df85f21031({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodVoid,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$7acfc3e64785411 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.array) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $2c9e117f21850d30$export$5ba560653e4a1035.too_big : $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $2c9e117f21850d30$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $2c9e117f21850d30$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $2c9e117f21850d30$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $2c9e117f21850d30$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $2c9e117f21850d30$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $2c9e117f21850d30$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2c9e117f21850d30$export$7acfc3e64785411.create = (schema, params)=>{
    return new $2c9e117f21850d30$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodArray,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
function $2c9e117f21850d30$var$deepPartialify(schema) {
    if (schema instanceof $2c9e117f21850d30$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $2c9e117f21850d30$export$aa56fec1e9d629b8.create($2c9e117f21850d30$var$deepPartialify(fieldSchema));
        }
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $2c9e117f21850d30$export$7acfc3e64785411) return new $2c9e117f21850d30$export$7acfc3e64785411({
        ...schema._def,
        type: $2c9e117f21850d30$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $2c9e117f21850d30$export$aa56fec1e9d629b8) return $2c9e117f21850d30$export$aa56fec1e9d629b8.create($2c9e117f21850d30$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2c9e117f21850d30$export$aaac0b8b429cef5) return $2c9e117f21850d30$export$aaac0b8b429cef5.create($2c9e117f21850d30$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $2c9e117f21850d30$export$e2a18bb771d8e6a3) return $2c9e117f21850d30$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$2c9e117f21850d30$var$deepPartialify(item)));
    else return schema;
}
class $2c9e117f21850d30$export$736315c5b55efbad extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $2c9e117f21850d30$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $2c9e117f21850d30$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                        code: $2c9e117f21850d30$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $2c9e117f21850d30$var$errorUtil.errToObj;
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $2c9e117f21850d30$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $2c9e117f21850d30$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $2c9e117f21850d30$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $2c9e117f21850d30$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $2c9e117f21850d30$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $2c9e117f21850d30$var$createZodEnum($2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$2c9e117f21850d30$export$736315c5b55efbad.create = (shape, params)=>{
    return new $2c9e117f21850d30$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $2c9e117f21850d30$export$1e576a20c3ce9fb5.create(),
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodObject,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
$2c9e117f21850d30$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $2c9e117f21850d30$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $2c9e117f21850d30$export$1e576a20c3ce9fb5.create(),
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodObject,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
$2c9e117f21850d30$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $2c9e117f21850d30$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $2c9e117f21850d30$export$1e576a20c3ce9fb5.create(),
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodObject,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$a8b236cb5070a311 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $2c9e117f21850d30$export$f98dac4b251ab333(result.ctx.common.issues));
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $2c9e117f21850d30$export$f98dac4b251ab333(issues));
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$2c9e117f21850d30$export$a8b236cb5070a311.create = (types, params)=>{
    return new $2c9e117f21850d30$export$a8b236cb5070a311({
        options: types,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodUnion,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $2c9e117f21850d30$var$getDiscriminator = (type)=>{
    if (type instanceof $2c9e117f21850d30$export$378d0cfce37406e6) return $2c9e117f21850d30$var$getDiscriminator(type.schema);
    else if (type instanceof $2c9e117f21850d30$export$a60af00cc0ce2582) return $2c9e117f21850d30$var$getDiscriminator(type.innerType());
    else if (type instanceof $2c9e117f21850d30$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $2c9e117f21850d30$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $2c9e117f21850d30$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $2c9e117f21850d30$export$bb19b37874861e7e) return $2c9e117f21850d30$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $2c9e117f21850d30$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $2c9e117f21850d30$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $2c9e117f21850d30$export$5ef2424805ac76a3 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.object) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $2c9e117f21850d30$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $2c9e117f21850d30$export$5ef2424805ac76a3({
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$2c9e117f21850d30$var$processCreateParams(params)
        });
    }
}
function $2c9e117f21850d30$var$mergeValues(a, b) {
    const aType = $2c9e117f21850d30$export$3e9057828ebd5c7a(a);
    const bType = $2c9e117f21850d30$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $2c9e117f21850d30$export$5716da67bfaa244d.object && bType === $2c9e117f21850d30$export$5716da67bfaa244d.object) {
        const bKeys = $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $2c9e117f21850d30$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $2c9e117f21850d30$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $2c9e117f21850d30$export$5716da67bfaa244d.array && bType === $2c9e117f21850d30$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $2c9e117f21850d30$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $2c9e117f21850d30$export$5716da67bfaa244d.date && bType === $2c9e117f21850d30$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $2c9e117f21850d30$export$c02deaf0bb5203d4 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($2c9e117f21850d30$export$afa861e3c5730743(parsedLeft) || $2c9e117f21850d30$export$afa861e3c5730743(parsedRight)) return $2c9e117f21850d30$export$9a105a556e65c2c0;
            const merged = $2c9e117f21850d30$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $2c9e117f21850d30$export$9a105a556e65c2c0;
            }
            if ($2c9e117f21850d30$export$910b6cdd390341b3(parsedLeft) || $2c9e117f21850d30$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$2c9e117f21850d30$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $2c9e117f21850d30$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodIntersection,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$e2a18bb771d8e6a3 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.array) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $2c9e117f21850d30$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$2c9e117f21850d30$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $2c9e117f21850d30$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$a2acc09968cb4b7f extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.object) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $2c9e117f21850d30$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $2c9e117f21850d30$export$19342e026b58ebb7) return new $2c9e117f21850d30$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodRecord,
            ...$2c9e117f21850d30$var$processCreateParams(third)
        });
        return new $2c9e117f21850d30$export$a2acc09968cb4b7f({
            keyType: $2c9e117f21850d30$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodRecord,
            ...$2c9e117f21850d30$var$processCreateParams(second)
        });
    }
}
class $2c9e117f21850d30$export$163b6a2b712d9542 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.map) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$2c9e117f21850d30$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $2c9e117f21850d30$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodMap,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$977057706f816712 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.set) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $2c9e117f21850d30$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $2c9e117f21850d30$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $2c9e117f21850d30$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $2c9e117f21850d30$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $2c9e117f21850d30$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$2c9e117f21850d30$export$977057706f816712.create = (valueType, params)=>{
    return new $2c9e117f21850d30$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodSet,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$d4602ba55673f53c extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.function) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $2c9e117f21850d30$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2c9e117f21850d30$export$32f27c719778d4c4(),
                    $2c9e117f21850d30$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $2c9e117f21850d30$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $2c9e117f21850d30$export$32f27c719778d4c4(),
                    $2c9e117f21850d30$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $2c9e117f21850d30$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2c9e117f21850d30$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $2c9e117f21850d30$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $2c9e117f21850d30$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $2c9e117f21850d30$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $2c9e117f21850d30$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $2c9e117f21850d30$export$d4602ba55673f53c({
            ...this._def,
            args: $2c9e117f21850d30$export$e2a18bb771d8e6a3.create(items).rest($2c9e117f21850d30$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $2c9e117f21850d30$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $2c9e117f21850d30$export$d4602ba55673f53c({
            args: args ? args : $2c9e117f21850d30$export$e2a18bb771d8e6a3.create([]).rest($2c9e117f21850d30$export$ef3b1bb1630977ae.create()),
            returns: returns || $2c9e117f21850d30$export$ef3b1bb1630977ae.create(),
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodFunction,
            ...$2c9e117f21850d30$var$processCreateParams(params)
        });
    }
}
class $2c9e117f21850d30$export$378d0cfce37406e6 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$2c9e117f21850d30$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $2c9e117f21850d30$export$378d0cfce37406e6({
        getter: getter,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodLazy,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$7e44096782a165d3 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$2c9e117f21850d30$export$7e44096782a165d3.create = (value, params)=>{
    return new $2c9e117f21850d30$export$7e44096782a165d3({
        value: value,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodLiteral,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
function $2c9e117f21850d30$var$createZodEnum(values, params) {
    return new $2c9e117f21850d30$export$d325d1f0e1c20179({
        values: values,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodEnum,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
}
class $2c9e117f21850d30$export$d325d1f0e1c20179 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                expected: $2c9e117f21850d30$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $2c9e117f21850d30$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $2c9e117f21850d30$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$2c9e117f21850d30$export$d325d1f0e1c20179.create = $2c9e117f21850d30$var$createZodEnum;
class $2c9e117f21850d30$export$370b2e8d6d6f5c56 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $2c9e117f21850d30$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.string && ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.number) {
            const expectedValues = $2c9e117f21850d30$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                expected: $2c9e117f21850d30$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $2c9e117f21850d30$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$2c9e117f21850d30$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $2c9e117f21850d30$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNativeEnum,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$3f196b0127d6e50a extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $2c9e117f21850d30$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $2c9e117f21850d30$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$2c9e117f21850d30$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $2c9e117f21850d30$export$3f196b0127d6e50a({
        type: schema,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodPromise,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$a60af00cc0ce2582 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $2c9e117f21850d30$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $2c9e117f21850d30$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$2c9e117f21850d30$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$2c9e117f21850d30$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $2c9e117f21850d30$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$2c9e117f21850d30$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $2c9e117f21850d30$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
$2c9e117f21850d30$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $2c9e117f21850d30$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodEffects,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$aa56fec1e9d629b8 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2c9e117f21850d30$export$5716da67bfaa244d.undefined) return $2c9e117f21850d30$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2c9e117f21850d30$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $2c9e117f21850d30$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodOptional,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$aaac0b8b429cef5 extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $2c9e117f21850d30$export$5716da67bfaa244d.null) return $2c9e117f21850d30$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$2c9e117f21850d30$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $2c9e117f21850d30$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNullable,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$bb19b37874861e7e extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $2c9e117f21850d30$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$2c9e117f21850d30$export$bb19b37874861e7e.create = (type, params)=>{
    return new $2c9e117f21850d30$export$bb19b37874861e7e({
        innerType: type,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$75a44ec6249ac76b extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($2c9e117f21850d30$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $2c9e117f21850d30$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $2c9e117f21850d30$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$2c9e117f21850d30$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $2c9e117f21850d30$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
class $2c9e117f21850d30$export$26ccfa0145e8511f extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $2c9e117f21850d30$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $2c9e117f21850d30$export$db7caee60e5d514d(ctx, {
                code: $2c9e117f21850d30$export$5ba560653e4a1035.invalid_type,
                expected: $2c9e117f21850d30$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $2c9e117f21850d30$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$2c9e117f21850d30$export$26ccfa0145e8511f.create = (params)=>{
    return new $2c9e117f21850d30$export$26ccfa0145e8511f({
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodNaN,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
const $2c9e117f21850d30$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $2c9e117f21850d30$export$66b0c798a395271f extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $2c9e117f21850d30$export$a3c3ef8a0e95c6da extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $2c9e117f21850d30$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $2c9e117f21850d30$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $2c9e117f21850d30$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $2c9e117f21850d30$export$5d1f7ef05c4e493a extends $2c9e117f21850d30$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($2c9e117f21850d30$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$2c9e117f21850d30$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $2c9e117f21850d30$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $2c9e117f21850d30$export$558106ce543bd011.ZodReadonly,
        ...$2c9e117f21850d30$var$processCreateParams(params)
    });
};
const $2c9e117f21850d30$export$4c00f665f0d4b443 = (check, params = {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $2c9e117f21850d30$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $2c9e117f21850d30$export$b9d1edb536b4e4eb.create();
};
const $2c9e117f21850d30$export$1ee8ee30835eab8b = {
    object: $2c9e117f21850d30$export$736315c5b55efbad.lazycreate
};
var $2c9e117f21850d30$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($2c9e117f21850d30$export$558106ce543bd011 || ($2c9e117f21850d30$export$558106ce543bd011 = {}));
const $2c9e117f21850d30$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$2c9e117f21850d30$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $2c9e117f21850d30$export$22b082955e083ec3 = $2c9e117f21850d30$export$1230eb29b8d3b502.create;
const $2c9e117f21850d30$export$98e628dec113755e = $2c9e117f21850d30$export$5b070a55c0c43e09.create;
const $2c9e117f21850d30$export$9e06de0973666692 = $2c9e117f21850d30$export$26ccfa0145e8511f.create;
const $2c9e117f21850d30$export$a0f65b52274bcc00 = $2c9e117f21850d30$export$67d741fd70ff98f4.create;
const $2c9e117f21850d30$export$4a21f16c33752377 = $2c9e117f21850d30$export$723d146f80596191.create;
const $2c9e117f21850d30$export$324d90190a8b822a = $2c9e117f21850d30$export$e974be33bdc55521.create;
const $2c9e117f21850d30$export$8f701197936bc2a6 = $2c9e117f21850d30$export$bcc3b40f6b638044.create;
const $2c9e117f21850d30$export$1db45310990710a5 = $2c9e117f21850d30$export$4e780e961c30340d.create;
const $2c9e117f21850d30$export$7b1b591b262c240 = $2c9e117f21850d30$export$a96281f914484f2d.create;
const $2c9e117f21850d30$export$4154a199d7d90455 = $2c9e117f21850d30$export$b9d1edb536b4e4eb.create;
const $2c9e117f21850d30$export$19282c40b967aec6 = $2c9e117f21850d30$export$ef3b1bb1630977ae.create;
const $2c9e117f21850d30$export$b3e22bcfd64c1022 = $2c9e117f21850d30$export$1e576a20c3ce9fb5.create;
const $2c9e117f21850d30$export$490e536ee7389aeb = $2c9e117f21850d30$export$7d39f5df85f21031.create;
const $2c9e117f21850d30$export$2f23118c22fb2630 = $2c9e117f21850d30$export$7acfc3e64785411.create;
const $2c9e117f21850d30$export$be5493f9613cbbe = $2c9e117f21850d30$export$736315c5b55efbad.create;
const $2c9e117f21850d30$export$8fb0df5f40d0b477 = $2c9e117f21850d30$export$736315c5b55efbad.strictCreate;
const $2c9e117f21850d30$export$971dd5b0dfd021b6 = $2c9e117f21850d30$export$a8b236cb5070a311.create;
const $2c9e117f21850d30$export$4b888e40c4ee26dd = $2c9e117f21850d30$export$5ef2424805ac76a3.create;
const $2c9e117f21850d30$export$bc86dfbf7795668c = $2c9e117f21850d30$export$c02deaf0bb5203d4.create;
const $2c9e117f21850d30$export$65e3907585753458 = $2c9e117f21850d30$export$e2a18bb771d8e6a3.create;
const $2c9e117f21850d30$export$e5185e241753e543 = $2c9e117f21850d30$export$a2acc09968cb4b7f.create;
const $2c9e117f21850d30$export$871de8747c9eaa88 = $2c9e117f21850d30$export$163b6a2b712d9542.create;
const $2c9e117f21850d30$export$adaa4cf7ef1b65be = $2c9e117f21850d30$export$977057706f816712.create;
const $2c9e117f21850d30$export$44e51c8aac7c2deb = $2c9e117f21850d30$export$d4602ba55673f53c.create;
const $2c9e117f21850d30$export$488013bae63b21da = $2c9e117f21850d30$export$378d0cfce37406e6.create;
const $2c9e117f21850d30$export$c8ec6e1ec9fefcb0 = $2c9e117f21850d30$export$7e44096782a165d3.create;
const $2c9e117f21850d30$export$78a99c8d44d72635 = $2c9e117f21850d30$export$d325d1f0e1c20179.create;
const $2c9e117f21850d30$export$6fe7eca19ebe5199 = $2c9e117f21850d30$export$370b2e8d6d6f5c56.create;
const $2c9e117f21850d30$export$c957ef27a0ebfd4 = $2c9e117f21850d30$export$3f196b0127d6e50a.create;
const $2c9e117f21850d30$export$dc573d8a6576cdb3 = $2c9e117f21850d30$export$a60af00cc0ce2582.create;
const $2c9e117f21850d30$export$516e28dec6a4b6d4 = $2c9e117f21850d30$export$aa56fec1e9d629b8.create;
const $2c9e117f21850d30$export$133fc36489ac9add = $2c9e117f21850d30$export$aaac0b8b429cef5.create;
const $2c9e117f21850d30$export$fc37fe19dfda43ee = $2c9e117f21850d30$export$a60af00cc0ce2582.createWithPreprocess;
const $2c9e117f21850d30$export$43f28b24e1eb8181 = $2c9e117f21850d30$export$a3c3ef8a0e95c6da.create;
const $2c9e117f21850d30$export$3b3d07727c5b702c = ()=>$2c9e117f21850d30$export$22b082955e083ec3().optional();
const $2c9e117f21850d30$export$eb150471a61fced6 = ()=>$2c9e117f21850d30$export$98e628dec113755e().optional();
const $2c9e117f21850d30$export$269251733cdcbbf1 = ()=>$2c9e117f21850d30$export$4a21f16c33752377().optional();
const $2c9e117f21850d30$export$8c14e57e778d3873 = {
    string: (arg)=>$2c9e117f21850d30$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$2c9e117f21850d30$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$2c9e117f21850d30$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$2c9e117f21850d30$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$2c9e117f21850d30$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $2c9e117f21850d30$export$96c94437c95d7862 = $2c9e117f21850d30$export$9a105a556e65c2c0;
var $2c9e117f21850d30$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $2c9e117f21850d30$export$341b0b6e0a6f5099,
    setErrorMap: $2c9e117f21850d30$export$1097a8289cfd22d7,
    getErrorMap: $2c9e117f21850d30$export$32f27c719778d4c4,
    makeIssue: $2c9e117f21850d30$export$244a85fde9c419ed,
    EMPTY_PATH: $2c9e117f21850d30$export$1526d2e05f74572,
    addIssueToContext: $2c9e117f21850d30$export$db7caee60e5d514d,
    ParseStatus: $2c9e117f21850d30$export$5b20a5c3d05c1f6f,
    INVALID: $2c9e117f21850d30$export$9a105a556e65c2c0,
    DIRTY: $2c9e117f21850d30$export$325a211da9693fcf,
    OK: $2c9e117f21850d30$export$c6813a8d51f77eaf,
    isAborted: $2c9e117f21850d30$export$afa861e3c5730743,
    isDirty: $2c9e117f21850d30$export$910b6cdd390341b3,
    isValid: $2c9e117f21850d30$export$1ea939691cdc45b8,
    isAsync: $2c9e117f21850d30$export$aefee5ebe1dcfd9e,
    get util () {
        return $2c9e117f21850d30$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $2c9e117f21850d30$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $2c9e117f21850d30$export$5716da67bfaa244d,
    getParsedType: $2c9e117f21850d30$export$3e9057828ebd5c7a,
    ZodType: $2c9e117f21850d30$export$19342e026b58ebb7,
    ZodString: $2c9e117f21850d30$export$1230eb29b8d3b502,
    ZodNumber: $2c9e117f21850d30$export$5b070a55c0c43e09,
    ZodBigInt: $2c9e117f21850d30$export$67d741fd70ff98f4,
    ZodBoolean: $2c9e117f21850d30$export$723d146f80596191,
    ZodDate: $2c9e117f21850d30$export$e974be33bdc55521,
    ZodSymbol: $2c9e117f21850d30$export$bcc3b40f6b638044,
    ZodUndefined: $2c9e117f21850d30$export$4e780e961c30340d,
    ZodNull: $2c9e117f21850d30$export$a96281f914484f2d,
    ZodAny: $2c9e117f21850d30$export$b9d1edb536b4e4eb,
    ZodUnknown: $2c9e117f21850d30$export$ef3b1bb1630977ae,
    ZodNever: $2c9e117f21850d30$export$1e576a20c3ce9fb5,
    ZodVoid: $2c9e117f21850d30$export$7d39f5df85f21031,
    ZodArray: $2c9e117f21850d30$export$7acfc3e64785411,
    ZodObject: $2c9e117f21850d30$export$736315c5b55efbad,
    ZodUnion: $2c9e117f21850d30$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $2c9e117f21850d30$export$5ef2424805ac76a3,
    ZodIntersection: $2c9e117f21850d30$export$c02deaf0bb5203d4,
    ZodTuple: $2c9e117f21850d30$export$e2a18bb771d8e6a3,
    ZodRecord: $2c9e117f21850d30$export$a2acc09968cb4b7f,
    ZodMap: $2c9e117f21850d30$export$163b6a2b712d9542,
    ZodSet: $2c9e117f21850d30$export$977057706f816712,
    ZodFunction: $2c9e117f21850d30$export$d4602ba55673f53c,
    ZodLazy: $2c9e117f21850d30$export$378d0cfce37406e6,
    ZodLiteral: $2c9e117f21850d30$export$7e44096782a165d3,
    ZodEnum: $2c9e117f21850d30$export$d325d1f0e1c20179,
    ZodNativeEnum: $2c9e117f21850d30$export$370b2e8d6d6f5c56,
    ZodPromise: $2c9e117f21850d30$export$3f196b0127d6e50a,
    ZodEffects: $2c9e117f21850d30$export$a60af00cc0ce2582,
    ZodTransformer: $2c9e117f21850d30$export$a60af00cc0ce2582,
    ZodOptional: $2c9e117f21850d30$export$aa56fec1e9d629b8,
    ZodNullable: $2c9e117f21850d30$export$aaac0b8b429cef5,
    ZodDefault: $2c9e117f21850d30$export$bb19b37874861e7e,
    ZodCatch: $2c9e117f21850d30$export$75a44ec6249ac76b,
    ZodNaN: $2c9e117f21850d30$export$26ccfa0145e8511f,
    BRAND: $2c9e117f21850d30$export$cf2deea74cde46b4,
    ZodBranded: $2c9e117f21850d30$export$66b0c798a395271f,
    ZodPipeline: $2c9e117f21850d30$export$a3c3ef8a0e95c6da,
    ZodReadonly: $2c9e117f21850d30$export$5d1f7ef05c4e493a,
    custom: $2c9e117f21850d30$export$4c00f665f0d4b443,
    Schema: $2c9e117f21850d30$export$19342e026b58ebb7,
    ZodSchema: $2c9e117f21850d30$export$19342e026b58ebb7,
    late: $2c9e117f21850d30$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $2c9e117f21850d30$export$558106ce543bd011;
    },
    coerce: $2c9e117f21850d30$export$8c14e57e778d3873,
    any: $2c9e117f21850d30$export$4154a199d7d90455,
    array: $2c9e117f21850d30$export$2f23118c22fb2630,
    bigint: $2c9e117f21850d30$export$a0f65b52274bcc00,
    boolean: $2c9e117f21850d30$export$4a21f16c33752377,
    date: $2c9e117f21850d30$export$324d90190a8b822a,
    discriminatedUnion: $2c9e117f21850d30$export$4b888e40c4ee26dd,
    effect: $2c9e117f21850d30$export$dc573d8a6576cdb3,
    "enum": $2c9e117f21850d30$export$78a99c8d44d72635,
    "function": $2c9e117f21850d30$export$44e51c8aac7c2deb,
    "instanceof": $2c9e117f21850d30$export$3d916e7c22dbd8b5,
    intersection: $2c9e117f21850d30$export$bc86dfbf7795668c,
    lazy: $2c9e117f21850d30$export$488013bae63b21da,
    literal: $2c9e117f21850d30$export$c8ec6e1ec9fefcb0,
    map: $2c9e117f21850d30$export$871de8747c9eaa88,
    nan: $2c9e117f21850d30$export$9e06de0973666692,
    nativeEnum: $2c9e117f21850d30$export$6fe7eca19ebe5199,
    never: $2c9e117f21850d30$export$b3e22bcfd64c1022,
    "null": $2c9e117f21850d30$export$7b1b591b262c240,
    nullable: $2c9e117f21850d30$export$133fc36489ac9add,
    number: $2c9e117f21850d30$export$98e628dec113755e,
    object: $2c9e117f21850d30$export$be5493f9613cbbe,
    oboolean: $2c9e117f21850d30$export$269251733cdcbbf1,
    onumber: $2c9e117f21850d30$export$eb150471a61fced6,
    optional: $2c9e117f21850d30$export$516e28dec6a4b6d4,
    ostring: $2c9e117f21850d30$export$3b3d07727c5b702c,
    pipeline: $2c9e117f21850d30$export$43f28b24e1eb8181,
    preprocess: $2c9e117f21850d30$export$fc37fe19dfda43ee,
    promise: $2c9e117f21850d30$export$c957ef27a0ebfd4,
    record: $2c9e117f21850d30$export$e5185e241753e543,
    set: $2c9e117f21850d30$export$adaa4cf7ef1b65be,
    strictObject: $2c9e117f21850d30$export$8fb0df5f40d0b477,
    string: $2c9e117f21850d30$export$22b082955e083ec3,
    symbol: $2c9e117f21850d30$export$8f701197936bc2a6,
    transformer: $2c9e117f21850d30$export$dc573d8a6576cdb3,
    tuple: $2c9e117f21850d30$export$65e3907585753458,
    "undefined": $2c9e117f21850d30$export$1db45310990710a5,
    union: $2c9e117f21850d30$export$971dd5b0dfd021b6,
    unknown: $2c9e117f21850d30$export$19282c40b967aec6,
    "void": $2c9e117f21850d30$export$490e536ee7389aeb,
    NEVER: $2c9e117f21850d30$export$96c94437c95d7862,
    ZodIssueCode: $2c9e117f21850d30$export$5ba560653e4a1035,
    quotelessJson: $2c9e117f21850d30$export$913eddeaf297cfea,
    ZodError: $2c9e117f21850d30$export$f98dac4b251ab333
});


/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9KJkx = parcelRequire("9KJkx");
/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $9KJkx = parcelRequire("9KJkx");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $ea5f54980fbf41f8$var$_extends() {
    $ea5f54980fbf41f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea5f54980fbf41f8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $ea5f54980fbf41f8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($ea5f54980fbf41f8$export$e19cd5f9376f8cee || ($ea5f54980fbf41f8$export$e19cd5f9376f8cee = {}));
const $ea5f54980fbf41f8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $ea5f54980fbf41f8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $ea5f54980fbf41f8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ea5f54980fbf41f8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $ea5f54980fbf41f8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $ea5f54980fbf41f8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $ea5f54980fbf41f8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $ea5f54980fbf41f8$export$fe53371bee54353d(to);
    }
    return $ea5f54980fbf41f8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $ea5f54980fbf41f8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ea5f54980fbf41f8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ea5f54980fbf41f8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ea5f54980fbf41f8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ea5f54980fbf41f8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $ea5f54980fbf41f8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ea5f54980fbf41f8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ea5f54980fbf41f8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $ea5f54980fbf41f8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $ea5f54980fbf41f8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $ea5f54980fbf41f8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $ea5f54980fbf41f8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ea5f54980fbf41f8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $ea5f54980fbf41f8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $ea5f54980fbf41f8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ea5f54980fbf41f8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($ea5f54980fbf41f8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push;
        let location = $ea5f54980fbf41f8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ea5f54980fbf41f8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace;
        let location = $ea5f54980fbf41f8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ea5f54980fbf41f8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $ea5f54980fbf41f8$export$fe53371bee54353d(to);
        $ea5f54980fbf41f8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($ea5f54980fbf41f8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($ea5f54980fbf41f8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $ea5f54980fbf41f8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($ea5f54980fbf41f8$var$ResultType || ($ea5f54980fbf41f8$var$ResultType = {}));
const $ea5f54980fbf41f8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ea5f54980fbf41f8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $ea5f54980fbf41f8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ea5f54980fbf41f8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($ea5f54980fbf41f8$var$isIndexRoute(route)) {
            let indexRoute = $ea5f54980fbf41f8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $ea5f54980fbf41f8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ea5f54980fbf41f8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $ea5f54980fbf41f8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ea5f54980fbf41f8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ea5f54980fbf41f8$var$flattenRoutes(routes);
    $ea5f54980fbf41f8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $ea5f54980fbf41f8$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $ea5f54980fbf41f8$var$safelyDecodeURI(pathname));
    return matches;
}
function $ea5f54980fbf41f8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ea5f54980fbf41f8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ea5f54980fbf41f8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ea5f54980fbf41f8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $ea5f54980fbf41f8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $ea5f54980fbf41f8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ea5f54980fbf41f8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $ea5f54980fbf41f8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $ea5f54980fbf41f8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ea5f54980fbf41f8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ea5f54980fbf41f8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $ea5f54980fbf41f8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $ea5f54980fbf41f8$var$paramRe = /^:\w+$/;
const $ea5f54980fbf41f8$var$dynamicSegmentValue = 3;
const $ea5f54980fbf41f8$var$indexRouteValue = 2;
const $ea5f54980fbf41f8$var$emptySegmentValue = 1;
const $ea5f54980fbf41f8$var$staticSegmentValue = 10;
const $ea5f54980fbf41f8$var$splatPenalty = -2;
const $ea5f54980fbf41f8$var$isSplat = (s)=>s === "*";
function $ea5f54980fbf41f8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ea5f54980fbf41f8$var$isSplat)) initialScore += $ea5f54980fbf41f8$var$splatPenalty;
    if (index) initialScore += $ea5f54980fbf41f8$var$indexRouteValue;
    return segments.filter((s)=>!$ea5f54980fbf41f8$var$isSplat(s)).reduce((score, segment)=>score + ($ea5f54980fbf41f8$var$paramRe.test(segment) ? $ea5f54980fbf41f8$var$dynamicSegmentValue : segment === "" ? $ea5f54980fbf41f8$var$emptySegmentValue : $ea5f54980fbf41f8$var$staticSegmentValue), initialScore);
}
function $ea5f54980fbf41f8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ea5f54980fbf41f8$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ea5f54980fbf41f8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ea5f54980fbf41f8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ea5f54980fbf41f8$export$a5c6d149b50c1d86($ea5f54980fbf41f8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ea5f54980fbf41f8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $ea5f54980fbf41f8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ea5f54980fbf41f8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ea5f54980fbf41f8$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $ea5f54980fbf41f8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $ea5f54980fbf41f8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $ea5f54980fbf41f8$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ea5f54980fbf41f8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $ea5f54980fbf41f8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $ea5f54980fbf41f8$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $ea5f54980fbf41f8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $ea5f54980fbf41f8$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $ea5f54980fbf41f8$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $ea5f54980fbf41f8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $ea5f54980fbf41f8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ea5f54980fbf41f8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ea5f54980fbf41f8$var$normalizeSearch(search),
        hash: $ea5f54980fbf41f8$var$normalizeHash(hash)
    };
}
function $ea5f54980fbf41f8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ea5f54980fbf41f8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $ea5f54980fbf41f8$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $ea5f54980fbf41f8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $ea5f54980fbf41f8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $ea5f54980fbf41f8$var$_extends({}, toArg);
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $ea5f54980fbf41f8$var$getInvalidPathError("?", "pathname", "search", to));
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $ea5f54980fbf41f8$var$getInvalidPathError("#", "pathname", "hash", to));
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $ea5f54980fbf41f8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ea5f54980fbf41f8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $ea5f54980fbf41f8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $ea5f54980fbf41f8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $ea5f54980fbf41f8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $ea5f54980fbf41f8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $ea5f54980fbf41f8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $ea5f54980fbf41f8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $ea5f54980fbf41f8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $ea5f54980fbf41f8$export$42a99a7a4bc0e76a extends Error {
}
class $ea5f54980fbf41f8$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $ea5f54980fbf41f8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $ea5f54980fbf41f8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $ea5f54980fbf41f8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $ea5f54980fbf41f8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $ea5f54980fbf41f8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $ea5f54980fbf41f8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $ea5f54980fbf41f8$var$unwrapTrackedPromise(value) {
    if (!$ea5f54980fbf41f8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $ea5f54980fbf41f8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $ea5f54980fbf41f8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ea5f54980fbf41f8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $ea5f54980fbf41f8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ea5f54980fbf41f8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ea5f54980fbf41f8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $ea5f54980fbf41f8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $ea5f54980fbf41f8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $ea5f54980fbf41f8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $ea5f54980fbf41f8$var$validMutationMethods = new Set($ea5f54980fbf41f8$var$validMutationMethodsArr);
const $ea5f54980fbf41f8$var$validRequestMethodsArr = [
    "get",
    ...$ea5f54980fbf41f8$var$validMutationMethodsArr
];
const $ea5f54980fbf41f8$var$validRequestMethods = new Set($ea5f54980fbf41f8$var$validRequestMethodsArr);
const $ea5f54980fbf41f8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $ea5f54980fbf41f8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $ea5f54980fbf41f8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ea5f54980fbf41f8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ea5f54980fbf41f8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $ea5f54980fbf41f8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $ea5f54980fbf41f8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $ea5f54980fbf41f8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $ea5f54980fbf41f8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ea5f54980fbf41f8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $ea5f54980fbf41f8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $ea5f54980fbf41f8$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ea5f54980fbf41f8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $ea5f54980fbf41f8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ea5f54980fbf41f8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ea5f54980fbf41f8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $ea5f54980fbf41f8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ea5f54980fbf41f8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $ea5f54980fbf41f8$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ea5f54980fbf41f8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $ea5f54980fbf41f8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ea5f54980fbf41f8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ea5f54980fbf41f8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($ea5f54980fbf41f8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ea5f54980fbf41f8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ea5f54980fbf41f8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $ea5f54980fbf41f8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ea5f54980fbf41f8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $ea5f54980fbf41f8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $ea5f54980fbf41f8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ea5f54980fbf41f8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $ea5f54980fbf41f8$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ea5f54980fbf41f8$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $ea5f54980fbf41f8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ea5f54980fbf41f8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $ea5f54980fbf41f8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$ea5f54980fbf41f8$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $ea5f54980fbf41f8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $ea5f54980fbf41f8$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $ea5f54980fbf41f8$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $ea5f54980fbf41f8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $ea5f54980fbf41f8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $ea5f54980fbf41f8$var$ResultType.error,
            error: $ea5f54980fbf41f8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $ea5f54980fbf41f8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ea5f54980fbf41f8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($ea5f54980fbf41f8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($ea5f54980fbf41f8$var$isDeferredResult(result)) throw $ea5f54980fbf41f8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $ea5f54980fbf41f8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $ea5f54980fbf41f8$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $ea5f54980fbf41f8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $ea5f54980fbf41f8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $ea5f54980fbf41f8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($ea5f54980fbf41f8$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $ea5f54980fbf41f8$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ea5f54980fbf41f8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $ea5f54980fbf41f8$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $ea5f54980fbf41f8$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ea5f54980fbf41f8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $ea5f54980fbf41f8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $ea5f54980fbf41f8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $ea5f54980fbf41f8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $ea5f54980fbf41f8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ea5f54980fbf41f8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $ea5f54980fbf41f8$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $ea5f54980fbf41f8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $ea5f54980fbf41f8$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($ea5f54980fbf41f8$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $ea5f54980fbf41f8$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($ea5f54980fbf41f8$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($ea5f54980fbf41f8$var$isDeferredResult(actionResult)) throw $ea5f54980fbf41f8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ea5f54980fbf41f8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ea5f54980fbf41f8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ea5f54980fbf41f8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ea5f54980fbf41f8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $ea5f54980fbf41f8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ea5f54980fbf41f8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $ea5f54980fbf41f8$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ea5f54980fbf41f8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ea5f54980fbf41f8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($ea5f54980fbf41f8$var$_extends({
                errors: errors,
                loaderData: $ea5f54980fbf41f8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $ea5f54980fbf41f8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $ea5f54980fbf41f8$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $ea5f54980fbf41f8$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($ea5f54980fbf41f8$var$isDeferredResult(result)) result = await $ea5f54980fbf41f8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($ea5f54980fbf41f8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($ea5f54980fbf41f8$var$isErrorResult(result)) {
            let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!$ea5f54980fbf41f8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $ea5f54980fbf41f8$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $ea5f54980fbf41f8$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($ea5f54980fbf41f8$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ea5f54980fbf41f8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Replace : $ea5f54980fbf41f8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ea5f54980fbf41f8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($ea5f54980fbf41f8$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $ea5f54980fbf41f8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $ea5f54980fbf41f8$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $ea5f54980fbf41f8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ea5f54980fbf41f8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $ea5f54980fbf41f8$var$callLoaderOrAction("loader", $ea5f54980fbf41f8$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $ea5f54980fbf41f8$var$ResultType.error,
                        error: $ea5f54980fbf41f8$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $ea5f54980fbf41f8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $ea5f54980fbf41f8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $ea5f54980fbf41f8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ea5f54980fbf41f8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ea5f54980fbf41f8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ea5f54980fbf41f8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ea5f54980fbf41f8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $ea5f54980fbf41f8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $ea5f54980fbf41f8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $ea5f54980fbf41f8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$ea5f54980fbf41f8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ea5f54980fbf41f8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $ea5f54980fbf41f8$export$4d0306f8f6a4585b = Symbol("deferred");
function $ea5f54980fbf41f8$export$3336b097a6fbc59a(routes, opts) {
    $ea5f54980fbf41f8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ea5f54980fbf41f8$var$defaultMapRouteProperties;
    let dataRoutes = $ea5f54980fbf41f8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ea5f54980fbf41f8$var$createLocation("", $ea5f54980fbf41f8$export$fe53371bee54353d(url), null, "default");
        let matches = $ea5f54980fbf41f8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ea5f54980fbf41f8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ea5f54980fbf41f8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ea5f54980fbf41f8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($ea5f54980fbf41f8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $ea5f54980fbf41f8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ea5f54980fbf41f8$var$createLocation("", $ea5f54980fbf41f8$export$fe53371bee54353d(url), null, "default");
        let matches = $ea5f54980fbf41f8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ea5f54980fbf41f8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ea5f54980fbf41f8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ea5f54980fbf41f8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ea5f54980fbf41f8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ea5f54980fbf41f8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $ea5f54980fbf41f8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($ea5f54980fbf41f8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$ea5f54980fbf41f8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $ea5f54980fbf41f8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ea5f54980fbf41f8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $ea5f54980fbf41f8$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $ea5f54980fbf41f8$var$isResponse(result) ? result : $ea5f54980fbf41f8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($ea5f54980fbf41f8$var$isQueryRouteResponse(e)) {
                if (e.type === $ea5f54980fbf41f8$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($ea5f54980fbf41f8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ea5f54980fbf41f8$var$ResultType.error,
                error: error
            };
        } else {
            result = await $ea5f54980fbf41f8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($ea5f54980fbf41f8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($ea5f54980fbf41f8$var$isDeferredResult(result)) {
            let error = $ea5f54980fbf41f8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ea5f54980fbf41f8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($ea5f54980fbf41f8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($ea5f54980fbf41f8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $ea5f54980fbf41f8$var$_extends({}, context, {
                statusCode: $ea5f54980fbf41f8$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $ea5f54980fbf41f8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $ea5f54980fbf41f8$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $ea5f54980fbf41f8$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $ea5f54980fbf41f8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $ea5f54980fbf41f8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ea5f54980fbf41f8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $ea5f54980fbf41f8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $ea5f54980fbf41f8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $ea5f54980fbf41f8$export$fec11da027c70692(routes, context, error) {
    let newContext = $ea5f54980fbf41f8$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $ea5f54980fbf41f8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $ea5f54980fbf41f8$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $ea5f54980fbf41f8$export$cae722b0cc860f13(to ? to : ".", $ea5f54980fbf41f8$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $ea5f54980fbf41f8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$ea5f54980fbf41f8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ea5f54980fbf41f8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $ea5f54980fbf41f8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $ea5f54980fbf41f8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$ea5f54980fbf41f8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ea5f54980fbf41f8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ea5f54980fbf41f8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ea5f54980fbf41f8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $ea5f54980fbf41f8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$ea5f54980fbf41f8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$ea5f54980fbf41f8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ea5f54980fbf41f8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ea5f54980fbf41f8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ea5f54980fbf41f8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ea5f54980fbf41f8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ea5f54980fbf41f8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($ea5f54980fbf41f8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $ea5f54980fbf41f8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $ea5f54980fbf41f8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $ea5f54980fbf41f8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $ea5f54980fbf41f8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $ea5f54980fbf41f8$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $ea5f54980fbf41f8$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($ea5f54980fbf41f8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $ea5f54980fbf41f8$var$shouldRevalidateLoader(match, $ea5f54980fbf41f8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $ea5f54980fbf41f8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $ea5f54980fbf41f8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $ea5f54980fbf41f8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $ea5f54980fbf41f8$var$shouldRevalidateLoader(fetcherMatch, $ea5f54980fbf41f8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $ea5f54980fbf41f8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $ea5f54980fbf41f8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ea5f54980fbf41f8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $ea5f54980fbf41f8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $ea5f54980fbf41f8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $ea5f54980fbf41f8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$ea5f54980fbf41f8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $ea5f54980fbf41f8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $ea5f54980fbf41f8$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $ea5f54980fbf41f8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $ea5f54980fbf41f8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ea5f54980fbf41f8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $ea5f54980fbf41f8$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ea5f54980fbf41f8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $ea5f54980fbf41f8$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $ea5f54980fbf41f8$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($ea5f54980fbf41f8$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($ea5f54980fbf41f8$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $ea5f54980fbf41f8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$ea5f54980fbf41f8$var$ABSOLUTE_URL_REGEX.test(location)) location = $ea5f54980fbf41f8$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $ea5f54980fbf41f8$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $ea5f54980fbf41f8$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $ea5f54980fbf41f8$var$ResultType.error ? $ea5f54980fbf41f8$var$ResultType.error : $ea5f54980fbf41f8$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $ea5f54980fbf41f8$var$ResultType.error) return {
            type: resultType,
            error: new $ea5f54980fbf41f8$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $ea5f54980fbf41f8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $ea5f54980fbf41f8$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($ea5f54980fbf41f8$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $ea5f54980fbf41f8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $ea5f54980fbf41f8$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $ea5f54980fbf41f8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ea5f54980fbf41f8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ea5f54980fbf41f8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $ea5f54980fbf41f8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ea5f54980fbf41f8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ea5f54980fbf41f8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ea5f54980fbf41f8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $ea5f54980fbf41f8$export$3e9cee6b33872309(!$ea5f54980fbf41f8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ea5f54980fbf41f8$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $ea5f54980fbf41f8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($ea5f54980fbf41f8$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ea5f54980fbf41f8$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $ea5f54980fbf41f8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $ea5f54980fbf41f8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($ea5f54980fbf41f8$var$isErrorResult(result)) {
            let boundaryMatch = $ea5f54980fbf41f8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $ea5f54980fbf41f8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($ea5f54980fbf41f8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $ea5f54980fbf41f8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($ea5f54980fbf41f8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $ea5f54980fbf41f8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $ea5f54980fbf41f8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ea5f54980fbf41f8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $ea5f54980fbf41f8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $ea5f54980fbf41f8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ea5f54980fbf41f8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ea5f54980fbf41f8$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $ea5f54980fbf41f8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $ea5f54980fbf41f8$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($ea5f54980fbf41f8$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $ea5f54980fbf41f8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(path) : path;
    return $ea5f54980fbf41f8$export$fe53371bee54353d($ea5f54980fbf41f8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $ea5f54980fbf41f8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $ea5f54980fbf41f8$var$isDeferredResult(result) {
    return result.type === $ea5f54980fbf41f8$var$ResultType.deferred;
}
function $ea5f54980fbf41f8$var$isErrorResult(result) {
    return result.type === $ea5f54980fbf41f8$var$ResultType.error;
}
function $ea5f54980fbf41f8$var$isRedirectResult(result) {
    return (result && result.type) === $ea5f54980fbf41f8$var$ResultType.redirect;
}
function $ea5f54980fbf41f8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $ea5f54980fbf41f8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ea5f54980fbf41f8$var$isRedirectResponse(result) {
    if (!$ea5f54980fbf41f8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $ea5f54980fbf41f8$var$isQueryRouteResponse(obj) {
    return obj && $ea5f54980fbf41f8$var$isResponse(obj.response) && (obj.type === $ea5f54980fbf41f8$var$ResultType.data || obj.type === $ea5f54980fbf41f8$var$ResultType.error);
}
function $ea5f54980fbf41f8$var$isValidMethod(method) {
    return $ea5f54980fbf41f8$var$validRequestMethods.has(method.toLowerCase());
}
function $ea5f54980fbf41f8$var$isMutationMethod(method) {
    return $ea5f54980fbf41f8$var$validMutationMethods.has(method.toLowerCase());
}
async function $ea5f54980fbf41f8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$ea5f54980fbf41f8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($ea5f54980fbf41f8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $ea5f54980fbf41f8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $ea5f54980fbf41f8$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $ea5f54980fbf41f8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $ea5f54980fbf41f8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $ea5f54980fbf41f8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $ea5f54980fbf41f8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $ea5f54980fbf41f8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ea5f54980fbf41f8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ea5f54980fbf41f8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ea5f54980fbf41f8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $ea5f54980fbf41f8$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ea5f54980fbf41f8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $ea5f54980fbf41f8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $ea5f54980fbf41f8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ea5f54980fbf41f8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $ea5f54980fbf41f8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $ea5f54980fbf41f8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}


function $7222be8890473787$var$_extends() {
    $7222be8890473787$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7222be8890473787$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7222be8890473787$export$3add0d5dce533e2e = /*#__PURE__*/ $9KJkx.createContext(null);
const $7222be8890473787$export$145dfa71566a64dc = /*#__PURE__*/ $9KJkx.createContext(null);
const $7222be8890473787$var$AwaitContext = /*#__PURE__*/ $9KJkx.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7222be8890473787$export$26749e8557646306 = /*#__PURE__*/ $9KJkx.createContext(null);
const $7222be8890473787$export$c7914228fb69b0f5 = /*#__PURE__*/ $9KJkx.createContext(null);
const $7222be8890473787$export$9072aa6dd1f93057 = /*#__PURE__*/ $9KJkx.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7222be8890473787$var$RouteErrorContext = /*#__PURE__*/ $9KJkx.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7222be8890473787$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $9KJkx.useContext($7222be8890473787$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7222be8890473787$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ea5f54980fbf41f8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7222be8890473787$export$9c954a9d03d32f4a() {
    return $9KJkx.useContext($7222be8890473787$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7222be8890473787$export$45d76561a5302f2b() {
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return $9KJkx.useContext($7222be8890473787$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7222be8890473787$export$1b3f31771c5d07c() {
    return $9KJkx.useContext($7222be8890473787$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7222be8890473787$export$6c330e8992e8a295(pattern) {
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7222be8890473787$export$45d76561a5302f2b();
    return $9KJkx.useMemo(()=>(0, $ea5f54980fbf41f8$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7222be8890473787$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7222be8890473787$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $9KJkx.useContext($7222be8890473787$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $9KJkx.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7222be8890473787$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7222be8890473787$var$useNavigateStable() : $7222be8890473787$var$useNavigateUnstable();
}
function $7222be8890473787$var$useNavigateUnstable() {
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let dataRouterContext = $9KJkx.useContext($7222be8890473787$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $9KJkx.useContext($7222be8890473787$export$26749e8557646306);
    let { matches: matches } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7222be8890473787$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ea5f54980fbf41f8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $9KJkx.useRef(false);
    $7222be8890473787$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9KJkx.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ea5f54980fbf41f8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ea5f54980fbf41f8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7222be8890473787$var$OutletContext = /*#__PURE__*/ $9KJkx.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7222be8890473787$export$4138103a3ae699cc() {
    return $9KJkx.useContext($7222be8890473787$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7222be8890473787$export$a3be3530d8e40d0b(context) {
    let outlet = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7222be8890473787$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7222be8890473787$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7222be8890473787$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ea5f54980fbf41f8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $9KJkx.useMemo(()=>(0, $ea5f54980fbf41f8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7222be8890473787$export$5d3fca4a98652595(routes, locationArg) {
    return $7222be8890473787$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7222be8890473787$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $9KJkx.useContext($7222be8890473787$export$26749e8557646306);
    let { matches: parentMatches } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7222be8890473787$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ea5f54980fbf41f8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $ea5f54980fbf41f8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7222be8890473787$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ea5f54980fbf41f8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ea5f54980fbf41f8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7222be8890473787$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ea5f54980fbf41f8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7222be8890473787$var$DefaultErrorComponent() {
    let error = $7222be8890473787$export$ed527bf60f6e05f2();
    let message = (0, $ea5f54980fbf41f8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $9KJkx.createElement($9KJkx.Fragment, null, /*#__PURE__*/ $9KJkx.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $9KJkx.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $9KJkx.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7222be8890473787$var$defaultErrorElement = /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$DefaultErrorComponent, null);
class $7222be8890473787$var$RenderErrorBoundary extends $9KJkx.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7222be8890473787$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $9KJkx.useContext($7222be8890473787$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7222be8890473787$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $7222be8890473787$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $9KJkx.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7222be8890473787$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7222be8890473787$var$DataRouterHook || {});
var $7222be8890473787$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7222be8890473787$var$DataRouterStateHook || {});
function $7222be8890473787$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7222be8890473787$var$useDataRouterContext(hookName) {
    let ctx = $9KJkx.useContext($7222be8890473787$export$3add0d5dce533e2e);
    !ctx && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7222be8890473787$var$useDataRouterState(hookName) {
    let state = $9KJkx.useContext($7222be8890473787$export$145dfa71566a64dc);
    !state && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return state;
}
function $7222be8890473787$var$useRouteContext(hookName) {
    let route = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    !route && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7222be8890473787$var$useCurrentRouteId(hookName) {
    let route = $7222be8890473787$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7222be8890473787$export$5fc8298006ad9e58() {
    return $7222be8890473787$var$useCurrentRouteId($7222be8890473787$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7222be8890473787$export$d0fd4b7106de2769() {
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7222be8890473787$export$600dc272ed516c15() {
    let dataRouterContext = $7222be8890473787$var$useDataRouterContext($7222be8890473787$var$DataRouterHook.UseRevalidator);
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseRevalidator);
    return $9KJkx.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7222be8890473787$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseMatches);
    return $9KJkx.useMemo(()=>matches.map((m)=>(0, $ea5f54980fbf41f8$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7222be8890473787$export$1448a5050d252c4d() {
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7222be8890473787$var$useCurrentRouteId($7222be8890473787$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7222be8890473787$export$fd5d37484eab868d(routeId) {
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7222be8890473787$export$fdc00f3f26066d5e() {
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseActionData);
    let route = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    !route && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7222be8890473787$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $9KJkx.useContext($7222be8890473787$var$RouteErrorContext);
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseRouteError);
    let routeId = $7222be8890473787$var$useCurrentRouteId($7222be8890473787$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7222be8890473787$export$78a72ddb39bdd145() {
    let value = $9KJkx.useContext($7222be8890473787$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7222be8890473787$export$17f53340677d5831() {
    let value = $9KJkx.useContext($7222be8890473787$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7222be8890473787$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7222be8890473787$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $7222be8890473787$var$useDataRouterContext($7222be8890473787$var$DataRouterHook.UseBlocker);
    let state = $7222be8890473787$var$useDataRouterState($7222be8890473787$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $9KJkx.useState("");
    let blockerFunction = $9KJkx.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7222be8890473787$var$_extends({}, currentLocation, {
                pathname: (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7222be8890473787$var$_extends({}, nextLocation, {
                pathname: (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $9KJkx.useEffect(()=>{
        let key = String(++$7222be8890473787$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $9KJkx.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ea5f54980fbf41f8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7222be8890473787$var$useNavigateStable() {
    let { router: router } = $7222be8890473787$var$useDataRouterContext($7222be8890473787$var$DataRouterHook.UseNavigateStable);
    let id = $7222be8890473787$var$useCurrentRouteId($7222be8890473787$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $9KJkx.useRef(false);
    $7222be8890473787$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $9KJkx.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7222be8890473787$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7222be8890473787$var$alreadyWarned = {};
function $7222be8890473787$var$warningOnce(key, cond, message) {
    if (!cond && !$7222be8890473787$var$alreadyWarned[key]) $7222be8890473787$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7222be8890473787$var$START_TRANSITION = "startTransition";
const $7222be8890473787$var$startTransitionImpl = $9KJkx[$7222be8890473787$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7222be8890473787$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $9KJkx.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9KJkx.useCallback((newState)=>{
        v7_startTransition && $7222be8890473787$var$startTransitionImpl ? $7222be8890473787$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9KJkx.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $9KJkx.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $9KJkx.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $9KJkx.createElement($9KJkx.Fragment, null, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $7222be8890473787$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $7222be8890473787$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7222be8890473787$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $9KJkx.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ea5f54980fbf41f8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9KJkx.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9KJkx.useCallback((newState)=>{
        v7_startTransition && $7222be8890473787$var$startTransitionImpl ? $7222be8890473787$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9KJkx.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7222be8890473787$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let { matches: matches } = $9KJkx.useContext($7222be8890473787$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7222be8890473787$export$45d76561a5302f2b();
    let navigate = $7222be8890473787$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ea5f54980fbf41f8$export$cae722b0cc860f13)(to, (0, $ea5f54980fbf41f8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $9KJkx.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7222be8890473787$export$910ae8079b2c2852(props) {
    return $7222be8890473787$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7222be8890473787$export$e7b0ac011bb776c6(_props) {
    (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7222be8890473787$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ea5f54980fbf41f8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$7222be8890473787$export$9c954a9d03d32f4a() && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $9KJkx.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ea5f54980fbf41f8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $9KJkx.useMemo(()=>{
        let trailingPathname = (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7222be8890473787$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7222be8890473787$export$5d3fca4a98652595($7222be8890473787$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7222be8890473787$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$ResolveAwait, null, children));
}
var $7222be8890473787$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7222be8890473787$var$AwaitRenderStatus || {});
const $7222be8890473787$var$neverSettledPromise = new Promise(()=>{});
class $7222be8890473787$var$AwaitErrorBoundary extends $9KJkx.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7222be8890473787$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7222be8890473787$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7222be8890473787$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7222be8890473787$var$AwaitRenderStatus.error : promise._data !== undefined ? $7222be8890473787$var$AwaitRenderStatus.success : $7222be8890473787$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7222be8890473787$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7222be8890473787$var$AwaitRenderStatus.error && promise._error instanceof (0, $ea5f54980fbf41f8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7222be8890473787$var$neverSettledPromise;
        if (status === $7222be8890473787$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7222be8890473787$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7222be8890473787$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $9KJkx.createElement($7222be8890473787$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7222be8890473787$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7222be8890473787$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $9KJkx.createElement($9KJkx.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7222be8890473787$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $9KJkx.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $9KJkx.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $9KJkx.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7222be8890473787$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7222be8890473787$export$e7b0ac011bb776c6) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7222be8890473787$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7222be8890473787$export$daf73786167a7f72(matches) {
    return $7222be8890473787$var$_renderMatches(matches);
}
function $7222be8890473787$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $9KJkx.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $9KJkx.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7222be8890473787$export$f30f7e456d254e83(routes, opts) {
    return (0, $ea5f54980fbf41f8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7222be8890473787$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ea5f54980fbf41f8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7222be8890473787$export$52b333d321859367
    }).initialize();
}



function $fb8bfc43ed9eb0bb$var$_extends() {
    $fb8bfc43ed9eb0bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb8bfc43ed9eb0bb$var$_extends.apply(this, arguments);
}
function $fb8bfc43ed9eb0bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $fb8bfc43ed9eb0bb$var$defaultMethod = "get";
const $fb8bfc43ed9eb0bb$var$defaultEncType = "application/x-www-form-urlencoded";
function $fb8bfc43ed9eb0bb$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fb8bfc43ed9eb0bb$var$isButtonElement(object) {
    return $fb8bfc43ed9eb0bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fb8bfc43ed9eb0bb$var$isFormElement(object) {
    return $fb8bfc43ed9eb0bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fb8bfc43ed9eb0bb$var$isInputElement(object) {
    return $fb8bfc43ed9eb0bb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fb8bfc43ed9eb0bb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fb8bfc43ed9eb0bb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fb8bfc43ed9eb0bb$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fb8bfc43ed9eb0bb$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fb8bfc43ed9eb0bb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fb8bfc43ed9eb0bb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $fb8bfc43ed9eb0bb$var$_formDataSupportsSubmitter = null;
function $fb8bfc43ed9eb0bb$var$isFormDataSubmitterSupported() {
    if ($fb8bfc43ed9eb0bb$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fb8bfc43ed9eb0bb$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fb8bfc43ed9eb0bb$var$_formDataSupportsSubmitter = true;
    }
    return $fb8bfc43ed9eb0bb$var$_formDataSupportsSubmitter;
}
const $fb8bfc43ed9eb0bb$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fb8bfc43ed9eb0bb$var$getFormEncType(encType) {
    if (encType != null && !$fb8bfc43ed9eb0bb$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fb8bfc43ed9eb0bb$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fb8bfc43ed9eb0bb$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fb8bfc43ed9eb0bb$var$defaultMethod;
        encType = $fb8bfc43ed9eb0bb$var$getFormEncType(target.getAttribute("enctype")) || $fb8bfc43ed9eb0bb$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fb8bfc43ed9eb0bb$var$isButtonElement(target) || $fb8bfc43ed9eb0bb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fb8bfc43ed9eb0bb$var$defaultMethod;
        encType = $fb8bfc43ed9eb0bb$var$getFormEncType(target.getAttribute("formenctype")) || $fb8bfc43ed9eb0bb$var$getFormEncType(form.getAttribute("enctype")) || $fb8bfc43ed9eb0bb$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fb8bfc43ed9eb0bb$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fb8bfc43ed9eb0bb$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fb8bfc43ed9eb0bb$var$defaultMethod;
        action = null;
        encType = $fb8bfc43ed9eb0bb$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $fb8bfc43ed9eb0bb$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $fb8bfc43ed9eb0bb$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $fb8bfc43ed9eb0bb$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $fb8bfc43ed9eb0bb$export$1f3f55432a00e06d(routes, opts) {
    return (0, $ea5f54980fbf41f8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fb8bfc43ed9eb0bb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ea5f54980fbf41f8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fb8bfc43ed9eb0bb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7222be8890473787$export$52b333d321859367)
    }).initialize();
}
function $fb8bfc43ed9eb0bb$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $ea5f54980fbf41f8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fb8bfc43ed9eb0bb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ea5f54980fbf41f8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fb8bfc43ed9eb0bb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7222be8890473787$export$52b333d321859367)
    }).initialize();
}
function $fb8bfc43ed9eb0bb$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fb8bfc43ed9eb0bb$var$_extends({}, state, {
        errors: $fb8bfc43ed9eb0bb$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fb8bfc43ed9eb0bb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $ea5f54980fbf41f8$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $fb8bfc43ed9eb0bb$var$START_TRANSITION = "startTransition";
const $fb8bfc43ed9eb0bb$var$startTransitionImpl = $9KJkx[$fb8bfc43ed9eb0bb$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fb8bfc43ed9eb0bb$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $9KJkx.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ea5f54980fbf41f8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9KJkx.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9KJkx.useCallback((newState)=>{
        v7_startTransition && $fb8bfc43ed9eb0bb$var$startTransitionImpl ? $fb8bfc43ed9eb0bb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9KJkx.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9KJkx.createElement((0, $7222be8890473787$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fb8bfc43ed9eb0bb$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $9KJkx.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ea5f54980fbf41f8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $9KJkx.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9KJkx.useCallback((newState)=>{
        v7_startTransition && $fb8bfc43ed9eb0bb$var$startTransitionImpl ? $fb8bfc43ed9eb0bb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9KJkx.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9KJkx.createElement((0, $7222be8890473787$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fb8bfc43ed9eb0bb$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $9KJkx.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $9KJkx.useCallback((newState)=>{
        v7_startTransition && $fb8bfc43ed9eb0bb$var$startTransitionImpl ? $fb8bfc43ed9eb0bb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $9KJkx.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $9KJkx.createElement((0, $7222be8890473787$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $fb8bfc43ed9eb0bb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $fb8bfc43ed9eb0bb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $fb8bfc43ed9eb0bb$export$a6c7ac8248d6e38a = /*#__PURE__*/ $9KJkx.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $fb8bfc43ed9eb0bb$var$_objectWithoutPropertiesLoose(_ref4, $fb8bfc43ed9eb0bb$var$_excluded);
    let { basename: basename } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $fb8bfc43ed9eb0bb$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fb8bfc43ed9eb0bb$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7222be8890473787$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $fb8bfc43ed9eb0bb$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $9KJkx.createElement("a", $fb8bfc43ed9eb0bb$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $fb8bfc43ed9eb0bb$export$b0d92dbee9b5b60d = /*#__PURE__*/ $9KJkx.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $fb8bfc43ed9eb0bb$var$_objectWithoutPropertiesLoose(_ref5, $fb8bfc43ed9eb0bb$var$_excluded2);
    let path = (0, $7222be8890473787$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7222be8890473787$export$45d76561a5302f2b)();
    let routerState = $9KJkx.useContext((0, $7222be8890473787$export$145dfa71566a64dc));
    let { navigator: navigator } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $9KJkx.createElement($fb8bfc43ed9eb0bb$export$a6c7ac8248d6e38a, $fb8bfc43ed9eb0bb$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $fb8bfc43ed9eb0bb$export$a7fed597f4b8afd8 = /*#__PURE__*/ $9KJkx.forwardRef((props, ref)=>{
    let submit = $fb8bfc43ed9eb0bb$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $9KJkx.createElement($fb8bfc43ed9eb0bb$var$FormImpl, $fb8bfc43ed9eb0bb$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $fb8bfc43ed9eb0bb$var$FormImpl = /*#__PURE__*/ $9KJkx.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $fb8bfc43ed9eb0bb$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $fb8bfc43ed9eb0bb$var$_objectWithoutPropertiesLoose(_ref6, $fb8bfc43ed9eb0bb$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $fb8bfc43ed9eb0bb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $9KJkx.createElement("form", $fb8bfc43ed9eb0bb$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fb8bfc43ed9eb0bb$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $fb8bfc43ed9eb0bb$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fb8bfc43ed9eb0bb$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($fb8bfc43ed9eb0bb$var$DataRouterHook || ($fb8bfc43ed9eb0bb$var$DataRouterHook = {}));
var $fb8bfc43ed9eb0bb$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fb8bfc43ed9eb0bb$var$DataRouterStateHook || ($fb8bfc43ed9eb0bb$var$DataRouterStateHook = {}));
function $fb8bfc43ed9eb0bb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $fb8bfc43ed9eb0bb$var$useDataRouterContext(hookName) {
    let ctx = $9KJkx.useContext((0, $7222be8890473787$export$3add0d5dce533e2e));
    !ctx && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fb8bfc43ed9eb0bb$var$useDataRouterState(hookName) {
    let state = $9KJkx.useContext((0, $7222be8890473787$export$145dfa71566a64dc));
    !state && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fb8bfc43ed9eb0bb$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7222be8890473787$export$9770f232ac06a008)();
    let location = (0, $7222be8890473787$export$45d76561a5302f2b)();
    let path = (0, $7222be8890473787$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $9KJkx.useCallback((event)=>{
        if ($fb8bfc43ed9eb0bb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $ea5f54980fbf41f8$export$fe53371bee54353d)(location) === (0, $ea5f54980fbf41f8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $9KJkx.useRef($fb8bfc43ed9eb0bb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $9KJkx.useRef(false);
    let location = (0, $7222be8890473787$export$45d76561a5302f2b)();
    let searchParams = $9KJkx.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fb8bfc43ed9eb0bb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7222be8890473787$export$9770f232ac06a008)();
    let setSearchParams = $9KJkx.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fb8bfc43ed9eb0bb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fb8bfc43ed9eb0bb$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fb8bfc43ed9eb0bb$export$47c85c6e3a081d3() {
    let { router: router } = $fb8bfc43ed9eb0bb$var$useDataRouterContext($fb8bfc43ed9eb0bb$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    let currentRouteId = (0, $7222be8890473787$export$5fc8298006ad9e58)();
    return $9KJkx.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fb8bfc43ed9eb0bb$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fb8bfc43ed9eb0bb$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $fb8bfc43ed9eb0bb$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $fb8bfc43ed9eb0bb$var$useDataRouterContext($fb8bfc43ed9eb0bb$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    return $9KJkx.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fb8bfc43ed9eb0bb$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fb8bfc43ed9eb0bb$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fb8bfc43ed9eb0bb$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    let routeContext = $9KJkx.useContext((0, $7222be8890473787$export$9072aa6dd1f93057));
    !routeContext && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $fb8bfc43ed9eb0bb$var$_extends({}, (0, $7222be8890473787$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7222be8890473787$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ea5f54980fbf41f8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $ea5f54980fbf41f8$export$fe53371bee54353d)(path);
}
function $fb8bfc43ed9eb0bb$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $9KJkx.forwardRef((props, ref)=>{
        let submit = $fb8bfc43ed9eb0bb$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $9KJkx.createElement($fb8bfc43ed9eb0bb$var$FormImpl, $fb8bfc43ed9eb0bb$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $fb8bfc43ed9eb0bb$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fb8bfc43ed9eb0bb$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $fb8bfc43ed9eb0bb$var$useDataRouterContext($fb8bfc43ed9eb0bb$var$DataRouterHook.UseFetcher);
    let route = $9KJkx.useContext((0, $7222be8890473787$export$9072aa6dd1f93057));
    !route && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $9KJkx.useState(()=>String(++$fb8bfc43ed9eb0bb$var$fetcherId));
    let [Form] = $9KJkx.useState(()=>{
        !routeId && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
        return $fb8bfc43ed9eb0bb$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $9KJkx.useState(()=>(href)=>{
            !router && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
            !routeId && (0, $ea5f54980fbf41f8$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $fb8bfc43ed9eb0bb$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $9KJkx.useMemo(()=>$fb8bfc43ed9eb0bb$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $9KJkx.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fb8bfc43ed9eb0bb$export$fa996778a3a31087() {
    let state = $fb8bfc43ed9eb0bb$var$useDataRouterState($fb8bfc43ed9eb0bb$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $fb8bfc43ed9eb0bb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $fb8bfc43ed9eb0bb$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fb8bfc43ed9eb0bb$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $fb8bfc43ed9eb0bb$var$useDataRouterContext($fb8bfc43ed9eb0bb$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fb8bfc43ed9eb0bb$var$useDataRouterState($fb8bfc43ed9eb0bb$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $9KJkx.useContext((0, $7222be8890473787$export$26749e8557646306));
    let location = (0, $7222be8890473787$export$45d76561a5302f2b)();
    let matches = (0, $7222be8890473787$export$2378eb7f5ff86053)();
    let navigation = (0, $7222be8890473787$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $9KJkx.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fb8bfc43ed9eb0bb$var$usePageHide($9KJkx.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $fb8bfc43ed9eb0bb$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $fb8bfc43ed9eb0bb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fb8bfc43ed9eb0bb$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9KJkx.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fb8bfc43ed9eb0bb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fb8bfc43ed9eb0bb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9KJkx.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($fb8bfc43ed9eb0bb$var$_extends({}, location, {
                    pathname: (0, $ea5f54980fbf41f8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fb8bfc43ed9eb0bb$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $9KJkx.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fb8bfc43ed9eb0bb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $9KJkx.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fb8bfc43ed9eb0bb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $9KJkx.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fb8bfc43ed9eb0bb$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $7222be8890473787$export$2af03a1de5c0910)(when);
    $9KJkx.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $9KJkx.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}


const $11499d46e9310e07$var$DEFAULT_LANGUAGE_VALUE = "Any Language";
const $11499d46e9310e07$var$DEFAULT_YEAR_VALUE = "Year";
const $11499d46e9310e07$var$options = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
    title: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
    slug: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string()
}));
const $11499d46e9310e07$var$popularSearches = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
    title: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    text: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    "author-institution": (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    "region-country": (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    language: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    "year-from": (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    "year-to": (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable()
}));
const $11499d46e9310e07$var$categories = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).string());
const $11499d46e9310e07$var$recentlyAdded = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
    title: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
    image: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string().nullable(),
    url: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
    authors: $11499d46e9310e07$var$categories,
    years: $11499d46e9310e07$var$categories
}));
const $11499d46e9310e07$var$props = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
    languages: $11499d46e9310e07$var$options,
    years: $11499d46e9310e07$var$options,
    popularSearches: $11499d46e9310e07$var$popularSearches,
    recentlyAdded: $11499d46e9310e07$var$recentlyAdded
});
const $11499d46e9310e07$var$documentsSchema = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
    title: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
    url: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
    authors: $11499d46e9310e07$var$categories,
    institutions: $11499d46e9310e07$var$categories,
    regions: $11499d46e9310e07$var$categories,
    countries: $11499d46e9310e07$var$categories,
    languages: $11499d46e9310e07$var$categories,
    years: $11499d46e9310e07$var$categories
}));
function $11499d46e9310e07$export$2e2bcd8739ae039() {
    const rootNode = document.getElementById("search");
    if (!rootNode) return;
    const data = $11499d46e9310e07$var$props.parse(JSON.parse(rootNode?.dataset.search ?? ""));
    const root = (0, $bcfd25cead63bedb$export$882461b6382ed46c)(rootNode);
    root.render(/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $fb8bfc43ed9eb0bb$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Search, {
            ...data
        })
    }));
}
function $11499d46e9310e07$var$Search({ languages: languages, years: years, popularSearches: popularSearches, recentlyAdded: recentlyAdded }) {
    const [state, setState] = (0, $9KJkx.useState)(null);
    const [searchParams, _] = (0, $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a)();
    const textParam = searchParams.get("text");
    const authorOrInstitutionParam = searchParams.get("author-institution");
    const regionOrCountryParam = searchParams.get("region-country");
    const languageParam = searchParams.get("language");
    const yearFromParam = searchParams.get("year-from");
    const yearToParam = searchParams.get("year-to");
    const filterParams = [
        authorOrInstitutionParam,
        regionOrCountryParam,
        languageParam,
        yearFromParam,
        yearToParam
    ].filter((param)=>param !== null);
    const isFiltering = filterParams.length > 0;
    const isSearching = textParam || isFiltering;
    (0, $9KJkx.useEffect)(()=>{
        if (isSearching) {
            const getInitialDocuments = async ()=>{
                const params = new URLSearchParams(window.location.search);
                await $11499d46e9310e07$var$getDocuments(params.toString(), setState);
            };
            getInitialDocuments();
        }
    }, []);
    async function handleSubmit() {
        const params = new URLSearchParams(window.location.search);
        await $11499d46e9310e07$var$getDocuments(params.toString(), setState);
    }
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $25a891b5df1b0dc7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("form", {
                className: "mb-12 sm:mb-16",
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleSubmit();
                },
                children: [
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                        className: "mb-4 sm:mb-6 sm:flex sm:gap-6",
                        children: [
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                className: "mb-3 sm:mb-0 sm:w-[70%] lg:w-[640px]",
                                children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$InputSearch, {
                                    name: "text",
                                    value: textParam,
                                    placeholder: "Search documents...",
                                    isLarge: true
                                })
                            }),
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("button", {
                                type: "submit",
                                className: "h-[48px] sm:h-auto w-full sm:w-auto group flex items-center justify-center bg-green hover:bg-black active:bg-plum py-4 px-6 text-2xs sm:text-xs text-plum hover:text-white tracking-tight leading-[1.5] font-bold transition-colors cursor-pointer rounded-lg",
                                children: [
                                    "Search",
                                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$SearchIcon, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Filter, {
                        isActive: isFiltering,
                        params: filterParams,
                        onSubmit: ()=>handleSubmit(),
                        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                            className: "open hidden [&.open]:block",
                            children: [
                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                                    className: "mb-6 sm:flex sm:gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                            className: "mb-4 sm:mb-0 sm:w-[312px]",
                                            children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$InputSearch, {
                                                name: "author-institution",
                                                value: authorOrInstitutionParam,
                                                placeholder: "Author or institution",
                                                onChange: ()=>handleSubmit()
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                            className: "mb-4 sm:mb-0 sm:w-[312px]",
                                            children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$InputSearch, {
                                                name: "region-country",
                                                value: regionOrCountryParam,
                                                placeholder: "Region or country",
                                                onChange: ()=>handleSubmit()
                                            })
                                        }),
                                        languages.length > 0 && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                            className: "mb-4 sm:mb-0 sm:w-[312px]",
                                            children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Select, {
                                                name: "language",
                                                options: languages,
                                                value: languageParam,
                                                placeholder: $11499d46e9310e07$var$DEFAULT_LANGUAGE_VALUE,
                                                onChange: ()=>handleSubmit()
                                            })
                                        })
                                    ]
                                }),
                                years.length > 0 && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                                    className: "mb-1 sm:flex sm:gap-6 sm:items-center",
                                    children: [
                                        /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("label", {
                                            className: "block mb-3 sm:mb-0 text-2xs sm:text-xs leading-[1.5] tracking-tight",
                                            children: "Publication Date"
                                        }),
                                        /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                                            className: "flex items-center gap-6 mb-6 sm:mb-0",
                                            children: [
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                                    className: "w-[146px]",
                                                    children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Select, {
                                                        name: "year-from",
                                                        options: years,
                                                        value: yearFromParam,
                                                        placeholder: $11499d46e9310e07$var$DEFAULT_YEAR_VALUE,
                                                        onChange: ()=>handleSubmit()
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("span", {
                                                    className: "text-xs leading-[1.5] tracking-tight",
                                                    children: "to"
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                                    className: "w-[146px]",
                                                    children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Select, {
                                                        name: "year-to",
                                                        options: years,
                                                        value: yearToParam,
                                                        placeholder: $11499d46e9310e07$var$DEFAULT_YEAR_VALUE,
                                                        onChange: ()=>handleSubmit()
                                                    })
                                                })
                                            ]
                                        }),
                                        isFiltering && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$ClearButton, {
                                            onClick: ()=>handleSubmit()
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Page, {
                state: state,
                popularSearches: popularSearches,
                recentlyAdded: recentlyAdded
            })
        ]
    });
}
const $11499d46e9310e07$var$getDocuments = async (queryString, setState)=>{
    try {
        setState({
            type: "loading"
        });
        const response = await fetch(`/library/documents?${queryString}`);
        if (!response.ok) throw new Error("Network response was not ok");
        const responseData = await response.json();
        const documents = $11499d46e9310e07$var$documentsSchema.parse(responseData);
        setState({
            type: "documents",
            documents: documents
        });
    } catch (err) {
        setState({
            type: "error",
            message: err
        });
    }
};
function $11499d46e9310e07$var$Page({ state: state, popularSearches: popularSearches, recentlyAdded: recentlyAdded }) {
    if (!state) return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $25a891b5df1b0dc7$exports.Fragment), {
        children: [
            popularSearches.length > 0 && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                className: "mb-12 sm:mb-20",
                children: [
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$HeadingLarge, {
                        children: "Popular Searches"
                    }),
                    popularSearches.map((popularSearch, index)=>{
                        const params = new URLSearchParams();
                        Object.keys(popularSearch).forEach((key)=>{
                            if (key !== "title" && popularSearch[key]) params.append(key, popularSearch[key]);
                        });
                        return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("a", {
                            className: "text-xs leading-[1.4] sm:text-md sm:leading-[1.5] tracking-tight",
                            href: `${window.location.origin}${window.location.pathname}?${params.toString()}`,
                            children: [
                                "“",
                                popularSearch.title,
                                "”",
                                index < popularSearches.length - 1 && ", "
                            ]
                        }, popularSearch.title);
                    })
                ]
            }),
            recentlyAdded.length > 0 && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                className: "mb-12 lg:mb-20",
                children: [
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$HeadingLarge, {
                        children: "Recently Added"
                    }),
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                        className: "lg:grid lg:grid-cols-12 lg:gap-x-9",
                        children: recentlyAdded.map((document1)=>/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                                className: "lg:col-span-4 flex gap-7 mb-6 last:mb-0 lg:mb-0",
                                children: [
                                    document1.image ? /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("a", {
                                        href: document1.url,
                                        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("img", {
                                            className: "max-w-[114px]",
                                            src: document1.image,
                                            alt: document1.title,
                                            loading: "lazy"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                                                className: "mb-2 lg:mb-4",
                                                children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("a", {
                                                    className: "inline font-bridge-head-text text-2xs lg:text-sm leading-[1.3] hover:border-solid hover:border-b-[1.5px] hover:border-purple",
                                                    href: document1.url,
                                                    children: document1.title
                                                }, document1.url)
                                            }),
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("span", {
                                                className: "block text-2xs text-[#3F3F3F] leading-[1.5] tracking-tight",
                                                children: [
                                                    document1.authors[0],
                                                    document1.years[0]
                                                ].filter((value)=>value != null).join(", ")
                                            })
                                        ]
                                    })
                                ]
                            }, document1.url))
                    })
                ]
            })
        ]
    });
    switch(state.type){
        case "loading":
            return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)($11499d46e9310e07$var$HeadingSmall, {
                children: [
                    "Searching...",
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("img", {
                        className: "h-[24px] w-[24px] ml-6",
                        src: "/assets/images/loading.gif"
                    })
                ]
            });
        case "error":
            return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("h3", {
                className: "font-bold",
                children: JSON.stringify(state?.message)
            });
        case "documents":
            return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$HeadingSmall, {
                        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("span", {
                            children: [
                                "Search Results",
                                " ",
                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("span", {
                                    className: "text-[#757575]",
                                    children: [
                                        "(",
                                        state.documents.length,
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    state.documents.length > 0 ? /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("table", {
                            className: "border-collapse w-full",
                            children: [
                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("thead", {
                                    className: "sm:border-solid sm:border-b-[1px] sm:border-[#ddd]",
                                    children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("tr", {
                                        className: "font-akkurat-mono font-normal text-3xs text-[#3F3F3F] tracking-wider leading-[1.5] uppercase",
                                        children: [
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("th", {
                                                className: "hidden sm:table-cell font-normal text-left py-4",
                                                children: "Document Title"
                                            }),
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("th", {
                                                className: "hidden sm:table-cell w-[30%] font-normal text-left py-4",
                                                children: "Author or Institution"
                                            }),
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("th", {
                                                className: "hidden sm:table-cell w-[20%] font-normal text-left py-4",
                                                children: "Region or Country"
                                            }),
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("th", {
                                                className: "hidden sm:table-cell font-normal text-left py-4",
                                                children: "Language"
                                            }),
                                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("th", {
                                                className: "hidden sm:table-cell font-normal text-right py-4",
                                                children: "Year"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("tbody", {
                                    children: state.documents.map((document1)=>/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("tr", {
                                            className: "border-solid border-b-[1px] border-[#ddd] block sm:table-row py-4",
                                            children: [
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("td", {
                                                    className: "font-bridge-head-text text-md sm:text-xs leading-[1.3] tracking-tight sm:py-4 sm:pr-4 mb-4 sm:mb-0 block sm:table-cell",
                                                    children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("a", {
                                                        className: "hover:border-solid hover:border-b-[1.5px] hover:border-purple",
                                                        href: document1.url,
                                                        children: document1.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("td", {
                                                    className: "text-3xs sm:text-2xs sm:py-4 sm:pr-4 block sm:table-cell",
                                                    children: [
                                                        ...new Set([
                                                            ...document1.authors,
                                                            ...document1.institutions
                                                        ])
                                                    ].join(", ")
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("td", {
                                                    className: "text-3xs sm:text-2xs sm:py-4 sm:pr-4 block sm:table-cell",
                                                    children: [
                                                        ...new Set([
                                                            ...document1.regions,
                                                            ...document1.countries
                                                        ])
                                                    ].join(", ")
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("td", {
                                                    className: "text-3xs sm:text-2xs sm:py-4 sm:pr-4 block sm:table-cell",
                                                    children: document1.languages.join(", ")
                                                }),
                                                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("td", {
                                                    className: "text-3xs sm:text-2xs sm:py-4 sm:text-right block sm:table-cell",
                                                    children: document1.years.join(", ")
                                                })
                                            ]
                                        }, document1.url))
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $25a891b5df1b0dc7$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("h4", {
                                className: "mb-4 sm:mb-6 font-bridge-head-ext font-bold text-lg sm:text-xl leading-[1.2] sm:leading-[1.3]",
                                children: "Oops! Looks like we don’t have any documents matching your search criteria."
                            }),
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("p", {
                                className: "text-xs sm:text-md leading-[1.4] sm:leading-[1.5] tracking-tight",
                                children: "Try adjusting your search."
                            })
                        ]
                    })
                ]
            });
    }
}
function $11499d46e9310e07$var$Filter({ isActive: isActive, params: params, children: children, onSubmit: onSubmit }) {
    const [active, setActive] = (0, $9KJkx.useState)(isActive);
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $25a891b5df1b0dc7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("div", {
                className: "flex items-center mb-4 sm:mb-6",
                children: [
                    /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("button", {
                        type: "button",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($d9c73ad69b0d6fe9$exports)))("filter flex items-center text-plum leading-[1.5] tracking-tight", {
                            active: active
                        }),
                        onClick: ()=>setActive(!active),
                        children: [
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("span", {
                                className: "text-2xs sm:text-xs font-bold",
                                children: active ? `Hide filters` : "Show filters"
                            }),
                            params.length > 0 ? /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("span", {
                                className: "bg-purple font-normal text-4xs px-2 rounded-[100px] ml-2",
                                children: params.length
                            }) : null,
                            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$DownArrowIcon, {})
                        ]
                    }),
                    !active && /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                        className: "flex gap-4 ml-6",
                        children: params.map((param)=>/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$Pill, {
                                param: param,
                                onClick: ()=>onSubmit()
                            }, param))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d9c73ad69b0d6fe9$exports)))({
                    hidden: !active,
                    block: active
                }),
                children: children
            })
        ]
    });
}
function $11499d46e9310e07$var$InputSearch({ name: name, value: value, placeholder: placeholder, isLarge: isLarge = false, onChange: onChange }) {
    const [_, setSearchParams] = (0, $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a)();
    const timerRef = (0, $9KJkx.useRef)(null);
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("input", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d9c73ad69b0d6fe9$exports)))("w-full rounded-lg tracking-tight focus:outline-none border-solid border-[2px] border-white hover:border-purple focus:border-plum transition-colors", {
            "p-4 text-xs h-[56px] sm:h-[62px]": isLarge,
            "p-3 text-2xs leading-[1.5] h-[56px]": !isLarge
        }),
        type: "search",
        name: name,
        value: value ?? "",
        placeholder: placeholder,
        autoComplete: "off",
        onChange: (e)=>{
            setSearchParams((prev)=>{
                if (e.target.value) prev.set(name, e.target.value);
                else prev.delete(name);
                return prev;
            }, {
                replace: true
            });
            if (onChange) {
                clearTimeout(timerRef.current ?? undefined);
                timerRef.current = setTimeout(()=>{
                    onChange();
                }, 1000);
            }
        }
    });
}
function $11499d46e9310e07$var$Select({ name: name, value: value, options: options, placeholder: placeholder, onChange: onChange }) {
    const [_, setSearchParams] = (0, $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("div", {
        className: "relative after:content-[''] after:absolute after:right-0 after:top-[50%] after:translate-y-[-50%] after:mr-3 after:h-[24px] after:w-[24px] after:bg-down-arrow",
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("select", {
            className: "appearance-none w-full p-3 text-2xs leading-[1.5] rounded-lg tracking-tight focus:outline-none border-solid border-[2px] border-white hover:border-purple focus:border-plum transition-colors",
            name: name,
            value: value ?? "",
            onChange: (e)=>{
                setSearchParams((prev)=>{
                    if (e.target.value !== placeholder) prev.set(name, e.target.value);
                    else prev.delete(name);
                    return prev;
                }, {
                    replace: true
                });
                if (onChange) onChange();
            },
            children: [
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("option", {
                    defaultValue: "",
                    children: placeholder
                }),
                options.map((option)=>/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("option", {
                        defaultValue: option.slug,
                        children: option.title
                    }, option.slug))
            ]
        })
    });
}
function $11499d46e9310e07$var$Pill({ param: param, onClick: onClick }) {
    const [_, setSearchParams] = (0, $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("button", {
        className: "flex items-center text-contrasting-purple border-solid border-contrasting-purple border-[1px] rounded-lg text-4xs leading-[1.5] tracking-tight px-3 py-1",
        type: "button",
        onClick: ()=>{
            setSearchParams((prev)=>{
                for (const [key, val] of prev.entries())if (val === param) prev.delete(key);
                return prev;
            }, {
                replace: true
            });
            onClick();
        },
        children: [
            param,
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$CloseIconSmall, {})
        ]
    });
}
function $11499d46e9310e07$var$ClearButton({ onClick: onClick }) {
    const [searchParams, setSearchParams] = (0, $fb8bfc43ed9eb0bb$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)("button", {
        className: "flex items-center font-bold text-plum text-2xs leading-[1.2] tracking-tight",
        type: "button",
        onClick: ()=>{
            const textParam = searchParams.get("text");
            if (textParam) setSearchParams({
                text: textParam
            }, {
                replace: true
            });
            else setSearchParams(undefined, {
                replace: true
            });
            onClick();
        },
        children: [
            "Clear all ",
            /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)($11499d46e9310e07$var$CloseIconLarge, {})
        ]
    });
}
function $11499d46e9310e07$var$SearchIcon() {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("svg", {
        className: "ml-[10px] stroke-black group-hover:stroke-white group-active:stroke-white transition-colors",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("path", {
            d: "M17 17L21 21M3 11C3 13.1217 3.84285 15.1566 5.34315 16.6569C6.84344 18.1571 8.87827 19 11 19C13.1217 19 15.1566 18.1571 16.6569 16.6569C18.1571 15.1566 19 13.1217 19 11C19 8.87827 18.1571 6.84344 16.6569 5.34315C15.1566 3.84285 13.1217 3 11 3C8.87827 3 6.84344 3.84285 5.34315 5.34315C3.84285 6.84344 3 8.87827 3 11Z",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $11499d46e9310e07$var$DownArrowIcon() {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("svg", {
        className: "ml-2 [.filter.active_&]:rotate-180",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("path", {
            d: "M6 9L12 15L18 9",
            stroke: "#3F0853",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $11499d46e9310e07$var$CloseIconLarge() {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("svg", {
        className: "ml-2",
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("path", {
            d: "M5 5.5L19 19.5M19 5.5L5 19.5",
            stroke: "#3F0853",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $11499d46e9310e07$var$CloseIconSmall() {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("svg", {
        className: "ml-2",
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("path", {
            d: "M2.5 2.5L9.5 9.5M9.5 2.5L2.5 9.5",
            stroke: "#690B96",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
        })
    });
}
function $11499d46e9310e07$var$HeadingLarge({ children: children }) {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("h3", {
        className: "mb-8 sm:mb-10 font-bold text-sm sm:text-lg leading-[1.3] tracking-tight",
        children: children
    });
}
function $11499d46e9310e07$var$HeadingSmall({ children: children }) {
    return /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)("h3", {
        className: "flex items-center mb-6 sm:mb-10 font-bold text-md sm:text-sm leading-[1.2] tracking-tight",
        children: children
    });
}




parcelRequire("9KJkx");
function $416e29c4ee421493$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $416e29c4ee421493$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $416e29c4ee421493$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $416e29c4ee421493$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $416e29c4ee421493$export$2e2bcd8739ae039 = $416e29c4ee421493$export$4f5d2d50c9deca37;



var $9KJkx = parcelRequire("9KJkx");
var $210f438d283ca1c5$exports = {};
var $cd092c2760b4362d$exports = {};
var $dba4143ccd45ffc1$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dba4143ccd45ffc1$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$dba4143ccd45ffc1$exports = $dba4143ccd45ffc1$var$isObject;


var $4ec511c4ebedd6d1$exports = {};

var $jgVft = parcelRequire("jgVft");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $4ec511c4ebedd6d1$var$now = function() {
    return $jgVft.Date.now();
};
$4ec511c4ebedd6d1$exports = $4ec511c4ebedd6d1$var$now;


var $8ad1792df8b974ad$exports = {};
var $2bc8b4729d5fa937$exports = {};
var $6916f3111bacc8a4$exports = {};
/** Used to match a single whitespace character. */ var $6916f3111bacc8a4$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6916f3111bacc8a4$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6916f3111bacc8a4$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6916f3111bacc8a4$exports = $6916f3111bacc8a4$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $2bc8b4729d5fa937$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $2bc8b4729d5fa937$var$baseTrim(string) {
    return string ? string.slice(0, $6916f3111bacc8a4$exports(string) + 1).replace($2bc8b4729d5fa937$var$reTrimStart, "") : string;
}
$2bc8b4729d5fa937$exports = $2bc8b4729d5fa937$var$baseTrim;



var $bc906635e498c759$exports = {};
var $e5640db8046fdbb6$exports = {};
var $c7b8eaee86d7adbd$exports = {};

var $jgVft = parcelRequire("jgVft");
/** Built-in value references. */ var $c7b8eaee86d7adbd$var$Symbol = $jgVft.Symbol;
$c7b8eaee86d7adbd$exports = $c7b8eaee86d7adbd$var$Symbol;


var $1ff6d43bc0a2dbcd$exports = {};

/** Used for built-in method references. */ var $1ff6d43bc0a2dbcd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1ff6d43bc0a2dbcd$var$hasOwnProperty = $1ff6d43bc0a2dbcd$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1ff6d43bc0a2dbcd$var$nativeObjectToString = $1ff6d43bc0a2dbcd$var$objectProto.toString;
/** Built-in value references. */ var $1ff6d43bc0a2dbcd$var$symToStringTag = $c7b8eaee86d7adbd$exports ? $c7b8eaee86d7adbd$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $1ff6d43bc0a2dbcd$var$getRawTag(value) {
    var isOwn = $1ff6d43bc0a2dbcd$var$hasOwnProperty.call(value, $1ff6d43bc0a2dbcd$var$symToStringTag), tag = value[$1ff6d43bc0a2dbcd$var$symToStringTag];
    try {
        value[$1ff6d43bc0a2dbcd$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $1ff6d43bc0a2dbcd$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$1ff6d43bc0a2dbcd$var$symToStringTag] = tag;
        else delete value[$1ff6d43bc0a2dbcd$var$symToStringTag];
    }
    return result;
}
$1ff6d43bc0a2dbcd$exports = $1ff6d43bc0a2dbcd$var$getRawTag;


var $244c6a969e2ee400$exports = {};
/** Used for built-in method references. */ var $244c6a969e2ee400$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $244c6a969e2ee400$var$nativeObjectToString = $244c6a969e2ee400$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $244c6a969e2ee400$var$objectToString(value) {
    return $244c6a969e2ee400$var$nativeObjectToString.call(value);
}
$244c6a969e2ee400$exports = $244c6a969e2ee400$var$objectToString;


/** `Object#toString` result references. */ var $e5640db8046fdbb6$var$nullTag = "[object Null]", $e5640db8046fdbb6$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $e5640db8046fdbb6$var$symToStringTag = $c7b8eaee86d7adbd$exports ? $c7b8eaee86d7adbd$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e5640db8046fdbb6$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e5640db8046fdbb6$var$undefinedTag : $e5640db8046fdbb6$var$nullTag;
    return $e5640db8046fdbb6$var$symToStringTag && $e5640db8046fdbb6$var$symToStringTag in Object(value) ? $1ff6d43bc0a2dbcd$exports(value) : $244c6a969e2ee400$exports(value);
}
$e5640db8046fdbb6$exports = $e5640db8046fdbb6$var$baseGetTag;


var $2ea446141c31cf3d$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ea446141c31cf3d$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$2ea446141c31cf3d$exports = $2ea446141c31cf3d$var$isObjectLike;


/** `Object#toString` result references. */ var $bc906635e498c759$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $bc906635e498c759$var$isSymbol(value) {
    return typeof value == "symbol" || $2ea446141c31cf3d$exports(value) && $e5640db8046fdbb6$exports(value) == $bc906635e498c759$var$symbolTag;
}
$bc906635e498c759$exports = $bc906635e498c759$var$isSymbol;


/** Used as references for various `Number` constants. */ var $8ad1792df8b974ad$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8ad1792df8b974ad$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8ad1792df8b974ad$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8ad1792df8b974ad$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8ad1792df8b974ad$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8ad1792df8b974ad$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($bc906635e498c759$exports(value)) return $8ad1792df8b974ad$var$NAN;
    if ($dba4143ccd45ffc1$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $dba4143ccd45ffc1$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $2bc8b4729d5fa937$exports(value);
    var isBinary = $8ad1792df8b974ad$var$reIsBinary.test(value);
    return isBinary || $8ad1792df8b974ad$var$reIsOctal.test(value) ? $8ad1792df8b974ad$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8ad1792df8b974ad$var$reIsBadHex.test(value) ? $8ad1792df8b974ad$var$NAN : +value;
}
$8ad1792df8b974ad$exports = $8ad1792df8b974ad$var$toNumber;


/** Error message constants. */ var $cd092c2760b4362d$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd092c2760b4362d$var$nativeMax = Math.max, $cd092c2760b4362d$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $cd092c2760b4362d$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($cd092c2760b4362d$var$FUNC_ERROR_TEXT);
    wait = $8ad1792df8b974ad$exports(wait) || 0;
    if ($dba4143ccd45ffc1$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $cd092c2760b4362d$var$nativeMax($8ad1792df8b974ad$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $cd092c2760b4362d$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $4ec511c4ebedd6d1$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($4ec511c4ebedd6d1$exports());
    }
    function debounced() {
        var time = $4ec511c4ebedd6d1$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$cd092c2760b4362d$exports = $cd092c2760b4362d$var$debounce;



/** Error message constants. */ var $210f438d283ca1c5$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $210f438d283ca1c5$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($210f438d283ca1c5$var$FUNC_ERROR_TEXT);
    if ($dba4143ccd45ffc1$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $cd092c2760b4362d$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$210f438d283ca1c5$exports = $210f438d283ca1c5$var$throttle;


var $c24026ac5bd36ce0$exports = {};
"use strict";

$c24026ac5bd36ce0$exports = (parcelRequire("fR9CR"));


var $77d9a27889f83835$exports = {};

var $fcffceb67c06866f$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $fcffceb67c06866f$var$isArray = Array.isArray;
$fcffceb67c06866f$exports = $fcffceb67c06866f$var$isArray;



/** `Object#toString` result references. */ var $77d9a27889f83835$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $77d9a27889f83835$var$isString(value) {
    return typeof value == "string" || !$fcffceb67c06866f$exports(value) && $2ea446141c31cf3d$exports(value) && $e5640db8046fdbb6$exports(value) == $77d9a27889f83835$var$stringTag;
}
$77d9a27889f83835$exports = $77d9a27889f83835$var$isString;


var $106a9ee8332602e2$exports = {};
var $a907811d00b2aa8e$exports = {};


/** `Object#toString` result references. */ var $a907811d00b2aa8e$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $a907811d00b2aa8e$var$isNumber(value) {
    return typeof value == "number" || $2ea446141c31cf3d$exports(value) && $e5640db8046fdbb6$exports(value) == $a907811d00b2aa8e$var$numberTag;
}
$a907811d00b2aa8e$exports = $a907811d00b2aa8e$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $106a9ee8332602e2$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $a907811d00b2aa8e$exports(value) && value != +value;
}
$106a9ee8332602e2$exports = $106a9ee8332602e2$var$isNaN;


var $72b701a528e94106$exports = {};
var $5f55a9144e42af22$exports = {};
var $2c26c95ed0049a1f$exports = {};

var $828929acb6543810$exports = {};


/** Used to match property names within property paths. */ var $828929acb6543810$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $828929acb6543810$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $828929acb6543810$var$isKey(value, object) {
    if ($fcffceb67c06866f$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $bc906635e498c759$exports(value)) return true;
    return $828929acb6543810$var$reIsPlainProp.test(value) || !$828929acb6543810$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$828929acb6543810$exports = $828929acb6543810$var$isKey;


var $65e9c5c4858c721f$exports = {};
var $896e0aecc269088a$exports = {};
var $a9c98813ee857279$exports = {};
var $5f580ee10f3abb81$exports = {};
var $1852f431810d6b16$exports = {};
var $283a6ffc8ee5636e$exports = {};
var $1618b0fc3c9984ed$exports = {};
var $d4977497f7ee4dbb$exports = {};
var $44f0d6b1e7551713$exports = {};
var $466b85590590083c$exports = {};
var $3dca80e523384196$exports = {};


/** `Object#toString` result references. */ var $3dca80e523384196$var$asyncTag = "[object AsyncFunction]", $3dca80e523384196$var$funcTag = "[object Function]", $3dca80e523384196$var$genTag = "[object GeneratorFunction]", $3dca80e523384196$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3dca80e523384196$var$isFunction(value) {
    if (!$dba4143ccd45ffc1$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $e5640db8046fdbb6$exports(value);
    return tag == $3dca80e523384196$var$funcTag || tag == $3dca80e523384196$var$genTag || tag == $3dca80e523384196$var$asyncTag || tag == $3dca80e523384196$var$proxyTag;
}
$3dca80e523384196$exports = $3dca80e523384196$var$isFunction;


var $b5df82991ecd3d5f$exports = {};
var $d8873b7ee8988f8b$exports = {};

var $jgVft = parcelRequire("jgVft");
/** Used to detect overreaching core-js shims. */ var $d8873b7ee8988f8b$var$coreJsData = $jgVft["__core-js_shared__"];
$d8873b7ee8988f8b$exports = $d8873b7ee8988f8b$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $b5df82991ecd3d5f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($d8873b7ee8988f8b$exports && $d8873b7ee8988f8b$exports.keys && $d8873b7ee8988f8b$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b5df82991ecd3d5f$var$isMasked(func) {
    return !!$b5df82991ecd3d5f$var$maskSrcKey && $b5df82991ecd3d5f$var$maskSrcKey in func;
}
$b5df82991ecd3d5f$exports = $b5df82991ecd3d5f$var$isMasked;



var $a35771c56f74bbb1$exports = {};
/** Used for built-in method references. */ var $a35771c56f74bbb1$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $a35771c56f74bbb1$var$funcToString = $a35771c56f74bbb1$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $a35771c56f74bbb1$var$toSource(func) {
    if (func != null) {
        try {
            return $a35771c56f74bbb1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$a35771c56f74bbb1$exports = $a35771c56f74bbb1$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $466b85590590083c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $466b85590590083c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $466b85590590083c$var$funcProto = Function.prototype, $466b85590590083c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $466b85590590083c$var$funcToString = $466b85590590083c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $466b85590590083c$var$hasOwnProperty = $466b85590590083c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $466b85590590083c$var$reIsNative = RegExp("^" + $466b85590590083c$var$funcToString.call($466b85590590083c$var$hasOwnProperty).replace($466b85590590083c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $466b85590590083c$var$baseIsNative(value) {
    if (!$dba4143ccd45ffc1$exports(value) || $b5df82991ecd3d5f$exports(value)) return false;
    var pattern = $3dca80e523384196$exports(value) ? $466b85590590083c$var$reIsNative : $466b85590590083c$var$reIsHostCtor;
    return pattern.test($a35771c56f74bbb1$exports(value));
}
$466b85590590083c$exports = $466b85590590083c$var$baseIsNative;


var $3f6f4fe8e7be6cad$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3f6f4fe8e7be6cad$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$3f6f4fe8e7be6cad$exports = $3f6f4fe8e7be6cad$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $44f0d6b1e7551713$var$getNative(object, key) {
    var value = $3f6f4fe8e7be6cad$exports(object, key);
    return $466b85590590083c$exports(value) ? value : undefined;
}
$44f0d6b1e7551713$exports = $44f0d6b1e7551713$var$getNative;


/* Built-in method references that are verified to be native. */ var $d4977497f7ee4dbb$var$nativeCreate = $44f0d6b1e7551713$exports(Object, "create");
$d4977497f7ee4dbb$exports = $d4977497f7ee4dbb$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1618b0fc3c9984ed$var$hashClear() {
    this.__data__ = $d4977497f7ee4dbb$exports ? $d4977497f7ee4dbb$exports(null) : {};
    this.size = 0;
}
$1618b0fc3c9984ed$exports = $1618b0fc3c9984ed$var$hashClear;


var $c2f3f90de5414582$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c2f3f90de5414582$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$c2f3f90de5414582$exports = $c2f3f90de5414582$var$hashDelete;


var $d336ef7052c6ea55$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $d336ef7052c6ea55$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $d336ef7052c6ea55$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d336ef7052c6ea55$var$hasOwnProperty = $d336ef7052c6ea55$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d336ef7052c6ea55$var$hashGet(key) {
    var data = this.__data__;
    if ($d4977497f7ee4dbb$exports) {
        var result = data[key];
        return result === $d336ef7052c6ea55$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d336ef7052c6ea55$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$d336ef7052c6ea55$exports = $d336ef7052c6ea55$var$hashGet;


var $06ea3653b918d8ac$exports = {};

/** Used for built-in method references. */ var $06ea3653b918d8ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $06ea3653b918d8ac$var$hasOwnProperty = $06ea3653b918d8ac$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $06ea3653b918d8ac$var$hashHas(key) {
    var data = this.__data__;
    return $d4977497f7ee4dbb$exports ? data[key] !== undefined : $06ea3653b918d8ac$var$hasOwnProperty.call(data, key);
}
$06ea3653b918d8ac$exports = $06ea3653b918d8ac$var$hashHas;


var $3cc4aea2052814b6$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $3cc4aea2052814b6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $3cc4aea2052814b6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $d4977497f7ee4dbb$exports && value === undefined ? $3cc4aea2052814b6$var$HASH_UNDEFINED : value;
    return this;
}
$3cc4aea2052814b6$exports = $3cc4aea2052814b6$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $283a6ffc8ee5636e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$283a6ffc8ee5636e$var$Hash.prototype.clear = $1618b0fc3c9984ed$exports;
$283a6ffc8ee5636e$var$Hash.prototype["delete"] = $c2f3f90de5414582$exports;
$283a6ffc8ee5636e$var$Hash.prototype.get = $d336ef7052c6ea55$exports;
$283a6ffc8ee5636e$var$Hash.prototype.has = $06ea3653b918d8ac$exports;
$283a6ffc8ee5636e$var$Hash.prototype.set = $3cc4aea2052814b6$exports;
$283a6ffc8ee5636e$exports = $283a6ffc8ee5636e$var$Hash;


var $3b1a4a85555466b9$exports = {};
var $216c6a9ff30b68f8$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $216c6a9ff30b68f8$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$216c6a9ff30b68f8$exports = $216c6a9ff30b68f8$var$listCacheClear;


var $98a3fdc9607db440$exports = {};
var $d4b61b4988b5f45c$exports = {};
var $6a43b4a5a31825f6$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $6a43b4a5a31825f6$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$6a43b4a5a31825f6$exports = $6a43b4a5a31825f6$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d4b61b4988b5f45c$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6a43b4a5a31825f6$exports(array[length][0], key)) return length;
    }
    return -1;
}
$d4b61b4988b5f45c$exports = $d4b61b4988b5f45c$var$assocIndexOf;


/** Used for built-in method references. */ var $98a3fdc9607db440$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $98a3fdc9607db440$var$splice = $98a3fdc9607db440$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $98a3fdc9607db440$var$listCacheDelete(key) {
    var data = this.__data__, index = $d4b61b4988b5f45c$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $98a3fdc9607db440$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$98a3fdc9607db440$exports = $98a3fdc9607db440$var$listCacheDelete;


var $96899fbf02d40ccb$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $96899fbf02d40ccb$var$listCacheGet(key) {
    var data = this.__data__, index = $d4b61b4988b5f45c$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$96899fbf02d40ccb$exports = $96899fbf02d40ccb$var$listCacheGet;


var $fc8d16851a41c9a3$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc8d16851a41c9a3$var$listCacheHas(key) {
    return $d4b61b4988b5f45c$exports(this.__data__, key) > -1;
}
$fc8d16851a41c9a3$exports = $fc8d16851a41c9a3$var$listCacheHas;


var $81f2bee29925c0bf$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $81f2bee29925c0bf$var$listCacheSet(key, value) {
    var data = this.__data__, index = $d4b61b4988b5f45c$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$81f2bee29925c0bf$exports = $81f2bee29925c0bf$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3b1a4a85555466b9$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$3b1a4a85555466b9$var$ListCache.prototype.clear = $216c6a9ff30b68f8$exports;
$3b1a4a85555466b9$var$ListCache.prototype["delete"] = $98a3fdc9607db440$exports;
$3b1a4a85555466b9$var$ListCache.prototype.get = $96899fbf02d40ccb$exports;
$3b1a4a85555466b9$var$ListCache.prototype.has = $fc8d16851a41c9a3$exports;
$3b1a4a85555466b9$var$ListCache.prototype.set = $81f2bee29925c0bf$exports;
$3b1a4a85555466b9$exports = $3b1a4a85555466b9$var$ListCache;


var $144d4f6027fbd351$exports = {};


var $jgVft = parcelRequire("jgVft");
/* Built-in method references that are verified to be native. */ var $144d4f6027fbd351$var$Map = $44f0d6b1e7551713$exports($jgVft, "Map");
$144d4f6027fbd351$exports = $144d4f6027fbd351$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1852f431810d6b16$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $283a6ffc8ee5636e$exports,
        "map": new ($144d4f6027fbd351$exports || $3b1a4a85555466b9$exports),
        "string": new $283a6ffc8ee5636e$exports
    };
}
$1852f431810d6b16$exports = $1852f431810d6b16$var$mapCacheClear;


var $0aa9cd782ee8fc49$exports = {};
var $67872ca8c4aedd3c$exports = {};
var $7182677a720aca66$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $7182677a720aca66$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$7182677a720aca66$exports = $7182677a720aca66$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $67872ca8c4aedd3c$var$getMapData(map, key) {
    var data = map.__data__;
    return $7182677a720aca66$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$67872ca8c4aedd3c$exports = $67872ca8c4aedd3c$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0aa9cd782ee8fc49$var$mapCacheDelete(key) {
    var result = $67872ca8c4aedd3c$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$0aa9cd782ee8fc49$exports = $0aa9cd782ee8fc49$var$mapCacheDelete;


var $fe4ec5e6e978ecae$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fe4ec5e6e978ecae$var$mapCacheGet(key) {
    return $67872ca8c4aedd3c$exports(this, key).get(key);
}
$fe4ec5e6e978ecae$exports = $fe4ec5e6e978ecae$var$mapCacheGet;


var $1bce49bc04ebd6a8$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1bce49bc04ebd6a8$var$mapCacheHas(key) {
    return $67872ca8c4aedd3c$exports(this, key).has(key);
}
$1bce49bc04ebd6a8$exports = $1bce49bc04ebd6a8$var$mapCacheHas;


var $1cccc7a0ca6126bc$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $1cccc7a0ca6126bc$var$mapCacheSet(key, value) {
    var data = $67872ca8c4aedd3c$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$1cccc7a0ca6126bc$exports = $1cccc7a0ca6126bc$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5f580ee10f3abb81$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5f580ee10f3abb81$var$MapCache.prototype.clear = $1852f431810d6b16$exports;
$5f580ee10f3abb81$var$MapCache.prototype["delete"] = $0aa9cd782ee8fc49$exports;
$5f580ee10f3abb81$var$MapCache.prototype.get = $fe4ec5e6e978ecae$exports;
$5f580ee10f3abb81$var$MapCache.prototype.has = $1bce49bc04ebd6a8$exports;
$5f580ee10f3abb81$var$MapCache.prototype.set = $1cccc7a0ca6126bc$exports;
$5f580ee10f3abb81$exports = $5f580ee10f3abb81$var$MapCache;


/** Error message constants. */ var $a9c98813ee857279$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a9c98813ee857279$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a9c98813ee857279$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a9c98813ee857279$var$memoize.Cache || $5f580ee10f3abb81$exports);
    return memoized;
}
// Expose `MapCache`.
$a9c98813ee857279$var$memoize.Cache = $5f580ee10f3abb81$exports;
$a9c98813ee857279$exports = $a9c98813ee857279$var$memoize;


/** Used as the maximum memoize cache size. */ var $896e0aecc269088a$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $896e0aecc269088a$var$memoizeCapped(func) {
    var result = $a9c98813ee857279$exports(func, function(key) {
        if (cache.size === $896e0aecc269088a$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$896e0aecc269088a$exports = $896e0aecc269088a$var$memoizeCapped;


/** Used to match property names within property paths. */ var $65e9c5c4858c721f$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $65e9c5c4858c721f$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $65e9c5c4858c721f$var$stringToPath = $896e0aecc269088a$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($65e9c5c4858c721f$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($65e9c5c4858c721f$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$65e9c5c4858c721f$exports = $65e9c5c4858c721f$var$stringToPath;


var $96d32cc37a67927b$exports = {};
var $dfcd73a6fae955de$exports = {};

var $99747295c2209139$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $99747295c2209139$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$99747295c2209139$exports = $99747295c2209139$var$arrayMap;




/** Used as references for various `Number` constants. */ var $dfcd73a6fae955de$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $dfcd73a6fae955de$var$symbolProto = $c7b8eaee86d7adbd$exports ? $c7b8eaee86d7adbd$exports.prototype : undefined, $dfcd73a6fae955de$var$symbolToString = $dfcd73a6fae955de$var$symbolProto ? $dfcd73a6fae955de$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dfcd73a6fae955de$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($fcffceb67c06866f$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $99747295c2209139$exports(value, $dfcd73a6fae955de$var$baseToString) + "";
    if ($bc906635e498c759$exports(value)) return $dfcd73a6fae955de$var$symbolToString ? $dfcd73a6fae955de$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$dfcd73a6fae955de$var$INFINITY ? "-0" : result;
}
$dfcd73a6fae955de$exports = $dfcd73a6fae955de$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $96d32cc37a67927b$var$toString(value) {
    return value == null ? "" : $dfcd73a6fae955de$exports(value);
}
$96d32cc37a67927b$exports = $96d32cc37a67927b$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $2c26c95ed0049a1f$var$castPath(value, object) {
    if ($fcffceb67c06866f$exports(value)) return value;
    return $828929acb6543810$exports(value, object) ? [
        value
    ] : $65e9c5c4858c721f$exports($96d32cc37a67927b$exports(value));
}
$2c26c95ed0049a1f$exports = $2c26c95ed0049a1f$var$castPath;


var $45828227bb9c497e$exports = {};

/** Used as references for various `Number` constants. */ var $45828227bb9c497e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $45828227bb9c497e$var$toKey(value) {
    if (typeof value == "string" || $bc906635e498c759$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$45828227bb9c497e$var$INFINITY ? "-0" : result;
}
$45828227bb9c497e$exports = $45828227bb9c497e$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $5f55a9144e42af22$var$baseGet(object, path) {
    path = $2c26c95ed0049a1f$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$45828227bb9c497e$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$5f55a9144e42af22$exports = $5f55a9144e42af22$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $72b701a528e94106$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5f55a9144e42af22$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$72b701a528e94106$exports = $72b701a528e94106$var$get;



var $3c48a89ca795c151$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $3c48a89ca795c151$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($77d9a27889f83835$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $3c48a89ca795c151$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a907811d00b2aa8e$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($106a9ee8332602e2$exports)))(value);
};
var $3c48a89ca795c151$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $3c48a89ca795c151$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($77d9a27889f83835$exports)))(value);
};
var $3c48a89ca795c151$var$idCounter = 0;
var $3c48a89ca795c151$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$3c48a89ca795c151$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $3c48a89ca795c151$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$3c48a89ca795c151$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($77d9a27889f83835$exports)))(percent)) return defaultValue;
    var value;
    if ($3c48a89ca795c151$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($106a9ee8332602e2$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $3c48a89ca795c151$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $3c48a89ca795c151$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $3c48a89ca795c151$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($3c48a89ca795c151$export$7e4aa119212bc614(numberA) && $3c48a89ca795c151$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $3c48a89ca795c151$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $3c48a89ca795c151$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


/* eslint no-console: 0 */ var $a8938748035e8b2c$var$isDev = false;
var $a8938748035e8b2c$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($a8938748035e8b2c$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $94f4f2296d1fa77c$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $94f4f2296d1fa77c$var$isNil(value) {
    return value == null;
}
$94f4f2296d1fa77c$exports = $94f4f2296d1fa77c$var$isNil;






var $9KJkx = parcelRequire("9KJkx");


function $62f30e004766c582$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $9KJkx = parcelRequire("9KJkx");

function $6d098ec72682e3e0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6d098ec72682e3e0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6d098ec72682e3e0$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $6d098ec72682e3e0$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $6d098ec72682e3e0$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $6d098ec72682e3e0$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $6d098ec72682e3e0$export$2b22758266a6fa48 = {
    svg: $6d098ec72682e3e0$var$SVGContainerPropKeys,
    polygon: $6d098ec72682e3e0$var$PolyElementKeys,
    polyline: $6d098ec72682e3e0$var$PolyElementKeys
};
var $6d098ec72682e3e0$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $6d098ec72682e3e0$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($6d098ec72682e3e0$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $6d098ec72682e3e0$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $6d098ec72682e3e0$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(props) || $6d098ec72682e3e0$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($6d098ec72682e3e0$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $6d098ec72682e3e0$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $19f907b79fb0a735$var$_excluded = [
    "children"
], $19f907b79fb0a735$var$_excluded2 = [
    "children"
];
function $19f907b79fb0a735$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $19f907b79fb0a735$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $19f907b79fb0a735$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $19f907b79fb0a735$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $19f907b79fb0a735$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $19f907b79fb0a735$var$_typeof(o);
}
var $19f907b79fb0a735$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $19f907b79fb0a735$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $19f907b79fb0a735$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $19f907b79fb0a735$export$59a4d7d024cf1025 = [
    "none"
];
var $19f907b79fb0a735$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $19f907b79fb0a735$var$lastChildren = null;
var $19f907b79fb0a735$var$lastResult = null;
var $19f907b79fb0a735$export$45b10814cc054894 = function toArray(children) {
    if (children === $19f907b79fb0a735$var$lastChildren && Array.isArray($19f907b79fb0a735$var$lastResult)) return $19f907b79fb0a735$var$lastResult;
    var result = [];
    (0, $9KJkx.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(child)) return;
        if ((0, $c24026ac5bd36ce0$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $19f907b79fb0a735$var$lastResult = result;
    $19f907b79fb0a735$var$lastChildren = children;
    return result;
};
function $19f907b79fb0a735$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $19f907b79fb0a735$export$be63e0664592e141(t);
    });
    else types = [
        $19f907b79fb0a735$export$be63e0664592e141(type)
    ];
    $19f907b79fb0a735$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $19f907b79fb0a735$export$64c61536a2b72e0f(children, type) {
    var result = $19f907b79fb0a735$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $19f907b79fb0a735$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $19f907b79fb0a735$export$be63e0664592e141(t);
    });
    else types = [
        $19f907b79fb0a735$export$be63e0664592e141(type)
    ];
    $19f907b79fb0a735$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $19f907b79fb0a735$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $19f907b79fb0a735$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $19f907b79fb0a735$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($77d9a27889f83835$exports)))(child.type) && $19f907b79fb0a735$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $19f907b79fb0a735$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $19f907b79fb0a735$var$_typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var $19f907b79fb0a735$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $6d098ec72682e3e0$export$2b22758266a6fa48) === null || (0, $6d098ec72682e3e0$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $6d098ec72682e3e0$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $6d098ec72682e3e0$export$190f430946f96110).includes(key)) || includeEvents && (0, $6d098ec72682e3e0$export$f30789245f2c4d11).includes(key);
};
var $19f907b79fb0a735$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $19f907b79fb0a735$export$45b10814cc054894(children).forEach(function(entry) {
        if ($19f907b79fb0a735$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $19f907b79fb0a735$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($19f907b79fb0a735$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $19f907b79fb0a735$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $9KJkx.Children).count(nextChildren);
    if (count !== (0, $9KJkx.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $19f907b79fb0a735$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$19f907b79fb0a735$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $19f907b79fb0a735$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $19f907b79fb0a735$var$_objectWithoutProperties(_ref, $19f907b79fb0a735$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $19f907b79fb0a735$var$_objectWithoutProperties(_ref2, $19f907b79fb0a735$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $62f30e004766c582$export$d36bdfa510afb180)(nextProps, prevProps) && $19f907b79fb0a735$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $62f30e004766c582$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $19f907b79fb0a735$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $19f907b79fb0a735$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($19f907b79fb0a735$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $19f907b79fb0a735$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $19f907b79fb0a735$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $19f907b79fb0a735$var$REACT_BROWSER_EVENT_MAP[type]) return $19f907b79fb0a735$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $19f907b79fb0a735$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $19f907b79fb0a735$export$45b10814cc054894(children).indexOf(child);
};


function $2c30ba11dd70f90f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2c30ba11dd70f90f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2c30ba11dd70f90f$var$_typeof(o);
}
function $2c30ba11dd70f90f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2c30ba11dd70f90f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2c30ba11dd70f90f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2c30ba11dd70f90f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2c30ba11dd70f90f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2c30ba11dd70f90f$var$_defineProperty(obj, key, value) {
    key = $2c30ba11dd70f90f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c30ba11dd70f90f$var$_toPropertyKey(arg) {
    var key = $2c30ba11dd70f90f$var$_toPrimitive(arg, "string");
    return $2c30ba11dd70f90f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2c30ba11dd70f90f$var$_toPrimitive(input, hint) {
    if ($2c30ba11dd70f90f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2c30ba11dd70f90f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2c30ba11dd70f90f$var$_slicedToArray(arr, i) {
    return $2c30ba11dd70f90f$var$_arrayWithHoles(arr) || $2c30ba11dd70f90f$var$_iterableToArrayLimit(arr, i) || $2c30ba11dd70f90f$var$_unsupportedIterableToArray(arr, i) || $2c30ba11dd70f90f$var$_nonIterableRest();
}
function $2c30ba11dd70f90f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2c30ba11dd70f90f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2c30ba11dd70f90f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2c30ba11dd70f90f$var$_arrayLikeToArray(o, minLen);
}
function $2c30ba11dd70f90f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2c30ba11dd70f90f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2c30ba11dd70f90f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $2c30ba11dd70f90f$export$e60a4704009a0009 = /*#__PURE__*/ (0, $9KJkx.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $9KJkx.useRef)(null);
    var onResizeRef = (0, $9KJkx.useRef)();
    onResizeRef.current = onResize;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0, $9KJkx.useImperativeHandle)(ref, function() {
        return containerRef;
    });
    var _useState = (0, $9KJkx.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $2c30ba11dd70f90f$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $9KJkx.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $9KJkx.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($210f438d283ca1c5$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $9KJkx.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)((0, $3c48a89ca795c151$export$e50269385c77c348)(width) || (0, $3c48a89ca795c151$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $3c48a89ca795c151$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $3c48a89ca795c151$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $c24026ac5bd36ce0$exports.isElement)(children) && (0, $19f907b79fb0a735$export$be63e0664592e141)(children.type).endsWith("Chart");
        return (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).Children.map(children, function(child) {
            if ((0, $c24026ac5bd36ce0$exports.isElement)(child)) return /*#__PURE__*/ (0, $9KJkx.cloneElement)(child, $2c30ba11dd70f90f$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $2c30ba11dd70f90f$var$_objectSpread({
                    height: "100%",
                    width: "100%",
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-responsive-container", className),
        style: $2c30ba11dd70f90f$var$_objectSpread($2c30ba11dd70f90f$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});

/**
 * @fileOverview Line Chart
 */ 
var $9KJkx = parcelRequire("9KJkx");


var $23f0498cce9e4f06$exports = {};
var $bba8ea8942e3fc34$exports = {};
var $32b1aeac0a76fd42$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $32b1aeac0a76fd42$var$nativeCeil = Math.ceil, $32b1aeac0a76fd42$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $32b1aeac0a76fd42$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $32b1aeac0a76fd42$var$nativeMax($32b1aeac0a76fd42$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$32b1aeac0a76fd42$exports = $32b1aeac0a76fd42$var$baseRange;


var $8c8e22eb97a4a2ac$exports = {};

var $024a4ddc25146379$exports = {};

var $f23ad2ada6617e4c$exports = {};
/** Used as references for various `Number` constants. */ var $f23ad2ada6617e4c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $f23ad2ada6617e4c$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $f23ad2ada6617e4c$var$MAX_SAFE_INTEGER;
}
$f23ad2ada6617e4c$exports = $f23ad2ada6617e4c$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $024a4ddc25146379$var$isArrayLike(value) {
    return value != null && $f23ad2ada6617e4c$exports(value.length) && !$3dca80e523384196$exports(value);
}
$024a4ddc25146379$exports = $024a4ddc25146379$var$isArrayLike;


var $33986151a94ad725$exports = {};
/** Used as references for various `Number` constants. */ var $33986151a94ad725$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $33986151a94ad725$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $33986151a94ad725$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $33986151a94ad725$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $33986151a94ad725$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$33986151a94ad725$exports = $33986151a94ad725$var$isIndex;



/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $8c8e22eb97a4a2ac$var$isIterateeCall(value, index, object) {
    if (!$dba4143ccd45ffc1$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $024a4ddc25146379$exports(object) && $33986151a94ad725$exports(index, object.length) : type == "string" && index in object) return $6a43b4a5a31825f6$exports(object[index], value);
    return false;
}
$8c8e22eb97a4a2ac$exports = $8c8e22eb97a4a2ac$var$isIterateeCall;


var $26ad675659fd5b85$exports = {};

/** Used as references for various `Number` constants. */ var $26ad675659fd5b85$var$INFINITY = 1 / 0, $26ad675659fd5b85$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $26ad675659fd5b85$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $8ad1792df8b974ad$exports(value);
    if (value === $26ad675659fd5b85$var$INFINITY || value === -$26ad675659fd5b85$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $26ad675659fd5b85$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$26ad675659fd5b85$exports = $26ad675659fd5b85$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $bba8ea8942e3fc34$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $8c8e22eb97a4a2ac$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $26ad675659fd5b85$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $26ad675659fd5b85$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $26ad675659fd5b85$exports(step);
        return $32b1aeac0a76fd42$exports(start, end, step, fromRight);
    };
}
$bba8ea8942e3fc34$exports = $bba8ea8942e3fc34$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $23f0498cce9e4f06$var$range = $bba8ea8942e3fc34$exports();
$23f0498cce9e4f06$exports = $23f0498cce9e4f06$var$range;



var $0f90809c435feb4c$exports = {};
var $4f85d08177189c11$exports = {};
var $3e8e1f95180d86eb$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3e8e1f95180d86eb$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3e8e1f95180d86eb$exports = $3e8e1f95180d86eb$var$arrayPush;


var $8f25e0d242ec4b97$exports = {};

var $a08b556b280201a6$exports = {};
var $962a2184db1f11b0$exports = {};


/** `Object#toString` result references. */ var $962a2184db1f11b0$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $962a2184db1f11b0$var$baseIsArguments(value) {
    return $2ea446141c31cf3d$exports(value) && $e5640db8046fdbb6$exports(value) == $962a2184db1f11b0$var$argsTag;
}
$962a2184db1f11b0$exports = $962a2184db1f11b0$var$baseIsArguments;



/** Used for built-in method references. */ var $a08b556b280201a6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a08b556b280201a6$var$hasOwnProperty = $a08b556b280201a6$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $a08b556b280201a6$var$propertyIsEnumerable = $a08b556b280201a6$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $a08b556b280201a6$var$isArguments = $962a2184db1f11b0$exports(function() {
    return arguments;
}()) ? $962a2184db1f11b0$exports : function(value) {
    return $2ea446141c31cf3d$exports(value) && $a08b556b280201a6$var$hasOwnProperty.call(value, "callee") && !$a08b556b280201a6$var$propertyIsEnumerable.call(value, "callee");
};
$a08b556b280201a6$exports = $a08b556b280201a6$var$isArguments;



/** Built-in value references. */ var $8f25e0d242ec4b97$var$spreadableSymbol = $c7b8eaee86d7adbd$exports ? $c7b8eaee86d7adbd$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8f25e0d242ec4b97$var$isFlattenable(value) {
    return $fcffceb67c06866f$exports(value) || $a08b556b280201a6$exports(value) || !!($8f25e0d242ec4b97$var$spreadableSymbol && value && value[$8f25e0d242ec4b97$var$spreadableSymbol]);
}
$8f25e0d242ec4b97$exports = $8f25e0d242ec4b97$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $4f85d08177189c11$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $8f25e0d242ec4b97$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $4f85d08177189c11$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $3e8e1f95180d86eb$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$4f85d08177189c11$exports = $4f85d08177189c11$var$baseFlatten;


var $f052ed0757b8b16a$exports = {};


var $e7eef0e89d3554e6$exports = {};
var $208a0f7df17060e2$exports = {};
var $029fc0af05ec856c$exports = {};
var $6545a6593b895f8a$exports = {};

var $665c932b762283b7$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $665c932b762283b7$var$stackClear() {
    this.__data__ = new $3b1a4a85555466b9$exports;
    this.size = 0;
}
$665c932b762283b7$exports = $665c932b762283b7$var$stackClear;


var $806628b9e907f247$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $806628b9e907f247$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$806628b9e907f247$exports = $806628b9e907f247$var$stackDelete;


var $5d7a0161c47c176b$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5d7a0161c47c176b$var$stackGet(key) {
    return this.__data__.get(key);
}
$5d7a0161c47c176b$exports = $5d7a0161c47c176b$var$stackGet;


var $e25b5e5350ed36ed$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e25b5e5350ed36ed$var$stackHas(key) {
    return this.__data__.has(key);
}
$e25b5e5350ed36ed$exports = $e25b5e5350ed36ed$var$stackHas;


var $c3eb38710c908a00$exports = {};



/** Used as the size to enable large array optimizations. */ var $c3eb38710c908a00$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $c3eb38710c908a00$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $3b1a4a85555466b9$exports) {
        var pairs = data.__data__;
        if (!$144d4f6027fbd351$exports || pairs.length < $c3eb38710c908a00$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $5f580ee10f3abb81$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$c3eb38710c908a00$exports = $c3eb38710c908a00$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6545a6593b895f8a$var$Stack(entries) {
    var data = this.__data__ = new $3b1a4a85555466b9$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$6545a6593b895f8a$var$Stack.prototype.clear = $665c932b762283b7$exports;
$6545a6593b895f8a$var$Stack.prototype["delete"] = $806628b9e907f247$exports;
$6545a6593b895f8a$var$Stack.prototype.get = $5d7a0161c47c176b$exports;
$6545a6593b895f8a$var$Stack.prototype.has = $e25b5e5350ed36ed$exports;
$6545a6593b895f8a$var$Stack.prototype.set = $c3eb38710c908a00$exports;
$6545a6593b895f8a$exports = $6545a6593b895f8a$var$Stack;


var $95f603d1d18ed3fb$exports = {};
var $aa2293488e224305$exports = {};

var $61639ae1f4fd9e80$exports = {};
var $5c8d9875c4518b2e$exports = {};

var $05cc9b51dea74c37$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $05cc9b51dea74c37$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $05cc9b51dea74c37$var$setCacheAdd(value) {
    this.__data__.set(value, $05cc9b51dea74c37$var$HASH_UNDEFINED);
    return this;
}
$05cc9b51dea74c37$exports = $05cc9b51dea74c37$var$setCacheAdd;


var $a6032f477276376a$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $a6032f477276376a$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$a6032f477276376a$exports = $a6032f477276376a$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $5c8d9875c4518b2e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $5f580ee10f3abb81$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$5c8d9875c4518b2e$var$SetCache.prototype.add = $5c8d9875c4518b2e$var$SetCache.prototype.push = $05cc9b51dea74c37$exports;
$5c8d9875c4518b2e$var$SetCache.prototype.has = $a6032f477276376a$exports;
$5c8d9875c4518b2e$exports = $5c8d9875c4518b2e$var$SetCache;


var $ac815e27a108b746$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $ac815e27a108b746$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$ac815e27a108b746$exports = $ac815e27a108b746$var$arraySome;


var $61947952d773f171$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $61947952d773f171$var$cacheHas(cache, key) {
    return cache.has(key);
}
$61947952d773f171$exports = $61947952d773f171$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $61639ae1f4fd9e80$var$COMPARE_PARTIAL_FLAG = 1, $61639ae1f4fd9e80$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $61639ae1f4fd9e80$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $61639ae1f4fd9e80$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $61639ae1f4fd9e80$var$COMPARE_UNORDERED_FLAG ? new $5c8d9875c4518b2e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$ac815e27a108b746$exports(other, function(othValue, othIndex) {
                if (!$61947952d773f171$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$61639ae1f4fd9e80$exports = $61639ae1f4fd9e80$var$equalArrays;


var $36486f07fb463033$exports = {};

var $a99e4a7f475c5e6a$exports = {};

var $jgVft = parcelRequire("jgVft");
/** Built-in value references. */ var $a99e4a7f475c5e6a$var$Uint8Array = $jgVft.Uint8Array;
$a99e4a7f475c5e6a$exports = $a99e4a7f475c5e6a$var$Uint8Array;




var $16bb13f885ccb26e$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $16bb13f885ccb26e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$16bb13f885ccb26e$exports = $16bb13f885ccb26e$var$mapToArray;


var $23fd3a833208544f$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $23fd3a833208544f$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$23fd3a833208544f$exports = $23fd3a833208544f$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $36486f07fb463033$var$COMPARE_PARTIAL_FLAG = 1, $36486f07fb463033$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $36486f07fb463033$var$boolTag = "[object Boolean]", $36486f07fb463033$var$dateTag = "[object Date]", $36486f07fb463033$var$errorTag = "[object Error]", $36486f07fb463033$var$mapTag = "[object Map]", $36486f07fb463033$var$numberTag = "[object Number]", $36486f07fb463033$var$regexpTag = "[object RegExp]", $36486f07fb463033$var$setTag = "[object Set]", $36486f07fb463033$var$stringTag = "[object String]", $36486f07fb463033$var$symbolTag = "[object Symbol]";
var $36486f07fb463033$var$arrayBufferTag = "[object ArrayBuffer]", $36486f07fb463033$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $36486f07fb463033$var$symbolProto = $c7b8eaee86d7adbd$exports ? $c7b8eaee86d7adbd$exports.prototype : undefined, $36486f07fb463033$var$symbolValueOf = $36486f07fb463033$var$symbolProto ? $36486f07fb463033$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $36486f07fb463033$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $36486f07fb463033$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $36486f07fb463033$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $a99e4a7f475c5e6a$exports(object), new $a99e4a7f475c5e6a$exports(other))) return false;
            return true;
        case $36486f07fb463033$var$boolTag:
        case $36486f07fb463033$var$dateTag:
        case $36486f07fb463033$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6a43b4a5a31825f6$exports(+object, +other);
        case $36486f07fb463033$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $36486f07fb463033$var$regexpTag:
        case $36486f07fb463033$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $36486f07fb463033$var$mapTag:
            var convert = $16bb13f885ccb26e$exports;
        case $36486f07fb463033$var$setTag:
            var isPartial = bitmask & $36486f07fb463033$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $23fd3a833208544f$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $36486f07fb463033$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $61639ae1f4fd9e80$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $36486f07fb463033$var$symbolTag:
            if ($36486f07fb463033$var$symbolValueOf) return $36486f07fb463033$var$symbolValueOf.call(object) == $36486f07fb463033$var$symbolValueOf.call(other);
    }
    return false;
}
$36486f07fb463033$exports = $36486f07fb463033$var$equalByTag;


var $f701c4a2a8a67db6$exports = {};
var $668a50d1a004fa29$exports = {};
var $7559656cded0f43b$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7559656cded0f43b$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $fcffceb67c06866f$exports(object) ? result : $3e8e1f95180d86eb$exports(result, symbolsFunc(object));
}
$7559656cded0f43b$exports = $7559656cded0f43b$var$baseGetAllKeys;


var $67fffe27d65048c2$exports = {};
var $ee94e6dd3ce97809$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $ee94e6dd3ce97809$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$ee94e6dd3ce97809$exports = $ee94e6dd3ce97809$var$arrayFilter;


var $c94e05369bdd75e4$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c94e05369bdd75e4$var$stubArray() {
    return [];
}
$c94e05369bdd75e4$exports = $c94e05369bdd75e4$var$stubArray;


/** Used for built-in method references. */ var $67fffe27d65048c2$var$objectProto = Object.prototype;
/** Built-in value references. */ var $67fffe27d65048c2$var$propertyIsEnumerable = $67fffe27d65048c2$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $67fffe27d65048c2$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $67fffe27d65048c2$var$getSymbols = !$67fffe27d65048c2$var$nativeGetSymbols ? $c94e05369bdd75e4$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $ee94e6dd3ce97809$exports($67fffe27d65048c2$var$nativeGetSymbols(object), function(symbol) {
        return $67fffe27d65048c2$var$propertyIsEnumerable.call(object, symbol);
    });
};
$67fffe27d65048c2$exports = $67fffe27d65048c2$var$getSymbols;


var $3c6f89c9606b3915$exports = {};
var $4424f42e5c0694ac$exports = {};
var $25f69d79ea76656c$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25f69d79ea76656c$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$25f69d79ea76656c$exports = $25f69d79ea76656c$var$baseTimes;





var $3nAsT = parcelRequire("3nAsT");

var $10256317013a6058$exports = {};
var $c07eef7bcc4876ad$exports = {};



/** `Object#toString` result references. */ var $c07eef7bcc4876ad$var$argsTag = "[object Arguments]", $c07eef7bcc4876ad$var$arrayTag = "[object Array]", $c07eef7bcc4876ad$var$boolTag = "[object Boolean]", $c07eef7bcc4876ad$var$dateTag = "[object Date]", $c07eef7bcc4876ad$var$errorTag = "[object Error]", $c07eef7bcc4876ad$var$funcTag = "[object Function]", $c07eef7bcc4876ad$var$mapTag = "[object Map]", $c07eef7bcc4876ad$var$numberTag = "[object Number]", $c07eef7bcc4876ad$var$objectTag = "[object Object]", $c07eef7bcc4876ad$var$regexpTag = "[object RegExp]", $c07eef7bcc4876ad$var$setTag = "[object Set]", $c07eef7bcc4876ad$var$stringTag = "[object String]", $c07eef7bcc4876ad$var$weakMapTag = "[object WeakMap]";
var $c07eef7bcc4876ad$var$arrayBufferTag = "[object ArrayBuffer]", $c07eef7bcc4876ad$var$dataViewTag = "[object DataView]", $c07eef7bcc4876ad$var$float32Tag = "[object Float32Array]", $c07eef7bcc4876ad$var$float64Tag = "[object Float64Array]", $c07eef7bcc4876ad$var$int8Tag = "[object Int8Array]", $c07eef7bcc4876ad$var$int16Tag = "[object Int16Array]", $c07eef7bcc4876ad$var$int32Tag = "[object Int32Array]", $c07eef7bcc4876ad$var$uint8Tag = "[object Uint8Array]", $c07eef7bcc4876ad$var$uint8ClampedTag = "[object Uint8ClampedArray]", $c07eef7bcc4876ad$var$uint16Tag = "[object Uint16Array]", $c07eef7bcc4876ad$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $c07eef7bcc4876ad$var$typedArrayTags = {};
$c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$float32Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$float64Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$int8Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$int16Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$int32Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$uint8Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$uint8ClampedTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$uint16Tag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$uint32Tag] = true;
$c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$argsTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$arrayTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$arrayBufferTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$boolTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$dataViewTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$dateTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$errorTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$funcTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$mapTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$numberTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$objectTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$regexpTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$setTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$stringTag] = $c07eef7bcc4876ad$var$typedArrayTags[$c07eef7bcc4876ad$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c07eef7bcc4876ad$var$baseIsTypedArray(value) {
    return $2ea446141c31cf3d$exports(value) && $f23ad2ada6617e4c$exports(value.length) && !!$c07eef7bcc4876ad$var$typedArrayTags[$e5640db8046fdbb6$exports(value)];
}
$c07eef7bcc4876ad$exports = $c07eef7bcc4876ad$var$baseIsTypedArray;


var $ac0dbf6ea7925a2c$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ac0dbf6ea7925a2c$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$ac0dbf6ea7925a2c$exports = $ac0dbf6ea7925a2c$var$baseUnary;



var $cydsp = parcelRequire("cydsp");
/* Node.js helper references. */ var $10256317013a6058$var$nodeIsTypedArray = $cydsp && $cydsp.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $10256317013a6058$var$isTypedArray = $10256317013a6058$var$nodeIsTypedArray ? $ac0dbf6ea7925a2c$exports($10256317013a6058$var$nodeIsTypedArray) : $c07eef7bcc4876ad$exports;
$10256317013a6058$exports = $10256317013a6058$var$isTypedArray;


/** Used for built-in method references. */ var $4424f42e5c0694ac$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4424f42e5c0694ac$var$hasOwnProperty = $4424f42e5c0694ac$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $4424f42e5c0694ac$var$arrayLikeKeys(value, inherited) {
    var isArr = $fcffceb67c06866f$exports(value), isArg = !isArr && $a08b556b280201a6$exports(value), isBuff = !isArr && !isArg && $3nAsT(value), isType = !isArr && !isArg && !isBuff && $10256317013a6058$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $25f69d79ea76656c$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $4424f42e5c0694ac$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $33986151a94ad725$exports(key, length)))) result.push(key);
    return result;
}
$4424f42e5c0694ac$exports = $4424f42e5c0694ac$var$arrayLikeKeys;


var $83665465398055c7$exports = {};
var $e451b074e9b7405b$exports = {};
/** Used for built-in method references. */ var $e451b074e9b7405b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e451b074e9b7405b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $e451b074e9b7405b$var$objectProto;
    return value === proto;
}
$e451b074e9b7405b$exports = $e451b074e9b7405b$var$isPrototype;


var $ec299fb23e6d0db8$exports = {};
var $08cb3ad02025adaa$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $08cb3ad02025adaa$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$08cb3ad02025adaa$exports = $08cb3ad02025adaa$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $ec299fb23e6d0db8$var$nativeKeys = $08cb3ad02025adaa$exports(Object.keys, Object);
$ec299fb23e6d0db8$exports = $ec299fb23e6d0db8$var$nativeKeys;


/** Used for built-in method references. */ var $83665465398055c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83665465398055c7$var$hasOwnProperty = $83665465398055c7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $83665465398055c7$var$baseKeys(object) {
    if (!$e451b074e9b7405b$exports(object)) return $ec299fb23e6d0db8$exports(object);
    var result = [];
    for(var key in Object(object))if ($83665465398055c7$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$83665465398055c7$exports = $83665465398055c7$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $3c6f89c9606b3915$var$keys(object) {
    return $024a4ddc25146379$exports(object) ? $4424f42e5c0694ac$exports(object) : $83665465398055c7$exports(object);
}
$3c6f89c9606b3915$exports = $3c6f89c9606b3915$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $668a50d1a004fa29$var$getAllKeys(object) {
    return $7559656cded0f43b$exports(object, $3c6f89c9606b3915$exports, $67fffe27d65048c2$exports);
}
$668a50d1a004fa29$exports = $668a50d1a004fa29$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f701c4a2a8a67db6$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f701c4a2a8a67db6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f701c4a2a8a67db6$var$hasOwnProperty = $f701c4a2a8a67db6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f701c4a2a8a67db6$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f701c4a2a8a67db6$var$COMPARE_PARTIAL_FLAG, objProps = $668a50d1a004fa29$exports(object), objLength = objProps.length, othProps = $668a50d1a004fa29$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f701c4a2a8a67db6$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$f701c4a2a8a67db6$exports = $f701c4a2a8a67db6$var$equalObjects;


var $5409945b96a65c43$exports = {};
var $e2045ed8d96f2465$exports = {};


var $jgVft = parcelRequire("jgVft");
/* Built-in method references that are verified to be native. */ var $e2045ed8d96f2465$var$DataView = $44f0d6b1e7551713$exports($jgVft, "DataView");
$e2045ed8d96f2465$exports = $e2045ed8d96f2465$var$DataView;



var $fcb22021fc9b04bd$exports = {};


var $jgVft = parcelRequire("jgVft");
/* Built-in method references that are verified to be native. */ var $fcb22021fc9b04bd$var$Promise = $44f0d6b1e7551713$exports($jgVft, "Promise");
$fcb22021fc9b04bd$exports = $fcb22021fc9b04bd$var$Promise;


var $6d389a7e18625706$exports = {};


var $jgVft = parcelRequire("jgVft");
/* Built-in method references that are verified to be native. */ var $6d389a7e18625706$var$Set = $44f0d6b1e7551713$exports($jgVft, "Set");
$6d389a7e18625706$exports = $6d389a7e18625706$var$Set;


var $9cb263b42a18e1ed$exports = {};


var $jgVft = parcelRequire("jgVft");
/* Built-in method references that are verified to be native. */ var $9cb263b42a18e1ed$var$WeakMap = $44f0d6b1e7551713$exports($jgVft, "WeakMap");
$9cb263b42a18e1ed$exports = $9cb263b42a18e1ed$var$WeakMap;




/** `Object#toString` result references. */ var $5409945b96a65c43$var$mapTag = "[object Map]", $5409945b96a65c43$var$objectTag = "[object Object]", $5409945b96a65c43$var$promiseTag = "[object Promise]", $5409945b96a65c43$var$setTag = "[object Set]", $5409945b96a65c43$var$weakMapTag = "[object WeakMap]";
var $5409945b96a65c43$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5409945b96a65c43$var$dataViewCtorString = $a35771c56f74bbb1$exports($e2045ed8d96f2465$exports), $5409945b96a65c43$var$mapCtorString = $a35771c56f74bbb1$exports($144d4f6027fbd351$exports), $5409945b96a65c43$var$promiseCtorString = $a35771c56f74bbb1$exports($fcb22021fc9b04bd$exports), $5409945b96a65c43$var$setCtorString = $a35771c56f74bbb1$exports($6d389a7e18625706$exports), $5409945b96a65c43$var$weakMapCtorString = $a35771c56f74bbb1$exports($9cb263b42a18e1ed$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5409945b96a65c43$var$getTag = $e5640db8046fdbb6$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($e2045ed8d96f2465$exports && $5409945b96a65c43$var$getTag(new $e2045ed8d96f2465$exports(new ArrayBuffer(1))) != $5409945b96a65c43$var$dataViewTag || $144d4f6027fbd351$exports && $5409945b96a65c43$var$getTag(new $144d4f6027fbd351$exports) != $5409945b96a65c43$var$mapTag || $fcb22021fc9b04bd$exports && $5409945b96a65c43$var$getTag($fcb22021fc9b04bd$exports.resolve()) != $5409945b96a65c43$var$promiseTag || $6d389a7e18625706$exports && $5409945b96a65c43$var$getTag(new $6d389a7e18625706$exports) != $5409945b96a65c43$var$setTag || $9cb263b42a18e1ed$exports && $5409945b96a65c43$var$getTag(new $9cb263b42a18e1ed$exports) != $5409945b96a65c43$var$weakMapTag) $5409945b96a65c43$var$getTag = function(value) {
    var result = $e5640db8046fdbb6$exports(value), Ctor = result == $5409945b96a65c43$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $a35771c56f74bbb1$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5409945b96a65c43$var$dataViewCtorString:
            return $5409945b96a65c43$var$dataViewTag;
        case $5409945b96a65c43$var$mapCtorString:
            return $5409945b96a65c43$var$mapTag;
        case $5409945b96a65c43$var$promiseCtorString:
            return $5409945b96a65c43$var$promiseTag;
        case $5409945b96a65c43$var$setCtorString:
            return $5409945b96a65c43$var$setTag;
        case $5409945b96a65c43$var$weakMapCtorString:
            return $5409945b96a65c43$var$weakMapTag;
    }
    return result;
};
$5409945b96a65c43$exports = $5409945b96a65c43$var$getTag;




var $3nAsT = parcelRequire("3nAsT");

/** Used to compose bitmasks for value comparisons. */ var $aa2293488e224305$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $aa2293488e224305$var$argsTag = "[object Arguments]", $aa2293488e224305$var$arrayTag = "[object Array]", $aa2293488e224305$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $aa2293488e224305$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aa2293488e224305$var$hasOwnProperty = $aa2293488e224305$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $aa2293488e224305$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $fcffceb67c06866f$exports(object), othIsArr = $fcffceb67c06866f$exports(other), objTag = objIsArr ? $aa2293488e224305$var$arrayTag : $5409945b96a65c43$exports(object), othTag = othIsArr ? $aa2293488e224305$var$arrayTag : $5409945b96a65c43$exports(other);
    objTag = objTag == $aa2293488e224305$var$argsTag ? $aa2293488e224305$var$objectTag : objTag;
    othTag = othTag == $aa2293488e224305$var$argsTag ? $aa2293488e224305$var$objectTag : othTag;
    var objIsObj = objTag == $aa2293488e224305$var$objectTag, othIsObj = othTag == $aa2293488e224305$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $3nAsT(object)) {
        if (!$3nAsT(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $6545a6593b895f8a$exports);
        return objIsArr || $10256317013a6058$exports(object) ? $61639ae1f4fd9e80$exports(object, other, bitmask, customizer, equalFunc, stack) : $36486f07fb463033$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $aa2293488e224305$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $aa2293488e224305$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $aa2293488e224305$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $6545a6593b895f8a$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $6545a6593b895f8a$exports);
    return $f701c4a2a8a67db6$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$aa2293488e224305$exports = $aa2293488e224305$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $95f603d1d18ed3fb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$2ea446141c31cf3d$exports(value) && !$2ea446141c31cf3d$exports(other)) return value !== value && other !== other;
    return $aa2293488e224305$exports(value, other, bitmask, customizer, $95f603d1d18ed3fb$var$baseIsEqual, stack);
}
$95f603d1d18ed3fb$exports = $95f603d1d18ed3fb$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $029fc0af05ec856c$var$COMPARE_PARTIAL_FLAG = 1, $029fc0af05ec856c$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $029fc0af05ec856c$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $6545a6593b895f8a$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $95f603d1d18ed3fb$exports(srcValue, objValue, $029fc0af05ec856c$var$COMPARE_PARTIAL_FLAG | $029fc0af05ec856c$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$029fc0af05ec856c$exports = $029fc0af05ec856c$var$baseIsMatch;


var $7b79377a702efe57$exports = {};
var $9e2a7b408d6185d1$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9e2a7b408d6185d1$var$isStrictComparable(value) {
    return value === value && !$dba4143ccd45ffc1$exports(value);
}
$9e2a7b408d6185d1$exports = $9e2a7b408d6185d1$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $7b79377a702efe57$var$getMatchData(object) {
    var result = $3c6f89c9606b3915$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9e2a7b408d6185d1$exports(value)
        ];
    }
    return result;
}
$7b79377a702efe57$exports = $7b79377a702efe57$var$getMatchData;


var $aadd5cd1c0e563a1$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $aadd5cd1c0e563a1$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$aadd5cd1c0e563a1$exports = $aadd5cd1c0e563a1$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $208a0f7df17060e2$var$baseMatches(source) {
    var matchData = $7b79377a702efe57$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $aadd5cd1c0e563a1$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $029fc0af05ec856c$exports(object, source, matchData);
    };
}
$208a0f7df17060e2$exports = $208a0f7df17060e2$var$baseMatches;


var $df6c25462d882404$exports = {};


var $b49fe70d727899e1$exports = {};
var $268e64ea8de46352$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $268e64ea8de46352$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$268e64ea8de46352$exports = $268e64ea8de46352$var$baseHasIn;


var $9d887375c0a0a970$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $9d887375c0a0a970$var$hasPath(object, path, hasFunc) {
    path = $2c26c95ed0049a1f$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $45828227bb9c497e$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $f23ad2ada6617e4c$exports(length) && $33986151a94ad725$exports(key, length) && ($fcffceb67c06866f$exports(object) || $a08b556b280201a6$exports(object));
}
$9d887375c0a0a970$exports = $9d887375c0a0a970$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $b49fe70d727899e1$var$hasIn(object, path) {
    return object != null && $9d887375c0a0a970$exports(object, path, $268e64ea8de46352$exports);
}
$b49fe70d727899e1$exports = $b49fe70d727899e1$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $df6c25462d882404$var$COMPARE_PARTIAL_FLAG = 1, $df6c25462d882404$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $df6c25462d882404$var$baseMatchesProperty(path, srcValue) {
    if ($828929acb6543810$exports(path) && $9e2a7b408d6185d1$exports(srcValue)) return $aadd5cd1c0e563a1$exports($45828227bb9c497e$exports(path), srcValue);
    return function(object) {
        var objValue = $72b701a528e94106$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $b49fe70d727899e1$exports(object, path) : $95f603d1d18ed3fb$exports(srcValue, objValue, $df6c25462d882404$var$COMPARE_PARTIAL_FLAG | $df6c25462d882404$var$COMPARE_UNORDERED_FLAG);
    };
}
$df6c25462d882404$exports = $df6c25462d882404$var$baseMatchesProperty;


var $402384d5d8a18b54$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $402384d5d8a18b54$var$identity(value) {
    return value;
}
$402384d5d8a18b54$exports = $402384d5d8a18b54$var$identity;



var $ee9ec28fb1d87ae3$exports = {};
var $3a7b3951e521d3c7$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $3a7b3951e521d3c7$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$3a7b3951e521d3c7$exports = $3a7b3951e521d3c7$var$baseProperty;


var $d86ab363eecd4089$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d86ab363eecd4089$var$basePropertyDeep(path) {
    return function(object) {
        return $5f55a9144e42af22$exports(object, path);
    };
}
$d86ab363eecd4089$exports = $d86ab363eecd4089$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ee9ec28fb1d87ae3$var$property(path) {
    return $828929acb6543810$exports(path) ? $3a7b3951e521d3c7$exports($45828227bb9c497e$exports(path)) : $d86ab363eecd4089$exports(path);
}
$ee9ec28fb1d87ae3$exports = $ee9ec28fb1d87ae3$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $e7eef0e89d3554e6$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $402384d5d8a18b54$exports;
    if (typeof value == "object") return $fcffceb67c06866f$exports(value) ? $df6c25462d882404$exports(value[0], value[1]) : $208a0f7df17060e2$exports(value);
    return $ee9ec28fb1d87ae3$exports(value);
}
$e7eef0e89d3554e6$exports = $e7eef0e89d3554e6$var$baseIteratee;


var $ce9fb961f9c96274$exports = {};
var $d48549f2a9abd534$exports = {};
var $90099ca8d868fcaa$exports = {};
var $37939cb0fadd953e$exports = {};
var $7b3801b56412fdc2$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7b3801b56412fdc2$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$7b3801b56412fdc2$exports = $7b3801b56412fdc2$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $37939cb0fadd953e$var$baseFor = $7b3801b56412fdc2$exports();
$37939cb0fadd953e$exports = $37939cb0fadd953e$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $90099ca8d868fcaa$var$baseForOwn(object, iteratee) {
    return object && $37939cb0fadd953e$exports(object, iteratee, $3c6f89c9606b3915$exports);
}
$90099ca8d868fcaa$exports = $90099ca8d868fcaa$var$baseForOwn;


var $7bc0bafac5604b4e$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7bc0bafac5604b4e$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$024a4ddc25146379$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$7bc0bafac5604b4e$exports = $7bc0bafac5604b4e$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d48549f2a9abd534$var$baseEach = $7bc0bafac5604b4e$exports($90099ca8d868fcaa$exports);
$d48549f2a9abd534$exports = $d48549f2a9abd534$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $ce9fb961f9c96274$var$baseMap(collection, iteratee) {
    var index = -1, result = $024a4ddc25146379$exports(collection) ? Array(collection.length) : [];
    $d48549f2a9abd534$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$ce9fb961f9c96274$exports = $ce9fb961f9c96274$var$baseMap;


var $51dd0aad5466b4f9$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $51dd0aad5466b4f9$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$51dd0aad5466b4f9$exports = $51dd0aad5466b4f9$var$baseSortBy;



var $be9bf9b845c015a0$exports = {};
var $9723aa1c7fd10176$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $9723aa1c7fd10176$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $bc906635e498c759$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $bc906635e498c759$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$9723aa1c7fd10176$exports = $9723aa1c7fd10176$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $be9bf9b845c015a0$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $9723aa1c7fd10176$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$be9bf9b845c015a0$exports = $be9bf9b845c015a0$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f052ed0757b8b16a$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $99747295c2209139$exports(iteratees, function(iteratee) {
        if ($fcffceb67c06866f$exports(iteratee)) return function(value) {
            return $5f55a9144e42af22$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $402384d5d8a18b54$exports
    ];
    var index = -1;
    iteratees = $99747295c2209139$exports(iteratees, $ac0dbf6ea7925a2c$exports($e7eef0e89d3554e6$exports));
    var result = $ce9fb961f9c96274$exports(collection, function(value, key, collection) {
        var criteria = $99747295c2209139$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $51dd0aad5466b4f9$exports(result, function(object, other) {
        return $be9bf9b845c015a0$exports(object, other, orders);
    });
}
$f052ed0757b8b16a$exports = $f052ed0757b8b16a$var$baseOrderBy;


var $0d06cae154656d6e$exports = {};

var $489ce3d2b7eccdd8$exports = {};
var $4df8bc939e1a2158$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $4df8bc939e1a2158$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$4df8bc939e1a2158$exports = $4df8bc939e1a2158$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $489ce3d2b7eccdd8$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $489ce3d2b7eccdd8$var$overRest(func, start, transform) {
    start = $489ce3d2b7eccdd8$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $489ce3d2b7eccdd8$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $4df8bc939e1a2158$exports(func, this, otherArgs);
    };
}
$489ce3d2b7eccdd8$exports = $489ce3d2b7eccdd8$var$overRest;


var $32bfbdf8685b138e$exports = {};
var $7a2cf0654019dc61$exports = {};
var $104683e54ec4e8a6$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $104683e54ec4e8a6$var$constant(value) {
    return function() {
        return value;
    };
}
$104683e54ec4e8a6$exports = $104683e54ec4e8a6$var$constant;


var $2f7ac0479f3c7c55$exports = {};

var $2f7ac0479f3c7c55$var$defineProperty = function() {
    try {
        var func = $44f0d6b1e7551713$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$2f7ac0479f3c7c55$exports = $2f7ac0479f3c7c55$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $7a2cf0654019dc61$var$baseSetToString = !$2f7ac0479f3c7c55$exports ? $402384d5d8a18b54$exports : function(func, string) {
    return $2f7ac0479f3c7c55$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $104683e54ec4e8a6$exports(string),
        "writable": true
    });
};
$7a2cf0654019dc61$exports = $7a2cf0654019dc61$var$baseSetToString;


var $e1d6bb885010b3cb$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $e1d6bb885010b3cb$var$HOT_COUNT = 800, $e1d6bb885010b3cb$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e1d6bb885010b3cb$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $e1d6bb885010b3cb$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $e1d6bb885010b3cb$var$nativeNow(), remaining = $e1d6bb885010b3cb$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $e1d6bb885010b3cb$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$e1d6bb885010b3cb$exports = $e1d6bb885010b3cb$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $32bfbdf8685b138e$var$setToString = $e1d6bb885010b3cb$exports($7a2cf0654019dc61$exports);
$32bfbdf8685b138e$exports = $32bfbdf8685b138e$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $0d06cae154656d6e$var$baseRest(func, start) {
    return $32bfbdf8685b138e$exports($489ce3d2b7eccdd8$exports(func, start, $402384d5d8a18b54$exports), func + "");
}
$0d06cae154656d6e$exports = $0d06cae154656d6e$var$baseRest;



/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $0f90809c435feb4c$var$sortBy = $0d06cae154656d6e$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $8c8e22eb97a4a2ac$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $8c8e22eb97a4a2ac$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $f052ed0757b8b16a$exports(collection, $4f85d08177189c11$exports(iteratees, 1), []);
});
$0f90809c435feb4c$exports = $0f90809c435feb4c$var$sortBy;



var $cdd8e4305f677179$exports = {};
var $675c17bf2ddd8fa2$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $675c17bf2ddd8fa2$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$024a4ddc25146379$exports(collection)) {
            var iteratee = $e7eef0e89d3554e6$exports(predicate, 3);
            collection = $3c6f89c9606b3915$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$675c17bf2ddd8fa2$exports = $675c17bf2ddd8fa2$var$createFind;


var $130bdee7202a9a23$exports = {};
var $e1c89747a26014f1$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e1c89747a26014f1$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$e1c89747a26014f1$exports = $e1c89747a26014f1$var$baseFindIndex;



var $540f16e1a7350f5a$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $540f16e1a7350f5a$var$toInteger(value) {
    var result = $26ad675659fd5b85$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$540f16e1a7350f5a$exports = $540f16e1a7350f5a$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $130bdee7202a9a23$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $130bdee7202a9a23$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $540f16e1a7350f5a$exports(fromIndex);
    if (index < 0) index = $130bdee7202a9a23$var$nativeMax(length + index, 0);
    return $e1c89747a26014f1$exports(array, $e7eef0e89d3554e6$exports(predicate, 3), index);
}
$130bdee7202a9a23$exports = $130bdee7202a9a23$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $cdd8e4305f677179$var$find = $675c17bf2ddd8fa2$exports($130bdee7202a9a23$exports);
$cdd8e4305f677179$exports = $cdd8e4305f677179$var$find;


var $d387f13f91c2d601$exports = {};
var $2e9822c08b88998e$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $2e9822c08b88998e$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$2e9822c08b88998e$exports = $2e9822c08b88998e$var$arrayEvery;


var $003272d08b7af73e$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $003272d08b7af73e$var$baseEvery(collection, predicate) {
    var result = true;
    $d48549f2a9abd534$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$003272d08b7af73e$exports = $003272d08b7af73e$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $d387f13f91c2d601$var$every(collection, predicate, guard) {
    var func = $fcffceb67c06866f$exports(collection) ? $2e9822c08b88998e$exports : $003272d08b7af73e$exports;
    if (guard && $8c8e22eb97a4a2ac$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $e7eef0e89d3554e6$exports(predicate, 3));
}
$d387f13f91c2d601$exports = $d387f13f91c2d601$var$every;



var $1be50d0e7793a737$var$isProduction = true;
var $1be50d0e7793a737$var$prefix = "Invariant failed";
function $1be50d0e7793a737$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($1be50d0e7793a737$var$isProduction) throw new Error($1be50d0e7793a737$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($1be50d0e7793a737$var$prefix, ": ").concat(provided) : $1be50d0e7793a737$var$prefix;
    throw new Error(value);
}




var $eb5d583b38281801$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$eb5d583b38281801$exports = (parcelRequire("4FAiI"));


var $3e3747f547314eb6$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$3e3747f547314eb6$exports = (parcelRequire("hyQ6c"));


var $09ffab375da8dbb9$exports = {};
var $38615fe74e63708c$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $38615fe74e63708c$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$bc906635e498c759$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$38615fe74e63708c$exports = $38615fe74e63708c$var$baseExtremum;


var $5c18bbc4ea45e704$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $5c18bbc4ea45e704$var$baseGt(value, other) {
    return value > other;
}
$5c18bbc4ea45e704$exports = $5c18bbc4ea45e704$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $09ffab375da8dbb9$var$max(array) {
    return array && array.length ? $38615fe74e63708c$exports(array, $402384d5d8a18b54$exports, $5c18bbc4ea45e704$exports) : undefined;
}
$09ffab375da8dbb9$exports = $09ffab375da8dbb9$var$max;


var $b889fa35dcf82a15$exports = {};

var $0ecaa187216094ab$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $0ecaa187216094ab$var$baseLt(value, other) {
    return value < other;
}
$0ecaa187216094ab$exports = $0ecaa187216094ab$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $b889fa35dcf82a15$var$min(array) {
    return array && array.length ? $38615fe74e63708c$exports(array, $402384d5d8a18b54$exports, $0ecaa187216094ab$exports) : undefined;
}
$b889fa35dcf82a15$exports = $b889fa35dcf82a15$var$min;






var $413047c36f2728d5$exports = {};

var $698a9740214e110f$exports = {};




/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $698a9740214e110f$var$map(collection, iteratee) {
    var func = $fcffceb67c06866f$exports(collection) ? $99747295c2209139$exports : $ce9fb961f9c96274$exports;
    return func(collection, $e7eef0e89d3554e6$exports(iteratee, 3));
}
$698a9740214e110f$exports = $698a9740214e110f$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $413047c36f2728d5$var$flatMap(collection, iteratee) {
    return $4f85d08177189c11$exports($698a9740214e110f$exports(collection, iteratee), 1);
}
$413047c36f2728d5$exports = $413047c36f2728d5$var$flatMap;



var $a5ba6f20100f95e5$exports = {};
var $44e0ae5d942c73a5$exports = {};
var $bb6460539d163f4a$exports = {};
var $4fc16fde8b4c74a5$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $4fc16fde8b4c74a5$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$4fc16fde8b4c74a5$exports = $4fc16fde8b4c74a5$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $bb6460539d163f4a$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $4fc16fde8b4c74a5$exports(array, start, end);
}
$bb6460539d163f4a$exports = $bb6460539d163f4a$var$castSlice;


var $013ea2a3e6b55c0c$exports = {};
/** Used to compose unicode character classes. */ var $013ea2a3e6b55c0c$var$rsAstralRange = "\ud800-\udfff", $013ea2a3e6b55c0c$var$rsComboMarksRange = "\\u0300-\\u036f", $013ea2a3e6b55c0c$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $013ea2a3e6b55c0c$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $013ea2a3e6b55c0c$var$rsComboRange = $013ea2a3e6b55c0c$var$rsComboMarksRange + $013ea2a3e6b55c0c$var$reComboHalfMarksRange + $013ea2a3e6b55c0c$var$rsComboSymbolsRange, $013ea2a3e6b55c0c$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $013ea2a3e6b55c0c$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $013ea2a3e6b55c0c$var$reHasUnicode = RegExp("[" + $013ea2a3e6b55c0c$var$rsZWJ + $013ea2a3e6b55c0c$var$rsAstralRange + $013ea2a3e6b55c0c$var$rsComboRange + $013ea2a3e6b55c0c$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $013ea2a3e6b55c0c$var$hasUnicode(string) {
    return $013ea2a3e6b55c0c$var$reHasUnicode.test(string);
}
$013ea2a3e6b55c0c$exports = $013ea2a3e6b55c0c$var$hasUnicode;


var $546b6000c1cac5cc$exports = {};
var $3c75d6f477fe992e$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3c75d6f477fe992e$var$asciiToArray(string) {
    return string.split("");
}
$3c75d6f477fe992e$exports = $3c75d6f477fe992e$var$asciiToArray;



var $ea69c3227c25ccf4$exports = {};
/** Used to compose unicode character classes. */ var $ea69c3227c25ccf4$var$rsAstralRange = "\ud800-\udfff", $ea69c3227c25ccf4$var$rsComboMarksRange = "\\u0300-\\u036f", $ea69c3227c25ccf4$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $ea69c3227c25ccf4$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $ea69c3227c25ccf4$var$rsComboRange = $ea69c3227c25ccf4$var$rsComboMarksRange + $ea69c3227c25ccf4$var$reComboHalfMarksRange + $ea69c3227c25ccf4$var$rsComboSymbolsRange, $ea69c3227c25ccf4$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $ea69c3227c25ccf4$var$rsAstral = "[" + $ea69c3227c25ccf4$var$rsAstralRange + "]", $ea69c3227c25ccf4$var$rsCombo = "[" + $ea69c3227c25ccf4$var$rsComboRange + "]", $ea69c3227c25ccf4$var$rsFitz = "\ud83c[\udffb-\udfff]", $ea69c3227c25ccf4$var$rsModifier = "(?:" + $ea69c3227c25ccf4$var$rsCombo + "|" + $ea69c3227c25ccf4$var$rsFitz + ")", $ea69c3227c25ccf4$var$rsNonAstral = "[^" + $ea69c3227c25ccf4$var$rsAstralRange + "]", $ea69c3227c25ccf4$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $ea69c3227c25ccf4$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $ea69c3227c25ccf4$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $ea69c3227c25ccf4$var$reOptMod = $ea69c3227c25ccf4$var$rsModifier + "?", $ea69c3227c25ccf4$var$rsOptVar = "[" + $ea69c3227c25ccf4$var$rsVarRange + "]?", $ea69c3227c25ccf4$var$rsOptJoin = "(?:" + $ea69c3227c25ccf4$var$rsZWJ + "(?:" + [
    $ea69c3227c25ccf4$var$rsNonAstral,
    $ea69c3227c25ccf4$var$rsRegional,
    $ea69c3227c25ccf4$var$rsSurrPair
].join("|") + ")" + $ea69c3227c25ccf4$var$rsOptVar + $ea69c3227c25ccf4$var$reOptMod + ")*", $ea69c3227c25ccf4$var$rsSeq = $ea69c3227c25ccf4$var$rsOptVar + $ea69c3227c25ccf4$var$reOptMod + $ea69c3227c25ccf4$var$rsOptJoin, $ea69c3227c25ccf4$var$rsSymbol = "(?:" + [
    $ea69c3227c25ccf4$var$rsNonAstral + $ea69c3227c25ccf4$var$rsCombo + "?",
    $ea69c3227c25ccf4$var$rsCombo,
    $ea69c3227c25ccf4$var$rsRegional,
    $ea69c3227c25ccf4$var$rsSurrPair,
    $ea69c3227c25ccf4$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $ea69c3227c25ccf4$var$reUnicode = RegExp($ea69c3227c25ccf4$var$rsFitz + "(?=" + $ea69c3227c25ccf4$var$rsFitz + ")|" + $ea69c3227c25ccf4$var$rsSymbol + $ea69c3227c25ccf4$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $ea69c3227c25ccf4$var$unicodeToArray(string) {
    return string.match($ea69c3227c25ccf4$var$reUnicode) || [];
}
$ea69c3227c25ccf4$exports = $ea69c3227c25ccf4$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $546b6000c1cac5cc$var$stringToArray(string) {
    return $013ea2a3e6b55c0c$exports(string) ? $ea69c3227c25ccf4$exports(string) : $3c75d6f477fe992e$exports(string);
}
$546b6000c1cac5cc$exports = $546b6000c1cac5cc$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $44e0ae5d942c73a5$var$createCaseFirst(methodName) {
    return function(string) {
        string = $96d32cc37a67927b$exports(string);
        var strSymbols = $013ea2a3e6b55c0c$exports(string) ? $546b6000c1cac5cc$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $bb6460539d163f4a$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$44e0ae5d942c73a5$exports = $44e0ae5d942c73a5$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $a5ba6f20100f95e5$var$upperFirst = $44e0ae5d942c73a5$exports("toUpperCase");
$a5ba6f20100f95e5$exports = $a5ba6f20100f95e5$var$upperFirst;


var $6cf74f74207fce54$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $6cf74f74207fce54$var$isEqual(value, other) {
    return $95f603d1d18ed3fb$exports(value, other);
}
$6cf74f74207fce54$exports = $6cf74f74207fce54$var$isEqual;



var $ea309ea445a2292e$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $ea309ea445a2292e$exports) $ea309ea445a2292e$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($ea309ea445a2292e$exports);


function $c9ff6f996101fdad$var$_toConsumableArray(arr) {
    return $c9ff6f996101fdad$var$_arrayWithoutHoles(arr) || $c9ff6f996101fdad$var$_iterableToArray(arr) || $c9ff6f996101fdad$var$_unsupportedIterableToArray(arr) || $c9ff6f996101fdad$var$_nonIterableSpread();
}
function $c9ff6f996101fdad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c9ff6f996101fdad$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c9ff6f996101fdad$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c9ff6f996101fdad$var$_arrayLikeToArray(o, minLen);
}
function $c9ff6f996101fdad$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c9ff6f996101fdad$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c9ff6f996101fdad$var$_arrayLikeToArray(arr);
}
function $c9ff6f996101fdad$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c9ff6f996101fdad$var$identity = function identity(i) {
    return i;
};
var $c9ff6f996101fdad$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $c9ff6f996101fdad$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $c9ff6f996101fdad$export$ca73b6d700d0505;
};
var $c9ff6f996101fdad$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $c9ff6f996101fdad$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $c9ff6f996101fdad$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $c9ff6f996101fdad$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $c9ff6f996101fdad$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $c9ff6f996101fdad$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $c9ff6f996101fdad$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $c9ff6f996101fdad$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $c9ff6f996101fdad$export$c3095a23b368d1f2 = function curry(fn) {
    return $c9ff6f996101fdad$var$curryN(fn.length, fn);
};
var $c9ff6f996101fdad$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $c9ff6f996101fdad$export$871de8747c9eaa88 = $c9ff6f996101fdad$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $c9ff6f996101fdad$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $c9ff6f996101fdad$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $c9ff6f996101fdad$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $c9ff6f996101fdad$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $47094ae168e480a7$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $47094ae168e480a7$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $47094ae168e480a7$var$interpolateNumber = (0, $c9ff6f996101fdad$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $47094ae168e480a7$var$uninterpolateNumber = (0, $c9ff6f996101fdad$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $47094ae168e480a7$var$uninterpolateTruncation = (0, $c9ff6f996101fdad$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $47094ae168e480a7$export$2e2bcd8739ae039 = {
    rangeStep: $47094ae168e480a7$var$rangeStep,
    getDigitCount: $47094ae168e480a7$var$getDigitCount,
    interpolateNumber: $47094ae168e480a7$var$interpolateNumber,
    uninterpolateNumber: $47094ae168e480a7$var$uninterpolateNumber,
    uninterpolateTruncation: $47094ae168e480a7$var$uninterpolateTruncation
};


function $793e3313270b4fe2$var$_toConsumableArray(arr) {
    return $793e3313270b4fe2$var$_arrayWithoutHoles(arr) || $793e3313270b4fe2$var$_iterableToArray(arr) || $793e3313270b4fe2$var$_unsupportedIterableToArray(arr) || $793e3313270b4fe2$var$_nonIterableSpread();
}
function $793e3313270b4fe2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $793e3313270b4fe2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $793e3313270b4fe2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $793e3313270b4fe2$var$_arrayLikeToArray(arr);
}
function $793e3313270b4fe2$var$_slicedToArray(arr, i) {
    return $793e3313270b4fe2$var$_arrayWithHoles(arr) || $793e3313270b4fe2$var$_iterableToArrayLimit(arr, i) || $793e3313270b4fe2$var$_unsupportedIterableToArray(arr, i) || $793e3313270b4fe2$var$_nonIterableRest();
}
function $793e3313270b4fe2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $793e3313270b4fe2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $793e3313270b4fe2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $793e3313270b4fe2$var$_arrayLikeToArray(o, minLen);
}
function $793e3313270b4fe2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $793e3313270b4fe2$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $793e3313270b4fe2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $793e3313270b4fe2$var$getValidInterval(_ref) {
    var _ref2 = $793e3313270b4fe2$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $793e3313270b4fe2$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0);
    var digitCount = (0, $47094ae168e480a7$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $793e3313270b4fe2$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(10).pow((0, $47094ae168e480a7$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $c9ff6f996101fdad$export$f672e0b6f7222cd7)((0, $c9ff6f996101fdad$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $c9ff6f996101fdad$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $793e3313270b4fe2$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $793e3313270b4fe2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $793e3313270b4fe2$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $793e3313270b4fe2$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $793e3313270b4fe2$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $793e3313270b4fe2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $793e3313270b4fe2$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($793e3313270b4fe2$var$_toConsumableArray((0, $c9ff6f996101fdad$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($793e3313270b4fe2$var$_toConsumableArray((0, $c9ff6f996101fdad$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $c9ff6f996101fdad$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $793e3313270b4fe2$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $793e3313270b4fe2$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $47094ae168e480a7$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $c9ff6f996101fdad$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $793e3313270b4fe2$var$getTickValuesFn(_ref5) {
    var _ref6 = $793e3313270b4fe2$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $793e3313270b4fe2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $793e3313270b4fe2$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $793e3313270b4fe2$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $793e3313270b4fe2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $c9ff6f996101fdad$export$f672e0b6f7222cd7)((0, $c9ff6f996101fdad$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(n).mul(step)).toNumber();
    }), (0, $c9ff6f996101fdad$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $c9ff6f996101fdad$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $793e3313270b4fe2$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $793e3313270b4fe2$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $793e3313270b4fe2$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $793e3313270b4fe2$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $793e3313270b4fe2$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($793e3313270b4fe2$var$_toConsumableArray((0, $47094ae168e480a7$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($ea309ea445a2292e$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $c9ff6f996101fdad$export$66c1ae025e96b4bc)(values) : values;
}
var $793e3313270b4fe2$export$b84e75ccbfe6a612 = (0, $c9ff6f996101fdad$export$fc10aeed3a532e2a)($793e3313270b4fe2$var$getNiceTickValuesFn);
var $793e3313270b4fe2$export$4cc7a216492b1f53 = (0, $c9ff6f996101fdad$export$fc10aeed3a532e2a)($793e3313270b4fe2$var$getTickValuesFn);
var $793e3313270b4fe2$export$e9d28da780436e98 = (0, $c9ff6f996101fdad$export$fc10aeed3a532e2a)($793e3313270b4fe2$var$getTickValuesFixedDomainFn);





var $9KJkx = parcelRequire("9KJkx");

var $9KJkx = parcelRequire("9KJkx");


var $a84cf7b0e0eb3816$var$_excluded = [
    "children",
    "className"
];
function $a84cf7b0e0eb3816$var$_extends() {
    $a84cf7b0e0eb3816$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a84cf7b0e0eb3816$var$_extends.apply(this, arguments);
}
function $a84cf7b0e0eb3816$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a84cf7b0e0eb3816$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a84cf7b0e0eb3816$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a84cf7b0e0eb3816$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $a84cf7b0e0eb3816$var$_objectWithoutProperties(props, $a84cf7b0e0eb3816$var$_excluded);
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", $a84cf7b0e0eb3816$var$_extends({
        className: layerClass
    }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $09f57e96f11ada43$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $09f57e96f11ada43$var$_extends() {
    $09f57e96f11ada43$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09f57e96f11ada43$var$_extends.apply(this, arguments);
}
function $09f57e96f11ada43$var$_slicedToArray(arr, i) {
    return $09f57e96f11ada43$var$_arrayWithHoles(arr) || $09f57e96f11ada43$var$_iterableToArrayLimit(arr, i) || $09f57e96f11ada43$var$_unsupportedIterableToArray(arr, i) || $09f57e96f11ada43$var$_nonIterableRest();
}
function $09f57e96f11ada43$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $09f57e96f11ada43$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $09f57e96f11ada43$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $09f57e96f11ada43$var$_arrayLikeToArray(o, minLen);
}
function $09f57e96f11ada43$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $09f57e96f11ada43$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $09f57e96f11ada43$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $09f57e96f11ada43$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $09f57e96f11ada43$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $09f57e96f11ada43$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $09f57e96f11ada43$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $09f57e96f11ada43$var$_objectWithoutProperties(props, $09f57e96f11ada43$var$_excluded);
    var svgProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others);
    var errorBars = data.map(function(entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $09f57e96f11ada43$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), $09f57e96f11ada43$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
        }, svgProps), lineCoordinates.map(function(coordinates, index) {
            return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
            (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", $09f57e96f11ada43$var$_extends({}, coordinates, {
                key: "line-".concat(index)
            })));
        })));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$09f57e96f11ada43$export$4f4d7676bdf949e5.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
$09f57e96f11ada43$export$4f4d7676bdf949e5.displayName = "ErrorBar";





var $9KJkx = parcelRequire("9KJkx");

var $9KJkx = parcelRequire("9KJkx");




var $9KJkx = parcelRequire("9KJkx");


var $47567e5d38653620$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $47567e5d38653620$var$_extends() {
    $47567e5d38653620$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47567e5d38653620$var$_extends.apply(this, arguments);
}
function $47567e5d38653620$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $47567e5d38653620$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $47567e5d38653620$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $47567e5d38653620$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $47567e5d38653620$var$_objectWithoutProperties(props, $47567e5d38653620$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("svg", $47567e5d38653620$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("desc", null, desc), children);
}



var $9KJkx = parcelRequire("9KJkx");




function $01d4c0b8afeeb8c1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $01d4c0b8afeeb8c1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01d4c0b8afeeb8c1$var$_typeof(o);
}
var $01d4c0b8afeeb8c1$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $01d4c0b8afeeb8c1$var$_extends() {
    $01d4c0b8afeeb8c1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $01d4c0b8afeeb8c1$var$_extends.apply(this, arguments);
}
function $01d4c0b8afeeb8c1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01d4c0b8afeeb8c1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01d4c0b8afeeb8c1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $01d4c0b8afeeb8c1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01d4c0b8afeeb8c1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $01d4c0b8afeeb8c1$var$_defineProperty(obj, key, value) {
    key = $01d4c0b8afeeb8c1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $01d4c0b8afeeb8c1$var$_toPropertyKey(arg) {
    var key = $01d4c0b8afeeb8c1$var$_toPrimitive(arg, "string");
    return $01d4c0b8afeeb8c1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $01d4c0b8afeeb8c1$var$_toPrimitive(input, hint) {
    if ($01d4c0b8afeeb8c1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($01d4c0b8afeeb8c1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $01d4c0b8afeeb8c1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $01d4c0b8afeeb8c1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $01d4c0b8afeeb8c1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $01d4c0b8afeeb8c1$var$symbolFactories = {
    symbolCircle: (0, $3e3747f547314eb6$exports.symbolCircle),
    symbolCross: (0, $3e3747f547314eb6$exports.symbolCross),
    symbolDiamond: (0, $3e3747f547314eb6$exports.symbolDiamond),
    symbolSquare: (0, $3e3747f547314eb6$exports.symbolSquare),
    symbolStar: (0, $3e3747f547314eb6$exports.symbolStar),
    symbolTriangle: (0, $3e3747f547314eb6$exports.symbolTriangle),
    symbolWye: (0, $3e3747f547314eb6$exports.symbolWye)
};
var $01d4c0b8afeeb8c1$var$RADIAN = Math.PI / 180;
var $01d4c0b8afeeb8c1$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($a5ba6f20100f95e5$exports)))(type));
    return $01d4c0b8afeeb8c1$var$symbolFactories[name] || (0, $3e3747f547314eb6$exports.symbolCircle);
};
var $01d4c0b8afeeb8c1$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $01d4c0b8afeeb8c1$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $01d4c0b8afeeb8c1$var$registerSymbol = function registerSymbol(key, factory) {
    $01d4c0b8afeeb8c1$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($a5ba6f20100f95e5$exports)))(key))] = factory;
};
var $01d4c0b8afeeb8c1$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = $01d4c0b8afeeb8c1$var$_objectWithoutProperties(_ref, $01d4c0b8afeeb8c1$var$_excluded);
    var props = $01d4c0b8afeeb8c1$var$_objectSpread($01d4c0b8afeeb8c1$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $01d4c0b8afeeb8c1$var$getSymbolFactory(type);
        var symbol = (0, $3e3747f547314eb6$exports.symbol)().type(symbolFactory).size($01d4c0b8afeeb8c1$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $01d4c0b8afeeb8c1$var$_extends({}, filteredProps, {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$01d4c0b8afeeb8c1$export$fa456266707bf4e4.registerSymbol = $01d4c0b8afeeb8c1$var$registerSymbol;



function $e0e1cf7d8fdaea53$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e0e1cf7d8fdaea53$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e0e1cf7d8fdaea53$var$_typeof(o);
}
function $e0e1cf7d8fdaea53$var$_extends() {
    $e0e1cf7d8fdaea53$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0e1cf7d8fdaea53$var$_extends.apply(this, arguments);
}
function $e0e1cf7d8fdaea53$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0e1cf7d8fdaea53$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0e1cf7d8fdaea53$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e0e1cf7d8fdaea53$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0e1cf7d8fdaea53$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e0e1cf7d8fdaea53$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e0e1cf7d8fdaea53$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e0e1cf7d8fdaea53$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e0e1cf7d8fdaea53$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e0e1cf7d8fdaea53$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e0e1cf7d8fdaea53$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e0e1cf7d8fdaea53$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e0e1cf7d8fdaea53$var$_setPrototypeOf(subClass, superClass);
}
function $e0e1cf7d8fdaea53$var$_setPrototypeOf(o, p) {
    $e0e1cf7d8fdaea53$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0e1cf7d8fdaea53$var$_setPrototypeOf(o, p);
}
function $e0e1cf7d8fdaea53$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e0e1cf7d8fdaea53$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e0e1cf7d8fdaea53$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e0e1cf7d8fdaea53$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e0e1cf7d8fdaea53$var$_possibleConstructorReturn(this, result);
    };
}
function $e0e1cf7d8fdaea53$var$_possibleConstructorReturn(self, call) {
    if (call && ($e0e1cf7d8fdaea53$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e0e1cf7d8fdaea53$var$_assertThisInitialized(self);
}
function $e0e1cf7d8fdaea53$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e0e1cf7d8fdaea53$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e0e1cf7d8fdaea53$var$_getPrototypeOf(o) {
    $e0e1cf7d8fdaea53$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e0e1cf7d8fdaea53$var$_getPrototypeOf(o);
}
function $e0e1cf7d8fdaea53$var$_defineProperty(obj, key, value) {
    key = $e0e1cf7d8fdaea53$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0e1cf7d8fdaea53$var$_toPropertyKey(arg) {
    var key = $e0e1cf7d8fdaea53$var$_toPrimitive(arg, "string");
    return $e0e1cf7d8fdaea53$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e0e1cf7d8fdaea53$var$_toPrimitive(input, hint) {
    if ($e0e1cf7d8fdaea53$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e0e1cf7d8fdaea53$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e0e1cf7d8fdaea53$var$SIZE = 32;
var $e0e1cf7d8fdaea53$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $e0e1cf7d8fdaea53$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $e0e1cf7d8fdaea53$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $e0e1cf7d8fdaea53$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $e0e1cf7d8fdaea53$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $e0e1cf7d8fdaea53$var$SIZE / 2;
                var sixthSize = $e0e1cf7d8fdaea53$var$SIZE / 6;
                var thirdSize = $e0e1cf7d8fdaea53$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $e0e1cf7d8fdaea53$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($e0e1cf7d8fdaea53$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($e0e1cf7d8fdaea53$var$SIZE / 8, "h").concat($e0e1cf7d8fdaea53$var$SIZE, "v").concat($e0e1cf7d8fdaea53$var$SIZE * 3 / 4, "h").concat(-$e0e1cf7d8fdaea53$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(data.legendIcon)) {
                    var iconProps = $e0e1cf7d8fdaea53$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $01d4c0b8afeeb8c1$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $e0e1cf7d8fdaea53$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $e0e1cf7d8fdaea53$var$SIZE,
                    height: $e0e1cf7d8fdaea53$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _clsx;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $416e29c4ee421493$export$2e2bcd8739ae039)((_clsx = {
                        "recharts-legend-item": true
                    }, $e0e1cf7d8fdaea53$var$_defineProperty(_clsx, "legend-item-".concat(i), true), $e0e1cf7d8fdaea53$var$_defineProperty(_clsx, "inactive", entry.inactive), _clsx));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(entry.value) ? entry.value : null;
                    (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("li", $e0e1cf7d8fdaea53$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $6d098ec72682e3e0$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $47567e5d38653620$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $9KJkx.PureComponent));
$e0e1cf7d8fdaea53$var$_defineProperty($e0e1cf7d8fdaea53$export$99f8d96ed0cededa, "displayName", "Legend");
$e0e1cf7d8fdaea53$var$_defineProperty($e0e1cf7d8fdaea53$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



var $a9bb75b64af261e8$exports = {};

var $0cebb66a9874f947$exports = {};

var $c9a034d0b9e73b71$exports = {};
var $314e9b4464e1925e$exports = {};

var $685d3f586cdce4bc$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $685d3f586cdce4bc$var$baseIsNaN(value) {
    return value !== value;
}
$685d3f586cdce4bc$exports = $685d3f586cdce4bc$var$baseIsNaN;


var $43abbf952a29ebf7$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $43abbf952a29ebf7$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$43abbf952a29ebf7$exports = $43abbf952a29ebf7$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $314e9b4464e1925e$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $43abbf952a29ebf7$exports(array, value, fromIndex) : $e1c89747a26014f1$exports(array, $685d3f586cdce4bc$exports, fromIndex);
}
$314e9b4464e1925e$exports = $314e9b4464e1925e$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c9a034d0b9e73b71$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $314e9b4464e1925e$exports(array, value, 0) > -1;
}
$c9a034d0b9e73b71$exports = $c9a034d0b9e73b71$var$arrayIncludes;


var $e612a6972db6fab2$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e612a6972db6fab2$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$e612a6972db6fab2$exports = $e612a6972db6fab2$var$arrayIncludesWith;



var $3e2383f48b538f7a$exports = {};

var $3b59d726f2a3abde$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $3b59d726f2a3abde$var$noop() {
// No operation performed.
}
$3b59d726f2a3abde$exports = $3b59d726f2a3abde$var$noop;



/** Used as references for various `Number` constants. */ var $3e2383f48b538f7a$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3e2383f48b538f7a$var$createSet = !($6d389a7e18625706$exports && 1 / $23fd3a833208544f$exports(new $6d389a7e18625706$exports([
    ,
    -0
]))[1] == $3e2383f48b538f7a$var$INFINITY) ? $3b59d726f2a3abde$exports : function(values) {
    return new $6d389a7e18625706$exports(values);
};
$3e2383f48b538f7a$exports = $3e2383f48b538f7a$var$createSet;



/** Used as the size to enable large array optimizations. */ var $0cebb66a9874f947$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $0cebb66a9874f947$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $c9a034d0b9e73b71$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $e612a6972db6fab2$exports;
    } else if (length >= $0cebb66a9874f947$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $3e2383f48b538f7a$exports(array);
        if (set) return $23fd3a833208544f$exports(set);
        isCommon = false;
        includes = $61947952d773f171$exports;
        seen = new $5c8d9875c4518b2e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$0cebb66a9874f947$exports = $0cebb66a9874f947$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $a9bb75b64af261e8$var$uniqBy(array, iteratee) {
    return array && array.length ? $0cebb66a9874f947$exports(array, $e7eef0e89d3554e6$exports(iteratee, 2)) : [];
}
$a9bb75b64af261e8$exports = $a9bb75b64af261e8$var$uniqBy;



function $90ce88196b05cf2b$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($a9bb75b64af261e8$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($a9bb75b64af261e8$exports)))(payload, option);
    return payload;
}


function $43190005d2438131$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $43190005d2438131$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $43190005d2438131$var$_typeof(o);
}
var $43190005d2438131$var$_excluded = [
    "ref"
];
function $43190005d2438131$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43190005d2438131$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43190005d2438131$var$ownKeys(Object(t), !0).forEach(function(r) {
            $43190005d2438131$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43190005d2438131$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $43190005d2438131$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43190005d2438131$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $43190005d2438131$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $43190005d2438131$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $43190005d2438131$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $43190005d2438131$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $43190005d2438131$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $43190005d2438131$var$_setPrototypeOf(subClass, superClass);
}
function $43190005d2438131$var$_setPrototypeOf(o, p) {
    $43190005d2438131$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $43190005d2438131$var$_setPrototypeOf(o, p);
}
function $43190005d2438131$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $43190005d2438131$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $43190005d2438131$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $43190005d2438131$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $43190005d2438131$var$_possibleConstructorReturn(this, result);
    };
}
function $43190005d2438131$var$_possibleConstructorReturn(self, call) {
    if (call && ($43190005d2438131$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $43190005d2438131$var$_assertThisInitialized(self);
}
function $43190005d2438131$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $43190005d2438131$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $43190005d2438131$var$_getPrototypeOf(o) {
    $43190005d2438131$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $43190005d2438131$var$_getPrototypeOf(o);
}
function $43190005d2438131$var$_defineProperty(obj, key, value) {
    key = $43190005d2438131$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $43190005d2438131$var$_toPropertyKey(arg) {
    var key = $43190005d2438131$var$_toPrimitive(arg, "string");
    return $43190005d2438131$var$_typeof(key) === "symbol" ? key : String(key);
}
function $43190005d2438131$var$_toPrimitive(input, hint) {
    if ($43190005d2438131$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($43190005d2438131$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $43190005d2438131$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $43190005d2438131$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $43190005d2438131$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $43190005d2438131$var$defaultUniqBy(entry) {
    return entry.value;
}
function $43190005d2438131$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement(content, props);
    var ref = props.ref, otherProps = $43190005d2438131$var$_objectWithoutProperties(props, $43190005d2438131$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $e0e1cf7d8fdaea53$export$99f8d96ed0cededa), otherProps);
}
var $43190005d2438131$var$EPS = 1;
var $43190005d2438131$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $43190005d2438131$var$_inherits(Legend, _PureComponent);
    var _super = $43190005d2438131$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $43190005d2438131$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $43190005d2438131$var$_defineProperty($43190005d2438131$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $43190005d2438131$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box.width - this.lastBoundingBox.width) > $43190005d2438131$var$EPS || Math.abs(_box.height - this.lastBoundingBox.height) > $43190005d2438131$var$EPS) {
                        this.lastBoundingBox.width = _box.width;
                        this.lastBoundingBox.height = _box.height;
                        if (onBBoxUpdate) onBBoxUpdate(_box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $43190005d2438131$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $43190005d2438131$var$_objectSpread($43190005d2438131$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $43190005d2438131$var$_objectSpread($43190005d2438131$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $43190005d2438131$var$renderContent(content, $43190005d2438131$var$_objectSpread($43190005d2438131$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $90ce88196b05cf2b$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $43190005d2438131$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $9KJkx.PureComponent));
$43190005d2438131$var$_defineProperty($43190005d2438131$export$ed247974535929c7, "displayName", "Legend");
$43190005d2438131$var$_defineProperty($43190005d2438131$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});




function $8c22a6e4f658d1c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8c22a6e4f658d1c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8c22a6e4f658d1c8$var$_typeof(o);
}
function $8c22a6e4f658d1c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c22a6e4f658d1c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c22a6e4f658d1c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8c22a6e4f658d1c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c22a6e4f658d1c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c22a6e4f658d1c8$var$_defineProperty(obj, key, value) {
    key = $8c22a6e4f658d1c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8c22a6e4f658d1c8$var$_toPropertyKey(arg) {
    var key = $8c22a6e4f658d1c8$var$_toPrimitive(arg, "string");
    return $8c22a6e4f658d1c8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8c22a6e4f658d1c8$var$_toPrimitive(input, hint) {
    if ($8c22a6e4f658d1c8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8c22a6e4f658d1c8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8c22a6e4f658d1c8$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $43190005d2438131$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: (0, $71c7ed1f813f02c8$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $8c22a6e4f658d1c8$var$_objectSpread($8c22a6e4f658d1c8$var$_objectSpread($8c22a6e4f658d1c8$var$_objectSpread({}, legendItem.props), (0, $43190005d2438131$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $71c7ed1f813f02c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71c7ed1f813f02c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71c7ed1f813f02c8$var$_typeof(o);
}
function $71c7ed1f813f02c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71c7ed1f813f02c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71c7ed1f813f02c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71c7ed1f813f02c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71c7ed1f813f02c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71c7ed1f813f02c8$var$_defineProperty(obj, key, value) {
    key = $71c7ed1f813f02c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71c7ed1f813f02c8$var$_toPropertyKey(arg) {
    var key = $71c7ed1f813f02c8$var$_toPrimitive(arg, "string");
    return $71c7ed1f813f02c8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71c7ed1f813f02c8$var$_toPrimitive(input, hint) {
    if ($71c7ed1f813f02c8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71c7ed1f813f02c8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $71c7ed1f813f02c8$var$_toConsumableArray(arr) {
    return $71c7ed1f813f02c8$var$_arrayWithoutHoles(arr) || $71c7ed1f813f02c8$var$_iterableToArray(arr) || $71c7ed1f813f02c8$var$_unsupportedIterableToArray(arr) || $71c7ed1f813f02c8$var$_nonIterableSpread();
}
function $71c7ed1f813f02c8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $71c7ed1f813f02c8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $71c7ed1f813f02c8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $71c7ed1f813f02c8$var$_arrayLikeToArray(o, minLen);
}
function $71c7ed1f813f02c8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $71c7ed1f813f02c8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $71c7ed1f813f02c8$var$_arrayLikeToArray(arr);
}
function $71c7ed1f813f02c8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $71c7ed1f813f02c8$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(dataKey)) return defaultValue;
    if ((0, $3c48a89ca795c151$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $71c7ed1f813f02c8$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($413047c36f2728d5$exports)))(data, function(entry) {
        return $71c7ed1f813f02c8$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $3c48a89ca795c151$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($b889fa35dcf82a15$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($09ffab375da8dbb9$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $3c48a89ca795c151$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $71c7ed1f813f02c8$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $3c48a89ca795c151$export$9d334328eb75e624)(cur - before) !== (0, $3c48a89ca795c151$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $3c48a89ca795c151$export$9d334328eb75e624)(after - cur) === (0, $3c48a89ca795c151$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $71c7ed1f813f02c8$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $71c7ed1f813f02c8$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $19f907b79fb0a735$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $71c7ed1f813f02c8$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($71c7ed1f813f02c8$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($71c7ed1f813f02c8$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $71c7ed1f813f02c8$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $8c22a6e4f658d1c8$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(offset[align])) return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, offset), {}, $71c7ed1f813f02c8$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(offset[verticalAlign])) return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, offset), {}, $71c7ed1f813f02c8$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $71c7ed1f813f02c8$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $71c7ed1f813f02c8$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $09f57e96f11ada43$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $71c7ed1f813f02c8$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $71c7ed1f813f02c8$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($b889fa35dcf82a15$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($09ffab375da8dbb9$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $71c7ed1f813f02c8$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $71c7ed1f813f02c8$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $71c7ed1f813f02c8$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $71c7ed1f813f02c8$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $71c7ed1f813f02c8$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $71c7ed1f813f02c8$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $71c7ed1f813f02c8$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $71c7ed1f813f02c8$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $71c7ed1f813f02c8$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $71c7ed1f813f02c8$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $3c48a89ca795c151$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($106a9ee8332602e2$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $71c7ed1f813f02c8$var$handlerWeakMap = new WeakMap();
var $71c7ed1f813f02c8$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!$71c7ed1f813f02c8$var$handlerWeakMap.has(defaultHandler)) $71c7ed1f813f02c8$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $71c7ed1f813f02c8$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $71c7ed1f813f02c8$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $eb5d583b38281801$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $eb5d583b38281801$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $eb5d583b38281801$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $eb5d583b38281801$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $eb5d583b38281801$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($77d9a27889f83835$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($a5ba6f20100f95e5$exports)))(scale));
        return {
            scale: ($eb5d583b38281801$exports[name] || $eb5d583b38281801$exports.scalePoint)(),
            realScaleType: $eb5d583b38281801$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $eb5d583b38281801$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $71c7ed1f813f02c8$var$EPS = 1e-4;
var $71c7ed1f813f02c8$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $71c7ed1f813f02c8$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $71c7ed1f813f02c8$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $71c7ed1f813f02c8$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $71c7ed1f813f02c8$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(domain[0]) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $3c48a89ca795c151$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $3c48a89ca795c151$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $71c7ed1f813f02c8$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($106a9ee8332602e2$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $71c7ed1f813f02c8$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($106a9ee8332602e2$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $71c7ed1f813f02c8$var$STACK_OFFSET_MAP = {
    sign: $71c7ed1f813f02c8$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $3e3747f547314eb6$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $3e3747f547314eb6$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $3e3747f547314eb6$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $3e3747f547314eb6$exports.stackOffsetWiggle),
    positive: $71c7ed1f813f02c8$export$9f2c6ead70935022
};
var $71c7ed1f813f02c8$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $71c7ed1f813f02c8$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $3e3747f547314eb6$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$71c7ed1f813f02c8$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $3e3747f547314eb6$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $71c7ed1f813f02c8$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $3c48a89ca795c151$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $3c48a89ca795c151$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, result), {}, $71c7ed1f813f02c8$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, res), {}, $71c7ed1f813f02c8$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $71c7ed1f813f02c8$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, result), {}, $71c7ed1f813f02c8$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $71c7ed1f813f02c8$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $793e3313270b4fe2$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($b889fa35dcf82a15$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($09ffab375da8dbb9$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $793e3313270b4fe2$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $71c7ed1f813f02c8$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $3c48a89ca795c151$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $71c7ed1f813f02c8$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(value) ? axis.scale(value) : null;
};
var $71c7ed1f813f02c8$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $71c7ed1f813f02c8$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $71c7ed1f813f02c8$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $71c7ed1f813f02c8$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $3c48a89ca795c151$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $71c7ed1f813f02c8$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($b889fa35dcf82a15$exports)))(entry.concat([
                result[0]
            ]).filter((0, $3c48a89ca795c151$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($09ffab375da8dbb9$exports)))(entry.concat([
                result[1]
            ]).filter((0, $3c48a89ca795c151$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $71c7ed1f813f02c8$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $71c7ed1f813f02c8$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $71c7ed1f813f02c8$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $71c7ed1f813f02c8$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $71c7ed1f813f02c8$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($71c7ed1f813f02c8$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$71c7ed1f813f02c8$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($71c7ed1f813f02c8$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$71c7ed1f813f02c8$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $71c7ed1f813f02c8$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($0f90809c435feb4c$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $71c7ed1f813f02c8$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6cf74f74207fce54$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $71c7ed1f813f02c8$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $71c7ed1f813f02c8$var$_objectSpread($71c7ed1f813f02c8$var$_objectSpread({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $71c7ed1f813f02c8$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $71c7ed1f813f02c8$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $98248a286e872525$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $98248a286e872525$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $98248a286e872525$var$_typeof(o);
}
function $98248a286e872525$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98248a286e872525$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98248a286e872525$var$ownKeys(Object(t), !0).forEach(function(r) {
            $98248a286e872525$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98248a286e872525$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $98248a286e872525$var$_defineProperty(obj, key, value) {
    key = $98248a286e872525$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98248a286e872525$var$_toPropertyKey(arg) {
    var key = $98248a286e872525$var$_toPrimitive(arg, "string");
    return $98248a286e872525$var$_typeof(key) === "symbol" ? key : String(key);
}
function $98248a286e872525$var$_toPrimitive(input, hint) {
    if ($98248a286e872525$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($98248a286e872525$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $98248a286e872525$var$_slicedToArray(arr, i) {
    return $98248a286e872525$var$_arrayWithHoles(arr) || $98248a286e872525$var$_iterableToArrayLimit(arr, i) || $98248a286e872525$var$_unsupportedIterableToArray(arr, i) || $98248a286e872525$var$_nonIterableRest();
}
function $98248a286e872525$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $98248a286e872525$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $98248a286e872525$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $98248a286e872525$var$_arrayLikeToArray(o, minLen);
}
function $98248a286e872525$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $98248a286e872525$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $98248a286e872525$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $98248a286e872525$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $98248a286e872525$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $98248a286e872525$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $98248a286e872525$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$98248a286e872525$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$98248a286e872525$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $98248a286e872525$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $98248a286e872525$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $98248a286e872525$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $98248a286e872525$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $71c7ed1f813f02c8$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $71c7ed1f813f02c8$export$9d80152e23bae434)(scale);
        var ticks = (0, $71c7ed1f813f02c8$export$ac086aaa4358d590)(scale, $98248a286e872525$var$_objectSpread($98248a286e872525$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $98248a286e872525$var$_objectSpread($98248a286e872525$var$_objectSpread($98248a286e872525$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $98248a286e872525$var$_objectSpread($98248a286e872525$var$_objectSpread({}, result), {}, $98248a286e872525$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $98248a286e872525$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $98248a286e872525$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $98248a286e872525$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $98248a286e872525$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $98248a286e872525$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $98248a286e872525$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $98248a286e872525$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $98248a286e872525$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $98248a286e872525$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $98248a286e872525$var$_objectSpread($98248a286e872525$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $98248a286e872525$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};


function $74646f7876f0355d$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}




var $53543b9e1a8a46fb$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $53543b9e1a8a46fb$export$98f03c5d19621d70 = {
    isSsr: $53543b9e1a8a46fb$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $53543b9e1a8a46fb$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $53543b9e1a8a46fb$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $53543b9e1a8a46fb$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};


function $dc248c2135213327$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc248c2135213327$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc248c2135213327$var$_typeof(o);
}
function $dc248c2135213327$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc248c2135213327$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc248c2135213327$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dc248c2135213327$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc248c2135213327$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc248c2135213327$var$_defineProperty(obj, key, value) {
    key = $dc248c2135213327$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc248c2135213327$var$_toPropertyKey(arg) {
    var key = $dc248c2135213327$var$_toPrimitive(arg, "string");
    return $dc248c2135213327$var$_typeof(key) === "symbol" ? key : String(key);
}
function $dc248c2135213327$var$_toPrimitive(input, hint) {
    if ($dc248c2135213327$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($dc248c2135213327$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dc248c2135213327$var$_toConsumableArray(arr) {
    return $dc248c2135213327$var$_arrayWithoutHoles(arr) || $dc248c2135213327$var$_iterableToArray(arr) || $dc248c2135213327$var$_unsupportedIterableToArray(arr) || $dc248c2135213327$var$_nonIterableSpread();
}
function $dc248c2135213327$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc248c2135213327$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dc248c2135213327$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dc248c2135213327$var$_arrayLikeToArray(o, minLen);
}
function $dc248c2135213327$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $dc248c2135213327$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $dc248c2135213327$var$_arrayLikeToArray(arr);
}
function $dc248c2135213327$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $dc248c2135213327$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $dc248c2135213327$var$MAX_CACHE_NUM = 2000;
var $dc248c2135213327$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $dc248c2135213327$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $dc248c2135213327$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $dc248c2135213327$var$autoCompleteStyle(name, value) {
    if ($dc248c2135213327$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $dc248c2135213327$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($dc248c2135213327$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($dc248c2135213327$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $dc248c2135213327$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($dc248c2135213327$var$camelToMiddleLine(s), ":").concat($dc248c2135213327$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function $dc248c2135213327$var$removeInvalidKeys(obj) {
    var copyObj = $dc248c2135213327$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $dc248c2135213327$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $dc248c2135213327$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($dc248c2135213327$var$stringCache.widthCache[cacheKey]) return $dc248c2135213327$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($dc248c2135213327$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $dc248c2135213327$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $dc248c2135213327$var$_objectSpread($dc248c2135213327$var$_objectSpread({}, $dc248c2135213327$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $dc248c2135213327$var$stringCache.widthCache[cacheKey] = result;
        if (++$dc248c2135213327$var$stringCache.cacheCount > $dc248c2135213327$var$MAX_CACHE_NUM) {
            $dc248c2135213327$var$stringCache.cacheCount = 0;
            $dc248c2135213327$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $dc248c2135213327$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};



var $59d36855b344bc89$exports = {};
var $54c61209c57bbf98$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $54c61209c57bbf98$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $2f7ac0479f3c7c55$exports) $2f7ac0479f3c7c55$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$54c61209c57bbf98$exports = $54c61209c57bbf98$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $59d36855b344bc89$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $e7eef0e89d3554e6$exports(iteratee, 3);
    $90099ca8d868fcaa$exports(object, function(value, key, object) {
        $54c61209c57bbf98$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$59d36855b344bc89$exports = $59d36855b344bc89$var$mapValues;







var $9KJkx = parcelRequire("9KJkx");


var $9KJkx = parcelRequire("9KJkx");

var $3P0iH = parcelRequire("3P0iH");
var $f4b8325724dd2d83$exports = {};
(function(global, factory) {
    factory($f4b8325724dd2d83$exports);
})($f4b8325724dd2d83$exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $13b0b15598d6e855$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function $13b0b15598d6e855$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $13b0b15598d6e855$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $505b94837c7b52de$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $505b94837c7b52de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $505b94837c7b52de$var$_typeof(obj);
}
function $505b94837c7b52de$var$_toArray(arr) {
    return $505b94837c7b52de$var$_arrayWithHoles(arr) || $505b94837c7b52de$var$_iterableToArray(arr) || $505b94837c7b52de$var$_unsupportedIterableToArray(arr) || $505b94837c7b52de$var$_nonIterableRest();
}
function $505b94837c7b52de$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $505b94837c7b52de$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $505b94837c7b52de$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $505b94837c7b52de$var$_arrayLikeToArray(o, minLen);
}
function $505b94837c7b52de$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $505b94837c7b52de$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $505b94837c7b52de$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $505b94837c7b52de$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $505b94837c7b52de$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $13b0b15598d6e855$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $13b0b15598d6e855$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($505b94837c7b52de$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $52c62b34c1505cbc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $52c62b34c1505cbc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $52c62b34c1505cbc$var$_typeof(obj);
}
function $52c62b34c1505cbc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $52c62b34c1505cbc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $52c62b34c1505cbc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $52c62b34c1505cbc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $52c62b34c1505cbc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $52c62b34c1505cbc$var$_defineProperty(obj, key, value) {
    key = $52c62b34c1505cbc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $52c62b34c1505cbc$var$_toPropertyKey(arg) {
    var key = $52c62b34c1505cbc$var$_toPrimitive(arg, "string");
    return $52c62b34c1505cbc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $52c62b34c1505cbc$var$_toPrimitive(input, hint) {
    if ($52c62b34c1505cbc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($52c62b34c1505cbc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint no-console: 0 */ var $52c62b34c1505cbc$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $52c62b34c1505cbc$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $52c62b34c1505cbc$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $52c62b34c1505cbc$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $52c62b34c1505cbc$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $52c62b34c1505cbc$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $52c62b34c1505cbc$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($52c62b34c1505cbc$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $52c62b34c1505cbc$var$_defineProperty({}, name, Number.isNaN(value) ? 0 : value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $52c62b34c1505cbc$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($52c62b34c1505cbc$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $52c62b34c1505cbc$var$_objectSpread($52c62b34c1505cbc$var$_objectSpread({}, result), {}, $52c62b34c1505cbc$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $52c62b34c1505cbc$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $52c62b34c1505cbc$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $52c62b34c1505cbc$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $52c62b34c1505cbc$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $52c62b34c1505cbc$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $52c62b34c1505cbc$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $52c62b34c1505cbc$var$_objectSpread($52c62b34c1505cbc$var$_objectSpread({}, res), {}, $52c62b34c1505cbc$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $52c62b34c1505cbc$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $52c62b34c1505cbc$var$_objectSpread($52c62b34c1505cbc$var$_objectSpread({}, res), $52c62b34c1505cbc$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $52c62b34c1505cbc$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $52c62b34c1505cbc$export$f0954fd7d5368655;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $52c62b34c1505cbc$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($52c62b34c1505cbc$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $52c62b34c1505cbc$var$isDev = false;
var $52c62b34c1505cbc$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($52c62b34c1505cbc$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $ae4b24d7c3606c08$var$_slicedToArray(arr, i) {
    return $ae4b24d7c3606c08$var$_arrayWithHoles(arr) || $ae4b24d7c3606c08$var$_iterableToArrayLimit(arr, i) || $ae4b24d7c3606c08$var$_unsupportedIterableToArray(arr, i) || $ae4b24d7c3606c08$var$_nonIterableRest();
}
function $ae4b24d7c3606c08$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ae4b24d7c3606c08$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $ae4b24d7c3606c08$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ae4b24d7c3606c08$var$_toConsumableArray(arr) {
    return $ae4b24d7c3606c08$var$_arrayWithoutHoles(arr) || $ae4b24d7c3606c08$var$_iterableToArray(arr) || $ae4b24d7c3606c08$var$_unsupportedIterableToArray(arr) || $ae4b24d7c3606c08$var$_nonIterableSpread();
}
function $ae4b24d7c3606c08$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ae4b24d7c3606c08$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ae4b24d7c3606c08$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ae4b24d7c3606c08$var$_arrayLikeToArray(o, minLen);
}
function $ae4b24d7c3606c08$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ae4b24d7c3606c08$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ae4b24d7c3606c08$var$_arrayLikeToArray(arr);
}
function $ae4b24d7c3606c08$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ae4b24d7c3606c08$var$ACCURACY = 1e-4;
var $ae4b24d7c3606c08$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $ae4b24d7c3606c08$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $ae4b24d7c3606c08$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $ae4b24d7c3606c08$var$cubicBezierFactor(c1, c2);
        return $ae4b24d7c3606c08$var$multyTime(params, t);
    };
};
var $ae4b24d7c3606c08$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $ae4b24d7c3606c08$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($ae4b24d7c3606c08$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $ae4b24d7c3606c08$var$multyTime(newParams, t);
    };
};
var $ae4b24d7c3606c08$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $ae4b24d7c3606c08$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $52c62b34c1505cbc$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $52c62b34c1505cbc$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $ae4b24d7c3606c08$var$cubicBezier(x1, x2);
    var curveY = $ae4b24d7c3606c08$var$cubicBezier(y1, y2);
    var derCurveX = $ae4b24d7c3606c08$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $ae4b24d7c3606c08$var$ACCURACY || derVal < $ae4b24d7c3606c08$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $ae4b24d7c3606c08$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $ae4b24d7c3606c08$var$ACCURACY && Math.abs(newV) < $ae4b24d7c3606c08$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $ae4b24d7c3606c08$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $ae4b24d7c3606c08$export$56c51296f72f0592(easing);
        case "spring":
            return $ae4b24d7c3606c08$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $ae4b24d7c3606c08$export$56c51296f72f0592(easing);
            (0, $52c62b34c1505cbc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $52c62b34c1505cbc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $ddca06a7327b7958$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ddca06a7327b7958$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ddca06a7327b7958$var$_typeof(obj);
}
function $ddca06a7327b7958$var$_toConsumableArray(arr) {
    return $ddca06a7327b7958$var$_arrayWithoutHoles(arr) || $ddca06a7327b7958$var$_iterableToArray(arr) || $ddca06a7327b7958$var$_unsupportedIterableToArray(arr) || $ddca06a7327b7958$var$_nonIterableSpread();
}
function $ddca06a7327b7958$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ddca06a7327b7958$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ddca06a7327b7958$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ddca06a7327b7958$var$_arrayLikeToArray(arr);
}
function $ddca06a7327b7958$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ddca06a7327b7958$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ddca06a7327b7958$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ddca06a7327b7958$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ddca06a7327b7958$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ddca06a7327b7958$var$_defineProperty(obj, key, value) {
    key = $ddca06a7327b7958$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ddca06a7327b7958$var$_toPropertyKey(arg) {
    var key = $ddca06a7327b7958$var$_toPrimitive(arg, "string");
    return $ddca06a7327b7958$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ddca06a7327b7958$var$_toPrimitive(input, hint) {
    if ($ddca06a7327b7958$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ddca06a7327b7958$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ddca06a7327b7958$var$_slicedToArray(arr, i) {
    return $ddca06a7327b7958$var$_arrayWithHoles(arr) || $ddca06a7327b7958$var$_iterableToArrayLimit(arr, i) || $ddca06a7327b7958$var$_unsupportedIterableToArray(arr, i) || $ddca06a7327b7958$var$_nonIterableRest();
}
function $ddca06a7327b7958$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ddca06a7327b7958$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ddca06a7327b7958$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ddca06a7327b7958$var$_arrayLikeToArray(o, minLen);
}
function $ddca06a7327b7958$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ddca06a7327b7958$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $ddca06a7327b7958$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ddca06a7327b7958$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $ddca06a7327b7958$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $ddca06a7327b7958$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $52c62b34c1505cbc$export$d6051a0f7a227332)(function(key, val) {
        if ($ddca06a7327b7958$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $ddca06a7327b7958$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $52c62b34c1505cbc$export$d6051a0f7a227332)(function(key, val) {
        if ($ddca06a7327b7958$var$needContinue(val)) return $ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, val), {}, {
            velocity: $ddca06a7327b7958$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $ddca06a7327b7958$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$ddca06a7327b7958$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $52c62b34c1505cbc$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, res), {}, $ddca06a7327b7958$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, res), {}, $ddca06a7327b7958$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $52c62b34c1505cbc$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($ddca06a7327b7958$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $ddca06a7327b7958$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $52c62b34c1505cbc$export$d6051a0f7a227332)(function(key, val) {
            return $ddca06a7327b7958$var$alpha.apply(void 0, $ddca06a7327b7958$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $52c62b34c1505cbc$export$d6051a0f7a227332)(function(key, val) {
                return $ddca06a7327b7958$var$alpha.apply(void 0, $ddca06a7327b7958$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread($ddca06a7327b7958$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $1ad3405a492af268$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1ad3405a492af268$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1ad3405a492af268$var$_typeof(obj);
}
var $1ad3405a492af268$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $1ad3405a492af268$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1ad3405a492af268$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1ad3405a492af268$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1ad3405a492af268$var$_toConsumableArray(arr) {
    return $1ad3405a492af268$var$_arrayWithoutHoles(arr) || $1ad3405a492af268$var$_iterableToArray(arr) || $1ad3405a492af268$var$_unsupportedIterableToArray(arr) || $1ad3405a492af268$var$_nonIterableSpread();
}
function $1ad3405a492af268$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1ad3405a492af268$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1ad3405a492af268$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1ad3405a492af268$var$_arrayLikeToArray(o, minLen);
}
function $1ad3405a492af268$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1ad3405a492af268$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1ad3405a492af268$var$_arrayLikeToArray(arr);
}
function $1ad3405a492af268$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1ad3405a492af268$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1ad3405a492af268$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1ad3405a492af268$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1ad3405a492af268$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1ad3405a492af268$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1ad3405a492af268$var$_defineProperty(obj, key, value) {
    key = $1ad3405a492af268$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1ad3405a492af268$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1ad3405a492af268$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1ad3405a492af268$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1ad3405a492af268$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1ad3405a492af268$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1ad3405a492af268$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1ad3405a492af268$var$_toPropertyKey(arg) {
    var key = $1ad3405a492af268$var$_toPrimitive(arg, "string");
    return $1ad3405a492af268$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1ad3405a492af268$var$_toPrimitive(input, hint) {
    if ($1ad3405a492af268$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1ad3405a492af268$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1ad3405a492af268$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1ad3405a492af268$var$_setPrototypeOf(subClass, superClass);
}
function $1ad3405a492af268$var$_setPrototypeOf(o, p) {
    $1ad3405a492af268$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1ad3405a492af268$var$_setPrototypeOf(o, p);
}
function $1ad3405a492af268$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1ad3405a492af268$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1ad3405a492af268$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1ad3405a492af268$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1ad3405a492af268$var$_possibleConstructorReturn(this, result);
    };
}
function $1ad3405a492af268$var$_possibleConstructorReturn(self, call) {
    if (call && ($1ad3405a492af268$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1ad3405a492af268$var$_assertThisInitialized(self);
}
function $1ad3405a492af268$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1ad3405a492af268$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1ad3405a492af268$var$_getPrototypeOf(o) {
    $1ad3405a492af268$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1ad3405a492af268$var$_getPrototypeOf(o);
}
var $1ad3405a492af268$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $1ad3405a492af268$var$_inherits(Animate, _PureComponent);
    var _super = $1ad3405a492af268$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $1ad3405a492af268$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($1ad3405a492af268$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($1ad3405a492af268$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $1ad3405a492af268$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $1ad3405a492af268$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $1ad3405a492af268$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $1ad3405a492af268$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $1ad3405a492af268$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $f4b8325724dd2d83$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $1ad3405a492af268$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && [
                        attributeName
                    ] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $ddca06a7327b7958$export$2e2bcd8739ae039)(from, to, (0, $ae4b24d7c3606c08$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($1ad3405a492af268$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $52c62b34c1505cbc$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($1ad3405a492af268$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $52c62b34c1505cbc$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($1ad3405a492af268$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $505b94837c7b52de$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $1ad3405a492af268$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $52c62b34c1505cbc$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $1ad3405a492af268$var$_objectWithoutProperties(_this$props4, $1ad3405a492af268$var$_excluded);
                var count = (0, $9KJkx.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = (0, $52c62b34c1505cbc$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $9KJkx.cloneElement)(container, $1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread({}, others), {}, {
                        style: $1ad3405a492af268$var$_objectSpread($1ad3405a492af268$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $9KJkx.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", null, (0, $9KJkx.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $9KJkx.PureComponent));
$1ad3405a492af268$var$Animate.displayName = "Animate";
$1ad3405a492af268$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$1ad3405a492af268$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).func
};
var $1ad3405a492af268$export$2e2bcd8739ae039 = $1ad3405a492af268$var$Animate;





var $9KJkx = parcelRequire("9KJkx");
var $15c106ae6fe7159a$exports = {};
"use strict";

var $15c106ae6fe7159a$var$_CSSTransition = $15c106ae6fe7159a$var$_interopRequireDefault((parcelRequire("4e8ah")));

var $15c106ae6fe7159a$var$_ReplaceTransition = $15c106ae6fe7159a$var$_interopRequireDefault((parcelRequire("i0Zus")));

var $15c106ae6fe7159a$var$_TransitionGroup = $15c106ae6fe7159a$var$_interopRequireDefault((parcelRequire("iAsDd")));

var $15c106ae6fe7159a$var$_Transition = $15c106ae6fe7159a$var$_interopRequireDefault((parcelRequire("dj5i3")));
function $15c106ae6fe7159a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$15c106ae6fe7159a$exports = {
    Transition: $15c106ae6fe7159a$var$_Transition.default,
    TransitionGroup: $15c106ae6fe7159a$var$_TransitionGroup.default,
    ReplaceTransition: $15c106ae6fe7159a$var$_ReplaceTransition.default,
    CSSTransition: $15c106ae6fe7159a$var$_CSSTransition.default
};



var $3P0iH = parcelRequire("3P0iH");

var $9KJkx = parcelRequire("9KJkx");


var $3P0iH = parcelRequire("3P0iH");

var $387147477c1122ec$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $387147477c1122ec$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $387147477c1122ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $387147477c1122ec$var$_typeof(obj);
}
function $387147477c1122ec$var$_extends() {
    $387147477c1122ec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $387147477c1122ec$var$_extends.apply(this, arguments);
}
function $387147477c1122ec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $387147477c1122ec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $387147477c1122ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $387147477c1122ec$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $387147477c1122ec$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $387147477c1122ec$var$ownKeys(Object(source), !0).forEach(function(key) {
            $387147477c1122ec$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $387147477c1122ec$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $387147477c1122ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $387147477c1122ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $387147477c1122ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $387147477c1122ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $387147477c1122ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $387147477c1122ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $387147477c1122ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $387147477c1122ec$var$_setPrototypeOf(subClass, superClass);
}
function $387147477c1122ec$var$_setPrototypeOf(o, p) {
    $387147477c1122ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $387147477c1122ec$var$_setPrototypeOf(o, p);
}
function $387147477c1122ec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $387147477c1122ec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $387147477c1122ec$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $387147477c1122ec$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $387147477c1122ec$var$_possibleConstructorReturn(this, result);
    };
}
function $387147477c1122ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($387147477c1122ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $387147477c1122ec$var$_assertThisInitialized(self);
}
function $387147477c1122ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $387147477c1122ec$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $387147477c1122ec$var$_getPrototypeOf(o) {
    $387147477c1122ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $387147477c1122ec$var$_getPrototypeOf(o);
}
function $387147477c1122ec$var$_defineProperty(obj, key, value) {
    key = $387147477c1122ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $387147477c1122ec$var$_toPropertyKey(arg) {
    var key = $387147477c1122ec$var$_toPrimitive(arg, "string");
    return $387147477c1122ec$var$_typeof(key) === "symbol" ? key : String(key);
}
function $387147477c1122ec$var$_toPrimitive(input, hint) {
    if ($387147477c1122ec$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($387147477c1122ec$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $387147477c1122ec$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $387147477c1122ec$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $387147477c1122ec$var$_inherits(AnimateGroupChild, _Component);
    var _super = $387147477c1122ec$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $387147477c1122ec$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $387147477c1122ec$var$_defineProperty($387147477c1122ec$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $387147477c1122ec$var$_defineProperty($387147477c1122ec$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $387147477c1122ec$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($387147477c1122ec$var$_objectSpread($387147477c1122ec$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $387147477c1122ec$var$parseDurationOfSingleTransition(appearOptions) + $387147477c1122ec$var$parseDurationOfSingleTransition(enterOptions) + $387147477c1122ec$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $387147477c1122ec$var$_objectWithoutProperties(_this$props3, $387147477c1122ec$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $15c106ae6fe7159a$exports.Transition), $387147477c1122ec$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $1ad3405a492af268$export$2e2bcd8739ae039), _this2.state, (0, $9KJkx.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $9KJkx.Component));
$387147477c1122ec$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).element
};
var $387147477c1122ec$export$2e2bcd8739ae039 = $387147477c1122ec$var$AnimateGroupChild;


function $a6190e4fbdb4f341$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $15c106ae6fe7159a$exports.TransitionGroup), {
        component: component
    }, (0, $9KJkx.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $387147477c1122ec$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$a6190e4fbdb4f341$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($3P0iH))).any
};
$a6190e4fbdb4f341$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $a6190e4fbdb4f341$export$2e2bcd8739ae039 = $a6190e4fbdb4f341$var$AnimateGroup;


var $f2edb043998c1672$export$2e2bcd8739ae039 = (0, $1ad3405a492af268$export$2e2bcd8739ae039);






/**
 * @fileOverview Cross
 */ var $40c6ca5300496387$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$40c6ca5300496387$export$f6f0c3fe4ec306ea.displayName = "Cell";



var $9KJkx = parcelRequire("9KJkx");



var $8b9e457f302bb1f6$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $8b9e457f302bb1f6$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$8b9e457f302bb1f6$exports = $8b9e457f302bb1f6$var$last;



var $9KJkx = parcelRequire("9KJkx");





var $9KJkx = parcelRequire("9KJkx");






function $d13cfe69f1cf6fb1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d13cfe69f1cf6fb1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d13cfe69f1cf6fb1$var$_typeof(o);
}
function $d13cfe69f1cf6fb1$var$_slicedToArray(arr, i) {
    return $d13cfe69f1cf6fb1$var$_arrayWithHoles(arr) || $d13cfe69f1cf6fb1$var$_iterableToArrayLimit(arr, i) || $d13cfe69f1cf6fb1$var$_unsupportedIterableToArray(arr, i) || $d13cfe69f1cf6fb1$var$_nonIterableRest();
}
function $d13cfe69f1cf6fb1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d13cfe69f1cf6fb1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d13cfe69f1cf6fb1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d13cfe69f1cf6fb1$var$_arrayLikeToArray(o, minLen);
}
function $d13cfe69f1cf6fb1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d13cfe69f1cf6fb1$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d13cfe69f1cf6fb1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d13cfe69f1cf6fb1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d13cfe69f1cf6fb1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d13cfe69f1cf6fb1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d13cfe69f1cf6fb1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d13cfe69f1cf6fb1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d13cfe69f1cf6fb1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d13cfe69f1cf6fb1$var$_toPropertyKey(arg) {
    var key = $d13cfe69f1cf6fb1$var$_toPrimitive(arg, "string");
    return $d13cfe69f1cf6fb1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d13cfe69f1cf6fb1$var$_toPrimitive(input, hint) {
    if ($d13cfe69f1cf6fb1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d13cfe69f1cf6fb1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d13cfe69f1cf6fb1$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $d13cfe69f1cf6fb1$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $d13cfe69f1cf6fb1$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $d13cfe69f1cf6fb1$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $d13cfe69f1cf6fb1$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $d13cfe69f1cf6fb1$var$FIXED_CSS_LENGTH_UNITS = Object.keys($d13cfe69f1cf6fb1$var$CONVERSION_RATES);
var $d13cfe69f1cf6fb1$var$STR_NAN = "NaN";
function $d13cfe69f1cf6fb1$var$convertToPx(value, unit) {
    return value * $d13cfe69f1cf6fb1$var$CONVERSION_RATES[unit];
}
var $d13cfe69f1cf6fb1$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $d13cfe69f1cf6fb1$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !$d13cfe69f1cf6fb1$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if ($d13cfe69f1cf6fb1$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $d13cfe69f1cf6fb1$var$convertToPx(num, unit);
            this.unit = "px";
        }
    }
    $d13cfe69f1cf6fb1$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $d13cfe69f1cf6fb1$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $d13cfe69f1cf6fb1$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
    return DecimalCSS;
}();
function $d13cfe69f1cf6fb1$var$calculateArithmetic(expr) {
    if (expr.includes($d13cfe69f1cf6fb1$var$STR_NAN)) return $d13cfe69f1cf6fb1$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $d13cfe69f1cf6fb1$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $d13cfe69f1cf6fb1$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $d13cfe69f1cf6fb1$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = $d13cfe69f1cf6fb1$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $d13cfe69f1cf6fb1$var$STR_NAN;
        newExpr = newExpr.replace($d13cfe69f1cf6fb1$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $d13cfe69f1cf6fb1$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $d13cfe69f1cf6fb1$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $d13cfe69f1cf6fb1$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = $d13cfe69f1cf6fb1$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $d13cfe69f1cf6fb1$var$STR_NAN;
        newExpr = newExpr.replace($d13cfe69f1cf6fb1$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $d13cfe69f1cf6fb1$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $d13cfe69f1cf6fb1$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = $d13cfe69f1cf6fb1$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $d13cfe69f1cf6fb1$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($d13cfe69f1cf6fb1$var$PARENTHESES_REGEX, $d13cfe69f1cf6fb1$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $d13cfe69f1cf6fb1$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = $d13cfe69f1cf6fb1$var$calculateParentheses(newExpr);
    newExpr = $d13cfe69f1cf6fb1$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $d13cfe69f1cf6fb1$export$c891f73c9c6d00c9(expression) {
    try {
        return $d13cfe69f1cf6fb1$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $d13cfe69f1cf6fb1$var$STR_NAN;
    }
}
function $d13cfe69f1cf6fb1$export$254eac204f89fd7d(expression) {
    var result = $d13cfe69f1cf6fb1$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $d13cfe69f1cf6fb1$var$STR_NAN) // notify the user
    return "";
    return result;
}


var $b0a47abc2c07d3b6$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $b0a47abc2c07d3b6$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $b0a47abc2c07d3b6$var$_extends() {
    $b0a47abc2c07d3b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0a47abc2c07d3b6$var$_extends.apply(this, arguments);
}
function $b0a47abc2c07d3b6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b0a47abc2c07d3b6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b0a47abc2c07d3b6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b0a47abc2c07d3b6$var$_slicedToArray(arr, i) {
    return $b0a47abc2c07d3b6$var$_arrayWithHoles(arr) || $b0a47abc2c07d3b6$var$_iterableToArrayLimit(arr, i) || $b0a47abc2c07d3b6$var$_unsupportedIterableToArray(arr, i) || $b0a47abc2c07d3b6$var$_nonIterableRest();
}
function $b0a47abc2c07d3b6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b0a47abc2c07d3b6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b0a47abc2c07d3b6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b0a47abc2c07d3b6$var$_arrayLikeToArray(o, minLen);
}
function $b0a47abc2c07d3b6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b0a47abc2c07d3b6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b0a47abc2c07d3b6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $b0a47abc2c07d3b6$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $b0a47abc2c07d3b6$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($b0a47abc2c07d3b6$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $dc248c2135213327$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $dc248c2135213327$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $b0a47abc2c07d3b6$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $3c48a89ca795c151$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "…";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $b0a47abc2c07d3b6$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $b0a47abc2c07d3b6$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $b0a47abc2c07d3b6$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $b0a47abc2c07d3b6$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(children) ? children.toString().split($b0a47abc2c07d3b6$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $b0a47abc2c07d3b6$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $b0a47abc2c07d3b6$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $b0a47abc2c07d3b6$var$getWordsWithoutCalculate(children);
        return $b0a47abc2c07d3b6$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $b0a47abc2c07d3b6$var$getWordsWithoutCalculate(children);
};
var $b0a47abc2c07d3b6$var$DEFAULT_FILL = "#808080";
var $b0a47abc2c07d3b6$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $b0a47abc2c07d3b6$var$DEFAULT_FILL : _ref5$fill, props = $b0a47abc2c07d3b6$var$_objectWithoutProperties(_ref5, $b0a47abc2c07d3b6$var$_excluded);
    var wordsByLines = (0, $9KJkx.useMemo)(function() {
        return $b0a47abc2c07d3b6$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $b0a47abc2c07d3b6$var$_objectWithoutProperties(props, $b0a47abc2c07d3b6$var$_excluded2);
    if (!(0, $3c48a89ca795c151$export$402a499e1ea44294)(propsX) || !(0, $3c48a89ca795c151$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, $d13cfe69f1cf6fb1$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, $d13cfe69f1cf6fb1$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $d13cfe69f1cf6fb1$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("text", $b0a47abc2c07d3b6$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? $b0a47abc2c07d3b6$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
        }, line.words.join(breakAll ? "" : " ")));
    }));
};





function $6195d75aa460b7f0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6195d75aa460b7f0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6195d75aa460b7f0$var$_typeof(o);
}
var $6195d75aa460b7f0$var$_excluded = [
    "offset"
];
function $6195d75aa460b7f0$var$_toConsumableArray(arr) {
    return $6195d75aa460b7f0$var$_arrayWithoutHoles(arr) || $6195d75aa460b7f0$var$_iterableToArray(arr) || $6195d75aa460b7f0$var$_unsupportedIterableToArray(arr) || $6195d75aa460b7f0$var$_nonIterableSpread();
}
function $6195d75aa460b7f0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6195d75aa460b7f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6195d75aa460b7f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6195d75aa460b7f0$var$_arrayLikeToArray(o, minLen);
}
function $6195d75aa460b7f0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6195d75aa460b7f0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6195d75aa460b7f0$var$_arrayLikeToArray(arr);
}
function $6195d75aa460b7f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6195d75aa460b7f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6195d75aa460b7f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6195d75aa460b7f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6195d75aa460b7f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6195d75aa460b7f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6195d75aa460b7f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6195d75aa460b7f0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6195d75aa460b7f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6195d75aa460b7f0$var$_defineProperty(obj, key, value) {
    key = $6195d75aa460b7f0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6195d75aa460b7f0$var$_toPropertyKey(arg) {
    var key = $6195d75aa460b7f0$var$_toPrimitive(arg, "string");
    return $6195d75aa460b7f0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6195d75aa460b7f0$var$_toPrimitive(input, hint) {
    if ($6195d75aa460b7f0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6195d75aa460b7f0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6195d75aa460b7f0$var$_extends() {
    $6195d75aa460b7f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6195d75aa460b7f0$var$_extends.apply(this, arguments);
}
var $6195d75aa460b7f0$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(formatter)) return formatter(label);
    return label;
};
var $6195d75aa460b7f0$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3c48a89ca795c151$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $6195d75aa460b7f0$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $6195d75aa460b7f0$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(labelProps.id) ? (0, $3c48a89ca795c151$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("text", $6195d75aa460b7f0$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $6195d75aa460b7f0$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $6195d75aa460b7f0$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $6195d75aa460b7f0$var$_objectSpread($6195d75aa460b7f0$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $6195d75aa460b7f0$var$_objectSpread($6195d75aa460b7f0$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $6195d75aa460b7f0$var$_objectSpread($6195d75aa460b7f0$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $6195d75aa460b7f0$var$_objectSpread($6195d75aa460b7f0$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(position) && ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(position.x) || (0, $3c48a89ca795c151$export$e50269385c77c348)(position.x)) && ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(position.y) || (0, $3c48a89ca795c151$export$e50269385c77c348)(position.y))) return $6195d75aa460b7f0$var$_objectSpread({
        x: x + (0, $3c48a89ca795c151$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $3c48a89ca795c151$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $6195d75aa460b7f0$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $6195d75aa460b7f0$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(viewBox.cx);
};
function $6195d75aa460b7f0$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $6195d75aa460b7f0$var$_objectWithoutProperties(_ref4, $6195d75aa460b7f0$var$_excluded);
    var props = $6195d75aa460b7f0$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(children) && !/*#__PURE__*/ (0, $9KJkx.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(content)) return /*#__PURE__*/ (0, $9KJkx.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(content)) {
        label = /*#__PURE__*/ (0, $9KJkx.createElement)(content, props);
        if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(label)) return label;
    } else label = $6195d75aa460b7f0$var$getLabel(props);
    var isPolarLabel = $6195d75aa460b7f0$var$isPolar(viewBox);
    var attrs = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $6195d75aa460b7f0$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $6195d75aa460b7f0$var$getAttrsOfPolarLabel(props) : $6195d75aa460b7f0$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b0a47abc2c07d3b6$export$5f1af8db9871e1d6), $6195d75aa460b7f0$var$_extends({
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$6195d75aa460b7f0$export$b04be29aa201d4f5.displayName = "Label";
var $6195d75aa460b7f0$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(height)) {
        if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(x) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(top) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(x) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(cx) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $6195d75aa460b7f0$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($6195d75aa460b7f0$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $3c48a89ca795c151$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($6195d75aa460b7f0$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(label)) {
        if (label.type === $6195d75aa460b7f0$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $9KJkx.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($6195d75aa460b7f0$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($6195d75aa460b7f0$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($6195d75aa460b7f0$export$b04be29aa201d4f5, $6195d75aa460b7f0$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $6195d75aa460b7f0$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $6195d75aa460b7f0$var$parseViewBox(parentProps);
    var explicitChildren = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, $6195d75aa460b7f0$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $9KJkx.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $6195d75aa460b7f0$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($6195d75aa460b7f0$var$_toConsumableArray(explicitChildren));
};
$6195d75aa460b7f0$export$b04be29aa201d4f5.parseViewBox = $6195d75aa460b7f0$var$parseViewBox;
$6195d75aa460b7f0$export$b04be29aa201d4f5.renderCallByParent = $6195d75aa460b7f0$var$renderCallByParent;





function $3b2fa8e9df665478$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3b2fa8e9df665478$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3b2fa8e9df665478$var$_typeof(o);
}
var $3b2fa8e9df665478$var$_excluded = [
    "valueAccessor"
], $3b2fa8e9df665478$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $3b2fa8e9df665478$var$_toConsumableArray(arr) {
    return $3b2fa8e9df665478$var$_arrayWithoutHoles(arr) || $3b2fa8e9df665478$var$_iterableToArray(arr) || $3b2fa8e9df665478$var$_unsupportedIterableToArray(arr) || $3b2fa8e9df665478$var$_nonIterableSpread();
}
function $3b2fa8e9df665478$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3b2fa8e9df665478$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b2fa8e9df665478$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b2fa8e9df665478$var$_arrayLikeToArray(o, minLen);
}
function $3b2fa8e9df665478$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3b2fa8e9df665478$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3b2fa8e9df665478$var$_arrayLikeToArray(arr);
}
function $3b2fa8e9df665478$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3b2fa8e9df665478$var$_extends() {
    $3b2fa8e9df665478$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b2fa8e9df665478$var$_extends.apply(this, arguments);
}
function $3b2fa8e9df665478$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b2fa8e9df665478$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b2fa8e9df665478$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3b2fa8e9df665478$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b2fa8e9df665478$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3b2fa8e9df665478$var$_defineProperty(obj, key, value) {
    key = $3b2fa8e9df665478$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b2fa8e9df665478$var$_toPropertyKey(arg) {
    var key = $3b2fa8e9df665478$var$_toPrimitive(arg, "string");
    return $3b2fa8e9df665478$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3b2fa8e9df665478$var$_toPrimitive(input, hint) {
    if ($3b2fa8e9df665478$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3b2fa8e9df665478$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3b2fa8e9df665478$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b2fa8e9df665478$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b2fa8e9df665478$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3b2fa8e9df665478$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($8b9e457f302bb1f6$exports)))(entry.value) : entry.value;
};
function $3b2fa8e9df665478$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $3b2fa8e9df665478$var$defaultAccessor : _ref$valueAccessor, restProps = $3b2fa8e9df665478$var$_objectWithoutProperties(_ref, $3b2fa8e9df665478$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $3b2fa8e9df665478$var$_objectWithoutProperties(restProps, $3b2fa8e9df665478$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $6195d75aa460b7f0$export$b04be29aa201d4f5), $3b2fa8e9df665478$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $6195d75aa460b7f0$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(clockWise) ? entry : $3b2fa8e9df665478$var$_objectSpread($3b2fa8e9df665478$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$3b2fa8e9df665478$export$835fcf23ab7bf88.displayName = "LabelList";
function $3b2fa8e9df665478$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($3b2fa8e9df665478$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($3b2fa8e9df665478$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dba4143ccd45ffc1$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($3b2fa8e9df665478$export$835fcf23ab7bf88, $3b2fa8e9df665478$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $3b2fa8e9df665478$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, $3b2fa8e9df665478$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $9KJkx.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $3b2fa8e9df665478$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($3b2fa8e9df665478$var$_toConsumableArray(explicitChildren));
}
$3b2fa8e9df665478$export$835fcf23ab7bf88.renderCallByParent = $3b2fa8e9df665478$var$renderCallByParent;








var $9KJkx = parcelRequire("9KJkx");

var $9KJkx = parcelRequire("9KJkx");

var $92fc475fbdf5fd47$exports = {};

var $22439d0ebf2e38fc$exports = {};

/** Built-in value references. */ var $22439d0ebf2e38fc$var$getPrototype = $08cb3ad02025adaa$exports(Object.getPrototypeOf, Object);
$22439d0ebf2e38fc$exports = $22439d0ebf2e38fc$var$getPrototype;



/** `Object#toString` result references. */ var $92fc475fbdf5fd47$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $92fc475fbdf5fd47$var$funcProto = Function.prototype, $92fc475fbdf5fd47$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $92fc475fbdf5fd47$var$funcToString = $92fc475fbdf5fd47$var$funcProto.toString;
/** Used to check objects for own properties. */ var $92fc475fbdf5fd47$var$hasOwnProperty = $92fc475fbdf5fd47$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $92fc475fbdf5fd47$var$objectCtorString = $92fc475fbdf5fd47$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $92fc475fbdf5fd47$var$isPlainObject(value) {
    if (!$2ea446141c31cf3d$exports(value) || $e5640db8046fdbb6$exports(value) != $92fc475fbdf5fd47$var$objectTag) return false;
    var proto = $22439d0ebf2e38fc$exports(value);
    if (proto === null) return true;
    var Ctor = $92fc475fbdf5fd47$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $92fc475fbdf5fd47$var$funcToString.call(Ctor) == $92fc475fbdf5fd47$var$objectCtorString;
}
$92fc475fbdf5fd47$exports = $92fc475fbdf5fd47$var$isPlainObject;


var $c818bea3fad872ee$exports = {};


/** `Object#toString` result references. */ var $c818bea3fad872ee$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $c818bea3fad872ee$var$isBoolean(value) {
    return value === true || value === false || $2ea446141c31cf3d$exports(value) && $e5640db8046fdbb6$exports(value) == $c818bea3fad872ee$var$boolTag;
}
$c818bea3fad872ee$exports = $c818bea3fad872ee$var$isBoolean;




var $9KJkx = parcelRequire("9KJkx");



function $c0dd9af3b0375cc0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0dd9af3b0375cc0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0dd9af3b0375cc0$var$_typeof(o);
}
function $c0dd9af3b0375cc0$var$_extends() {
    $c0dd9af3b0375cc0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0dd9af3b0375cc0$var$_extends.apply(this, arguments);
}
function $c0dd9af3b0375cc0$var$_slicedToArray(arr, i) {
    return $c0dd9af3b0375cc0$var$_arrayWithHoles(arr) || $c0dd9af3b0375cc0$var$_iterableToArrayLimit(arr, i) || $c0dd9af3b0375cc0$var$_unsupportedIterableToArray(arr, i) || $c0dd9af3b0375cc0$var$_nonIterableRest();
}
function $c0dd9af3b0375cc0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0dd9af3b0375cc0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c0dd9af3b0375cc0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c0dd9af3b0375cc0$var$_arrayLikeToArray(o, minLen);
}
function $c0dd9af3b0375cc0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c0dd9af3b0375cc0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c0dd9af3b0375cc0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c0dd9af3b0375cc0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0dd9af3b0375cc0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0dd9af3b0375cc0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0dd9af3b0375cc0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0dd9af3b0375cc0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0dd9af3b0375cc0$var$_defineProperty(obj, key, value) {
    key = $c0dd9af3b0375cc0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0dd9af3b0375cc0$var$_toPropertyKey(arg) {
    var key = $c0dd9af3b0375cc0$var$_toPrimitive(arg, "string");
    return $c0dd9af3b0375cc0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c0dd9af3b0375cc0$var$_toPrimitive(input, hint) {
    if ($c0dd9af3b0375cc0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c0dd9af3b0375cc0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $c0dd9af3b0375cc0$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $c0dd9af3b0375cc0$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $c0dd9af3b0375cc0$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $c0dd9af3b0375cc0$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $c0dd9af3b0375cc0$var$_objectSpread($c0dd9af3b0375cc0$var$_objectSpread({}, $c0dd9af3b0375cc0$var$defaultProps), rectangleProps);
    var pathRef = (0, $9KJkx.useRef)();
    var _useState = (0, $9KJkx.useState)(-1), _useState2 = $c0dd9af3b0375cc0$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $9KJkx.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $c0dd9af3b0375cc0$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $c0dd9af3b0375cc0$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $c0dd9af3b0375cc0$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $c0dd9af3b0375cc0$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $9KJkx = parcelRequire("9KJkx");



function $2464539841a4a279$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2464539841a4a279$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2464539841a4a279$var$_typeof(o);
}
function $2464539841a4a279$var$_extends() {
    $2464539841a4a279$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2464539841a4a279$var$_extends.apply(this, arguments);
}
function $2464539841a4a279$var$_slicedToArray(arr, i) {
    return $2464539841a4a279$var$_arrayWithHoles(arr) || $2464539841a4a279$var$_iterableToArrayLimit(arr, i) || $2464539841a4a279$var$_unsupportedIterableToArray(arr, i) || $2464539841a4a279$var$_nonIterableRest();
}
function $2464539841a4a279$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2464539841a4a279$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2464539841a4a279$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2464539841a4a279$var$_arrayLikeToArray(o, minLen);
}
function $2464539841a4a279$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2464539841a4a279$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2464539841a4a279$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2464539841a4a279$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2464539841a4a279$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2464539841a4a279$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2464539841a4a279$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2464539841a4a279$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2464539841a4a279$var$_defineProperty(obj, key, value) {
    key = $2464539841a4a279$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2464539841a4a279$var$_toPropertyKey(arg) {
    var key = $2464539841a4a279$var$_toPrimitive(arg, "string");
    return $2464539841a4a279$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2464539841a4a279$var$_toPrimitive(input, hint) {
    if ($2464539841a4a279$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2464539841a4a279$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2464539841a4a279$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $2464539841a4a279$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $2464539841a4a279$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $2464539841a4a279$var$_objectSpread($2464539841a4a279$var$_objectSpread({}, $2464539841a4a279$var$defaultProps), props);
    var pathRef = (0, $9KJkx.useRef)();
    var _useState = (0, $9KJkx.useState)(-1), _useState2 = $2464539841a4a279$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $9KJkx.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $2464539841a4a279$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $2464539841a4a279$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $2464539841a4a279$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $2464539841a4a279$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $9KJkx = parcelRequire("9KJkx");




function $e6ec9c4619bf0f62$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e6ec9c4619bf0f62$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6ec9c4619bf0f62$var$_typeof(o);
}
function $e6ec9c4619bf0f62$var$_extends() {
    $e6ec9c4619bf0f62$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6ec9c4619bf0f62$var$_extends.apply(this, arguments);
}
function $e6ec9c4619bf0f62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6ec9c4619bf0f62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6ec9c4619bf0f62$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e6ec9c4619bf0f62$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6ec9c4619bf0f62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e6ec9c4619bf0f62$var$_defineProperty(obj, key, value) {
    key = $e6ec9c4619bf0f62$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e6ec9c4619bf0f62$var$_toPropertyKey(arg) {
    var key = $e6ec9c4619bf0f62$var$_toPrimitive(arg, "string");
    return $e6ec9c4619bf0f62$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e6ec9c4619bf0f62$var$_toPrimitive(input, hint) {
    if ($e6ec9c4619bf0f62$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e6ec9c4619bf0f62$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e6ec9c4619bf0f62$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3c48a89ca795c151$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $e6ec9c4619bf0f62$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $98248a286e872525$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $98248a286e872525$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $e6ec9c4619bf0f62$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $e6ec9c4619bf0f62$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $e6ec9c4619bf0f62$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $3c48a89ca795c151$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $e6ec9c4619bf0f62$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $e6ec9c4619bf0f62$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $e6ec9c4619bf0f62$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $e6ec9c4619bf0f62$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $e6ec9c4619bf0f62$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $e6ec9c4619bf0f62$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $e6ec9c4619bf0f62$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $e6ec9c4619bf0f62$var$_objectSpread($e6ec9c4619bf0f62$var$_objectSpread({}, $e6ec9c4619bf0f62$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $e6ec9c4619bf0f62$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $e6ec9c4619bf0f62$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $e6ec9c4619bf0f62$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $91ce6a0bf35cea97$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $91ce6a0bf35cea97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $91ce6a0bf35cea97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $91ce6a0bf35cea97$var$_typeof(o);
}
function $91ce6a0bf35cea97$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $91ce6a0bf35cea97$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $91ce6a0bf35cea97$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $91ce6a0bf35cea97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91ce6a0bf35cea97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91ce6a0bf35cea97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $91ce6a0bf35cea97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91ce6a0bf35cea97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91ce6a0bf35cea97$var$_defineProperty(obj, key, value) {
    key = $91ce6a0bf35cea97$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91ce6a0bf35cea97$var$_toPropertyKey(arg) {
    var key = $91ce6a0bf35cea97$var$_toPrimitive(arg, "string");
    return $91ce6a0bf35cea97$var$_typeof(key) === "symbol" ? key : String(key);
}
function $91ce6a0bf35cea97$var$_toPrimitive(input, hint) {
    if ($91ce6a0bf35cea97$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($91ce6a0bf35cea97$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $91ce6a0bf35cea97$var$defaultPropTransformer(option, props) {
    return $91ce6a0bf35cea97$var$_objectSpread($91ce6a0bf35cea97$var$_objectSpread({}, props), option);
}
function $91ce6a0bf35cea97$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function $91ce6a0bf35cea97$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $c0dd9af3b0375cc0$export$4617fb02663045ef), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $2464539841a4a279$export$d1ed33dc592f5337), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $e6ec9c4619bf0f62$export$e98c2c7eb2b14f45), elementProps);
        case "symbols":
            if ($91ce6a0bf35cea97$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $01d4c0b8afeeb8c1$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $91ce6a0bf35cea97$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(option)) return option.props;
    return option;
}
function $91ce6a0bf35cea97$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $91ce6a0bf35cea97$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = $91ce6a0bf35cea97$var$_objectWithoutProperties(_ref2, $91ce6a0bf35cea97$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(option)) shape = /*#__PURE__*/ (0, $9KJkx.cloneElement)(option, $91ce6a0bf35cea97$var$_objectSpread($91ce6a0bf35cea97$var$_objectSpread({}, props), $91ce6a0bf35cea97$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($92fc475fbdf5fd47$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($c818bea3fad872ee$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($91ce6a0bf35cea97$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement($91ce6a0bf35cea97$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $91ce6a0bf35cea97$export$4b83e8415af38a18(graphicalItem, _item) {
    return "trapezoids" in graphicalItem.props;
}
function $91ce6a0bf35cea97$export$f722d7e63cc07b(graphicalItem, _item) {
    return "sectors" in graphicalItem.props;
}
function $91ce6a0bf35cea97$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return "points" in graphicalItem.props;
}
function $91ce6a0bf35cea97$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $91ce6a0bf35cea97$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $91ce6a0bf35cea97$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $91ce6a0bf35cea97$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($91ce6a0bf35cea97$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $91ce6a0bf35cea97$export$7c9a98b3f068686f;
    else if ($91ce6a0bf35cea97$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $91ce6a0bf35cea97$export$b356b51e8337a02f;
    else if ($91ce6a0bf35cea97$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $91ce6a0bf35cea97$export$559c3a78b4889350;
    return comparison;
}
function $91ce6a0bf35cea97$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($91ce6a0bf35cea97$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if ($91ce6a0bf35cea97$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = "sectors";
    else if ($91ce6a0bf35cea97$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function $91ce6a0bf35cea97$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($91ce6a0bf35cea97$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($91ce6a0bf35cea97$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($91ce6a0bf35cea97$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $91ce6a0bf35cea97$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $91ce6a0bf35cea97$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $91ce6a0bf35cea97$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($6cf74f74207fce54$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $91ce6a0bf35cea97$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


function $93a172fb5ea8fe54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $93a172fb5ea8fe54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $93a172fb5ea8fe54$var$_typeof(o);
}
var $93a172fb5ea8fe54$var$_excluded = [
    "x",
    "y"
];
function $93a172fb5ea8fe54$var$_extends() {
    $93a172fb5ea8fe54$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93a172fb5ea8fe54$var$_extends.apply(this, arguments);
}
function $93a172fb5ea8fe54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93a172fb5ea8fe54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93a172fb5ea8fe54$var$ownKeys(Object(t), !0).forEach(function(r) {
            $93a172fb5ea8fe54$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93a172fb5ea8fe54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $93a172fb5ea8fe54$var$_defineProperty(obj, key, value) {
    key = $93a172fb5ea8fe54$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93a172fb5ea8fe54$var$_toPropertyKey(arg) {
    var key = $93a172fb5ea8fe54$var$_toPrimitive(arg, "string");
    return $93a172fb5ea8fe54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $93a172fb5ea8fe54$var$_toPrimitive(input, hint) {
    if ($93a172fb5ea8fe54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($93a172fb5ea8fe54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $93a172fb5ea8fe54$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $93a172fb5ea8fe54$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $93a172fb5ea8fe54$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, numbe, number, number]
function $93a172fb5ea8fe54$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $93a172fb5ea8fe54$var$_objectWithoutProperties(_ref, $93a172fb5ea8fe54$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $93a172fb5ea8fe54$var$_objectSpread($93a172fb5ea8fe54$var$_objectSpread($93a172fb5ea8fe54$var$_objectSpread($93a172fb5ea8fe54$var$_objectSpread($93a172fb5ea8fe54$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $93a172fb5ea8fe54$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $91ce6a0bf35cea97$export$6428a7f2611ef1fa), $93a172fb5ea8fe54$var$_extends({
        shapeType: "rectangle",
        propTransformer: $93a172fb5ea8fe54$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}


var $e0ba214202464c16$var$_excluded = [
    "value",
    "background"
];
function $e0ba214202464c16$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e0ba214202464c16$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e0ba214202464c16$var$_typeof(o);
}
function $e0ba214202464c16$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e0ba214202464c16$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e0ba214202464c16$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0ba214202464c16$var$_extends() {
    $e0ba214202464c16$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0ba214202464c16$var$_extends.apply(this, arguments);
}
function $e0ba214202464c16$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e0ba214202464c16$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e0ba214202464c16$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e0ba214202464c16$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e0ba214202464c16$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e0ba214202464c16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e0ba214202464c16$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e0ba214202464c16$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e0ba214202464c16$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e0ba214202464c16$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e0ba214202464c16$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e0ba214202464c16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e0ba214202464c16$var$_setPrototypeOf(subClass, superClass);
}
function $e0ba214202464c16$var$_setPrototypeOf(o, p) {
    $e0ba214202464c16$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0ba214202464c16$var$_setPrototypeOf(o, p);
}
function $e0ba214202464c16$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e0ba214202464c16$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e0ba214202464c16$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e0ba214202464c16$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e0ba214202464c16$var$_possibleConstructorReturn(this, result);
    };
}
function $e0ba214202464c16$var$_possibleConstructorReturn(self, call) {
    if (call && ($e0ba214202464c16$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e0ba214202464c16$var$_assertThisInitialized(self);
}
function $e0ba214202464c16$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e0ba214202464c16$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e0ba214202464c16$var$_getPrototypeOf(o) {
    $e0ba214202464c16$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e0ba214202464c16$var$_getPrototypeOf(o);
}
function $e0ba214202464c16$var$_defineProperty(obj, key, value) {
    key = $e0ba214202464c16$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0ba214202464c16$var$_toPropertyKey(arg) {
    var key = $e0ba214202464c16$var$_toPrimitive(arg, "string");
    return $e0ba214202464c16$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e0ba214202464c16$var$_toPrimitive(input, hint) {
    if ($e0ba214202464c16$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e0ba214202464c16$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $e0ba214202464c16$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $e0ba214202464c16$var$_inherits(Bar, _PureComponent);
    var _super = $e0ba214202464c16$var$_createSuper(Bar);
    function Bar() {
        var _this;
        $e0ba214202464c16$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $e0ba214202464c16$var$_defineProperty($e0ba214202464c16$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $e0ba214202464c16$var$_defineProperty($e0ba214202464c16$var$_assertThisInitialized(_this), "id", (0, $3c48a89ca795c151$export$8b15d37bc3f197d4)("recharts-bar-"));
        $e0ba214202464c16$var$_defineProperty($e0ba214202464c16$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $e0ba214202464c16$var$_defineProperty($e0ba214202464c16$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $e0ba214202464c16$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), $e0ba214202464c16$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $6d098ec72682e3e0$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $93a172fb5ea8fe54$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($6cf74f74207fce54$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props.background);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $e0ba214202464c16$var$_objectWithoutProperties(entry, $e0ba214202464c16$var$_excluded);
                    if (!background) return null;
                    var props = $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $6d098ec72682e3e0$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $93a172fb5ea8fe54$export$f19074a6842f9217), $e0ba214202464c16$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $09f57e96f11ada43$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(item, {
                        key: "error-bar-".concat(i),
                        // eslint-disable-line react/no-array-index-key
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $3b2fa8e9df665478$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $9KJkx.PureComponent));
$e0ba214202464c16$var$_defineProperty($e0ba214202464c16$export$bbc6c6369b38e3d1, "displayName", "Bar");
$e0ba214202464c16$var$_defineProperty($e0ba214202464c16$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: true,
    isAnimationActive: !(0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $e0ba214202464c16$var$_defineProperty($e0ba214202464c16$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $71c7ed1f813f02c8$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSize = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $71c7ed1f813f02c8$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $40c6ca5300496387$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $71c7ed1f813f02c8$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $71c7ed1f813f02c8$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $3c48a89ca795c151$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $71c7ed1f813f02c8$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $3c48a89ca795c151$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread($e0ba214202464c16$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $71c7ed1f813f02c8$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $e0ba214202464c16$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $eb9a7968d0442930$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb9a7968d0442930$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb9a7968d0442930$var$_typeof(o);
}
function $eb9a7968d0442930$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $eb9a7968d0442930$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $eb9a7968d0442930$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $eb9a7968d0442930$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $eb9a7968d0442930$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $eb9a7968d0442930$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $eb9a7968d0442930$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb9a7968d0442930$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb9a7968d0442930$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eb9a7968d0442930$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb9a7968d0442930$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb9a7968d0442930$var$_defineProperty(obj, key, value) {
    key = $eb9a7968d0442930$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb9a7968d0442930$var$_toPropertyKey(arg) {
    var key = $eb9a7968d0442930$var$_toPrimitive(arg, "string");
    return $eb9a7968d0442930$var$_typeof(key) === "symbol" ? key : String(key);
}
function $eb9a7968d0442930$var$_toPrimitive(input, hint) {
    if ($eb9a7968d0442930$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($eb9a7968d0442930$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $eb9a7968d0442930$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $e0ba214202464c16$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $3c48a89ca795c151$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $71c7ed1f813f02c8$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $71c7ed1f813f02c8$export$9d80152e23bae434)(scale);
        var ticks = (0, $71c7ed1f813f02c8$export$ac086aaa4358d590)(scale, $eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $71c7ed1f813f02c8$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread({}, result), {}, $eb9a7968d0442930$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $eb9a7968d0442930$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $eb9a7968d0442930$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $eb9a7968d0442930$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $eb9a7968d0442930$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $eb9a7968d0442930$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $eb9a7968d0442930$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$eb9a7968d0442930$var$_defineProperty($eb9a7968d0442930$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $eb9a7968d0442930$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread({}, res), {}, $eb9a7968d0442930$var$_defineProperty({}, key, $eb9a7968d0442930$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $eb9a7968d0442930$var$_objectSpread($eb9a7968d0442930$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($59d36855b344bc89$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($d387f13f91c2d601$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $eb9a7968d0442930$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $eb9a7968d0442930$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $eb9a7968d0442930$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $ab7a0e2836c9f848$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $1e7a8af0e509da1f$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $eb9a7968d0442930$export$3ee78d51cffc2b68)(size, angle);
}
function $1e7a8af0e509da1f$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $1e7a8af0e509da1f$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $1e7a8af0e509da1f$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $ab7a0e2836c9f848$export$41514b9f058a6886)(ticks, interval + 1);
}




function $8045333c813f41ab$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $ab7a0e2836c9f848$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $1e7a8af0e509da1f$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $fb1302fd1362cb06$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fb1302fd1362cb06$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fb1302fd1362cb06$var$_typeof(o);
}
function $fb1302fd1362cb06$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb1302fd1362cb06$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb1302fd1362cb06$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fb1302fd1362cb06$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb1302fd1362cb06$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb1302fd1362cb06$var$_defineProperty(obj, key, value) {
    key = $fb1302fd1362cb06$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fb1302fd1362cb06$var$_toPropertyKey(arg) {
    var key = $fb1302fd1362cb06$var$_toPrimitive(arg, "string");
    return $fb1302fd1362cb06$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fb1302fd1362cb06$var$_toPrimitive(input, hint) {
    if ($fb1302fd1362cb06$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fb1302fd1362cb06$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fb1302fd1362cb06$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $1e7a8af0e509da1f$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $fb1302fd1362cb06$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $1e7a8af0e509da1f$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $1e7a8af0e509da1f$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $fb1302fd1362cb06$var$_objectSpread($fb1302fd1362cb06$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $fb1302fd1362cb06$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(interval) || (0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr) return (0, $1e7a8af0e509da1f$export$beeebbe3ff1b306b)(ticks, typeof interval === "number" && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, $dc248c2135213327$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, $1e7a8af0e509da1f$export$a1966f4ad955c82b)((0, $dc248c2135213327$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $dc248c2135213327$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $3c48a89ca795c151$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $1e7a8af0e509da1f$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, $8045333c813f41ab$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $fb1302fd1362cb06$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = $fb1302fd1362cb06$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}





var $9KJkx = parcelRequire("9KJkx");

var $9KJkx = parcelRequire("9KJkx");




function $6e0a49c1349cde01$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e0a49c1349cde01$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e0a49c1349cde01$var$_typeof(o);
}
function $6e0a49c1349cde01$var$_slicedToArray(arr, i) {
    return $6e0a49c1349cde01$var$_arrayWithHoles(arr) || $6e0a49c1349cde01$var$_iterableToArrayLimit(arr, i) || $6e0a49c1349cde01$var$_unsupportedIterableToArray(arr, i) || $6e0a49c1349cde01$var$_nonIterableRest();
}
function $6e0a49c1349cde01$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6e0a49c1349cde01$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6e0a49c1349cde01$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6e0a49c1349cde01$var$_arrayLikeToArray(o, minLen);
}
function $6e0a49c1349cde01$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6e0a49c1349cde01$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6e0a49c1349cde01$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6e0a49c1349cde01$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e0a49c1349cde01$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e0a49c1349cde01$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6e0a49c1349cde01$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e0a49c1349cde01$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6e0a49c1349cde01$var$_defineProperty(obj, key, value) {
    key = $6e0a49c1349cde01$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e0a49c1349cde01$var$_toPropertyKey(arg) {
    var key = $6e0a49c1349cde01$var$_toPrimitive(arg, "string");
    return $6e0a49c1349cde01$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6e0a49c1349cde01$var$_toPrimitive(input, hint) {
    if ($6e0a49c1349cde01$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6e0a49c1349cde01$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6e0a49c1349cde01$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $3c48a89ca795c151$export$402a499e1ea44294)(value[0]) && (0, $3c48a89ca795c151$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $6e0a49c1349cde01$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($0f90809c435feb4c$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $6e0a49c1349cde01$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $6e0a49c1349cde01$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $6e0a49c1349cde01$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $3c48a89ca795c151$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $3c48a89ca795c151$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $6e0a49c1349cde01$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $6e0a49c1349cde01$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", {
        className: wrapperCN,
        style: finalStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $9KJkx = parcelRequire("9KJkx");




function $264dc3974a72e641$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $264dc3974a72e641$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $264dc3974a72e641$var$_typeof(o);
}
function $264dc3974a72e641$var$_defineProperty(obj, key, value) {
    key = $264dc3974a72e641$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $264dc3974a72e641$var$_toPropertyKey(arg) {
    var key = $264dc3974a72e641$var$_toPrimitive(arg, "string");
    return $264dc3974a72e641$var$_typeof(key) === "symbol" ? key : String(key);
}
function $264dc3974a72e641$var$_toPrimitive(input, hint) {
    if ($264dc3974a72e641$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($264dc3974a72e641$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $264dc3974a72e641$var$CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var $264dc3974a72e641$var$TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function $264dc3974a72e641$export$46aee7ef09f78756(_ref) {
    var _clsx;
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $416e29c4ee421493$export$2e2bcd8739ae039)($264dc3974a72e641$var$CSS_CLASS_PREFIX, (_clsx = {}, $264dc3974a72e641$var$_defineProperty(_clsx, "".concat($264dc3974a72e641$var$CSS_CLASS_PREFIX, "-right"), (0, $3c48a89ca795c151$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $264dc3974a72e641$var$_defineProperty(_clsx, "".concat($264dc3974a72e641$var$CSS_CLASS_PREFIX, "-left"), (0, $3c48a89ca795c151$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $264dc3974a72e641$var$_defineProperty(_clsx, "".concat($264dc3974a72e641$var$CSS_CLASS_PREFIX, "-bottom"), (0, $3c48a89ca795c151$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $264dc3974a72e641$var$_defineProperty(_clsx, "".concat($264dc3974a72e641$var$CSS_CLASS_PREFIX, "-top"), (0, $3c48a89ca795c151$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _clsx));
}
function $264dc3974a72e641$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $264dc3974a72e641$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return (0, $52c62b34c1505cbc$export$ff9926a5d1daa67c)({
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    });
}
function $264dc3974a72e641$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $264dc3974a72e641$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $264dc3974a72e641$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $264dc3974a72e641$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $264dc3974a72e641$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $264dc3974a72e641$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $b8d1ec3c3aec973d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b8d1ec3c3aec973d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8d1ec3c3aec973d$var$_typeof(o);
}
function $b8d1ec3c3aec973d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8d1ec3c3aec973d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8d1ec3c3aec973d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b8d1ec3c3aec973d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8d1ec3c3aec973d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b8d1ec3c3aec973d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b8d1ec3c3aec973d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b8d1ec3c3aec973d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b8d1ec3c3aec973d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b8d1ec3c3aec973d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b8d1ec3c3aec973d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b8d1ec3c3aec973d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b8d1ec3c3aec973d$var$_setPrototypeOf(subClass, superClass);
}
function $b8d1ec3c3aec973d$var$_setPrototypeOf(o, p) {
    $b8d1ec3c3aec973d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b8d1ec3c3aec973d$var$_setPrototypeOf(o, p);
}
function $b8d1ec3c3aec973d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b8d1ec3c3aec973d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b8d1ec3c3aec973d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b8d1ec3c3aec973d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b8d1ec3c3aec973d$var$_possibleConstructorReturn(this, result);
    };
}
function $b8d1ec3c3aec973d$var$_possibleConstructorReturn(self, call) {
    if (call && ($b8d1ec3c3aec973d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b8d1ec3c3aec973d$var$_assertThisInitialized(self);
}
function $b8d1ec3c3aec973d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b8d1ec3c3aec973d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b8d1ec3c3aec973d$var$_getPrototypeOf(o) {
    $b8d1ec3c3aec973d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b8d1ec3c3aec973d$var$_getPrototypeOf(o);
}
function $b8d1ec3c3aec973d$var$_defineProperty(obj, key, value) {
    key = $b8d1ec3c3aec973d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8d1ec3c3aec973d$var$_toPropertyKey(arg) {
    var key = $b8d1ec3c3aec973d$var$_toPrimitive(arg, "string");
    return $b8d1ec3c3aec973d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b8d1ec3c3aec973d$var$_toPrimitive(input, hint) {
    if ($b8d1ec3c3aec973d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b8d1ec3c3aec973d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b8d1ec3c3aec973d$var$EPSILON = 1;
var $b8d1ec3c3aec973d$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $b8d1ec3c3aec973d$var$_inherits(TooltipBoundingBox, _PureComponent);
    var _super = $b8d1ec3c3aec973d$var$_createSuper(TooltipBoundingBox);
    function TooltipBoundingBox() {
        var _this;
        $b8d1ec3c3aec973d$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b8d1ec3c3aec973d$var$_defineProperty($b8d1ec3c3aec973d$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        $b8d1ec3c3aec973d$var$_defineProperty($b8d1ec3c3aec973d$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        $b8d1ec3c3aec973d$var$_defineProperty($b8d1ec3c3aec973d$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $b8d1ec3c3aec973d$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $b8d1ec3c3aec973d$var$EPSILON || Math.abs(box.height - this.lastBoundingBox.height) > $b8d1ec3c3aec973d$var$EPSILON) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $264dc3974a72e641$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: {
                        height: this.lastBoundingBox.height,
                        width: this.lastBoundingBox.width
                    },
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $b8d1ec3c3aec973d$var$_objectSpread($b8d1ec3c3aec973d$var$_objectSpread($b8d1ec3c3aec973d$var$_objectSpread({}, isAnimationActive && active && (0, $52c62b34c1505cbc$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", {
                    tabIndex: -1,
                    role: "dialog",
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $9KJkx.PureComponent));




function $f7a5969fbb86644e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f7a5969fbb86644e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f7a5969fbb86644e$var$_typeof(o);
}
function $f7a5969fbb86644e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7a5969fbb86644e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7a5969fbb86644e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f7a5969fbb86644e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7a5969fbb86644e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f7a5969fbb86644e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f7a5969fbb86644e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f7a5969fbb86644e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f7a5969fbb86644e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f7a5969fbb86644e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f7a5969fbb86644e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f7a5969fbb86644e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f7a5969fbb86644e$var$_setPrototypeOf(subClass, superClass);
}
function $f7a5969fbb86644e$var$_setPrototypeOf(o, p) {
    $f7a5969fbb86644e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f7a5969fbb86644e$var$_setPrototypeOf(o, p);
}
function $f7a5969fbb86644e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f7a5969fbb86644e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f7a5969fbb86644e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f7a5969fbb86644e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f7a5969fbb86644e$var$_possibleConstructorReturn(this, result);
    };
}
function $f7a5969fbb86644e$var$_possibleConstructorReturn(self, call) {
    if (call && ($f7a5969fbb86644e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f7a5969fbb86644e$var$_assertThisInitialized(self);
}
function $f7a5969fbb86644e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f7a5969fbb86644e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f7a5969fbb86644e$var$_getPrototypeOf(o) {
    $f7a5969fbb86644e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f7a5969fbb86644e$var$_getPrototypeOf(o);
}
function $f7a5969fbb86644e$var$_defineProperty(obj, key, value) {
    key = $f7a5969fbb86644e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f7a5969fbb86644e$var$_toPropertyKey(arg) {
    var key = $f7a5969fbb86644e$var$_toPrimitive(arg, "string");
    return $f7a5969fbb86644e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f7a5969fbb86644e$var$_toPrimitive(input, hint) {
    if ($f7a5969fbb86644e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f7a5969fbb86644e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f7a5969fbb86644e$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $f7a5969fbb86644e$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $6e0a49c1349cde01$export$6fe33945eebf9ac8), props);
}
var $f7a5969fbb86644e$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $f7a5969fbb86644e$var$_inherits(Tooltip, _PureComponent);
    var _super = $f7a5969fbb86644e$var$_createSuper(Tooltip);
    function Tooltip() {
        $f7a5969fbb86644e$var$_classCallCheck(this, Tooltip);
        return _super.apply(this, arguments);
    }
    $f7a5969fbb86644e$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $90ce88196b05cf2b$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null;
                }), payloadUniqBy, $f7a5969fbb86644e$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b8d1ec3c3aec973d$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $f7a5969fbb86644e$var$renderContent(content, $f7a5969fbb86644e$var$_objectSpread($f7a5969fbb86644e$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $9KJkx.PureComponent));
$f7a5969fbb86644e$var$_defineProperty($f7a5969fbb86644e$export$28c660c63b792dea, "displayName", "Tooltip");
$f7a5969fbb86644e$var$_defineProperty($f7a5969fbb86644e$export$28c660c63b792dea, "defaultProps", {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $9KJkx = parcelRequire("9KJkx");







function $b5aeadb44826077c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b5aeadb44826077c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b5aeadb44826077c$var$_typeof(o);
}
function $b5aeadb44826077c$var$_extends() {
    $b5aeadb44826077c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5aeadb44826077c$var$_extends.apply(this, arguments);
}
function $b5aeadb44826077c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5aeadb44826077c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5aeadb44826077c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b5aeadb44826077c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5aeadb44826077c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5aeadb44826077c$var$_defineProperty(obj, key, value) {
    key = $b5aeadb44826077c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b5aeadb44826077c$var$_toPropertyKey(arg) {
    var key = $b5aeadb44826077c$var$_toPrimitive(arg, "string");
    return $b5aeadb44826077c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b5aeadb44826077c$var$_toPrimitive(input, hint) {
    if ($b5aeadb44826077c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b5aeadb44826077c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b5aeadb44826077c$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $3e3747f547314eb6$exports.curveBasisClosed),
    curveBasisOpen: (0, $3e3747f547314eb6$exports.curveBasisOpen),
    curveBasis: (0, $3e3747f547314eb6$exports.curveBasis),
    curveBumpX: (0, $3e3747f547314eb6$exports.curveBumpX),
    curveBumpY: (0, $3e3747f547314eb6$exports.curveBumpY),
    curveLinearClosed: (0, $3e3747f547314eb6$exports.curveLinearClosed),
    curveLinear: (0, $3e3747f547314eb6$exports.curveLinear),
    curveMonotoneX: (0, $3e3747f547314eb6$exports.curveMonotoneX),
    curveMonotoneY: (0, $3e3747f547314eb6$exports.curveMonotoneY),
    curveNatural: (0, $3e3747f547314eb6$exports.curveNatural),
    curveStep: (0, $3e3747f547314eb6$exports.curveStep),
    curveStepAfter: (0, $3e3747f547314eb6$exports.curveStepAfter),
    curveStepBefore: (0, $3e3747f547314eb6$exports.curveStepBefore)
};
var $b5aeadb44826077c$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $b5aeadb44826077c$var$getX = function getX(p) {
    return p.x;
};
var $b5aeadb44826077c$var$getY = function getY(p) {
    return p.y;
};
var $b5aeadb44826077c$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($a5ba6f20100f95e5$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $b5aeadb44826077c$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $b5aeadb44826077c$var$CURVE_FACTORIES[name] || (0, $3e3747f547314eb6$exports.curveLinear);
};
/**
 * Calculate the path of curve
 * @return {String} path
 */ var $b5aeadb44826077c$var$getPath = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $b5aeadb44826077c$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $b5aeadb44826077c$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $b5aeadb44826077c$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $b5aeadb44826077c$var$_objectSpread($b5aeadb44826077c$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $3e3747f547314eb6$exports.area)().y($b5aeadb44826077c$var$getY).x1($b5aeadb44826077c$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $3e3747f547314eb6$exports.area)().x($b5aeadb44826077c$var$getX).y1($b5aeadb44826077c$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($b5aeadb44826077c$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $3e3747f547314eb6$exports.area)().y($b5aeadb44826077c$var$getY).x1($b5aeadb44826077c$var$getX).x0(baseLine);
    else if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $3e3747f547314eb6$exports.area)().x($b5aeadb44826077c$var$getX).y1($b5aeadb44826077c$var$getY).y0(baseLine);
    else lineFunction = (0, $3e3747f547314eb6$exports.line)().x($b5aeadb44826077c$var$getX).y($b5aeadb44826077c$var$getY);
    lineFunction.defined($b5aeadb44826077c$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $b5aeadb44826077c$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $b5aeadb44826077c$var$getPath(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $b5aeadb44826077c$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props), (0, $6d098ec72682e3e0$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};



var $9KJkx = parcelRequire("9KJkx");



function $31e5d556a0493738$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $31e5d556a0493738$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $31e5d556a0493738$var$_typeof(o);
}
var $31e5d556a0493738$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $31e5d556a0493738$var$_extends() {
    $31e5d556a0493738$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $31e5d556a0493738$var$_extends.apply(this, arguments);
}
function $31e5d556a0493738$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31e5d556a0493738$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31e5d556a0493738$var$ownKeys(Object(t), !0).forEach(function(r) {
            $31e5d556a0493738$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31e5d556a0493738$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $31e5d556a0493738$var$_defineProperty(obj, key, value) {
    key = $31e5d556a0493738$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $31e5d556a0493738$var$_toPropertyKey(arg) {
    var key = $31e5d556a0493738$var$_toPrimitive(arg, "string");
    return $31e5d556a0493738$var$_typeof(key) === "symbol" ? key : String(key);
}
function $31e5d556a0493738$var$_toPrimitive(input, hint) {
    if ($31e5d556a0493738$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($31e5d556a0493738$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $31e5d556a0493738$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $31e5d556a0493738$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $31e5d556a0493738$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $31e5d556a0493738$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $31e5d556a0493738$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $31e5d556a0493738$var$_objectWithoutProperties(_ref, $31e5d556a0493738$var$_excluded);
    var props = $31e5d556a0493738$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $3c48a89ca795c151$export$7e4aa119212bc614)(x) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(y) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(height) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(top) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("path", $31e5d556a0493738$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true), {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-cross", className),
        d: $31e5d556a0493738$var$getPath(x, y, width, height, top, left)
    }));
};




var $9KJkx = parcelRequire("9KJkx");



function $469504db9d3a1a19$var$_extends() {
    $469504db9d3a1a19$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $469504db9d3a1a19$var$_extends.apply(this, arguments);
}
var $469504db9d3a1a19$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("circle", $469504db9d3a1a19$var$_extends({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props), (0, $6d098ec72682e3e0$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $9KJkx = parcelRequire("9KJkx");











var $5d39a9f9e3cc2ced$var$_excluded = [
    "viewBox"
], $5d39a9f9e3cc2ced$var$_excluded2 = [
    "viewBox"
], $5d39a9f9e3cc2ced$var$_excluded3 = [
    "ticks"
];
function $5d39a9f9e3cc2ced$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5d39a9f9e3cc2ced$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5d39a9f9e3cc2ced$var$_typeof(o);
}
function $5d39a9f9e3cc2ced$var$_extends() {
    $5d39a9f9e3cc2ced$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5d39a9f9e3cc2ced$var$_extends.apply(this, arguments);
}
function $5d39a9f9e3cc2ced$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d39a9f9e3cc2ced$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d39a9f9e3cc2ced$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5d39a9f9e3cc2ced$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d39a9f9e3cc2ced$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5d39a9f9e3cc2ced$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5d39a9f9e3cc2ced$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5d39a9f9e3cc2ced$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $5d39a9f9e3cc2ced$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5d39a9f9e3cc2ced$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5d39a9f9e3cc2ced$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5d39a9f9e3cc2ced$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5d39a9f9e3cc2ced$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d39a9f9e3cc2ced$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5d39a9f9e3cc2ced$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5d39a9f9e3cc2ced$var$_setPrototypeOf(subClass, superClass);
}
function $5d39a9f9e3cc2ced$var$_setPrototypeOf(o, p) {
    $5d39a9f9e3cc2ced$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5d39a9f9e3cc2ced$var$_setPrototypeOf(o, p);
}
function $5d39a9f9e3cc2ced$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d39a9f9e3cc2ced$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5d39a9f9e3cc2ced$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5d39a9f9e3cc2ced$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5d39a9f9e3cc2ced$var$_possibleConstructorReturn(this, result);
    };
}
function $5d39a9f9e3cc2ced$var$_possibleConstructorReturn(self, call) {
    if (call && ($5d39a9f9e3cc2ced$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5d39a9f9e3cc2ced$var$_assertThisInitialized(self);
}
function $5d39a9f9e3cc2ced$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5d39a9f9e3cc2ced$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5d39a9f9e3cc2ced$var$_getPrototypeOf(o) {
    $5d39a9f9e3cc2ced$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5d39a9f9e3cc2ced$var$_getPrototypeOf(o);
}
function $5d39a9f9e3cc2ced$var$_defineProperty(obj, key, value) {
    key = $5d39a9f9e3cc2ced$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5d39a9f9e3cc2ced$var$_toPropertyKey(arg) {
    var key = $5d39a9f9e3cc2ced$var$_toPrimitive(arg, "string");
    return $5d39a9f9e3cc2ced$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5d39a9f9e3cc2ced$var$_toPrimitive(input, hint) {
    if ($5d39a9f9e3cc2ced$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5d39a9f9e3cc2ced$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5d39a9f9e3cc2ced$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $5d39a9f9e3cc2ced$var$_inherits(CartesianAxis, _Component);
    var _super = $5d39a9f9e3cc2ced$var$_createSuper(CartesianAxis);
    function CartesianAxis(props) {
        var _this;
        $5d39a9f9e3cc2ced$var$_classCallCheck(this, CartesianAxis);
        _this = _super.call(this, props);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $5d39a9f9e3cc2ced$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $5d39a9f9e3cc2ced$var$_objectWithoutProperties(_ref, $5d39a9f9e3cc2ced$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $5d39a9f9e3cc2ced$var$_objectWithoutProperties(_this$props, $5d39a9f9e3cc2ced$var$_excluded2);
                return !(0, $62f30e004766c582$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $62f30e004766c582$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $62f30e004766c582$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $3c48a89ca795c151$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props)), (0, $19f907b79fb0a735$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", $5d39a9f9e3cc2ced$var$_extends({}, props, {
                    className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $fb1302fd1362cb06$export$3d27d42b1034de5c)($5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(tick);
                var tickLineProps = $5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread($5d39a9f9e3cc2ced$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), $5d39a9f9e3cc2ced$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $6d098ec72682e3e0$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", $5d39a9f9e3cc2ced$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $5d39a9f9e3cc2ced$var$_objectWithoutProperties(_this$props8, $5d39a9f9e3cc2ced$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $6195d75aa460b7f0$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b0a47abc2c07d3b6$export$5f1af8db9871e1d6), $5d39a9f9e3cc2ced$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $9KJkx.Component));
$5d39a9f9e3cc2ced$var$_defineProperty($5d39a9f9e3cc2ced$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$5d39a9f9e3cc2ced$var$_defineProperty($5d39a9f9e3cc2ced$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});



var $9KJkx = parcelRequire("9KJkx");








function $8e29663f7b9ac32b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e29663f7b9ac32b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e29663f7b9ac32b$var$_typeof(o);
}
function $8e29663f7b9ac32b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e29663f7b9ac32b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e29663f7b9ac32b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e29663f7b9ac32b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e29663f7b9ac32b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e29663f7b9ac32b$var$_defineProperty(obj, key, value) {
    key = $8e29663f7b9ac32b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e29663f7b9ac32b$var$_toPropertyKey(arg) {
    var key = $8e29663f7b9ac32b$var$_toPrimitive(arg, "string");
    return $8e29663f7b9ac32b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8e29663f7b9ac32b$var$_toPrimitive(input, hint) {
    if ($8e29663f7b9ac32b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8e29663f7b9ac32b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $8e29663f7b9ac32b$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $8e29663f7b9ac32b$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $8e29663f7b9ac32b$var$PREFIX_LIST.reduce(function(res, entry) {
        return $8e29663f7b9ac32b$var$_objectSpread($8e29663f7b9ac32b$var$_objectSpread({}, res), {}, $8e29663f7b9ac32b$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $b761d249634e4202$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b761d249634e4202$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b761d249634e4202$var$_typeof(o);
}
function $b761d249634e4202$var$_extends() {
    $b761d249634e4202$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b761d249634e4202$var$_extends.apply(this, arguments);
}
function $b761d249634e4202$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b761d249634e4202$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b761d249634e4202$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b761d249634e4202$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b761d249634e4202$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b761d249634e4202$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b761d249634e4202$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b761d249634e4202$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b761d249634e4202$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b761d249634e4202$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b761d249634e4202$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b761d249634e4202$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b761d249634e4202$var$_setPrototypeOf(subClass, superClass);
}
function $b761d249634e4202$var$_setPrototypeOf(o, p) {
    $b761d249634e4202$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b761d249634e4202$var$_setPrototypeOf(o, p);
}
function $b761d249634e4202$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b761d249634e4202$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b761d249634e4202$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b761d249634e4202$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b761d249634e4202$var$_possibleConstructorReturn(this, result);
    };
}
function $b761d249634e4202$var$_possibleConstructorReturn(self, call) {
    if (call && ($b761d249634e4202$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b761d249634e4202$var$_assertThisInitialized(self);
}
function $b761d249634e4202$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b761d249634e4202$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b761d249634e4202$var$_getPrototypeOf(o) {
    $b761d249634e4202$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b761d249634e4202$var$_getPrototypeOf(o);
}
function $b761d249634e4202$var$_defineProperty(obj, key, value) {
    key = $b761d249634e4202$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b761d249634e4202$var$_toPropertyKey(arg) {
    var key = $b761d249634e4202$var$_toPrimitive(arg, "string");
    return $b761d249634e4202$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b761d249634e4202$var$_toPrimitive(input, hint) {
    if ($b761d249634e4202$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b761d249634e4202$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b761d249634e4202$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $eb5d583b38281801$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($23f0498cce9e4f06$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $b761d249634e4202$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $b761d249634e4202$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $b761d249634e4202$var$_inherits(Brush, _PureComponent);
    var _super = $b761d249634e4202$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $b761d249634e4202$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $b761d249634e4202$var$_defineProperty($b761d249634e4202$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $b761d249634e4202$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($b761d249634e4202$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($b761d249634e4202$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $b761d249634e4202$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $b761d249634e4202$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $b761d249634e4202$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $b761d249634e4202$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState($b761d249634e4202$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $9KJkx.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $b761d249634e4202$var$_objectSpread($b761d249634e4202$var$_objectSpread({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b0a47abc2c07d3b6$export$5f1af8db9871e1d6), $b761d249634e4202$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b0a47abc2c07d3b6$export$5f1af8db9871e1d6), $b761d249634e4202$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(x) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(y) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).Children.count(children) === 1;
                var style = (0, $8e29663f7b9ac32b$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $b761d249634e4202$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $b761d249634e4202$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $9KJkx.PureComponent));
$b761d249634e4202$var$_defineProperty($b761d249634e4202$export$59bc2e3533b384a0, "displayName", "Brush");
$b761d249634e4202$var$_defineProperty($b761d249634e4202$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $9KJkx = parcelRequire("9KJkx");






var $e48998550a57b3c7$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};





function $6afbdced2c7bf4ce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6afbdced2c7bf4ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6afbdced2c7bf4ce$var$_typeof(o);
}
function $6afbdced2c7bf4ce$var$_extends() {
    $6afbdced2c7bf4ce$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6afbdced2c7bf4ce$var$_extends.apply(this, arguments);
}
function $6afbdced2c7bf4ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6afbdced2c7bf4ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6afbdced2c7bf4ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6afbdced2c7bf4ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6afbdced2c7bf4ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6afbdced2c7bf4ce$var$_defineProperty(obj, key, value) {
    key = $6afbdced2c7bf4ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6afbdced2c7bf4ce$var$_toPropertyKey(arg) {
    var key = $6afbdced2c7bf4ce$var$_toPrimitive(arg, "string");
    return $6afbdced2c7bf4ce$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6afbdced2c7bf4ce$var$_toPrimitive(input, hint) {
    if ($6afbdced2c7bf4ce$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6afbdced2c7bf4ce$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $6afbdced2c7bf4ce$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $eb9a7968d0442930$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $6afbdced2c7bf4ce$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $3c48a89ca795c151$export$402a499e1ea44294)(x);
    var isY = (0, $3c48a89ca795c151$export$402a499e1ea44294)(y);
    (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $6afbdced2c7bf4ce$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $6afbdced2c7bf4ce$var$_objectSpread($6afbdced2c7bf4ce$var$_objectSpread({
        clipPath: clipPath
    }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-reference-dot", className)
    }, $6afbdced2c7bf4ce$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $6195d75aa460b7f0$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$6afbdced2c7bf4ce$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$6afbdced2c7bf4ce$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$6afbdced2c7bf4ce$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $469504db9d3a1a19$export$d046b3c4a416f60d), $6afbdced2c7bf4ce$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $9KJkx = parcelRequire("9KJkx");

var $d9af1463836a62d7$exports = {};


var $512568a2bb5059ab$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $512568a2bb5059ab$var$baseSome(collection, predicate) {
    var result;
    $d48549f2a9abd534$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$512568a2bb5059ab$exports = $512568a2bb5059ab$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $d9af1463836a62d7$var$some(collection, predicate, guard) {
    var func = $fcffceb67c06866f$exports(collection) ? $ac815e27a108b746$exports : $512568a2bb5059ab$exports;
    if (guard && $8c8e22eb97a4a2ac$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $e7eef0e89d3554e6$exports(predicate, 3));
}
$d9af1463836a62d7$exports = $d9af1463836a62d7$var$some;










function $b8d95a93ae854cb8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b8d95a93ae854cb8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8d95a93ae854cb8$var$_typeof(o);
}
function $b8d95a93ae854cb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b8d95a93ae854cb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b8d95a93ae854cb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b8d95a93ae854cb8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b8d95a93ae854cb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b8d95a93ae854cb8$var$_defineProperty(obj, key, value) {
    key = $b8d95a93ae854cb8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8d95a93ae854cb8$var$_toPropertyKey(arg) {
    var key = $b8d95a93ae854cb8$var$_toPrimitive(arg, "string");
    return $b8d95a93ae854cb8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b8d95a93ae854cb8$var$_toPrimitive(input, hint) {
    if ($b8d95a93ae854cb8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b8d95a93ae854cb8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b8d95a93ae854cb8$var$_slicedToArray(arr, i) {
    return $b8d95a93ae854cb8$var$_arrayWithHoles(arr) || $b8d95a93ae854cb8$var$_iterableToArrayLimit(arr, i) || $b8d95a93ae854cb8$var$_unsupportedIterableToArray(arr, i) || $b8d95a93ae854cb8$var$_nonIterableRest();
}
function $b8d95a93ae854cb8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b8d95a93ae854cb8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b8d95a93ae854cb8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b8d95a93ae854cb8$var$_arrayLikeToArray(o, minLen);
}
function $b8d95a93ae854cb8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b8d95a93ae854cb8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $b8d95a93ae854cb8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b8d95a93ae854cb8$var$_extends() {
    $b8d95a93ae854cb8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8d95a93ae854cb8$var$_extends.apply(this, arguments);
}
var $b8d95a93ae854cb8$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", $b8d95a93ae854cb8$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
// TODO: ScaleHelper
var $b8d95a93ae854cb8$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($d9af1463836a62d7$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $b8d95a93ae854cb8$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $eb9a7968d0442930$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $3c48a89ca795c151$export$402a499e1ea44294)(fixedX);
    var isY = (0, $3c48a89ca795c151$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $b8d95a93ae854cb8$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $b8d95a93ae854cb8$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $b8d95a93ae854cb8$var$_objectSpread($b8d95a93ae854cb8$var$_objectSpread({
        clipPath: clipPath
    }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-reference-line", className)
    }, $b8d95a93ae854cb8$var$renderLine(shape, lineProps), (0, $6195d75aa460b7f0$export$b04be29aa201d4f5).renderCallByParent(props, (0, $eb9a7968d0442930$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$b8d95a93ae854cb8$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$b8d95a93ae854cb8$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};



var $9KJkx = parcelRequire("9KJkx");










function $369b94dc3e801652$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $369b94dc3e801652$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $369b94dc3e801652$var$_typeof(o);
}
function $369b94dc3e801652$var$_extends() {
    $369b94dc3e801652$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $369b94dc3e801652$var$_extends.apply(this, arguments);
}
function $369b94dc3e801652$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $369b94dc3e801652$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $369b94dc3e801652$var$ownKeys(Object(t), !0).forEach(function(r) {
            $369b94dc3e801652$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $369b94dc3e801652$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $369b94dc3e801652$var$_defineProperty(obj, key, value) {
    key = $369b94dc3e801652$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $369b94dc3e801652$var$_toPropertyKey(arg) {
    var key = $369b94dc3e801652$var$_toPrimitive(arg, "string");
    return $369b94dc3e801652$var$_typeof(key) === "symbol" ? key : String(key);
}
function $369b94dc3e801652$var$_toPrimitive(input, hint) {
    if ($369b94dc3e801652$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($369b94dc3e801652$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $369b94dc3e801652$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $eb9a7968d0442930$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $eb9a7968d0442930$export$c7964a5b9439ae62)(p1, p2);
};
function $369b94dc3e801652$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $a8938748035e8b2c$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $3c48a89ca795c151$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $3c48a89ca795c151$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $3c48a89ca795c151$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $3c48a89ca795c151$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $369b94dc3e801652$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $e48998550a57b3c7$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-reference-area", className)
    }, $369b94dc3e801652$export$b4ec4f050ce240b9.renderRect(shape, $369b94dc3e801652$var$_objectSpread($369b94dc3e801652$var$_objectSpread({
        clipPath: clipPath
    }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(props, true)), rect)), (0, $6195d75aa460b7f0$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$369b94dc3e801652$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$369b94dc3e801652$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$369b94dc3e801652$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $c0dd9af3b0375cc0$export$4617fb02663045ef), $369b94dc3e801652$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $035a3b467e849d36$var$_toConsumableArray(arr) {
    return $035a3b467e849d36$var$_arrayWithoutHoles(arr) || $035a3b467e849d36$var$_iterableToArray(arr) || $035a3b467e849d36$var$_unsupportedIterableToArray(arr) || $035a3b467e849d36$var$_nonIterableSpread();
}
function $035a3b467e849d36$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $035a3b467e849d36$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $035a3b467e849d36$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $035a3b467e849d36$var$_arrayLikeToArray(o, minLen);
}
function $035a3b467e849d36$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $035a3b467e849d36$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $035a3b467e849d36$var$_arrayLikeToArray(arr);
}
function $035a3b467e849d36$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $035a3b467e849d36$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $b8d95a93ae854cb8$export$b2f28e248e7838eb));
    var dots = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $6afbdced2c7bf4ce$export$aa7f0b0106bff39));
    var elements = [].concat($035a3b467e849d36$var$_toConsumableArray(lines), $035a3b467e849d36$var$_toConsumableArray(dots));
    var areas = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $369b94dc3e801652$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $e48998550a57b3c7$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $e48998550a57b3c7$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(el.props[key1]) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $3c48a89ca795c151$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $7ad40871e3977fa8$exports = {};
"use strict";
var $7ad40871e3977fa8$var$has = Object.prototype.hasOwnProperty, $7ad40871e3977fa8$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $7ad40871e3977fa8$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $7ad40871e3977fa8$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $7ad40871e3977fa8$var$Events().__proto__) $7ad40871e3977fa8$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $7ad40871e3977fa8$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $7ad40871e3977fa8$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $7ad40871e3977fa8$var$EE(fn, context || emitter, once), evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $7ad40871e3977fa8$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $7ad40871e3977fa8$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $7ad40871e3977fa8$var$EventEmitter() {
    this._events = new $7ad40871e3977fa8$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($7ad40871e3977fa8$var$has.call(events, name)) names.push($7ad40871e3977fa8$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $7ad40871e3977fa8$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $7ad40871e3977fa8$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $7ad40871e3977fa8$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $7ad40871e3977fa8$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $7ad40871e3977fa8$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $7ad40871e3977fa8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $7ad40871e3977fa8$var$prefix ? $7ad40871e3977fa8$var$prefix + event : event;
        if (this._events[evt]) $7ad40871e3977fa8$var$clearEvent(this, evt);
    } else {
        this._events = new $7ad40871e3977fa8$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$7ad40871e3977fa8$var$EventEmitter.prototype.off = $7ad40871e3977fa8$var$EventEmitter.prototype.removeListener;
$7ad40871e3977fa8$var$EventEmitter.prototype.addListener = $7ad40871e3977fa8$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$7ad40871e3977fa8$var$EventEmitter.prefixed = $7ad40871e3977fa8$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$7ad40871e3977fa8$var$EventEmitter.EventEmitter = $7ad40871e3977fa8$var$EventEmitter;
$7ad40871e3977fa8$exports = $7ad40871e3977fa8$var$EventEmitter;


var $79e46638cd3d9ac8$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($7ad40871e3977fa8$exports)))();
var $79e46638cd3d9ac8$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $82bae1b8d08d541c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $82bae1b8d08d541c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $82bae1b8d08d541c$var$_typeof(o);
}
function $82bae1b8d08d541c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82bae1b8d08d541c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $82bae1b8d08d541c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $82bae1b8d08d541c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $82bae1b8d08d541c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $82bae1b8d08d541c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $82bae1b8d08d541c$var$_defineProperty(obj, key, value) {
    key = $82bae1b8d08d541c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82bae1b8d08d541c$var$_toPropertyKey(arg) {
    var key = $82bae1b8d08d541c$var$_toPrimitive(arg, "string");
    return $82bae1b8d08d541c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $82bae1b8d08d541c$var$_toPrimitive(input, hint) {
    if ($82bae1b8d08d541c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($82bae1b8d08d541c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $82bae1b8d08d541c$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $82bae1b8d08d541c$var$_classCallCheck(this, AccessibilityManager);
        $82bae1b8d08d541c$var$_defineProperty(this, "activeIndex", 0);
        $82bae1b8d08d541c$var$_defineProperty(this, "coordinateList", []);
        $82bae1b8d08d541c$var$_defineProperty(this, "layout", "horizontal");
    }
    $82bae1b8d08d541c$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? [] : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList;
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $31cc781398693ebc$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(domainStart) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}





function $da01983a8c2a1b98$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $98248a286e872525$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $74646f7876f0355d$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}


function $459adaa2f03433c2$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}


var $71c20b59a6471984$var$_excluded = [
    "item"
], $71c20b59a6471984$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $71c20b59a6471984$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71c20b59a6471984$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71c20b59a6471984$var$_typeof(o);
}
function $71c20b59a6471984$var$_slicedToArray(arr, i) {
    return $71c20b59a6471984$var$_arrayWithHoles(arr) || $71c20b59a6471984$var$_iterableToArrayLimit(arr, i) || $71c20b59a6471984$var$_unsupportedIterableToArray(arr, i) || $71c20b59a6471984$var$_nonIterableRest();
}
function $71c20b59a6471984$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $71c20b59a6471984$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $71c20b59a6471984$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $71c20b59a6471984$var$_extends() {
    $71c20b59a6471984$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71c20b59a6471984$var$_extends.apply(this, arguments);
}
function $71c20b59a6471984$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $71c20b59a6471984$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $71c20b59a6471984$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $71c20b59a6471984$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $71c20b59a6471984$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $71c20b59a6471984$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $71c20b59a6471984$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $71c20b59a6471984$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $71c20b59a6471984$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $71c20b59a6471984$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $71c20b59a6471984$var$_setPrototypeOf(subClass, superClass);
}
function $71c20b59a6471984$var$_setPrototypeOf(o, p) {
    $71c20b59a6471984$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $71c20b59a6471984$var$_setPrototypeOf(o, p);
}
function $71c20b59a6471984$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $71c20b59a6471984$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $71c20b59a6471984$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $71c20b59a6471984$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $71c20b59a6471984$var$_possibleConstructorReturn(this, result);
    };
}
function $71c20b59a6471984$var$_possibleConstructorReturn(self, call) {
    if (call && ($71c20b59a6471984$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $71c20b59a6471984$var$_assertThisInitialized(self);
}
function $71c20b59a6471984$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $71c20b59a6471984$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $71c20b59a6471984$var$_getPrototypeOf(o) {
    $71c20b59a6471984$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $71c20b59a6471984$var$_getPrototypeOf(o);
}
function $71c20b59a6471984$var$_toConsumableArray(arr) {
    return $71c20b59a6471984$var$_arrayWithoutHoles(arr) || $71c20b59a6471984$var$_iterableToArray(arr) || $71c20b59a6471984$var$_unsupportedIterableToArray(arr) || $71c20b59a6471984$var$_nonIterableSpread();
}
function $71c20b59a6471984$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $71c20b59a6471984$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $71c20b59a6471984$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $71c20b59a6471984$var$_arrayLikeToArray(o, minLen);
}
function $71c20b59a6471984$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $71c20b59a6471984$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $71c20b59a6471984$var$_arrayLikeToArray(arr);
}
function $71c20b59a6471984$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $71c20b59a6471984$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71c20b59a6471984$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71c20b59a6471984$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71c20b59a6471984$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71c20b59a6471984$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71c20b59a6471984$var$_defineProperty(obj, key, value) {
    key = $71c20b59a6471984$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71c20b59a6471984$var$_toPropertyKey(arg) {
    var key = $71c20b59a6471984$var$_toPrimitive(arg, "string");
    return $71c20b59a6471984$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71c20b59a6471984$var$_toPrimitive(input, hint) {
    if ($71c20b59a6471984$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71c20b59a6471984$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $71c20b59a6471984$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $71c20b59a6471984$var$FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var $71c20b59a6471984$var$originCoordinate = {
    x: 0,
    y: 0
};
var $71c20b59a6471984$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $71c20b59a6471984$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, rangeObj), (0, $98248a286e872525$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, rangeObj), (0, $98248a286e872525$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $71c20b59a6471984$var$originCoordinate;
};
var $71c20b59a6471984$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($71c20b59a6471984$var$_toConsumableArray(result), $71c20b59a6471984$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(dataStartIndex) && (0, $3c48a89ca795c151$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $71c20b59a6471984$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $71c20b59a6471984$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $71c20b59a6471984$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        var hide = child.props.hide;
        if (hide) return result;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $3c48a89ca795c151$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($71c20b59a6471984$var$_toConsumableArray(result), [
            (0, $71c7ed1f813f02c8$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $71c20b59a6471984$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $71c20b59a6471984$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $71c7ed1f813f02c8$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $71c20b59a6471984$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $71c20b59a6471984$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $71c20b59a6471984$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $71c7ed1f813f02c8$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $71c20b59a6471984$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $31cc781398693ebc$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $71c7ed1f813f02c8$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $71c7ed1f813f02c8$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $71c20b59a6471984$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $71c7ed1f813f02c8$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $3c48a89ca795c151$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($23f0498cce9e4f06$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $71c7ed1f813f02c8$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($71c20b59a6471984$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $71c7ed1f813f02c8$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(entry) ? finalDomain : [].concat($71c20b59a6471984$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $71c7ed1f813f02c8$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $71c7ed1f813f02c8$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($23f0498cce9e4f06$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $71c7ed1f813f02c8$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $71c7ed1f813f02c8$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $035a3b467e849d36$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $71c7ed1f813f02c8$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, $71c20b59a6471984$var$_defineProperty({}, axisId, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $71c20b59a6471984$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $71c20b59a6471984$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $71c7ed1f813f02c8$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $71c20b59a6471984$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($23f0498cce9e4f06$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $71c7ed1f813f02c8$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $035a3b467e849d36$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $71c7ed1f813f02c8$export$a0bc8660980558a0)(originalDomain, (0, $71c7ed1f813f02c8$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $035a3b467e849d36$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, $71c20b59a6471984$var$_defineProperty({}, axisId, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))($71c20b59a6471984$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $71c20b59a6471984$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $71c20b59a6471984$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $71c20b59a6471984$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $71c20b59a6471984$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($0f90809c435feb4c$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $71c7ed1f813f02c8$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $71c20b59a6471984$var$createDefaultState = function createDefaultState(props) {
    var _brushItem$props, _brushItem$props2;
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $b761d249634e4202$export$59bc2e3533b384a0));
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = (brushItem === null || brushItem === void 0 || (_brushItem$props = brushItem.props) === null || _brushItem$props === void 0 ? void 0 : _brushItem$props.endIndex) !== undefined ? brushItem === null || brushItem === void 0 || (_brushItem$props2 = brushItem.props) === null || _brushItem$props2 === void 0 ? void 0 : _brushItem$props2.endIndex : props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $71c20b59a6471984$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $19f907b79fb0a735$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $71c20b59a6471984$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $71c20b59a6471984$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $b761d249634e4202$export$59bc2e3533b384a0));
    var legendItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $43190005d2438131$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, $71c20b59a6471984$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, $71c20b59a6471984$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $b761d249634e4202$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $71c7ed1f813f02c8$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
var $71c20b59a6471984$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $71c20b59a6471984$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $71c20b59a6471984$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $71c7ed1f813f02c8$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $71c20b59a6471984$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type, _objectSpread6;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, $1be50d0e7793a737$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $71c20b59a6471984$var$_defineProperty(_objectSpread6, entry.axisType, axis), $71c20b59a6471984$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $71c7ed1f813f02c8$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $19f907b79fb0a735$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $71c7ed1f813f02c8$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $71c7ed1f813f02c8$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $71c7ed1f813f02c8$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, pos), {}, {
                        position: $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, composedFn($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $71c20b59a6471984$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $71c20b59a6471984$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $71c20b59a6471984$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $19f907b79fb0a735$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $19f907b79fb0a735$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $71c20b59a6471984$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $71c7ed1f813f02c8$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, result), {}, $71c20b59a6471984$var$_defineProperty({}, name, $71c20b59a6471984$var$getAxisMap(props, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $71c20b59a6471984$var$calculateOffset($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $71c20b59a6471984$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _class = /*#__PURE__*/ function(_Component) {
        $71c20b59a6471984$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $71c20b59a6471984$var$_createSuper(CategoricalChartWrapper);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $71c20b59a6471984$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $82bae1b8d08d541c$export$a2c2de1efa8671eb)());
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($71c20b59a6471984$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $71c20b59a6471984$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $19f907b79fb0a735$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $79e46638cd3d9ac8$export$9bcdfe5f29bb33).emit((0, $79e46638cd3d9ac8$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($71c20b59a6471984$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $71c20b59a6471984$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $71c20b59a6471984$var$originCoordinate;
                    _this.setState($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "verticalCoordinatesGenerator", function(_ref10, syncWithTicks) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $71c7ed1f813f02c8$export$846dc5ac5fecff74)((0, $fb1302fd1362cb06$export$3d27d42b1034de5c)($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, (0, $5d39a9f9e3cc2ced$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width, syncWithTicks);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "horizontalCoordinatesGenerator", function(_ref11, syncWithTicks) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $71c7ed1f813f02c8$export$846dc5ac5fecff74)((0, $fb1302fd1362cb06$export$3d27d42b1034de5c)($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, (0, $5d39a9f9e3cc2ced$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height, syncWithTicks);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "axesTicksGenerator", function(axis) {
                return (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(axis, true);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $b5aeadb44826077c$export$b0e83c3ef8d2db1);
                if (chartName === "ScatterChart") {
                    restProps = activeCoordinate;
                    cursorComp = (0, $31e5d556a0493738$export$3c877bb842c36952);
                } else if (chartName === "BarChart") {
                    restProps = (0, $459adaa2f03433c2$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
                    cursorComp = (0, $c0dd9af3b0375cc0$export$4617fb02663045ef);
                } else if (layout === "radial") {
                    var _getRadialCursorPoint = (0, $74646f7876f0355d$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $e6ec9c4619bf0f62$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: (0, $da01983a8c2a1b98$export$56e1305620ce5745)(layout, activeCoordinate, offset)
                    };
                    cursorComp = (0, $b5aeadb44826077c$export$b0e83c3ef8d2db1);
                }
                var key = element.key || "_recharts-cursor";
                var cursorProps = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                    stroke: "#ccc",
                    pointerEvents: "none"
                }, offset), restProps), (0, $19f907b79fb0a735$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: "recharts-tooltip-cursor"
                });
                return /*#__PURE__*/ (0, $9KJkx.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $9KJkx.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $9KJkx.createElement)(cursorComp, cursorProps);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($72b701a528e94106$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderXAxis", function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderYAxis", function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            });
            /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderGrid", function(element) {
                var _this$state4 = _this.state, xAxisMap = _this$state4.xAxisMap, yAxisMap = _this$state4.yAxisMap, offset = _this$state4.offset;
                var _this$props2 = _this.props, width = _this$props2.width, height = _this$props2.height;
                var xAxis = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($cdd8e4305f677179$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($d387f13f91c2d601$exports)))(axis.domain, Number.isFinite);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state5 = _this.state, radiusAxisMap = _this$state5.radiusAxisMap, angleAxisMap = _this$state5.angleAxisMap;
                var radiusAxis = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $71c7ed1f813f02c8$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props3 = _this.props, children = _this$props3.children, width = _this$props3.width, height = _this$props3.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $8c22a6e4f658d1c8$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $71c20b59a6471984$var$_objectWithoutProperties(props, $71c20b59a6471984$var$_excluded);
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(item, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var children = _this.props.children;
                var tooltipItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $f7a5969fbb86644e$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state6 = _this.state, isTooltipActive = _this$state6.isTooltipActive, activeCoordinate = _this$state6.activeCoordinate, activePayload = _this$state6.activePayload, activeLabel = _this$state6.activeLabel, offset = _this$state6.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(tooltipItem, {
                    viewBox: $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state7 = _this.state, offset = _this$state7.offset, dataStartIndex = _this$state7.dataStartIndex, dataEndIndex = _this$state7.dataEndIndex, updateId = _this$state7.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $71c7ed1f813f02c8$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $3c48a89ca795c151$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $71c20b59a6471984$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state8 = _this.state, xAxisMap = _this$state8.xAxisMap, yAxisMap = _this$state8.yAxisMap, offset = _this$state8.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $71c7ed1f813f02c8$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(activeDot)), (0, $6d098ec72682e3e0$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state9 = _this.state, isTooltipActive = _this$state9.isTooltipActive, tooltipAxis = _this$state9.tooltipAxis, activeTooltipIndex = _this$state9.activeTooltipIndex, activeLabel = _this$state9.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $f7a5969fbb86644e$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $71c7ed1f813f02c8$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $71c7ed1f813f02c8$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $71c7ed1f813f02c8$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $3c48a89ca795c151$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $3c48a89ca795c151$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($71c20b59a6471984$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref13 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref13$graphicalItem = _ref13.graphicalItem, _ref13$graphicalItem$ = _ref13$graphicalItem.item, xyItem = _ref13$graphicalItem$ === void 0 ? element : _ref13$graphicalItem$, childIndex = _ref13$graphicalItem.childIndex;
                        var elementProps = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $9KJkx.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $9KJkx.cloneElement)(element, $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $71c20b59a6471984$var$_defineProperty($71c20b59a6471984$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: _this.renderGrid,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: _this.renderReferenceElement
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: _this.renderXAxis
                },
                YAxis: {
                    handler: _this.renderYAxis
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $3c48a89ca795c151$export$8b15d37bc3f197d4)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($210f438d283ca1c5$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $71c20b59a6471984$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: // eslint-disable-next-line @typescript-eslint/no-empty-function
                function componentDidUpdate() {}
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(this.props.children, (0, $f7a5969fbb86644e$export$28c660c63b792dea));
                    if (tooltipItem && Boolean(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $dc248c2135213327$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state10 = this.state, xAxisMap = _this$state10.xAxisMap, yAxisMap = _this$state10.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $71c20b59a6471984$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state11 = this.state, angleAxisMap = _this$state11.angleAxisMap, radiusAxisMap = _this$state11.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $3c48a89ca795c151$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $98248a286e872525$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $19f907b79fb0a735$export$64c61536a2b72e0f)(children, (0, $f7a5969fbb86644e$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $6d098ec72682e3e0$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $79e46638cd3d9ac8$export$9bcdfe5f29bb33).on((0, $79e46638cd3d9ac8$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $79e46638cd3d9ac8$export$9bcdfe5f29bb33).removeListener((0, $79e46638cd3d9ac8$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $19f907b79fb0a735$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $5d39a9f9e3cc2ced$export$bdd99f2cdf352bae), $71c20b59a6471984$var$_extends({}, axisOptions, {
                        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref14) {
                        var _ref15 = $71c20b59a6471984$var$_slicedToArray(_ref14, 2), axisId = _ref15[0], axisProps = _ref15[1];
                        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, res), {}, $71c20b59a6471984$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref16) {
                        var _ref17 = $71c20b59a6471984$var$_slicedToArray(_ref16, 2), axisId = _ref17[0], axisProps = _ref17[1];
                        return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, res), {}, $71c20b59a6471984$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state12 = this.state, formattedGraphicalItems = _this$state12.formattedGraphicalItems, activeItem = _this$state12.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $19f907b79fb0a735$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $c0dd9af3b0375cc0$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $98248a286e872525$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $91ce6a0bf35cea97$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $91ce6a0bf35cea97$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $91ce6a0bf35cea97$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $91ce6a0bf35cea97$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $91ce6a0bf35cea97$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $19f907b79fb0a735$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $71c20b59a6471984$var$_objectWithoutProperties(_this$props6, $71c20b59a6471984$var$_excluded2);
                    var attrs = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $47567e5d38653620$export$7b92b459e668cb21), $71c20b59a6471984$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $19f907b79fb0a735$export$a98d6da55570cb82)(children, this.renderMap));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "img";
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("div", $71c20b59a6471984$var$_extends({
                        className: (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-wrapper", className),
                        style: $71c20b59a6471984$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        },
                        role: "region"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $47567e5d38653620$export$7b92b459e668cb21), $71c20b59a6471984$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $71c20b59a6471984$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $19f907b79fb0a735$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $9KJkx.Component)), $71c20b59a6471984$var$_defineProperty(_class, "displayName", chartName), $71c20b59a6471984$var$_defineProperty(_class, "defaultProps", $71c20b59a6471984$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), $71c20b59a6471984$var$_defineProperty(_class, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if (prevState.updateId === undefined) {
            var defaultState = $71c20b59a6471984$var$createDefaultState(nextProps);
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $62f30e004766c582$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $71c20b59a6471984$var$createDefaultState(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, $71c20b59a6471984$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($71c20b59a6471984$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $19f907b79fb0a735$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($71c20b59a6471984$var$_objectSpread($71c20b59a6471984$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }), $71c20b59a6471984$var$_defineProperty(_class, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $9KJkx.isValidElement)(option)) dot = /*#__PURE__*/ (0, $9KJkx.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $469504db9d3a1a19$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _class;
};



var $9KJkx = parcelRequire("9KJkx");














var $02e96d78249ab75d$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $02e96d78249ab75d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $02e96d78249ab75d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $02e96d78249ab75d$var$_typeof(o);
}
function $02e96d78249ab75d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $02e96d78249ab75d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $02e96d78249ab75d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $02e96d78249ab75d$var$_extends() {
    $02e96d78249ab75d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $02e96d78249ab75d$var$_extends.apply(this, arguments);
}
function $02e96d78249ab75d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $02e96d78249ab75d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $02e96d78249ab75d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $02e96d78249ab75d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $02e96d78249ab75d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $02e96d78249ab75d$var$_toConsumableArray(arr) {
    return $02e96d78249ab75d$var$_arrayWithoutHoles(arr) || $02e96d78249ab75d$var$_iterableToArray(arr) || $02e96d78249ab75d$var$_unsupportedIterableToArray(arr) || $02e96d78249ab75d$var$_nonIterableSpread();
}
function $02e96d78249ab75d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $02e96d78249ab75d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $02e96d78249ab75d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $02e96d78249ab75d$var$_arrayLikeToArray(o, minLen);
}
function $02e96d78249ab75d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $02e96d78249ab75d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $02e96d78249ab75d$var$_arrayLikeToArray(arr);
}
function $02e96d78249ab75d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $02e96d78249ab75d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $02e96d78249ab75d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $02e96d78249ab75d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $02e96d78249ab75d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02e96d78249ab75d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02e96d78249ab75d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $02e96d78249ab75d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $02e96d78249ab75d$var$_setPrototypeOf(subClass, superClass);
}
function $02e96d78249ab75d$var$_setPrototypeOf(o, p) {
    $02e96d78249ab75d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $02e96d78249ab75d$var$_setPrototypeOf(o, p);
}
function $02e96d78249ab75d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $02e96d78249ab75d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $02e96d78249ab75d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $02e96d78249ab75d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $02e96d78249ab75d$var$_possibleConstructorReturn(this, result);
    };
}
function $02e96d78249ab75d$var$_possibleConstructorReturn(self, call) {
    if (call && ($02e96d78249ab75d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $02e96d78249ab75d$var$_assertThisInitialized(self);
}
function $02e96d78249ab75d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $02e96d78249ab75d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $02e96d78249ab75d$var$_getPrototypeOf(o) {
    $02e96d78249ab75d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $02e96d78249ab75d$var$_getPrototypeOf(o);
}
function $02e96d78249ab75d$var$_defineProperty(obj, key, value) {
    key = $02e96d78249ab75d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $02e96d78249ab75d$var$_toPropertyKey(arg) {
    var key = $02e96d78249ab75d$var$_toPrimitive(arg, "string");
    return $02e96d78249ab75d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $02e96d78249ab75d$var$_toPrimitive(input, hint) {
    if ($02e96d78249ab75d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($02e96d78249ab75d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $02e96d78249ab75d$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $02e96d78249ab75d$var$_inherits(Line, _PureComponent);
    var _super = $02e96d78249ab75d$var$_createSuper(Line);
    function Line() {
        var _this;
        $02e96d78249ab75d$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($02e96d78249ab75d$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($02e96d78249ab75d$var$_toConsumableArray(Line.repeat(lines, count)), $02e96d78249ab75d$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(", ");
        });
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "id", (0, $3c48a89ca795c151$export$8b15d37bc3f197d4)("recharts-line-"));
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $02e96d78249ab75d$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $19f907b79fb0a735$export$fdd5e64c0e8495bb)(children, (0, $09f57e96f11ada43$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item, i) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(item, {
                        // eslint-disable-next-line react/no-array-index-key
                        key: "bar-".concat(i),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), $02e96d78249ab75d$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $02e96d78249ab75d$var$_objectWithoutProperties(_this$props3, $02e96d78249ab75d$var$_excluded);
                var curveProps = $02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread({}, (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: "none",
                    className: "recharts-line-curve",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $b5aeadb44826077c$export$b0e83c3ef8d2db1), $02e96d78249ab75d$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $f2edb043998c1672$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $02e96d78249ab75d$var$_objectSpread($02e96d78249ab75d$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $3c48a89ca795c151$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($6cf74f74207fce54$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-line", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(dot)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $19f907b79fb0a735$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $a84cf7b0e0eb3816$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $3b2fa8e9df665478$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($02e96d78249ab75d$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($02e96d78249ab75d$var$_toConsumableArray(result), $02e96d78249ab75d$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, $416e29c4ee421493$export$2e2bcd8739ae039)("recharts-line-dot", option ? option.className : "");
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement((0, $469504db9d3a1a19$export$d046b3c4a416f60d), $02e96d78249ab75d$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $9KJkx.PureComponent));
$02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$export$17d680238e50603e, "displayName", "Line");
$02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !(0, $53543b9e1a8a46fb$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $02e96d78249ab75d$var$_defineProperty($02e96d78249ab75d$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $71c7ed1f813f02c8$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === "horizontal") return {
            x: (0, $71c7ed1f813f02c8$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($94f4f2296d1fa77c$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $71c7ed1f813f02c8$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $02e96d78249ab75d$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});


/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $c2b2d679e40ddaeb$export$ea77231de273b52d = function XAxis() {
    return null;
};
$c2b2d679e40ddaeb$export$ea77231de273b52d.displayName = "XAxis";
$c2b2d679e40ddaeb$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $2da8ef8b3539ae48$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$2da8ef8b3539ae48$export$f96c4024c52de8f4.displayName = "YAxis";
$2da8ef8b3539ae48$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $ab613df5996254d8$export$54d0e8420ac838ac = (0, $71c20b59a6471984$export$77871aede60e6838)({
    chartName: "LineChart",
    GraphicalChild: (0, $02e96d78249ab75d$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $c2b2d679e40ddaeb$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $2da8ef8b3539ae48$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $eb9a7968d0442930$export$ece7de1383db5ac)
});


var $9KJkx = parcelRequire("9KJkx");



var $efb93902ac615057$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $efb93902ac615057$var$_excluded2 = [
    "offset"
];
function $efb93902ac615057$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $efb93902ac615057$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $efb93902ac615057$var$_typeof(o);
}
function $efb93902ac615057$var$_extends() {
    $efb93902ac615057$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efb93902ac615057$var$_extends.apply(this, arguments);
}
function $efb93902ac615057$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $efb93902ac615057$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $efb93902ac615057$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $efb93902ac615057$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efb93902ac615057$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efb93902ac615057$var$ownKeys(Object(t), !0).forEach(function(r) {
            $efb93902ac615057$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efb93902ac615057$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $efb93902ac615057$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $efb93902ac615057$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $efb93902ac615057$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $efb93902ac615057$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $efb93902ac615057$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $efb93902ac615057$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $efb93902ac615057$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $efb93902ac615057$var$_setPrototypeOf(subClass, superClass);
}
function $efb93902ac615057$var$_setPrototypeOf(o, p) {
    $efb93902ac615057$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $efb93902ac615057$var$_setPrototypeOf(o, p);
}
function $efb93902ac615057$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $efb93902ac615057$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $efb93902ac615057$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $efb93902ac615057$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $efb93902ac615057$var$_possibleConstructorReturn(this, result);
    };
}
function $efb93902ac615057$var$_possibleConstructorReturn(self, call) {
    if (call && ($efb93902ac615057$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $efb93902ac615057$var$_assertThisInitialized(self);
}
function $efb93902ac615057$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $efb93902ac615057$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $efb93902ac615057$var$_getPrototypeOf(o) {
    $efb93902ac615057$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $efb93902ac615057$var$_getPrototypeOf(o);
}
function $efb93902ac615057$var$_defineProperty(obj, key, value) {
    key = $efb93902ac615057$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efb93902ac615057$var$_toPropertyKey(arg) {
    var key = $efb93902ac615057$var$_toPrimitive(arg, "string");
    return $efb93902ac615057$var$_typeof(key) === "symbol" ? key : String(key);
}
function $efb93902ac615057$var$_toPrimitive(input, hint) {
    if ($efb93902ac615057$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($efb93902ac615057$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $efb93902ac615057$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $efb93902ac615057$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $efb93902ac615057$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $efb93902ac615057$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $efb93902ac615057$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $efb93902ac615057$var$_objectSpread($efb93902ac615057$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $efb93902ac615057$var$_objectSpread($efb93902ac615057$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
                    return Math.round(e + x - x);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
                var items = roundedSortedVerticalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedVerticalPoints[i + 1];
                    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: entry,
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
                    return Math.round(e + y - y);
                }).sort(function(a, b) {
                    return a - b;
                });
                if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
                var items = roundedSortedHorizontalPoints.map(function(entry, i) {
                    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
                    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: entry,
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight, syncWithTicks = _this$props6.syncWithTicks, horizontalValues = _this$props6.horizontalValues, verticalValues = _this$props6.verticalValues;
                if (!(0, $3c48a89ca795c151$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(x) || x !== +x || !(0, $3c48a89ca795c151$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints;
                // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(horizontalCoordinatesGenerator)) {
                    var isHorizontalValues = horizontalValues && horizontalValues.length;
                    horizontalPoints = horizontalCoordinatesGenerator({
                        yAxis: yAxis ? $efb93902ac615057$var$_objectSpread($efb93902ac615057$var$_objectSpread({}, yAxis), {}, {
                            ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
                        }) : undefined,
                        width: chartWidth,
                        height: chartHeight,
                        offset: offset
                    }, isHorizontalValues ? true : syncWithTicks);
                }
                // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(verticalCoordinatesGenerator)) {
                    var isVerticalValues = verticalValues && verticalValues.length;
                    verticalPoints = verticalCoordinatesGenerator({
                        xAxis: xAxis ? $efb93902ac615057$var$_objectSpread($efb93902ac615057$var$_objectSpread({}, xAxis), {}, {
                            ticks: isVerticalValues ? verticalValues : xAxis.ticks
                        }) : undefined,
                        width: chartWidth,
                        height: chartHeight,
                        offset: offset
                    }, isVerticalValues ? true : syncWithTicks);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($3dca80e523384196$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $efb93902ac615057$var$_objectWithoutProperties(props, $efb93902ac615057$var$_excluded);
                    var _filterProps = (0, $19f907b79fb0a735$export$d697c39a2985a4c)(others), __ = _filterProps.offset, restOfFilteredProps = $efb93902ac615057$var$_objectWithoutProperties(_filterProps, $efb93902ac615057$var$_excluded2);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9KJkx))).createElement("line", $efb93902ac615057$var$_extends({}, restOfFilteredProps, {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $9KJkx.PureComponent));
$efb93902ac615057$var$_defineProperty($efb93902ac615057$export$6440e27b9f186856, "displayName", "CartesianGrid");
$efb93902ac615057$var$_defineProperty($efb93902ac615057$export$6440e27b9f186856, "defaultProps", {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
});

/**
 * @fileOverview Bar Chart
 */ 




var $edd9758e7b737c81$export$94aefc399ef206a9 = (0, $71c20b59a6471984$export$77871aede60e6838)({
    chartName: "BarChart",
    GraphicalChild: (0, $e0ba214202464c16$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: "axis",
    validateTooltipEventTypes: [
        "axis",
        "item"
    ],
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $c2b2d679e40ddaeb$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $2da8ef8b3539ae48$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $eb9a7968d0442930$export$ece7de1383db5ac)
});



function $322bee87abe039b9$export$2e2bcd8739ae039() {
    $322bee87abe039b9$var$initLineChart();
    $322bee87abe039b9$var$initBarChart();
}
function $322bee87abe039b9$var$initLineChart() {
    const values = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
        name: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
        Female: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
        Male: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
        "Total Population": (0, $2c9e117f21850d30$export$2e2bcd8739ae039).coerce.number()
    }));
    const rootNode = document.getElementById("line-chart");
    if (!rootNode) return;
    const root = (0, $bcfd25cead63bedb$export$882461b6382ed46c)(rootNode);
    const data = values.parse(JSON.parse(rootNode?.dataset.values ?? ""));
    root.render(/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $2c30ba11dd70f90f$export$e60a4704009a0009), {
        height: 307,
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $ab613df5996254d8$export$54d0e8420ac838ac), {
            data: data,
            children: [
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $efb93902ac615057$export$6440e27b9f186856), {}),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $c2b2d679e40ddaeb$export$ea77231de273b52d), {
                    dataKey: "name"
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $2da8ef8b3539ae48$export$f96c4024c52de8f4), {}),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $f7a5969fbb86644e$export$28c660c63b792dea), {
                    separator: ": "
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $43190005d2438131$export$ed247974535929c7), {}),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $02e96d78249ab75d$export$17d680238e50603e), {
                    stroke: "#3F0853",
                    dataKey: "Female"
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $02e96d78249ab75d$export$17d680238e50603e), {
                    stroke: "#9760DC",
                    dataKey: "Male"
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $02e96d78249ab75d$export$17d680238e50603e), {
                    stroke: "#F57549",
                    dataKey: "Total Population"
                })
            ]
        })
    }));
}
function $322bee87abe039b9$var$initBarChart() {
    const values = (0, $2c9e117f21850d30$export$2e2bcd8739ae039).array((0, $2c9e117f21850d30$export$2e2bcd8739ae039).object({
        name: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).string(),
        Female: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).coerce.string(),
        Male: (0, $2c9e117f21850d30$export$2e2bcd8739ae039).coerce.string()
    }));
    const rootNode = document.getElementById("bar-chart");
    if (!rootNode) return;
    const root = (0, $bcfd25cead63bedb$export$882461b6382ed46c)(rootNode);
    const data = values.parse(JSON.parse(rootNode?.dataset.values ?? ""));
    root.render(/*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $2c30ba11dd70f90f$export$e60a4704009a0009), {
        height: 307,
        children: /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsxs)((0, $edd9758e7b737c81$export$94aefc399ef206a9), {
            data: data,
            children: [
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $efb93902ac615057$export$6440e27b9f186856), {}),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $c2b2d679e40ddaeb$export$ea77231de273b52d), {
                    dataKey: "name"
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $2da8ef8b3539ae48$export$f96c4024c52de8f4), {
                    tickFormatter: (tick)=>{
                        return `${tick}%`;
                    }
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $f7a5969fbb86644e$export$28c660c63b792dea), {
                    separator: ": ",
                    formatter: (tick)=>{
                        return `${tick}%`;
                    }
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $43190005d2438131$export$ed247974535929c7), {}),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $e0ba214202464c16$export$bbc6c6369b38e3d1), {
                    fill: "#3F0853",
                    dataKey: "Female"
                }),
                /*#__PURE__*/ (0, $25a891b5df1b0dc7$exports.jsx)((0, $e0ba214202464c16$export$bbc6c6369b38e3d1), {
                    fill: "#9760DC",
                    dataKey: "Male"
                })
            ]
        })
    }));
}


function $48a43d6d24a69c9e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $48a43d6d24a69c9e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $48a43d6d24a69c9e$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $48a43d6d24a69c9e$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $48a43d6d24a69c9e$var$_suppressOverwrites, $48a43d6d24a69c9e$var$_reverting, $48a43d6d24a69c9e$var$_context, $48a43d6d24a69c9e$var$_bigNum = 1e8, $48a43d6d24a69c9e$var$_tinyNum = 1 / $48a43d6d24a69c9e$var$_bigNum, $48a43d6d24a69c9e$var$_2PI = Math.PI * 2, $48a43d6d24a69c9e$var$_HALF_PI = $48a43d6d24a69c9e$var$_2PI / 4, $48a43d6d24a69c9e$var$_gsID = 0, $48a43d6d24a69c9e$var$_sqrt = Math.sqrt, $48a43d6d24a69c9e$var$_cos = Math.cos, $48a43d6d24a69c9e$var$_sin = Math.sin, $48a43d6d24a69c9e$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $48a43d6d24a69c9e$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $48a43d6d24a69c9e$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $48a43d6d24a69c9e$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $48a43d6d24a69c9e$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $48a43d6d24a69c9e$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $48a43d6d24a69c9e$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $48a43d6d24a69c9e$var$_isFuncOrString = function _isFuncOrString(value) {
    return $48a43d6d24a69c9e$var$_isFunction(value) || $48a43d6d24a69c9e$export$f664476fd67145ca(value);
}, $48a43d6d24a69c9e$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$48a43d6d24a69c9e$var$_isArray = Array.isArray, $48a43d6d24a69c9e$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$48a43d6d24a69c9e$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$48a43d6d24a69c9e$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $48a43d6d24a69c9e$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$48a43d6d24a69c9e$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $48a43d6d24a69c9e$var$_delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
$48a43d6d24a69c9e$var$_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, $48a43d6d24a69c9e$var$_globalTimeline, $48a43d6d24a69c9e$var$_win, $48a43d6d24a69c9e$var$_coreInitted, $48a43d6d24a69c9e$var$_doc, $48a43d6d24a69c9e$var$_globals = {}, $48a43d6d24a69c9e$var$_installScope = {}, $48a43d6d24a69c9e$var$_coreReady, $48a43d6d24a69c9e$var$_install = function _install(scope) {
    return ($48a43d6d24a69c9e$var$_installScope = $48a43d6d24a69c9e$var$_merge(scope, $48a43d6d24a69c9e$var$_globals)) && $48a43d6d24a69c9e$export$99ee26438460406a;
}, $48a43d6d24a69c9e$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $48a43d6d24a69c9e$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $48a43d6d24a69c9e$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($48a43d6d24a69c9e$var$_globals[name] = obj) && $48a43d6d24a69c9e$var$_installScope && ($48a43d6d24a69c9e$var$_installScope[name] = obj) || $48a43d6d24a69c9e$var$_globals;
}, $48a43d6d24a69c9e$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $48a43d6d24a69c9e$var$_startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, $48a43d6d24a69c9e$var$_revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, $48a43d6d24a69c9e$var$_revertConfig = {
    suppressEvents: true
}, $48a43d6d24a69c9e$var$_reservedProps = {}, $48a43d6d24a69c9e$var$_lazyTweens = [], $48a43d6d24a69c9e$var$_lazyLookup = {}, $48a43d6d24a69c9e$var$_lastRenderedFrame, $48a43d6d24a69c9e$export$d305d8ec5d7c26b8 = {}, $48a43d6d24a69c9e$var$_effects = {}, $48a43d6d24a69c9e$var$_nextGCFrame = 30, $48a43d6d24a69c9e$var$_harnessPlugins = [], $48a43d6d24a69c9e$var$_callbackNames = "", $48a43d6d24a69c9e$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $48a43d6d24a69c9e$var$_isObject(target) || $48a43d6d24a69c9e$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $48a43d6d24a69c9e$var$_harnessPlugins.length;
        while(i-- && !$48a43d6d24a69c9e$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $48a43d6d24a69c9e$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $48a43d6d24a69c9e$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $48a43d6d24a69c9e$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $48a43d6d24a69c9e$var$_harness($48a43d6d24a69c9e$export$45b10814cc054894(target))[0]._gsap;
}, $48a43d6d24a69c9e$export$51d6bbe898aef1f9 = function _getProperty(target, property, v) {
    return (v = target[property]) && $48a43d6d24a69c9e$var$_isFunction(v) ? target[property]() : $48a43d6d24a69c9e$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v;
}, $48a43d6d24a69c9e$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$48a43d6d24a69c9e$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $48a43d6d24a69c9e$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
$48a43d6d24a69c9e$export$dac762bc6301b560 = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, $48a43d6d24a69c9e$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $48a43d6d24a69c9e$var$_lazyRender = function _lazyRender() {
    var l = $48a43d6d24a69c9e$var$_lazyTweens.length, a = $48a43d6d24a69c9e$var$_lazyTweens.slice(0), i, tween;
    $48a43d6d24a69c9e$var$_lazyLookup = {};
    $48a43d6d24a69c9e$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $48a43d6d24a69c9e$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $48a43d6d24a69c9e$var$_lazyTweens.length && !$48a43d6d24a69c9e$var$_reverting && $48a43d6d24a69c9e$var$_lazyRender();
    animation.render(time, suppressEvents, force || $48a43d6d24a69c9e$var$_reverting && time < 0 && (animation._initted || animation._startAt));
    $48a43d6d24a69c9e$var$_lazyTweens.length && !$48a43d6d24a69c9e$var$_reverting && $48a43d6d24a69c9e$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $48a43d6d24a69c9e$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($48a43d6d24a69c9e$var$_delimitedValueExp).length < 2 ? n : $48a43d6d24a69c9e$export$f664476fd67145ca(value) ? value.trim() : value;
}, $48a43d6d24a69c9e$var$_passThrough = function _passThrough(p) {
    return p;
}, $48a43d6d24a69c9e$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $48a43d6d24a69c9e$var$_setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, $48a43d6d24a69c9e$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $48a43d6d24a69c9e$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $48a43d6d24a69c9e$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $48a43d6d24a69c9e$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $48a43d6d24a69c9e$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $48a43d6d24a69c9e$var$_globalTimeline, func = vars.keyframes ? $48a43d6d24a69c9e$var$_setKeyframeDefaults($48a43d6d24a69c9e$var$_isArray(vars.keyframes)) : $48a43d6d24a69c9e$export$dc2b19673bb53610;
    if ($48a43d6d24a69c9e$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $48a43d6d24a69c9e$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $48a43d6d24a69c9e$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $48a43d6d24a69c9e$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $48a43d6d24a69c9e$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, $48a43d6d24a69c9e$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $48a43d6d24a69c9e$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $48a43d6d24a69c9e$var$_rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && ($48a43d6d24a69c9e$var$_reverting ? tween._startAt.revert($48a43d6d24a69c9e$var$_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, $48a43d6d24a69c9e$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $48a43d6d24a69c9e$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $48a43d6d24a69c9e$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$48a43d6d24a69c9e$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $48a43d6d24a69c9e$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $48a43d6d24a69c9e$var$_setEnd = function _setEnd(animation) {
    return animation._end = $48a43d6d24a69c9e$var$_roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $48a43d6d24a69c9e$var$_tinyNum) || 0));
}, $48a43d6d24a69c9e$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $48a43d6d24a69c9e$var$_roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $48a43d6d24a69c9e$var$_setEnd(animation);
        parent._dirty || $48a43d6d24a69c9e$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $48a43d6d24a69c9e$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = $48a43d6d24a69c9e$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $48a43d6d24a69c9e$var$_clamp(0, child.totalDuration(), t) - child._tTime > $48a43d6d24a69c9e$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($48a43d6d24a69c9e$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$48a43d6d24a69c9e$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $48a43d6d24a69c9e$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $48a43d6d24a69c9e$var$_removeFromParent(child);
    child._start = $48a43d6d24a69c9e$var$_roundPrecise(($48a43d6d24a69c9e$var$_isNumber(position) ? position : position || timeline !== $48a43d6d24a69c9e$var$_globalTimeline ? $48a43d6d24a69c9e$var$_parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = $48a43d6d24a69c9e$var$_roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $48a43d6d24a69c9e$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    $48a43d6d24a69c9e$var$_isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || $48a43d6d24a69c9e$var$_postAddChecks(timeline, child);
    timeline._ts < 0 && $48a43d6d24a69c9e$var$_alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, $48a43d6d24a69c9e$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($48a43d6d24a69c9e$var$_globals.ScrollTrigger || $48a43d6d24a69c9e$export$7fb54635790b59a5("scrollTrigger", trigger)) && $48a43d6d24a69c9e$var$_globals.ScrollTrigger.create(trigger, animation);
}, $48a43d6d24a69c9e$var$_attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    $48a43d6d24a69c9e$var$_initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !$48a43d6d24a69c9e$var$_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $48a43d6d24a69c9e$var$_lastRenderedFrame !== $48a43d6d24a69c9e$export$762ed8fbedb691e3.frame) {
        $48a43d6d24a69c9e$var$_lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, $48a43d6d24a69c9e$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$48a43d6d24a69c9e$var$_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, $48a43d6d24a69c9e$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $48a43d6d24a69c9e$var$_parentPlayheadIsBeforeStart(tween) && !(!tween._initted && $48a43d6d24a69c9e$var$_isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !$48a43d6d24a69c9e$var$_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $48a43d6d24a69c9e$var$_clamp(0, tween._tDur, totalTime);
        iteration = $48a43d6d24a69c9e$var$_animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== $48a43d6d24a69c9e$var$_animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || $48a43d6d24a69c9e$var$_reverting || force || tween._zTime === $48a43d6d24a69c9e$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $48a43d6d24a69c9e$var$_attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $48a43d6d24a69c9e$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && $48a43d6d24a69c9e$var$_rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && $48a43d6d24a69c9e$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $48a43d6d24a69c9e$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $48a43d6d24a69c9e$var$_removeFromParent(tween, 1);
            if (!suppressEvents && !$48a43d6d24a69c9e$var$_reverting) {
                $48a43d6d24a69c9e$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $48a43d6d24a69c9e$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $48a43d6d24a69c9e$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $48a43d6d24a69c9e$var$_roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $48a43d6d24a69c9e$var$_roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && $48a43d6d24a69c9e$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && $48a43d6d24a69c9e$var$_setEnd(animation);
    skipUncache || $48a43d6d24a69c9e$var$_uncache(animation.parent, animation);
    return animation;
}, $48a43d6d24a69c9e$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $48a43d6d24a69c9e$export$e6a97ba2cae5bb94 ? $48a43d6d24a69c9e$var$_uncache(animation) : $48a43d6d24a69c9e$var$_setDuration(animation, animation._dur);
}, $48a43d6d24a69c9e$var$_zeroPosition = {
    _start: 0,
    endTime: $48a43d6d24a69c9e$var$_emptyFunc,
    totalDuration: $48a43d6d24a69c9e$var$_emptyFunc
}, $48a43d6d24a69c9e$var$_parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || $48a43d6d24a69c9e$var$_zeroPosition, clippedDuration = animation.duration() >= $48a43d6d24a69c9e$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if ($48a43d6d24a69c9e$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * ($48a43d6d24a69c9e$var$_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $48a43d6d24a69c9e$var$_createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = $48a43d6d24a69c9e$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $48a43d6d24a69c9e$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $48a43d6d24a69c9e$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new $48a43d6d24a69c9e$export$208a41d6b4e37b97(params[0], vars, params[varsIndex + 1]);
}, $48a43d6d24a69c9e$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $48a43d6d24a69c9e$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $48a43d6d24a69c9e$export$65f2564e9a9b9222 = function getUnit(value, v) {
    return !$48a43d6d24a69c9e$export$f664476fd67145ca(value) || !(v = $48a43d6d24a69c9e$var$_unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$48a43d6d24a69c9e$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $48a43d6d24a69c9e$var$_conditionalReturn(value, function(v) {
        return $48a43d6d24a69c9e$var$_clamp(min, max, v);
    });
}, $48a43d6d24a69c9e$var$_slice = [].slice, $48a43d6d24a69c9e$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $48a43d6d24a69c9e$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $48a43d6d24a69c9e$var$_isObject(value[0])) && !value.nodeType && value !== $48a43d6d24a69c9e$var$_win;
}, $48a43d6d24a69c9e$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $48a43d6d24a69c9e$export$f664476fd67145ca(value) && !leaveStrings || $48a43d6d24a69c9e$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $48a43d6d24a69c9e$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$48a43d6d24a69c9e$export$45b10814cc054894 = function toArray(value, scope, leaveStrings) {
    return $48a43d6d24a69c9e$var$_context && !scope && $48a43d6d24a69c9e$var$_context.selector ? $48a43d6d24a69c9e$var$_context.selector(value) : $48a43d6d24a69c9e$export$f664476fd67145ca(value) && !leaveStrings && ($48a43d6d24a69c9e$var$_coreInitted || !$48a43d6d24a69c9e$var$_wake()) ? $48a43d6d24a69c9e$var$_slice.call((scope || $48a43d6d24a69c9e$var$_doc).querySelectorAll(value), 0) : $48a43d6d24a69c9e$var$_isArray(value) ? $48a43d6d24a69c9e$var$_flatten(value, leaveStrings) : $48a43d6d24a69c9e$var$_isArrayLike(value) ? $48a43d6d24a69c9e$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $48a43d6d24a69c9e$export$aea217a45095ce11 = function selector(value) {
    value = $48a43d6d24a69c9e$export$45b10814cc054894(value)[0] || $48a43d6d24a69c9e$var$_warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return $48a43d6d24a69c9e$export$45b10814cc054894(v, el.querySelectorAll ? el : el === value ? $48a43d6d24a69c9e$var$_warn("Invalid scope") || $48a43d6d24a69c9e$var$_doc.createElement("div") : value);
    };
}, $48a43d6d24a69c9e$export$448332262467e042 = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$48a43d6d24a69c9e$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($48a43d6d24a69c9e$var$_isFunction(v)) return v;
    var vars = $48a43d6d24a69c9e$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $48a43d6d24a69c9e$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($48a43d6d24a69c9e$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $48a43d6d24a69c9e$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$48a43d6d24a69c9e$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === $48a43d6d24a69c9e$var$_bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $48a43d6d24a69c9e$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $48a43d6d24a69c9e$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $48a43d6d24a69c9e$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $48a43d6d24a69c9e$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $48a43d6d24a69c9e$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $48a43d6d24a69c9e$var$_roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $48a43d6d24a69c9e$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = $48a43d6d24a69c9e$var$_roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + ($48a43d6d24a69c9e$var$_isNumber(raw) ? 0 : $48a43d6d24a69c9e$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $48a43d6d24a69c9e$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $48a43d6d24a69c9e$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $48a43d6d24a69c9e$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $48a43d6d24a69c9e$var$_bigNum;
        if (snapTo.values) {
            snapTo = $48a43d6d24a69c9e$export$45b10814cc054894(snapTo.values);
            if (is2D = !$48a43d6d24a69c9e$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $48a43d6d24a69c9e$export$dd12390e6b265a17(snapTo.increment);
    }
    return $48a43d6d24a69c9e$var$_conditionalReturn(value, !isArray ? $48a43d6d24a69c9e$export$dd12390e6b265a17(snapTo) : $48a43d6d24a69c9e$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $48a43d6d24a69c9e$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $48a43d6d24a69c9e$var$_isNumber(raw) ? closest : closest + $48a43d6d24a69c9e$export$65f2564e9a9b9222(raw);
    });
}, $48a43d6d24a69c9e$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $48a43d6d24a69c9e$var$_conditionalReturn($48a43d6d24a69c9e$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $48a43d6d24a69c9e$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $48a43d6d24a69c9e$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $48a43d6d24a69c9e$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $48a43d6d24a69c9e$export$65f2564e9a9b9222(value));
    };
}, $48a43d6d24a69c9e$export$a3295358bff77e = function normalize(min, max, value) {
    return $48a43d6d24a69c9e$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $48a43d6d24a69c9e$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $48a43d6d24a69c9e$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $48a43d6d24a69c9e$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $48a43d6d24a69c9e$var$_isArray(min) ? $48a43d6d24a69c9e$var$_wrapArray(min, wrap(0, min.length), max) : $48a43d6d24a69c9e$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $48a43d6d24a69c9e$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $48a43d6d24a69c9e$var$_isArray(min) ? $48a43d6d24a69c9e$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $48a43d6d24a69c9e$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $48a43d6d24a69c9e$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $48a43d6d24a69c9e$var$_delimitedValueExp : $48a43d6d24a69c9e$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $48a43d6d24a69c9e$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $48a43d6d24a69c9e$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $48a43d6d24a69c9e$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $48a43d6d24a69c9e$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $48a43d6d24a69c9e$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($48a43d6d24a69c9e$var$_isArray(start) && !$48a43d6d24a69c9e$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $48a43d6d24a69c9e$var$_merge($48a43d6d24a69c9e$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$48a43d6d24a69c9e$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $48a43d6d24a69c9e$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $48a43d6d24a69c9e$var$_conditionalReturn(progress, func);
}, $48a43d6d24a69c9e$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $48a43d6d24a69c9e$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $48a43d6d24a69c9e$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = $48a43d6d24a69c9e$var$_context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $48a43d6d24a69c9e$var$_lazyTweens.length && $48a43d6d24a69c9e$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && ($48a43d6d24a69c9e$var$_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    $48a43d6d24a69c9e$var$_context = prevContext;
    return result;
}, $48a43d6d24a69c9e$var$_interrupt = function _interrupt(animation) {
    $48a43d6d24a69c9e$var$_removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!$48a43d6d24a69c9e$var$_reverting);
    animation.progress() < 1 && $48a43d6d24a69c9e$var$_callback(animation, "onInterrupt");
    return animation;
}, $48a43d6d24a69c9e$var$_quickTween, $48a43d6d24a69c9e$var$_registerPluginQueue = [], $48a43d6d24a69c9e$var$_createPlugin = function _createPlugin(config) {
    if ($48a43d6d24a69c9e$var$_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = $48a43d6d24a69c9e$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: $48a43d6d24a69c9e$var$_emptyFunc,
            render: $48a43d6d24a69c9e$var$_renderPropTweens,
            add: $48a43d6d24a69c9e$var$_addPropTween,
            kill: $48a43d6d24a69c9e$var$_killPropTweensOf,
            modifier: $48a43d6d24a69c9e$var$_addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: $48a43d6d24a69c9e$export$d60fbc1e0278aaf0,
            aliases: {},
            register: 0
        };
        $48a43d6d24a69c9e$var$_wake();
        if (config !== Plugin) {
            if ($48a43d6d24a69c9e$export$d305d8ec5d7c26b8[name]) return;
            $48a43d6d24a69c9e$export$dc2b19673bb53610(Plugin, $48a43d6d24a69c9e$export$dc2b19673bb53610($48a43d6d24a69c9e$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
            $48a43d6d24a69c9e$var$_merge(Plugin.prototype, $48a43d6d24a69c9e$var$_merge(instanceDefaults, $48a43d6d24a69c9e$var$_copyExcluding(config, statics))); //instance methods
            $48a43d6d24a69c9e$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                $48a43d6d24a69c9e$var$_harnessPlugins.push(Plugin);
                $48a43d6d24a69c9e$var$_reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        $48a43d6d24a69c9e$var$_addGlobal(name, Plugin);
        config.register && config.register($48a43d6d24a69c9e$export$99ee26438460406a, Plugin, $48a43d6d24a69c9e$export$3a67f7f44b1e838a);
    } else config && $48a43d6d24a69c9e$var$_registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $48a43d6d24a69c9e$var$_255 = 255, $48a43d6d24a69c9e$var$_colorLookup = {
    aqua: [
        0,
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255
    ],
    lime: [
        0,
        $48a43d6d24a69c9e$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $48a43d6d24a69c9e$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255,
        0
    ],
    orange: [
        $48a43d6d24a69c9e$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $48a43d6d24a69c9e$var$_255,
        0,
        0
    ],
    pink: [
        $48a43d6d24a69c9e$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255
    ],
    transparent: [
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255,
        $48a43d6d24a69c9e$var$_255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
$48a43d6d24a69c9e$var$_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $48a43d6d24a69c9e$var$_255 + .5 | 0;
}, $48a43d6d24a69c9e$export$73d6f35be992df24 = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $48a43d6d24a69c9e$var$_colorLookup.black : $48a43d6d24a69c9e$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $48a43d6d24a69c9e$var$_255,
        v & $48a43d6d24a69c9e$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($48a43d6d24a69c9e$var$_colorLookup[v]) a = $48a43d6d24a69c9e$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $48a43d6d24a69c9e$var$_255,
                    a & $48a43d6d24a69c9e$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $48a43d6d24a69c9e$var$_255,
                v & $48a43d6d24a69c9e$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($48a43d6d24a69c9e$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $48a43d6d24a69c9e$var$_hue(h + 1 / 3, r, g);
                a[1] = $48a43d6d24a69c9e$var$_hue(h, r, g);
                a[2] = $48a43d6d24a69c9e$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($48a43d6d24a69c9e$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($48a43d6d24a69c9e$var$_strictNumExp) || $48a43d6d24a69c9e$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $48a43d6d24a69c9e$var$_255;
        g = a[1] / $48a43d6d24a69c9e$var$_255;
        b = a[2] / $48a43d6d24a69c9e$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $48a43d6d24a69c9e$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($48a43d6d24a69c9e$export$dd733e62515be2bd).forEach(function(v) {
        var a = v.match($48a43d6d24a69c9e$export$65c88bbd597e7b0a) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $48a43d6d24a69c9e$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($48a43d6d24a69c9e$export$dd733e62515be2bd), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $48a43d6d24a69c9e$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $48a43d6d24a69c9e$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($48a43d6d24a69c9e$export$dd733e62515be2bd, "1").split($48a43d6d24a69c9e$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($48a43d6d24a69c9e$export$dd733e62515be2bd);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $48a43d6d24a69c9e$export$dd733e62515be2bd = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $48a43d6d24a69c9e$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $48a43d6d24a69c9e$var$_hslExp = /hsl[a]?\(/, $48a43d6d24a69c9e$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $48a43d6d24a69c9e$export$dd733e62515be2bd.lastIndex = 0;
    if ($48a43d6d24a69c9e$export$dd733e62515be2bd.test(combined)) {
        toHSL = $48a43d6d24a69c9e$var$_hslExp.test(combined);
        a[1] = $48a43d6d24a69c9e$var$_formatColors(a[1], toHSL);
        a[0] = $48a43d6d24a69c9e$var$_formatColors(a[0], toHSL, $48a43d6d24a69c9e$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $48a43d6d24a69c9e$var$_tickerActive, $48a43d6d24a69c9e$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($48a43d6d24a69c9e$var$_coreReady) {
                if (!$48a43d6d24a69c9e$var$_coreInitted && $48a43d6d24a69c9e$var$_windowExists()) {
                    $48a43d6d24a69c9e$var$_win = $48a43d6d24a69c9e$var$_coreInitted = window;
                    $48a43d6d24a69c9e$var$_doc = $48a43d6d24a69c9e$var$_win.document || {};
                    $48a43d6d24a69c9e$var$_globals.gsap = $48a43d6d24a69c9e$export$99ee26438460406a;
                    ($48a43d6d24a69c9e$var$_win.gsapVersions || ($48a43d6d24a69c9e$var$_win.gsapVersions = [])).push($48a43d6d24a69c9e$export$99ee26438460406a.version);
                    $48a43d6d24a69c9e$var$_install($48a43d6d24a69c9e$var$_installScope || $48a43d6d24a69c9e$var$_win.GreenSockGlobals || !$48a43d6d24a69c9e$var$_win.gsap && $48a43d6d24a69c9e$var$_win || {});
                    _raf = $48a43d6d24a69c9e$var$_win.requestAnimationFrame;
                    $48a43d6d24a69c9e$var$_registerPluginQueue.forEach($48a43d6d24a69c9e$var$_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $48a43d6d24a69c9e$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $48a43d6d24a69c9e$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $48a43d6d24a69c9e$var$_tickerActive = 0;
            _req = $48a43d6d24a69c9e$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            $48a43d6d24a69c9e$var$_wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $48a43d6d24a69c9e$var$_wake = function _wake() {
    return !$48a43d6d24a69c9e$var$_tickerActive && $48a43d6d24a69c9e$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $48a43d6d24a69c9e$var$_easeMap = {}, $48a43d6d24a69c9e$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $48a43d6d24a69c9e$var$_quotesExp = /["']/g, $48a43d6d24a69c9e$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($48a43d6d24a69c9e$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $48a43d6d24a69c9e$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $48a43d6d24a69c9e$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $48a43d6d24a69c9e$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $48a43d6d24a69c9e$var$_parseObjectInString(split[1])
    ] : $48a43d6d24a69c9e$var$_valueInParentheses(name).split(",").map($48a43d6d24a69c9e$var$_numericIfPossible)) : $48a43d6d24a69c9e$var$_easeMap._CE && $48a43d6d24a69c9e$var$_customEaseExp.test(name) ? $48a43d6d24a69c9e$var$_easeMap._CE("", name) : ease;
}, $48a43d6d24a69c9e$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$48a43d6d24a69c9e$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $48a43d6d24a69c9e$export$e6a97ba2cae5bb94) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $48a43d6d24a69c9e$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($48a43d6d24a69c9e$var$_isFunction(ease) ? ease : $48a43d6d24a69c9e$var$_easeMap[ease] || $48a43d6d24a69c9e$var$_configEaseFromString(ease)) || defaultEase;
}, $48a43d6d24a69c9e$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $48a43d6d24a69c9e$export$f9000b814859f126(names, function(name) {
        $48a43d6d24a69c9e$var$_easeMap[name] = $48a43d6d24a69c9e$var$_globals[name] = ease;
        $48a43d6d24a69c9e$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$48a43d6d24a69c9e$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $48a43d6d24a69c9e$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $48a43d6d24a69c9e$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $48a43d6d24a69c9e$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $48a43d6d24a69c9e$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $48a43d6d24a69c9e$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $48a43d6d24a69c9e$var$_easeInOutFromOut(easeOut);
    p2 = $48a43d6d24a69c9e$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $48a43d6d24a69c9e$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $48a43d6d24a69c9e$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$48a43d6d24a69c9e$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $48a43d6d24a69c9e$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$48a43d6d24a69c9e$var$_easeMap.Linear.easeNone = $48a43d6d24a69c9e$var$_easeMap.none = $48a43d6d24a69c9e$var$_easeMap.Linear.easeIn;
$48a43d6d24a69c9e$var$_insertEase("Elastic", $48a43d6d24a69c9e$var$_configElastic("in"), $48a43d6d24a69c9e$var$_configElastic("out"), $48a43d6d24a69c9e$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $48a43d6d24a69c9e$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$48a43d6d24a69c9e$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$48a43d6d24a69c9e$var$_insertEase("Circ", function(p) {
    return -($48a43d6d24a69c9e$var$_sqrt(1 - p * p) - 1);
});
$48a43d6d24a69c9e$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$48a43d6d24a69c9e$var$_cos(p * $48a43d6d24a69c9e$var$_HALF_PI) + 1;
});
$48a43d6d24a69c9e$var$_insertEase("Back", $48a43d6d24a69c9e$var$_configBack("in"), $48a43d6d24a69c9e$var$_configBack("out"), $48a43d6d24a69c9e$var$_configBack());
$48a43d6d24a69c9e$var$_easeMap.SteppedEase = $48a43d6d24a69c9e$var$_easeMap.steps = $48a43d6d24a69c9e$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $48a43d6d24a69c9e$var$_tinyNum;
        return function(p) {
            return ((p2 * $48a43d6d24a69c9e$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$48a43d6d24a69c9e$var$_defaults.ease = $48a43d6d24a69c9e$var$_easeMap["quad.out"];
$48a43d6d24a69c9e$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $48a43d6d24a69c9e$var$_callbackNames += name + "," + name + "Params,";
});
var $48a43d6d24a69c9e$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $48a43d6d24a69c9e$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $48a43d6d24a69c9e$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $48a43d6d24a69c9e$export$d60fbc1e0278aaf0;
};
var $48a43d6d24a69c9e$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $48a43d6d24a69c9e$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if ($48a43d6d24a69c9e$var$_context) {
            this._ctx = $48a43d6d24a69c9e$var$_context;
            $48a43d6d24a69c9e$var$_context.data.push(this);
        }
        $48a43d6d24a69c9e$var$_tickerActive || $48a43d6d24a69c9e$export$762ed8fbedb691e3.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $48a43d6d24a69c9e$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $48a43d6d24a69c9e$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $48a43d6d24a69c9e$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $48a43d6d24a69c9e$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $48a43d6d24a69c9e$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $48a43d6d24a69c9e$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $48a43d6d24a69c9e$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $48a43d6d24a69c9e$var$_elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $48a43d6d24a69c9e$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $48a43d6d24a69c9e$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$48a43d6d24a69c9e$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $48a43d6d24a69c9e$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$48a43d6d24a69c9e$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime($48a43d6d24a69c9e$var$_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        $48a43d6d24a69c9e$var$_setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return $48a43d6d24a69c9e$var$_recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $48a43d6d24a69c9e$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== $48a43d6d24a69c9e$var$_tinyNum && (this._tTime -= $48a43d6d24a69c9e$var$_tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $48a43d6d24a69c9e$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($48a43d6d24a69c9e$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $48a43d6d24a69c9e$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = $48a43d6d24a69c9e$var$_revertConfig;
        var prevIsReverting = $48a43d6d24a69c9e$var$_reverting;
        $48a43d6d24a69c9e$var$_reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        $48a43d6d24a69c9e$var$_reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $48a43d6d24a69c9e$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            $48a43d6d24a69c9e$var$_onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($48a43d6d24a69c9e$var$_parsePosition(this, position), $48a43d6d24a69c9e$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $48a43d6d24a69c9e$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$48a43d6d24a69c9e$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$48a43d6d24a69c9e$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $48a43d6d24a69c9e$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $48a43d6d24a69c9e$var$_isFunction(onFulfilled) ? onFulfilled : $48a43d6d24a69c9e$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $48a43d6d24a69c9e$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $48a43d6d24a69c9e$var$_interrupt(this);
    };
    return Animation;
}();
$48a43d6d24a69c9e$export$dc2b19673bb53610($48a43d6d24a69c9e$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$48a43d6d24a69c9e$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var $48a43d6d24a69c9e$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $48a43d6d24a69c9e$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $48a43d6d24a69c9e$var$_isNotFalse(vars.sortChildren);
        $48a43d6d24a69c9e$var$_globalTimeline && $48a43d6d24a69c9e$var$_addToTimeline(vars.parent || $48a43d6d24a69c9e$var$_globalTimeline, $48a43d6d24a69c9e$var$_assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && $48a43d6d24a69c9e$var$_scrollTrigger($48a43d6d24a69c9e$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        $48a43d6d24a69c9e$var$_createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        $48a43d6d24a69c9e$var$_createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        $48a43d6d24a69c9e$var$_createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $48a43d6d24a69c9e$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $48a43d6d24a69c9e$export$208a41d6b4e37b97(targets, vars, $48a43d6d24a69c9e$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $48a43d6d24a69c9e$var$_addToTimeline(this, $48a43d6d24a69c9e$export$208a41d6b4e37b97.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $48a43d6d24a69c9e$export$208a41d6b4e37b97(targets, vars, $48a43d6d24a69c9e$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $48a43d6d24a69c9e$var$_inheritDefaults(vars).immediateRender = $48a43d6d24a69c9e$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $48a43d6d24a69c9e$var$_inheritDefaults(toVars).immediateRender = $48a43d6d24a69c9e$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : $48a43d6d24a69c9e$var$_roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== $48a43d6d24a69c9e$var$_globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $48a43d6d24a69c9e$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $48a43d6d24a69c9e$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $48a43d6d24a69c9e$var$_roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && $48a43d6d24a69c9e$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $48a43d6d24a69c9e$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $48a43d6d24a69c9e$var$_findNextPauseTween(this, $48a43d6d24a69c9e$var$_roundPrecise(prevTime), $48a43d6d24a69c9e$var$_roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                $48a43d6d24a69c9e$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$48a43d6d24a69c9e$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || $48a43d6d24a69c9e$var$_reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$48a43d6d24a69c9e$var$_tinyNum : $48a43d6d24a69c9e$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$48a43d6d24a69c9e$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $48a43d6d24a69c9e$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $48a43d6d24a69c9e$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $48a43d6d24a69c9e$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            $48a43d6d24a69c9e$var$_callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $48a43d6d24a69c9e$var$_isNumber(position) || (position = $48a43d6d24a69c9e$var$_parsePosition(this, position, child));
        if (!(child instanceof $48a43d6d24a69c9e$export$c35d437ae5945fcd)) {
            if ($48a43d6d24a69c9e$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($48a43d6d24a69c9e$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($48a43d6d24a69c9e$var$_isFunction(child)) child = $48a43d6d24a69c9e$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $48a43d6d24a69c9e$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$48a43d6d24a69c9e$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $48a43d6d24a69c9e$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($48a43d6d24a69c9e$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($48a43d6d24a69c9e$var$_isFunction(child)) return this.killTweensOf(child);
        $48a43d6d24a69c9e$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $48a43d6d24a69c9e$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $48a43d6d24a69c9e$var$_roundPrecise($48a43d6d24a69c9e$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $48a43d6d24a69c9e$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $48a43d6d24a69c9e$export$208a41d6b4e37b97.delayedCall(0, callback || $48a43d6d24a69c9e$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $48a43d6d24a69c9e$var$_addToTimeline(this, t, $48a43d6d24a69c9e$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $48a43d6d24a69c9e$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $48a43d6d24a69c9e$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$48a43d6d24a69c9e$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $48a43d6d24a69c9e$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $48a43d6d24a69c9e$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $48a43d6d24a69c9e$export$208a41d6b4e37b97) {
                if ($48a43d6d24a69c9e$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$48a43d6d24a69c9e$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $48a43d6d24a69c9e$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = $48a43d6d24a69c9e$export$208a41d6b4e37b97.to(tl, $48a43d6d24a69c9e$export$dc2b19673bb53610({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $48a43d6d24a69c9e$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && $48a43d6d24a69c9e$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $48a43d6d24a69c9e$export$dc2b19673bb53610({
            startAt: {
                time: $48a43d6d24a69c9e$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $48a43d6d24a69c9e$var$_getLabelInDirection(this, $48a43d6d24a69c9e$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $48a43d6d24a69c9e$var$_getLabelInDirection(this, $48a43d6d24a69c9e$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $48a43d6d24a69c9e$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $48a43d6d24a69c9e$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $48a43d6d24a69c9e$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $48a43d6d24a69c9e$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $48a43d6d24a69c9e$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $48a43d6d24a69c9e$var$_setDuration(self, self === $48a43d6d24a69c9e$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($48a43d6d24a69c9e$var$_globalTimeline._ts) {
            $48a43d6d24a69c9e$var$_lazySafeRender($48a43d6d24a69c9e$var$_globalTimeline, $48a43d6d24a69c9e$var$_parentToChildTotalTime(time, $48a43d6d24a69c9e$var$_globalTimeline));
            $48a43d6d24a69c9e$var$_lastRenderedFrame = $48a43d6d24a69c9e$export$762ed8fbedb691e3.frame;
        }
        if ($48a43d6d24a69c9e$export$762ed8fbedb691e3.frame >= $48a43d6d24a69c9e$var$_nextGCFrame) {
            $48a43d6d24a69c9e$var$_nextGCFrame += $48a43d6d24a69c9e$export$4922bee768729a77.autoSleep || 120;
            var child = $48a43d6d24a69c9e$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($48a43d6d24a69c9e$export$4922bee768729a77.autoSleep && $48a43d6d24a69c9e$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $48a43d6d24a69c9e$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($48a43d6d24a69c9e$export$c35d437ae5945fcd);
$48a43d6d24a69c9e$export$dc2b19673bb53610($48a43d6d24a69c9e$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $48a43d6d24a69c9e$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $48a43d6d24a69c9e$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $48a43d6d24a69c9e$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $48a43d6d24a69c9e$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($48a43d6d24a69c9e$var$_complexStringNumExp) || [];
    while(result = $48a43d6d24a69c9e$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? $48a43d6d24a69c9e$export$dac762bc6301b560(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $48a43d6d24a69c9e$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($48a43d6d24a69c9e$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $48a43d6d24a69c9e$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    $48a43d6d24a69c9e$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$48a43d6d24a69c9e$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$48a43d6d24a69c9e$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$48a43d6d24a69c9e$var$_isFunction(currentValue) ? $48a43d6d24a69c9e$var$_setterPlain : funcParam ? $48a43d6d24a69c9e$var$_setterFuncWithParam : $48a43d6d24a69c9e$var$_setterFunc, pt;
    if ($48a43d6d24a69c9e$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $48a43d6d24a69c9e$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") {
            pt = $48a43d6d24a69c9e$export$dac762bc6301b560(parsedStart, end) + ($48a43d6d24a69c9e$export$65f2564e9a9b9222(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || $48a43d6d24a69c9e$var$_forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new $48a43d6d24a69c9e$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $48a43d6d24a69c9e$var$_renderBoolean : $48a43d6d24a69c9e$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $48a43d6d24a69c9e$export$7fb54635790b59a5(prop, end);
        return $48a43d6d24a69c9e$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $48a43d6d24a69c9e$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$48a43d6d24a69c9e$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $48a43d6d24a69c9e$var$_isFunction(vars) && (vars = $48a43d6d24a69c9e$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$48a43d6d24a69c9e$var$_isObject(vars) || vars.style && vars.nodeType || $48a43d6d24a69c9e$var$_isArray(vars) || $48a43d6d24a69c9e$var$_isTypedArray(vars)) return $48a43d6d24a69c9e$export$f664476fd67145ca(vars) ? $48a43d6d24a69c9e$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $48a43d6d24a69c9e$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $48a43d6d24a69c9e$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property] && (plugin = new $48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $48a43d6d24a69c9e$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $48a43d6d24a69c9e$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $48a43d6d24a69c9e$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $48a43d6d24a69c9e$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$48a43d6d24a69c9e$var$_forceAllPropTweens, $48a43d6d24a69c9e$var$_initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !$48a43d6d24a69c9e$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $48a43d6d24a69c9e$var$_parseEase(ease, $48a43d6d24a69c9e$var$_defaults.ease);
    tween._yEase = yoyoEase ? $48a43d6d24a69c9e$var$_invertEase($48a43d6d24a69c9e$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $48a43d6d24a69c9e$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $48a43d6d24a69c9e$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $48a43d6d24a69c9e$var$_copyExcluding(vars, $48a43d6d24a69c9e$var$_reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? $48a43d6d24a69c9e$var$_revertConfigNoKill : $48a43d6d24a69c9e$var$_startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            $48a43d6d24a69c9e$var$_removeFromParent(tween._startAt = $48a43d6d24a69c9e$export$208a41d6b4e37b97.set(targets, $48a43d6d24a69c9e$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && $48a43d6d24a69c9e$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && ($48a43d6d24a69c9e$var$_reverting || !immediateRender && !autoRevert) && tween._startAt.revert($48a43d6d24a69c9e$var$_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $48a43d6d24a69c9e$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && $48a43d6d24a69c9e$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $48a43d6d24a69c9e$var$_removeFromParent(tween._startAt = $48a43d6d24a69c9e$export$208a41d6b4e37b97.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && ($48a43d6d24a69c9e$var$_reverting ? tween._startAt.revert($48a43d6d24a69c9e$var$_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, $48a43d6d24a69c9e$var$_tinyNum, $48a43d6d24a69c9e$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && $48a43d6d24a69c9e$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $48a43d6d24a69c9e$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $48a43d6d24a69c9e$var$_lazyLookup[gsData.id] && $48a43d6d24a69c9e$var$_lazyTweens.length && $48a43d6d24a69c9e$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $48a43d6d24a69c9e$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($48a43d6d24a69c9e$export$d305d8ec5d7c26b8[p] && (plugin = $48a43d6d24a69c9e$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $48a43d6d24a69c9e$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $48a43d6d24a69c9e$var$_overwritingTween = tween;
                $48a43d6d24a69c9e$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $48a43d6d24a69c9e$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($48a43d6d24a69c9e$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $48a43d6d24a69c9e$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render($48a43d6d24a69c9e$var$_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, $48a43d6d24a69c9e$var$_updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                $48a43d6d24a69c9e$var$_forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                $48a43d6d24a69c9e$var$_initTween(tween, time);
                $48a43d6d24a69c9e$var$_forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = $48a43d6d24a69c9e$export$9c8d725d65e13f94(value) + $48a43d6d24a69c9e$export$65f2564e9a9b9222(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + $48a43d6d24a69c9e$export$65f2564e9a9b9222(rootPT.b)); // (beginning value)
    }
}, $48a43d6d24a69c9e$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $48a43d6d24a69c9e$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $48a43d6d24a69c9e$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
$48a43d6d24a69c9e$var$_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if ($48a43d6d24a69c9e$var$_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, $48a43d6d24a69c9e$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $48a43d6d24a69c9e$var$_isFunction(value) ? value.call(tween, i, target, targets) : $48a43d6d24a69c9e$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $48a43d6d24a69c9e$export$d5962a97e3cde94d(value) : value;
}, $48a43d6d24a69c9e$var$_staggerTweenProps = $48a43d6d24a69c9e$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", $48a43d6d24a69c9e$var$_staggerPropsToSkip = {};
$48a43d6d24a69c9e$export$f9000b814859f126($48a43d6d24a69c9e$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return $48a43d6d24a69c9e$var$_staggerPropsToSkip[name] = 1;
});
var $48a43d6d24a69c9e$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $48a43d6d24a69c9e$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $48a43d6d24a69c9e$var$_inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || $48a43d6d24a69c9e$var$_globalTimeline, parsedTargets = ($48a43d6d24a69c9e$var$_isArray(targets) || $48a43d6d24a69c9e$var$_isTypedArray(targets) ? $48a43d6d24a69c9e$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $48a43d6d24a69c9e$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $48a43d6d24a69c9e$var$_harness(parsedTargets) : $48a43d6d24a69c9e$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$48a43d6d24a69c9e$export$4922bee768729a77.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $48a43d6d24a69c9e$var$_isFuncOrString(duration) || $48a43d6d24a69c9e$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $48a43d6d24a69c9e$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = $48a43d6d24a69c9e$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || $48a43d6d24a69c9e$var$_isFuncOrString(duration) || $48a43d6d24a69c9e$var$_isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && $48a43d6d24a69c9e$export$f02a9ddbe4480f19(stagger);
                if ($48a43d6d24a69c9e$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$48a43d6d24a69c9e$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = $48a43d6d24a69c9e$var$_copyExcluding(vars, $48a43d6d24a69c9e$var$_staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $48a43d6d24a69c9e$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$48a43d6d24a69c9e$var$_parseFuncOrString(duration, $48a43d6d24a69c9e$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$48a43d6d24a69c9e$var$_parseFuncOrString(delay, $48a43d6d24a69c9e$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = $48a43d6d24a69c9e$var$_easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                $48a43d6d24a69c9e$var$_inheritDefaults($48a43d6d24a69c9e$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = $48a43d6d24a69c9e$var$_parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if ($48a43d6d24a69c9e$var$_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || $48a43d6d24a69c9e$var$_parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$48a43d6d24a69c9e$var$_suppressOverwrites) {
            $48a43d6d24a69c9e$var$_overwritingTween = $48a43d6d24a69c9e$var$_assertThisInitialized(_this3);
            $48a43d6d24a69c9e$var$_globalTimeline.killTweensOf(parsedTargets);
            $48a43d6d24a69c9e$var$_overwritingTween = 0;
        }
        $48a43d6d24a69c9e$var$_addToTimeline(parent, $48a43d6d24a69c9e$var$_assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === $48a43d6d24a69c9e$var$_roundPrecise(parent._time) && $48a43d6d24a69c9e$var$_isNotFalse(immediateRender) && $48a43d6d24a69c9e$var$_hasNoPausedAncestors($48a43d6d24a69c9e$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$48a43d6d24a69c9e$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && $48a43d6d24a69c9e$var$_scrollTrigger($48a43d6d24a69c9e$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - $48a43d6d24a69c9e$var$_tinyNum && !isNegative ? tDur : totalTime < $48a43d6d24a69c9e$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $48a43d6d24a69c9e$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $48a43d6d24a69c9e$var$_roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $48a43d6d24a69c9e$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $48a43d6d24a69c9e$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($48a43d6d24a69c9e$var$_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($48a43d6d24a69c9e$var$_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                $48a43d6d24a69c9e$var$_callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$48a43d6d24a69c9e$var$_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && $48a43d6d24a69c9e$var$_rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $48a43d6d24a69c9e$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $48a43d6d24a69c9e$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && $48a43d6d24a69c9e$var$_rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $48a43d6d24a69c9e$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $48a43d6d24a69c9e$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        $48a43d6d24a69c9e$var$_tickerActive || $48a43d6d24a69c9e$export$762ed8fbedb691e3.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || $48a43d6d24a69c9e$var$_initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if ($48a43d6d24a69c9e$var$_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        $48a43d6d24a69c9e$var$_alignPlayhead(this, 0);
        this.parent || $48a43d6d24a69c9e$var$_addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $48a43d6d24a69c9e$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $48a43d6d24a69c9e$var$_overwritingTween && $48a43d6d24a69c9e$var$_overwritingTween.vars.overwrite !== true)._first || $48a43d6d24a69c9e$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $48a43d6d24a69c9e$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $48a43d6d24a69c9e$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $48a43d6d24a69c9e$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $48a43d6d24a69c9e$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($48a43d6d24a69c9e$export$f664476fd67145ca(vars)) {
                p = {};
                $48a43d6d24a69c9e$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $48a43d6d24a69c9e$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $48a43d6d24a69c9e$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $48a43d6d24a69c9e$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return $48a43d6d24a69c9e$var$_createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return $48a43d6d24a69c9e$var$_createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $48a43d6d24a69c9e$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($48a43d6d24a69c9e$export$c35d437ae5945fcd);
$48a43d6d24a69c9e$export$dc2b19673bb53610($48a43d6d24a69c9e$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$48a43d6d24a69c9e$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $48a43d6d24a69c9e$export$208a41d6b4e37b97[name] = function() {
        var tl = new $48a43d6d24a69c9e$export$e6a97ba2cae5bb94(), params = $48a43d6d24a69c9e$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $48a43d6d24a69c9e$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $48a43d6d24a69c9e$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $48a43d6d24a69c9e$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $48a43d6d24a69c9e$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $48a43d6d24a69c9e$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $48a43d6d24a69c9e$var$_isFunction(target[property]) ? $48a43d6d24a69c9e$var$_setterFunc : $48a43d6d24a69c9e$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $48a43d6d24a69c9e$var$_setterAttribute : $48a43d6d24a69c9e$var$_setterPlain;
}, $48a43d6d24a69c9e$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, $48a43d6d24a69c9e$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $48a43d6d24a69c9e$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $48a43d6d24a69c9e$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $48a43d6d24a69c9e$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $48a43d6d24a69c9e$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $48a43d6d24a69c9e$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $48a43d6d24a69c9e$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $48a43d6d24a69c9e$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $48a43d6d24a69c9e$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $48a43d6d24a69c9e$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $48a43d6d24a69c9e$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $48a43d6d24a69c9e$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$48a43d6d24a69c9e$export$f9000b814859f126($48a43d6d24a69c9e$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $48a43d6d24a69c9e$var$_reservedProps[name] = 1;
});
$48a43d6d24a69c9e$var$_globals.TweenMax = $48a43d6d24a69c9e$var$_globals.TweenLite = $48a43d6d24a69c9e$export$208a41d6b4e37b97;
$48a43d6d24a69c9e$var$_globals.TimelineLite = $48a43d6d24a69c9e$var$_globals.TimelineMax = $48a43d6d24a69c9e$export$e6a97ba2cae5bb94;
$48a43d6d24a69c9e$var$_globalTimeline = new $48a43d6d24a69c9e$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $48a43d6d24a69c9e$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$48a43d6d24a69c9e$export$4922bee768729a77.stringFilter = $48a43d6d24a69c9e$export$7eb2e5eb5eeb96a4;
var $48a43d6d24a69c9e$var$_media = [], $48a43d6d24a69c9e$var$_listeners = {}, $48a43d6d24a69c9e$var$_emptyArray = [], $48a43d6d24a69c9e$var$_lastMediaTime = 0, $48a43d6d24a69c9e$var$_contextID = 0, $48a43d6d24a69c9e$var$_dispatch = function _dispatch(type) {
    return ($48a43d6d24a69c9e$var$_listeners[type] || $48a43d6d24a69c9e$var$_emptyArray).map(function(f) {
        return f();
    });
}, $48a43d6d24a69c9e$var$_onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - $48a43d6d24a69c9e$var$_lastMediaTime > 2) {
        $48a43d6d24a69c9e$var$_dispatch("matchMediaInit");
        $48a43d6d24a69c9e$var$_media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = $48a43d6d24a69c9e$var$_win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        $48a43d6d24a69c9e$var$_dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        $48a43d6d24a69c9e$var$_lastMediaTime = time;
        $48a43d6d24a69c9e$var$_dispatch("matchMedia");
    }
};
var $48a43d6d24a69c9e$var$Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && $48a43d6d24a69c9e$export$aea217a45095ce11(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = $48a43d6d24a69c9e$var$_contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if ($48a43d6d24a69c9e$var$_isFunction(name)) {
            scope = func;
            func = name;
            name = $48a43d6d24a69c9e$var$_isFunction;
        }
        var self = this, f = function f() {
            var prev = $48a43d6d24a69c9e$var$_context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = $48a43d6d24a69c9e$export$aea217a45095ce11(scope));
            $48a43d6d24a69c9e$var$_context = self;
            result = func.apply(self, arguments);
            $48a43d6d24a69c9e$var$_isFunction(result) && self._r.push(result);
            $48a43d6d24a69c9e$var$_context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === $48a43d6d24a69c9e$var$_isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = $48a43d6d24a69c9e$var$_context;
        $48a43d6d24a69c9e$var$_context = null;
        func(this);
        $48a43d6d24a69c9e$var$_context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof $48a43d6d24a69c9e$export$208a41d6b4e37b97 && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof $48a43d6d24a69c9e$export$208a41d6b4e37b97) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = $48a43d6d24a69c9e$var$_media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            $48a43d6d24a69c9e$var$_media[i].id === this.id && $48a43d6d24a69c9e$var$_media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var $48a43d6d24a69c9e$var$MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        $48a43d6d24a69c9e$var$_isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new $48a43d6d24a69c9e$var$Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        $48a43d6d24a69c9e$var$_context && !context.selector && (context.selector = $48a43d6d24a69c9e$var$_context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = $48a43d6d24a69c9e$var$_win.matchMedia(conditions[p]);
            if (mq) {
                $48a43d6d24a69c9e$var$_media.indexOf(context) < 0 && $48a43d6d24a69c9e$var$_media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener($48a43d6d24a69c9e$var$_onMediaChange) : mq.addEventListener("change", $48a43d6d24a69c9e$var$_onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $48a43d6d24a69c9e$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $48a43d6d24a69c9e$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $48a43d6d24a69c9e$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $48a43d6d24a69c9e$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $48a43d6d24a69c9e$export$f664476fd67145ca(target) && (target = $48a43d6d24a69c9e$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        var getter = $48a43d6d24a69c9e$export$8b9be379d2de2a39(target || {}).get, format = unit ? $48a43d6d24a69c9e$var$_passThrough : $48a43d6d24a69c9e$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property] && $48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property] && $48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $48a43d6d24a69c9e$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $48a43d6d24a69c9e$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $48a43d6d24a69c9e$export$d305d8ec5d7c26b8[property], cache = $48a43d6d24a69c9e$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $48a43d6d24a69c9e$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $48a43d6d24a69c9e$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $48a43d6d24a69c9e$var$_quickTween._pt && $48a43d6d24a69c9e$var$_renderPropTweens(1, $48a43d6d24a69c9e$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = $48a43d6d24a69c9e$export$99ee26438460406a.to(target, $48a43d6d24a69c9e$var$_merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return $48a43d6d24a69c9e$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $48a43d6d24a69c9e$var$_parseEase(value.ease, $48a43d6d24a69c9e$var$_defaults.ease));
        return $48a43d6d24a69c9e$var$_mergeDeep($48a43d6d24a69c9e$var$_defaults, value || {});
    },
    config: function config(value) {
        return $48a43d6d24a69c9e$var$_mergeDeep($48a43d6d24a69c9e$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$48a43d6d24a69c9e$export$d305d8ec5d7c26b8[pluginName] && !$48a43d6d24a69c9e$var$_globals[pluginName] && $48a43d6d24a69c9e$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $48a43d6d24a69c9e$var$_effects[name] = function(targets, vars, tl) {
            return effect($48a43d6d24a69c9e$export$45b10814cc054894(targets), $48a43d6d24a69c9e$export$dc2b19673bb53610(vars || {}, defaults), tl);
        };
        if (extendTimeline) $48a43d6d24a69c9e$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($48a43d6d24a69c9e$var$_effects[name](targets, $48a43d6d24a69c9e$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $48a43d6d24a69c9e$var$_easeMap[name] = $48a43d6d24a69c9e$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $48a43d6d24a69c9e$var$_parseEase(ease, defaultEase) : $48a43d6d24a69c9e$var$_easeMap;
    },
    getById: function getById(id) {
        return $48a43d6d24a69c9e$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $48a43d6d24a69c9e$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $48a43d6d24a69c9e$var$_isNotFalse(vars.smoothChildTiming);
        $48a43d6d24a69c9e$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $48a43d6d24a69c9e$var$_globalTimeline._time;
        child = $48a43d6d24a69c9e$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $48a43d6d24a69c9e$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $48a43d6d24a69c9e$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $48a43d6d24a69c9e$var$_addToTimeline($48a43d6d24a69c9e$var$_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new $48a43d6d24a69c9e$var$Context(func, scope) : $48a43d6d24a69c9e$var$_context;
    },
    matchMedia: function matchMedia(scope) {
        return new $48a43d6d24a69c9e$var$MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return $48a43d6d24a69c9e$var$_media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || $48a43d6d24a69c9e$var$_onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = $48a43d6d24a69c9e$var$_listeners[type] || ($48a43d6d24a69c9e$var$_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = $48a43d6d24a69c9e$var$_listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: $48a43d6d24a69c9e$export$4997ffc0176396a6,
        wrapYoyo: $48a43d6d24a69c9e$export$cfc0b067273edc55,
        distribute: $48a43d6d24a69c9e$export$f02a9ddbe4480f19,
        random: $48a43d6d24a69c9e$export$4385e60b38654f68,
        snap: $48a43d6d24a69c9e$export$51a0620f7a28532b,
        normalize: $48a43d6d24a69c9e$export$a3295358bff77e,
        getUnit: $48a43d6d24a69c9e$export$65f2564e9a9b9222,
        clamp: $48a43d6d24a69c9e$export$7d15b64cf5a3a4c4,
        splitColor: $48a43d6d24a69c9e$export$73d6f35be992df24,
        toArray: $48a43d6d24a69c9e$export$45b10814cc054894,
        selector: $48a43d6d24a69c9e$export$aea217a45095ce11,
        mapRange: $48a43d6d24a69c9e$export$f65a7599bbc6b121,
        pipe: $48a43d6d24a69c9e$export$a4627e546088548d,
        unitize: $48a43d6d24a69c9e$export$d7502930aa5492de,
        interpolate: $48a43d6d24a69c9e$export$89e29e4ab65e70a9,
        shuffle: $48a43d6d24a69c9e$export$448332262467e042
    },
    install: $48a43d6d24a69c9e$var$_install,
    effects: $48a43d6d24a69c9e$var$_effects,
    ticker: $48a43d6d24a69c9e$export$762ed8fbedb691e3,
    updateRoot: $48a43d6d24a69c9e$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $48a43d6d24a69c9e$export$d305d8ec5d7c26b8,
    globalTimeline: $48a43d6d24a69c9e$var$_globalTimeline,
    core: {
        PropTween: $48a43d6d24a69c9e$export$3a67f7f44b1e838a,
        globals: $48a43d6d24a69c9e$var$_addGlobal,
        Tween: $48a43d6d24a69c9e$export$208a41d6b4e37b97,
        Timeline: $48a43d6d24a69c9e$export$e6a97ba2cae5bb94,
        Animation: $48a43d6d24a69c9e$export$c35d437ae5945fcd,
        getCache: $48a43d6d24a69c9e$export$8b9be379d2de2a39,
        _removeLinkedListItem: $48a43d6d24a69c9e$export$cd008aa6cd8844e3,
        reverting: function reverting() {
            return $48a43d6d24a69c9e$var$_reverting;
        },
        context: function context(toAdd) {
            if (toAdd && $48a43d6d24a69c9e$var$_context) {
                $48a43d6d24a69c9e$var$_context.data.push(toAdd);
                toAdd._ctx = $48a43d6d24a69c9e$var$_context;
            }
            return $48a43d6d24a69c9e$var$_context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return $48a43d6d24a69c9e$var$_suppressOverwrites = value;
        }
    }
};
$48a43d6d24a69c9e$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $48a43d6d24a69c9e$var$_gsap[name] = $48a43d6d24a69c9e$export$208a41d6b4e37b97[name];
});
$48a43d6d24a69c9e$export$762ed8fbedb691e3.add($48a43d6d24a69c9e$export$e6a97ba2cae5bb94.updateRoot);
$48a43d6d24a69c9e$var$_quickTween = $48a43d6d24a69c9e$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $48a43d6d24a69c9e$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $48a43d6d24a69c9e$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $48a43d6d24a69c9e$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $48a43d6d24a69c9e$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($48a43d6d24a69c9e$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $48a43d6d24a69c9e$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $48a43d6d24a69c9e$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $48a43d6d24a69c9e$export$99ee26438460406a = $48a43d6d24a69c9e$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            $48a43d6d24a69c9e$var$_reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, $48a43d6d24a69c9e$var$_buildModifierPlugin("roundProps", $48a43d6d24a69c9e$export$dd12390e6b265a17), $48a43d6d24a69c9e$var$_buildModifierPlugin("modifiers"), $48a43d6d24a69c9e$var$_buildModifierPlugin("snap", $48a43d6d24a69c9e$export$51a0620f7a28532b)) || $48a43d6d24a69c9e$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$48a43d6d24a69c9e$export$208a41d6b4e37b97.version = $48a43d6d24a69c9e$export$e6a97ba2cae5bb94.version = $48a43d6d24a69c9e$export$99ee26438460406a.version = "3.12.2";
$48a43d6d24a69c9e$var$_coreReady = 1;
$48a43d6d24a69c9e$var$_windowExists() && $48a43d6d24a69c9e$var$_wake();
var $48a43d6d24a69c9e$export$2fae1e8613537d5f = $48a43d6d24a69c9e$var$_easeMap.Power0, $48a43d6d24a69c9e$export$5d84ab4efbecec39 = $48a43d6d24a69c9e$var$_easeMap.Power1, $48a43d6d24a69c9e$export$d8c694b7490ad65d = $48a43d6d24a69c9e$var$_easeMap.Power2, $48a43d6d24a69c9e$export$acebdf2b184a0b6f = $48a43d6d24a69c9e$var$_easeMap.Power3, $48a43d6d24a69c9e$export$42e40a141003d2f0 = $48a43d6d24a69c9e$var$_easeMap.Power4, $48a43d6d24a69c9e$export$cff00ccf6e2392de = $48a43d6d24a69c9e$var$_easeMap.Linear, $48a43d6d24a69c9e$export$7005c9eb6671414d = $48a43d6d24a69c9e$var$_easeMap.Quad, $48a43d6d24a69c9e$export$755261d5a1567778 = $48a43d6d24a69c9e$var$_easeMap.Cubic, $48a43d6d24a69c9e$export$daf531446cad3d2a = $48a43d6d24a69c9e$var$_easeMap.Quart, $48a43d6d24a69c9e$export$4c407d38ce8ad8cc = $48a43d6d24a69c9e$var$_easeMap.Quint, $48a43d6d24a69c9e$export$f301627d437cff88 = $48a43d6d24a69c9e$var$_easeMap.Strong, $48a43d6d24a69c9e$export$56ebabebb04a9ca9 = $48a43d6d24a69c9e$var$_easeMap.Elastic, $48a43d6d24a69c9e$export$25e48ac541203d4a = $48a43d6d24a69c9e$var$_easeMap.Back, $48a43d6d24a69c9e$export$f7a11c7543d81853 = $48a43d6d24a69c9e$var$_easeMap.SteppedEase, $48a43d6d24a69c9e$export$d20e79fdc3899e95 = $48a43d6d24a69c9e$var$_easeMap.Bounce, $48a43d6d24a69c9e$export$bed2d20ad96b784c = $48a43d6d24a69c9e$var$_easeMap.Sine, $48a43d6d24a69c9e$export$41e9d1ff1a2fb15a = $48a43d6d24a69c9e$var$_easeMap.Expo, $48a43d6d24a69c9e$export$ce49a57dd865b86c = $48a43d6d24a69c9e$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $3c40134fbe910360$var$_win, $3c40134fbe910360$var$_doc, $3c40134fbe910360$var$_docElement, $3c40134fbe910360$var$_pluginInitted, $3c40134fbe910360$var$_tempDiv, $3c40134fbe910360$var$_tempDivStyler, $3c40134fbe910360$var$_recentSetterPlugin, $3c40134fbe910360$var$_reverting, $3c40134fbe910360$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $3c40134fbe910360$var$_transformProps = {}, $3c40134fbe910360$var$_RAD2DEG = 180 / Math.PI, $3c40134fbe910360$var$_DEG2RAD = Math.PI / 180, $3c40134fbe910360$var$_atan2 = Math.atan2, $3c40134fbe910360$var$_bigNum = 1e8, $3c40134fbe910360$var$_capsExp = /([A-Z])/g, $3c40134fbe910360$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $3c40134fbe910360$var$_complexExp = /[\s,\(]\S/, $3c40134fbe910360$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $3c40134fbe910360$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $3c40134fbe910360$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $3c40134fbe910360$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$3c40134fbe910360$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $3c40134fbe910360$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $3c40134fbe910360$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $3c40134fbe910360$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $3c40134fbe910360$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $3c40134fbe910360$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $3c40134fbe910360$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $3c40134fbe910360$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $3c40134fbe910360$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $3c40134fbe910360$var$_transformProp = "transform", $3c40134fbe910360$var$_transformOriginProp = $3c40134fbe910360$var$_transformProp + "Origin", $3c40134fbe910360$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $3c40134fbe910360$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $3c40134fbe910360$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $3c40134fbe910360$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $3c40134fbe910360$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $3c40134fbe910360$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($3c40134fbe910360$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($3c40134fbe910360$var$_transformOriginProp, isNotCSS, "");
        }
        property = $3c40134fbe910360$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $3c40134fbe910360$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $3c40134fbe910360$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($3c40134fbe910360$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $3c40134fbe910360$var$_reverting();
        if ((!i || !i.isStart) && !style[$3c40134fbe910360$var$_transformProp]) {
            $3c40134fbe910360$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $3c40134fbe910360$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $3c40134fbe910360$var$_revertStyle,
        save: $3c40134fbe910360$var$_saveStyle
    };
    target._gsap || (0, $48a43d6d24a69c9e$export$99ee26438460406a).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $3c40134fbe910360$var$_supports3D, $3c40134fbe910360$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $3c40134fbe910360$var$_doc.createElementNS ? $3c40134fbe910360$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $3c40134fbe910360$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $3c40134fbe910360$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $3c40134fbe910360$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($3c40134fbe910360$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $3c40134fbe910360$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $3c40134fbe910360$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $3c40134fbe910360$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $3c40134fbe910360$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($3c40134fbe910360$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $3c40134fbe910360$var$_prefixes[i] : "") + property;
}, $3c40134fbe910360$var$_initCore = function _initCore() {
    if ($3c40134fbe910360$var$_windowExists() && window.document) {
        $3c40134fbe910360$var$_win = window;
        $3c40134fbe910360$var$_doc = $3c40134fbe910360$var$_win.document;
        $3c40134fbe910360$var$_docElement = $3c40134fbe910360$var$_doc.documentElement;
        $3c40134fbe910360$var$_tempDiv = $3c40134fbe910360$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $3c40134fbe910360$var$_tempDivStyler = $3c40134fbe910360$export$a232bb0480ae674a("div");
        $3c40134fbe910360$var$_transformProp = $3c40134fbe910360$export$8cbef5dd49a09c8b($3c40134fbe910360$var$_transformProp);
        $3c40134fbe910360$var$_transformOriginProp = $3c40134fbe910360$var$_transformProp + "Origin";
        $3c40134fbe910360$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $3c40134fbe910360$var$_supports3D = !!$3c40134fbe910360$export$8cbef5dd49a09c8b("perspective");
        $3c40134fbe910360$var$_reverting = (0, $48a43d6d24a69c9e$export$99ee26438460406a).core.reverting;
        $3c40134fbe910360$var$_pluginInitted = 1;
    }
}, $3c40134fbe910360$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $3c40134fbe910360$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $3c40134fbe910360$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $3c40134fbe910360$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $3c40134fbe910360$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $3c40134fbe910360$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $3c40134fbe910360$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $3c40134fbe910360$var$_getBBoxHack || (bounds = $3c40134fbe910360$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$3c40134fbe910360$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$3c40134fbe910360$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $3c40134fbe910360$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $3c40134fbe910360$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$3c40134fbe910360$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $3c40134fbe910360$var$_transformProps && property !== $3c40134fbe910360$var$_transformOriginProp) property = $3c40134fbe910360$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($3c40134fbe910360$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $3c40134fbe910360$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $3c40134fbe910360$var$_renderNonTweeningValueOnlyAtEnd : $3c40134fbe910360$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $3c40134fbe910360$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $3c40134fbe910360$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$3c40134fbe910360$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $3c40134fbe910360$var$_tempDiv.style, horizontal = $3c40134fbe910360$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $3c40134fbe910360$var$_nonConvertibleUnits[unit] || $3c40134fbe910360$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $3c40134fbe910360$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($3c40134fbe910360$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $3c40134fbe910360$var$_doc || !parent.appendChild) parent = $3c40134fbe910360$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $48a43d6d24a69c9e$export$762ed8fbedb691e3).time && !cache.uncache) return (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$3c40134fbe910360$var$_nonStandardLayouts[$3c40134fbe910360$var$_getComputedProperty(parent, "display")] && (style.position = $3c40134fbe910360$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($3c40134fbe910360$var$_tempDiv);
        px = $3c40134fbe910360$var$_tempDiv[measureProperty];
        parent.removeChild($3c40134fbe910360$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $48a43d6d24a69c9e$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $48a43d6d24a69c9e$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $3c40134fbe910360$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $3c40134fbe910360$var$_pluginInitted || $3c40134fbe910360$var$_initCore();
    if (property in $3c40134fbe910360$var$_propertyAliases && property !== "transform") {
        property = $3c40134fbe910360$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($3c40134fbe910360$var$_transformProps[property] && property !== "transform") {
        value = $3c40134fbe910360$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $3c40134fbe910360$var$_firstTwoOnly($3c40134fbe910360$var$_getComputedProperty(target, $3c40134fbe910360$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $3c40134fbe910360$var$_specialProps[property] && $3c40134fbe910360$var$_specialProps[property](target, property, unit) || $3c40134fbe910360$var$_getComputedProperty(target, property) || (0, $48a43d6d24a69c9e$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $3c40134fbe910360$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $3c40134fbe910360$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $3c40134fbe910360$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $3c40134fbe910360$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $3c40134fbe910360$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $48a43d6d24a69c9e$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $3c40134fbe910360$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $48a43d6d24a69c9e$export$7eb2e5eb5eeb96a4)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $48a43d6d24a69c9e$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $48a43d6d24a69c9e$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $48a43d6d24a69c9e$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $48a43d6d24a69c9e$export$dac762bc6301b560)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $48a43d6d24a69c9e$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $48a43d6d24a69c9e$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $3c40134fbe910360$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $3c40134fbe910360$var$_renderNonTweeningValueOnlyAtEnd : $3c40134fbe910360$var$_renderNonTweeningValue;
    (0, $48a43d6d24a69c9e$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $3c40134fbe910360$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $3c40134fbe910360$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $3c40134fbe910360$var$_keywordToPercent[x] || x;
    split[1] = $3c40134fbe910360$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $3c40134fbe910360$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($3c40134fbe910360$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $3c40134fbe910360$var$_transformOriginProp : $3c40134fbe910360$var$_transformProp;
                }
                $3c40134fbe910360$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $3c40134fbe910360$var$_removeProperty(target, $3c40134fbe910360$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $3c40134fbe910360$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $3c40134fbe910360$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$3c40134fbe910360$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $3c40134fbe910360$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $3c40134fbe910360$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $3c40134fbe910360$var$_rotationalProperties = {}, $3c40134fbe910360$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $3c40134fbe910360$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $3c40134fbe910360$var$_getComputedProperty(target, $3c40134fbe910360$var$_transformProp);
    return $3c40134fbe910360$var$_isNullTransform(matrixString) ? $3c40134fbe910360$var$_identity2DMatrix : matrixString.substr(7).match((0, $48a43d6d24a69c9e$export$b9d44bb6523120d6)).map((0, $48a43d6d24a69c9e$export$9c8d725d65e13f94));
}, $3c40134fbe910360$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $48a43d6d24a69c9e$export$8b9be379d2de2a39)(target), style = target.style, matrix = $3c40134fbe910360$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $3c40134fbe910360$var$_identity2DMatrix : matrix;
    } else if (matrix === $3c40134fbe910360$var$_identity2DMatrix && !target.offsetParent && target !== $3c40134fbe910360$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $3c40134fbe910360$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $3c40134fbe910360$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $3c40134fbe910360$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $3c40134fbe910360$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $3c40134fbe910360$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $3c40134fbe910360$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $3c40134fbe910360$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $3c40134fbe910360$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$3c40134fbe910360$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $3c40134fbe910360$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $3c40134fbe910360$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $3c40134fbe910360$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $3c40134fbe910360$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $3c40134fbe910360$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $48a43d6d24a69c9e$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $3c40134fbe910360$var$_getComputedProperty(target, $3c40134fbe910360$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $3c40134fbe910360$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$3c40134fbe910360$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$3c40134fbe910360$var$_transformProp] !== "none" ? cs[$3c40134fbe910360$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $3c40134fbe910360$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $3c40134fbe910360$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $3c40134fbe910360$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $3c40134fbe910360$var$_atan2(b, a) * $3c40134fbe910360$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $3c40134fbe910360$var$_atan2(c, d) * $3c40134fbe910360$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $3c40134fbe910360$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $3c40134fbe910360$var$_atan2(a32, a33);
            rotationX = angle * $3c40134fbe910360$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $3c40134fbe910360$var$_atan2(-c, a33);
            rotationY = angle * $3c40134fbe910360$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $3c40134fbe910360$var$_atan2(b, a);
            rotation = angle * $3c40134fbe910360$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $3c40134fbe910360$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $3c40134fbe910360$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$3c40134fbe910360$var$_isNullTransform($3c40134fbe910360$var$_getComputedProperty(target, $3c40134fbe910360$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$3c40134fbe910360$var$_transformOriginProp] = $3c40134fbe910360$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $48a43d6d24a69c9e$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $3c40134fbe910360$var$_renderSVGTransforms : $3c40134fbe910360$var$_supports3D ? $3c40134fbe910360$var$_renderCSSTransforms : $3c40134fbe910360$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $3c40134fbe910360$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$3c40134fbe910360$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(start);
    return (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($3c40134fbe910360$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $3c40134fbe910360$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $3c40134fbe910360$var$_renderCSSTransforms(ratio, cache);
}, $3c40134fbe910360$var$_zeroDeg = "0deg", $3c40134fbe910360$var$_zeroPx = "0px", $3c40134fbe910360$var$_endParenthesis = ") ", $3c40134fbe910360$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $3c40134fbe910360$var$_zeroDeg || rotationY !== $3c40134fbe910360$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $3c40134fbe910360$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $3c40134fbe910360$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $3c40134fbe910360$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $3c40134fbe910360$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $3c40134fbe910360$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $3c40134fbe910360$var$_zeroPx) transforms += "perspective(" + transformPerspective + $3c40134fbe910360$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $3c40134fbe910360$var$_zeroPx || y !== $3c40134fbe910360$var$_zeroPx || z !== $3c40134fbe910360$var$_zeroPx) transforms += z !== $3c40134fbe910360$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $3c40134fbe910360$var$_endParenthesis;
    if (rotation !== $3c40134fbe910360$var$_zeroDeg) transforms += "rotate(" + rotation + $3c40134fbe910360$var$_endParenthesis;
    if (rotationY !== $3c40134fbe910360$var$_zeroDeg) transforms += "rotateY(" + rotationY + $3c40134fbe910360$var$_endParenthesis;
    if (rotationX !== $3c40134fbe910360$var$_zeroDeg) transforms += "rotateX(" + rotationX + $3c40134fbe910360$var$_endParenthesis;
    if (skewX !== $3c40134fbe910360$var$_zeroDeg || skewY !== $3c40134fbe910360$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $3c40134fbe910360$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $3c40134fbe910360$var$_endParenthesis;
    target.style[$3c40134fbe910360$var$_transformProp] = transforms || "translate(0, 0)";
}, $3c40134fbe910360$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $3c40134fbe910360$var$_DEG2RAD;
        skewX *= $3c40134fbe910360$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $3c40134fbe910360$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(a11);
        a21 = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(a21);
        a12 = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(a12);
        a22 = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $3c40134fbe910360$var$_convertToUnit(target, "x", x, "px");
        ty = $3c40134fbe910360$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $48a43d6d24a69c9e$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$3c40134fbe910360$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $3c40134fbe910360$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $48a43d6d24a69c9e$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $3c40134fbe910360$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $3c40134fbe910360$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $3c40134fbe910360$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $3c40134fbe910360$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $3c40134fbe910360$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $3c40134fbe910360$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $3c40134fbe910360$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$3c40134fbe910360$var$_transformProp] = transforms;
        endCache = $3c40134fbe910360$var$_parseTransform(target, 1);
        $3c40134fbe910360$var$_removeProperty(target, $3c40134fbe910360$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$3c40134fbe910360$var$_transformProp];
        style[$3c40134fbe910360$var$_transformProp] = transforms;
        endCache = $3c40134fbe910360$var$_parseTransform(target, 1);
        style[$3c40134fbe910360$var$_transformProp] = startValue;
    }
    for(p in $3c40134fbe910360$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $3c40134fbe910360$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(plugin._pt, endCache, p, startNum, endNum - startNum, $3c40134fbe910360$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $3c40134fbe910360$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $48a43d6d24a69c9e$export$f9000b814859f126)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $3c40134fbe910360$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $3c40134fbe910360$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $3c40134fbe910360$export$855822f522f18eef = {
    name: "css",
    register: $3c40134fbe910360$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $3c40134fbe910360$var$_pluginInitted || $3c40134fbe910360$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $3c40134fbe910360$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $48a43d6d24a69c9e$export$d305d8ec5d7c26b8)[p] && (0, $48a43d6d24a69c9e$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $3c40134fbe910360$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $48a43d6d24a69c9e$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $48a43d6d24a69c9e$export$dd733e62515be2bd).lastIndex = 0;
                if (!(0, $48a43d6d24a69c9e$export$dd733e62515be2bd).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(startValue);
                    endUnit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $3c40134fbe910360$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $48a43d6d24a69c9e$export$f664476fd67145ca)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $48a43d6d24a69c9e$export$d5962a97e3cde94d)(startValue));
                    (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(startValue + "") || (startValue += (0, $48a43d6d24a69c9e$export$4922bee768729a77).units[p] || (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)($3c40134fbe910360$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $3c40134fbe910360$var$_get(target, p)); // can't work with relative values
                } else startValue = $3c40134fbe910360$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $3c40134fbe910360$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $3c40134fbe910360$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $3c40134fbe910360$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $3c40134fbe910360$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $3c40134fbe910360$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $3c40134fbe910360$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(this._pt, style, $3c40134fbe910360$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $48a43d6d24a69c9e$export$dac762bc6301b560)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $3c40134fbe910360$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($3c40134fbe910360$var$_transformOriginProp, 0, style[$3c40134fbe910360$var$_transformOriginProp]);
                        endValue = $3c40134fbe910360$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $3c40134fbe910360$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $3c40134fbe910360$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $3c40134fbe910360$var$_addNonTweeningPT(this, style, p, $3c40134fbe910360$var$_firstTwoOnly(startValue), $3c40134fbe910360$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $3c40134fbe910360$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $3c40134fbe910360$var$_rotationalProperties) {
                        $3c40134fbe910360$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $48a43d6d24a69c9e$export$dac762bc6301b560)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $3c40134fbe910360$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $3c40134fbe910360$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $3c40134fbe910360$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$3c40134fbe910360$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $48a43d6d24a69c9e$export$65f2564e9a9b9222)(endValue) || (p in (0, $48a43d6d24a69c9e$export$4922bee768729a77).units ? (0, $48a43d6d24a69c9e$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $3c40134fbe910360$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $48a43d6d24a69c9e$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $48a43d6d24a69c9e$export$dac762bc6301b560)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $3c40134fbe910360$var$_renderRoundedCSSProp : $3c40134fbe910360$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $3c40134fbe910360$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $48a43d6d24a69c9e$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $3c40134fbe910360$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $48a43d6d24a69c9e$export$eed5824f53346d57)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$3c40134fbe910360$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $3c40134fbe910360$var$_get,
    aliases: $3c40134fbe910360$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $3c40134fbe910360$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $3c40134fbe910360$var$_transformProps && property !== $3c40134fbe910360$var$_transformOriginProp && (target._gsap.x || $3c40134fbe910360$var$_get(target, "x")) ? plugin && $3c40134fbe910360$var$_recentSetterPlugin === plugin ? property === "scale" ? $3c40134fbe910360$var$_setterScale : $3c40134fbe910360$var$_setterTransform : ($3c40134fbe910360$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $3c40134fbe910360$var$_setterScaleWithRender : $3c40134fbe910360$var$_setterTransformWithRender) : target.style && !(0, $48a43d6d24a69c9e$export$a8178c063a9fd3a1)(target.style[property]) ? $3c40134fbe910360$var$_setterCSSStyle : ~property.indexOf("-") ? $3c40134fbe910360$var$_setterCSSProp : (0, $48a43d6d24a69c9e$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $3c40134fbe910360$var$_removeProperty,
        _getMatrix: $3c40134fbe910360$var$_getMatrix
    }
};
(0, $48a43d6d24a69c9e$export$99ee26438460406a).utils.checkPrefix = $3c40134fbe910360$export$8cbef5dd49a09c8b;
(0, $48a43d6d24a69c9e$export$99ee26438460406a).core.getStyleSaver = $3c40134fbe910360$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $48a43d6d24a69c9e$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $3c40134fbe910360$var$_transformProps[name] = 1;
    });
    (0, $48a43d6d24a69c9e$export$f9000b814859f126)(rotation, function(name) {
        (0, $48a43d6d24a69c9e$export$4922bee768729a77).units[name] = "deg";
        $3c40134fbe910360$var$_rotationalProperties[name] = 1;
    });
    $3c40134fbe910360$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $48a43d6d24a69c9e$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $3c40134fbe910360$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $48a43d6d24a69c9e$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $48a43d6d24a69c9e$export$4922bee768729a77).units[name] = "px";
});
(0, $48a43d6d24a69c9e$export$99ee26438460406a).registerPlugin($3c40134fbe910360$export$855822f522f18eef);


var $bcde7b69d8e3aef8$export$99ee26438460406a = (0, $48a43d6d24a69c9e$export$99ee26438460406a).registerPlugin((0, $3c40134fbe910360$export$855822f522f18eef)) || (0, $48a43d6d24a69c9e$export$99ee26438460406a), // to protect from tree shaking
$bcde7b69d8e3aef8$export$7b23975ad686bf91 = $bcde7b69d8e3aef8$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $3f3f0a4407c27751$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3f3f0a4407c27751$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3f3f0a4407c27751$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3f3f0a4407c27751$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $3f3f0a4407c27751$var$gsap, $3f3f0a4407c27751$var$_coreInitted, $3f3f0a4407c27751$var$_clamp, $3f3f0a4407c27751$var$_win, $3f3f0a4407c27751$var$_doc, $3f3f0a4407c27751$var$_docEl, $3f3f0a4407c27751$var$_body, $3f3f0a4407c27751$var$_isTouch, $3f3f0a4407c27751$var$_pointerType, $3f3f0a4407c27751$var$ScrollTrigger, $3f3f0a4407c27751$var$_root, $3f3f0a4407c27751$var$_normalizer, $3f3f0a4407c27751$var$_eventTypes, $3f3f0a4407c27751$var$_context, $3f3f0a4407c27751$var$_getGSAP = function _getGSAP() {
    return $3f3f0a4407c27751$var$gsap || typeof window !== "undefined" && ($3f3f0a4407c27751$var$gsap = window.gsap) && $3f3f0a4407c27751$var$gsap.registerPlugin && $3f3f0a4407c27751$var$gsap;
}, $3f3f0a4407c27751$var$_startup = 1, $3f3f0a4407c27751$var$_observers = [], $3f3f0a4407c27751$export$3cd1cee43d19b683 = [], $3f3f0a4407c27751$export$d8e56d510a804d0a = [], $3f3f0a4407c27751$var$_getTime = Date.now, $3f3f0a4407c27751$var$_bridge = function _bridge(name, value) {
    return value;
}, $3f3f0a4407c27751$var$_integrate = function _integrate() {
    var core = $3f3f0a4407c27751$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $3f3f0a4407c27751$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $3f3f0a4407c27751$export$d8e56d510a804d0a);
    $3f3f0a4407c27751$export$3cd1cee43d19b683 = scrollers;
    $3f3f0a4407c27751$export$d8e56d510a804d0a = proxies;
    $3f3f0a4407c27751$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $3f3f0a4407c27751$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$3f3f0a4407c27751$export$d8e56d510a804d0a.indexOf(element) && $3f3f0a4407c27751$export$d8e56d510a804d0a[$3f3f0a4407c27751$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $3f3f0a4407c27751$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$3f3f0a4407c27751$var$_root.indexOf(el);
}, $3f3f0a4407c27751$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $3f3f0a4407c27751$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $3f3f0a4407c27751$var$_scrollLeft = "scrollLeft", $3f3f0a4407c27751$var$_scrollTop = "scrollTop", $3f3f0a4407c27751$var$_onScroll = function _onScroll() {
    return $3f3f0a4407c27751$var$_normalizer && $3f3f0a4407c27751$var$_normalizer.isPressed || $3f3f0a4407c27751$export$3cd1cee43d19b683.cache++;
}, $3f3f0a4407c27751$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $3f3f0a4407c27751$var$_startup && ($3f3f0a4407c27751$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $3f3f0a4407c27751$var$_normalizer && $3f3f0a4407c27751$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($3f3f0a4407c27751$var$_normalizer && $3f3f0a4407c27751$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $3f3f0a4407c27751$export$3cd1cee43d19b683.cache;
            isNormalizing && $3f3f0a4407c27751$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $3f3f0a4407c27751$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $3f3f0a4407c27751$var$_bridge("ref")) {
            cachingFunc.cacheID = $3f3f0a4407c27751$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $3f3f0a4407c27751$export$b2cabb342cb0ebe1 = {
    s: $3f3f0a4407c27751$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $3f3f0a4407c27751$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $3f3f0a4407c27751$var$_win.scrollTo(value, $3f3f0a4407c27751$export$8e40fc98ff518e9d.sc()) : $3f3f0a4407c27751$var$_win.pageXOffset || $3f3f0a4407c27751$var$_doc[$3f3f0a4407c27751$var$_scrollLeft] || $3f3f0a4407c27751$var$_docEl[$3f3f0a4407c27751$var$_scrollLeft] || $3f3f0a4407c27751$var$_body[$3f3f0a4407c27751$var$_scrollLeft] || 0;
    })
}, $3f3f0a4407c27751$export$8e40fc98ff518e9d = {
    s: $3f3f0a4407c27751$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $3f3f0a4407c27751$export$b2cabb342cb0ebe1,
    sc: $3f3f0a4407c27751$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $3f3f0a4407c27751$var$_win.scrollTo($3f3f0a4407c27751$export$b2cabb342cb0ebe1.sc(), value) : $3f3f0a4407c27751$var$_win.pageYOffset || $3f3f0a4407c27751$var$_doc[$3f3f0a4407c27751$var$_scrollTop] || $3f3f0a4407c27751$var$_docEl[$3f3f0a4407c27751$var$_scrollTop] || $3f3f0a4407c27751$var$_body[$3f3f0a4407c27751$var$_scrollTop] || 0;
    })
}, $3f3f0a4407c27751$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $3f3f0a4407c27751$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $3f3f0a4407c27751$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $3f3f0a4407c27751$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $3f3f0a4407c27751$export$4330f3a92e5d2e94(element) && (element = $3f3f0a4407c27751$var$_doc.scrollingElement || $3f3f0a4407c27751$var$_docEl);
    var i = $3f3f0a4407c27751$export$3cd1cee43d19b683.indexOf(element), offset = sc === $3f3f0a4407c27751$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $3f3f0a4407c27751$export$3cd1cee43d19b683.push(element) - 1);
    $3f3f0a4407c27751$export$3cd1cee43d19b683[i + offset] || $3f3f0a4407c27751$var$_addListener(element, "scroll", $3f3f0a4407c27751$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $3f3f0a4407c27751$export$3cd1cee43d19b683[i + offset], func = prev || ($3f3f0a4407c27751$export$3cd1cee43d19b683[i + offset] = $3f3f0a4407c27751$var$_scrollCacheFunc($3f3f0a4407c27751$export$6078f1ef08b38af9(element, s), true) || ($3f3f0a4407c27751$export$4330f3a92e5d2e94(element) ? sc : $3f3f0a4407c27751$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $3f3f0a4407c27751$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $3f3f0a4407c27751$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $3f3f0a4407c27751$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $3f3f0a4407c27751$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $3f3f0a4407c27751$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $3f3f0a4407c27751$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $3f3f0a4407c27751$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $3f3f0a4407c27751$var$_setScrollTrigger = function _setScrollTrigger() {
    $3f3f0a4407c27751$var$ScrollTrigger = $3f3f0a4407c27751$var$gsap.core.globals().ScrollTrigger;
    $3f3f0a4407c27751$var$ScrollTrigger && $3f3f0a4407c27751$var$ScrollTrigger.core && $3f3f0a4407c27751$var$_integrate();
}, $3f3f0a4407c27751$var$_initCore = function _initCore(core) {
    $3f3f0a4407c27751$var$gsap = core || $3f3f0a4407c27751$var$_getGSAP();
    if ($3f3f0a4407c27751$var$gsap && typeof document !== "undefined" && document.body) {
        $3f3f0a4407c27751$var$_win = window;
        $3f3f0a4407c27751$var$_doc = document;
        $3f3f0a4407c27751$var$_docEl = $3f3f0a4407c27751$var$_doc.documentElement;
        $3f3f0a4407c27751$var$_body = $3f3f0a4407c27751$var$_doc.body;
        $3f3f0a4407c27751$var$_root = [
            $3f3f0a4407c27751$var$_win,
            $3f3f0a4407c27751$var$_doc,
            $3f3f0a4407c27751$var$_docEl,
            $3f3f0a4407c27751$var$_body
        ];
        $3f3f0a4407c27751$var$_clamp = $3f3f0a4407c27751$var$gsap.utils.clamp;
        $3f3f0a4407c27751$var$_context = $3f3f0a4407c27751$var$gsap.core.context || function() {};
        $3f3f0a4407c27751$var$_pointerType = "onpointerenter" in $3f3f0a4407c27751$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $3f3f0a4407c27751$var$_isTouch = $3f3f0a4407c27751$export$c1cbdee04e18ea8b.isTouch = $3f3f0a4407c27751$var$_win.matchMedia && $3f3f0a4407c27751$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $3f3f0a4407c27751$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $3f3f0a4407c27751$var$_eventTypes = $3f3f0a4407c27751$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $3f3f0a4407c27751$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $3f3f0a4407c27751$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $3f3f0a4407c27751$var$_startup = 0;
        }, 500);
        $3f3f0a4407c27751$var$_setScrollTrigger();
        $3f3f0a4407c27751$var$_coreInitted = 1;
    }
    return $3f3f0a4407c27751$var$_coreInitted;
};
$3f3f0a4407c27751$export$b2cabb342cb0ebe1.op = $3f3f0a4407c27751$export$8e40fc98ff518e9d;
$3f3f0a4407c27751$export$3cd1cee43d19b683.cache = 0;
var $3f3f0a4407c27751$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $3f3f0a4407c27751$var$_coreInitted || $3f3f0a4407c27751$var$_initCore($3f3f0a4407c27751$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $3f3f0a4407c27751$var$ScrollTrigger || $3f3f0a4407c27751$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $3f3f0a4407c27751$export$937374fea3f88711(target) || $3f3f0a4407c27751$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $3f3f0a4407c27751$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($3f3f0a4407c27751$var$_win.getComputedStyle($3f3f0a4407c27751$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, scrollFuncX = $3f3f0a4407c27751$export$8665aac53dad5647(target, $3f3f0a4407c27751$export$b2cabb342cb0ebe1), scrollFuncY = $3f3f0a4407c27751$export$8665aac53dad5647(target, $3f3f0a4407c27751$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $3f3f0a4407c27751$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $3f3f0a4407c27751$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $3f3f0a4407c27751$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $3f3f0a4407c27751$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $3f3f0a4407c27751$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $3f3f0a4407c27751$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $3f3f0a4407c27751$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $3f3f0a4407c27751$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $3f3f0a4407c27751$var$_addListener(isNormalizer ? target : ownerDoc, $3f3f0a4407c27751$var$_eventTypes[1], _onDrag, preventDefault, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $3f3f0a4407c27751$var$_removeListener(isNormalizer ? target : ownerDoc, $3f3f0a4407c27751$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $3f3f0a4407c27751$var$_getEvent(e);
            if (!wasDragging && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset();
                if (preventDefault && allowClicks) $3f3f0a4407c27751$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($3f3f0a4407c27751$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $3f3f0a4407c27751$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, wasDragging);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $3f3f0a4407c27751$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $3f3f0a4407c27751$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $3f3f0a4407c27751$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $3f3f0a4407c27751$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $3f3f0a4407c27751$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $3f3f0a4407c27751$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $3f3f0a4407c27751$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $3f3f0a4407c27751$var$_addListener(isViewport ? ownerDoc : target, "scroll", $3f3f0a4407c27751$var$_onScroll);
                type.indexOf("scroll") >= 0 && $3f3f0a4407c27751$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, preventDefault, capture);
                type.indexOf("wheel") >= 0 && $3f3f0a4407c27751$var$_addListener(target, "wheel", _onWheel, preventDefault, capture);
                if (type.indexOf("touch") >= 0 && $3f3f0a4407c27751$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $3f3f0a4407c27751$var$_addListener(target, $3f3f0a4407c27751$var$_eventTypes[0], _onPress, preventDefault, capture);
                    $3f3f0a4407c27751$var$_addListener(ownerDoc, $3f3f0a4407c27751$var$_eventTypes[2], _onRelease);
                    $3f3f0a4407c27751$var$_addListener(ownerDoc, $3f3f0a4407c27751$var$_eventTypes[3], _onRelease);
                    allowClicks && $3f3f0a4407c27751$var$_addListener(target, "click", clickCapture, false, true);
                    onClick && $3f3f0a4407c27751$var$_addListener(target, "click", _onClick);
                    onGestureStart && $3f3f0a4407c27751$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $3f3f0a4407c27751$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $3f3f0a4407c27751$var$_addListener(target, $3f3f0a4407c27751$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $3f3f0a4407c27751$var$_addListener(target, $3f3f0a4407c27751$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $3f3f0a4407c27751$var$_addListener(target, $3f3f0a4407c27751$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $3f3f0a4407c27751$var$_observers.filter(function(o) {
                    return o !== self && $3f3f0a4407c27751$export$4330f3a92e5d2e94(o.target);
                }).length || $3f3f0a4407c27751$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $3f3f0a4407c27751$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $3f3f0a4407c27751$var$_removeListener(isNormalizer ? target : ownerDoc, $3f3f0a4407c27751$var$_eventTypes[1], _onDrag, true);
                }
                $3f3f0a4407c27751$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $3f3f0a4407c27751$var$_removeListener(target, "wheel", _onWheel, capture);
                $3f3f0a4407c27751$var$_removeListener(target, $3f3f0a4407c27751$var$_eventTypes[0], _onPress, capture);
                $3f3f0a4407c27751$var$_removeListener(ownerDoc, $3f3f0a4407c27751$var$_eventTypes[2], _onRelease);
                $3f3f0a4407c27751$var$_removeListener(ownerDoc, $3f3f0a4407c27751$var$_eventTypes[3], _onRelease);
                $3f3f0a4407c27751$var$_removeListener(target, "click", clickCapture, true);
                $3f3f0a4407c27751$var$_removeListener(target, "click", _onClick);
                $3f3f0a4407c27751$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $3f3f0a4407c27751$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $3f3f0a4407c27751$var$_removeListener(target, $3f3f0a4407c27751$var$_pointerType + "enter", _onHover);
                $3f3f0a4407c27751$var$_removeListener(target, $3f3f0a4407c27751$var$_pointerType + "leave", _onHoverEnd);
                $3f3f0a4407c27751$var$_removeListener(target, $3f3f0a4407c27751$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $3f3f0a4407c27751$var$_observers.indexOf(self);
            i >= 0 && $3f3f0a4407c27751$var$_observers.splice(i, 1);
            $3f3f0a4407c27751$var$_normalizer === self && ($3f3f0a4407c27751$var$_normalizer = 0);
        };
        $3f3f0a4407c27751$var$_observers.push(self);
        isNormalizer && $3f3f0a4407c27751$export$4330f3a92e5d2e94(target) && ($3f3f0a4407c27751$var$_normalizer = self);
        self.enable(event);
    };
    $3f3f0a4407c27751$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$3f3f0a4407c27751$export$c1cbdee04e18ea8b.version = "3.12.2";
$3f3f0a4407c27751$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $3f3f0a4407c27751$export$c1cbdee04e18ea8b(vars);
};
$3f3f0a4407c27751$export$c1cbdee04e18ea8b.register = $3f3f0a4407c27751$var$_initCore;
$3f3f0a4407c27751$export$c1cbdee04e18ea8b.getAll = function() {
    return $3f3f0a4407c27751$var$_observers.slice();
};
$3f3f0a4407c27751$export$c1cbdee04e18ea8b.getById = function(id) {
    return $3f3f0a4407c27751$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$3f3f0a4407c27751$var$_getGSAP() && $3f3f0a4407c27751$var$gsap.registerPlugin($3f3f0a4407c27751$export$c1cbdee04e18ea8b);


var $d3ebcbb2fcb6c723$var$gsap, $d3ebcbb2fcb6c723$var$_coreInitted, $d3ebcbb2fcb6c723$var$_win, $d3ebcbb2fcb6c723$var$_doc, $d3ebcbb2fcb6c723$var$_docEl, $d3ebcbb2fcb6c723$var$_body, $d3ebcbb2fcb6c723$var$_root, $d3ebcbb2fcb6c723$var$_resizeDelay, $d3ebcbb2fcb6c723$var$_toArray, $d3ebcbb2fcb6c723$var$_clamp, $d3ebcbb2fcb6c723$var$_time2, $d3ebcbb2fcb6c723$var$_syncInterval, $d3ebcbb2fcb6c723$var$_refreshing, $d3ebcbb2fcb6c723$var$_pointerIsDown, $d3ebcbb2fcb6c723$var$_transformProp, $d3ebcbb2fcb6c723$var$_i, $d3ebcbb2fcb6c723$var$_prevWidth, $d3ebcbb2fcb6c723$var$_prevHeight, $d3ebcbb2fcb6c723$var$_autoRefresh, $d3ebcbb2fcb6c723$var$_sort, $d3ebcbb2fcb6c723$var$_suppressOverwrites, $d3ebcbb2fcb6c723$var$_ignoreResize, $d3ebcbb2fcb6c723$var$_normalizer, $d3ebcbb2fcb6c723$var$_ignoreMobileResize, $d3ebcbb2fcb6c723$var$_baseScreenHeight, $d3ebcbb2fcb6c723$var$_baseScreenWidth, $d3ebcbb2fcb6c723$var$_fixIOSBug, $d3ebcbb2fcb6c723$var$_context, $d3ebcbb2fcb6c723$var$_scrollRestoration, $d3ebcbb2fcb6c723$var$_div100vh, $d3ebcbb2fcb6c723$var$_100vh, $d3ebcbb2fcb6c723$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$d3ebcbb2fcb6c723$var$_startup = 1, $d3ebcbb2fcb6c723$var$_getTime = Date.now, $d3ebcbb2fcb6c723$var$_time1 = $d3ebcbb2fcb6c723$var$_getTime(), $d3ebcbb2fcb6c723$var$_lastScrollTime = 0, $d3ebcbb2fcb6c723$var$_enabled = 0, $d3ebcbb2fcb6c723$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $d3ebcbb2fcb6c723$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $d3ebcbb2fcb6c723$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$d3ebcbb2fcb6c723$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $d3ebcbb2fcb6c723$var$_rafBugFix = function _rafBugFix() {
    return $d3ebcbb2fcb6c723$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$d3ebcbb2fcb6c723$var$_pointerDownHandler = function _pointerDownHandler() {
    return $d3ebcbb2fcb6c723$var$_pointerIsDown = 1;
}, $d3ebcbb2fcb6c723$var$_pointerUpHandler = function _pointerUpHandler() {
    return $d3ebcbb2fcb6c723$var$_pointerIsDown = 0;
}, $d3ebcbb2fcb6c723$var$_passThrough = function _passThrough(v) {
    return v;
}, $d3ebcbb2fcb6c723$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $d3ebcbb2fcb6c723$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $d3ebcbb2fcb6c723$var$_getGSAP = function _getGSAP() {
    return $d3ebcbb2fcb6c723$var$gsap || $d3ebcbb2fcb6c723$var$_windowExists() && ($d3ebcbb2fcb6c723$var$gsap = window.gsap) && $d3ebcbb2fcb6c723$var$gsap.registerPlugin && $d3ebcbb2fcb6c723$var$gsap;
}, $d3ebcbb2fcb6c723$var$_isViewport = function _isViewport(e) {
    return !!~$d3ebcbb2fcb6c723$var$_root.indexOf(e);
}, $d3ebcbb2fcb6c723$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $d3ebcbb2fcb6c723$var$_100vh : $d3ebcbb2fcb6c723$var$_win["inner" + dimensionProperty]) || $d3ebcbb2fcb6c723$var$_docEl["client" + dimensionProperty] || $d3ebcbb2fcb6c723$var$_body["client" + dimensionProperty];
}, $d3ebcbb2fcb6c723$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($d3ebcbb2fcb6c723$var$_isViewport(element) ? function() {
        $d3ebcbb2fcb6c723$var$_winOffsets.width = $d3ebcbb2fcb6c723$var$_win.innerWidth;
        $d3ebcbb2fcb6c723$var$_winOffsets.height = $d3ebcbb2fcb6c723$var$_100vh;
        return $d3ebcbb2fcb6c723$var$_winOffsets;
    } : function() {
        return $d3ebcbb2fcb6c723$var$_getBounds(element);
    });
}, $d3ebcbb2fcb6c723$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $d3ebcbb2fcb6c723$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $d3ebcbb2fcb6c723$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $3f3f0a4407c27751$export$d8e56d510a804d0a).indexOf(element) ? $d3ebcbb2fcb6c723$var$_getBoundsFunc(element) : function() {
        return $d3ebcbb2fcb6c723$var$_winOffsets;
    };
}, $d3ebcbb2fcb6c723$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(element, s)) ? a() - $d3ebcbb2fcb6c723$var$_getBoundsFunc(element)()[d] : $d3ebcbb2fcb6c723$var$_isViewport(element) ? ($d3ebcbb2fcb6c723$var$_docEl[s] || $d3ebcbb2fcb6c723$var$_body[s]) - $d3ebcbb2fcb6c723$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $d3ebcbb2fcb6c723$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $d3ebcbb2fcb6c723$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($d3ebcbb2fcb6c723$var$_autoRefresh[i + 1])) && func($d3ebcbb2fcb6c723$var$_autoRefresh[i], $d3ebcbb2fcb6c723$var$_autoRefresh[i + 1], $d3ebcbb2fcb6c723$var$_autoRefresh[i + 2]);
}, $d3ebcbb2fcb6c723$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $d3ebcbb2fcb6c723$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $d3ebcbb2fcb6c723$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $d3ebcbb2fcb6c723$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $d3ebcbb2fcb6c723$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $d3ebcbb2fcb6c723$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $d3ebcbb2fcb6c723$var$_abs = Math.abs, $d3ebcbb2fcb6c723$var$_left = "left", $d3ebcbb2fcb6c723$var$_top = "top", $d3ebcbb2fcb6c723$var$_right = "right", $d3ebcbb2fcb6c723$var$_bottom = "bottom", $d3ebcbb2fcb6c723$var$_width = "width", $d3ebcbb2fcb6c723$var$_height = "height", $d3ebcbb2fcb6c723$var$_Right = "Right", $d3ebcbb2fcb6c723$var$_Left = "Left", $d3ebcbb2fcb6c723$var$_Top = "Top", $d3ebcbb2fcb6c723$var$_Bottom = "Bottom", $d3ebcbb2fcb6c723$var$_padding = "padding", $d3ebcbb2fcb6c723$var$_margin = "margin", $d3ebcbb2fcb6c723$var$_Width = "Width", $d3ebcbb2fcb6c723$var$_Height = "Height", $d3ebcbb2fcb6c723$var$_px = "px", $d3ebcbb2fcb6c723$var$_getComputedStyle = function _getComputedStyle(element) {
    return $d3ebcbb2fcb6c723$var$_win.getComputedStyle(element);
}, $d3ebcbb2fcb6c723$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $d3ebcbb2fcb6c723$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $d3ebcbb2fcb6c723$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $d3ebcbb2fcb6c723$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $d3ebcbb2fcb6c723$var$_getComputedStyle(element)[$d3ebcbb2fcb6c723$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $d3ebcbb2fcb6c723$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $d3ebcbb2fcb6c723$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $d3ebcbb2fcb6c723$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $d3ebcbb2fcb6c723$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $d3ebcbb2fcb6c723$var$gsap.utils.snap($d3ebcbb2fcb6c723$var$_getLabelRatioArray(animation), value);
    };
}, $d3ebcbb2fcb6c723$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $d3ebcbb2fcb6c723$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $d3ebcbb2fcb6c723$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $d3ebcbb2fcb6c723$var$_snapDirectional($d3ebcbb2fcb6c723$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $d3ebcbb2fcb6c723$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $d3ebcbb2fcb6c723$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $d3ebcbb2fcb6c723$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $d3ebcbb2fcb6c723$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $d3ebcbb2fcb6c723$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $d3ebcbb2fcb6c723$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $d3ebcbb2fcb6c723$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $d3ebcbb2fcb6c723$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($d3ebcbb2fcb6c723$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $d3ebcbb2fcb6c723$var$_keywords ? $d3ebcbb2fcb6c723$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $d3ebcbb2fcb6c723$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $d3ebcbb2fcb6c723$var$_doc.createElement("div"), useFixedPosition = $d3ebcbb2fcb6c723$var$_isViewport(container) || (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $d3ebcbb2fcb6c723$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d) ? $d3ebcbb2fcb6c723$var$_right : $d3ebcbb2fcb6c723$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $d3ebcbb2fcb6c723$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $d3ebcbb2fcb6c723$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $d3ebcbb2fcb6c723$var$_Width] = 1;
    vars["border" + oppositeSide + $d3ebcbb2fcb6c723$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $d3ebcbb2fcb6c723$var$gsap.set(marker, vars);
}, $d3ebcbb2fcb6c723$var$_triggers = [], $d3ebcbb2fcb6c723$var$_ids = {}, $d3ebcbb2fcb6c723$var$_rafID, $d3ebcbb2fcb6c723$var$_sync = function _sync() {
    return $d3ebcbb2fcb6c723$var$_getTime() - $d3ebcbb2fcb6c723$var$_lastScrollTime > 34 && ($d3ebcbb2fcb6c723$var$_rafID || ($d3ebcbb2fcb6c723$var$_rafID = requestAnimationFrame($d3ebcbb2fcb6c723$var$_updateAll)));
}, $d3ebcbb2fcb6c723$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$d3ebcbb2fcb6c723$var$_normalizer || !$d3ebcbb2fcb6c723$var$_normalizer.isPressed || $d3ebcbb2fcb6c723$var$_normalizer.startX > $d3ebcbb2fcb6c723$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache++;
        if ($d3ebcbb2fcb6c723$var$_normalizer) $d3ebcbb2fcb6c723$var$_rafID || ($d3ebcbb2fcb6c723$var$_rafID = requestAnimationFrame($d3ebcbb2fcb6c723$var$_updateAll));
        else $d3ebcbb2fcb6c723$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $d3ebcbb2fcb6c723$var$_lastScrollTime || $d3ebcbb2fcb6c723$var$_dispatch("scrollStart");
        $d3ebcbb2fcb6c723$var$_lastScrollTime = $d3ebcbb2fcb6c723$var$_getTime();
    }
}, $d3ebcbb2fcb6c723$var$_setBaseDimensions = function _setBaseDimensions() {
    $d3ebcbb2fcb6c723$var$_baseScreenWidth = $d3ebcbb2fcb6c723$var$_win.innerWidth;
    $d3ebcbb2fcb6c723$var$_baseScreenHeight = $d3ebcbb2fcb6c723$var$_win.innerHeight;
}, $d3ebcbb2fcb6c723$var$_onResize = function _onResize() {
    (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache++;
    !$d3ebcbb2fcb6c723$var$_refreshing && !$d3ebcbb2fcb6c723$var$_ignoreResize && !$d3ebcbb2fcb6c723$var$_doc.fullscreenElement && !$d3ebcbb2fcb6c723$var$_doc.webkitFullscreenElement && (!$d3ebcbb2fcb6c723$var$_ignoreMobileResize || $d3ebcbb2fcb6c723$var$_baseScreenWidth !== $d3ebcbb2fcb6c723$var$_win.innerWidth || Math.abs($d3ebcbb2fcb6c723$var$_win.innerHeight - $d3ebcbb2fcb6c723$var$_baseScreenHeight) > $d3ebcbb2fcb6c723$var$_win.innerHeight * 0.25) && $d3ebcbb2fcb6c723$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$d3ebcbb2fcb6c723$var$_listeners = {}, $d3ebcbb2fcb6c723$var$_emptyArray = [], $d3ebcbb2fcb6c723$var$_softRefresh = function _softRefresh() {
    return $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$export$875bcbe48555930, "scrollEnd", _softRefresh) || $d3ebcbb2fcb6c723$var$_refreshAll(true);
}, $d3ebcbb2fcb6c723$var$_dispatch = function _dispatch(type) {
    return $d3ebcbb2fcb6c723$var$_listeners[type] && $d3ebcbb2fcb6c723$var$_listeners[type].map(function(f) {
        return f();
    }) || $d3ebcbb2fcb6c723$var$_emptyArray;
}, $d3ebcbb2fcb6c723$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$d3ebcbb2fcb6c723$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $d3ebcbb2fcb6c723$var$_savedStyles.length; i += 5)if (!media || $d3ebcbb2fcb6c723$var$_savedStyles[i + 4] && $d3ebcbb2fcb6c723$var$_savedStyles[i + 4].query === media) {
        $d3ebcbb2fcb6c723$var$_savedStyles[i].style.cssText = $d3ebcbb2fcb6c723$var$_savedStyles[i + 1];
        $d3ebcbb2fcb6c723$var$_savedStyles[i].getBBox && $d3ebcbb2fcb6c723$var$_savedStyles[i].setAttribute("transform", $d3ebcbb2fcb6c723$var$_savedStyles[i + 2] || "");
        $d3ebcbb2fcb6c723$var$_savedStyles[i + 3].uncache = 1;
    }
}, $d3ebcbb2fcb6c723$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($d3ebcbb2fcb6c723$var$_i = 0; $d3ebcbb2fcb6c723$var$_i < $d3ebcbb2fcb6c723$var$_triggers.length; $d3ebcbb2fcb6c723$var$_i++){
        trigger = $d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    media && $d3ebcbb2fcb6c723$var$_revertRecorded(media);
    media || $d3ebcbb2fcb6c723$var$_dispatch("revert");
}, $d3ebcbb2fcb6c723$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache++;
    (force || !$d3ebcbb2fcb6c723$var$_refreshingAll) && (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).forEach(function(obj) {
        return $d3ebcbb2fcb6c723$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $d3ebcbb2fcb6c723$var$_isString(scrollRestoration) && ($d3ebcbb2fcb6c723$var$_win.history.scrollRestoration = $d3ebcbb2fcb6c723$var$_scrollRestoration = scrollRestoration);
}, $d3ebcbb2fcb6c723$var$_refreshingAll, $d3ebcbb2fcb6c723$var$_refreshID = 0, $d3ebcbb2fcb6c723$var$_queueRefreshID, $d3ebcbb2fcb6c723$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($d3ebcbb2fcb6c723$var$_queueRefreshID !== $d3ebcbb2fcb6c723$var$_refreshID) {
        var id = $d3ebcbb2fcb6c723$var$_queueRefreshID = $d3ebcbb2fcb6c723$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $d3ebcbb2fcb6c723$var$_refreshID && $d3ebcbb2fcb6c723$var$_refreshAll(true);
        });
    }
}, $d3ebcbb2fcb6c723$var$_refresh100vh = function _refresh100vh() {
    $d3ebcbb2fcb6c723$var$_body.appendChild($d3ebcbb2fcb6c723$var$_div100vh);
    $d3ebcbb2fcb6c723$var$_100vh = $d3ebcbb2fcb6c723$var$_div100vh.offsetHeight || $d3ebcbb2fcb6c723$var$_win.innerHeight;
    $d3ebcbb2fcb6c723$var$_body.removeChild($d3ebcbb2fcb6c723$var$_div100vh);
}, $d3ebcbb2fcb6c723$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($d3ebcbb2fcb6c723$var$_lastScrollTime && !force) {
        $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$export$875bcbe48555930, "scrollEnd", $d3ebcbb2fcb6c723$var$_softRefresh);
        return;
    }
    $d3ebcbb2fcb6c723$var$_refresh100vh();
    $d3ebcbb2fcb6c723$var$_refreshingAll = $d3ebcbb2fcb6c723$export$875bcbe48555930.isRefreshing = true;
    (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).forEach(function(obj) {
        return $d3ebcbb2fcb6c723$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $d3ebcbb2fcb6c723$var$_dispatch("refreshInit");
    $d3ebcbb2fcb6c723$var$_sort && $d3ebcbb2fcb6c723$export$875bcbe48555930.sort();
    skipRevert || $d3ebcbb2fcb6c723$var$_revertAll();
    (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($d3ebcbb2fcb6c723$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $d3ebcbb2fcb6c723$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t, i) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $d3ebcbb2fcb6c723$var$_maxScroll(t.scroller, t._dir);
        (t.vars.end === "max" || t._endClamp && t.end > max) && t.setPositions(t.start, Math.max(t.start + 1, max), true);
    });
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($d3ebcbb2fcb6c723$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $d3ebcbb2fcb6c723$var$_clearScrollMemory($d3ebcbb2fcb6c723$var$_scrollRestoration, 1);
    $d3ebcbb2fcb6c723$var$_resizeDelay.pause();
    $d3ebcbb2fcb6c723$var$_refreshID++;
    $d3ebcbb2fcb6c723$var$_refreshingAll = 2;
    $d3ebcbb2fcb6c723$var$_updateAll(2);
    $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
        return $d3ebcbb2fcb6c723$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $d3ebcbb2fcb6c723$var$_refreshingAll = $d3ebcbb2fcb6c723$export$875bcbe48555930.isRefreshing = false;
    $d3ebcbb2fcb6c723$var$_dispatch("refresh");
}, $d3ebcbb2fcb6c723$var$_lastScroll = 0, $d3ebcbb2fcb6c723$var$_direction = 1, $d3ebcbb2fcb6c723$var$_primary, $d3ebcbb2fcb6c723$var$_updateAll = function _updateAll(force) {
    if (!$d3ebcbb2fcb6c723$var$_refreshingAll || force === 2) {
        $d3ebcbb2fcb6c723$export$875bcbe48555930.isUpdating = true;
        $d3ebcbb2fcb6c723$var$_primary && $d3ebcbb2fcb6c723$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $d3ebcbb2fcb6c723$var$_triggers.length, time = $d3ebcbb2fcb6c723$var$_getTime(), recordVelocity = time - $d3ebcbb2fcb6c723$var$_time1 >= 50, scroll = l && $d3ebcbb2fcb6c723$var$_triggers[0].scroll();
        $d3ebcbb2fcb6c723$var$_direction = $d3ebcbb2fcb6c723$var$_lastScroll > scroll ? -1 : 1;
        $d3ebcbb2fcb6c723$var$_refreshingAll || ($d3ebcbb2fcb6c723$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($d3ebcbb2fcb6c723$var$_lastScrollTime && !$d3ebcbb2fcb6c723$var$_pointerIsDown && time - $d3ebcbb2fcb6c723$var$_lastScrollTime > 200) {
                $d3ebcbb2fcb6c723$var$_lastScrollTime = 0;
                $d3ebcbb2fcb6c723$var$_dispatch("scrollEnd");
            }
            $d3ebcbb2fcb6c723$var$_time2 = $d3ebcbb2fcb6c723$var$_time1;
            $d3ebcbb2fcb6c723$var$_time1 = time;
        }
        if ($d3ebcbb2fcb6c723$var$_direction < 0) {
            $d3ebcbb2fcb6c723$var$_i = l;
            while($d3ebcbb2fcb6c723$var$_i-- > 0)$d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_i] && $d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_i].update(0, recordVelocity);
            $d3ebcbb2fcb6c723$var$_direction = 1;
        } else for($d3ebcbb2fcb6c723$var$_i = 0; $d3ebcbb2fcb6c723$var$_i < l; $d3ebcbb2fcb6c723$var$_i++)$d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_i] && $d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_i].update(0, recordVelocity);
        $d3ebcbb2fcb6c723$export$875bcbe48555930.isUpdating = false;
    }
    $d3ebcbb2fcb6c723$var$_rafID = 0;
}, $d3ebcbb2fcb6c723$var$_propNamesToCopy = [
    $d3ebcbb2fcb6c723$var$_left,
    $d3ebcbb2fcb6c723$var$_top,
    $d3ebcbb2fcb6c723$var$_bottom,
    $d3ebcbb2fcb6c723$var$_right,
    $d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Bottom,
    $d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Right,
    $d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Top,
    $d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $d3ebcbb2fcb6c723$var$_stateProps = $d3ebcbb2fcb6c723$var$_propNamesToCopy.concat([
    $d3ebcbb2fcb6c723$var$_width,
    $d3ebcbb2fcb6c723$var$_height,
    "boxSizing",
    "max" + $d3ebcbb2fcb6c723$var$_Width,
    "max" + $d3ebcbb2fcb6c723$var$_Height,
    "position",
    $d3ebcbb2fcb6c723$var$_margin,
    $d3ebcbb2fcb6c723$var$_padding,
    $d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Top,
    $d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Right,
    $d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Bottom,
    $d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Left
]), $d3ebcbb2fcb6c723$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $d3ebcbb2fcb6c723$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $d3ebcbb2fcb6c723$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $d3ebcbb2fcb6c723$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $d3ebcbb2fcb6c723$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $d3ebcbb2fcb6c723$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$d3ebcbb2fcb6c723$var$_bottom] = pinStyle[$d3ebcbb2fcb6c723$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$d3ebcbb2fcb6c723$var$_width] = $d3ebcbb2fcb6c723$var$_getSize(pin, (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1)) + $d3ebcbb2fcb6c723$var$_px;
        spacerStyle[$d3ebcbb2fcb6c723$var$_height] = $d3ebcbb2fcb6c723$var$_getSize(pin, (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d)) + $d3ebcbb2fcb6c723$var$_px;
        spacerStyle[$d3ebcbb2fcb6c723$var$_padding] = pinStyle[$d3ebcbb2fcb6c723$var$_margin] = pinStyle[$d3ebcbb2fcb6c723$var$_top] = pinStyle[$d3ebcbb2fcb6c723$var$_left] = "0";
        $d3ebcbb2fcb6c723$var$_setState(spacerState);
        pinStyle[$d3ebcbb2fcb6c723$var$_width] = pinStyle["max" + $d3ebcbb2fcb6c723$var$_Width] = cs[$d3ebcbb2fcb6c723$var$_width];
        pinStyle[$d3ebcbb2fcb6c723$var$_height] = pinStyle["max" + $d3ebcbb2fcb6c723$var$_Height] = cs[$d3ebcbb2fcb6c723$var$_height];
        pinStyle[$d3ebcbb2fcb6c723$var$_padding] = cs[$d3ebcbb2fcb6c723$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $d3ebcbb2fcb6c723$var$_capsExp = /([A-Z])/g, $d3ebcbb2fcb6c723$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $d3ebcbb2fcb6c723$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($d3ebcbb2fcb6c723$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $d3ebcbb2fcb6c723$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $d3ebcbb2fcb6c723$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($d3ebcbb2fcb6c723$var$_stateProps[i], style[$d3ebcbb2fcb6c723$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $d3ebcbb2fcb6c723$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $d3ebcbb2fcb6c723$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$d3ebcbb2fcb6c723$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $d3ebcbb2fcb6c723$var$_isFunction(value) && (value = value(self));
    if ($d3ebcbb2fcb6c723$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $d3ebcbb2fcb6c723$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$d3ebcbb2fcb6c723$var$_isNumber(value)) {
        $d3ebcbb2fcb6c723$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $3f3f0a4407c27751$export$937374fea3f88711)(trigger, self) || $d3ebcbb2fcb6c723$var$_body;
        bounds = $d3ebcbb2fcb6c723$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $d3ebcbb2fcb6c723$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $d3ebcbb2fcb6c723$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $d3ebcbb2fcb6c723$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $d3ebcbb2fcb6c723$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $d3ebcbb2fcb6c723$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $d3ebcbb2fcb6c723$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $d3ebcbb2fcb6c723$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $d3ebcbb2fcb6c723$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($d3ebcbb2fcb6c723$var$_body[p1], $d3ebcbb2fcb6c723$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $d3ebcbb2fcb6c723$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $d3ebcbb2fcb6c723$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $d3ebcbb2fcb6c723$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $d3ebcbb2fcb6c723$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $d3ebcbb2fcb6c723$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $d3ebcbb2fcb6c723$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $d3ebcbb2fcb6c723$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $d3ebcbb2fcb6c723$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$d3ebcbb2fcb6c723$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $d3ebcbb2fcb6c723$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $d3ebcbb2fcb6c723$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $d3ebcbb2fcb6c723$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $d3ebcbb2fcb6c723$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$d3ebcbb2fcb6c723$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $3f3f0a4407c27751$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $d3ebcbb2fcb6c723$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache++;
            $d3ebcbb2fcb6c723$var$_updateAll();
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $d3ebcbb2fcb6c723$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $d3ebcbb2fcb6c723$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $d3ebcbb2fcb6c723$export$875bcbe48555930.isTouch && $d3ebcbb2fcb6c723$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $d3ebcbb2fcb6c723$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $d3ebcbb2fcb6c723$var$_coreInitted || ScrollTrigger.register($d3ebcbb2fcb6c723$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $d3ebcbb2fcb6c723$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$d3ebcbb2fcb6c723$var$_enabled) {
            this.update = this.refresh = this.kill = $d3ebcbb2fcb6c723$var$_passThrough;
            return;
        }
        vars = $d3ebcbb2fcb6c723$var$_setDefaults($d3ebcbb2fcb6c723$var$_isString(vars) || $d3ebcbb2fcb6c723$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $d3ebcbb2fcb6c723$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1) : (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $3f3f0a4407c27751$export$937374fea3f88711)(vars.scroller || $d3ebcbb2fcb6c723$var$_win), scrollerCache = $d3ebcbb2fcb6c723$var$gsap.core.getCache(scroller), isViewport = $d3ebcbb2fcb6c723$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $d3ebcbb2fcb6c723$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($d3ebcbb2fcb6c723$var$_getComputedStyle(scroller)["border" + direction.p2 + $d3ebcbb2fcb6c723$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $d3ebcbb2fcb6c723$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $d3ebcbb2fcb6c723$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $3f3f0a4407c27751$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $d3ebcbb2fcb6c723$var$_sort = 1;
            vars.refreshPriority === -9999 && ($d3ebcbb2fcb6c723$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $d3ebcbb2fcb6c723$var$_getTweenCreator(scroller, (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d)),
            left: $d3ebcbb2fcb6c723$var$_getTweenCreator(scroller, (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $d3ebcbb2fcb6c723$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $d3ebcbb2fcb6c723$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://greensock.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$d3ebcbb2fcb6c723$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $d3ebcbb2fcb6c723$var$_body.style && $d3ebcbb2fcb6c723$var$gsap.set(isViewport ? [
                $d3ebcbb2fcb6c723$var$_body,
                $d3ebcbb2fcb6c723$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).forEach(function(o) {
                return $d3ebcbb2fcb6c723$var$_isFunction(o) && o.target === (isViewport ? $d3ebcbb2fcb6c723$var$_doc.scrollingElement || $d3ebcbb2fcb6c723$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $d3ebcbb2fcb6c723$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $d3ebcbb2fcb6c723$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $d3ebcbb2fcb6c723$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $d3ebcbb2fcb6c723$var$_snapDirectional(snap.snapTo)(value, $d3ebcbb2fcb6c723$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $d3ebcbb2fcb6c723$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $d3ebcbb2fcb6c723$var$_isObject(snapDurClamp) ? $d3ebcbb2fcb6c723$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $d3ebcbb2fcb6c723$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $d3ebcbb2fcb6c723$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $d3ebcbb2fcb6c723$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$d3ebcbb2fcb6c723$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($d3ebcbb2fcb6c723$var$_getTime() - $d3ebcbb2fcb6c723$var$_time2) * 1000 || 0, change1 = $d3ebcbb2fcb6c723$var$gsap.utils.clamp(-progress, 1 - progress, $d3ebcbb2fcb6c723$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue = $d3ebcbb2fcb6c723$var$_clamp(0, 1, snapFunc(naturalEnd, self)), endScroll = Math.round(start + endValue * change), _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $d3ebcbb2fcb6c723$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($d3ebcbb2fcb6c723$var$_abs(Math.max($d3ebcbb2fcb6c723$var$_abs(naturalEnd - totalProgress), $d3ebcbb2fcb6c723$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $d3ebcbb2fcb6c723$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($d3ebcbb2fcb6c723$var$_ids[id] = self);
        trigger = self.trigger = (0, $3f3f0a4407c27751$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $3f3f0a4407c27751$export$937374fea3f88711)(pin);
        $d3ebcbb2fcb6c723$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $d3ebcbb2fcb6c723$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $d3ebcbb2fcb6c723$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $d3ebcbb2fcb6c723$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $d3ebcbb2fcb6c723$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $3f3f0a4407c27751$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $d3ebcbb2fcb6c723$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $d3ebcbb2fcb6c723$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $d3ebcbb2fcb6c723$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $d3ebcbb2fcb6c723$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $d3ebcbb2fcb6c723$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $d3ebcbb2fcb6c723$var$gsap.getProperty(pin);
            pinSetter = $d3ebcbb2fcb6c723$var$gsap.quickSetter(pin, direction.a, $d3ebcbb2fcb6c723$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $d3ebcbb2fcb6c723$var$_swapPinIn(pin, spacer, cs);
            pinState = $d3ebcbb2fcb6c723$var$_getState(pin);
        }
        if (markers) {
            markerVars = $d3ebcbb2fcb6c723$var$_isObject(markers) ? $d3ebcbb2fcb6c723$var$_setDefaults(markers, $d3ebcbb2fcb6c723$var$_markerDefaults) : $d3ebcbb2fcb6c723$var$_markerDefaults;
            markerStartTrigger = $d3ebcbb2fcb6c723$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $d3ebcbb2fcb6c723$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $3f3f0a4407c27751$export$937374fea3f88711)((0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $d3ebcbb2fcb6c723$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $d3ebcbb2fcb6c723$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $d3ebcbb2fcb6c723$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $d3ebcbb2fcb6c723$var$_px));
            if (!useFixedPosition && !((0, $3f3f0a4407c27751$export$d8e56d510a804d0a).length && (0, $3f3f0a4407c27751$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $d3ebcbb2fcb6c723$var$_makePositionable(isViewport ? $d3ebcbb2fcb6c723$var$_body : scroller);
                $d3ebcbb2fcb6c723$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $d3ebcbb2fcb6c723$var$gsap.quickSetter(markerStartTrigger, direction.a, $d3ebcbb2fcb6c723$var$_px);
                markerEndSetter = $d3ebcbb2fcb6c723$var$gsap.quickSetter(markerEndTrigger, direction.a, $d3ebcbb2fcb6c723$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $d3ebcbb2fcb6c723$var$_triggers[$d3ebcbb2fcb6c723$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $d3ebcbb2fcb6c723$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $d3ebcbb2fcb6c723$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $d3ebcbb2fcb6c723$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $d3ebcbb2fcb6c723$var$_swapPinIn(pin, spacer, $d3ebcbb2fcb6c723$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $d3ebcbb2fcb6c723$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($d3ebcbb2fcb6c723$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $d3ebcbb2fcb6c723$var$_lastScrollTime) {
                $d3ebcbb2fcb6c723$var$_addListener(ScrollTrigger, "scrollEnd", $d3ebcbb2fcb6c723$var$_softRefresh);
                return;
            }
            !$d3ebcbb2fcb6c723$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $d3ebcbb2fcb6c723$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $d3ebcbb2fcb6c723$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $d3ebcbb2fcb6c723$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $d3ebcbb2fcb6c723$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $3f3f0a4407c27751$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $d3ebcbb2fcb6c723$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $d3ebcbb2fcb6c723$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $d3ebcbb2fcb6c723$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $d3ebcbb2fcb6c723$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $d3ebcbb2fcb6c723$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($d3ebcbb2fcb6c723$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $d3ebcbb2fcb6c723$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $d3ebcbb2fcb6c723$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $d3ebcbb2fcb6c723$var$_parseClamp(parsedStart, "start", self);
            start = $d3ebcbb2fcb6c723$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $d3ebcbb2fcb6c723$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($d3ebcbb2fcb6c723$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($d3ebcbb2fcb6c723$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $d3ebcbb2fcb6c723$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $d3ebcbb2fcb6c723$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $d3ebcbb2fcb6c723$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $d3ebcbb2fcb6c723$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $d3ebcbb2fcb6c723$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $d3ebcbb2fcb6c723$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$d3ebcbb2fcb6c723$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $d3ebcbb2fcb6c723$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $d3ebcbb2fcb6c723$var$gsap.utils.clamp(0, 1, $d3ebcbb2fcb6c723$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $d3ebcbb2fcb6c723$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $d3ebcbb2fcb6c723$var$_getComputedStyle(pin);
                isVertical = direction === (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $d3ebcbb2fcb6c723$var$_doc.scrollingElement || $d3ebcbb2fcb6c723$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $d3ebcbb2fcb6c723$var$_getComputedStyle($d3ebcbb2fcb6c723$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $d3ebcbb2fcb6c723$var$_swapPinIn(pin, spacer, cs);
                pinState = $d3ebcbb2fcb6c723$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $d3ebcbb2fcb6c723$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $3f3f0a4407c27751$export$8665aac53dad5647)(scroller, isVertical ? (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1) : (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $d3ebcbb2fcb6c723$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $d3ebcbb2fcb6c723$var$_padding ? $d3ebcbb2fcb6c723$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $d3ebcbb2fcb6c723$var$_px); // for box-sizing: border-box (must include padding).
                    $d3ebcbb2fcb6c723$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $d3ebcbb2fcb6c723$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $d3ebcbb2fcb6c723$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$d3ebcbb2fcb6c723$var$_width] = override["max" + $d3ebcbb2fcb6c723$var$_Width] = Math.ceil(bounds.width) + $d3ebcbb2fcb6c723$var$_px;
                    override[$d3ebcbb2fcb6c723$var$_height] = override["max" + $d3ebcbb2fcb6c723$var$_Height] = Math.ceil(bounds.height) + $d3ebcbb2fcb6c723$var$_px;
                    override[$d3ebcbb2fcb6c723$var$_margin] = override[$d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Top] = override[$d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Right] = override[$d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Bottom] = override[$d3ebcbb2fcb6c723$var$_margin + $d3ebcbb2fcb6c723$var$_Left] = "0";
                    override[$d3ebcbb2fcb6c723$var$_padding] = cs[$d3ebcbb2fcb6c723$var$_padding];
                    override[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Top] = cs[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Top];
                    override[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Right] = cs[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Right];
                    override[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Bottom] = cs[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Bottom];
                    override[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Left] = cs[$d3ebcbb2fcb6c723$var$_padding + $d3ebcbb2fcb6c723$var$_Left];
                    pinActiveState = $d3ebcbb2fcb6c723$var$_copyState(pinOriginalState, override, pinReparent);
                    $d3ebcbb2fcb6c723$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $d3ebcbb2fcb6c723$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $d3ebcbb2fcb6c723$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $d3ebcbb2fcb6c723$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $d3ebcbb2fcb6c723$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$d3ebcbb2fcb6c723$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $d3ebcbb2fcb6c723$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $d3ebcbb2fcb6c723$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $d3ebcbb2fcb6c723$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $d3ebcbb2fcb6c723$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $d3ebcbb2fcb6c723$var$gsap.getProperty(markerEndTrigger, direction.p);
                $d3ebcbb2fcb6c723$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $d3ebcbb2fcb6c723$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $d3ebcbb2fcb6c723$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $d3ebcbb2fcb6c723$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$d3ebcbb2fcb6c723$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$d3ebcbb2fcb6c723$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($d3ebcbb2fcb6c723$var$_getTime() - $d3ebcbb2fcb6c723$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $d3ebcbb2fcb6c723$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $d3ebcbb2fcb6c723$var$_endAnimation(animation, animation.reversed()) : isToggle || $d3ebcbb2fcb6c723$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $d3ebcbb2fcb6c723$var$_triggers.indexOf(self), a = self.direction > 0 ? $d3ebcbb2fcb6c723$var$_triggers.slice(0, i).reverse() : $d3ebcbb2fcb6c723$var$_triggers.slice(i + 1);
            return ($d3ebcbb2fcb6c723$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $d3ebcbb2fcb6c723$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$d3ebcbb2fcb6c723$var$_refreshing && !$d3ebcbb2fcb6c723$var$_startup && $d3ebcbb2fcb6c723$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($d3ebcbb2fcb6c723$var$_getTime() - $d3ebcbb2fcb6c723$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$d3ebcbb2fcb6c723$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($d3ebcbb2fcb6c723$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$d3ebcbb2fcb6c723$var$_refreshing && !$d3ebcbb2fcb6c723$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($d3ebcbb2fcb6c723$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($d3ebcbb2fcb6c723$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $d3ebcbb2fcb6c723$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $d3ebcbb2fcb6c723$var$_getBounds(pin, true), _offset = scroll - start;
                                $d3ebcbb2fcb6c723$var$_reparent(pin, $d3ebcbb2fcb6c723$var$_body, bounds.top + (direction === (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d) ? _offset : 0) + $d3ebcbb2fcb6c723$var$_px, bounds.left + (direction === (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d) ? 0 : _offset) + $d3ebcbb2fcb6c723$var$_px);
                            } else $d3ebcbb2fcb6c723$var$_reparent(pin, spacer);
                        }
                        $d3ebcbb2fcb6c723$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$d3ebcbb2fcb6c723$var$_refreshing && !$d3ebcbb2fcb6c723$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$d3ebcbb2fcb6c723$var$_limitCallbacks)) && $d3ebcbb2fcb6c723$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$d3ebcbb2fcb6c723$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$d3ebcbb2fcb6c723$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $d3ebcbb2fcb6c723$var$_callback(self, onToggle);
                        callbacks[toggleState] && $d3ebcbb2fcb6c723$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $d3ebcbb2fcb6c723$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($d3ebcbb2fcb6c723$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $d3ebcbb2fcb6c723$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $d3ebcbb2fcb6c723$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$d3ebcbb2fcb6c723$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $d3ebcbb2fcb6c723$var$_addListener(scroller, "resize", $d3ebcbb2fcb6c723$var$_onResize);
                isViewport || $d3ebcbb2fcb6c723$var$_addListener(scroller, "scroll", $d3ebcbb2fcb6c723$var$_onScroll);
                onRefreshInit && $d3ebcbb2fcb6c723$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $d3ebcbb2fcb6c723$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $d3ebcbb2fcb6c723$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $d3ebcbb2fcb6c723$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $d3ebcbb2fcb6c723$var$_px;
                $d3ebcbb2fcb6c723$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $d3ebcbb2fcb6c723$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $d3ebcbb2fcb6c723$var$_triggers.length;
                    while(i--){
                        if ($d3ebcbb2fcb6c723$var$_triggers[i].scroller === scroller && $d3ebcbb2fcb6c723$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $d3ebcbb2fcb6c723$var$_removeListener(scroller, "resize", $d3ebcbb2fcb6c723$var$_onResize);
                    isViewport || $d3ebcbb2fcb6c723$var$_removeListener(scroller, "scroll", $d3ebcbb2fcb6c723$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $d3ebcbb2fcb6c723$var$_ids[id];
            var i = $d3ebcbb2fcb6c723$var$_triggers.indexOf(self);
            i >= 0 && $d3ebcbb2fcb6c723$var$_triggers.splice(i, 1);
            i === $d3ebcbb2fcb6c723$var$_i && $d3ebcbb2fcb6c723$var$_direction > 0 && $d3ebcbb2fcb6c723$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $d3ebcbb2fcb6c723$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $d3ebcbb2fcb6c723$var$_primary === self && ($d3ebcbb2fcb6c723$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $d3ebcbb2fcb6c723$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $d3ebcbb2fcb6c723$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $d3ebcbb2fcb6c723$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$d3ebcbb2fcb6c723$var$_coreInitted) {
            $d3ebcbb2fcb6c723$var$gsap = core || $d3ebcbb2fcb6c723$var$_getGSAP();
            $d3ebcbb2fcb6c723$var$_windowExists() && window.document && ScrollTrigger.enable();
            $d3ebcbb2fcb6c723$var$_coreInitted = $d3ebcbb2fcb6c723$var$_enabled;
        }
        return $d3ebcbb2fcb6c723$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$d3ebcbb2fcb6c723$var$_defaults[p] = config[p];
        return $d3ebcbb2fcb6c723$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $d3ebcbb2fcb6c723$var$_enabled = 0;
        $d3ebcbb2fcb6c723$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_win, "wheel", $d3ebcbb2fcb6c723$var$_onScroll);
        $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_doc, "scroll", $d3ebcbb2fcb6c723$var$_onScroll);
        clearInterval($d3ebcbb2fcb6c723$var$_syncInterval);
        $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_doc, "touchcancel", $d3ebcbb2fcb6c723$var$_passThrough);
        $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_body, "touchstart", $d3ebcbb2fcb6c723$var$_passThrough);
        $d3ebcbb2fcb6c723$var$_multiListener($d3ebcbb2fcb6c723$var$_removeListener, $d3ebcbb2fcb6c723$var$_doc, "pointerdown,touchstart,mousedown", $d3ebcbb2fcb6c723$var$_pointerDownHandler);
        $d3ebcbb2fcb6c723$var$_multiListener($d3ebcbb2fcb6c723$var$_removeListener, $d3ebcbb2fcb6c723$var$_doc, "pointerup,touchend,mouseup", $d3ebcbb2fcb6c723$var$_pointerUpHandler);
        $d3ebcbb2fcb6c723$var$_resizeDelay.kill();
        $d3ebcbb2fcb6c723$var$_iterateAutoRefresh($d3ebcbb2fcb6c723$var$_removeListener);
        for(var i = 0; i < (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).length; i += 3){
            $d3ebcbb2fcb6c723$var$_wheelListener($d3ebcbb2fcb6c723$var$_removeListener, (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i], (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i + 1]);
            $d3ebcbb2fcb6c723$var$_wheelListener($d3ebcbb2fcb6c723$var$_removeListener, (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i], (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $d3ebcbb2fcb6c723$var$_win = window;
        $d3ebcbb2fcb6c723$var$_doc = document;
        $d3ebcbb2fcb6c723$var$_docEl = $d3ebcbb2fcb6c723$var$_doc.documentElement;
        $d3ebcbb2fcb6c723$var$_body = $d3ebcbb2fcb6c723$var$_doc.body;
        if ($d3ebcbb2fcb6c723$var$gsap) {
            $d3ebcbb2fcb6c723$var$_toArray = $d3ebcbb2fcb6c723$var$gsap.utils.toArray;
            $d3ebcbb2fcb6c723$var$_clamp = $d3ebcbb2fcb6c723$var$gsap.utils.clamp;
            $d3ebcbb2fcb6c723$var$_context = $d3ebcbb2fcb6c723$var$gsap.core.context || $d3ebcbb2fcb6c723$var$_passThrough;
            $d3ebcbb2fcb6c723$var$_suppressOverwrites = $d3ebcbb2fcb6c723$var$gsap.core.suppressOverwrites || $d3ebcbb2fcb6c723$var$_passThrough;
            $d3ebcbb2fcb6c723$var$_scrollRestoration = $d3ebcbb2fcb6c723$var$_win.history.scrollRestoration || "auto";
            $d3ebcbb2fcb6c723$var$_lastScroll = $d3ebcbb2fcb6c723$var$_win.pageYOffset;
            $d3ebcbb2fcb6c723$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($d3ebcbb2fcb6c723$var$_body) {
                $d3ebcbb2fcb6c723$var$_enabled = 1;
                $d3ebcbb2fcb6c723$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $d3ebcbb2fcb6c723$var$_div100vh.style.height = "100vh";
                $d3ebcbb2fcb6c723$var$_div100vh.style.position = "absolute";
                $d3ebcbb2fcb6c723$var$_refresh100vh();
                $d3ebcbb2fcb6c723$var$_rafBugFix();
                (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).register($d3ebcbb2fcb6c723$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).isTouch;
                $d3ebcbb2fcb6c723$var$_fixIOSBug = (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_win, "wheel", $d3ebcbb2fcb6c723$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $d3ebcbb2fcb6c723$var$_root = [
                    $d3ebcbb2fcb6c723$var$_win,
                    $d3ebcbb2fcb6c723$var$_doc,
                    $d3ebcbb2fcb6c723$var$_docEl,
                    $d3ebcbb2fcb6c723$var$_body
                ];
                if ($d3ebcbb2fcb6c723$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $d3ebcbb2fcb6c723$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $d3ebcbb2fcb6c723$var$gsap.addEventListener("matchMediaInit", function() {
                        return $d3ebcbb2fcb6c723$var$_revertAll();
                    });
                    $d3ebcbb2fcb6c723$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $d3ebcbb2fcb6c723$var$_revertRecorded();
                    });
                    $d3ebcbb2fcb6c723$var$gsap.addEventListener("matchMedia", function() {
                        $d3ebcbb2fcb6c723$var$_refreshAll(0, 1);
                        $d3ebcbb2fcb6c723$var$_dispatch("matchMedia");
                    });
                    $d3ebcbb2fcb6c723$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $d3ebcbb2fcb6c723$var$_setBaseDimensions();
                        return $d3ebcbb2fcb6c723$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $d3ebcbb2fcb6c723$var$_setBaseDimensions();
                $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_doc, "scroll", $d3ebcbb2fcb6c723$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $d3ebcbb2fcb6c723$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $d3ebcbb2fcb6c723$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $d3ebcbb2fcb6c723$var$_getBounds($d3ebcbb2fcb6c723$var$_body);
                (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $d3ebcbb2fcb6c723$var$_syncInterval = setInterval($d3ebcbb2fcb6c723$var$_sync, 250);
                $d3ebcbb2fcb6c723$var$gsap.delayedCall(0.5, function() {
                    return $d3ebcbb2fcb6c723$var$_startup = 0;
                });
                $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_doc, "touchcancel", $d3ebcbb2fcb6c723$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_body, "touchstart", $d3ebcbb2fcb6c723$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $d3ebcbb2fcb6c723$var$_multiListener($d3ebcbb2fcb6c723$var$_addListener, $d3ebcbb2fcb6c723$var$_doc, "pointerdown,touchstart,mousedown", $d3ebcbb2fcb6c723$var$_pointerDownHandler);
                $d3ebcbb2fcb6c723$var$_multiListener($d3ebcbb2fcb6c723$var$_addListener, $d3ebcbb2fcb6c723$var$_doc, "pointerup,touchend,mouseup", $d3ebcbb2fcb6c723$var$_pointerUpHandler);
                $d3ebcbb2fcb6c723$var$_transformProp = $d3ebcbb2fcb6c723$var$gsap.utils.checkPrefix("transform");
                $d3ebcbb2fcb6c723$var$_stateProps.push($d3ebcbb2fcb6c723$var$_transformProp);
                $d3ebcbb2fcb6c723$var$_coreInitted = $d3ebcbb2fcb6c723$var$_getTime();
                $d3ebcbb2fcb6c723$var$_resizeDelay = $d3ebcbb2fcb6c723$var$gsap.delayedCall(0.2, $d3ebcbb2fcb6c723$var$_refreshAll).pause();
                $d3ebcbb2fcb6c723$var$_autoRefresh = [
                    $d3ebcbb2fcb6c723$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $d3ebcbb2fcb6c723$var$_win.innerWidth, h = $d3ebcbb2fcb6c723$var$_win.innerHeight;
                        if ($d3ebcbb2fcb6c723$var$_doc.hidden) {
                            $d3ebcbb2fcb6c723$var$_prevWidth = w;
                            $d3ebcbb2fcb6c723$var$_prevHeight = h;
                        } else if ($d3ebcbb2fcb6c723$var$_prevWidth !== w || $d3ebcbb2fcb6c723$var$_prevHeight !== h) $d3ebcbb2fcb6c723$var$_onResize();
                    },
                    $d3ebcbb2fcb6c723$var$_doc,
                    "DOMContentLoaded",
                    $d3ebcbb2fcb6c723$var$_refreshAll,
                    $d3ebcbb2fcb6c723$var$_win,
                    "load",
                    $d3ebcbb2fcb6c723$var$_refreshAll,
                    $d3ebcbb2fcb6c723$var$_win,
                    "resize",
                    $d3ebcbb2fcb6c723$var$_onResize
                ];
                $d3ebcbb2fcb6c723$var$_iterateAutoRefresh($d3ebcbb2fcb6c723$var$_addListener);
                $d3ebcbb2fcb6c723$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).length; i += 3){
                    $d3ebcbb2fcb6c723$var$_wheelListener($d3ebcbb2fcb6c723$var$_removeListener, (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i], (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i + 1]);
                    $d3ebcbb2fcb6c723$var$_wheelListener($d3ebcbb2fcb6c723$var$_removeListener, (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i], (0, $3f3f0a4407c27751$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($d3ebcbb2fcb6c723$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($d3ebcbb2fcb6c723$var$_syncInterval) || ($d3ebcbb2fcb6c723$var$_syncInterval = ms) && setInterval($d3ebcbb2fcb6c723$var$_sync, ms);
        "ignoreMobileResize" in vars && ($d3ebcbb2fcb6c723$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $d3ebcbb2fcb6c723$var$_iterateAutoRefresh($d3ebcbb2fcb6c723$var$_removeListener) || $d3ebcbb2fcb6c723$var$_iterateAutoRefresh($d3ebcbb2fcb6c723$var$_addListener, vars.autoRefreshEvents || "none");
            $d3ebcbb2fcb6c723$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $3f3f0a4407c27751$export$937374fea3f88711)(target), i = (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).indexOf(t), isViewport = $d3ebcbb2fcb6c723$var$_isViewport(t);
        if (~i) (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $3f3f0a4407c27751$export$d8e56d510a804d0a).unshift($d3ebcbb2fcb6c723$var$_win, vars, $d3ebcbb2fcb6c723$var$_body, vars, $d3ebcbb2fcb6c723$var$_docEl, vars) : (0, $3f3f0a4407c27751$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $d3ebcbb2fcb6c723$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($d3ebcbb2fcb6c723$var$_isString(element) ? (0, $3f3f0a4407c27751$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $d3ebcbb2fcb6c723$var$_width : $d3ebcbb2fcb6c723$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $d3ebcbb2fcb6c723$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $d3ebcbb2fcb6c723$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $d3ebcbb2fcb6c723$var$_isString(element) && (element = (0, $3f3f0a4407c27751$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $d3ebcbb2fcb6c723$var$_width : $d3ebcbb2fcb6c723$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $d3ebcbb2fcb6c723$var$_keywords ? $d3ebcbb2fcb6c723$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $d3ebcbb2fcb6c723$var$_win.innerWidth : (bounds.top + offset) / $d3ebcbb2fcb6c723$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $d3ebcbb2fcb6c723$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $d3ebcbb2fcb6c723$var$_listeners.killAll || [];
            $d3ebcbb2fcb6c723$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$d3ebcbb2fcb6c723$export$875bcbe48555930.version = "3.12.2";
$d3ebcbb2fcb6c723$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $d3ebcbb2fcb6c723$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $d3ebcbb2fcb6c723$var$_savedStyles.indexOf(target);
            i >= 0 && $d3ebcbb2fcb6c723$var$_savedStyles.splice(i, 5);
            $d3ebcbb2fcb6c723$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $d3ebcbb2fcb6c723$var$gsap.core.getCache(target), $d3ebcbb2fcb6c723$var$_context());
        }
    }) : $d3ebcbb2fcb6c723$var$_savedStyles;
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.revert = function(soft, media) {
    return $d3ebcbb2fcb6c723$var$_revertAll(!soft, media);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.create = function(vars, animation) {
    return new $d3ebcbb2fcb6c723$export$875bcbe48555930(vars, animation);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $d3ebcbb2fcb6c723$var$_onResize() : ($d3ebcbb2fcb6c723$var$_coreInitted || $d3ebcbb2fcb6c723$export$875bcbe48555930.register()) && $d3ebcbb2fcb6c723$var$_refreshAll(true);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.update = function(force) {
    return ++(0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache && $d3ebcbb2fcb6c723$var$_updateAll(force === true ? 2 : 0);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.clearScrollMemory = $d3ebcbb2fcb6c723$var$_clearScrollMemory;
$d3ebcbb2fcb6c723$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $d3ebcbb2fcb6c723$var$_maxScroll(element, horizontal ? (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1) : (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d));
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $3f3f0a4407c27751$export$8665aac53dad5647)((0, $3f3f0a4407c27751$export$937374fea3f88711)(element), horizontal ? (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1) : (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d));
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.getById = function(id) {
    return $d3ebcbb2fcb6c723$var$_ids[id];
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.getAll = function() {
    return $d3ebcbb2fcb6c723$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$d3ebcbb2fcb6c723$export$875bcbe48555930.isScrolling = function() {
    return !!$d3ebcbb2fcb6c723$var$_lastScrollTime;
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.snapDirectional = $d3ebcbb2fcb6c723$var$_snapDirectional;
$d3ebcbb2fcb6c723$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $d3ebcbb2fcb6c723$var$_listeners[type] || ($d3ebcbb2fcb6c723$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $d3ebcbb2fcb6c723$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $d3ebcbb2fcb6c723$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $d3ebcbb2fcb6c723$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($d3ebcbb2fcb6c723$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $d3ebcbb2fcb6c723$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($d3ebcbb2fcb6c723$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $d3ebcbb2fcb6c723$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $d3ebcbb2fcb6c723$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $d3ebcbb2fcb6c723$var$_docEl && _allowNativePanning($d3ebcbb2fcb6c723$var$_body, direction);
}, $d3ebcbb2fcb6c723$var$_overflow = {
    auto: 1,
    scroll: 1
}, $d3ebcbb2fcb6c723$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $d3ebcbb2fcb6c723$var$gsap.core.getCache(node), time = $d3ebcbb2fcb6c723$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $d3ebcbb2fcb6c723$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($d3ebcbb2fcb6c723$var$_overflow[(cs = $d3ebcbb2fcb6c723$var$_getComputedStyle(node)).overflowY] || $d3ebcbb2fcb6c723$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$d3ebcbb2fcb6c723$var$_isViewport(node) && ($d3ebcbb2fcb6c723$var$_overflow[(cs = $d3ebcbb2fcb6c723$var$_getComputedStyle(node)).overflowY] || $d3ebcbb2fcb6c723$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$d3ebcbb2fcb6c723$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $d3ebcbb2fcb6c723$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_doc, (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).eventTypes[0], $d3ebcbb2fcb6c723$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_doc, (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).eventTypes[0], $d3ebcbb2fcb6c723$var$_captureInputs, true);
        }
    });
}, $d3ebcbb2fcb6c723$var$_inputExp = /(input|label|select|textarea)/i, $d3ebcbb2fcb6c723$var$_inputIsFocused, $d3ebcbb2fcb6c723$var$_captureInputs = function _captureInputs(e) {
    var isInput = $d3ebcbb2fcb6c723$var$_inputExp.test(e.target.tagName);
    if (isInput || $d3ebcbb2fcb6c723$var$_inputIsFocused) {
        e._gsapAllow = true;
        $d3ebcbb2fcb6c723$var$_inputIsFocused = isInput;
    }
}, $d3ebcbb2fcb6c723$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $d3ebcbb2fcb6c723$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $3f3f0a4407c27751$export$937374fea3f88711)(vars.target) || $d3ebcbb2fcb6c723$var$_docEl, smoother = $d3ebcbb2fcb6c723$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $d3ebcbb2fcb6c723$var$_fixIOSBug && (vars.content && (0, $3f3f0a4407c27751$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $3f3f0a4407c27751$export$8665aac53dad5647)(target, (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d)), scrollFuncX = (0, $3f3f0a4407c27751$export$8665aac53dad5647)(target, (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b).isTouch && $d3ebcbb2fcb6c723$var$_win.visualViewport ? $d3ebcbb2fcb6c723$var$_win.visualViewport.scale * $d3ebcbb2fcb6c723$var$_win.visualViewport.width : $d3ebcbb2fcb6c723$var$_win.outerWidth) / $d3ebcbb2fcb6c723$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $d3ebcbb2fcb6c723$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $d3ebcbb2fcb6c723$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $d3ebcbb2fcb6c723$var$_passThrough, scrollClampY = $d3ebcbb2fcb6c723$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $d3ebcbb2fcb6c723$var$_maxScroll(target, (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d));
        scrollClampY = $d3ebcbb2fcb6c723$var$_clamp($d3ebcbb2fcb6c723$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $d3ebcbb2fcb6c723$var$_clamp(0, $d3ebcbb2fcb6c723$var$_maxScroll(target, (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1))));
        lastRefreshID = $d3ebcbb2fcb6c723$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $d3ebcbb2fcb6c723$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $d3ebcbb2fcb6c723$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $d3ebcbb2fcb6c723$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache;
                $d3ebcbb2fcb6c723$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $d3ebcbb2fcb6c723$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $d3ebcbb2fcb6c723$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $d3ebcbb2fcb6c723$var$_round(($d3ebcbb2fcb6c723$var$_win.visualViewport && $d3ebcbb2fcb6c723$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $d3ebcbb2fcb6c723$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $d3ebcbb2fcb6c723$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $3f3f0a4407c27751$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $d3ebcbb2fcb6c723$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $d3ebcbb2fcb6c723$var$_maxScroll(target, (0, $3f3f0a4407c27751$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $d3ebcbb2fcb6c723$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $d3ebcbb2fcb6c723$var$_maxScroll(target, (0, $3f3f0a4407c27751$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($d3ebcbb2fcb6c723$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $d3ebcbb2fcb6c723$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($d3ebcbb2fcb6c723$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $d3ebcbb2fcb6c723$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $d3ebcbb2fcb6c723$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $d3ebcbb2fcb6c723$var$_updateAll();
    };
    vars.onEnable = function() {
        $d3ebcbb2fcb6c723$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $d3ebcbb2fcb6c723$export$875bcbe48555930.addEventListener("refresh", onResize);
        $d3ebcbb2fcb6c723$var$_addListener($d3ebcbb2fcb6c723$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $d3ebcbb2fcb6c723$var$_allowNativePanning(target, true);
        $d3ebcbb2fcb6c723$var$_removeListener($d3ebcbb2fcb6c723$var$_win, "resize", onResize);
        $d3ebcbb2fcb6c723$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $d3ebcbb2fcb6c723$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $d3ebcbb2fcb6c723$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $d3ebcbb2fcb6c723$var$_fixIOSBug && $d3ebcbb2fcb6c723$var$gsap.ticker.add($d3ebcbb2fcb6c723$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $d3ebcbb2fcb6c723$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $d3ebcbb2fcb6c723$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $d3ebcbb2fcb6c723$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.sort = function(func) {
    return $d3ebcbb2fcb6c723$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.observe = function(vars) {
    return new (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b)(vars);
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $d3ebcbb2fcb6c723$var$_normalizer;
    if (vars === true && $d3ebcbb2fcb6c723$var$_normalizer) return $d3ebcbb2fcb6c723$var$_normalizer.enable();
    if (vars === false) return $d3ebcbb2fcb6c723$var$_normalizer && $d3ebcbb2fcb6c723$var$_normalizer.kill();
    var normalizer = vars instanceof (0, $3f3f0a4407c27751$export$c1cbdee04e18ea8b) ? vars : $d3ebcbb2fcb6c723$var$_getScrollNormalizer(vars);
    $d3ebcbb2fcb6c723$var$_normalizer && $d3ebcbb2fcb6c723$var$_normalizer.target === normalizer.target && $d3ebcbb2fcb6c723$var$_normalizer.kill();
    $d3ebcbb2fcb6c723$var$_isViewport(normalizer.target) && ($d3ebcbb2fcb6c723$var$_normalizer = normalizer);
    return normalizer;
};
$d3ebcbb2fcb6c723$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $3f3f0a4407c27751$export$5de019f4480f0f8d),
    _inputObserver: $d3ebcbb2fcb6c723$var$_inputObserver,
    _scrollers: (0, $3f3f0a4407c27751$export$3cd1cee43d19b683),
    _proxies: (0, $3f3f0a4407c27751$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $d3ebcbb2fcb6c723$var$_lastScrollTime || $d3ebcbb2fcb6c723$var$_dispatch("scrollStart");
            $d3ebcbb2fcb6c723$var$_lastScrollTime = $d3ebcbb2fcb6c723$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $d3ebcbb2fcb6c723$var$_refreshing;
        }
    }
};
$d3ebcbb2fcb6c723$var$_getGSAP() && $d3ebcbb2fcb6c723$var$gsap.registerPlugin($d3ebcbb2fcb6c723$export$875bcbe48555930);


(0, $bcde7b69d8e3aef8$export$99ee26438460406a).registerPlugin((0, $d3ebcbb2fcb6c723$export$875bcbe48555930));
function $30e84b592787c419$export$2e2bcd8739ae039() {
    if ($30e84b592787c419$export$631f2404f2411c1c()) return;
    const singleItems = document.querySelectorAll(".js-animate-appear");
    $30e84b592787c419$var$makeSingleItemsAppear(singleItems);
    const groups = document.querySelectorAll(".js-animate-group");
    $30e84b592787c419$var$makeGroupsAppear(groups);
    const horizontalGroups = document.querySelectorAll(".js-animate-group-horizontal");
    $30e84b592787c419$var$makeGroupsAppear(horizontalGroups, 0.8, 0.2, true);
}
function $30e84b592787c419$export$631f2404f2411c1c() {
    return window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
}
function $30e84b592787c419$var$makeSingleItemsAppear(elements) {
    elements.forEach((element)=>{
        (0, $bcde7b69d8e3aef8$export$99ee26438460406a).from(element, {
            scrollTrigger: {
                trigger: element,
                start: "top bottom-=15%"
            },
            duration: 0.5,
            opacity: 0,
            ease: "power1.out",
            y: 30
        });
    });
}
function $30e84b592787c419$var$makeGroupsAppear(groups, duration = 0.5, stagger = 0.15, horizontal = false) {
    const direction = horizontal ? {
        x: 30
    } : {
        y: 30
    };
    groups.forEach((group)=>{
        const items = group.querySelectorAll(".js-animate-group-item");
        (0, $bcde7b69d8e3aef8$export$99ee26438460406a).from(items, {
            scrollTrigger: {
                trigger: group,
                start: "top bottom-=15%"
            },
            duration: duration,
            opacity: 0,
            ease: "power1.out",
            stagger: stagger,
            ...direction
        });
    });
}


(0, $484b67efc9cd0e78$export$2e2bcd8739ae039)();
(0, $11499d46e9310e07$export$2e2bcd8739ae039)();
(0, $d04805db938379b5$export$2e2bcd8739ae039)();
(0, $dc4dfe08a56070a6$export$1a288977efa87e02)();
(0, $322bee87abe039b9$export$2e2bcd8739ae039)();
(0, $30e84b592787c419$export$2e2bcd8739ae039)();


//# sourceMappingURL=js.def3f0a7.js.map
